(function () {
    'use strict';

    angular
        .module('dialysisApp', [
            'ngStorage',
            // 'tmh.dynamicLocale',
            // 'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ds.objectDiff',
            'udt',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.checkbox',
            'ncy-angular-breadcrumb',
            'datatables',
            'datatables.factory',
            'datatables.bootstrap',
            'datatables.colreorder',
            'datatables.columnfilter',
            'ui.toggle',
            'ui.mask',
            'angularMoment',
            'ui.select',
            'nzToggle',
            'ngSanitize',
            'rmDatepicker',
            'webcam',
            'chart.js',
            'nvd3',
            'ngIdle',
            'dialogs.main',
            'dialogs.default-translations',
            'rm2Datepicker',
            'ui.calendar',
            'pdfjsViewer',
            'ngLodash',
            'mgo-angular-wizard',
            'ods-lib',
            'ods-lib-old',
            'toastr',
            'rm3Datepicker',
            'moment-picker',
            'mgo-angular-wizard'
        ]).config(['toastrConfig', function (toastrConfig) {
            angular.extend(toastrConfig, {
                allowHtml: true,
                closeButton: true,
                closeHtml: '<button>&times;</button>',
                extendedTimeOut: 1000,
                autoDismiss: false,
                maxOpened: 5,
                iconClasses: {
                    error: 'toast-error',
                    info: 'toast-info',
                    success: 'toast-success',
                    warning: 'toast-warning'
                },
                messageClass: 'toast-message',
                onHidden: null,
                onShown: null,
                onTap: null,
                progressBar: true,
                tapToDismiss: true,
                newestOnTop: true,
                positionClass: 'toast-bottom-right',
                timeOut: 5000,
                titleClass: 'toast-title',
                toastClass: 'toast'
            });
        }])
        .run(run);

    run.$inject = ['stateHandler', '$rootScope'];

    function run(stateHandler, $rootScope) {
        stateHandler.initialize();

        $rootScope.dateformat = "MM/dd/yyyy";
        $rootScope.displayDateformat = "MM/DD/YYYY";
        $rootScope.displayAmDateTimeFormat = "MM/DD/YYYY hh:mm A";
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sign', {
                abstract: true,
                parent: 'app',
                url: '/sign',
                ncyBreadcrumb: {
                    label: 'Sign',
                    parent: 'app'
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/sign/sign.html',
                        controller: 'SignController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })

            .state('sign.consent', {
                parent: 'sign',
                url: '/consent',
                ncyBreadcrumb: {
                    label: 'Consent',
                    parent: 'app'
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    '': {
                        templateUrl: 'app/sign/consent.html'
                    }
                },
                resolve: {}
            })
            .state('sign.signature', {
                parent: 'sign',
                url: '/signature',
                ncyBreadcrumb: {
                    label: 'Signature',
                    parent: 'sign.consent'
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    '': {
                        templateUrl: 'app/sign/signature.html'
                    }
                },
                resolve: {}
            })

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('SignService', SignService);

    SignService.$inject = ['$uibModal'];

    function SignService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SignController', SignController);

    SignController.$inject = ['JSignature', 'CoreService', 'Employee', '$state', 'previousState'];

    function SignController(JSignature, CoreService, Employee, $state, previousState) {
        var vm = this;

        vm.previousState = previousState;
        vm.result = {
            agree: false,
            signed: true
        }

        vm.save = save;

        vm.getData = getData;
        vm.enable = enable;
        vm.disable = disable;

        //We check if the employee has signed we redirect to the previous state
        var employee = CoreService.getCurrentEmployee();
        if (employee.hasSigned) {
            $state.go(vm.previousState.name);
        }

        function save() {
            if (!JSignature.getData(JSignature.exportTypes.NATIVE).length) {
                alert("Please sign and then press finish!!!");
            } else {
                var sign = JSignature.getData(JSignature.exportTypes.IMAGE_PNG_BASE64);

                employee.hasSigned = true;
                employee.specialist.signature = sign;

                Employee.update(employee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {

            Employee.employeeAccount(function (result) {
                CoreService.setCurrentEmployee(result);
                $state.go("home");
            });
        }

        function onSaveError() {
            vm.isError = false;
        }

        function getData() {
            var data = JSignature.getData(JSignature.exportTypes.IMAGE_SVG_XML_BASE64);
            var i = new Image();
            i.src = 'data:' + data[0] + ',' + data[1];
            vm.hash = 'data:' + data[0] + ',' + data[1];
        }

        function enable() {
            JSignature.enable();
        }

        function disable() {
            JSignature.disable();
        }
    }
})
();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('AdminLTEService', AdminLTEService);

    function AdminLTEService() {

        var service = {
            registerTreeActions : registerTreeActions,
            registerPushMenuActions: registerPushMenuActions,
            registerBoxWidget: registerBoxWidget,
            registerControlSidebar: registerControlSidebar,
            registerICheckWidget: registerICheckWidget,
            layoutFix: layoutFix
        };

        return service;

        function registerTreeActions(menu) {

            $.AdminLTE.tree(menu);
        }

        function registerPushMenuActions(toggleBtn) {

            $.AdminLTE.pushMenu.activate(toggleBtn);
        }

        function registerBoxWidget() {

            $.AdminLTE.boxWidget.activate();
        }

        function registerControlSidebar() {

            $.AdminLTE.controlSidebar.activate();
        }

        function registerICheckWidget() {

            //iCheck for checkbox and radio inputs
            $('input[type="checkbox"].minimal, input[type="radio"].minimal').iCheck({
                checkboxClass: 'icheckbox_minimal-blue',
                radioClass: 'iradio_minimal-blue'
            });
            //Red color scheme for iCheck
            $('input[type="checkbox"].minimal-red, input[type="radio"].minimal-red').iCheck({
                checkboxClass: 'icheckbox_minimal-red',
                radioClass: 'iradio_minimal-red'
            });
            //Flat red color scheme for iCheck
            $('input[type="checkbox"].flat-red, input[type="radio"].flat-red').iCheck({
                checkboxClass: 'icheckbox_flat-green',
                radioClass: 'iradio_flat-green'
            });
        }

        function layoutFix() {
            $.AdminLTE.layout.activate();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" >{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PopupService', PopupService);

    PopupService.$inject = ['$uibModal'];

    function PopupService($uibModal) {

        var service = {
            showPatientBarcodePopup: showPatientBarcodePopup,
            showPatientResultDetPopup: showPatientResultDetPopup,
            showEnvResultDetPopup: showEnvResultDetPopup,
            showEnvironmentalBarcodePopup: showEnvironmentalBarcodePopup
        };

        return service;

        function showPatientBarcodePopup(groupNumberId, patientOrder) {
            $uibModal.open({
                templateUrl: 'app/entities/clinic-schedule-detail/dashboard-v2/patient-barcode-detail.html',
                controller: 'PatientBarcodeDetail2Controller',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                   barcode: ['PatientBarcode', function (PatientBarcode) {
                       if (groupNumberId) {
                           return PatientBarcode.get({barcode: groupNumberId}).$promise;
                       } else {
                           return groupNumberId;
                       }
                   }],
                   patient: ['Patient', function(Patient) {
                        if (groupNumberId) {
                            return Patient.byBarcode({barcode: groupNumberId}).$promise;
                        } else {
                            return Patient.get({id: patientOrder.patientId}).$promise;
                        }
                   }],
                   patientOrder: patientOrder
                }
            });
        }

        function showEnvironmentalBarcodePopup(envOrder) {
            $uibModal.open({
                templateUrl: 'app/entities/clinic-schedule-detail/dashboard-v2/machine-barcode-detail.html',
                controller: 'MachineBarcodeDetail2Controller',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    barcode: ['MachineBarcode', function (MachineBarcode) {
                        if (envOrder.barcode) {
                            return MachineBarcode.get({barcode: envOrder.barcode}).$promise;
                        } else {
                            return envOrder.barcode;
                        }
                    }],
                    machine: ['Machine', function (Machine) {
                        if (envOrder.barcode) {
                            return Machine.byBarcode({barcode: envOrder.barcode}).$promise;
                        } else {
                            return envOrder;
                        }
                    }],
                }
            });
        }

        /**
         *
         * @param idOrPatientResult id or patientResult Object
         */
        function showPatientResultDetPopup(idOrPatientResult) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-result-det/patient-result-dets.html',
                controller: 'PatientResultDetController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    patientResult: ['PatientResult', function (PatientResult) {
                        if (isObject(idOrPatientResult)) {
                            return idOrPatientResult;
                        } else {
                            return PatientResult.get({id: idOrPatientResult}).$promise;
                        }
                    }]
                }
            });
        }

        function showEnvResultDetPopup(idOrEnvResult) {
            $uibModal.open({
                templateUrl: 'app/entities/env-result-det/env-result-dets.html',
                controller: 'EnvResultDetController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    envResult: ['EnvResult', function (EnvResult) {
                        if (isObject(idOrEnvResult)) {
                            return idOrEnvResult;
                        } else {
                            return EnvResult.get({id: idOrEnvResult}).$promise;
                        }
                    }]
                }
            });
        }

        function isObject(value) {
            return value instanceof Object;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('DataTablesService', DataTablesService);

    DataTablesService.$inject = [];

    function DataTablesService() {

        var service = {
            toggleAll: toggleAll,
            toggleOne: toggleOne,
            getSelectedIds: getSelectedIds,
            setUniqueIds: setUniqueIds
        };

        return service;

        function toggleAll(selected, selectAll) {
            for (var id in selected) {
                if (selected.hasOwnProperty(id)) {
                    selected[id] = selectAll;
                }
            }
        }

        function toggleOne(selected, selectAll) {
            for (var id in selected) {
                if (selected.hasOwnProperty(id)) {
                    if (!selected[id]) {
                        selectAll = false;
                        return;
                    }
                }
            }
            selectAll = true;
        }

        function getSelectedIds(selected) {
            var ids = [];

            for (var id in selected) {
                if (selected[id]) {
                    ids.push(id);
                }
            }

            return ids;
        }

        function setUniqueIds(data) {
            for (var i = 0; i < data.length; i++) {
                data[i].id = i;
            }

            return data;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CoreService', CoreService);

    CoreService.$inject = ['$sessionStorage', 'Base64', '$rootScope'];

    function CoreService($sessionStorage, Base64, $rootScope) {

        var service = {
            setCurrentClinic: setCurrentClinic,
            getCurrentClinic: getCurrentClinic,
            setCurrentEmployee: setCurrentEmployee,
            getCurrentEmployee: getCurrentEmployee,
            setCurrentPatient: setCurrentPatient,
            getCurrentPatient: getCurrentPatient,
            getAvatar: getAvatar,
            clearSession: clearSession,
            currentHasEmployeeRole: currentHasEmployeeRole,
            setCurrentMachine: setCurrentMachine,
            getCurrentMachine: getCurrentMachine,
            removeCurrentMachine: removeCurrentMachine,
            setStorage: setStorage,
            getStorage: getStorage,
            initActiveScheduleTabTab: initActiveScheduleTabTab,
            toggleAll: toggleAll,
            toggleOne: toggleOne,
            getSelectedIds: getSelectedIds,
            readPatientResultFilter: readPatientResultFilter,
            initPatientResultFilter: initPatientResultFilter,
            readPatientResultFromLocalStore: readPatientResultFromLocalStore,
            initEnvResultFilter: initEnvResultFilter,
            readEnvResultFilter: readEnvResultFilter,
            readEnvResultFromLocalStore: readEnvResultFromLocalStore,
            getActiveScheduleDateEnv: getActiveScheduleDateEnv,
            getActiveScheduleDate: getActiveScheduleDate,
            readEmrIntegrationLogFilter: readEmrIntegrationLogFilter,
            initEmrIntegrationLogFilter: initEmrIntegrationLogFilter,
            readEmrIntegrationLogFromLocalStore: readEmrIntegrationLogFromLocalStore
        };

        return service;

        /**
         * Set a clinic to the session storage
         * @param clinic
         */
        function setCurrentClinic(clinic) {
            if (clinic) {
                $sessionStorage.selectedClinic = Base64.encode(JSON.stringify(clinic));
                $rootScope.$broadcast('dialysisApp:setCurrentClinic', clinic);
            }
        }

        /**
         * Get current clinic from the session storage
         */
        function getCurrentClinic() {
            if ($sessionStorage.selectedClinic) {
                return JSON.parse(Base64.decode($sessionStorage.selectedClinic));
            }

            return null;
        }

        /**
         * Set a employee to the session storage
         * @param employee
         */
        function setCurrentEmployee(currentEmployee) {
            if (currentEmployee) {
                $sessionStorage.currentEmployee = Base64.encode(JSON.stringify(currentEmployee));
            }
        }

        /**
         * Get current employee from the session storage
         */
        function getCurrentEmployee() {
            if ($sessionStorage.currentEmployee) {
                return JSON.parse(Base64.decode($sessionStorage.currentEmployee));
            }

            return null;
        }

        /**
         * Get random avatar by gender
         */
        function getAvatar(gender) {

            var maleAvatar = [
                'content/adminLTE/img/avatar.png',
                'content/adminLTE/img/avatar4.png',
                'content/adminLTE/img/avatar5.png'
            ];

            var femaleAvatar = [
                'content/adminLTE/img/avatar2.png',
                'content/adminLTE/img/avatar3.png'
            ];

            var ramdom = 0;
            if (gender == 'MALE') {
                ramdom = Math.floor((Math.random() * 3));
                return maleAvatar[ramdom];
            }
            else {
                ramdom = Math.floor((Math.random() * 2));
                return femaleAvatar[ramdom];
            }
        }

        /**
         * Clear the session storage
         */
        function clearSession() {
            $sessionStorage.$reset();
        }

        function setCurrentPatient(patient) {
            if (patient) {
                $sessionStorage.patient = Base64.encode(JSON.stringify(patient));
            } else {
                $sessionStorage.patient = null;
            }
        }

        function getCurrentPatient() {
            if ($sessionStorage.patient) {
                return JSON.parse(Base64.decode($sessionStorage.patient));
            }

            return null;
        }

        function setCurrentMachine(machine) {
            if (machine) {
                $sessionStorage.machine = Base64.encode(JSON.stringify(machine));
            } else {
                $sessionStorage.machine = null;
            }

        }

        function getCurrentMachine() {
            if ($sessionStorage.machine) {
                return JSON.parse(Base64.decode($sessionStorage.machine));
            }

            return null;
        }

        function removeCurrentMachine() {
            $sessionStorage.machine = null;
        }

        function currentHasEmployeeRole(role) {
            var employee = getCurrentEmployee();

            if (employee == null) {
                return false;
            }

            return $.grep(getCurrentEmployee().user.authorities, function (authority, i) {
                return authority.name == role;
            }).length > 0;
        }

        function setStorage(attr, value) {
            $sessionStorage[attr] = value;
        }

        function getStorage(attr) {
            return $sessionStorage[attr];
        }

        function initActiveScheduleTabTab() {
            if ($sessionStorage["activeScheduleTab"] === undefined) {
                $sessionStorage["activeScheduleTab"] = 0;
            }

            if ($sessionStorage["activeScheduleDate"] === undefined) {
                $sessionStorage["activeScheduleDate"] = new Date();
            }
        }

        function getActiveScheduleDateEnv() {
            if ($sessionStorage["activeScheduleDateEnv"] === undefined) {
                return $sessionStorage["activeScheduleDateEnv"] = new Date();
            }

            return $sessionStorage["activeScheduleDateEnv"];
        }

        function getActiveScheduleDate() {
            if ($sessionStorage["activeScheduleDate"] === undefined) {
                return $sessionStorage["activeScheduleDate"] = new Date();
            }

            return $sessionStorage["activeScheduleDate"];
        }

        function toggleAll(selected, selectAll) {
            for (var id in selected) {
                if (selected.hasOwnProperty(id)) {
                    selected[id] = selectAll;
                }
            }
        }

        function toggleOne(selected, selectAll) {
            for (var id in selected) {
                if (selected.hasOwnProperty(id)) {
                    if (!selected[id]) {
                        selectAll = false;
                        return;
                    }
                }
            }
            selectAll = true;
        }

        function getSelectedIds(selected) {
            var ids = [];

            for (var id in selected) {
                if (selected[id]) {
                    ids.push(id);
                }
            }

            return ids;
        }

        function readPatientResultFilter(paramsfilter) {
            var filter = {
                reviewedStatus: paramsfilter.reviewedStatus,
                patientName: paramsfilter.patientName,
                start: paramsfilter.start,
                end: paramsfilter.end,
                abnormal: paramsfilter.abnormal,
                status: paramsfilter.status,
                dob: paramsfilter.dob,
                barcode: paramsfilter.barcode,
                shift: paramsfilter.shift,
                shiftImpl: paramsfilter.shiftImpl == null ? -1 : paramsfilter.shiftImpl,
                page: paramsfilter.page == null ? 1 : paramsfilter.page
            }

            return filter;
        }

        function readPatientResultFromLocalStore(filterLS) {
            if (filterLS == undefined) {
                filterLS = CoreService.getStorage('filterPatient');
            }

            var filter = {
                reviewedStatus: filterLS.reviewedStatus,
                patientName: filterLS.patientName,
                start: isNaN(Date.parse(filterLS.start)) ? filterLS.start : Date.parse(filterLS.start),
                end: isNaN(Date.parse(filterLS.end)) ? filterLS.end : Date.parse(filterLS.end),
                abnormal: filterLS.abnormal,
                status: filterLS.status,
                dob: isNaN(Date.parse(filterLS.dob)) ? filterLS.dob : Date.parse(filterLS.dob),
                barcode: filterLS.barcode,
                shift: filterLS.shift,
                shiftImpl: filterLS.shiftImpl,
                page: filterLS.page ? filterLS.page : 1
            }

            return filter;
        }

        function initPatientResultFilter() {
            var endDate = new Date();
            var startDate = new Date();
            startDate.setDate(endDate.getDate() - 30);

            return {
                reviewedStatus: null,
                patientName: null,
                start: startDate,
                end: endDate,
                abnormal: null,
                status: null,
                dob: null,
                barcode: null,
                shift: null,
                shiftImpl: -1,
                page: 1
            }
        }

        function initEnvResultFilter() {
            var endDate = new Date();
            var startDate = new Date();
            startDate.setDate(endDate.getDate() - 30);

            return {
                name: null,
                start: startDate,
                end: endDate,
                abnormal: null,
                status: null,
                barcode: null,
                reviewedStatus: null
            };
        }

        function readEnvResultFilter(paramsfilter) {
            var filter = {
                name: paramsfilter.name,
                start: paramsfilter.startDate,
                end: paramsfilter.endDate,
                abnormal: paramsfilter.abnormal,
                status: paramsfilter.status,
                barcode: paramsfilter.barcode,
                reviewedStatus: paramsfilter.reviewedStatus
            };

            return filter;
        }

        function readEnvResultFromLocalStore(filterLS) {
            if (filterLS == undefined) {
                filterLS = CoreService.getStorage('filterEnvironmental');
            }

            var filter = {
                name: filterLS.name,
                start: isNaN(Date.parse(filterLS.start)) ? filterLS.start : Date.parse(filterLS.start),
                end: isNaN(Date.parse(filterLS.end)) ? filterLS.end : Date.parse(filterLS.end),
                abnormal: filterLS.abnormal,
                status: filterLS.status,
                barcode: filterLS.barcode,
                reviewedStatus: filterLS.reviewedStatus
            }

            return filter;
        }


        function readEmrIntegrationLogFilter(paramsfilter) {
            var filter = {
                start: paramsfilter.start,
                end: paramsfilter.end,
            }

            return filter;
        }

        function initEmrIntegrationLogFilter() {
            var endDate = new Date();
            var startDate = new Date();
            startDate.setDate(endDate.getDate() - 30);

            return {
                start: startDate,
                end: endDate,

            }
        }

        function readEmrIntegrationLogFromLocalStore(filterLS) {
            if (filterLS == undefined) {
                filterLS = CoreService.getStorage('filterEmrIntegrationLog');
            }

            var filter = {
                start: isNaN(Date.parse(filterLS.start)) ? filterLS.start : Date.parse(filterLS.start),
                end: isNaN(Date.parse(filterLS.end)) ? filterLS.end : Date.parse(filterLS.end),
            }

            return filter;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            hasRole: hasRole
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function hasRole (authority) {
            if (!_authenticated) {
                return false;
            }
            return _identity && _identity.authorities.indexOf(authority) !== -1;

        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'CoreService',
        'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'EMPLOYEE_TYPE'];

    function Auth($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, CoreService,
                  LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, EMPLOYEE_TYPE) {

        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount(key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize(force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();

                //Check if employee is a doctor and haven't signed, redirect to sign.consent.
                var employee = CoreService.getCurrentEmployee();
                if (employee) {
                    if (employee.employeeType.name === EMPLOYEE_TYPE.PHYSICIAN &&
                        !employee.hasSigned &&
                        employee.employeeType &&
                        $rootScope.toState.name !== 'sign.consent' &&
                        $rootScope.toState.name !== 'sign.signature') {

                        $state.go('sign.consent');
                    }
                }

                // an authenticated user can't access to login and register pages
                if (isAuthenticated &&
                    $rootScope.toState.parent === 'account' &&
                    ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {

                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated &&
                    !$rootScope.fromState.name &&
                    getPreviousState()) {

                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities &&
                    $rootScope.toState.data.authorities.length > 0 &&
                    !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {

                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('login');

                    }
                } else {
                    //Go to requested state

                    // var employee = CoreService.getCurrentEmployee();
                    //
                    // if (!employee.hasSigned && employee.employeeType && employee.employeeType.name === EMPLOYEE_TYPE.PHYSICIAN && $state.current.name != 'sign.consent') {
                    //     // $state.go('sign.consent');
                    //     alert("Mandarlo para sign.");
                    // } else {
                    //     alert("Continuar adelante");
                    // }
                }

            }
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount(account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                Principal.identity(true).then(function (account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount(account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = {"name": previousStateName, "params": previousStateParams};
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reports', {
                parent: 'entity',
                url: '/reports',
                ncyBreadcrumb: {
                    label: 'Reports',
                    parent: 'entity'
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Reports Management'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reports/reports.html',
                        controller: 'ReportsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                }
            })
    }
})();

/**
 * Created by hermeslm on 3/28/17.
 */
(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ReportsController', ReportsController);

    ReportsController.$inject = ['OdsParamType', 'CoreService', 'Employee', 'GUIUtils', 'moment', 'Patient', 'RptMetadata',
        'Modality', 'Compendium'];

    function ReportsController(OdsParamType, CoreService, Employee, GUIUtils, moment, Patient, RptMetadata,
                               Modality, Compendium) {

        var vm = this;

        vm.date = new Date();
        vm.lastDate = new Date();
        vm.lastDate.setMonth(vm.date.getMonth() - 1);

        vm.currentClinic = CoreService.getCurrentClinic();

        vm.physicians = [];

        vm.patientsList = [];

        vm.modalities = [];
        vm.compendiums = [];

        Patient.getAllByClinic({id: vm.currentClinic.id}).$promise.then(function (data) {
            for (var i = 0; i < data.length; i++) {
                vm.patientsList.push(data[i]);
            }
        });

        Employee.employeeCorpPhysicians().$promise.then(function (data) {
            for (var i = 0; i < data.length; i++) {
                vm.physicians.push(data[i]);
            }
        });

        vm.modalities = Modality.query();

        vm.compendiums = Compendium.query();

        vm.reportsGroup = {
            title: 'Reports Groups',
            groups: []
        };

        vm.reportsGroup.groups.push({
            id: 5,
            open: false,
            disabled: false,
            title: 'Patient Specifics',
            icon: 'fa fa-dashboard',
            reports: [
              {
                    id: 1,
                    title: 'Monthly Orders',
                    url: '/api/report/monthly-orders',
                    base64: true,
                    modalSize: 'lg',
                    params: [{
                        id: 3,
                        title: 'Patients',
                        hideTitle: true,
                        name: 'patients',
                        required: true,
                        hideInFooter: true,
                        placeholder: 'Select patients',
                        type: OdsParamType.TABLE_SELECT,
                        valueField: 'id',
                        gridOptions: {
                            columnDef: [{
                                id: true,
                                title: 'Name',
                                field: 'null'
                            }, {
                                id: false,
                                title: 'Name',
                                field: 'null',
                                render: function (data, type, full) {
                                    return full.lastName + ', ' + full.firstName + ' ' +
                                        (full.middleInitial ? full.middleInitial : '');
                                }
                            }, {
                                id: false,
                                title: 'DOB',
                                field: 'null',
                                render: function (data, type, full) {
                                    return moment(full.dob).format('MM/DD/YYYY');
                                }
                            }, {
                                id: false,
                                title: 'Gender',
                                field: 'gender'
                            }, {
                                id: false,
                                title: 'Language',
                                field: 'language',
                                render: function (data, type, full) {
                                    return full.language !== null ? full.language : 'No Language';
                                }
                            }],
                            data: vm.patientsList,
                            preSelected: []
                        },
                        value: [],
                        hidden: false
                    }, {
                        id: 2,
                        title: 'End Date',
                        name: 'end_date',
                        required: true,
                        type: OdsParamType.DATE,
                        value: new Date()
                    }]
                },
                {
                    id: 2,
                    title: 'Dietitian Monthly',
                    url: '/api/report/dietitian-monthly',
                    base64: true,
                    modalSize: 'lg',
                    params: [{
                        id: 3,
                        title: 'Patients',
                        hideTitle: true,
                        name: 'patients',
                        required: true,
                        hideInFooter: true,
                        placeholder: 'Select patients',
                        type: OdsParamType.TABLE_SELECT,
                        valueField: 'id',
                        gridOptions: {
                            columnDef: [{
                                id: true,
                                title: 'Name',
                                field: 'null'
                            }, {
                                id: false,
                                title: 'Name',
                                field: 'null',
                                render: function (data, type, full) {
                                    return full.lastName + ', ' + full.firstName + ' ' +
                                        (full.middleInitial ? full.middleInitial : '');
                                }
                            }, {
                                id: false,
                                title: 'DOB',
                                field: 'null',
                                render: function (data, type, full) {
                                    return moment(full.dob).format('MM/DD/YYYY');
                                }
                            }, {
                                id: false,
                                title: 'Gender',
                                field: 'gender'
                            }, {
                                id: false,
                                title: 'Language',
                                field: 'language',
                                render: function (data, type, full) {
                                    return full.language !== null ? full.language : 'No Language';
                                }
                            }],
                            data: vm.patientsList,
                            preSelected: []
                        },
                        value: [],
                        hidden: false
                    }, {
                        title: 'Start Date',
                        name: 'start_date',
                        required: true,
                        type: OdsParamType.DATE,
                        value: new Date()//new Date(1980, 0, 24) way to pass default value in params
                    }, {
                        title: 'End Date',
                        name: 'end_date',
                        required: true,
                        type: OdsParamType.DATE,
                        value: new Date()
                    }]
                },
                {
                    id: 3,
                    title: 'Nursing Monthly',
                    url: '/api/report/nursing-monthly',
                    base64: true,
                    modalSize: 'lg',
                    params: [{
                        id: 3,
                        title: 'Patients',
                        hideTitle: true,
                        name: 'patients',
                        required: true,
                        hideInFooter: true,
                        placeholder: 'Select patients',
                        type: OdsParamType.TABLE_SELECT,
                        valueField: 'id',
                        gridOptions: {
                            columnDef: [{
                                id: true,
                                title: 'Name',
                                field: 'null'
                            }, {
                                id: false,
                                title: 'Name',
                                field: 'null',
                                render: function (data, type, full) {
                                    return full.lastName + ', ' + full.firstName + ' ' +
                                        (full.middleInitial ? full.middleInitial : '');
                                }
                            }, {
                                id: false,
                                title: 'DOB',
                                field: 'null',
                                render: function (data, type, full) {
                                    return moment(full.dob).format('MM/DD/YYYY');
                                }
                            }, {
                                id: false,
                                title: 'Gender',
                                field: 'gender'
                            }, {
                                id: false,
                                title: 'Language',
                                field: 'language',
                                render: function (data, type, full) {
                                    return full.language !== null ? full.language : 'No Language';
                                }
                            }],
                            data: vm.patientsList,
                            preSelected: []
                        },
                        value: [],
                        hidden: false
                    }, {
                        title: 'Start Date',
                        name: 'start_date',
                        required: true,
                        type: OdsParamType.DATE,
                        value: new Date()//new Date(1980, 0, 24) way to pass default value in params
                    }, {
                        title: 'End Date',
                        name: 'end_date',
                        required: true,
                        type: OdsParamType.DATE,
                        value: new Date()
                    }]
                },
                {
                    id: 4,
                    title: 'Physician Rounding Report',
                    url: '/api/report/physician-rounding',
                    base64: true,
                    modalSize: 'lg',
                    params: [{
                        id: 3,
                        title: 'Patients',
                        hideTitle: true,
                        name: 'patients',
                        required: true,
                        hideInFooter: true,
                        placeholder: 'Select patients',
                        type: OdsParamType.TABLE_SELECT,
                        valueField: 'id',
                        gridOptions: {
                            columnDef: [{
                                id: true,
                                title: 'Name',
                                field: 'null'
                            }, {
                                id: false,
                                title: 'Name',
                                field: 'null',
                                render: function (data, type, full) {
                                    return full.lastName + ', ' + full.firstName + ' ' +
                                        (full.middleInitial ? full.middleInitial : '');
                                }
                            }, {
                                id: false,
                                title: 'DOB',
                                field: 'null',
                                render: function (data, type, full) {
                                    return moment(full.dob).format('MM/DD/YYYY');
                                }
                            }, {
                                id: false,
                                title: 'Gender',
                                field: 'gender'
                            }, {
                                id: false,
                                title: 'Language',
                                field: 'language',
                                render: function (data, type, full) {
                                    return full.language !== null ? full.language : 'No Language';
                                }
                            }],
                            data: vm.patientsList,
                            preSelected: []
                        },
                        value: [],
                        hidden: false
                    }, {
                        title: 'Start Date',
                        name: 'start_date',
                        required: true,
                        type: OdsParamType.DATE,
                        value: new Date()//new Date(1980, 0, 24) way to pass default value in params
                    }, {
                        title: 'End Date',
                        name: 'end_date',
                        required: true,
                        type: OdsParamType.DATE,
                        value: new Date()
                    }]
                },
                {
                    id: 5,
                    title: 'Lab Draw Report',
                    url: '/api/report/lab-draw',
                    params: [{
                        title: 'Patient',
                        name: 'patient',
                        required: true,
                        placeholder: 'Type patients name...',
                        type: OdsParamType.SINGLE_SELECT,
                        valueField: 'id',
                        titleField: 'firstName',
                        render: function (full) {
                            if (full.length === 0) {
                                return 'Type patients name...';
                            } else {
                                return full.lastName + ', ' + full.firstName + ' ' +
                                    (full.middleInitial ? full.middleInitial : '');
                            }
                        },
                        value: [],
                        list: vm.patientsList
                    }, {
                        title: 'Start Date',
                        name: 'start_date',
                        required: true,
                        type: OdsParamType.DATE,
                        value: new Date()//new Date(1980, 0, 24) way to pass default value in params
                    }, {
                        title: 'End Date',
                        name: 'end_date',
                        required: true,
                        type: OdsParamType.DATE,
                        value: new Date()
                    }]
                },
                {
                    id: 6,
                    title: 'CIWA',
                    url: '/api/report/ciwa',
                    base64: true,
                    params: [{
                        title: 'Patient',
                        name: 'patient',
                        required: true,
                        placeholder: 'Type patients name...',
                        type: OdsParamType.SINGLE_SELECT,
                        valueField: 'id',
                        titleField: 'firstName',
                        render: function (full) {
                            if (full.length === 0) {
                                return 'Type patients name...';
                            } else {
                                return full.lastName + ', ' + full.firstName + ' ' +
                                    (full.middleInitial ? full.middleInitial : '');
                            }
                        },
                        value: [],
                        list: vm.patientsList
                    }, {
                        title: 'Start Date',
                        name: 'start_date',
                        required: true,
                        type: OdsParamType.DATE,
                        value: new Date()
                    }, {
                        title: 'End Date',
                        name: 'end_date',
                        required: true,
                        type: OdsParamType.DATE,
                        value: new Date()
                    }]
                },
                {
                    id: 7,
                    title: 'AC IDT Quarterly',
                    url: '/api/report/ac-idt-quarterly',
                    base64: true,
                    modalSize: 'sm',
                    params: [{
                        title: 'Patient',
                        name: 'patient',
                        required: true,
                        placeholder: 'Type patients name...',
                        type: OdsParamType.SINGLE_SELECT,
                        valueField: 'id',
                        titleField: 'firstName',
                        render: function (element) {
                            if (element.length === 0) {
                                return 'Type patients name...';
                            } else {
                                return element.lastName + ', ' + element.firstName + ' ' +
                                    (element.middleInitial ? element.middleInitial : '');
                            }
                        },
                        value: [],
                        list: vm.patientsList
                    }, {
                        id: 2,
                        title: 'End Date',
                        name: 'end_date',
                        required: true,
                        type: OdsParamType.DATE,
                        value: new Date()
                    }]
                }
            ]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider.state('login', {
            url: '/login',
            templateUrl: 'app/login/login.html',
            controller: 'LoginController',
            controllerAs: 'vm',
            data: {
                authorities: []
            },
            resolve: {}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', 'APP'];

    function LoginController ($rootScope, $state, $timeout, Auth, APP) {
        var vm = this;

        $rootScope.background = 'background-image: url(content/images/background.jpg); ' +
            'background-repeat: no-repeat; background-size:cover'

        vm.authenticationError = false;
        vm.errorMessage = 'Please check your credentials and try again.';
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = false;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        vm.appName = APP.APP_NAME;
        vm.appSuffixName = APP.APP_SUFFIX_NAME;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                // $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
                $state.go('home');
                // $state.go('maintenance');
            }).catch(function (error) {
                vm.authenticationError = true;
                vm.errorMessage = error.data.AuthenticationException;
            });
        }

        function register () {
            // $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            // $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SidebarController', SidebarController);

    SidebarController.$inject = ['$rootScope', '$state', 'Principal', 'ProfileService',
        'CoreService', 'ROLES', 'Clinic', 'Dashboard', 'DYMO', 'employee', 'clinics'];

    function SidebarController($rootScope, $state, Principal, ProfileService,
                               CoreService, ROLES, Clinic, Dashboard, DYMO, employee, clinics) {
        $rootScope.background = '';
        DYMO.loadPrinters();
        DYMO.loadDefaultDYMOOrderTemplate();
        DYMO.loadDefaultDYMOEnvOrderTemplate();

        var vm = this;
        vm.patientAuthority = [ROLES.ROLE_DOCTOR, ROLES.ROLE_SUPERVISOR].join(',');

        vm.abnormal = 0;
        vm.normal = 0;
        vm.kinetics = 0;
        vm.pdAdequacy = 0;
        vm.pdAdequacyWOUrine = 0;

        vm.account = null;
        vm.employee = employee;

        vm.isNavbarCollapsed = true;
        vm.isControlbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.changeClinic = changeClinic;
        vm.loadAllClinics = loadAllClinics;
        vm.deployClinics = deployClinics;

        vm.clinics = clinics;
        deployClinics(vm.clinics);

        vm.sideBarItems = [
            {
                id: 'home',
                open: 'menu-open',
                displayName: 'Dashboard',
                icon: 'fa fa-dashboard',
                state: '',
                style: 'display: block;',
                url: 'home',
                access: [ROLES.ROLE_USER].join(),
                items: [],
                alias: ["dashboard", "dashboard-doc", "dashboard-env", "dashboard-admin"]
            },
            {
                id: 'clinic',
                open: '',
                displayName: 'Clinic Information',
                icon: 'fa fa-medkit',
                state: '',
                style: 'display: block;',
                url: 'clinic',
                access: [ROLES.ROLE_USER].join(),
                items: []
            },
            {
                id: 'patient',
                open: '',
                displayName: 'Patients',
                icon: 'fa fa-users',
                state: '',
                style: 'display: none;',
                url: null,
                access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE].join(),
                items: [
                    {
                        state: '',
                        displayName: 'Roster',
                        url: 'patient',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE].join()
                    }, {
                        state: '',
                        displayName: 'Demographics',
                        url: 'patient-detail-menu({state1: "patient-detail"})',
                        icon: 'fa fa-dot-circle-o',
                        alias: ["patient-detail"],
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE].join()
                    }, {
                        state: '',
                        displayName: 'Hospitalization',
                        url: 'patient-detail-menu({state1: "hospitalization"})',
                        icon: 'fa fa-dot-circle-o',
                        alias: ["hospitalization"],
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE].join()
                    }, {
                        state: '',
                        displayName: 'Infections',
                        url: 'patient-detail-menu({state1: "infection"})',
                        icon: 'fa fa-dot-circle-o',
                        alias: ["infection"],
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE].join()
                    },
                    {
                        state: '',
                        displayName: 'Vaccination',
                        url: 'patient-detail-menu({state1: "vaccination"})',
                        icon: 'fa fa-dot-circle-o',
                        alias: ["vaccination"],
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE].join()
                    },
                    {
                        state: '',
                        displayName: 'Inactive Patient',
                        url: 'patient-i',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE].join()
                    }
                ]
            },
            {
                id: 'orders',
                open: '',
                displayName: 'Orders',
                icon: 'fa fa-calendar-check-o',
                state: '',
                style: 'display: block;',
                url: 'patient-detail-menu({state1: "patient-order-current"})',
                alias: ["patient-order-current"],
                access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE].join(),
                items: []
            },
            {
                id: 'kinetic',
                open: '',
                displayName: 'Kinetic',
                icon: 'fa fa-calculator',
                state: '',
                style: 'display: none;',
                url: 'kinetic',
                access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE].join(','),
                items: []
            },
            {
                id: 'pd_adequacy',
                open: '',
                displayName: 'Pd Adequacy',
                icon: 'fa fa-calculator',
                state: '',
                style: 'display: none;',
                url: 'pd-adequacy-patients',
                access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE].join(','),
                items: []
            },
            {
                id: 'results',
                open: '',
                displayName: 'Results',
                icon: 'fa fa-calendar-o',
                state: '',
                style: 'display: none;',
                alias: ["latest-result"],
                url: 'latest-result',
                access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE, ROLES.ROLE_ADMIN].join(),
                items: []
            },
            {
                id: 'environmental',
                open: '',
                displayName: 'Environmental',
                icon: 'fa fa-thermometer',
                state: '',
                style: 'display: none;',
                url: null,
                access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE, ROLES.ROLE_ENVIRONMENTAL].join(),
                items: [
                    {
                        state: '',
                        displayName: 'Sites',
                        url: 'machine',
                        icon: 'fa fa-dot-circle-o',
                        alias: ["machine"],
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE, ROLES.ROLE_ENVIRONMENTAL].join()
                    },
                    {
                        // id: 'machine-detail',
                        id: 'env-order',
                        displayName: 'Orders',
                        state: '',
                        url: 'machine-detail-menu({statem: "env-order"})',
                        alias: ["env-order"],
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE, ROLES.ROLE_ENVIRONMENTAL].join()
                    },
                    {
                        state: '',
                        displayName: 'Latest Results',
                        icon: 'fa fa-dot-circle-o',
                        url: 'machine-detail-menu({statem: "latest-env-result"})',
                        alias: ["latest-env-result", "machine-env-result"],
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_NURSE, ROLES.ROLE_ENVIRONMENTAL].join()
                    }
                ]
            },
            {
                id: 'reports',
                open: '',
                displayName: 'Reports',
                icon: 'fa fa-bar-chart',
                state: '',
                style: 'display: none;',
                url: 'reports',
                access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_ENVIRONMENTAL, ROLES.ROLE_NURSE].join(),
                items: []
            },
            {
                id: 'rpt-template',
                open: '',
                displayName: 'Report 2.0',
                icon: 'fa fa-bar-chart',
                state: '',
                style: 'display: none;',
                url: 'rpt-template',
                access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_DOCTOR, ROLES.ROLE_ENVIRONMENTAL, ROLES.ROLE_NURSE, ROLES.ROLE_ADMIN].join(),
                items: []
            },
            {
                id: 'report-template',
                state: '',
                open: '',
                displayName: 'Reports Templates',
                icon: 'fa fa-clone',
                style: 'display: none;',
                url: null,
                access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_ADMIN].join(),
                items: [
                    {
                        state: 'rpt-template-admin',
                        displayName: 'Report 2.0',
                        url: 'rpt-template-admin',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_ADMIN].join()
                    },
                    {
                        state: '',
                        displayName: 'Report Card Message',
                        url: 'rpt-compendium-message',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_ADMIN].join()
                    },
                    {
                        state: '',
                        displayName: 'Default Report Card Message',
                        url: 'rpt-compendium-default-message',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                    {
                        state: '',
                        displayName: 'Report Language',
                        url: 'rpt-language',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                    {
                        state: '',
                        displayName: 'Report Category',
                        url: 'rpt-category',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_ADMIN].join()
                    }
                ]
            },
            {
                id: 'template',
                state: '',
                open: '',
                displayName: 'Templates',
                icon: 'fa fa-clone',
                style: 'display: none;',
                url: null,
                access: [ROLES.ROLE_NURSE, ROLES.ROLE_SUPERVISOR, ROLES.ROLE_ADMIN, ROLES.ROLE_ENVIRONMENTAL].join(),
                items: [
                    {
                        state: '',
                        displayName: 'Patient Order',
                        url: 'patient-order-tpl',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_NURSE, ROLES.ROLE_SUPERVISOR, ROLES.ROLE_ADMIN].join()
                    },
                    {
                        state: '',
                        displayName: 'Site Order',
                        url: 'env-order-tpl',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_NURSE, ROLES.ROLE_SUPERVISOR, ROLES.ROLE_ADMIN, ROLES.ROLE_ENVIRONMENTAL].join()
                    },
                    {
                        id: 'report-config',
                        state: '',
                        open: '',
                        displayName: 'Patient Report',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        url: 'report-design',
                        access: [ROLES.ROLE_SUPERVISOR].join(),
                    },
                    {
                        id: 'result-level-message',
                        state: 'result-level-message',
                        open: '',
                        displayName: 'Report Card',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        url: 'result-level-message',
                        access: [ROLES.ROLE_SUPERVISOR].join(),
                    },
                    {
                        id: 'result-ranges',
                        state: '',
                        open: '',
                        displayName: 'Results Range',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        url: 'result-range',
                        access: [ROLES.ROLE_SUPERVISOR].join()
                    }
                ]
            },
            {
                id: 'config',
                state: '',
                open: '',
                displayName: 'Configuration',
                icon: 'fa fa-cog',
                style: 'display: none;',
                url: null,
                access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_ADMIN].join(),
                items: [
                    {
                        state: 'clinic-new',
                        displayName: 'New Clinic',
                        url: 'clinic-new',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                    {
                        state: 'clinics',
                        displayName: 'All Clinics',
                        url: 'clinics',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                    {
                        state: '',
                        displayName: 'Employees',
                        url: 'employee',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_ADMIN].join()
                    },
                    {
                        state: '',
                        displayName: 'Site Location',
                        url: 'site-location',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR].join()
                    },
                    {
                        state: '',
                        displayName: 'Corporation',
                        url: 'corporation',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                    {
                        id: 'patient-info-config',
                        state: '',
                        open: '',
                        displayName: 'Patient Info',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR].join(),
                        items: [
                            {
                                state: '',
                                displayName: 'Race',
                                url: 'race',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            },
                            {
                                state: '',
                                displayName: 'Language',
                                url: 'language',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            }
                        ]
                    },
                    {
                        id: 'patient-clinical-info-config',
                        state: '',
                        open: '',
                        displayName: 'Patient Clinical Info',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR].join(),
                        items: [
                            {
                                state: '',
                                displayName: 'Patient Type',
                                url: 'patient-type',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            },
                            {
                                state: '',
                                displayName: 'Modality',
                                url: 'modality',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            },
                            {
                                state: '',
                                displayName: 'Template',
                                url: 'patient-template',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            }
                        ]
                    },
                    {
                        id: 'patient-insurance-config',
                        state: '',
                        open: '',
                        displayName: 'Patient Insurance',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_ADMIN].join(),
                        items: [
                            {
                                state: '',
                                displayName: 'Insurance Carrier',
                                url: 'insurance-carrier',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_ADMIN].join()
                            },
                            {
                                state: '',
                                displayName: 'Insurance Level',
                                url: 'insurance-level',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            },
                            {
                                state: '',
                                displayName: 'Insurance Relation',
                                url: 'insurance-relation',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            },
                            {
                                state: '',
                                displayName: 'Insurance Type',
                                url: 'insurance-type',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            }
                        ]
                    },
                    {
                        id: 'patient-care-team-config',
                        state: '',
                        open: '',
                        displayName: 'Patient Care Team',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR].join(),
                        items: [
                            {
                                state: '',
                                displayName: 'Care Team Specialty',
                                url: 'care-team-specialty',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            }
                        ]
                    },
                    {
                        id: 'hospitalization-discharge-to-config',
                        state: '',
                        open: '',
                        displayName: 'Patient Hospitalization',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR].join(),
                        items: [
                            {
                                state: '',
                                displayName: 'Hospitalization Discharge',
                                url: 'hospitalization-discharge-to',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            }
                        ]
                    },
                    {
                        id: 'patient-infection-config',
                        state: '',
                        open: '',
                        displayName: 'Patient Infection',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR].join(),
                        items: [
                            {
                                state: '',
                                displayName: 'Source',
                                url: 'source',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            },
                            {
                                state: '',
                                displayName: 'Primary Access',
                                url: 'infection-primary-access',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            },
                            {
                                state: '',
                                displayName: 'Type of Dialyser',
                                url: 'dialyser-type',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            },
                            {
                                state: '',
                                displayName: 'Symptoms',
                                url: 'symptom',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            }
                        ]
                    },
                    {
                        id: 'patient-medication',
                        state: '',
                        open: '',
                        displayName: 'Patient Medication',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR].join(),
                        items: [
                            {
                                state: '',
                                displayName: 'Dosage',
                                url: 'med-dosage-unit',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            },
                            {
                                state: '',
                                displayName: 'Route',
                                url: 'med-route',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            },
                            {
                                state: '',
                                displayName: 'Fecuency From',
                                url: 'med-frequency-from',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            },
                            {
                                state: '',
                                displayName: 'Fecuency To',
                                url: 'med-frequency-to',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            },
                            {
                                state: '',
                                displayName: 'Location',
                                url: 'med-location',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SUPERVISOR].join()
                            }
                        ]
                    },
                    {
                        id: 'compendium',
                        state: '',
                        open: '',
                        displayName: 'Compendium',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        url: 'compendium',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                    {
                        state: '',
                        displayName: 'Internal Codes',
                        url: 'rpt-metadata',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                    {
                        id: 'compendium-report-group',
                        state: '',
                        open: '',
                        displayName: 'Compendium Report Group',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        url: 'compendium-report-group',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                    {
                        id: 'tube',
                        state: '',
                        open: '',
                        displayName: 'Tubes',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        url: 'tube',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                    {
                        id: 'xml-config',
                        state: '',
                        open: '',
                        displayName: 'Labels',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        url: 'x-ml-config',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                    {
                        id: 'maintenance',
                        state: '',
                        open: '',
                        displayName: 'Maintenance',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        url: 'x-ml-config',
                        access: [ROLES.ROLE_ADMIN].join(),
                        items: [
                            {
                                state: '',
                                displayName: 'Report Group',
                                url: 'maintenance-rgroup',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_ADMIN].join()
                            },
                            {
                                state: '',
                                displayName: 'Ranges',
                                url: 'maintenance-range',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_ADMIN].join()
                            }
                        ]
                    },
                    {
                        state: '',
                        displayName: 'Kinetic Skip',
                        url: 'kinetic-skip',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                    {
                        id: 'vaccine',
                        state: '',
                        open: '',
                        displayName: 'Vaccines',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        url: 'vaccine',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                    {
                        state: '',
                        displayName: 'Emr Integration Log',
                        url: 'pr-emr-integration-log',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_SUPERVISOR, ROLES.ROLE_ADMIN].join()
                    },
                    {
                        state: '',
                        displayName: 'Lab Notifications',
                        url: 'lab-notification',
                        icon: 'fa fa-dot-circle-o',
                        access: [ROLES.ROLE_ADMIN].join()
                    },
                ]
            },
            {
                id: 'kinetic-sent',
                state: '',
                open: '',
                displayName: 'Kinetic Sent',
                icon: 'fa fa-cog',
                style: 'display: none;',
                url: 'kinetic-sent',
                access: [ROLES.ROLE_ADMIN].join(),
                items: []
            },
            {
                id: 'billing-menu',
                state: '',
                displayName: 'Billing',
                url: null,
                icon: 'fa fa-dollar',
                access: [ROLES.ROLE_ADMIN].join(),
                items: [
                    {
                        id: 'invoice',
                        state: 'invoice',
                        open: 'invoice',
                        displayName: 'Invoice',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join(),
                        url: 'invoice'
                    },
                    {
                        id: 'billing',
                        state: 'billing',
                        open: 'billing',
                        displayName: 'Billing Documents',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join(),
                        url: 'billing'
                    }, {
                        id: 'billing-bundle',
                        state: '',
                        open: '',
                        displayName: 'Billing Bundle',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join(),
                        url: 'lab-bundle-billing-code'
                    }, {
                        id: 'compendium-special-price',
                        state: '',
                        open: '',
                        displayName: 'Compendium Special Prices',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join(),
                        url: 'compendium-special-price'
                    }, {
                        id: 'billing-frequency',
                        state: '',
                        open: '',
                        displayName: 'Billing Frequency',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join(),
                        url: 'billing-frequency'
                    }, {
                        id: 'bundle',
                        state: '',
                        open: '',
                        displayName: 'Bundle',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join(),
                        url: 'bundle'
                    }, {
                        id: 'composite',
                        state: '',
                        open: '',
                        displayName: 'Composite',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join(),
                        url: 'composite'
                    }
                ]
            },
            {
                id: 'adjust',
                state: '',
                displayName: 'Admin adjust',
                url: null,
                icon: 'fa fa-gear',
                access: [ROLES.ROLE_ADMIN].join(),
                items: [
                    {
                        id: 'patient-result-update-dates',
                        state: 'patient-result-update-dates',
                        open: 'patient-result-update-dates',
                        displayName: 'Patient Result Dates',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join(),
                        url: 'patient-result-update-dates'
                    },
                    {
                        id: 'env-result-update-dates',
                        state: 'env-result-update-dates',
                        open: 'env-result-update-dates',
                        displayName: 'Site Result Dates',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join(),
                        url: 'env-result-update-dates'
                    },
                    {
                        id: 'kinetic-skip',
                        state: 'kinetic-skip',
                        // open: 'env-result-update-dates',
                        displayName: 'Kinetic Skip',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join(),
                        url: 'kinetic-skip'
                    },
                    {
                        id: 'patient-result-delete',
                        state: 'patient-result-delete',
                        displayName: 'Delete Patient Result',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join(),
                        url: 'patient-result-delete'
                    },
                    {
                        id: 'env-result-delete',
                        state: 'env-result-delete',
                        displayName: 'Delete Env Result',
                        style: 'display: none;',
                        icon: 'fa fa-circle-o',
                        access: [ROLES.ROLE_ADMIN].join(),
                        url: 'env-result-delete'
                    }
                ]
            }
        ];

        $rootScope.$on('$stateChangeSuccess',
            function (event, toState, toParams, fromState, fromParams) {
                selectMenuItem($state.current.name);
            });

        selectMenuItem();

        function selectMenuItem() {
            var url = $state.current.name;
            var lessChild = null;
            var parent = null;
            var child = null;
            for (var i = 0; i < vm.sideBarItems.length; i++) {
                if (vm.sideBarItems[i].url == url || (vm.sideBarItems[i].alias != null && vm.sideBarItems[i].alias.indexOf(url) != -1)) {
                    vm.sideBarItems[i].state = 'active';
                    vm.sideBarItems[i].style = 'display: none;';
                } else {
                    vm.sideBarItems[i].state = '';
                    vm.sideBarItems[i].style = 'display: none;';
                    vm.sideBarItems[i].open = '';
                }

                for (var j = 0; j < vm.sideBarItems[i].items.length; j++) {
                    if (vm.sideBarItems[i].items[j].items == null) {
                        if (vm.sideBarItems[i].items[j].url == url || (vm.sideBarItems[i].items[j].alias != null && vm.sideBarItems[i].items[j].alias.indexOf(url) != -1)) {
                            parent = i;
                            child = j;
                        } else {
                            vm.sideBarItems[i].open = '';
                            vm.sideBarItems[i].style = 'display: none;';
                            vm.sideBarItems[i].state = '';
                            vm.sideBarItems[i].items[j].state = '';
                            vm.sideBarItems[i].items[j].icon = "fa fa-circle-o";
                            vm.sideBarItems[i].items[j].active = '';
                        }
                    } else {
                        for (var k = 0; k < vm.sideBarItems[i].items[j].items.length; k++) {
                            if (vm.sideBarItems[i].items[j].items[k].url == url || (vm.sideBarItems[i].items[j].items[k].alias != null && vm.sideBarItems[i].items[j].items[k].alias.indexOf(url) !== -1)) {
                                parent = i;
                                child = j;
                                lessChild = k;
                            } else {
                                vm.sideBarItems[i].open = '';
                                vm.sideBarItems[i].style = 'display: none;';
                                vm.sideBarItems[i].state = '';
                                vm.sideBarItems[i].items[j].open = '';
                                vm.sideBarItems[i].items[j].style = 'display: none;';
                                vm.sideBarItems[i].items[j].state = '';
                                vm.sideBarItems[i].items[j].items[k].state = '';
                                vm.sideBarItems[i].items[j].items[k].icon = "fa fa-circle-o";
                                vm.sideBarItems[i].items[j].items[k].active = '';
                            }
                        }
                    }
                }
            }

            if (parent != null && child != null) {
                if (lessChild == null) {
                    vm.sideBarItems[parent].open = 'menu-open';
                    vm.sideBarItems[parent].style = 'display: block;';
                    vm.sideBarItems[parent].state = 'active';

                    vm.sideBarItems[parent].items[child].state = 'active';
                    vm.sideBarItems[parent].items[child].icon = "fa fa-dot-circle-o";
                    vm.sideBarItems[parent].items[child].active = 'active';
                } else {
                    vm.sideBarItems[parent].open = 'menu-open';
                    vm.sideBarItems[parent].style = 'display: block;';
                    vm.sideBarItems[parent].state = 'active';

                    vm.sideBarItems[parent].items[child].open = 'menu-open';
                    vm.sideBarItems[parent].items[child].style = "display: block;";
                    vm.sideBarItems[parent].items[child].state = 'active';

                    vm.sideBarItems[parent].items[child].items[lessChild].state = 'active';
                    vm.sideBarItems[parent].items[child].items[lessChild].icon = "fa fa-dot-circle-o";
                    vm.sideBarItems[parent].items[child].items[lessChild].active = 'active';
                }
            }
        }

        function loadAllClinics() {
            Clinic.query(function (result) {
                deployClinics(result);
            });
        }

        sortSubMenus();

        $rootScope.$on('dialysisApp:clinicNew', loadAllClinics);

        function changeClinic() {
            CoreService.setCurrentPatient(null);
            CoreService.setCurrentClinic(vm.currentClinic);

            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function toggleControlbar() {
            vm.isControlbarCollapsed = !vm.isControlbarCollapsed;
        }

        function getEmployee() {
            vm.employee = CoreService.getCurrentEmployee();
        }

        function deployClinics(result) {
            vm.clinics = result;
            if (result.length > 0) {
                vm.currentClinic = CoreService.getCurrentClinic();

                if (!vm.currentClinic) {
                    vm.currentClinic = result[0];
                }

                CoreService.setCurrentClinic(vm.currentClinic);
            }
        }

        function sortSubMenus() {
            _.forEach(vm.sideBarItems, function (parentItem) {
                if (parentItem.items && parentItem.items.length > 0) {
                    parentItem.items = _.sortBy(parentItem.items, 'displayName');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

/**
 * Created by hermeslm on 10/2/16.
 */

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MainController', MainController);

    MainController.$inject = ['$scope', '$state', 'Auth', 'Principal', 'ProfileService',
        'LoginService', 'AdminLTEService'];

    function MainController ($scope, $state, Auth, Principal, ProfileService, LoginService, AdminLTEService) {
        var vm = this;

        vm.toggleBtn = '[data-toggle="offcanvas"]';

        vm.account = null;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        AdminLTEService.registerPushMenuActions(vm.toggleBtn);
        AdminLTEService.registerBoxWidget();
        AdminLTEService.registerControlSidebar();

        // $scope.$on('authenticationSuccess', function() {
        //     getAccount();
        // });
        //
        // getAccount();
        //
        // // $state.transitionTo('app.layout');
        //
        // function getAccount() {
        //     Principal.identity().then(function(account) {
        //         vm.account = account;
        //         vm.isAuthenticated = Principal.isAuthenticated;
        //     });
        // }

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

/**
 * Created by hermeslm on 10/2/16.
 */

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HeaderController', HeaderController);

    HeaderController.$inject = ['employee', '$state', 'Auth', 'Principal', 'APP',
        'CoreService', '$rootScope', 'EMPLOYEE_TYPE', 'Idle', '$uibModal', 'IDLE', '$uibModalStack'];

    function HeaderController(employee, $state, Auth, Principal, APP, CoreService,
                              $rootScope, EMPLOYEE_TYPE, Idle, $uibModal, IDLE, $uibModalStack) {
        var vm = this;

        vm.appName = APP.APP_NAME;
        vm.appSuffixName = APP.APP_SUFFIX_NAME;
        vm.appShortName = APP.APP_SHORT_NAME;
        vm.account = null;
        vm.clinics = [];
        vm.currentClinic = null;
        vm.avatar = null;
        vm.memberSince = null;

        vm.isAuthenticated = Principal.isAuthenticated;
        vm.logout = logout;
        vm.$state = $state;

        vm.account = employee.user;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.employee = employee;
        vm.employee.avatar = CoreService.getAvatar(employee.gender);
        CoreService.setCurrentEmployee(vm.employee);

        function logout() {
            Auth.logout();
            CoreService.clearSession();
            $state.go('login');
        }

        vm.countdown = IDLE.timeout;

        closeModals();
        function closeModals() {
            if (vm.warning) {
                vm.warning.close();
                vm.warning = null;
            }
        }

        $rootScope.$on('IdleStart', function() {
            vm.warning = $uibModal.open({
                templateUrl: 'warning-dialog.html',
                windowClass: 'modal-danger'
            });
        });

        $rootScope.$on('IdleEnd', function() {
            closeModals();

            vm.countdown = IDLE.timeout;
        });

        $rootScope.$on('IdleTimeout', function() {
            $uibModalStack.dismissAll();

            logout();
        });

        Idle.watch();
    }
})();


/**
 * Created by hermeslm on 10/2/16.
 */

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('FooterController', FooterController);

    FooterController.$inject = ['AdminLTEService', '$timeout', '$rootScope'];

    function FooterController(AdminLTEService, $timeout, $rootScope) {
        var vm = this;

        $rootScope.$on('$viewContentLoading',
            function (event, viewConfig) {
                // Access to all the view config properties.
                // and one special property 'targetView'
                // viewConfig.targetView
                $timeout(function () {
                    $timeout(function () {
                        AdminLTEService.layoutFix();
                    }, 0);
                }, 0);
            });

    }
})();


(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            })
            .state('maintenance', {
                parent: 'app',
                url: '/maintenance',
                ncyBreadcrumb: {
                    label: 'Maintenance'
                },
                data: {
                    authorities: [],
                    pageTitle: 'Under Construction'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/construction.html',
                        controller: 'ConstructionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'maintenance',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ConstructionController', ConstructionController);

    ConstructionController.$inject = ['previousState'];

    function ConstructionController (previousState) {
        var vm = this;
        vm.previousState = previousState.name;

    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ControlBarController', ControlBarController);

    ControlBarController.$inject = ['$rootScope', '$scope', '$state', 'Auth', 'Principal',
        'ProfileService', 'LoginService', 'AdminLTEService'];

    function ControlBarController($rootScope, $scope, $state, Auth, Principal, ProfileService,
                                  LoginService, AdminLTEService) {
        var vm = this;
        vm.isControlbarCollapsed = true;
        AdminLTEService.registerControlSidebar();

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('home', {
                parent: 'app',
                url: '/',
                ncyBreadcrumb: {
                    label: 'Home',
                    parent: 'app'
                },
                data: {
                    pageTitle: 'Dialysis',
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/home.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    date: ['$stateParams', 'moment', function ($stateParams, moment) {
                        return $stateParams.date ? moment($stateParams.date).format("Y/MM/DD") : moment(new Date()).format("Y/MM/DD");
                    }],
                    hasPrinter: ['DYMO', function (DYMO) {
                        return DYMO.loadPrinters();
                    }]
                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['CoreService', 'ROLES', '$state'];

    function HomeController (CoreService, ROLES, $state) {
        var vm = this;

        CoreService.initActiveScheduleTabTab();

        if (CoreService.currentHasEmployeeRole(ROLES.ROLE_ENVIRONMENTAL)) {
            $state.go("dashboard-env");
        } else if (CoreService.currentHasEmployeeRole(ROLES.ROLE_ADMIN)) {
            $state.go("dashboard-admin");
        } else if (CoreService.currentHasEmployeeRole(ROLES.ROLE_LAB_OVERVIEW)) {
            $state.go("calendar");
        } else {
            var clinic = CoreService.getCurrentClinic();
            $state.go("dashboard2");

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('XMLConfigDialogController', XMLConfigDialogController);

    XMLConfigDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'XMLConfig', 'Corporation'];

    function XMLConfigDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, XMLConfig, Corporation) {
        var vm = this;

        vm.xMLConfig = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.corporations = Corporation.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.xMLConfig.id !== null) {
                XMLConfig.update(vm.xMLConfig, onSaveSuccess, onSaveError);
            } else {
                XMLConfig.save(vm.xMLConfig, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:xMLConfigUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setFile = function ($file, xMLConfig) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        xMLConfig.file = base64Data;
                        xMLConfig.fileContentType = $file.type;
                    });
                });
            }
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('XMLConfigDetailController', XMLConfigDetailController);

    XMLConfigDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'XMLConfig', 'Corporation'];

    function XMLConfigDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, XMLConfig, Corporation) {
        var vm = this;

        vm.xMLConfig = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('dialysisApp:xMLConfigUpdate', function(event, result) {
            vm.xMLConfig = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('XMLConfigDeleteController',XMLConfigDeleteController);

    XMLConfigDeleteController.$inject = ['$uibModalInstance', 'entity', 'XMLConfig'];

    function XMLConfigDeleteController($uibModalInstance, entity, XMLConfig) {
        var vm = this;

        vm.xMLConfig = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            XMLConfig.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('x-ml-config', {
            parent: 'entity',
            url: '/x-ml-config',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'XMLConfigs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/x-ml-config/x-ml-configs.html',
                    controller: 'XMLConfigController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('x-ml-config-detail', {
            parent: 'entity',
            url: '/x-ml-config/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'XMLConfig'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/x-ml-config/x-ml-config-detail.html',
                    controller: 'XMLConfigDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'XMLConfig', function($stateParams, XMLConfig) {
                    return XMLConfig.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'x-ml-config',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('x-ml-config-detail.edit', {
            parent: 'x-ml-config-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'XMLConfig'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/x-ml-config/x-ml-config-dialog.html',
                    controller: 'XMLConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['XMLConfig', function(XMLConfig) {
                            return XMLConfig.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('x-ml-config.new', {
            parent: 'x-ml-config',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/x-ml-config/x-ml-config-dialog.html',
                    controller: 'XMLConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                file: null,
                                fileContentType: null,
                                xType: null,
                                byDefault: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('x-ml-config', null, { reload: 'x-ml-config' });
                }, function() {
                    $state.go('x-ml-config');
                });
            }]
        })
        .state('x-ml-config.edit', {
            parent: 'x-ml-config',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/x-ml-config/x-ml-config-dialog.html',
                    controller: 'XMLConfigDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['XMLConfig', function(XMLConfig) {
                            return XMLConfig.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('x-ml-config', null, { reload: 'x-ml-config' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('x-ml-config.delete', {
            parent: 'x-ml-config',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/x-ml-config/x-ml-config-delete-dialog.html',
                    controller: 'XMLConfigDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['XMLConfig', function(XMLConfig) {
                            return XMLConfig.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('x-ml-config', null, { reload: 'x-ml-config' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('XMLConfig', XMLConfig);

    XMLConfig.$inject = ['$resource'];

    function XMLConfig ($resource) {
        var resourceUrl =  'api/x-ml-configs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'environmental': { url: 'api/x-ml-configs/environmental/default', method: 'GET'},
            'patient': { url: 'api/x-ml-configs/patient/default', method: 'GET'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('XMLConfigSearch', XMLConfigSearch);

    XMLConfigSearch.$inject = ['$resource'];

    function XMLConfigSearch($resource) {
        var resourceUrl =  'api/_search/x-ml-configs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('XMLConfigController', XMLConfigController);

    XMLConfigController.$inject = ['$scope', '$state', 'DataUtils', 'XMLConfig', 'XMLConfigSearch', '$q',
        'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'DYMO'];

    function XMLConfigController($scope, $state, DataUtils, XMLConfig, XMLConfigSearch, $q,
                                 DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, DYMO) {
        var vm = this;
        vm.title = 'Labels Configs';
        vm.entityClassHumanized = 'XML Config';
        vm.entityStateName = 'x-ml-config';

        vm.xMLConfigs = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                XMLConfig.query(function (result) {
                    vm.xMLConfigs = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.xMLConfigs, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn('description').withTitle('Description'),
            DTColumnBuilder.newColumn('xType').withTitle('Type'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '190px').notSortable().renderWith(actionsHtml)
        ];

        function yesNoHtml(data, type, full, meta) {
            if (full.byDefault) {
                return GUIUtils.getStatusTemplate('YES', 'success');
            } else {
                return GUIUtils.getStatusTemplate('NO', 'danger');
            }
        }

        function loadAll() {
            XMLConfig.query(function (result) {
                vm.xMLConfigs = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta) {
            return '<a class="btn-sm btn-primary" ng-click="vm.print(' + "'" + data.file + "'" + ",'" + data.xType +  "'"  + ')">' +
                '<i class="glyphicon glyphicon-print"></i></a>&nbsp;' + GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        vm.print = print;
        function print(b64xml, type){
            if (type == 'PATIENT')
                DYMO.testPatientLabel(b64xml);
            else
                DYMO.testEnvironmentalLabel(b64xml);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderTestIntervalDialogController', PatientOrderTestIntervalDialogController);

    PatientOrderTestIntervalDialogController.$inject = ['DateUtils', 'patientOrderTpl', '$uibModalInstance', 'clinic'];

    function PatientOrderTestIntervalDialogController(DateUtils, patientOrderTpl, $uibModalInstance, clinic) {
        var vm = this;

        vm.patientOrderTpl = patientOrderTpl;
        vm.staringDate = null;
        vm.endDate = null;
        vm.clinic = clinic;

        if (vm.patientOrderTpl.orderType == 'STANDING') {
            vm.endDate = DateUtils.convertLocalDateFromServer(vm.clinic.standingEnd);
        }

        var days = vm.clinic.drawDays;

        vm.form = {};
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.staringDate = false;

        vm.startOptions = {
            minDate: new Date(),
            dateDisabled: disabled,
            startingDay: 1
        }

        vm.endOptions = {
            minDate: new Date(),
            startingDay: 1
        }

        function disabled(date) {
            if (vm.patientOrderTpl.orderType == "ONE_TIME") {
                return false;
            }

            var match = false;
            if (date.date.getDay() == 0) {
                //sunday js(0) -> java(6)
                match = date.mode === 'day' && days[6] == "0";
            } else {
                //others days
                match = date.mode === 'day' && days[date.date.getDay() - 1] == "0";
            }

            if (!match) {
                switch (vm.clinic.pDrawWeek) {
                    case 'FIRST_HALF_WEEK': {
                        if (date.date.getDate() < 8) {
                            match = false;
                        } else {
                            match = true;
                        }

                        break;
                    }
                    case 'FIRST_FULL_WEEK': {
                        var x = date.date.getDate() + 1 - (date.date.getDay() == 0 ? 7 : date.date.getDay());
                        match = x <= 0 || x >= 8;

                        break;
                    }
                    case 'SECOND_FULL_WEEK': {
                        var x = date.date.getDate() + 1 - (date.date.getDay() == 0 ? 7 : date.date.getDay()) - 7;
                        match = x <= 0 || x >= 8;

                        break;
                    }
                }
            }

            return match;
        }

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.openCalendar = openCalendar;
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.accept = function () {
            for (var i = 0; i < vm.patientOrderTpl.patientOrderJson.patientOrderTests.length; i++) {
                vm.patientOrderTpl.patientOrderJson.patientOrderTests[i].staringDate = vm.staringDate;
                vm.patientOrderTpl.patientOrderJson.patientOrderTests[i].endDate = vm.endDate ? vm.endDate : vm.staringDate;
            }

            $uibModalInstance.close({tpl: vm.patientOrderTpl});
        }

        vm.closeAlert = function(index) {
            vm.alerts.splice(index, 1);
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvTestIntervalDialogController', EnvTestIntervalDialogController);

    EnvTestIntervalDialogController.$inject = ['envOrderTpl', '$uibModalInstance', 'clinic'];

    function EnvTestIntervalDialogController(envOrderTpl, $uibModalInstance, clinic) {
        var vm = this;

        vm.envOrderTpl = envOrderTpl;
        vm.staringDate = null;
        vm.endDate = null;
        vm.clinic = clinic;

        vm.form = {};
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.staringDate = false;

        vm.startOptions = {
            minDate: new Date(),
            // dateDisabled: disabled,
            startingDay: 1
        }

        vm.endOptions = {
            minDate: new Date(),
            startingDay: 1
        }

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.openCalendar = openCalendar;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.accept = function () {
            for (var i = 0; i < vm.envOrderTpl.envOrderJson.envTests.length; i++) {
                vm.envOrderTpl.envOrderJson.envTests[i].staringDate = vm.staringDate;
                vm.envOrderTpl.envOrderJson.envTests[i].endDate = vm.staringDate;
            }

            $uibModalInstance.close({tpl: vm.envOrderTpl});
        }

        vm.closeAlert = function(index) {
            vm.alerts.splice(index, 1);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DatePickerDialogController', DatePickerDialogController);

    DatePickerDialogController.$inject = ['date', '$uibModalInstance'];

    function DatePickerDialogController (date, $uibModalInstance) {
        var vm = this;

        vm.date = date;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.date = false;

        vm.openCalendar = openCalendar;
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.accept = function () {
            $uibModalInstance.close({date: vm.date});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ViaDialogController', ViaDialogController);

    ViaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Via', 'PatientOrder'];

    function ViaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Via, PatientOrder) {
        var vm = this;

        vm.via = entity;
        vm.clear = clear;
        vm.save = save;
        vm.patientorders = PatientOrder.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.via.id !== null) {
                Via.update(vm.via, onSaveSuccess, onSaveError);
            } else {
                Via.save(vm.via, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:viaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ViaDetailController', ViaDetailController);

    ViaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Via', 'PatientOrder'];

    function ViaDetailController($scope, $rootScope, $stateParams, previousState, entity, Via, PatientOrder) {
        var vm = this;

        vm.via = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:viaUpdate', function(event, result) {
            vm.via = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ViaDeleteController',ViaDeleteController);

    ViaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Via'];

    function ViaDeleteController($uibModalInstance, entity, Via) {
        var vm = this;

        vm.via = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Via.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('via', {
            parent: 'entity',
            url: '/via',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Vias'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/via/vias.html',
                    controller: 'ViaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('via-detail', {
            parent: 'entity',
            url: '/via/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Via'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/via/via-detail.html',
                    controller: 'ViaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Via', function($stateParams, Via) {
                    return Via.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'via',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('via-detail.edit', {
            parent: 'via-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/via/via-dialog.html',
                    controller: 'ViaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Via', function(Via) {
                            return Via.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('via.new', {
            parent: 'via',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/via/via-dialog.html',
                    controller: 'ViaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('via', null, { reload: 'via' });
                }, function() {
                    $state.go('via');
                });
            }]
        })
        .state('via.edit', {
            parent: 'via',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/via/via-dialog.html',
                    controller: 'ViaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Via', function(Via) {
                            return Via.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('via', null, { reload: 'via' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('via.delete', {
            parent: 'via',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/via/via-delete-dialog.html',
                    controller: 'ViaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Via', function(Via) {
                            return Via.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('via', null, { reload: 'via' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Via', Via);

    Via.$inject = ['$resource'];

    function Via ($resource) {
        var resourceUrl =  'api/vias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('ViaSearch', ViaSearch);

    ViaSearch.$inject = ['$resource'];

    function ViaSearch($resource) {
        var resourceUrl =  'api/_search/vias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ViaController', ViaController);

    ViaController.$inject = ['$scope', '$state', 'Via', 'ViaSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function ViaController ($scope, $state, Via, ViaSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.vias = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  Via.query(function(result) {
                  vm.vias = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.vias, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            Via.query(function(result) {
                vm.vias = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('VaccineDialogController', VaccineDialogController);

    VaccineDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Vaccine'];

    function VaccineDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Vaccine) {
        var vm = this;

        vm.vaccine = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vaccine.id !== null) {
                Vaccine.update(vm.vaccine, onSaveSuccess, onSaveError);
            } else {
                Vaccine.save(vm.vaccine, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:vaccineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('VaccineDetailController', VaccineDetailController);

    VaccineDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Vaccine'];

    function VaccineDetailController($scope, $rootScope, $stateParams, previousState, entity, Vaccine) {
        var vm = this;

        vm.vaccine = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:vaccineUpdate', function(event, result) {
            vm.vaccine = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('VaccineDeleteController',VaccineDeleteController);

    VaccineDeleteController.$inject = ['$uibModalInstance', 'entity', 'Vaccine'];

    function VaccineDeleteController($uibModalInstance, entity, Vaccine) {
        var vm = this;

        vm.vaccine = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Vaccine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vaccine', {
            parent: 'entity',
            url: '/vaccine',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vaccines'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vaccine/vaccines.html',
                    controller: 'VaccineController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('vaccine-detail', {
            parent: 'vaccine',
            url: '/vaccine/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vaccine'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vaccine/vaccine-detail.html',
                    controller: 'VaccineDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Vaccine', function($stateParams, Vaccine) {
                    return Vaccine.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'vaccine',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('vaccine-detail.edit', {
            parent: 'vaccine-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vaccine/vaccine-dialog.html',
                    controller: 'VaccineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Vaccine', function(Vaccine) {
                            return Vaccine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vaccine.new', {
            parent: 'vaccine',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vaccine/vaccine-dialog.html',
                    controller: 'VaccineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('vaccine', null, { reload: 'vaccine' });
                }, function() {
                    $state.go('vaccine');
                });
            }]
        })
        .state('vaccine.edit', {
            parent: 'vaccine',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vaccine/vaccine-dialog.html',
                    controller: 'VaccineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Vaccine', function(Vaccine) {
                            return Vaccine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vaccine', null, { reload: 'vaccine' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vaccine.delete', {
            parent: 'vaccine',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vaccine/vaccine-delete-dialog.html',
                    controller: 'VaccineDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Vaccine', function(Vaccine) {
                            return Vaccine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vaccine', null, { reload: 'vaccine' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Vaccine', Vaccine);

    Vaccine.$inject = ['$resource'];

    function Vaccine ($resource) {
        var resourceUrl =  'api/vaccines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('VaccineSearch', VaccineSearch);

    VaccineSearch.$inject = ['$resource'];

    function VaccineSearch($resource) {
        var resourceUrl =  'api/_search/vaccines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('VaccineController', VaccineController);

    VaccineController.$inject = ['$scope', '$state', 'Vaccine', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function VaccineController($scope, $state, Vaccine, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile) {
        var vm = this;
        vm.title = 'Vaccines';
        vm.entityClassHumanized = 'Vaccines';
        vm.entityStateName = 'vaccine';

        vm.vaccines = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                Vaccine.query(function (result) {
                    vm.vaccines = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.vaccines, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function loadAll() {
            Vaccine.query(function (result) {
                vm.vaccines = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('VaccinationDialogController', VaccinationDialogController);

    VaccinationDialogController.$inject = ['$timeout', '$scope', 'vaccination', '$uibModalInstance', 'Vaccination', 'Vaccine', '$state'
    ];

    function VaccinationDialogController($timeout, $scope, vaccination, $uibModalInstance, Vaccination, Vaccine, $state) {
        var vm = this;
        vm.vaccination = vaccination;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.vaccines = Vaccine.query();
        vm.editing = $state.current.name != "vaccination.view";

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.vaccination.id !== null) {
                Vaccination.update(vm.vaccination, onSaveSuccess, onSaveError);
            } else {
                Vaccination.save(vm.vaccination, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('dialysisApp:vaccinationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.completionDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('VaccinationDetailController', VaccinationDetailController);

    VaccinationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Vaccination', 'Patient', 'Vaccin'];

    function VaccinationDetailController($scope, $rootScope, $stateParams, previousState, entity, Vaccination, Patient, Vaccin) {
        var vm = this;

        vm.vaccination = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:vaccinationUpdate', function(event, result) {
            vm.vaccination = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('VaccinationDeleteController',VaccinationDeleteController);

    VaccinationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Vaccination'];

    function VaccinationDeleteController($uibModalInstance, entity, Vaccination) {
        var vm = this;

        vm.vaccination = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Vaccination.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('vaccination', {
                parent: 'patient-abs',
                url: '/vaccination',
                ncyBreadcrumb: {
                    label: 'Vaccinations',
                },
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Vaccinations'
                },
                views: {
                    'content@patient-abs': {
                        templateUrl: 'app/entities/vaccination/vaccinations.html',
                        controller: 'VaccinationController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('vaccination.view', {
                parent: 'vaccination',
                url: '/{vid}/view',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/vaccination/vaccination-dialog.html',
                        controller: 'VaccinationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            vaccination: ['Vaccination', function (Vaccination) {
                                return Vaccination.get({id: $stateParams.vid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('vaccination', {id: $stateParams.id}, {reload: 'vaccination'});
                    }, function () {
                        $state.go('vaccination', {id: $stateParams.id}, {reload: 'vaccination'});
                    });
                }]
            })
            .state('vaccination.new', {
                parent: 'vaccination',
                url: '/new',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function ($stateParams, $state, $uibModal, entity) {
                    $uibModal.open({
                        templateUrl: 'app/entities/vaccination/vaccination-dialog.html',
                        controller: 'VaccinationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            vaccination: function () {
                                return {
                                    completionDate: null,
                                    responded: null,
                                    id: null,
                                    patient: entity
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('vaccination', {id: $stateParams.id}, {reload: 'vaccination'});
                    }, function () {
                        $state.go('vaccination', {id: $stateParams.id}, {reload: 'vaccination'});
                    });
                }]
            })
            .state('vaccination.delete', {
                parent: 'vaccination',
                url: '/{vid}/delete',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/vaccination/vaccination-delete-dialog.html',
                        controller: 'VaccinationDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Vaccination', function (Vaccination) {
                                return Vaccination.get({id: $stateParams.vid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('vaccination', null, {reload: 'vaccination'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Vaccination', Vaccination);

    Vaccination.$inject = ['$resource', 'DateUtils'];

    function Vaccination ($resource, DateUtils) {
        var resourceUrl =  'api/vaccinations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.completionDate = DateUtils.convertLocalDateFromServer(data.completionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.completionDate = DateUtils.convertLocalDateToServer(copy.completionDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.completionDate = DateUtils.convertLocalDateToServer(copy.completionDate);
                    return angular.toJson(copy);
                }
            },
            'getAllByPatientId': { 'url': 'api/vaccinations/patient/:id', method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('VaccinationSearch', VaccinationSearch);

    VaccinationSearch.$inject = ['$resource'];

    function VaccinationSearch($resource) {
        var resourceUrl =  'api/_search/vaccinations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('VaccinationController', VaccinationController);

    VaccinationController.$inject = ['$compile', '$scope', 'Vaccination', 'entity', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', '$filter', 'moment', 'GUIUtils', '$rootScope'];

    function VaccinationController($compile, $scope, Vaccination, entity, $q, DTColumnBuilder, DTOptionsBuilder,
                                   $filter, moment, GUIUtils, $rootScope) {
        var vm = this;

        vm.patient = entity;
        vm.vaccination = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                Vaccination.getAllByPatientId({id : vm.patient.id}, function (result) {
                    vm.vaccination = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patients, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('vaccine.name').withTitle('Vaccination Type'),
            DTColumnBuilder.newColumn('completionDate').withTitle('Completion Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Responded').renderWith(function (data, type, full) {
                return data.responded !== undefined ? GUIUtils.colorHtmlYesNo(data.responded) : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="vaccination.view({vid:' + data.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            if (vm.patient.status) {
                stButtons += '<a class="btn-sm btn-danger" ui-sref="vaccination.delete({vid:' + data.id + '})">' +
                    '   <i class="fa fa-trash"></i></a>';
            }

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('TubeDialogController', TubeDialogController);

    TubeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Tube', 'Compendium'];

    function TubeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Tube, Compendium) {
        var vm = this;

        vm.tube = entity;
        vm.clear = clear;
        vm.save = save;
        vm.compendiums = Compendium.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tube.id !== null) {
                Tube.update(vm.tube, onSaveSuccess, onSaveError);
            } else {
                Tube.save(vm.tube, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:tubeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('TubeDetailController', TubeDetailController);

    TubeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Tube', 'Compendium'];

    function TubeDetailController($scope, $rootScope, $stateParams, previousState, entity, Tube, Compendium) {
        var vm = this;

        vm.tube = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:tubeUpdate', function(event, result) {
            vm.tube = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('TubeDeleteController',TubeDeleteController);

    TubeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Tube'];

    function TubeDeleteController($uibModalInstance, entity, Tube) {
        var vm = this;

        vm.tube = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tube.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tube', {
            parent: 'entity',
            url: '/tube',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Tubes'
            },
            ncyBreadcrumb: {
                label: 'Tubes',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tube/tubes.html',
                    controller: 'TubeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('tube-detail.edit', {
            parent: 'tube-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tube/tube-dialog.html',
                    controller: 'TubeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Tube', function(Tube) {
                            return Tube.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tube.new', {
            parent: 'tube',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tube/tube-dialog.html',
                    controller: 'TubeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tube', null, { reload: 'tube' });
                }, function() {
                    $state.go('tube');
                });
            }]
        })
        .state('tube.edit', {
            parent: 'tube',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tube/tube-dialog.html',
                    controller: 'TubeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Tube', function(Tube) {
                            return Tube.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tube', null, { reload: 'tube' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tube.delete', {
            parent: 'tube',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tube/tube-delete-dialog.html',
                    controller: 'TubeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tube', function(Tube) {
                            return Tube.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tube', null, { reload: 'tube' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Tube', Tube);

    Tube.$inject = ['$resource'];

    function Tube ($resource) {
        var resourceUrl =  'api/tubes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('TubeSearch', TubeSearch);

    TubeSearch.$inject = ['$resource'];

    function TubeSearch($resource) {
        var resourceUrl =  'api/_search/tubes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('TubeController', TubeController);

    TubeController.$inject = ['$scope', '$state', 'Tube', 'TubeSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function TubeController ($scope, $state, Tube, TubeSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile ) {
        var vm = this;
        vm.title = 'Tubes';
        vm.entityClassHumanized = 'Tube';
        vm.entityStateName = 'tube';

        vm.tubes = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  Tube.query(function(result) {
                  vm.tubes = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.tubes, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
        .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $compile(nRow)($scope);
        });

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            Tube.query(function(result) {
                vm.tubes = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SymptomDialogController', SymptomDialogController);

    SymptomDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Symptom', 'Infection', 'Corporation'];

    function SymptomDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Symptom, Infection, Corporation) {
        var vm = this;

        vm.symptom = entity;
        vm.clear = clear;
        vm.save = save;
        // vm.infections = Infection.query();
        // vm.corporations = Corporation.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.symptom.id !== null) {
                Symptom.update(vm.symptom, onSaveSuccess, onSaveError);
            } else {
                Symptom.save(vm.symptom, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:symptomUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SymptomDetailController', SymptomDetailController);

    SymptomDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Symptom', 'Infection', 'Corporation'];

    function SymptomDetailController($scope, $rootScope, $stateParams, previousState, entity, Symptom, Infection, Corporation) {
        var vm = this;

        vm.symptom = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:symptomUpdate', function(event, result) {
            vm.symptom = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SymptomDeleteController',SymptomDeleteController);

    SymptomDeleteController.$inject = ['$uibModalInstance', 'entity', 'Symptom'];

    function SymptomDeleteController($uibModalInstance, entity, Symptom) {
        var vm = this;

        vm.symptom = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Symptom.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('symptom', {
            parent: 'entity',
            url: '/symptom',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Symptoms'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/symptom/symptoms.html',
                    controller: 'SymptomController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('symptom-detail', {
            parent: 'entity',
            url: '/symptom/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Symptom'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/symptom/symptom-detail.html',
                    controller: 'SymptomDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Symptom', function($stateParams, Symptom) {
                    return Symptom.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'symptom',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('symptom-detail.edit', {
            parent: 'symptom-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/symptom/symptom-dialog.html',
                    controller: 'SymptomDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Symptom', function(Symptom) {
                            return Symptom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('symptom.new', {
            parent: 'symptom',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/symptom/symptom-dialog.html',
                    controller: 'SymptomDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('symptom', null, { reload: 'symptom' });
                }, function() {
                    $state.go('symptom');
                });
            }]
        })
        .state('symptom.edit', {
            parent: 'symptom',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/symptom/symptom-dialog.html',
                    controller: 'SymptomDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Symptom', function(Symptom) {
                            return Symptom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('symptom', null, { reload: 'symptom' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('symptom.delete', {
            parent: 'symptom',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/symptom/symptom-delete-dialog.html',
                    controller: 'SymptomDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Symptom', function(Symptom) {
                            return Symptom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('symptom', null, { reload: 'symptom' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Symptom', Symptom);

    Symptom.$inject = ['$resource'];

    function Symptom ($resource) {
        var resourceUrl =  'api/symptoms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('SymptomSearch', SymptomSearch);

    SymptomSearch.$inject = ['$resource'];

    function SymptomSearch($resource) {
        var resourceUrl =  'api/_search/symptoms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SymptomController', SymptomController);

    SymptomController.$inject = ['$scope', '$state', 'Symptom', 'SymptomSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function SymptomController ($scope, $state, Symptom, SymptomSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;

        vm.symptoms = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  Symptom.query(function(result) {
                  vm.symptoms = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.symptoms, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            Symptom.query(function(result) {
                vm.symptoms = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SourceDialogController', SourceDialogController);

    SourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Source', 'Infection', 'Corporation'];

    function SourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Source, Infection, Corporation) {
        var vm = this;

        vm.source = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.source.id !== null) {
                Source.update(vm.source, onSaveSuccess, onSaveError);
            } else {
                Source.save(vm.source, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:sourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SourceDetailController', SourceDetailController);

    SourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Source', 'Infection', 'Corporation'];

    function SourceDetailController($scope, $rootScope, $stateParams, previousState, entity, Source, Infection, Corporation) {
        var vm = this;

        vm.source = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:sourceUpdate', function(event, result) {
            vm.source = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SourceDeleteController',SourceDeleteController);

    SourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Source'];

    function SourceDeleteController($uibModalInstance, entity, Source) {
        var vm = this;

        vm.source = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Source.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('source', {
            parent: 'entity',
            url: '/source',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Sources'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/source/sources.html',
                    controller: 'SourceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('source-detail', {
            parent: 'entity',
            url: '/source/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Source'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/source/source-detail.html',
                    controller: 'SourceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Source', function($stateParams, Source) {
                    return Source.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'source',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('source-detail.edit', {
            parent: 'source-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/source/source-dialog.html',
                    controller: 'SourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Source', function(Source) {
                            return Source.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('source.new', {
            parent: 'source',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/source/source-dialog.html',
                    controller: 'SourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('source', null, { reload: 'source' });
                }, function() {
                    $state.go('source');
                });
            }]
        })
        .state('source.edit', {
            parent: 'source',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/source/source-dialog.html',
                    controller: 'SourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Source', function(Source) {
                            return Source.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('source', null, { reload: 'source' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('source.delete', {
            parent: 'source',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/source/source-delete-dialog.html',
                    controller: 'SourceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Source', function(Source) {
                            return Source.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('source', null, { reload: 'source' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Source', Source);

    Source.$inject = ['$resource'];

    function Source ($resource) {
        var resourceUrl =  'api/sources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('SourceSearch', SourceSearch);

    SourceSearch.$inject = ['$resource'];

    function SourceSearch($resource) {
        var resourceUrl =  'api/_search/sources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SourceController', SourceController);

    SourceController.$inject = ['$scope', '$state', 'Source', 'SourceSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function SourceController ($scope, $state, Source, SourceSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;

        vm.sources = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  Source.query(function(result) {
                  vm.sources = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.sources, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            Source.query(function(result) {
                vm.sources = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SiteLocationDialogController', SiteLocationDialogController);

    SiteLocationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SiteLocation'];

    function SiteLocationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SiteLocation) {
        var vm = this;

        vm.siteLocation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.siteLocation.id !== null) {
                SiteLocation.update(vm.siteLocation, onSaveSuccess, onSaveError);
            } else {
                SiteLocation.save(vm.siteLocation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:siteLocationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SiteLocationDetailController', SiteLocationDetailController);

    SiteLocationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SiteLocation', 'Machine', 'Clinic'];

    function SiteLocationDetailController($scope, $rootScope, $stateParams, previousState, entity, SiteLocation, Machine, Clinic) {
        var vm = this;

        vm.siteLocation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:siteLocationUpdate', function(event, result) {
            vm.siteLocation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SiteLocationDeleteController',SiteLocationDeleteController);

    SiteLocationDeleteController.$inject = ['$uibModalInstance', 'entity', 'SiteLocation'];

    function SiteLocationDeleteController($uibModalInstance, entity, SiteLocation) {
        var vm = this;

        vm.siteLocation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SiteLocation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('site-location', {
            parent: 'entity',
            url: '/site-location',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'SiteLocations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-location/site-locations.html',
                    controller: 'SiteLocationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                clinic: ['CoreService', function (CoreService) {
                    return CoreService.getCurrentClinic();
                }]
            }
        })
        .state('site-location-detail', {
            parent: 'entity',
            url: '/site-location/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'SiteLocation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/site-location/site-location-detail.html',
                    controller: 'SiteLocationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SiteLocation', function($stateParams, SiteLocation) {
                    return SiteLocation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'site-location',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('site-location-detail.edit', {
            parent: 'site-location-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-location/site-location-dialog.html',
                    controller: 'SiteLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SiteLocation', function(SiteLocation) {
                            return SiteLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('site-location.new', {
            parent: 'site-location',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-location/site-location-dialog.html',
                    controller: 'SiteLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                name: null,
                                id: null,
                                clinic: CoreService.getCurrentClinic()
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-location', null, { reload: 'site-location' });
                }, function() {
                    $state.go('site-location');
                });
            }]
        })
        .state('site-location.edit', {
            parent: 'site-location',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-location/site-location-dialog.html',
                    controller: 'SiteLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SiteLocation', function(SiteLocation) {
                            return SiteLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-location', null, { reload: 'site-location' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('site-location.delete', {
            parent: 'site-location',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/site-location/site-location-delete-dialog.html',
                    controller: 'SiteLocationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SiteLocation', function(SiteLocation) {
                            return SiteLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('site-location', null, { reload: 'site-location' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('SiteLocation', SiteLocation);

    SiteLocation.$inject = ['$resource'];

    function SiteLocation ($resource) {
        var resourceUrl =  'api/site-locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByClinic': {url: 'api/site-locations/by-clinic/:id' ,method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('SiteLocationSearch', SiteLocationSearch);

    SiteLocationSearch.$inject = ['$resource'];

    function SiteLocationSearch($resource) {
        var resourceUrl =  'api/_search/site-locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SiteLocationController', SiteLocationController);

    SiteLocationController.$inject = ['$scope', '$state', 'SiteLocation', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', 'clinic'];

    function SiteLocationController ($scope, $state, SiteLocation,  $q, DTColumnBuilder , DTOptionsBuilder, GUIUtils, $filter, clinic) {
        var vm = this;

        vm.siteLocations = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};
        vm.clinic = clinic;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                SiteLocation.getAllByClinic({id: vm.clinic.id}, function (result) {
                    vm.siteLocations = result;
                    defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.siteLocations, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function loadAll() {
            SiteLocation.query(function(result) {
                vm.siteLocations = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search () {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SampleDialogController', SampleDialogController);

    SampleDialogController.$inject = ['$uibModalInstance'];

    function SampleDialogController($uibModalInstance) {
        var vm = this;

        vm.title = "Sample Title Detail";

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sample', {
            parent: 'entity',
            url: '/sample',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Sample'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sample/sample.html',
                    controller: 'SampleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
    }

})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SampleController', SampleController);

    SampleController.$inject = ['$scope', '$state', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', '$filter', '$compile', 'GUIUtils', '$uibModal'];

    function SampleController($scope, $state, $q, DTColumnBuilder,
                              DTOptionsBuilder, $filter, $compile, GUIUtils, $uibModal) {
        var vm = this;

        vm.title = "Sample Title";
        vm.dummy = [];
        vm.dtInstance = {};
        vm.selected = {};
        vm.searchQuery = "";
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        vm.search = search;
        vm.getSelectedIds = getSelectedIds;
        vm.modal = modal;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                vm.dummy = dummy();
                defer.resolve(vm.dummy);
            } else {
                defer.resolve($filter('filter')(vm.dummy, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[0, 'desc'], [1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Date').renderWith(function (data, type, full) {
                return data.date ? moment(data.date).format($scope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Link to State').renderWith(function (data, type, full) {
                return data.link ? toStateLink(data) : '';
            }),
            DTColumnBuilder.newColumn('').withTitle('Colors').withOption('class', 'col').withOption('width', '175px').notSortable()
                .renderWith(yesNoHtml),
            DTColumnBuilder.newColumn('').withTitle('Actions').withOption('class', 'col').withOption('width', '175px').notSortable()
                .renderWith(actionsHtml)
        ];

        function yesNoHtml(data, type, full, meta) {
            if (full.status == true) {
                return GUIUtils.getStatusTemplate('TRUE', 'danger');
            } else if (full.status == false){
                return GUIUtils.getStatusTemplate('FALSE', 'success');
            } else {
                return GUIUtils.getStatusTemplate('UNDEFINED', 'warning');
            }
        }

        function actionsHtml(data, type, full, meta) {
            return '<a class="dt-btn warning" ng-click="vm.modal(' + full.id + ')" uib-tooltip="View Details"><i class="fa fa-file-text" aria-hidden="true"></i></a>';
        }

        function toStateLink(row) {
            // return '<a ui-sref="' + "dashboard({barcode:'" + row.barcode + "'})" + '">' + row.barcode + '</a>';
            return '<a ui-sref="home">go to dashboard</a>';
        }

        function dummy() {
            return [
                {id: 1, name: 'Animal.com', status: true, date: new Date(), link: 'dashboard'},
                {id: 2, name: 'LaSombra.com', status: false, date: new Date(), link: null},
                {id: 3, name: 'PepeElGlobero.com', status: null, date: null, link: 'dashboard'},
                {id: 4, name: 'LordOfTheRing.com', status: true, date: new Date(), link: 'dashboard'}
            ]
        }

        function modal() {
            $uibModal.open({
                templateUrl: 'app/entities/sample/sample-dialog.html',
                controller: 'SampleDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {

                }
            }).result.then(function () {
                //apply
            }, function (result) {
                //cancel
            });
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }
            vm.selectAll = true;
        }

        function getSelectedIds() {
            var ids = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    ids.push(id);
                }
            }

            return ids;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptTemplateEnvDialogController', RptTemplateEnvDialogController);

    RptTemplateEnvDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'RptTemplate', '$q',
        'RptCategorySearch', 'CoreService', 'ROLES', 'Compendium', 'lodash', 'RptLanguage',
        'DTColumnBuilder', 'DTOptionsBuilder', '$compile', 'Machine', 'moment', '$filter',
        '$rootScope', 'DataTablesService'];

    function RptTemplateEnvDialogController($timeout, $scope, $uibModalInstance, entity, RptTemplate, $q,
                                         RptCategorySearch, CoreService, ROLES, Compendium, _, RptLanguage,
                                         DTColumnBuilder, DTOptionsBuilder, $compile, Machine, moment, $filter,
                                         $rootScope, DataTablesService) {
        var vm = this;

        vm.rptTemplate = entity;
        vm.clinic = CoreService.getCurrentClinic();
        vm.compendiums = Compendium.query();

        vm.rptCompendiumRange = {compendiums: [], below: null, above: null};
        vm.form = {};

        vm.patients = [];
        vm.searchQuery = "";
        vm.dtInstance = {};
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.selected = {};

        vm.clear = clear;
        vm.save = save;
        vm.getFilter = getFilter;
        vm.addRange = addRange;
        vm.deleteRange = deleteRange;
        vm.cloneRange = cloneRange;
        vm.report = report;
        vm.openCalendar = openCalendar;
        vm.search = search;

        vm.dtOptions = DTOptionsBuilder
            .fromFnPromise(function () {
                var defer = $q.defer();

                if (!vm.searchQuery || vm.searchQuery == '') {
                    Machine.getAllByClinic({id: vm.clinic.id}, function (result) {
                        vm.machines = result;
                        defer.resolve(result);
                    });
                } else {
                    defer.resolve($filter('filter')(vm.patients, vm.searchQuery, undefined));
                }

                return defer.promise;
            })
            .withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                }
            );

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Name').withOption('width', '180px').renderWith(function (data, type, full) {
                return data.name;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Type').renderWith(function (data, type, full) {
                return data.mType;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Location').renderWith(function (data, type, full) {
                return data.siteLocation ? data.siteLocation.name : '-';
            })
        ];

        function search() {
            vm.dtInstance.reloadData();
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.rptTemplate.id !== null) {
                RptTemplate.update(vm.rptTemplate, onSaveSuccess, onSaveError);
            } else {
                RptTemplate.save(vm.rptTemplate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('dialysisApp:rptTemplateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getFilter() {
            var must = [];
            must.push({term: {"delStatus": false}});

            if (CoreService.currentHasEmployeeRole(ROLES.ROLE_ADMIN)) {
                must.push({
                    bool: {
                        "should": [
                            {not: {exists: {"field": "clinic"}}},
                            {term: {"clinic.id": vm.clinic.id}}
                        ]
                    }
                });

            } else {
                must.push({term: {"clinic.id": vm.clinic.id}});
            }

            return must;
        }

        function addRange() {
            _.forEach(vm.rptCompendiumRange.compendiums, function (compendium) {
                vm.rptTemplate.rptCompendiumRanges.push({
                    compendium: compendium,
                    belowEq: vm.rptCompendiumRange.belowEq,
                    aboveEq: vm.rptCompendiumRange.aboveEq,
                    index: vm.rptTemplate.rptCompendiumRanges.length
                });
            });

            vm.rptCompendiumRange.compendiums = [];
        }

        function deleteRange(index) {
            vm.rptTemplate.rptCompendiumRanges.splice(index, 1);

            reindex();
        }

        function cloneRange(index) {
            vm.rptTemplate.rptCompendiumRanges.splice(index, 0, angular.copy(vm.rptTemplate.rptCompendiumRanges[index]));

            reindex();
        }

        function reindex() {
            _.forEach(vm.rptTemplate.rptCompendiumRanges, function (range, index) {
                range.index = index;
            })
        }

        function report() {
            var ids = DataTablesService.getSelectedIds(vm.selected).map(Number);
            vm.rptTemplate.machines = ids;

            RptTemplate.getReportPdf(vm.rptTemplate);
        }

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptTemplateDialogController', RptTemplateDialogController);

    RptTemplateDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'RptTemplate', '$q',
        'RptCategorySearch', 'CoreService', 'ROLES', 'Compendium', 'lodash', 'RptLanguage',
        'DTColumnBuilder', 'DTOptionsBuilder', '$compile', 'Patient', 'moment', '$filter',
        '$rootScope', 'DataTablesService', 'GUIUtils', 'VaccineSearch', 'Employee'];

    function RptTemplateDialogController($timeout, $scope, $uibModalInstance, entity, RptTemplate, $q,
                                         RptCategorySearch, CoreService, ROLES, Compendium, _, RptLanguage,
                                         DTColumnBuilder, DTOptionsBuilder, $compile, Patient, moment, $filter,
                                         $rootScope, DataTablesService, GUIUtils, VaccineSearch, Employee) {
        var vm = this;

        vm.rptTemplate = entity;
        vm.clinic = CoreService.getCurrentClinic();
        vm.rptCategories = RptCategorySearch.query({
            query: {
                bool: {
                    must: getFilter()
                }
            }
        });
        vm.compendiums = Compendium.query();

        if (vm.rptTemplate.type == 'REPORT_CARD') {
            vm.rptLanguages = RptLanguage.query();
        }

        if (vm.rptTemplate.type == 'VACCINATION') {
            vm.vaccines = VaccineSearch.query({
                query: {
                    bool: {
                        must: [{term: {"delStatus": false}}]
                    }
                }
            });
        }

        vm.rptCompendiumRange = {compendiums: [], below: null, above: null};
        vm.form = {};

        vm.patients = [];
        vm.searchQuery = "";
        vm.dtInstance = {};
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.selected = {};
        vm.modalities = ['HEMO_DIALYSIS', 'PERITONEAL_DIALYSIS'];
        vm.physicians = Employee.employeeCorpPhysicians();

        vm.clear = clear;
        vm.save = save;
        vm.getFilter = getFilter;
        vm.addRange = addRange;
        vm.deleteRange = deleteRange;
        vm.cloneRange = cloneRange;
        vm.report = report;
        vm.openCalendar = openCalendar;
        vm.search = search;

        vm.dtOptions = DTOptionsBuilder
            .fromFnPromise(function () {
                var defer = $q.defer();
                if (!vm.searchQuery || vm.searchQuery == '') {
                    Patient.allRoster({id: vm.clinic.id}, function (result) {
                        vm.patients = result;
                        defer.resolve(result);
                    });
                } else {
                    defer.resolve($filter('filter')(vm.patients, vm.searchQuery, undefined));
                }
                return defer.promise;
            })
            .withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                }
            );

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Name').withOption('width', '180px').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + (data.middleInitial ? data.middleInitial : "");
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format($rootScope.displayDateformat);
            }),
            DTColumnBuilder.newColumn('gender').withTitle('Gender'),
            DTColumnBuilder.newColumn(null).withTitle('Diabetic').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.diabetic);
            })
        ];

        function search() {
            vm.dtInstance.reloadData();
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.rptTemplate.id !== null) {
                RptTemplate.update(vm.rptTemplate, onSaveSuccess, onSaveError);
            } else {
                RptTemplate.save(vm.rptTemplate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('dialysisApp:rptTemplateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getFilter() {
            var must = [];
            must.push({term: {"delStatus": false}});

            if (CoreService.currentHasEmployeeRole(ROLES.ROLE_ADMIN)) {
                must.push({
                    bool: {
                        "should": [
                            {not: {exists: {"field": "clinic"}}},
                            {term: {"clinic.id": vm.clinic.id}}
                        ]
                    }
                });

            } else {
                must.push({term: {"clinic.id": vm.clinic.id}});
            }

            return must;
        }

        function addRange() {
            _.forEach(vm.rptCompendiumRange.compendiums, function (compendium) {
                vm.rptTemplate.rptCompendiumRanges.push({
                    compendium: compendium,
                    belowEq: vm.rptCompendiumRange.belowEq,
                    aboveEq: vm.rptCompendiumRange.aboveEq,
                    index: vm.rptTemplate.rptCompendiumRanges.length
                });
            });

            vm.rptCompendiumRange.compendiums = [];
        }

        function deleteRange(index) {
            vm.rptTemplate.rptCompendiumRanges.splice(index, 1);

            reindex();
        }

        function cloneRange(index) {
            vm.rptTemplate.rptCompendiumRanges.splice(index, 0, angular.copy(vm.rptTemplate.rptCompendiumRanges[index]));

            reindex();
        }

        function reindex() {
            _.forEach(vm.rptTemplate.rptCompendiumRanges, function (range, index) {
                range.index = index;
            })
        }

        function report() {
            var ids = DataTablesService.getSelectedIds(vm.selected).map(Number);
            vm.rptTemplate.patients = ids;

            RptTemplate.getReportPdf(vm.rptTemplate);
        }

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptTemplateExportController', RptTemplateExportController);

    RptTemplateExportController.$inject = ['$uibModalInstance', 'entity', 'RptTemplate', 'ClinicSearch'];

    function RptTemplateExportController($uibModalInstance, entity, RptTemplate, ClinicSearch) {
        var vm = this;

        vm.rptTemplate = entity;
        vm.selectClinics = null;
        vm.clinics = ClinicSearch.query({
            query: {
                bool: {
                    must: [{term: {delStatus: false}}]
                }
            }
        });

        vm.clear = clear;
        vm.confirmExport = confirmExport;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmExport(id) {
            RptTemplate.export({clinics: vm.selectClinics, id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptTemplateDeleteController',RptTemplateDeleteController);

    RptTemplateDeleteController.$inject = ['$uibModalInstance', 'entity', 'RptTemplate'];

    function RptTemplateDeleteController($uibModalInstance, entity, RptTemplate) {
        var vm = this;

        vm.rptTemplate = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RptTemplate.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptTemplateAdminDialogController', RptTemplateAdminDialogController);

    RptTemplateAdminDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'RptTemplate',
        'RptCategorySearch', 'CoreService', 'ROLES', 'Compendium', 'lodash', 'RptLanguage', 'VaccineSearch'];

    function RptTemplateAdminDialogController($timeout, $scope, $uibModalInstance, entity, RptTemplate,
                                              RptCategorySearch, CoreService, ROLES, Compendium, _, RptLanguage, VaccineSearch) {
        var vm = this;

        vm.rptTemplate = entity;
        vm.clinic = CoreService.getCurrentClinic();
        vm.rptCategories = RptCategorySearch.query({
            query: {
                bool: {
                    must: getFilter()
                }
            }
        });
        vm.compendiums = Compendium.query();
        vm.rptLanguages = RptLanguage.query();
        vm.rptCompendiumRange = {compendiums: [], below: null, above: null};
        vm.vaccines = VaccineSearch.query({
            query: {
                bool: {
                    must: [{term: {"delStatus": false}}]
                }
            }
        });
        vm.form = {};
        vm.modalities = ['HEMO_DIALYSIS', 'PERITONEAL_DIALYSIS'];

        vm.clear = clear;
        vm.save = save;
        vm.getFilter = getFilter;
        vm.addRange = addRange;
        vm.deleteRange = deleteRange;
        vm.cloneRange = cloneRange;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.rptTemplate.id !== null) {
                RptTemplate.update(vm.rptTemplate, onSaveSuccess, onSaveError);
            } else {
                RptTemplate.save(vm.rptTemplate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('dialysisApp:rptTemplateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getFilter() {
            var must = [];
            must.push({term: {"delStatus": false}});

            if (CoreService.currentHasEmployeeRole(ROLES.ROLE_ADMIN)) {
                must.push({
                    bool: {
                        should: [
                            {not: {exists: {"field": "clinic"}}},
                            {term: {"clinic.id": vm.clinic.id}}
                        ]
                    }
                });
            } else {
                must.push({term: {"clinic.id": vm.clinic.id}});
            }

            return must;
        }

        function addRange() {
            _.forEach(vm.rptCompendiumRange.compendiums, function (compendium) {
                vm.rptTemplate.rptCompendiumRanges.push({
                    compendium: compendium,
                    belowEq: angular.copy(vm.rptCompendiumRange.belowEq),
                    aboveEq: angular.copy(vm.rptCompendiumRange.aboveEq),
                    index: vm.rptTemplate.rptCompendiumRanges.length
                });
            });

            vm.rptCompendiumRange.compendiums = [];
        }

        function deleteRange(index) {
            vm.rptTemplate.rptCompendiumRanges.splice(index, 1);

            reindex();
        }

        function cloneRange(index) {
            vm.rptTemplate.rptCompendiumRanges.splice(index, 0, angular.copy(vm.rptTemplate.rptCompendiumRanges[index]));

            reindex();
        }

        function reindex() {
            _.forEach(vm.rptTemplate.rptCompendiumRanges, function (range, index) {
                range.index = index;
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptTemplateAdminController', RptTemplateAdminController);

    RptTemplateAdminController.$inject = ['$scope', '$state', 'RptTemplate', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'RptTemplateSearch', 'CoreService',
        'ROLES', '$uibModal', 'Principal'];

    function RptTemplateAdminController($scope, $state, RptTemplate, $q, DTColumnBuilder,
                                        DTOptionsBuilder, GUIUtils, $filter, $compile, RptTemplateSearch, CoreService,
                                        ROLES, $uibModal, Principal) {
        var vm = this;
        vm.rptTemplate = [];
        vm.entityClassHumanized = 'Report Template';
        vm.title = 'Report Templates';
        vm.entityStateName = 'rpt-template-admin';
        vm.dtInstance = {};
        vm.clinic = CoreService.getCurrentClinic();

        vm.exportRptTemplate = exportRptTemplate;
        vm.search = search;
        vm.del = del;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                RptTemplateSearch.query({
                    query: {
                        bool: {
                            must: getFilter()
                        }
                    }
                }, function (result) {
                    vm.rptTemplate = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.rptTemplate, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn('description').withTitle('Description'),
            DTColumnBuilder.newColumn(null).withTitle('Type').renderWith(function (data) {
                return data.type ? data.type.replace("_", " ") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Category').renderWith(function (data) {
                return data.rptCategory ? data.rptCategory.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Clinic').renderWith(function (data) {
                return data.rptCategory && data.rptCategory.clinic ? data.rptCategory.clinic.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var html = "";

            if (Principal.hasRole(ROLES.ROLE_ADMIN)) {
                html += '<a class="btn-sm btn-success" ng-click="vm.exportRptTemplate(' + full.id + ')" uib-tooltip="Export">' +
                    '<span class="glyphicon glyphicon-export"></span></a>&nbsp;'
            }

            html += GUIUtils.getActionsTemplate(data, vm.entityStateName, ['update']) + '&nbsp;' +
                '<a class="btn-sm btn-danger" ng-click="vm.del(' + data.id + ')" uib-tooltip="Delete">' +
                '<span class="glyphicon glyphicon-trash"></span></a>';

            return  html;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function getFilter() {
            var must = [];
            must.push({term: {"delStatus": false}});

            if (CoreService.currentHasEmployeeRole(ROLES.ROLE_ADMIN)) {
                must.push({
                    bool: {
                        "should": [
                            {not: {exists: {"field": "rptCategory.clinic"}}},
                            {term: {"rptCategory.clinic.id": vm.clinic.id}}
                        ]
                    }
                });

            } else {
                must.push({term: {"rptCategory.clinic.id": vm.clinic.id}});
            }

            return must;
        }

        function exportRptTemplate(id) {
            $uibModal.open({
                templateUrl: 'app/entities/rpt-template/rpt-template-export-dialog.html',
                controller: 'RptTemplateExportController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['RptTemplate', function (RptTemplate) {
                        return RptTemplate.get({id: id}).$promise;
                    }]
                },
                language: false
            });
        }

        function del(id) {
            $uibModal.open({
                templateUrl: 'app/entities/rpt-template/rpt-template-delete-dialog.html',
                controller: 'RptTemplateDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['RptTemplate', function (RptTemplate) {
                        return RptTemplate.get({id: id}).$promise;
                    }]
                },
                language: false
            }).result.then(function() {
               search();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rpt-template-admin', {
            parent: 'entity',
            url: '/rpt-template-admin',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Rpt Templates Admin'
            },
            ncyBreadcrumb: {
                label: 'Report Templates Admin',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-template/rpt-template-admin.html',
                    controller: 'RptTemplateAdminController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rpt-template', {
            parent: 'entity',
            url: '/rpt-template',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Report 2.0'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-template/rpt-templates.html',
                    controller: 'RptTemplateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rpt-template-admin.new', {
            parent: 'rpt-template-admin',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-template/rpt-template-admin-dialog.html',
                    controller: 'RptTemplateAdminDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                type: null,
                                orientation: null,
                                active: true,
                                patientStatus: null,
                                modality: null,
                                shift: null,
                                diabetic: null,
                                allResult: false,
                                id: null,
                                rptCompendiumRanges: [],
                                vaccinated: true,
                                vaccines: [],
                                compendiums: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rpt-template-admin', null, { reload: 'rpt-template-admin' });
                }, function() {
                    $state.go('rpt-template-admin');
                });
            }]
        })
        .state('rpt-template-admin.edit', {
            parent: 'rpt-template-admin',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-template/rpt-template-admin-dialog.html',
                    controller: 'RptTemplateAdminDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptTemplate', function(RptTemplate) {
                            return RptTemplate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-template-admin', null, { reload: 'rpt-template-admin' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-template-admin.delete', {
            parent: 'rpt-template-admin',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-template/rpt-template-delete-dialog.html',
                    controller: 'RptTemplateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RptTemplate', function(RptTemplate) {
                            return RptTemplate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-template-admin', null, { reload: 'rpt-template-admin' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('RptTemplate', RptTemplate);

    RptTemplate.$inject = ['$resource', 'DataUtils', 'DateUtils'];

    function RptTemplate ($resource, DataUtils, DateUtils) {
        var resourceUrl =  'api/rpt-templates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getReportPdf': {
                url: 'api/rpt-templates/generate-report',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                },
                transformRequest: function (data) {
                    var copy = angular.copy(data);

                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);

                    return angular.toJson(copy);
                }
            },
            'export': {method: 'POST', url: 'api/rpt-templates/export'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RptTemplateSearch', RptTemplateSearch);

    RptTemplateSearch.$inject = ['$resource'];

    function RptTemplateSearch($resource) {
        var resourceUrl =  'api/_search/rpt-templates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptTemplateController', RptTemplateController);

    RptTemplateController.$inject = ['$scope', '$state', 'RptTemplate', 'RptTemplateSearch', '$q',
        'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', 'CoreService', '$filter', '$compile', '$uibModal'];

    function RptTemplateController($scope, $state, RptTemplate, RptTemplateSearch, $q,
                                   DTColumnBuilder, DTOptionsBuilder, GUIUtils, CoreService, $filter, $compile, $uibModal) {
        var vm = this;

        vm.rptTemplate = [];
        vm.search = search;
        vm.report = report;

        vm.clinic = CoreService.getCurrentClinic();

        vm.title = 'Report 2.0';

        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                RptTemplateSearch.query({
                    query: {
                        bool: {
                            must: [
                                {term: {"rptCategory.clinic.id": vm.clinic.id}},
                                {term: {"active": true}},
                                {term: {"delStatus": false}}
                            ]
                        }
                    }
                }, function (result) {
                    vm.rptTemplate = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.rptTemplate, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn('description').withTitle('Description'),
            DTColumnBuilder.newColumn(null).withTitle('Type').renderWith(function (data) {
                return data.type ? data.type.replace("_", " ") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Category').renderWith(function (data) {
                return data.rptCategory ? data.rptCategory.name : "";
            }),
            DTColumnBuilder.newColumn('').withTitle('Actions').withOption('class', 'col').withOption('width', '175px').notSortable()
                .renderWith(actionsHtml)
        ];

        function search() {
            vm.dtInstance.reloadData();
        }

        function actionsHtml(data, type, full, meta) {
            return '<a class="dt-btn warning" ng-click="vm.report(' + full.id + ", '" + full.type + "'" + ')" uib-tooltip="Report"><i class="fa fa-file-text" aria-hidden="true"></i></a>';
        }

        function report(id, type) {
            var viewHtml = "";
            var controller = 'RptTemplateDialogController';

            switch (type) {
                case 'GRID' : {
                    viewHtml = 'app/entities/rpt-template/wizard/report/rpt-template-grid-report-dialog.html';
                    break;
                }
                case 'CUMULATIVE' : {
                    viewHtml = 'app/entities/rpt-template/wizard/report/rpt-template-cumulative-report-dialog.html';
                    break;
                }
                case 'REPORT_CARD' : {
                    viewHtml = 'app/entities/rpt-template/wizard/report/rpt-template-report-card-report-dialog.html';
                    break;
                }
                case 'AVERAGE' : {
                    viewHtml = 'app/entities/rpt-template/wizard/report/rpt-template-average-report-dialog.html';
                    break;
                }
                case 'GRAPH' : {
                    viewHtml = 'app/entities/rpt-template/wizard/report/rpt-template-graph-report-dialog.html';
                    break;
                }
                // case 'ADVANCED' : {
                //     viewHtml = 'app/entities/rpt-template/wizard/report/rpt-template-advanced-report-dialog.html';
                // }
                case 'VACCINATION' : {
                    viewHtml = 'app/entities/rpt-template/wizard/report/rpt-template-vaccination-report-dialog.html';
                    break;
                }
                case 'ENV_GRID' : {
                    viewHtml = 'app/entities/rpt-template/wizard/report/rpt-template-env-grid-report-dialog.html';
                    controller = 'RptTemplateEnvDialogController';

                    break;
                }
                case 'ENV_REFERENCE_RANGE' : {
                    viewHtml = 'app/entities/rpt-template/wizard/report/rpt-template-env-reference-range-report-dialog.html';
                    controller = 'RptTemplateEnvDialogController';

                    break;
                }
                case 'ENV_AVERAGE' : {
                    viewHtml = 'app/entities/rpt-template/wizard/report/rpt-template-env-average-report-dialog.html';
                    controller = 'RptTemplateEnvDialogController';

                    break;
                }

                default: return;
            }

            $uibModal.open({
                templateUrl: viewHtml,
                controller: controller,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['RptTemplate', function (RptTemplate) {
                        return RptTemplate.get({id: id}).$promise;
                    }]
                },
                language: false
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptMetadataDialogController', RptMetadataDialogController);

    RptMetadataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RptMetadata'];

    function RptMetadataDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RptMetadata) {
        var vm = this;

        vm.rptMetadata = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rptMetadata.id !== null) {
                RptMetadata.update(vm.rptMetadata, onSaveSuccess, onSaveError);
            } else {
                RptMetadata.save(vm.rptMetadata, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:rptMetadataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptMetadataDetailController', RptMetadataDetailController);

    RptMetadataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RptMetadata'];

    function RptMetadataDetailController($scope, $rootScope, $stateParams, previousState, entity, RptMetadata) {
        var vm = this;

        vm.rptMetadata = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:rptMetadataUpdate', function(event, result) {
            vm.rptMetadata = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptMetadataDeleteController',RptMetadataDeleteController);

    RptMetadataDeleteController.$inject = ['$uibModalInstance', 'entity', 'RptMetadata'];

    function RptMetadataDeleteController($uibModalInstance, entity, RptMetadata) {
        var vm = this;

        vm.rptMetadata = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RptMetadata.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rpt-metadata', {
            parent: 'entity',
            url: '/rpt-metadata',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'RptMetadata'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-metadata/rpt-metadata.html',
                    controller: 'RptMetadataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rpt-metadata-detail', {
            parent: 'entity',
            url: '/rpt-metadata/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'RptMetadata'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-metadata/rpt-metadata-detail.html',
                    controller: 'RptMetadataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RptMetadata', function($stateParams, RptMetadata) {
                    return RptMetadata.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rpt-metadata',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rpt-metadata-detail.edit', {
            parent: 'rpt-metadata-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-metadata/rpt-metadata-dialog.html',
                    controller: 'RptMetadataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptMetadata', function(RptMetadata) {
                            return RptMetadata.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-metadata.new', {
            parent: 'rpt-metadata',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-metadata/rpt-metadata-dialog.html',
                    controller: 'RptMetadataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                intCode: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rpt-metadata', null, { reload: 'rpt-metadata' });
                }, function() {
                    $state.go('rpt-metadata');
                });
            }]
        })
        .state('rpt-metadata.edit', {
            parent: 'rpt-metadata',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-metadata/rpt-metadata-dialog.html',
                    controller: 'RptMetadataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptMetadata', function(RptMetadata) {
                            return RptMetadata.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-metadata', null, { reload: 'rpt-metadata' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-metadata.delete', {
            parent: 'rpt-metadata',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-metadata/rpt-metadata-delete-dialog.html',
                    controller: 'RptMetadataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RptMetadata', function(RptMetadata) {
                            return RptMetadata.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-metadata', null, { reload: 'rpt-metadata' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('RptMetadata', RptMetadata);

    RptMetadata.$inject = ['$resource'];

    function RptMetadata($resource) {
        var resourceUrl = 'api/rpt-metadata/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'queryDiff': {url: 'api/rpt-metadata-diff', method: 'GET', isArray: true},
            'getByIntCode': {
                url: 'api/rpt-metadata-by-intcode/:intCode',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RptMetadataSearch', RptMetadataSearch);

    RptMetadataSearch.$inject = ['$resource'];

    function RptMetadataSearch($resource) {
        var resourceUrl =  'api/_search/rpt-metadata/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptMetadataController', RptMetadataController);

    RptMetadataController.$inject = ['$scope', '$state', 'RptMetadata', 'RptMetadataSearch', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function RptMetadataController($scope, $state, RptMetadata, RptMetadataSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile) {
        var vm = this;
        vm.title = 'Rpt Metadata';
        vm.entityClassHumanized = 'Rpt Metadata';
        vm.entityStateName = 'rpt-metadata';

        vm.rptMetadata = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                RptMetadata.query(function (result) {
                    vm.rptMetadata = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.rptMetadata, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('intCode').withTitle('IntCode'),
            DTColumnBuilder.newColumn('code').withTitle('Code'),
            DTColumnBuilder.newColumn('description').withTitle('Description'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function loadAll() {
            RptMetadata.query(function (result) {
                vm.rptMetadata = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptLanguageDialogController', RptLanguageDialogController);

    RptLanguageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RptLanguage'];

    function RptLanguageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RptLanguage) {
        var vm = this;

        vm.rptLanguage = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rptLanguage.id !== null) {
                RptLanguage.update(vm.rptLanguage, onSaveSuccess, onSaveError);
            } else {
                RptLanguage.save(vm.rptLanguage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:rptLanguageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptLanguageDetailController', RptLanguageDetailController);

    RptLanguageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RptLanguage'];

    function RptLanguageDetailController($scope, $rootScope, $stateParams, previousState, entity, RptLanguage) {
        var vm = this;

        vm.rptLanguage = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:rptLanguageUpdate', function(event, result) {
            vm.rptLanguage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptLanguageDeleteController',RptLanguageDeleteController);

    RptLanguageDeleteController.$inject = ['$uibModalInstance', 'entity', 'RptLanguage'];

    function RptLanguageDeleteController($uibModalInstance, entity, RptLanguage) {
        var vm = this;

        vm.rptLanguage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RptLanguage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rpt-language', {
            parent: 'entity',
            url: '/rpt-language',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'RptLanguages'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-language/rpt-languages.html',
                    controller: 'RptLanguageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rpt-language-detail', {
            parent: 'entity',
            url: '/rpt-language/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'RptLanguage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-language/rpt-language-detail.html',
                    controller: 'RptLanguageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RptLanguage', function($stateParams, RptLanguage) {
                    return RptLanguage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rpt-language',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rpt-language-detail.edit', {
            parent: 'rpt-language-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-language/rpt-language-dialog.html',
                    controller: 'RptLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptLanguage', function(RptLanguage) {
                            return RptLanguage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-language.new', {
            parent: 'rpt-language',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-language/rpt-language-dialog.html',
                    controller: 'RptLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rpt-language', null, { reload: 'rpt-language' });
                }, function() {
                    $state.go('rpt-language');
                });
            }]
        })
        .state('rpt-language.edit', {
            parent: 'rpt-language',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-language/rpt-language-dialog.html',
                    controller: 'RptLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptLanguage', function(RptLanguage) {
                            return RptLanguage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-language', null, { reload: 'rpt-language' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-language.delete', {
            parent: 'rpt-language',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-language/rpt-language-delete-dialog.html',
                    controller: 'RptLanguageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RptLanguage', function(RptLanguage) {
                            return RptLanguage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-language', null, { reload: 'rpt-language' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('RptLanguage', RptLanguage);

    RptLanguage.$inject = ['$resource'];

    function RptLanguage ($resource) {
        var resourceUrl =  'api/rpt-languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RptLanguageSearch', RptLanguageSearch);

    RptLanguageSearch.$inject = ['$resource'];

    function RptLanguageSearch($resource) {
        var resourceUrl =  'api/_search/rpt-languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptLanguageController', RptLanguageController);

    RptLanguageController.$inject = ['$scope', '$state', 'RptLanguage', 'RptLanguageSearch', 'DTOptionsBuilder',
    'DTColumnBuilder', '$q', '$compile', 'GUIUtils'];

    function RptLanguageController ($scope, $state, RptLanguage, RptLanguageSearch, DTOptionsBuilder,
                                    DTColumnBuilder, $q, $compile, GUIUtils) {
        var vm = this;

        vm.rptLanguages = [];
        vm.search = search;

        vm.dtInstance = {};
        vm.title = "Languages";
        vm.entityClassHumanized = "Languages";

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                RptLanguageSearch.query({
                    query: {
                        bool: {
                            must: [
                                {term: {"delStatus": false}}
                            ]
                        }
                    }
                }, function (result) {
                    vm.rptLanguages = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.rptLanguages, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Category').renderWith(function (data) {
                return data.name;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('class', 'col').withOption('width', '175px').notSortable()
                .renderWith(actionsHtml)
        ];

        function search() {
            vm.dtInstance.reloadData();
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCompendiumMessageDialogController', RptCompendiumMessageDialogController);

    RptCompendiumMessageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RptCompendiumMessage', 'RptLanguage', 'Compendium', 'Clinic'];

    function RptCompendiumMessageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RptCompendiumMessage, RptLanguage, Compendium, Clinic) {
        var vm = this;

        vm.rptCompendiumMessage = entity;
        vm.clear = clear;
        vm.save = save;
        vm.rptLanguages = RptLanguage.query();
        vm.compendiums = Compendium.query();
        vm.clinics = Clinic.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rptCompendiumMessage.id !== null) {
                RptCompendiumMessage.update(vm.rptCompendiumMessage, onSaveSuccess, onSaveError);
            } else {
                RptCompendiumMessage.save(vm.rptCompendiumMessage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:rptCompendiumMessageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCompendiumMessageDetailController', RptCompendiumMessageDetailController);

    RptCompendiumMessageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RptCompendiumMessage', 'RptLanguage', 'Compendium', 'Clinic'];

    function RptCompendiumMessageDetailController($scope, $rootScope, $stateParams, previousState, entity, RptCompendiumMessage, RptLanguage, Compendium, Clinic) {
        var vm = this;

        vm.rptCompendiumMessage = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:rptCompendiumMessageUpdate', function(event, result) {
            vm.rptCompendiumMessage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCompendiumMessageDeleteController',RptCompendiumMessageDeleteController);

    RptCompendiumMessageDeleteController.$inject = ['$uibModalInstance', 'entity', 'RptCompendiumMessage'];

    function RptCompendiumMessageDeleteController($uibModalInstance, entity, RptCompendiumMessage) {
        var vm = this;

        vm.rptCompendiumMessage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RptCompendiumMessage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rpt-compendium-message', {
                parent: 'entity',
                url: '/rpt-compendium-message',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN'],
                    pageTitle: 'RptCompendiumMessages'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rpt-compendium-message/rpt-compendium-messages.html',
                        controller: 'RptCompendiumMessageController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('rpt-compendium-message-detail', {
                parent: 'entity',
                url: '/rpt-compendium-message/{id}',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN'],
                    pageTitle: 'RptCompendiumMessage'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rpt-compendium-message/rpt-compendium-message-detail.html',
                        controller: 'RptCompendiumMessageDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'RptCompendiumMessage', function ($stateParams, RptCompendiumMessage) {
                        return RptCompendiumMessage.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'rpt-compendium-message',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('rpt-compendium-message-detail.edit', {
                parent: 'rpt-compendium-message-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/rpt-compendium-message/rpt-compendium-message-dialog.html',
                        controller: 'RptCompendiumMessageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['RptCompendiumMessage', function (RptCompendiumMessage) {
                                return RptCompendiumMessage.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('rpt-compendium-message.new', {
                parent: 'rpt-compendium-message',
                url: '/new',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/rpt-compendium-message/rpt-compendium-message-dialog.html',
                        controller: 'RptCompendiumMessageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CoreService', function (CoreService) {
                                return {
                                    lowMessage: null,
                                    normalMessage: null,
                                    highMessage: null,
                                    id: null,
                                    clinic: CoreService.getCurrentClinic()
                                };
                            }]
                        }
                    }).result.then(function () {
                        $state.go('rpt-compendium-message', null, {reload: 'rpt-compendium-message'});
                    }, function () {
                        $state.go('rpt-compendium-message');
                    });
                }]
            })
            .state('rpt-compendium-message.edit', {
                parent: 'rpt-compendium-message',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/rpt-compendium-message/rpt-compendium-message-dialog.html',
                        controller: 'RptCompendiumMessageDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['RptCompendiumMessage', function (RptCompendiumMessage) {
                                return RptCompendiumMessage.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('rpt-compendium-message', null, {reload: 'rpt-compendium-message'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('rpt-compendium-message.delete', {
                parent: 'rpt-compendium-message',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/rpt-compendium-message/rpt-compendium-message-delete-dialog.html',
                        controller: 'RptCompendiumMessageDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['RptCompendiumMessage', function (RptCompendiumMessage) {
                                return RptCompendiumMessage.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('rpt-compendium-message', null, {reload: 'rpt-compendium-message'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
    }

})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('RptCompendiumMessage', RptCompendiumMessage);

    RptCompendiumMessage.$inject = ['$resource'];

    function RptCompendiumMessage($resource) {
        var resourceUrl = 'api/rpt-compendium-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RptCompendiumMessageSearch', RptCompendiumMessageSearch);

    RptCompendiumMessageSearch.$inject = ['$resource'];

    function RptCompendiumMessageSearch($resource) {
        var resourceUrl =  'api/_search/rpt-compendium-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCompendiumMessageController', RptCompendiumMessageController);

    RptCompendiumMessageController.$inject = ['$scope', '$state', 'RptCompendiumMessage', 'RptCompendiumMessageSearch',
        'CoreService', 'DTOptionsBuilder', 'DTColumnBuilder', '$compile', '$q', 'GUIUtils', '$filter'];

    function RptCompendiumMessageController($scope, $state, RptCompendiumMessage, RptCompendiumMessageSearch,
                                            CoreService, DTOptionsBuilder, DTColumnBuilder, $compile, $q, GUIUtils, $filter) {
        var vm = this;

        vm.rptCompendiumMessages = [];
        vm.clinic = CoreService.getCurrentClinic();
        vm.dtInstance = {};
        vm.title = "Compendium Messages";
        vm.entityClassHumanized = "Compendium Messages";
        vm.filterRes = {};
        vm.selected = {};
        vm.selectAll = false;

        vm.search = search;
        vm.getFilter = getFilter;
        vm.clear = clear;
        vm.showFiltersPanel = showFiltersPanel;

        angular.element('.filter-box').hide();

        function showFiltersPanel() {
            angular.element('.filter-box').toggleClass('active');

            if (angular.element('.filter-box').hasClass('active')) {
                angular.element('.toggle-filters').addClass('open');
                angular.element('.filter-box').slideDown();
            } else {
                angular.element('.toggle-filters').removeClass('open');
                angular.element('.filter-box').slideUp();
            }
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (!vm.searchQuery || vm.searchQuery == '') {
                RptCompendiumMessageSearch.query(
                    {
                        query: {
                            bool: {
                                must: getFilter()
                            }
                        }
                    }, function (result) {
                        vm.rptCompendiumMessages = result;
                        defer.resolve(result);
                    });
            } else {
                defer.resolve($filter('filter')(vm.rptCompendiumMessages, vm.searchQuery, undefined));
            }

            vm.selected = {};
            vm.selectAll = false;

            return defer.promise;

        }).withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Language').renderWith(function (data) {
                return data.rptLanguage ? data.rptLanguage.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Compendium Code').renderWith(function (data) {
                return data.compendium ? data.compendium.code : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Compendium Description').renderWith(function (data) {
                return data.compendium ? data.compendium.description : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Low Message').renderWith(function (data) {
                return data.lowMessage && data.lowMessage.length > 30 ? data.lowMessage.substr(1, 30) + "..." : data.lowMessage;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Normal Message').renderWith(function (data) {
                return data.normalMessage && data.normalMessage.length > 30 ? data.normalMessage.substr(1, 30) + "..." : data.normalMessage;
            }),
            DTColumnBuilder.newColumn(null).withTitle('High Message').renderWith(function (data) {
                return data.highMessage && data.highMessage.length > 30 ? data.highMessage.substr(1, 30) + "..." : data.highMessage;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('class', 'col').withOption('width', '175px').notSortable()
                .renderWith(actionsHtml)
        ];

        function getFilter() {
            var must = [];

            must.push({
                bool: {
                    "should": [
                        {"term": {"clinic.id": vm.clinic.id}},
                    ]
                }
            });

            must.push({term: {"delStatus": false}});

            if (vm.filterRes.name != null && vm.filterRes.name.length > 0) {
                must.push({match: {"rptLanguage.name": {query: vm.filterRes.name + "%"}}});

            }

            if (vm.filterRes.description != null && vm.filterRes.description.length > 0) {
                must.push({wildcard: {"compendium.description": "*" + vm.filterRes.description + "*"}});
            }

            return must;
        }


        function search() {
            vm.dtInstance.reloadData();
        }

        function clear() {
            vm.filterRes ={};
            vm.dtInstance.reloadData();
        }

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCompendiumDefaultMessageDialogController', RptCompendiumDefaultMessageDialogController);

    RptCompendiumDefaultMessageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RptCompendiumDefaultMessage', 'RptLanguage', 'Compendium'];

    function RptCompendiumDefaultMessageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RptCompendiumDefaultMessage, RptLanguage, Compendium) {
        var vm = this;

        vm.rptCompendiumDefaultMessage = entity;
        vm.rptLanguages = RptLanguage.query();

        Compendium.byRptCompendiumDefaultMessageDif(function (result) {
            vm.compendiums = result;

            if (vm.rptCompendiumDefaultMessage.id) {
                vm.compendiums.push(vm.rptCompendiumDefaultMessage.compendium);
            }
        });

        vm.isSaving = false;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rptCompendiumDefaultMessage.id !== null) {
                RptCompendiumDefaultMessage.update(vm.rptCompendiumDefaultMessage, onSaveSuccess, onSaveError);
            } else {
                RptCompendiumDefaultMessage.save(vm.rptCompendiumDefaultMessage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:rptCompendiumDefaultMessageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCompendiumDefaultMessageDetailController', RptCompendiumDefaultMessageDetailController);

    RptCompendiumDefaultMessageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RptCompendiumDefaultMessage', 'RptLanguage', 'Compendium'];

    function RptCompendiumDefaultMessageDetailController($scope, $rootScope, $stateParams, previousState, entity, RptCompendiumDefaultMessage, RptLanguage, Compendium) {
        var vm = this;

        vm.rptCompendiumDefaultMessage = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:rptCompendiumDefaultMessageUpdate', function(event, result) {
            vm.rptCompendiumDefaultMessage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCompendiumDefaultMessageDeleteController',RptCompendiumDefaultMessageDeleteController);

    RptCompendiumDefaultMessageDeleteController.$inject = ['$uibModalInstance', 'entity', 'RptCompendiumDefaultMessage'];

    function RptCompendiumDefaultMessageDeleteController($uibModalInstance, entity, RptCompendiumDefaultMessage) {
        var vm = this;

        vm.rptCompendiumDefaultMessage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RptCompendiumDefaultMessage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rpt-compendium-default-message', {
            parent: 'entity',
            url: '/rpt-compendium-default-message',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'RptCompendiumDefaultMessages'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-compendium-default-message/rpt-compendium-default-messages.html',
                    controller: 'RptCompendiumDefaultMessageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rpt-compendium-default-message-detail', {
            parent: 'entity',
            url: '/rpt-compendium-default-message/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'RptCompendiumDefaultMessage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-compendium-default-message/rpt-compendium-default-message-detail.html',
                    controller: 'RptCompendiumDefaultMessageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RptCompendiumDefaultMessage', function($stateParams, RptCompendiumDefaultMessage) {
                    return RptCompendiumDefaultMessage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rpt-compendium-default-message',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rpt-compendium-default-message-detail.edit', {
            parent: 'rpt-compendium-default-message-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-compendium-default-message/rpt-compendium-default-message-dialog.html',
                    controller: 'RptCompendiumDefaultMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptCompendiumDefaultMessage', function(RptCompendiumDefaultMessage) {
                            return RptCompendiumDefaultMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-compendium-default-message.new', {
            parent: 'rpt-compendium-default-message',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-compendium-default-message/rpt-compendium-default-message-dialog.html',
                    controller: 'RptCompendiumDefaultMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                lowMessage: null,
                                highMessage: null,
                                normalMessage: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rpt-compendium-default-message', null, { reload: 'rpt-compendium-default-message' });
                }, function() {
                    $state.go('rpt-compendium-default-message');
                });
            }]
        })
        .state('rpt-compendium-default-message.edit', {
            parent: 'rpt-compendium-default-message',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-compendium-default-message/rpt-compendium-default-message-dialog.html',
                    controller: 'RptCompendiumDefaultMessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptCompendiumDefaultMessage', function(RptCompendiumDefaultMessage) {
                            return RptCompendiumDefaultMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-compendium-default-message', null, { reload: 'rpt-compendium-default-message' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-compendium-default-message.delete', {
            parent: 'rpt-compendium-default-message',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-compendium-default-message/rpt-compendium-default-message-delete-dialog.html',
                    controller: 'RptCompendiumDefaultMessageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RptCompendiumDefaultMessage', function(RptCompendiumDefaultMessage) {
                            return RptCompendiumDefaultMessage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-compendium-default-message', null, { reload: 'rpt-compendium-default-message' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('RptCompendiumDefaultMessage', RptCompendiumDefaultMessage);

    RptCompendiumDefaultMessage.$inject = ['$resource'];

    function RptCompendiumDefaultMessage ($resource) {
        var resourceUrl =  'api/rpt-compendium-default-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'init': {method: 'GET', url: 'api/rpt-compendium-default-messages/init-clinic/:id'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RptCompendiumDefaultMessageSearch', RptCompendiumDefaultMessageSearch);

    RptCompendiumDefaultMessageSearch.$inject = ['$resource'];

    function RptCompendiumDefaultMessageSearch($resource) {
        var resourceUrl =  'api/_search/rpt-compendium-default-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCompendiumDefaultMessageController', RptCompendiumDefaultMessageController);

    RptCompendiumDefaultMessageController.$inject = ['$scope', '$state', 'RptCompendiumDefaultMessage', '$q', 'GUIUtils',
        'RptCompendiumDefaultMessageSearch', 'DTOptionsBuilder', 'DTColumnBuilder',
        '$filter', '$compile', 'dialogs', 'CoreService', 'toastr'];

    function RptCompendiumDefaultMessageController($scope, $state, RptCompendiumDefaultMessage, $q, GUIUtils,
                                                   RptCompendiumDefaultMessageSearch, DTOptionsBuilder, DTColumnBuilder,
                                                   $filter, $compile, $dialogs, CoreService, toastr) {
        var vm = this;

        vm.rptCompendiumDefaultMessages = [];
        vm.dtInstance = {};
        vm.title = "Compendium Default Messages";
        vm.entityClassHumanized = "Compendium Default Message";
        vm.clinic = CoreService.getCurrentClinic();

        vm.filterRes = {};
        vm.selected = {};
        vm.selectAll = false;

        vm.search = search;
        vm.getFilter = getFilter;
        vm.clear = clear;
        vm.showFiltersPanel = showFiltersPanel;
        vm.init = init;

        angular.element('.filter-box').hide();

        function showFiltersPanel() {
            angular.element('.filter-box').toggleClass('active');

            if (angular.element('.filter-box').hasClass('active')) {
                angular.element('.toggle-filters').addClass('open');
                angular.element('.filter-box').slideDown();
            } else {
                angular.element('.toggle-filters').removeClass('open');
                angular.element('.filter-box').slideUp();
            }
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                RptCompendiumDefaultMessageSearch.query(
                    {
                        query: {
                            bool: {
                                must: getFilter()
                            }
                        }
                    }, function (result) {
                        vm.rptCompendiumDefaultMessages = result;
                        defer.resolve(result);
                    });
            } else {
                defer.resolve($filter('filter')(vm.rptCompendiumDefaultMessages, vm.searchQuery, undefined));
            }

            vm.selected = {};
            vm.selectAll = false;
            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Language').renderWith(function (data) {
                return data.rptLanguage ? data.rptLanguage.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Compendium Code').renderWith(function (data) {
                return data.compendium ? data.compendium.code : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Compendium Description').renderWith(function (data) {
                return data.compendium ? data.compendium.description : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Low Message').renderWith(function (data) {
                return data.lowMessage && data.lowMessage.length > 30 ? data.lowMessage.substr(1, 30) + "..." : data.lowMessage;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Normal Message').renderWith(function (data) {
                return data.normalMessage && data.normalMessage.length > 30 ? data.normalMessage.substr(1, 30) + "..." : data.normalMessage;
            }),
            DTColumnBuilder.newColumn(null).withTitle('High Message').renderWith(function (data) {
                return data.highMessage && data.highMessage.length > 30 ? data.highMessage.substr(1, 30) + "..." : data.highMessage;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('class', 'col').withOption('width', '175px').notSortable()
                .renderWith(actionsHtml)
        ];

        function getFilter() {
            var must = [];

            must.push({
                bool: {
                    "should": [
                        {term: {"delStatus": false}},
                    ]
                }
            });

            if (vm.filterRes.name != null && vm.filterRes.name.length > 0) {
                must.push({match: {"rptLanguage.name": {query: vm.filterRes.name + "%"}}});
            }

            if (vm.filterRes.description != null && vm.filterRes.description.length > 0) {
                must.push({wildcard: {"compendium.description": "*" + vm.filterRes.description + "*"}});
            }

            return must;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function clear() {
            vm.filterRes = {};
            vm.dtInstance.reloadData();
        }

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function init() {
            var dlg = $dialogs.confirm('Please Confirm', 'Reset all Messages for the current clinic? All current messages will be removed', {size: 'md'});
            dlg.result.then(function (btn) {
                RptCompendiumDefaultMessage.init({id: vm.clinic.id}, function () {
                    vm.dtInstance.reloadData();

                    toastr.success('Operation successfully');
                });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCategoryDialogController', RptCategoryDialogController);

    RptCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'RptCategory', 'CoreService', 'ROLES'];

    function RptCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                          RptCategory, CoreService, ROLES) {
        var vm = this;

        vm.rptCategory = entity;
        vm.clear = clear;
        vm.save = save;

        vm.clinics = CoreService.currentHasEmployeeRole(ROLES.ROLE_ADMIN) ? [CoreService.getCurrentClinic()] : [];

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rptCategory.id !== null) {
                RptCategory.update(vm.rptCategory, onSaveSuccess, onSaveError);
            } else {
                RptCategory.save(vm.rptCategory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:rptCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCategoryDetailController', RptCategoryDetailController);

    RptCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RptCategory', 'Clinic'];

    function RptCategoryDetailController($scope, $rootScope, $stateParams, previousState, entity, RptCategory, Clinic) {
        var vm = this;

        vm.rptCategory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:rptCategoryUpdate', function(event, result) {
            vm.rptCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCategoryDeleteController',RptCategoryDeleteController);

    RptCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'RptCategory'];

    function RptCategoryDeleteController($uibModalInstance, entity, RptCategory) {
        var vm = this;

        vm.rptCategory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RptCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rpt-category', {
            parent: 'entity',
            url: '/rpt-category',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
                pageTitle: 'RptCategories'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-category/rpt-categories.html',
                    controller: 'RptCategoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rpt-category-detail', {
            parent: 'entity',
            url: '/rpt-category/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
                pageTitle: 'RptCategory'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-category/rpt-category-detail.html',
                    controller: 'RptCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RptCategory', function($stateParams, RptCategory) {
                    return RptCategory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rpt-category',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rpt-category-detail.edit', {
            parent: 'rpt-category-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-category/rpt-category-dialog.html',
                    controller: 'RptCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptCategory', function(RptCategory) {
                            return RptCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-category.new', {
            parent: 'rpt-category',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-category/rpt-category-dialog.html',
                    controller: 'RptCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CoreService', 'ROLES', function (CoreService, ROLES) {
                            return {
                                name: null,
                                id: null,
                                clinic: CoreService.currentHasEmployeeRole(ROLES.ROLE_ADMIN) ? null : CoreService.getCurrentClinic()
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-category', null, { reload: 'rpt-category' });
                }, function() {
                    $state.go('rpt-category');
                });
            }]
        })
        .state('rpt-category.edit', {
            parent: 'rpt-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-category/rpt-category-dialog.html',
                    controller: 'RptCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptCategory', function(RptCategory) {
                            return RptCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-category', null, { reload: 'rpt-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-category.delete', {
            parent: 'rpt-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-category/rpt-category-delete-dialog.html',
                    controller: 'RptCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RptCategory', function(RptCategory) {
                            return RptCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-category', null, { reload: 'rpt-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('RptCategory', RptCategory);

    RptCategory.$inject = ['$resource'];

    function RptCategory ($resource) {
        var resourceUrl =  'api/rpt-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RptCategorySearch', RptCategorySearch);

    RptCategorySearch.$inject = ['$resource'];

    function RptCategorySearch($resource) {
        var resourceUrl =  'api/_search/rpt-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCategoryController', RptCategoryController);

    RptCategoryController.$inject = ['$scope', '$state', 'RptCategory', 'RptCategorySearch', '$filter', 'ROLES', 'CoreService', 'DTOptionsBuilder',
        'DTColumnBuilder', '$q', 'GUIUtils', '$compile'];

    function RptCategoryController ($scope, $state, RptCategory, RptCategorySearch, $filter, ROLES, CoreService, DTOptionsBuilder,
                                    DTColumnBuilder, $q, GUIUtils, $compile) {
        var vm = this;

        vm.rptCategories = [];
        vm.dtInstance = {};
        vm.clinic = CoreService.getCurrentClinic();

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                RptCategorySearch.query({
                    query: {
                        bool: {
                            must: getFilter()
                        }
                    }
                }, function (result) {
                    vm.rptCategories = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.rptCategories, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[0, 'desc'], [1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function getFilter() {
            var must = [];

            if (CoreService.currentHasEmployeeRole(ROLES.ROLE_ADMIN)) {
                must.push({
                    bool: {
                        "should": [
                            {not: {exists: {"field": "clinic"}}},
                            {term: {"clinic.id": vm.clinic.id}}
                        ]
                    }
                });

            } else {
                must.push({term: {"clinic.id": vm.clinic.id}});
            }

            must.push({term: {"delStatus": false}});

            return must;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ResultRangeDialogController', ResultRangeDialogController);

    ResultRangeDialogController.$inject = ['$timeout', '$scope', 'Compendium', '$uibModalInstance', 'resultRange', 'ResultRange'];

    function ResultRangeDialogController ($timeout, $scope, Compendium, $uibModalInstance, resultRange, ResultRange) {
        var vm = this;

        vm.resultRange = resultRange;
        vm.clear = clear;
        vm.save = save;

        vm.compendiums = Compendium.by_clinic_result_range_dif({id: vm.resultRange.clinic.id});

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.resultRange.id !== null) {
                ResultRange.update(vm.resultRange, onSaveSuccess, onSaveError);
            } else {
                ResultRange.save(vm.resultRange, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:resultRangeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ResultRangeDetailController', ResultRangeDetailController);

    ResultRangeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ResultRange'];

    function ResultRangeDetailController($scope, $rootScope, $stateParams, previousState, entity, ResultRange) {
        var vm = this;

        vm.resultRange = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:resultRangeUpdate', function(event, result) {
            vm.resultRange = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ResultRangeDeleteController',ResultRangeDeleteController);

    ResultRangeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ResultRange'];

    function ResultRangeDeleteController($uibModalInstance, entity, ResultRange) {
        var vm = this;

        vm.resultRange = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ResultRange.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('result-range', {
            parent: 'entity',
            url: '/result-range',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ResultRanges'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/result-range/result-ranges.html',
                    controller: 'ResultRangeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                clinic: ["CoreService", function (CoreService) {
                    return CoreService.getCurrentClinic();
                }]
            }
        })
        .state('result-range-detail', {
            parent: 'entity',
            url: '/result-range/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ResultRange'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/result-range/result-range-detail.html',
                    controller: 'ResultRangeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ResultRange', function($stateParams, ResultRange) {
                    return ResultRange.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'result-range',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('result-range-detail.edit', {
            parent: 'result-range-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-range/result-range-dialog.html',
                    controller: 'ResultRangeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        resultRange: ['ResultRange', function(ResultRange) {
                            return ResultRange.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('result-range.new', {
            parent: 'result-range',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-range/result-range-dialog.html',
                    controller: 'ResultRangeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        resultRange: ['CoreService', function (CoreService) {
                            return {
                                low: null,
                                high: null,
                                criticalLow: null,
                                criticalHigh: null,
                                description: null,
                                range: null,
                                compendium_code: null,
                                id: null,
                                clinic: CoreService.getCurrentClinic()
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('result-range', null, { reload: 'result-range' });
                }, function() {
                    $state.go('result-range');
                });
            }]
        })
        .state('result-range.edit', {
            parent: 'result-range',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-range/result-range-dialog.html',
                    controller: 'ResultRangeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        resultRange: ['ResultRange', function(ResultRange) {
                            return ResultRange.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('result-range', null, { reload: 'result-range' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('result-range.delete', {
            parent: 'result-range',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/result-range/result-range-delete-dialog.html',
                    controller: 'ResultRangeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ResultRange', function(ResultRange) {
                            return ResultRange.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('result-range', null, { reload: 'result-range' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('ResultRange', ResultRange);

    ResultRange.$inject = ['$resource'];

    function ResultRange ($resource) {
        var resourceUrl =  'api/result-ranges/:id';

        return $resource(resourceUrl, {}, {
            'getAllByClinic': { url: 'api/result-ranges/by-clinic', method: 'POST', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'init': {method: 'GET', url: 'api/result-ranges/init/:id'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('ResultRangeSearch', ResultRangeSearch);

    ResultRangeSearch.$inject = ['$resource'];

    function ResultRangeSearch($resource) {
        var resourceUrl =  'api/_search/result-ranges/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ResultRangeController', ResultRangeController);

    ResultRangeController.$inject = ['$scope', '$state', 'ResultRange', '$q', 'DTColumnBuilder', 'clinic',
        'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'dialogs'];

    function ResultRangeController($scope, $state, ResultRange, $q, DTColumnBuilder, clinic,
                                   DTOptionsBuilder, GUIUtils, $filter, $compile, $dialogs) {
        var vm = this;
        vm.title = 'Result Ranges';
        vm.entityClassHumanized = 'Result Range';
        vm.entityStateName = 'result-range';

        vm.resultRanges = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.init = init;
        vm.dtInstance = {};

        vm.clinic = clinic;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                ResultRange.getAllByClinic(vm.clinic.id, function (result) {
                    vm.resultRanges = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.resultRanges, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('low').withTitle('Low'),
            DTColumnBuilder.newColumn('high').withTitle('High'),
            DTColumnBuilder.newColumn('criticalLow').withTitle('CriticalLow'),
            DTColumnBuilder.newColumn('criticalHigh').withTitle('CriticalHigh'),
            DTColumnBuilder.newColumn('description').withTitle('Description'),
            DTColumnBuilder.newColumn(null).withTitle('Compendium').renderWith(function (data, type, full) {
                return data.compendium == undefined ? '' : data.compendium.code + ' - ' + data.compendium.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function loadAll() {
            ResultRange.query(function (result) {
                vm.resultRanges = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function init() {
            var dlg = $dialogs.confirm('Please Confirm','Reset all result ranges? All current result ranges will be removed', {size: 'md'});
            dlg.result.then(function(btn){
                ResultRange.init({id: vm.clinic.id}, function () {
                    vm.dtInstance.reloadData();
                });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ReportGroupDialogController', ReportGroupDialogController);

    ReportGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ReportGroup'];

    function ReportGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ReportGroup) {
        var vm = this;

        vm.reportGroup = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reportGroup.id !== null) {
                ReportGroup.update(vm.reportGroup, onSaveSuccess, onSaveError);
            } else {
                ReportGroup.save(vm.reportGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:reportGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ReportGroupDetailController', ReportGroupDetailController);

    ReportGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ReportGroup', 'Clinic', 'Corporation'];

    function ReportGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, ReportGroup, Clinic, Corporation) {
        var vm = this;

        vm.reportGroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:reportGroupUpdate', function(event, result) {
            vm.reportGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ReportGroupDeleteController',ReportGroupDeleteController);

    ReportGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'ReportGroup'];

    function ReportGroupDeleteController($uibModalInstance, entity, ReportGroup) {
        var vm = this;

        vm.reportGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ReportGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('report-group', {
                parent: 'entity',
                url: '/report-group',
                data: {
                    authorities: ['ROLE_SUPERVISOR'],
                    pageTitle: 'Report Groups'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/report-group/report-groups.html',
                        controller: 'ReportGroupController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('report-group-detail', {
                parent: 'entity',
                url: '/report-group/{id}',
                data: {
                    authorities: ['ROLE_SUPERVISOR'],
                    pageTitle: 'ReportGroup'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/report-group/report-group-detail.html',
                        controller: 'ReportGroupDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReportGroup', function ($stateParams, ReportGroup) {
                        return ReportGroup.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'report-group',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('report-group-detail.edit', {
                parent: 'report-group-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_SUPERVISOR']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/report-group/report-group-dialog.html',
                        controller: 'ReportGroupDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ReportGroup', function (ReportGroup) {
                                return ReportGroup.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('report-group.new', {
                parent: 'report-group',
                url: '/new',
                data: {
                    authorities: ['ROLE_SUPERVISOR']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/report-group/report-group-dialog.html',
                        controller: 'ReportGroupDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('report-group', null, {reload: 'report-group'});
                    }, function () {
                        $state.go('report-group');
                    });
                }]
            })
            .state('report-group.edit', {
                parent: 'report-group',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_SUPERVISOR']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/report-group/report-group-dialog.html',
                        controller: 'ReportGroupDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ReportGroup', function (ReportGroup) {
                                return ReportGroup.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('report-group', null, {reload: 'report-group'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('report-group.delete', {
                parent: 'report-group',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_SUPERVISOR']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/report-group/report-group-delete-dialog.html',
                        controller: 'ReportGroupDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ReportGroup', function (ReportGroup) {
                                return ReportGroup.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('report-group', null, {reload: 'report-group'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('ReportGroup', ReportGroup);

    ReportGroup.$inject = ['$resource'];

    function ReportGroup ($resource) {
        var resourceUrl =  'api/report-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('ReportGroupSearch', ReportGroupSearch);

    ReportGroupSearch.$inject = ['$resource'];

    function ReportGroupSearch($resource) {
        var resourceUrl =  'api/_search/report-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ReportGroupController', ReportGroupController);

    ReportGroupController.$inject = ['$scope', '$state', 'ReportGroup', 'ReportGroupSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function ReportGroupController ($scope, $state, ReportGroup, ReportGroupSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;

        vm.reportGroups = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  ReportGroup.query(function(result) {
                  vm.reportGroups = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.reportGroups, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            ReportGroup.query(function(result) {
                vm.reportGroups = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RaceDialogController', RaceDialogController);

    RaceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Race'];

    function RaceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Race) {
        var vm = this;

        vm.race = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.race.id !== null) {
                Race.update(vm.race, onSaveSuccess, onSaveError);
            } else {
                Race.save(vm.race, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:raceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RaceDetailController', RaceDetailController);

    RaceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Race', 'Patient', 'Corporation'];

    function RaceDetailController($scope, $rootScope, $stateParams, previousState, entity, Race, Patient, Corporation) {
        var vm = this;

        vm.race = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:raceUpdate', function(event, result) {
            vm.race = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RaceDeleteController',RaceDeleteController);

    RaceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Race'];

    function RaceDeleteController($uibModalInstance, entity, Race) {
        var vm = this;

        vm.race = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Race.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('race', {
            parent: 'entity',
            url: '/race',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Races'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/race/races.html',
                    controller: 'RaceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('race-detail', {
            parent: 'entity',
            url: '/race/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Race'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/race/race-detail.html',
                    controller: 'RaceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Race', function($stateParams, Race) {
                    return Race.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'race',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('race-detail.edit', {
            parent: 'race-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race/race-dialog.html',
                    controller: 'RaceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Race', function(Race) {
                            return Race.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('race.new', {
            parent: 'race',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race/race-dialog.html',
                    controller: 'RaceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('race', null, { reload: 'race' });
                }, function() {
                    $state.go('race');
                });
            }]
        })
        .state('race.edit', {
            parent: 'race',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race/race-dialog.html',
                    controller: 'RaceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Race', function(Race) {
                            return Race.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('race', null, { reload: 'race' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('race.delete', {
            parent: 'race',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race/race-delete-dialog.html',
                    controller: 'RaceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Race', function(Race) {
                            return Race.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('race', null, { reload: 'race' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Race', Race);

    Race.$inject = ['$resource'];

    function Race ($resource) {
        var resourceUrl =  'api/races/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RaceSearch', RaceSearch);

    RaceSearch.$inject = ['$resource'];

    function RaceSearch($resource) {
        var resourceUrl =  'api/_search/races/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RaceController', RaceController);

    RaceController.$inject = ['$scope', '$state', 'Race', 'RaceSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function RaceController ($scope, $state, Race, RaceSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;

        vm.races = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  Race.query(function(result) {
                  vm.races = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.races, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            Race.query(function(result) {
                vm.races = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ProblemListDialogController', ProblemListDialogController);

    ProblemListDialogController.$inject = ['$timeout', '$scope', 'DiagnosisSearch', '$uibModalInstance', 'problem', 'ProblemList', '$state'];

    function ProblemListDialogController ($timeout, $scope, DiagnosisSearch, $uibModalInstance, problem, ProblemList, $state) {
        var vm = this;

        vm.problem = problem;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.editing = $state.current.name != "problem-list-view";

        vm.getDiagnosis = getDiagnosis;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.problem.id !== null) {
                ProblemList.update(vm.problem, onSaveSuccess, onSaveError);
            } else {
                ProblemList.save(vm.problem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:problemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getDiagnosis(query) {
            if (query && query.length > 2) {
                DiagnosisSearch.query({query: query}, function (result) {
                    vm.diagnoses = result;
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ProblemListDeleteController',ProblemListDeleteController);

    ProblemListDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProblemList'];

    function ProblemListDeleteController($uibModalInstance, entity, ProblemList) {
        var vm = this;

        vm.problemList = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProblemList.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('problem-list-new', {
                parent: 'patient-detail',
                url: '/problem-list-new',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function ($stateParams, $state, $uibModal, entity) {
                    $uibModal.open({
                        templateUrl: 'app/entities/problem-list/problem-list-dialog.html',
                        controller: 'ProblemListDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            problem: function () {
                                return {
                                    renal: false,
                                    startDate: null,
                                    endDate: null,
                                    id: null,
                                    active: false,
                                    patient: entity
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', null, {reload: 'patient-detail'});
                    }, function () {
                        $state.go('patient-detail');
                    });
                }]
            })
            .state('problem-list-view', {
                parent: 'patient-detail',
                url: '/{pid}/view',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/problem-list/problem-list-dialog.html',
                        controller: 'ProblemListDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            problem: ['ProblemList', function (ProblemList) {
                                return ProblemList.get({id: $stateParams.pid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', null, {reload: 'patient-detail'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('problem-list-delete', {
                parent: 'patient-detail',
                url: '/problem-list/{pid}/delete',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/problem-list/problem-list-delete-dialog.html',
                        controller: 'ProblemListDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ProblemList', function (ProblemList) {
                                return ProblemList.get({id: $stateParams.pid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', {id: $stateParams.id}, {reload: 'patient-detail'});
                    }, function () {
                        $state.go('patient-detail', {id: $stateParams.id}, {reload: 'patient-detail'});
                    });
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('ProblemList', ProblemList);

    ProblemList.$inject = ['$resource', 'DateUtils'];

    function ProblemList ($resource, DateUtils) {
        var resourceUrl =  'api/problem-lists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'getAllByPatientId': { 'url': 'api/problem-list-by-patient/:id', method: 'GET', isArray: true},
            'getAllActiveByPatientId': { 'url': 'api/active-problem-list-by-patient/:id', method: 'GET', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ProblemListController', ProblemListController);

    ProblemListController.$inject = ['$scope', '$state', '$q', 'entity', '$compile', 'moment', 'DiagnosisSearch',
        'ProblemList', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$sessionStorage', '$http', 'DateUtils'
    ];

    function ProblemListController($scope, $state, $q, entity, $compile, moment, DiagnosisSearch,
                                   ProblemList, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $sessionStorage, $http, DateUtils) {

        var vm = this;
        vm.patient = entity;
        vm.problemList = [];
        vm.problemListDtInstance = {};

        vm.problemListDtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            ProblemList.getAllByPatientId({id: vm.patient.id}, function (result) {
                vm.problemList = result;
                defer.resolve(result);
            });
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('aaSorting', []).withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.problemListDtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('ICD10').renderWith(function (data, type, full) {
                return data.diagnosis ? data.diagnosis.icd10Code : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('ICD10 Description').renderWith(function (data, type, full) {
                return data.diagnosis ? data.diagnosis.description : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Renal').renderWith(function (data, type, full) {
                return data.renal ? 'Y' : 'N';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Is Active?').withOption('width', '155px').notSortable()
                .renderWith(function(data, type, full){
                    return GUIUtils.colorHtmlYesNo(data.active);
                }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return data.startDate ? moment(data.startDate).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return data.endDate ? moment(data.endDate).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-info" ui-sref="problem-list-view({pid:' + data.id + '})">' +
                '   <i class="fa fa-eye"></i></a>&nbsp;';

            if (vm.patient.status) {
                stButtons += '<a class="btn-sm btn-danger" ui-sref="problem-list-delete({pid:' + data.id + '})">' +
                    '   <i class="fa fa-trash"></i></a>';
            }

            return stButtons;
        }

        function problemListActiveActionHtml(data, type, full, meta) {
            if (data.active) {
                return '<span class="label label-success" ng-click="vm.changeProblemStatus(' + data.id + ')" ' +
                    'style="cursor: pointer;">Yes</span></td>';
            } else {
                return '<td><span class="label label-danger" ng-click="vm.changeProblemStatus(' + data.id + ')" ' +
                    'style="cursor: pointer;">No</span>';
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('pr-emr-integration-log', {
                parent: 'entity',
                url: '/pr-emr-integration-log',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
                    pageTitle: 'Emr Integration Log'
                },
                ncyBreadcrumb: {
                    label: 'Emr Integration Log',
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pr-emr-integration-log/pr-emr-integration-log.html',
                        controller: 'PrEmrIntegrationLogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    filter: null
                },
                resolve: {
                    clinic: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentClinic();
                    }],
                    filterRes: ['$stateParams', 'CoreService', function ($stateParams, CoreService) {
                        if ($stateParams.filter) {
                            return CoreService.readEmrIntegrationLogFilter($stateParams.filter)
                        } else {
                            var filterEmrIntegrationLog = CoreService.getStorage('filterEmrIntegrationLog');

                            if (filterEmrIntegrationLog == undefined) {
                                return CoreService.initEmrIntegrationLogFilter();
                            } else {
                                return CoreService.readEmrIntegrationLogFromLocalStore(filterEmrIntegrationLog);
                            }
                        }
                    }]
                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PrEmrIntegrationLogSearch', PrEmrIntegrationLogSearch);

    PrEmrIntegrationLogSearch.$inject = ['$resource'];

    function PrEmrIntegrationLogSearch($resource) {
        var resourceUrl =  'api/_search/patient-result-emr-integration-logs';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PrEmrIntegrationLogController', PrEmrIntegrationLogController);

    PrEmrIntegrationLogController.$inject = ['clinic', '$compile', '$scope', 'Patient', 'filterRes', 'moment',
        '$uibModal', 'PopupService', 'DataTablesService', 'PrEmrIntegrationLogSearch', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', 'GUIUtils', '$filter', 'PatientResultFile', '$rootScope',
        'CoreService', 'DateUtils'];

    function PrEmrIntegrationLogController(clinic, $compile, $scope, Patient, filterRes, moment,
                                           $uibModal, PopupService, DataTablesService, PrEmrIntegrationLogSearch, $q, DTColumnBuilder,
                                           DTOptionsBuilder, GUIUtils, $filter, PatientResultFile, $rootScope,
                                           CoreService, DateUtils) {
        var vm = this;

        vm.title = "Emr Integration Log";
        vm.showFilter = false;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';
        vm.prEmrIntegrationLogResults = [];
        vm.dtInstance = {};
        vm.clinic = clinic;
        vm.filterRes = filterRes;
        vm.selected = {};
        vm.selectAll = false;
        vm.currentMonth = false;
        vm.search = search;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getFilter = getFilter;
        vm.openCalendar = openCalendar;
        vm.clear = clear;
        vm.showFiltersPanel = showFiltersPanel;

        angular.element('.filter-box').hide();

        function showFiltersPanel() {
            angular.element('.filter-box').toggleClass('active');

            if (angular.element('.filter-box').hasClass('active')) {
                angular.element('.toggle-filters').addClass('open');
                angular.element('.filter-box').slideDown();
            } else {
                angular.element('.toggle-filters').removeClass('open');
                angular.element('.filter-box').slideUp();
            }
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (!vm.searchQuery || vm.searchQuery == '') {
                PrEmrIntegrationLogSearch.query(
                    {
                        query: {
                            bool: {
                                must: getFilter()
                            }
                        }
                    }, function (result) {
                        vm.prEmrIntegrationLogResults = result;
                        defer.resolve(vm.prEmrIntegrationLogResults);
                    });
            } else {
                defer.resolve($filter('filter')(vm.prEmrIntegrationLogResults, vm.searchQuery, undefined));
            }

            vm.selected = {};
            vm.selectAll = false;

            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[5, 'desc']])
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Accession Number').renderWith(function (data, type, full) {
                return data.patientResult ? data.patientResult.accessionNumber : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Collection Date').renderWith(function (data, type, full) {
                return data.patientResult ? moment(data.patientResult.collectionDate).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn('status').withTitle('Status'),

            DTColumnBuilder.newColumn(null).withTitle('Sent Date').renderWith(function (data, type, full) {
                return moment(data.createdDate).format($rootScope.displayAmDateTimeFormat);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Sent Date').notVisible().renderWith(function (data, type, full) {
                return moment(data.createdDate).format("YYYYMMDDHHmmss");
            }),
        ];

        function search() {
            CoreService.setStorage('filterEmrIntegrationLog', vm.filterRes);
            vm.dtInstance.reloadData();
        }

        function getFilter() {
            var must = [];

            must.push({
                bool: {
                    "should": [
                        {"term": {"patientResult.clinicId": vm.clinic.id}}
                    ]
                }
            });

            if (vm.filterRes.start) {
                must.push({range: {createdDate: {gte: moment(vm.filterRes.start).format("YYYY-MM-DD")}}});
            }

            if (vm.filterRes.end) {
                var end = new Date(vm.filterRes.end);
                end.setHours(23, 59, 59);
                must.push({range: {createdDate: {lte: moment(end).format("YYYY-MM-DDTHH:mm:ss")}}});
            }

            if (vm.filterRes.barcode != null && vm.filterRes.barcode.length > 0) {
                must.push({match: {'patientResult.accessionNumber': {query: vm.filterRes.barcode}}});
            }

            if (vm.filterRes.status != null && vm.filterRes.status.length > 0) {
                must.push({match: {status: {query: vm.filterRes.status}}});
            }

            return must;
        }

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;
        vm.datePickerOpenStatus.dob = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            vm.filterRes = CoreService.initEmrIntegrationLogFilter();
            CoreService.setStorage('filterEmrIntegrationLog', vm.filterRes);
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PRDetEmployeeCommentDialogController', PRDetEmployeeCommentDialogController);

    PRDetEmployeeCommentDialogController.$inject = ['$scope', '$uibModalInstance', 'prDetEmployeeComment', 'PRDetEmployeeComment', 'toastr'];

    function PRDetEmployeeCommentDialogController($scope, $uibModalInstance, prDetEmployeeComment, PRDetEmployeeComment, toastr) {
        var vm = this;

        vm.prDetEmployeeComment = prDetEmployeeComment;
        vm.clear = clear;
        vm.save = save;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            PRDetEmployeeComment.save(vm.prDetEmployeeComment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Employee comment successfully created');
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PRDetEmployeeComment', PRDetEmployeeComment);

    PRDetEmployeeComment.$inject = ['$resource'];

    function PRDetEmployeeComment($resource) {
        var resourceUrl = 'api/pr-det-employee-comments/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PdAdequacyPatientsController', PdAdequacyPatientsController);

    PdAdequacyPatientsController.$inject = ['$state', '$scope', 'PdAdequacy', 'CoreService', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', '$rootScope'];

    function PdAdequacyPatientsController($state, $scope, PdAdequacy, CoreService, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, $rootScope) {
        $rootScope.$broadcast('dialysisApp:dashboardPdAdequacyCollected', {});

        var vm = this;
        vm.title = 'Kinetics';
        vm.entityClassHumanized = 'Kinetic';
        vm.entityStateName = 'kinetic';

        vm.clinic = CoreService.getCurrentClinic();
        vm.patients = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.addPDAdequacy = addPDAdequacy;

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PdAdequacy.patients({id: vm.clinic.id}, function (result) {
                    vm.patients = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patients, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Name').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + (data.middleInitial ? data.middleInitial : "");
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('gender').withTitle('Gender'),
            DTColumnBuilder.newColumn(null).withTitle('Modality').renderWith(function (data, type, full) {
                return data.modality ? data.modality.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Days').renderWith(function (data, type, full) {
                return data.drawDays ? GUIUtils.expandWeekCodeString(data.drawDays, ',') : "";
            }),
            DTColumnBuilder.newColumn('shift').withTitle('Shift'),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(function (data, type, full) {
                return data.status ? 'Active' : 'Inactive';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Physician').renderWith(function (data, type, full) {
                return data.employee ? 'Dr. ' + data.employee.name + ' ' + data.employee.lastName : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('FDD Date').renderWith(function (data, type, full) {
                return moment(data.fddDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Diabetic').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.diabetic);
            }),
        ];

        function search() {
            vm.dtInstance.reloadData();
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }

            vm.selectAll = true;
        }

        function addPDAdequacy() {
            var patients = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    var _patient = $.grep(vm.patients, function (patient, i) {
                        return patient.id == id;
                    })[0];

                    patients.push(_patient);
                }
            }

            if (patients.length > 0) {
                $state.go('pd-adequacy-add', {patients: patients});
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PdAdequacyAddController', PdAdequacyAddController);

    PdAdequacyAddController.$inject = ['PdAdequacy', 'CoreService', 'patients', '$state', 'dialogs'];

    function PdAdequacyAddController(PdAdequacy, CoreService, patients, $state, $dialogs) {
        var vm = this;
        vm.clinic = CoreService.getCurrentClinic();
        vm.missing = [];
        vm.editForm = {};

        if (!patients || patients.length == 0) {
            $state.go("pd-adequacy-patients", null, {reload: true});
        } else {
            vm.patients = patients;
            var ids = [];

            for (var i = 0; i < vm.patients.length; i++) {
                ids.push(vm.patients[i].id);
            }

            vm.missing = PdAdequacy.missing({ids: ids});

            for (var i = 0; i < vm.missing.length; i++) {
                vm.datePickerOpenStatus.begin.push(false);
                vm.datePickerOpenStatus.end.push(false);
            }
        }

        vm.openCalendar = openCalendar;
        function openCalendar(field, index) {
            vm.datePickerOpenStatus[field][index] = true;
        }

        vm.datePickerOpenStatus = {
            begin: [],
            end: []
        };

        vm.save = function () {
            var pdAdequacies = [];

            for (var i = 0; i < vm.missing.length; i++) {
                var pdAdequacy = {};
                angular.copy(vm.missing[i], pdAdequacy);

                //TODO This code must be fixed, this is only a tmp solution
                if((pdAdequacy.intCode == 1072 || pdAdequacy.urineVolume !== null) &&
                    pdAdequacy.pdFluidOut !== null && pdAdequacy.height !== null && pdAdequacy.dryWeigh !== null && pdAdequacy.patientAge !== null){
                    pdAdequacies.push(pdAdequacy);
                }
            }

            if (pdAdequacies.length > 0) {
                PdAdequacy.save({pdAdequacies: pdAdequacies}, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            $state.go("pd-adequacy-patients", null, {reload: true});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.remove = function (index) {
            vm.missing.splice(index, 1);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('pd-adequacy-patients', {
                parent: 'entity',
                url: '/pd-adequacy-patients',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Kinetics'
                },
                ncyBreadcrumb: {
                    label: 'PD Adequacy',
                    parent: 'clinic'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pd-adequacy/pd-adequacy-patients.html',
                        controller: 'PdAdequacyPatientsController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('pd-adequacy-add', {
                parent: 'pd-adequacy-patients',
                url: '/pd-adequacy-add',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Pd Adequacy Add'
                },
                ncyBreadcrumb: {
                    label: 'Pd Adequacy Add',
                },
                params: {
                    patients: null,
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pd-adequacy/pd-adequacy-add.html',
                        controller: 'PdAdequacyAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    patients: ['$stateParams', function ($stateParams) {
                        return $stateParams.patients;
                    }]
                }
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PdAdequacy', PdAdequacy);

    PdAdequacy.$inject = ['$resource', 'DateUtils'];

    function PdAdequacy($resource, DateUtils) {
        var resourceUrl = 'api/pd-adequacy/:id';

        return $resource(resourceUrl, {}, {
            // 'query': {method: 'GET', isArray: true},
            // 'get': {
            //     method: 'GET',
            //     transformResponse: function (data) {
            //         if (data) {
            //             data = angular.fromJson(data);
            //             data.beginDate = DateUtils.convertDateTimeFromServer(data.beginDate);
            //             data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
            //         }
            //         return data;
            //     }
            // },
            // 'update': {
            //     method: 'PUT',
            //     // transformRequest: function (data) {
            //     //     var copy = angular.copy(data);
            //     //     copy.beginDate = DateUtils.convertLocalDateToServer(copy.beginDate);
            //     //     copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
            //     //
            //     //     return angular.toJson(copy);
            //     // }
            // },
            'save': {'url': 'api/pd-adequacy/save-all', method: 'POST'},
            'patients': {'url': 'api/pd-adequacy/patients/:id', method: 'GET', isArray: true},
            'missing': {url: 'api/pd-adequacy/missing-info', method: 'POST', isArray: true},
            'countMissing' : {url : 'api/pd-adequacy/count-missing/:id', method: 'GET',
                transformResponse: function (data) {
                    return {value: data};
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientTypeDialogController', PatientTypeDialogController);

    PatientTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatientType'];

    function PatientTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatientType) {
        var vm = this;

        vm.patientType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.patientType.id !== null) {
                PatientType.update(vm.patientType, onSaveSuccess, onSaveError);
            } else {
                PatientType.save(vm.patientType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:patientTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientTypeDetailController', PatientTypeDetailController);

    PatientTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PatientType', 'Patient', 'Corporation'];

    function PatientTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, PatientType, Patient, Corporation) {
        var vm = this;

        vm.patientType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:patientTypeUpdate', function(event, result) {
            vm.patientType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientTypeDeleteController',PatientTypeDeleteController);

    PatientTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientType'];

    function PatientTypeDeleteController($uibModalInstance, entity, PatientType) {
        var vm = this;

        vm.patientType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-type', {
            parent: 'entity',
            url: '/patient-type',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Patient Types'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-type/patient-types.html',
                    controller: 'PatientTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('patient-type-detail', {
            parent: 'entity',
            url: '/patient-type/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'PatientType'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-type/patient-type-detail.html',
                    controller: 'PatientTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PatientType', function($stateParams, PatientType) {
                    return PatientType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'patient-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('patient-type-detail.edit', {
            parent: 'patient-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-type/patient-type-dialog.html',
                    controller: 'PatientTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientType', function(PatientType) {
                            return PatientType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-type.new', {
            parent: 'patient-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-type/patient-type-dialog.html',
                    controller: 'PatientTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patient-type', null, { reload: 'patient-type' });
                }, function() {
                    $state.go('patient-type');
                });
            }]
        })
        .state('patient-type.edit', {
            parent: 'patient-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-type/patient-type-dialog.html',
                    controller: 'PatientTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientType', function(PatientType) {
                            return PatientType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-type', null, { reload: 'patient-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-type.delete', {
            parent: 'patient-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-type/patient-type-delete-dialog.html',
                    controller: 'PatientTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatientType', function(PatientType) {
                            return PatientType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-type', null, { reload: 'patient-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientType', PatientType);

    PatientType.$inject = ['$resource'];

    function PatientType ($resource) {
        var resourceUrl =  'api/patient-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientTypeSearch', PatientTypeSearch);

    PatientTypeSearch.$inject = ['$resource'];

    function PatientTypeSearch($resource) {
        var resourceUrl =  'api/_search/patient-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientTypeController', PatientTypeController);

    PatientTypeController.$inject = ['$scope', '$state', 'PatientType', 'PatientTypeSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function PatientTypeController ($scope, $state, PatientType, PatientTypeSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.patientTypes = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  PatientType.query(function(result) {
                  vm.patientTypes = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.patientTypes, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            PatientType.query(function(result) {
                vm.patientTypes = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientTemplateDialogController', PatientTemplateDialogController);

    PatientTemplateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatientTemplate', 'Patient', 'Corporation'];

    function PatientTemplateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatientTemplate, Patient, Corporation) {
        var vm = this;

        vm.patientTemplate = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.patientTemplate.id !== null) {
                PatientTemplate.update(vm.patientTemplate, onSaveSuccess, onSaveError);
            } else {
                PatientTemplate.save(vm.patientTemplate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:patientTemplateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientTemplateDetailController', PatientTemplateDetailController);

    PatientTemplateDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PatientTemplate', 'Patient', 'Corporation'];

    function PatientTemplateDetailController($scope, $rootScope, $stateParams, previousState, entity, PatientTemplate, Patient, Corporation) {
        var vm = this;

        vm.patientTemplate = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:patientTemplateUpdate', function(event, result) {
            vm.patientTemplate = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientTemplateDeleteController',PatientTemplateDeleteController);

    PatientTemplateDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientTemplate'];

    function PatientTemplateDeleteController($uibModalInstance, entity, PatientTemplate) {
        var vm = this;

        vm.patientTemplate = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientTemplate.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-template', {
            parent: 'entity',
            url: '/patient-template',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'PatientTemplates'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-template/patient-templates.html',
                    controller: 'PatientTemplateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('patient-template-detail', {
            parent: 'entity',
            url: '/patient-template/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'PatientTemplate'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-template/patient-template-detail.html',
                    controller: 'PatientTemplateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PatientTemplate', function($stateParams, PatientTemplate) {
                    return PatientTemplate.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'patient-template',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('patient-template-detail.edit', {
            parent: 'patient-template-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-template/patient-template-dialog.html',
                    controller: 'PatientTemplateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientTemplate', function(PatientTemplate) {
                            return PatientTemplate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-template.new', {
            parent: 'patient-template',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-template/patient-template-dialog.html',
                    controller: 'PatientTemplateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patient-template', null, { reload: 'patient-template' });
                }, function() {
                    $state.go('patient-template');
                });
            }]
        })
        .state('patient-template.edit', {
            parent: 'patient-template',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-template/patient-template-dialog.html',
                    controller: 'PatientTemplateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientTemplate', function(PatientTemplate) {
                            return PatientTemplate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-template', null, { reload: 'patient-template' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-template.delete', {
            parent: 'patient-template',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-template/patient-template-delete-dialog.html',
                    controller: 'PatientTemplateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatientTemplate', function(PatientTemplate) {
                            return PatientTemplate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-template', null, { reload: 'patient-template' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientTemplate', PatientTemplate);

    PatientTemplate.$inject = ['$resource'];

    function PatientTemplate ($resource) {
        var resourceUrl =  'api/patient-templates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientTemplateSearch', PatientTemplateSearch);

    PatientTemplateSearch.$inject = ['$resource'];

    function PatientTemplateSearch($resource) {
        var resourceUrl =  'api/_search/patient-templates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientTemplateController', PatientTemplateController);

    PatientTemplateController.$inject = ['$scope', '$state', 'PatientTemplate', 'PatientTemplateSearch', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function PatientTemplateController($scope, $state, PatientTemplate, PatientTemplateSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter) {
        var vm = this;

        vm.patientTemplates = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PatientTemplate.query(function (result) {
                    vm.patientTemplates = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patientTemplates, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function loadAll() {
            PatientTemplate.query(function (result) {
                vm.patientTemplates = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientStatusDialogController', PatientStatusDialogController);

    PatientStatusDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', 'patientStatus',
        'PatientStatus', 'Patient'];

    function PatientStatusDialogController ($timeout, $scope, $state, $stateParams, $uibModalInstance,
                                            patientStatus, PatientStatus, Patient) {
        var vm = this;

        vm.patientStatus = patientStatus;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.editing = $state.current.name != "patient-status.view";

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.patientStatus.id !== null) {
                PatientStatus.update(vm.patientStatus, onSaveSuccess, onSaveError);
            } else {
                PatientStatus.save(vm.patientStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:patientStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientStatusDeleteController',PatientStatusDeleteController);

    PatientStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientStatus'];

    function PatientStatusDeleteController($uibModalInstance, entity, PatientStatus) {
        var vm = this;

        vm.patientStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-status', {
            parent: 'patient-abs',
            url: '/status',
            ncyBreadcrumb: {
                label: 'Statuses',
            },
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Statuses'
            },
            views: {
                'content@patient-abs': {
                    templateUrl: 'app/entities/patient-status/patient-statuses.html',
                    controller: 'PatientStatusController',
                    controllerAs: 'vm'
                }
            }

        })
        .state('patient-status.view', {
            parent: 'patient-status',
            url: '/{psid}/view',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-status/patient-status-dialog.html',
                    controller: 'PatientStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        patientStatus: ['PatientStatus', function(PatientStatus) {
                            return PatientStatus.get({id : $stateParams.psid}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-status', {id: $stateParams.id}, { reload: 'patient-status' });
                }, function() {
                    $state.go('patient-status', {id: $stateParams.id}, { reload: 'patient-status' });
                });
            }]
        })
        .state('patient-status.new', {
            parent: 'patient-status',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-status/patient-status-dialog.html',
                    controller: 'PatientStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        patientStatus: ['CoreService', function (CoreService) {
                            return {
                                startDate: null,
                                endDate: null,
                                endStatus: null,
                                id: null,
                                clinic: CoreService.getCurrentClinic(),
                                patient: entity
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-status', {id: $stateParams.id}, { reload: 'patient-status' });
                }, function() {
                    $state.go('patient-status', {id: $stateParams.id}, { reload: 'patient-status' });
                });
            }]
        })
        .state('patient-status.delete', {
            parent: 'patient-status',
            url: '/{psid}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-status/patient-status-delete-dialog.html',
                    controller: 'PatientStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatientStatus', function(PatientStatus) {
                            return PatientStatus.get({id : $stateParams.psid}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-status', null, { reload: 'patient-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientStatus', PatientStatus);

    PatientStatus.$inject = ['$resource', 'DateUtils'];

    function PatientStatus ($resource, DateUtils) {
        var resourceUrl =  'api/patient-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'getAllByPatientId': { 'url': 'api/patient-statuses/patient/:id', method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientStatusSearch', PatientStatusSearch);

    PatientStatusSearch.$inject = ['$resource'];

    function PatientStatusSearch($resource) {
        var resourceUrl =  'api/_search/patient-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientStatusController', PatientStatusController);

    PatientStatusController.$inject = ['$compile', '$scope', 'PatientStatus', 'entity', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', '$filter', 'moment', '$rootScope'];

    function PatientStatusController($compile, $scope, PatientStatus, entity, $q, DTColumnBuilder, DTOptionsBuilder, $filter, moment, $rootScope) {
        var vm = this;

        vm.patient = entity;
        vm.patientStatuses = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PatientStatus.getAllByPatientId({id: vm.patient.id}, function (result) {
                    vm.patientStatuses = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patientStatuses, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('clinic.name').withTitle('Clinic'),
            DTColumnBuilder.newColumn('startDate').withTitle('Start Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn('endDate').withTitle('End Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn('endStatus').withTitle('End Status'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="patient-status.view({psid:' + data.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            if (vm.patient.status) {
                stButtons += '<a class="btn-sm btn-danger" ui-sref="patient-status.delete({psid:' + data.id + '})">' +
                    '   <i class="fa fa-trash"></i></a>';
            }

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultMissingDataDialogController', PatientResultMissingDataDialogController);

    PatientResultMissingDataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'Clinic',
        'entity', 'PatientResultMissingData', 'Kinetic'];

    function PatientResultMissingDataDialogController ($timeout, $scope, $stateParams, $uibModalInstance, Clinic,
                                                       entity, PatientResultMissingData, Kinetic) {
        var vm = this;

        vm.kinetic = entity;
        vm.kinetic.kg = true;
        vm.kinetic.hhmm = false;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            if (!vm.kinetic.kg) {
                vm.kinetic.preWeight = vm.kinetic.preWeight * 0.453592;
                vm.kinetic.posWeight = vm.kinetic.posWeight * 0.453592;
            }

            if (vm.kinetic.hhmm) {
                vm.kinetic.dialysisLength = moment(vm.kinetic.dialysisLengthHhmm, 'HH:mm').get('hour') * 60;
                vm.kinetic.dialysisLength += moment(vm.kinetic.dialysisLengthHhmm, 'HH:mm').get('minutes');
            }

            vm.isSaving = true;
            Kinetic.save({kinetics: [vm.kinetic]}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:patientResultMissingDataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultMissingDataDetailController', PatientResultMissingDataDetailController);

    PatientResultMissingDataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PatientResultMissingData', 'Compendium'];

    function PatientResultMissingDataDetailController($scope, $rootScope, $stateParams, previousState, entity, PatientResultMissingData, Compendium) {
        var vm = this;

        vm.patientResultMissingData = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:patientResultMissingDataUpdate', function(event, result) {
            vm.patientResultMissingData = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultMissingDataDeleteController',PatientResultMissingDataDeleteController);

    PatientResultMissingDataDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientResultMissingData'];

    function PatientResultMissingDataDeleteController($uibModalInstance, entity, PatientResultMissingData) {
        var vm = this;

        vm.patientResultMissingData = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientResultMissingData.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-result-missing-data', {
            parent: 'entity',
            url: '/patient-result-missing-data?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PatientResultMissingData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data.html',
                    controller: 'PatientResultMissingDataController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('patient-result-missing-data-detail', {
            parent: 'entity',
            url: '/patient-result-missing-data/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PatientResultMissingData'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data-detail.html',
                    controller: 'PatientResultMissingDataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PatientResultMissingData', function($stateParams, PatientResultMissingData) {
                    return PatientResultMissingData.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'patient-result-missing-data',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('patient-result-missing-data-detail.edit', {
            parent: 'patient-result-missing-data-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data-dialog.html',
                    controller: 'PatientResultMissingDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientResultMissingData', function(PatientResultMissingData) {
                            return PatientResultMissingData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-result-missing-data.new', {
            parent: 'patient-result-missing-data',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data-dialog.html',
                    controller: 'PatientResultMissingDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                result: null,
                                barcode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patient-result-missing-data', null, { reload: 'patient-result-missing-data' });
                }, function() {
                    $state.go('patient-result-missing-data');
                });
            }]
        })
        .state('patient-result-missing-data.edit', {
            parent: 'patient-result-missing-data',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data-dialog.html',
                    controller: 'PatientResultMissingDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientResultMissingData', function(PatientResultMissingData) {
                            return PatientResultMissingData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-result-missing-data', null, { reload: 'patient-result-missing-data' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-result-missing-data.delete', {
            parent: 'patient-result-missing-data',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data-delete-dialog.html',
                    controller: 'PatientResultMissingDataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatientResultMissingData', function(PatientResultMissingData) {
                            return PatientResultMissingData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-result-missing-data', null, { reload: 'patient-result-missing-data' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientResultMissingData', PatientResultMissingData);

    PatientResultMissingData.$inject = ['$resource'];

    function PatientResultMissingData ($resource) {
        var resourceUrl =  'api/patient-result-missing-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientResultMissingDataSearch', PatientResultMissingDataSearch);

    PatientResultMissingDataSearch.$inject = ['$resource'];

    function PatientResultMissingDataSearch($resource) {
        var resourceUrl =  'api/_search/patient-result-missing-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultMissingDataController', PatientResultMissingDataController);

    PatientResultMissingDataController.$inject = ['$scope', '$state', 'PatientResultMissingData', 'PatientResultMissingDataSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PatientResultMissingDataController ($scope, $state, PatientResultMissingData, PatientResultMissingDataSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PatientResultMissingDataSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PatientResultMissingData.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patientResultMissingData = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientResultFile', PatientResultFile);

    PatientResultFile.$inject = ['$resource', 'DataUtils'];

    function PatientResultFile($resource, DataUtils) {
        var resourceUrl = 'api/patient-result-files/:id';

        return $resource(resourceUrl, {}, {
            'getAllByPatientResult': {
                url: 'api/patient-result-files/by-patient-result/all/:id',
                method: 'GET',
                isArray: true
            },
            'getByPatientResult': {
                url: 'api/patient-result-files/by-patient-result/getpdf',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            },
            'getPdf': {
                url: 'api/patient-result-files/get-pdf',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            },
            'getOnePDFByPatientResults': {
                url: 'api/patient-result-files/get-all-in-one-pdf',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            },
            'getAllInOneRangePdf': {
                url: 'api/patient-result-files/get-all-in-one-range-pdf',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('latest-result-det', {
                parent: 'latest-result',
                url: '/{id}/lrdetails',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR', 'ROLE_ADMIN'],
                    pageTitle: 'Result Details'
                },
                ncyBreadcrumb: {
                    label: 'Result Details',
                    parent: 'latest-result'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result-det/patient-result-dets.html',
                        controller: 'PatientResultDetController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    patientResult: ['$stateParams', 'PatientResult', function ($stateParams, PatientResult) {
                        return PatientResult.get({id: $stateParams.id}).$promise;
                    }],
                    clinic: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentClinic();
                    }]
                }
            })
            .state('patient-result-details', {
                parent: 'patient-result',
                url: '/{rid}/details',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR', 'ROLE_ADMIN'],
                    pageTitle: 'Result Details'
                },
                ncyBreadcrumb: {
                    label: 'Result Details',
                    parent: 'patient-result'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result-det/patient-result-dets.html',
                        controller: 'PatientResultDetController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    patientResult: ['$stateParams', 'PatientResult', function ($stateParams, PatientResult) {
                        return PatientResult.get({id: $stateParams.rid}).$promise;
                    }],
                    clinic: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentClinic();
                    }]
                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientResultDet', PatientResultDet);

    PatientResultDet.$inject = ['$resource', 'DateUtils'];

    function PatientResultDet ($resource, DateUtils) {
        var resourceUrl =  'api/patient-result-dets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'compendium': {method: 'GET', isArray: true, url: 'api/patient-result-dets/compendium/:id/:start/:end'},
            'trending': {method: 'GET', isArray: true, url: 'api/patient-result-dets/by-patient/:id/:start/:end/:testcode'},
            'trendingRepo': {url: 'api/report/trending', method: 'POST', isArray: false},
            'getComments': {url: 'api/patient-result-dets/comments/:id', method: 'GET', isArray: true},
            'getEmployeeComments': {url: 'api/patient-result-dets/emp-comments/:id', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientResultDetSearch', PatientResultDetSearch);

    PatientResultDetSearch.$inject = ['$resource'];

    function PatientResultDetSearch($resource) {
        var resourceUrl =  'api/_search/patient-result-dets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultDetController', PatientResultDetController);

    PatientResultDetController.$inject = ['patientResult', '$scope', 'PatientResultDetSearch', '$compile', 'Patient', 'lodash', 'PatientResult',
        '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', 'PatientResultFile', '$uibModalInstance'];

    function PatientResultDetController(patientResult, $scope, PatientResultDetSearch, $compile, Patient, _, PatientResult,
                                        $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, PatientResultFile, $uibModalInstance) {
        var vm = this;

        vm.patientResult = patientResult;
        vm.dtInstance = {};

        vm.pdf = {};

        if (vm.patientResult.patientId) {
            vm.patient = Patient.get({id: vm.patientResult.patientId});
        } else {
            vm.patient = null;
        }

        //TODO get the physician
        vm.physician = vm.patient ? vm.patient.employee : null;
        vm.patientResultDets = [];
        vm.groups = [];
        vm.groupsAll = {name: 'All', value: true};
        vm.levels = {
            all: true,
            abnormals: true,
            criticals: true,
            L: true,
            LL: true,
            N: true,
            H: true,
            HH: true
        };

        vm.search = search;
        vm.clear = clear;
        vm.toggleFilters = toggleFilters;

        vm.dtColumns = [
            DTColumnBuilder.newColumn('testCode').withOption('width', '190px').withTitle('Test Code'),
            DTColumnBuilder.newColumn('testName').withOption('width', '350px').withTitle('Test'),
            DTColumnBuilder.newColumn('rGroup').withOption('width', '250px').withTitle('Group').notVisible(),
            DTColumnBuilder.newColumn(null).withTitle('Result').renderWith(function (data, type, full) {
                if (full.result) {
                    if (full.activeRange) {
                        return decorateResult(full.rangeStatus, full.result);
                    } else {
                        return decorateResult(full.status, full.result);
                    }
                }

                return "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Ranges').renderWith(function (data, type, full) {
                if (full.activeRange) {
                    return full.range ? full.range : full.cutOff;
                } else {
                    return full.cutOff;
                }
            }),
            DTColumnBuilder.newColumn('units').withTitle('Units')
        ];

        if (vm.patientResult.reviewedStatus == false && vm.patientResult.patientId) {
            PatientResult.markAsReviewed({id: vm.patientResult.id});
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (vm.patientResultDets.length == 0) {
                PatientResultDetSearch.query({
                    query: {
                        bool: {
                            must: getFilter()
                        }
                    },
                }, function (result) {
                    vm.patientResultDets = result;

                    var groupsIndex = {};

                    vm.patientResultDets.forEach(function (detail) {
                        if (detail.rGroup && groupsIndex[detail.rGroup] == undefined) {
                            groupsIndex[detail.rGroup] = detail.rGroup;
                            vm.groups.push({name: detail.rGroup, value: true});
                        }
                    });

                    defer.resolve(vm.patientResultDets);
                });
            } else {
                //groupsNames actives
                var groupsNames = _.map(_.filter(vm.groups, {'value': true}), function (group) {
                    return group.name;
                });

                //status actives
                var levelsIn = [];
                //status inactives
                var levelsOut = [];

                _.forOwn(vm.levels, function (value, key) {
                    if (['L', 'LL', 'N', 'H', 'HH'].indexOf(key) != -1) {
                        if (value) {
                            levelsIn.push(key);
                        } else {
                            levelsOut.push(key)
                        }
                    }
                });

                var resultsDets = _.filter(vm.patientResultDets, function (det) {
                    var status = det.activeRange ? det.rangeStatus : det.status;

                    return groupsNames.indexOf(det.rGroup) != -1 &&
                        //check if appear a value different of L, LL, N, H, HH like A
                        (levelsIn.indexOf(status) != -1 || levelsOut.indexOf(status) == -1);
                });

                defer.resolve($filter('filter')(resultsDets, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[2, 'asc'], [0, 'asc']])
            .withOption('fnDrawCallback', function (oSettings) {
                var api = this.api();
                var rows = api.rows({page: 'current'}).nodes();
                var last = null;
                api.column(2, {page: 'current'}).data().each(function (group, i) {
                    if (last !== group) {
                        $(rows).eq(i).before(
                            '<tr class="group"><td colspan="6"><strong>' + group + '</strong></td></tr>'
                        );
                        last = group;
                    }
                });
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        function decorateResult(status, result) {
            switch (status) {
                case 'N': {
                    return result;
                }
                case 'L':
                case 'H': {
                    return GUIUtils.getStatusTemplate(result + ' ' + status, 'primary');
                }
                case 'LL':
                case 'HH': {
                    return GUIUtils.getStatusTemplate(result + ' ' + status, 'danger');
                }
                default: {
                    return '';
                }
            }
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        vm.getPDF = function () {
            PatientResultFile.getPdf(vm.pdf.id);
        };

        function getFilter() {
            var must = [];
            must.push({term: {"delStatus": false}});
            must.push({term: {"patientResultId": vm.patientResult.id}});

            return must;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function toggleFilters() {
            angular.element('.filters-wrapper').slideToggle()
        }

        vm.groupsCheck = groupsCheck;
        vm.groupCheckAll = groupCheckAll;
        vm.levelAll = levelAll;
        vm.abnormals = abnormals;
        vm.criticals = criticals;
        vm.normal = normal;
        vm.notNormal = notNormal;

        function levelAll() {
            for (var key in vm.levels) {
                vm.levels[key] = vm.levels.all;
            }

            search();
        }

        function abnormals() {
            if (vm.levels.abnormals) {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'abnormals':
                        case 'L':
                        case 'H':
                            vm.levels[key] = true;
                            break;
                        default:
                            vm.levels[key] = false;
                    }
                }
            } else {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'all':
                        case 'criticals':
                        case 'L':
                        case 'H':
                            vm.levels[key] = false;
                            break;
                    }
                }
            }

            search();
        }

        function criticals() {
            if (vm.levels.criticals) {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'criticals':
                        case 'LL':
                        case 'HH':
                            vm.levels[key] = true;
                            break;
                        default:
                            vm.levels[key] = false;
                    }
                }
            } else {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'all':
                        case 'abnormals':
                        case 'LL':
                        case 'HH':
                            vm.levels[key] = false;
                            break;
                    }
                }
            }

            search();
        }

        function normal() {
            if (vm.levels.N) {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'abnormals':
                        case 'criticals':
                            vm.levels[key] = false;
                            break;
                        case 'all':
                            vm.levels[key] = vm.levels.L && vm.levels.LL && vm.levels.H && vm.levels.HH && vm.levels.N;
                            break;
                    }
                }
            } else {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'abnormals':
                            vm.levels[key] = vm.levels.L && vm.levels.LL && vm.levels.H && vm.levels.HH;
                            break;
                        case 'criticals':
                            vm.levels[key] = !vm.levels.L && vm.levels.LL && !vm.levels.H && vm.levels.HH;
                            break;
                        case 'all':
                            vm.levels[key] = false;
                            break;
                    }
                }
            }

            search();
        }

        function notNormal() {
            vm.levels['abnormals'] = vm.levels.L && vm.levels.LL && vm.levels.H && vm.levels.HH && !vm.levels.N;
            vm.levels['criticals'] = !vm.levels.L && vm.levels.LL && !vm.levels.h && vm.levels.hh && !vm.levels.N;
            vm.levels['all'] = vm.levels.L && vm.levels.LL && vm.levels.H && vm.levels.HH && vm.levels.N;

            search();
        }

        function groupsCheck() {
            var all = true;

            vm.groups.forEach(function (group) {
                all = all && group.value;
            });

            vm.groupsAll.value = all;

            search();
        }

        function groupCheckAll() {
            vm.groups.forEach(function (group) {
                group.value = vm.groupsAll.value;
            });

            search();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultUpdateDatesController', PatientResultUpdateDatesController);

    PatientResultUpdateDatesController.$inject = ['PatientResult', 'dialogs', 'toastr', '$state'];

    function PatientResultUpdateDatesController(PatientResult, $dialogs, toastr, $state) {
        var vm = this;

        vm.receivedDate = null;
        vm.collectionDate = null;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.receivedDate = false;
        vm.datePickerOpenStatus.collectionDate = false;

        vm.openCalendar = openCalendar;
        vm.saveDates = saveDates;
        vm.clear = clear;
        vm.clean = clean;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function saveDates() {
            var dlg = $dialogs.confirm('Please Confirm', 'Do you want to update this result?', {size: 'md'})
            dlg.result.then(function (btn) {
                vm.isSaving = true;
                PatientResult.updateDates({
                    barcode: vm.barcode,
                    startDate: vm.receivedDate,
                    endDate: vm.collectionDate
                }, function () {
                    toastr.success('Update dates operation successfully completed');
                    vm.isSaving = false;
                    vm.clean();
                },function () {
                    vm.isSaving = false;
                })
            })
        }

        function clear() {
            $state.go("latest-result", {});
        }

        function clean(){
            vm.barcode = "";
            vm.receivedDate = null;
            vm.collectionDate = null;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('UnassignedResultController', UnassignedResultController);

    UnassignedResultController.$inject = ['$compile', '$scope', 'filterRes', 'moment', 'Patient', 'DateUtils',
        'CoreService', 'PatientResult', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function UnassignedResultController($compile, $scope, filterRes, moment, Patient, DateUtils,
                                        CoreService, PatientResult, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter) {

        var vm = this;

        vm.title = "Unassigned Result";
        vm.patientResults = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.filterRes = filterRes;
        vm.clinic = CoreService.getCurrentClinic();
        vm.patients = [];
        vm.patient = {};

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        Patient._4filter({
            query: {
                bool: {
                    must: [
                        {term: {"clinicId": vm.clinic.id}},
                        {term: {"delStatus": false}}
                    ]
                }
            }
        }, function (result) {
            vm.patients = result;

            for (var i = 0; i < vm.patients.length; i++) {
                vm.patients[i].name = vm.patients[i].firstName + ' ' + vm.patients[i].lastName;
            }
        });

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.patientResults);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                PatientResult.unassigned({account: vm.clinic.account}, function (result) {
                    vm.selected = {};
                    vm.selectAll = false;
                    vm.toggleAll = toggleAll;
                    vm.toggleOne = toggleOne;
                    vm.patient = {};
                    vm.patientResults = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patientResults, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withOption('aaSorting', []).withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            }).withOption('createdRow', function (row, data, dataIndex) {
            $compile(angular.element(row).contents())($scope);
        }).withOption('headerCallback', function (header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Patient').renderWith(function (data, type, full) {
                return data.patientName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('status').withTitle('Status'),
            DTColumnBuilder.newColumn(null).withTitle('Result Date').renderWith(function (data, type, full) {
                return moment(data.createdDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('').withTitle('').withOption('width', '155px').notSortable()
                .renderWith(abnormalHtml),
        ];

        function abnormalHtml(data, type, full, meta) {
            if (full.abnormal) {
                return GUIUtils.getStatusTemplate('ABNORMAL', 'danger');
            } else {
                return GUIUtils.getStatusTemplate('NORMAL', 'success');
            }
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }
            vm.selectAll = true;
        }

        vm.assign = function () {
            if (!vm.patient) {
                return;
            }

            var result = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    result.push(id);
                }
            }

            if (result.length > 0) {
                vm.isSaving = true;
                PatientResult.assign({
                    ids: result,
                    date: DateUtils.convertLocalDateToServer(vm.oDate1),
                    patientId: vm.patient.id
                }, function () {
                    vm.dtInstance.reloadData();
                    vm.isSaving = false;
                }, function () {
                })
            }
        }

        vm.filterPatients = filterPatients;
        function filterPatients(query) {
            if (query && query.length > 1) {
                vm.currentClinic = CoreService.getCurrentClinic();
                Patient._4filter({
                    query: {
                        bool: {
                            should: [
                                {match: {firstName: {query: query, fuzziness: 1}}},
                                {match: {lastName: {query: query, fuzziness: 1}}}
                            ],
                            must: [
                                {term: {"clinic.id": vm.currentClinic.id}},
                                {term: {"delStatus": false}}
                            ]
                        }
                    }
                }, function (result) {
                    vm.patients = result;
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultTrendingController', PatientResultTrendingController);

    PatientResultTrendingController.$inject = ['entity', 'PatientResultDet', 'DateUtils', 'OdsReportsService'];

    function PatientResultTrendingController(entity, PatientResultDet, DateUtils, OdsReportsService) {
        var vm = this;

        vm.patient = entity;
        vm.compendiums = [];
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.staringDate = false;
        vm.trending = {
            staringDate: new Date('2016-01-01'),
            endDate: new Date(),
            compendium: null
        };
        vm.trendings = [];
        vm.trendings2 = [];
        vm.id = 0;

        vm.options = {
            chart: {
                type: 'lineChart',
                height: 550,
                margin: {
                    top: 100,
                    right: 40,
                    bottom: 110,
                    left: 100
                },
                x: function (d) {
                    return d ? d[0] : null;
                },
                y: function (d) {
                    return d ? d[1] : null;
                },
                // average: function (d) {
                //     return d.mean / 100;
                // },

                color: d3.scale.category10().range(),
                duration: 300,
                useInteractiveGuideline: true,
                // clipVoronoi: false,

                xAxis: {
                    axisLabel: 'Time Line',
                    tickFormat: function (d) {
                        return d3.time.format('%m/%d/%y')(new Date(d))
                    },
                    showMaxMin: false,
                    staggerLabels: true
                },

                yAxis: {
                    axisLabel: 'Test Result Value',
                    // tickFormat: function (d) {
                    //     return d3.format(',.1%')(d);
                    // },
                    axisLabelDistance: 20,
                    // showMaxMin: false,
                }
            }
        };

        vm.data = [];

        vm.openCalendar = openCalendar;
        vm.getCompendium = getCompendium;
        vm.getPDF = getPDF;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.getCompendium();

        function getCompendium() {
            if (vm.trending.staringDate && vm.trending.endDate) {
                vm.compendiums = PatientResultDet.compendium(
                    {
                        id: vm.patient.id,
                        start: DateUtils.convertLocalDateToServer(vm.trending.staringDate),
                        end: DateUtils.convertLocalDateToServer(vm.trending.endDate)
                    }, function (result) {
                        vm.trending.compendium = null;
                        vm.compendiums = result;
                    });
            }
        }

        vm.getResults = function () {
            PatientResultDet.trending({
                id: vm.patient.id,
                start: DateUtils.convertLocalDateToServer(vm.trending.staringDate),
                end: DateUtils.convertLocalDateToServer(vm.trending.endDate),
                testcode: vm.trending.compendium.code
            }, function (results) {
                vm.trendings.push({
                    id: vm.id,
                    start: DateUtils.convertLocalDateToServer(vm.trending.staringDate),
                    end: DateUtils.convertLocalDateToServer(vm.trending.endDate),
                    testcode: vm.trending.compendium.code,
                    description: vm.trending.compendium.description
                });

                vm.trendings2.push(vm.trendings[vm.trendings.length - 1]);

                var resultsDetData = {
                    id: vm.id,
                    key: vm.trending.compendium.code + " " + vm.trending.compendium.description + "(" + results.length + ")",
                    values: [],
                    mean: 250
                };

                for (var i = 0; i < results.length; i++) {
                    resultsDetData.values.push([new Date(results[i].createdDate).getTime(), parseInt(results[i].result)]);
                }

                vm.data.push(resultsDetData);

                vm.id++;
            });
        };

        vm.alert = function () {
            for (var i = 0; i < vm.data.length; i++) {
                var noExist = $.grep(vm.trendings2, function (trending) {
                    return trending.id == vm.data[i].id;
                });

                if (noExist.length == 0) {
                    vm.data.splice(i, 1);
                    break;
                }
            }

            angular.copy(vm.trendings2, vm.trendings);
        }

        function getPDF() {
            PatientResultDet.trendingRepo({patientId: vm.patient.id, kineticParams: vm.trendings2}, function (data) {
                OdsReportsService.forceDownloadAndOpenPDFObject(data);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PendingResultController', PendingResultController);

    PendingResultController.$inject = ['CoreService', '$uibModal', '$compile', '$q', '$scope', 'GUIUtils',
        'PatientOrder', 'DTOptionsBuilder', 'DTColumnBuilder', 'DateUtils'];

    function PendingResultController(CoreService, $uibModal, $compile, $q, $scope, GUIUtils,
                                     PatientOrder, DTOptionsBuilder, DTColumnBuilder, DateUtils) {
        var vm = this;
        vm.clinic = CoreService.getCurrentClinic();

        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (vm.clinic) {
                PatientOrder.pending({clinicId: vm.clinic.id, shift: -1}, function (result) {
                    vm.orders = result;
                    defer.resolve(vm.orders);
                });
            } else {
                defer.resolve(vm.orders);
            }

            return defer.promise;
        }).withBootstrap().withDOM('tip')
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Patient Name').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + data.middleName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('D.O.B').withOption('width', '110px').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Collected Date').withOption('width', '110px').renderWith(function (data, type, full) {
                return moment(data.scheduleDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.barcode ? showBarcode(data) : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Tests').withOption('width', '90px').renderWith(function (data, type, full, meta) {
                return showCompendiumHtml(data.barcode);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Collected').withOption('width', '80px').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.collected);
            })
        ];

        function search() {
            vm.dtInstance.reloadData();
        }

        $scope.$on('dialysisApp:dashboardCalendarUpdate', function (event, result) {
            vm.oDate1 = result;
            vm.selected = {};
            vm.selectAll = false;
            vm.search();
        });

        function showBarcode(row) {
            return '<a ui-sref="' + "clinic-schedule-pdetail-barcode({barcode:'" + row.barcode + "'})" + '">' + row.barcode + '</a>';
        }

        function showCompendiumHtml(barcode) {
            return '<a class="btn-sm btn-info" ng-click="vm.showCompendiums(' + "'" + barcode + "'" + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        };

        vm.showCompendiums = function (barcode) {
            $uibModal.open({
                templateUrl: 'app/entities/compendium/compendium-list-dialog.html',
                controller: 'CompendiumListDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    compendiums: ['Compendium', function (Compendium) {
                        return Compendium.by_patient_with_barcode({barcode: barcode}).$promise;
                    }]
                }
            });
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultLatestController', PatientResultLatestController);

    PatientResultLatestController.$inject = ['clinic', '$compile', '$scope', 'Patient', 'filterRes', 'moment',
        '$uibModal', 'PopupService', 'DataTablesService', 'PatientResultSearch', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', 'GUIUtils', '$filter', 'PatientResultFile', '$rootScope',
        'CoreService', 'PatientResult', 'dialogs', 'Principal', 'ROLES', 'toastr'];

    function PatientResultLatestController(clinic, $compile, $scope, Patient, filterRes, moment,
                                           $uibModal, PopupService, DataTablesService, PatientResultSearch, $q, DTColumnBuilder,
                                           DTOptionsBuilder, GUIUtils, $filter, PatientResultFile, $rootScope,
                                           CoreService, PatientResult, $dialogs, Principal, ROLES, toastr) {
        var vm = this;

        vm.title = "Latest Results";
        vm.showFilter = false;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';
        vm.patientResults = [];
        vm.dtInstance = {};
        vm.clinic = clinic;
        vm.filterRes = filterRes;
        vm.selected = {};
        vm.selectAll = false;
        vm.shifts = Patient.get_shift({id: vm.clinic.id});
        vm.shift = null;
        vm.shiftImpl = -1;
        vm.currentMonth = false;
        vm.page = 1;
        vm.itemsPerPage = 10;

        vm.search = search;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.selectShift = selectShift;
        vm.clearShift = clearShift;
        vm.printRangePDFs = printRangePDFs;
        vm.updateStatusButtonFilter = updateStatusButtonFilter;
        vm.updateCurrentMonthFilter = updateCurrentMonthFilter;
        vm.getFilter = getFilter;
        vm.details = details;
        vm.openCalendar = openCalendar;
        vm.clear = clear;
        vm.showFiltersPanel = showFiltersPanel;
        vm.sendToEmr = sendToEmr;
        vm.transition = transition;
        vm.dtInstanceCallback = dtInstanceCallback;

        angular.element('.filter-box').hide();

        function showFiltersPanel() {
            angular.element('.filter-box').toggleClass('active');

            if (angular.element('.filter-box').hasClass('active')) {
                angular.element('.toggle-filters').addClass('open');
                angular.element('.filter-box').slideDown();
            } else {
                angular.element('.toggle-filters').removeClass('open');
                angular.element('.filter-box').slideUp();
            }
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            PatientResult.getAllByFilter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');

                vm.patientResults = result;
                defer.resolve(vm.patientResults);
            })

            vm.selected = {};
            vm.selectAll = false;

            return defer.promise;
        }).withOption("bPaginate", false)
            .withBootstrap()
            .withDOM('tp')
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('patientName').withTitle('Patient Name'),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format($rootScope.displayDateformat);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.accessionNumber ? data.accessionNumber : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Collection Date').renderWith(function (data, type, full) {
                return data.collectionDate ? moment(data.collectionDate).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Result Date').renderWith(function (data, type, full) {
                return moment(data.createdDate).format($rootScope.displayDateformat);
            }),
            DTColumnBuilder.newColumn('').withTitle('').withOption('width', '175px').withTitle('Alert').notSortable()
                .renderWith(abnormalHtml),
            DTColumnBuilder.newColumn('status').withTitle('Status').renderWith(statusHtml),
            DTColumnBuilder.newColumn('').withTitle('Actions').withOption('class', 'col').withOption('width', '175px').notSortable()
                .renderWith(actionsHtml)
        ];

        function abnormalHtml(data, type, full, meta) {
            if (full.abnormalRange) {
                return GUIUtils.getStatusTemplate('ABNORMAL', 'danger');
            } else {
                return GUIUtils.getStatusTemplate('NORMAL', 'success');
            }
        }

        function statusHtml(data, type, full, meta) {
            if (full.status == 'PARTIAL') {
                return GUIUtils.getStatusTemplate(full.status, 'warning');
            } else {
                return GUIUtils.getStatusTemplate(full.status, 'primary');
            }
        }

        function actionsHtml(data, type, full, meta) {
            return '<a class="dt-btn warning" ng-click="vm.details(' + full.id + ')" uib-tooltip="View Details"><i class="fa fa-file-text" aria-hidden="true"></i></a>' +
                '<a class="dt-btn danger" ng-click="vm.printRangePDFs(' + full.id + ')" uib-tooltip="View PDF"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></a>'
        }

        function search() {
            CoreService.setStorage('filterPatient', vm.filterRes);
            vm.dtInstance.reloadData();
        }

        function getFilter() {
            var filter = {
                clinicId: vm.clinic.id,
                patientName: vm.filterRes.patientName,
                searchQuery: vm.searchQuery,
                status: vm.filterRes.status,
                abnormalRange: vm.filterRes.abnormal,
                startDate: vm.filterRes.start ? moment(vm.filterRes.start).format("YYYY-MM-DD") : null,
                endDate: vm.filterRes.end ? moment(vm.filterRes.end).format("YYYY-MM-DD") : null,
                dob: vm.filterRes.dob ? moment(vm.filterRes.dob).format("YYYY-MM-DD") : null,
                accessionNumber: vm.filterRes.barcode,
                reviewedStatus: vm.filterRes.reviewedStatus,
                page: vm.filterRes.page - 1,
                size: vm.itemsPerPage,
                shift: vm.filterRes.shiftImpl
            };

            var must = [];
            must.push({
                bool: {
                    "should": [
                        {"term": {"clinicId": vm.clinic.id}},
                        {"term": {"clinic.id": vm.clinic.id}}
                    ]
                }
            });

            must.push({term: {"delStatus": false}});
            must.push({exists: {"field": "accessionNumber"}});
            must.push({term: {"patient.status": true}});

            if ((vm.filterRes.patientName != null && vm.filterRes.patientName.length > 0) ||
                (vm.searchQuery != null && vm.searchQuery.length > 0)) {

                var patientNameQuery = {
                    bool: {
                        should: []
                    }
                };

                if (vm.filterRes.patientName != null && vm.filterRes.patientName.length > 0) {
                    patientNameQuery.bool.should.push({match_phrase_prefix: {patientName: {query: vm.filterRes.patientName}}})
                }

                if (vm.searchQuery != null && vm.searchQuery.length > 0) {
                    patientNameQuery.bool.should.push({match_phrase_prefix: {patientName: {query: vm.searchQuery}}})
                }

                must.push(patientNameQuery);
            }

            if (vm.filterRes.status != null && vm.filterRes.status.length > 0) {
                must.push({match: {status: {query: vm.filterRes.status}}});
            }

            if (vm.filterRes.abnormal != null && vm.filterRes.abnormal.length > 0) {
                must.push({match: {abnormalRange: {query: vm.filterRes.abnormal}}});
            }

            if (vm.filterRes.start) {
                must.push({range: {collectionDate: {gte: moment(vm.filterRes.start).format("YYYY-MM-DD")}}});
            }

            if (vm.filterRes.end) {
                must.push({range: {collectionDate: {lte: moment(vm.filterRes.end).format("YYYY-MM-DD")}}});
            }

            if (vm.filterRes.dob) {
                must.push({match: {dob: moment(vm.filterRes.dob).format("YYYY-MM-DD")}});
            }

            if (vm.filterRes.barcode != null && vm.filterRes.barcode.length > 0) {
                must.push({match: {accessionNumber: {query: vm.filterRes.barcode}}});
            }

            if (vm.filterRes.status != null && vm.filterRes.status.length > 0) {
                must.push({match: {status: {query: vm.filterRes.status}}});
            }

            if (vm.filterRes.reviewedStatus != null && vm.filterRes.reviewedStatus.length > 0) {
                must.push({match: {reviewedStatus: vm.filterRes.reviewedStatus}});
            }

            // return must;

            return filter;
        }

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;
        vm.datePickerOpenStatus.dob = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            vm.filterRes = CoreService.initPatientResultFilter();
            selectShift();
            CoreService.setStorage('filterPatient', vm.filterRes);
            vm.dtInstance.reloadData();
        }

        function selectShift() {
            if (vm.filterRes.shift == null) {
                vm.filterRes.shiftImpl = -1
            } else {
                vm.filterRes.shiftImpl = vm.filterRes.shift.id;
            }
        }

        function clearShift() {
            vm.shift = null;
            selectShift()
        }

        function printRangePDFs(id) {
            var ids;

            if (id) {
                ids = [id];
            } else {
                ids = DataTablesService.getSelectedIds(vm.selected);
            }

            if (ids.length > 0) {
                PatientResultFile.getAllInOneRangePdf({ids: ids});
            }
        }

        function updateStatusButtonFilter(status) {
            vm.filterRes.status = status;
            CoreService.setStorage('filterPatient', vm.filterRes);
            vm.dtInstance.reloadData();
        }

        function updateCurrentMonthFilter() {
            if (vm.currentMonth) {
                var nowdate = new Date();
                var monthStartDay = new Date(nowdate.getFullYear(), nowdate.getMonth(), 1);
                var monthEndDay = new Date(nowdate.getFullYear(), nowdate.getMonth() + 1, 0);

                vm.filterRes.start = monthStartDay;
                vm.filterRes.end = monthEndDay;
            } else {
                vm.filterRes = CoreService.initPatientResultFilter();
            }

            CoreService.setStorage('filterPatient', vm.filterRes);
            vm.dtInstance.reloadData();
        }

        function details(id) {
            var patientResult = vm.patientResults.find(function (el) {
                return el.id === id;
            });

            PopupService.showPatientResultDetPopup(patientResult);
        }

        function sendToEmr() {
            var ids = DataTablesService.getSelectedIds(vm.selected);

            if (ids.length > 0) {
                PatientResult.sendToEmr({ids: ids}, function (result) {
                    if (result.barcodes && result.barcodes.length > 0) {
                        $dialogs.error("Error", "The following patient results can't be send: " +
                            _.map(result.barcodes, function (barcode) {
                                    return barcode;
                                }
                            ).join(', ')
                        );
                    } else {
                        toastr.success('Patient results are in queue and will be send shortly');
                    }
                });
            }
        }

        vm.enableEmrIntegration = vm.clinic.emrIntegration != null && vm.clinic.emrIntegration.length > 0 && Principal.hasRole(ROLES.ROLE_ADMIN);

        function transition() {
            if (vm.dtInstance.reloadData) {
                CoreService.setStorage('filterPatient', vm.filterRes);

                vm.dtInstance.reloadData();
            }
        }

        function dtInstanceCallback(instance) {
            vm.dtInstance = instance;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardResultController', DashboardResultController);

    DashboardResultController.$inject = ['$compile', '$scope', 'filterRes', 'moment', 'PatientResultFile',
        'CoreService', 'PatientResult', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function DashboardResultController($compile, $scope, filterRes, moment, PatientResultFile,
                                       CoreService, PatientResult, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter) {

        var vm = this;

        vm.patientResults = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.filterRes = filterRes;
        vm.clinic = CoreService.getCurrentClinic();

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.patientResults);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                PatientResult[vm.filterRes.status]({id: vm.clinic.id}, function (result) {
                    vm.patientResults = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patientResults, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withOption('aaSorting', []).withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Patient').renderWith(function (data, type, full) {
                return data.patientName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.accessionNumber ? data.accessionNumber : '';
            }),
            DTColumnBuilder.newColumn('status').withTitle('Status'),
            DTColumnBuilder.newColumn(null).withTitle('Result Date').renderWith(function (data, type, full) {
                return moment(data.createdDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('').withTitle('').withOption('width', '155px').notSortable()
                .renderWith(abnormalHtml),
            DTColumnBuilder.newColumn('').withTitle('').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function abnormalHtml(data, type, full, meta) {
            if (full.abnormal) {
                return GUIUtils.getStatusTemplate('ABNORMAL', 'danger');
            } else {
                return GUIUtils.getStatusTemplate('NORMAL', 'success');
            }
        }

        function actionsHtml(data, type, full, meta) {
            return '<div>' +
                '<div class="btn-group" uib-dropdown>' +
                '<button type="button" class="btn btn-default" ng-click="vm.getPDF(' + full.id + ')">View PDF</button>' +
                '<button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle ng-disabled="disabled" data-toggle="dropdown" aria-expanded="false">' +
                '<span class="caret"></span>' +
                '<span class="sr-only">Toggle Dropdown</span>' +
                '</button>' +
                '<ul class="dropdown-menu" uib-dropdown-menu role="menu">' +
                '<li><a ui-sref="latest-result-det({id:' + full.id + '})">Details</a></li>' +
                '</ul>' +
                '</div></div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        vm.getPDF = function (id) {
            PatientResultFile.getByPatientResult(id);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultDeleteController',PatientResultDeleteController);

    PatientResultDeleteController.$inject = ['dialogs', 'PatientResult', 'toastr'];

    function PatientResultDeleteController($dialogs, PatientResult, toastr) {
        var vm = this;

        vm.barcode = "";

        vm.deleteResult = deleteResult;

        function deleteResult() {
            var dlg = $dialogs.confirm('Please Confirm','Do you want to delete this patient result?', {size: 'md'});

            dlg.result.then(function(btn){
                PatientResult.byBarcode({barcode: vm.barcode}, function (result) {
                    PatientResult.delete({id: result.id}, function () {
                        vm.barcode = "";

                        toastr.success('Delete successfully!');
                    });
                });
            },function(btn) {
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultByPatientController', PatientResultByPatientController);

    PatientResultByPatientController.$inject = ['$compile', '$scope', 'PatientResult', 'entity', 'filterRes', 'moment',
        'PatientResultSearch', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', 'PatientResultFile'];

    function PatientResultByPatientController($compile, $scope, PatientResult, entity, filterRes, moment,
                                              PatientResultSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, PatientResultFile) {
        var vm = this;

        vm.patientResults = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.patient = entity;
        vm.filterRes = filterRes;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.patientResults);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                PatientResult.byPatient({id: vm.patient.id}, function (result) {
                    vm.patientResults = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patientResults, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withOption('aaSorting', [[3, 'desc']])
            .withDOM('tip')
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.accessionNumber ? data.accessionNumber : '';
            }),
            DTColumnBuilder.newColumn('status').withTitle('Status'),
            DTColumnBuilder.newColumn(null).withTitle('Collection Date').renderWith(function (data, type, full) {
                return moment(data.collectionDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Result Date').renderWith(function (data, type, full) {
                return moment(data.createdDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('').withTitle('').withOption('width', '155px').notSortable()
                .renderWith(abnormalHtml),
            DTColumnBuilder.newColumn('').withTitle('').withOption('width', '220px').notSortable()
                .renderWith(actionsHtml),
        ];

        function abnormalHtml(data, type, full, meta) {
            if (full.abnormalRange) {
                return GUIUtils.getStatusTemplate('ABNORMAL', 'danger');
            } else {
                return GUIUtils.getStatusTemplate('NORMAL', 'success');
            }
        }

        function actionsHtml(data, type, full, meta) {
            return '<div>' +
                '<div class="btn-group" uib-dropdown>' +
                '<button type="button" class="btn btn-default" ng-click="vm.getRangePDF(' + full.id + ')">Range PDF</button>' +
                // '<button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle ng-disabled="disabled" data-toggle="dropdown" aria-expanded="false">' +
                // '<span class="caret"></span>' +
                // '<span class="sr-only">Toggle Dropdown</span>' +
                // '</button>' +
                // '<ul class="dropdown-menu" uib-dropdown-menu role="menu">' +
                // '<li><a ui-sref="patient-result-details({rid:' + full.id + '})">Details</a></li>' +
                // '<li><a ng-click="vm.getPDF(' + full.id + ')">View PDF</a></li>' +
                // '</ul>' +
                '</div></div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        vm.popoverFilterEnable = popoverFilterEnable;
        vm.showFilter = false;

        function popoverFilterEnable() {
            vm.showFilter = !vm.showFilter;
        }

        vm.isFilter = false;
        vm.filter = filter;

        function filter() {
            vm.isFilter = true;

            var must = [];
            must.push({term: {"order.patient.id": vm.patient.id}});
            must.push({term: {"delStatus": false}});

            if (vm.filterRes.status != null && vm.filterRes.status.length > 0) {
                must.push({match: {status: {query: vm.filterRes.status}}});
            }

            if (vm.filterRes.abnormal != null && vm.filterRes.abnormal.length > 0) {
                must.push({match: {abnormal: {query: vm.filterRes.abnormal}}});
            }

            if (vm.filterRes.start) {
                must.push({range: {createdDate: {gte: vm.filterRes.start}}});
            }

            if (vm.filterRes.end) {
                var end = new Date(vm.filterRes.end);
                end.setHours(23, 59, 59);
                must.push({range: {createdDate: {lte: end}}});
            }

            PatientResultSearch.query(
                {
                    query: {
                        bool: {
                            must: must
                        }
                    }
                }, function (result) {
                    vm.patientResults = result;
                    vm.dtInstance.reloadData();
                });
        }

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;

        vm.openCalendar = openCalendar;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.clear = clear;

        function clear() {
            vm.filterRes = {
                patientName: null,
                start: null,
                end: null,
                abnormal: null,
                status: null
            };

            vm.isFilter = false;
            vm.dtInstance.reloadData();
        }

        vm.getPDF = function (id) {
            PatientResultFile.getByPatientResult(id);
        }

        vm.getRangePDF = function (id) {
            PatientResultFile.getAllInOneRangePdf({ids: [id]});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('latest-result', {
                parent: 'entity',
                url: '/latest-result',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Latest Results'
                },
                ncyBreadcrumb: {
                    label: 'Latest Results',
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/patient-result-latest.html',
                        controller: 'PatientResultLatestController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    filter: null
                },
                resolve: {
                    clinic: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentClinic();
                    }],
                    filterRes: ['$stateParams', 'CoreService', function ($stateParams, CoreService) {
                        if ($stateParams.filter) {
                            return CoreService.readPatientResultFilter($stateParams.filter)
                        } else {
                            var filterPatient = CoreService.getStorage('filterPatient');

                            if (filterPatient == undefined) {
                                return CoreService.initPatientResultFilter();
                            } else {
                                return CoreService.readPatientResultFromLocalStore(filterPatient);
                            }
                        }
                    }]
                }
            })
            .state('patient-result', {
                parent: 'patient-abs',
                url: '/platest-result',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Patient Results'
                },
                ncyBreadcrumb: {
                    label: 'Results',
                    parent: 'patient-detail'
                },
                views: {
                    'content@patient-abs': {
                        templateUrl: 'app/entities/patient-result/patient-result-by-patient.html',
                        controller: 'PatientResultByPatientController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterRes: function () {
                        return {
                            patientName: null,
                            start: null,
                            end: null,
                            abnormal: null,
                            status: null
                        }
                    }
                }
            })
            .state('dashboard-final-result', {
                parent: 'entity',
                url: '/dfresult',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Final Results'
                },
                ncyBreadcrumb: {
                    label: 'Final Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/patient-result-final-partial-dashboard.html',
                        controller: 'DashboardResultController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterRes: function () {
                        return {
                            status: 'final',
                            title: 'Final Results'
                        }
                    }
                }
            })
            .state('dashboard-partial-result', {
                parent: 'entity',
                url: '/dpresult',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Partial Results'
                },
                ncyBreadcrumb: {
                    label: 'Partial Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/patient-result-final-partial-dashboard.html',
                        controller: 'DashboardResultController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterRes: function () {
                        return {
                            status: 'partial',
                            title: 'Partial Results'
                        }
                    }
                }
            })
            .state('dashboard-critical-result', {
                parent: 'entity',
                url: '/dcresult',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Critical Results'
                },
                ncyBreadcrumb: {
                    label: 'Critical Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/patient-result-final-partial-dashboard.html',
                        controller: 'DashboardResultController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterRes: function () {
                        return {
                            status: 'critical',
                            title: 'Critical Results'
                        }
                    }
                }
            })
            .state('dashboard2-critical-result', {
                parent: 'entity',
                url: '/critical-results',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Critical Results'
                },
                ncyBreadcrumb: {
                    label: 'Critical Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/dashboard/patient-result-critical.html',
                        controller: 'PatientResultCriticalController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('dashboard2-critical-result.detail', {
                url: '/critical-result/detail',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/patient-result/patient-result-critical-dialog.html',
                        controller: 'PatientResultCriticalDetails',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            patientCriticalResult: ['PatientResult', '$stateParams', function (PatientResult, $stateParams) {
                                return PatientResult.get({id: $stateParams.oid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('dashboard2-critical-result', {"id": $stateParams.id}, {reload: 'dashboard2-critical-result'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('dashboard2-pending-result', {
                parent: 'entity',
                url: '/pending-results',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Pending Results'
                },
                ncyBreadcrumb: {
                    label: 'Pending Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/dashboard/patient-result-pending.html',
                        controller: 'PatientResultPendingController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('dashboard2-unassigned-results', {
                parent: 'entity',
                url: '/unassigned-results',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Unassigned Results'
                },
                ncyBreadcrumb: {
                    label: 'Unassigned Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/dashboard/patient-result-unassigned.html',
                        controller: 'PatientResultsUnassignedController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterRes: function () {
                        return {status: 'unassigned'}
                    }
                }

            })
            .state('dashboard-non-perform-result', {
                parent: 'entity',
                url: '/dnonperform',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Non Perform Results'
                },
                ncyBreadcrumb: {
                    label: 'Non Perform Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/patient-result-final-partial-dashboard.html',
                        controller: 'DashboardResultController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterRes: function () {
                        return {
                            status: 'nonperform',
                            title: 'Non Perform Results'
                        }
                    }
                }
            })
            .state('unassigned-result', {
                parent: 'entity',
                url: '/unassigned',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Unassigned Results'
                },
                ncyBreadcrumb: {
                    label: 'Final Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/patient-result-unassigned.html',
                        controller: 'UnassignedResultController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterRes: function () {
                        return {
                            status: 'PARTIAL'
                        }
                    },
                }
            })
            .state('trending', {
                parent: 'patient-abs',
                url: '/trending',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Trending Results'
                },
                ncyBreadcrumb: {
                    label: 'Results',
                    parent: 'patient-detail'
                },
                views: {
                    'content@patient-abs': {
                        templateUrl: 'app/entities/patient-result/patient-result-trending.html',
                        controller: 'PatientResultTrendingController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('maintenance-rgroup', {
                parent: 'entity',
                url: '/maintenance-rgroup',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Maintenance Report Group'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/maintenance-rgroup.html',
                        controller: 'MaintenanceRepGroupController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterRes: function () {
                        return {
                            start: null,
                            end: null,
                            clinics: []
                        }
                    },
                }
            })
            .state('maintenance-range', {
                parent: 'entity',
                url: '/maintenance-range',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Maintenance Range'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/maintenance-range.html',
                        controller: 'MaintenanceRangeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterRes: function () {
                        return {
                            start: null,
                            end: null,
                            clinics: []
                        }
                    },
                }
            })
            .state('dashboard-pending-result', {
                parent: 'entity',
                url: '/pending-result',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Pending Result'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/patient-result-pending.html',
                        controller: 'PendingResultController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterRes: function () {
                        return {
                            start: null,
                            end: null,
                            clinics: []
                        }
                    },
                }
            })
            .state('patient-result-update-dates', {
                parent: 'entity',
                url: '/patient-result-update-dates',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Update Patient Result Dates'
                },
                ncyBreadcrumb: {
                    label: 'Update Patient Result',
                    parent: 'latest-result'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/patient-result-update-dates.html',
                        controller: 'PatientResultUpdateDatesController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('patient-result-delete', {
                parent: 'entity',
                url: '/patient-result-delete',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Delete patient result'
                },
                ncyBreadcrumb: {
                    label: 'Delete patient result',
                    parent: 'entity'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/patient-result-delete.html',
                        controller: 'PatientResultDeleteController',
                        controllerAs: 'vm'
                    }
                }
            })

    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientResult', PatientResult);

    PatientResult.$inject = ['$resource', 'DateUtils', 'DataUtils'];

    function PatientResult ($resource, DateUtils, DataUtils) {
        var resourceUrl =  'api/patient-results/:id';

        function transformCountResponse(data) {
            if (data) {
                data = angular.fromJson(data);
                data = {value: data};
            }
            return data;
        }

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'byClinic': {url : "api/patient-results/by-clinic/:id/:shift/:days", method: 'GET', isArray: true},
            'byPatient': {url : "api/patient-results/by-patient/:id", method: 'GET', isArray: true,
                transformResponse:  function(data, headers) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertLocalDateFromServer(data.createdDate);
                    }
                    return data;
                }},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                        data.collectionData = DateUtils.convertLocalDateFromServer(data.collectionData);
                        data.reviewedOn = DateUtils.convertLocalDateFromServer(data.reviewedOn);
                    }
                    return data;
                }
            },
            'byBarcode': {
                url : "api/patient-results/barcode/:barcode/",
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                        data.collectionData = DateUtils.convertLocalDateFromServer(data.collectionData);
                        data.reviewedOn = DateUtils.convertLocalDateFromServer(data.reviewedOn);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    copy.collectionData = DateUtils.convertLocalDateToServer(copy.collectionData);
                    copy.reviewedOn = DateUtils.convertLocalDateToServer(copy.reviewedOn);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    copy.collectionData = DateUtils.convertLocalDateToServer(copy.collectionData);
                    copy.reviewedOn = DateUtils.convertLocalDateToServer(copy.reviewedOn);
                    return angular.toJson(copy);
                }
            },
            'final': {url : "api/dfresults/:id", method: 'GET', isArray: true},
            'partial': {url : "api/dpresults/:id", method: 'GET', isArray: true},
            'unassigned': {url : "api/patient-results/unassigned/:account/:assigned", method: 'GET', isArray: true},
            'assign': {
                url: 'api/patient-results/assign', method: 'POST', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'pending': {url: 'api/patient-results/pending/:id', method: 'GET', isArray: true},
            'deletePending': {url: 'api/patient-result/delete-pending', method: 'POST'},
            'deleteUnassigned': {url: 'api/patient-result/delete-unassigned', method: 'POST'},
            'test_order_by_barcode': {url: 'api/patient-order-tests/by-barcode/:barcode', method: 'GET', isArray: true},
            'critical': {url: 'api/patient-results/critical/:id/:acknowledge', method: 'GET', isArray: true},
            'get6M': {url: 'api/patient-result-dets/6M/:id/:detailId', method: 'GET', isArray: true},
            'countAbnormalNotReviewedLast7Days': {url: 'api/patient-results/count-abnormal-not-reviewed-last-7days/:id', method: 'GET', isArray: true},
            'markAsReviewed': {url: 'api/patient-result/mark-as-reviewed', method: 'POST'},
            'updateDates': {url: 'api/patient-results/update-dates', method: 'POST'},
            'acknowledge': {url: 'api/patient-result-dets/acknowledge', method: 'POST'},
            'nonperform': {url: 'api/patient-results/by-clinic/nonperform/:id', method: 'GET', isArray: true},
            'maintenanceRGroup': {url: 'api/patient-results/maintenance/rgroup', method: 'POST'},
            'maintenanceRange': {url: 'api/patient-results/maintenance/range', method: 'POST'},
            'countCriticals': {
                url: 'api/patient-results/count-criticals/:id', method: 'GET',
                transformResponse: transformCountResponse
            },
            'countPending': {
                url: 'api/patient-results/count-pending/:id', method: 'GET',
                transformResponse: transformCountResponse
            },
            'countUnassigned': {
                url: 'api/patient-results/count-unassigned/:account', method: 'GET',
                transformResponse: transformCountResponse
            },
            'countAbnormalNotReviewed': {
                url: 'api/patient-results/count-abnormal-not-reviewed/:id', method: 'GET',
                transformResponse: transformCountResponse
            },
            'sendToEmr': {
                url: 'api/patient-results/send-to-emr', method: 'POST', isArray: false
            },
            'getAllByFilter': {url: 'api/patient-results/filter', method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientResultSearch', PatientResultSearch);

    PatientResultSearch.$inject = ['$resource'];

    function PatientResultSearch($resource) {
        var resourceUrl =  'api/_search/patient-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MaintenanceRepGroupController', MaintenanceRepGroupController);

    MaintenanceRepGroupController.$inject = ['filterRes', 'Clinic', 'PatientResult', 'dialogs'];

    function MaintenanceRepGroupController(filterRes, Clinic, PatientResult, $dialogs) {
        var vm = this;

        vm.filterRes = filterRes;

        vm.clinics = Clinic.query();

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;

        vm.openCalendar = openCalendar;
        vm.save = save;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function save() {
            var dlg = $dialogs.confirm('Please Confirm','Reset all report group?', {size: 'md'});
            dlg.result.then(function(btn){
                vm.isSaving = true;
                PatientResult.maintenanceRGroup(vm.filterRes, onSaveSuccess, onSaveError);

                function onSaveSuccess(result) {
                    vm.isSaving = false;
                }

                function onSaveError() {
                    vm.isSaving = false;
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MaintenanceRangeController', MaintenanceRangeController);

    MaintenanceRangeController.$inject = ['filterRes', 'Clinic', 'PatientResult', 'dialogs'];

    function MaintenanceRangeController(filterRes, Clinic, PatientResult, $dialogs) {
        var vm = this;

        vm.filterRes = filterRes;

        vm.clinics = Clinic.query();

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;

        vm.openCalendar = openCalendar;
        vm.save = save;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function save() {
            var dlg = $dialogs.confirm('Please Confirm','Reset all result ranges?', {size: 'md'});
            dlg.result.then(function(btn){
                PatientResult.maintenanceRange(vm.filterRes, onSaveSuccess, onSaveError);

                function onSaveSuccess(result) {
                    vm.isSaving = false;
                }

                function onSaveError() {
                    vm.isSaving = false;
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultUnassignedDeleteDialog', PatientResultUnassignedDeleteDialog);

    PatientResultUnassignedDeleteDialog.$inject = ['$uibModalInstance', 'id', 'PatientResult', 'toastr'];

    function PatientResultUnassignedDeleteDialog($uibModalInstance, id, PatientResult, toastr) {
        var vm = this;

        vm.clear = clear;
        vm.deleteUnassignedResult = deleteUnassignedResult;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function deleteUnassignedResult() {
            PatientResult.deleteUnassigned({id: id.selected}, function () {
                $uibModalInstance.close(true);
                toastr.success('Delete operation successfully');
            }, function () {
                toastr.error('Delete operation fail');
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultsUnassignedController', PatientResultsUnassignedController);

    PatientResultsUnassignedController.$inject = ['$uibModal', '$compile', '$scope', 'moment', 'Patient', 'DateUtils',
        'CoreService', 'PatientResult', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter',
        '$rootScope', 'lodash', 'filterRes', 'toastr', 'PopupService', 'DataTablesService'];

    function PatientResultsUnassignedController($uibModal, $compile, $scope, moment, Patient, DateUtils, CoreService,
                                                PatientResult, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils,
                                                $filter, $rootScope, _, filterRes, toastr, PopupService, DataTablesService) {
        var vm = this;

        vm.patientResults = [];
        vm.dtInstance = {};
        vm.title = "Unassigned Results";
        vm.clinic = CoreService.getCurrentClinic();
        vm.patients = [];
        vm.patient = {};
        vm.selected = {};
        vm.selectAll = false;
        vm.filterRes = filterRes;
        vm.disableTitle = false;

        vm.search = search;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.assign = assign;
        vm.updateStatusButtonFilter = updateStatusButtonFilter;
        vm.details = details;
        vm.modalDeleteUnassignedResult = modalDeleteUnassignedResult;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)" ng-disabled="vm.disableTitle">';

        Patient.getAllByClinic({id: vm.clinic.id}, function (result) {
            vm.patients = result;

            _.forEach(vm.patients, function (patient) {
                var optMiddleInitial = patient.middleInitial ? ', ' + patient.middleInitial : '';
                patient.fullName = patient.lastName + ', ' + patient.firstName + optMiddleInitial;
            })
        });

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PatientResult.unassigned({
                    account: vm.clinic.account,
                    assigned: vm.filterRes.status
                }, function (result) {
                    vm.selected = {};
                    vm.selectAll = false;
                    vm.patient = {};
                    vm.patientResults = result;
                    vm.disableTitle = isTitleDisabled();
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patientResults, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withOption('aaSorting', [])
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                if (!full.assigned) {
                    vm.selected[full.id] = false;
                }
                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)" ng-disabled="' + data.assigned + '">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Patient').renderWith(function (data, type, full) {
                return data.patientName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return data ? moment(data.dob).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Result Date').renderWith(function (data, type, full) {
                return data ? moment(data.collectionDate).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(assignedStatusHtml),
            DTColumnBuilder.newColumn('').withTitle('Actions').withOption('width', '90px').notSortable()
                .withOption('class', 'col-btn').notSortable().renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="btn btn-default btn-sm details" uib-tooltip="See Details"' +
                ' ng-click="vm.details(' + full.id + ')">' +
                '   <i class="fa fa-external-link"></i></a>&nbsp;';

            stButtons += '<a uib-tooltip="Delete" class="btn btn-default btn-sm delete" ' +
                ' ng-click="vm.modalDeleteUnassignedResult(' + "'" + full.id + "'" + ')" ' +
                ' ng-show="' + !full.assigned + '">' +
                '   <i class="fa fa-trash" aria-hidden="true"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function assign() {
            var result = DataTablesService.getSelectedIds(vm.selected);

            if (result.length > 0) {
                vm.isSaving = true;
                PatientResult.assign({
                    ids: result, patientId: vm.patient.id
                }, function (result) {
                    if (result.length > 0) {
                        toastr.error('Assign operation fail');
                    } else {
                        toastr.success('Assign operation successfully');
                    }

                    vm.dtInstance.reloadData();
                    vm.isSaving = false;
                }, function () {
                    toastr.error('Assign operation fail');
                    vm.isSaving = false;
                });
            }
        }

        function assignedStatusHtml(data, type, full) {
            var assignedStatus = data.assigned ? {label: 'Assigned', template: 'success'}
                : {label: 'Unassigned', template: 'danger'};

            return GUIUtils.getStatusTemplate(assignedStatus.label, assignedStatus.template);
        }

        function updateStatusButtonFilter(status) {
            vm.filterRes.status = status;

            vm.dtInstance.reloadData();
        }

        function isTitleDisabled() {
            return !_.some(vm.patientResults, function (patient) {
                return _.isNull(patient.patientId);
            });
        }

        function details(id) {
            PopupService.showPatientResultDetPopup(id);
        }

        function modalDeleteUnassignedResult(id) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-result/dashboard/patient-result-unassigned-delete-dialog.html',
                controller: 'PatientResultUnassignedDeleteDialog',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    id: {selected: id}
                }
            }).result.then(function () {
                vm.dtInstance.reloadData();
            }, function (result) {
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultSignDialogController', PatientResultSignDialogController);

    PatientResultSignDialogController.$inject = ['$uibModalInstance'];

    function PatientResultSignDialogController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultPendingDeleteDialog', PatientResultPendingDeleteDialog);

    PatientResultPendingDeleteDialog.$inject = ['$uibModalInstance', 'barcodes', 'PatientResult', 'toastr'];

    function PatientResultPendingDeleteDialog($uibModalInstance, barcodes, PatientResult, toastr) {
        var vm = this;

        vm.clear = clear;
        vm.deletePendingResult = deletePendingResult;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function deletePendingResult() {
            vm.isSaving = true;
            PatientResult.deletePending({barcodes: barcodes.selected}, function () {
                $uibModalInstance.close(true);
                toastr.success('Delete operation successfully');
                vm.isSaving = false;
            }, function () {
                toastr.error('Delete operation fail');
                vm.isSaving = false;
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultPendingController', PatientResultPendingController);

    PatientResultPendingController.$inject = ['CoreService', 'PatientResult', '$scope', '$compile', '$q', 'PatientBarcode',
        'DTColumnBuilder', 'DTOptionsBuilder', 'moment', '$filter', '$rootScope', '$uibModal', 'lodash', 'PopupService', 'DataTablesService'];

    function PatientResultPendingController(CoreService, PatientResult, $scope, $compile, $q, PatientBarcode,
                                            DTColumnBuilder, DTOptionsBuilder, moment, $filter, $rootScope, $uibModal, _, PopupService, DataTablesService) {
        var vm = this;
        vm.patientResults = [];

        vm.dtInstance = {};
        vm.title = "Pending Results";
        vm.clinic = CoreService.getCurrentClinic();
        vm.selected = {};
        vm.selectAll = false;

        vm.search = search;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.modalPendingResults = modalPendingResults;
        vm.modalDeletePendingResult = modalDeletePendingResult;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PatientResult.pending({id: vm.clinic.id}, function (result) {
                    vm.selected = {};
                    vm.selectAll = false;

                    vm.patientResults = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patientResults, vm.searchQuery, undefined));
            }
            return defer.promise;
        })
            .withPaginationType('full_numbers')
            .withBootstrap()
            .withOption('aaSorting', [])
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.groupNumberId] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + "'" + full.groupNumberId + "'" + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Patient').renderWith(function (data, type, full) {
                return data.firstName + ' ' + data.middleInitial + ' ' + data.lastName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return data ? moment(data.dob).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn('groupNumberId').withTitle('Specimen ID'),
            DTColumnBuilder.newColumn(null).withTitle('Collection Date').renderWith(function (data, type, full) {
                return data ? moment(data.collectedDate).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '90px').withOption('class', 'col-btn').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a uib-tooltip="See Details" class="btn btn-default btn-sm details" ng-click="vm.modalPendingResults(' + "'" + full.groupNumberId + "'" + ')">' +
                '   <i class="fa fa-external-link" aria-hidden="true"></i></a>&nbsp;';

            stButtons += '<a uib-tooltip="Cancel Requisition" class="btn btn-default btn-sm delete" ng-click="vm.modalDeletePendingResult(' + "'" + full.groupNumberId + "'" + ')">' +
                '   <i class="fa fa-trash" aria-hidden="true"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function modalPendingResults(groupNumberId) {
            PopupService.showPatientBarcodePopup(groupNumberId);
        }

        function modalDeletePendingResult(barcodes) {
            if (barcodes) {
                barcodes = [barcodes];
            } else {
                barcodes = DataTablesService.getSelectedIds(vm.selected);
            }

            $uibModal.open({
                templateUrl: 'app/entities/patient-result/dashboard/patient-result-pending-delete-dialog.html',
                controller: 'PatientResultPendingDeleteDialog',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    barcodes: {selected: barcodes}
                }
            }).result.then(function () {
                vm.dtInstance.reloadData();
            }, function (result) {
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultCriticalDialogController', PatientResultCriticalDialogController);

    PatientResultCriticalDialogController.$inject = ['$uibModalInstance', 'result', 'PatientResultDet', 'PatientResult', 'lodash'];

    function PatientResultCriticalDialogController($uibModalInstance, result, PatientResultDet, PatientResult, _) {
        var vm = this;

        vm.criticalResult = result;
        vm.comments = PatientResultDet.getComments({id: result.id});
        vm.testResult =  result.result + ' (' + result.status + ')';
        vm.acknowledgeBy = result.name + ' ' + result.lastName;

        vm.clear = clear;
        vm.acknowledge = acknowledge;

        PatientResultDet.getEmployeeComments({id: result.id}, function (comments) {
            vm.prDetEmployeeComments = comments;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function acknowledge() {
            PatientResult.acknowledge({ids: [result.id]}, function () {
                $uibModalInstance.dismiss('success')
            }, function () {
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultCriticalChartDialogController', PatientResultCriticalChartDialogController);

    PatientResultCriticalChartDialogController.$inject = ['$uibModalInstance', 'result', 'PatientResult', 'lodash', 'moment'];

    function PatientResultCriticalChartDialogController($uibModalInstance, result, PatientResult, _, moment) {
        var vm = this;

        vm.criticalResult = result;
        vm.testResult = result.result + ' (' + result.status + ')';
        vm.acknowledgeBy = result.name + ' ' + result.lastName;

        vm.clear = clear;
        vm.getResults = getResults;
        vm.acknowledge = acknowledge;

        getResults();

        function getResults() {
            PatientResult.get6M({
                id: result.patientId, detailId: result.id
            }, function (results) {
                _.forEach(results, function (result) {
                    vm.labels.push(moment(result.date).format('MM/DD/YYYY'));
                    vm.data[0].push(result.result);
                    var style = getPointStyle(result);
                    vm.colors[0].pointBackgroundColor.push(style.pointBackgroundColor);
                    vm.colors[0].pointRadius.push(style.pointRadius)
                });
            });
        };

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function acknowledge () {
            PatientResult.acknowledge({ids: [result.id]}, function () {
                $uibModalInstance.close(true);
            }, function () {
            })
        };

        vm.labels = [];
        vm.series = ['Results'];
        vm.data = [
            []
        ];
        vm.datasetOverride = [{ yAxisID: 'y-axis-1' }, { yAxisID: 'y-axis-2'}];
        vm.options = {
            scales: {
                yAxes: [
                    {
                        id: 'y-axis-1',
                        type: 'linear',
                        display: true,
                        position: 'left'
                    }
                ]
            }
        };
        vm.colors = [{
            fillColor: "rgba(151,187,205,0.2)",
            strokeColor: "rgba(151,187,205,1)",
            pointColor: "rgba(151,187,205,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#fff",
            pointHighlightStroke: "rgba(151,187,205,1)",
            pointBackgroundColor: [],
            pointRadius: []
        }];

        function getPointStyle(result) {
            switch (result.status) {
                case 'LL':
                case 'HH': return {pointBackgroundColor : 'red', pointRadius: 12};
                case 'L':
                case 'H': return {pointBackgroundColor : 'blue', pointRadius: 10};
                default : return {pointBackgroundColor : 'green', pointRadius: 6};
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultCriticalAlertDialogController', PatientResultCriticalAlertDialogController);

    PatientResultCriticalAlertDialogController.$inject = ['$uibModalInstance', 'criticals'];

    function PatientResultCriticalAlertDialogController($uibModalInstance, criticals) {
        var vm = this;

        vm.clear = clear;
        vm.criticals = criticals;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultCriticalController', PatientResultCriticalController);

    PatientResultCriticalController.$inject = ['CoreService', 'PatientResult', '$scope', '$compile', '$q',
        'DTColumnBuilder', 'DTOptionsBuilder', 'moment', '$filter', '$rootScope', '$uibModal', 'lodash', 'GUIUtils', 'DataTablesService'];

    function PatientResultCriticalController(CoreService, PatientResult, $scope, $compile, $q,
                                             DTColumnBuilder, DTOptionsBuilder, moment, $filter, $rootScope, $uibModal, _, GUIUtils, DataTablesService) {
        var vm = this;

        vm.patientResults = [];

        vm.dtInstance = {};
        vm.title = "Critical Results";
        vm.clinic = CoreService.getCurrentClinic();
        vm.selected = {};
        vm.selectAll = false;
        vm.acknowledgeFilter = 'Unacknowledged';
        vm.disableTitle = false;

        vm.search = search;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.modalCriticalResultDetails = modalCriticalResultDetails;
        vm.modalCriticalResultChart = modalCriticalResultChart;
        vm.modalCriticalResultCreateDetEmployeeComment = modalCriticalResultCreateDetEmployeeComment;
        vm.acknowledge = acknowledge;
        vm.updateAcknowledgeButtonFilter = updateAcknowledgeButtonFilter;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)" ng-disabled="vm.disableTitle">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PatientResult.critical({
                    id: vm.clinic.id,
                    acknowledge: vm.acknowledgeFilter
                }, function (result) {
                    vm.selected = {};
                    vm.selectAll = false;
                    vm.patientResults = result;
                    vm.disableTitle = !enableTitle();
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patientResults, vm.searchQuery, undefined));
            }
            return defer.promise;
        })
            .withPaginationType('full_numbers')
            .withBootstrap()
            .withOption('aaSorting', [])
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                if (!data.isAcknowledge) vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)" ng-disabled=' + data.isAcknowledge + '>';
            }),
            DTColumnBuilder.newColumn('patientName').withTitle('Patient'),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return data ? moment(data.dob).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn('barcode').withTitle('Specimen ID'),
            DTColumnBuilder.newColumn(null).withTitle('Collection Date').renderWith(function (data, type, full) {
                return data ? moment(data.collectionDate).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn('testName').withTitle('Test Name'),
            DTColumnBuilder.newColumn(null).withTitle('Result').renderWith(function (data, type, full) {
                return GUIUtils.getStatusTemplate(data.result + ' ' + data.status, 'danger');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(statusHtml),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('class', 'col-btn').withOption('width', '90px').notSortable()
                .renderWith(actionsHtml)
        ];

        function statusHtml(data, type, full, meta) {
            if (!full.isAcknowledge) {
                return GUIUtils.getStatusTemplate("Unacknowledged", 'danger');
            } else {
                return GUIUtils.getStatusTemplate("Acknowledge", 'success');
            }
        }

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a uib-tooltip="See Graph" class="btn btn-default btn-sm see-chart" ng-click="vm.modalCriticalResultChart(' + full.id + ')">' +
                '   <i class="fa fa-bar-chart" aria-hidden="true"></i></a>&nbsp;';

            stButtons += '<a uib-tooltip="See Details" class="btn btn-default btn-sm details" ng-click="vm.modalCriticalResultDetails(' + full.id + ')">' +
                '   <i class="fa fa-external-link" aria-hidden="true"></i></a>&nbsp;';

            stButtons += '<a uib-tooltip="Add Comment" class="btn btn-default btn-sm" ng-click="vm.modalCriticalResultCreateDetEmployeeComment(' + full.id + ')">' +
                '   <i class="fa fa-plus" aria-hidden="true"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function acknowledge() {
            var criticalResults = DataTablesService.getSelectedIds(vm.selected);

            if (criticalResults.length > 0) {
                vm.isSaving = true;
                PatientResult.acknowledge({ids: criticalResults}, function () {
                    vm.dtInstance.reloadData();
                    vm.isSaving = false;
                });
            }
        }

        function updateAcknowledgeButtonFilter(acknowledge) {
            vm.acknowledgeFilter = acknowledge;

            vm.dtInstance.reloadData();
        }

        function modalCriticalResultDetails(id) {
            var criticalResult = _.filter(vm.patientResults, {'id': id});

            $uibModal.open({
                templateUrl: 'app/entities/patient-result/dashboard/patient-result-critical-dialog.html',
                controller: 'PatientResultCriticalDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    result: criticalResult[0]
                }
            }).result.then(function () {
                vm.dtInstance.reloadData();
            }, function (result) {
                vm.dtInstance.reloadData();
            });
        }

        function modalCriticalResultChart(id) {
            var criticalResult = _.filter(vm.patientResults, {'id': id});

            $uibModal.open({
                templateUrl: 'app/entities/patient-result/dashboard/patient-result-critical-chart-dialog.html',
                controller: 'PatientResultCriticalChartDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    result: criticalResult[0]
                }
            }).result.then(function () {
                vm.dtInstance.reloadData();
            }, function (result) {
            });
        }

        function modalCriticalResultCreateDetEmployeeComment(id) {
            $uibModal.open({
                templateUrl: 'app/entities/pr-det-employee-comment/pr-det-employee-comment-dialog.html',
                controller: 'PRDetEmployeeCommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    prDetEmployeeComment: {
                        comment: null,
                        patientResultDetId: id,
                        employeeId: null,
                        id: null
                    }
                }
            }).result.then(function () {
            }, function (result) {
            });
        }

        function enableTitle() {
            return _.some(vm.patientResults, function (result) {
                return result.isAcknowledge == false;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientPictureDialogController', PatientPictureDialogController);

    PatientPictureDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatientPicture'];

    function PatientPictureDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatientPicture) {
        var vm = this;

        vm.patientPicture = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.patientPicture.id !== null) {
                PatientPicture.update(vm.patientPicture, onSaveSuccess, onSaveError);
            } else {
                PatientPicture.save(vm.patientPicture, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:patientPictureUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientPictureDetailController', PatientPictureDetailController);

    PatientPictureDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PatientPicture'];

    function PatientPictureDetailController($scope, $rootScope, $stateParams, previousState, entity, PatientPicture) {
        var vm = this;

        vm.patientPicture = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:patientPictureUpdate', function(event, result) {
            vm.patientPicture = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientPictureDeleteController',PatientPictureDeleteController);

    PatientPictureDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientPicture'];

    function PatientPictureDeleteController($uibModalInstance, entity, PatientPicture) {
        var vm = this;

        vm.patientPicture = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientPicture.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-picture', {
            parent: 'entity',
            url: '/patient-picture',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PatientPictures'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-picture/patient-pictures.html',
                    controller: 'PatientPictureController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('patient-picture-detail', {
            parent: 'entity',
            url: '/patient-picture/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PatientPicture'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-picture/patient-picture-detail.html',
                    controller: 'PatientPictureDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PatientPicture', function($stateParams, PatientPicture) {
                    return PatientPicture.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'patient-picture',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('patient-picture-detail.edit', {
            parent: 'patient-picture-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-picture/patient-picture-dialog.html',
                    controller: 'PatientPictureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientPicture', function(PatientPicture) {
                            return PatientPicture.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-picture.new', {
            parent: 'patient-picture',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-picture/patient-picture-dialog.html',
                    controller: 'PatientPictureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                picture: null,
                                picture_content_type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patient-picture', null, { reload: 'patient-picture' });
                }, function() {
                    $state.go('patient-picture');
                });
            }]
        })
        .state('patient-picture.edit', {
            parent: 'patient-picture',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-picture/patient-picture-dialog.html',
                    controller: 'PatientPictureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientPicture', function(PatientPicture) {
                            return PatientPicture.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-picture', null, { reload: 'patient-picture' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-picture.delete', {
            parent: 'patient-picture',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-picture/patient-picture-delete-dialog.html',
                    controller: 'PatientPictureDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatientPicture', function(PatientPicture) {
                            return PatientPicture.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-picture', null, { reload: 'patient-picture' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientPicture', PatientPicture);

    PatientPicture.$inject = ['$resource'];

    function PatientPicture ($resource) {
        var resourceUrl =  'api/patient-pictures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientPictureSearch', PatientPictureSearch);

    PatientPictureSearch.$inject = ['$resource'];

    function PatientPictureSearch($resource) {
        var resourceUrl =  'api/_search/patient-pictures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientPictureController', PatientPictureController);

    PatientPictureController.$inject = ['$scope', '$state', 'PatientPicture', 'PatientPictureSearch'];

    function PatientPictureController ($scope, $state, PatientPicture, PatientPictureSearch) {
        var vm = this;

        vm.patientPictures = [];
        vm.search = search;
        vm.loadAll = loadAll;

        function loadAll() {
            PatientPicture.query(function(result) {
                vm.patientPictures = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PatientPictureSearch.query({query: vm.searchQuery}, function(result) {
                vm.patientPictures = result;
            });
        }    }
})();

(function () {
   'use strict';
    angular
       .module('dialysisApp')
       .controller('PatientOrderWizardDialogController', PatientOrderWizardDialogController);

    PatientOrderWizardDialogController.$inject = ['$uibModalInstance', '$scope', '$state', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', '$filter', '$compile', 'GUIUtils'];

    function PatientOrderWizardDialogController($uibModalInstance, $scope, $state, $q, DTColumnBuilder,
                                                DTOptionsBuilder, $filter, $compile, GUIUtils) {
        var vm = this;

        vm.clear = clear;

        vm.onFinishWizard = onFinishWizard;
        vm.onCancelWizard = onCancelWizard;
        vm.renderRow = false;

        vm.dummy = [];
        vm.searchQuery = "";
        vm.dtInstance = {};
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';
        vm.search = search;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        vm.getSelectedIds = getSelectedIds;
        vm.selected = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                vm.dummy = dummy();
                defer.resolve(vm.dummy);
            } else {
                defer.resolve($filter('filter')(vm.dummy, vm.searchQuery, undefined));
            }
            return defer.promise;
        })
        .withPaginationType('full_numbers')
        .withBootstrap()
        .withDOM('ltp')
        .withLanguage({
            "paginate": {
                "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
            }
        })
        .withOption('aaSorting', [[0, 'desc'], [1, 'asc']])
        .withOption('headerCallback', function (header) {
            if (!vm.headerCompiled) {
                vm.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        })
        .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
        .withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            }
        );

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return data.date ? moment(data.date).format($scope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn('gender').withTitle('Gender'),
            DTColumnBuilder.newColumn('diabetic').withTitle('Diabetic')
        ];

        function dummy() {
            return [
                {id: 1, name: 'Epifanio Goldenberg', date: new Date(), gender: 'Male', diabetic: 'YES'},
                {id: 2, name: 'Gruttenger Aran', date: new Date(), gender: 'Female', diabetic: 'YES'},
                {id: 3, name: 'Magnus Northenfield', date: new Date(), gender: 'Male', diabetic: 'YES'},
                {id: 4, name: 'Mathias Perez', date: new Date(), gender: 'Male', diabetic: 'NO'},
                {id: 5, name: 'Sergay Fucker', date: new Date(), gender: 'Male', diabetic: 'YES'},
                {id: 6, name: 'Masseratti Aronian', date: new Date(), gender: 'Female', diabetic: 'NO'},
                {id: 7, name: 'Pericoldio Energizer', date: new Date(), gender: 'Female', diabetic: 'YES'},
                {id: 8, name: 'Dopperganger Estroncio', date: new Date(), gender: 'Other', diabetic: 'NO'},
                {id: 9, name: 'Astenerte Macedonio', date: new Date(), gender: 'Female', diabetic: 'YES'},
                {id: 10, name: 'Costrance Gasteroide', date: new Date(), gender: 'Male', diabetic: 'NO'}
            ]
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }
            vm.selectAll = true;
        }

        function getSelectedIds() {
            var ids = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    ids.push(id);
                }
            }

            return ids;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.enableDetails = function enableDetails($event) {
            var t = angular.element($event.currentTarget);
            t.parent().parent().toggleClass('hideDetails');
        };

        $scope.showDescription = function showDescription($event) {
            var t = angular.element($event.currentTarget);
            t.parent().parent().toggleClass('hideDescription');
        };

        function onFinishWizard() {

        }

        function onCancelWizard() {

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('order-wizard', {
                parent: 'entity',
                url: '/order-wizard',
                ncyBreadcrumb: {
                    label: 'Orders'
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Orders'
                },
                params: {

                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-order-wizard/patient-order-wizard.html',
                        controller: 'PatientOrderWizardController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderWizardController', PatientOrderWizardController);

    PatientOrderWizardController.$inject = ['$uibModal'];

    function PatientOrderWizardController($uibModal) {
        var vm = this;

        vm.title = 'Orders';
        vm.entityClassHumanized = 'Orders';
        vm.entityStateName = 'order-wizard';

        vm.openWizard = openWizard;

        function openWizard() {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order-wizard/patient-order-wizard-dialog.html',
                controller: 'PatientOrderWizardDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {

                }
            }).result.then(function () {

            }, function (result) {

            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderNewTemplateController', PatientOrderNewTemplateController);

    PatientOrderNewTemplateController.$inject = ['$scope', '$compile', '$state', 'patientOrderTpl', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', 'ROLES',
        'CoreService', 'OrderFrequency', 'PatientOrderTpl', 'Via', 'Employee', '$uibModal', '$stateParams', 'Principal', 'Corporation', 'Compendium', 'AlertService'];

    function PatientOrderNewTemplateController($scope, $compile, $state, patientOrderTpl, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, ROLES,
                                               CoreService, OrderFrequency, PatientOrderTpl, Via, Employee, $uibModal, $stateParams, Principal, Corporation, Compendium, AlertService) {

        var vm = this;

        vm.patientOrderTpl = patientOrderTpl;
        vm.patientOrder = patientOrderTpl.patientOrderJson;

        vm.form = {};
        vm.save = save;
        vm.vias = Via.query();
        vm.employees = [];

        if (Principal.hasRole(ROLES.ROLE_ADMIN)) {
            vm.corporations = Corporation.query();
        } else {
            vm.employees = Employee.employeeCorpPhysicians();
            vm.corporations = [CoreService.getCurrentEmployee().corporation];
            vm.corporations = [CoreService.getCurrentEmployee().corporation];
            vm.patientOrderTpl.corporation = CoreService.getCurrentEmployee().corporation;
            vm.patientOrder.corporation = CoreService.getCurrentEmployee().corporation;
        }

        if ($stateParams.clone) {
            vm.patientOrderTpl.id = null;
        }

        vm.orderfrequencies = [];
        vm.compendiumErrors = [];

        function save() {
            vm.isSaving = true;

            vm.patientOrderTpl.patientOrderJson = vm.patientOrder;
            vm.patientOrderTpl.via = vm.patientOrder.via;
            vm.patientOrderTpl.orderType = vm.patientOrder.orderType;
            vm.patientOrderTpl.signedBy = vm.patientOrder.signedBy;
            vm.patientOrderTpl.corporation = vm.patientOrder.corporation;

            vm.isSaving = true;
            if (vm.patientOrderTpl.id !== null) {
                PatientOrderTpl.update(vm.patientOrderTpl, onSaveSuccess, onSaveError);
            } else {
                PatientOrderTpl.save(vm.patientOrderTpl, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            $state.go("patient-order-tpl");
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        changeOrderType();
        vm.changeOrderType = changeOrderType;

        function changeOrderType() {
            vm.orderfrequencies = OrderFrequency.byordertype({orderType: vm.patientOrder.orderType}).$promise.then(function (data) {
                vm.orderfrequencies = data;
            });
        }

        vm.addPatientOrderTest = function () {
            var test = {
                renal: false,
                id: null,
                orderFrequency: vm.orderfrequencies[0],
                diagnoses: []
            };

            vm.popupTest(test, -1);
        };

        vm.editPatientOrderTest = function (index) {
            vm.popupTest(vm.patientOrder.patientOrderTests[index], index);
        };

        vm.deletePatientOrderTest = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order-test/patient-order-test-delete-dialog.html',
                controller: 'PatientOrderTestDeleteNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: {id: index}
                }
            }).result.then(function () {
                vm.patientOrder.patientOrderTests.splice(index, 1);

                vm.dtInstance.reloadData();
            }, function () {
            });
        };

        vm.showICD10 = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/diagnosis/diagnosis-dialog.html',
                controller: 'DiagnosisDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: vm.patientOrder.patientOrderTests[index]
                }
            });
        };

        vm.popupTest = function (patientOrderTest, index) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order-tpl/patient-order-test-tpl-new-dialog.html',
                controller: 'PatientOrderTestTplNewDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    patientOrder: vm.patientOrder,
                    patientOrderTest: patientOrderTest,
                }
            }).result.then(function (result) {
                if (index < 0) {
                    vm.patientOrder.patientOrderTests.push(result.patientOrderTest);
                } else {
                    vm.patientOrder.patientOrderTests[index] = result.patientOrderTest;
                }
                vm.dtInstance.reloadData();
            }, function () {
            });
        };

        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            vm.compendiumErrors = [];
            var compendiums = _.map(vm.patientOrder.patientOrderTests, 'compendium');

            Compendium.check({compendiums: compendiums}, function (result) {
                if (result.compendiums.length > 0) {
                    _.forEach(result.compendiums, function (compendium) {
                        return vm.compendiumErrors.push(compendium.code);
                    });
                }

                defer.resolve(vm.patientOrder.patientOrderTests);
            });

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('paging', false).withOption('aaSorting', []).withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Test').renderWith(function (data, type, full) {
                return (vm.compendiumErrors.indexOf(data.compendium.code) == -1 ? data.compendium.code : '<span class="label label-danger">' + data.compendium.code + '</span>');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.compendium.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Frequency').renderWith(function (data, type, full) {
                return data.orderFrequency.name;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Diagnosis (ICD10)').renderWith(function (data, type, full, meta) {
                return data.diagnoses != null && data.diagnoses.length == 1 ? data.diagnoses[0].icd10Code : data.diagnoses[0].icd10Code + showICD10Html(meta.row);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Renal').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.renal);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ng-click="vm.editPatientOrderTest(' + meta.row + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';
            stButtons += '<a class="btn-sm btn-danger" ng-click="vm.deletePatientOrderTest(' + meta.row + ')">' +
                '   <i class="fa fa-trash"></i></a>';

            return stButtons;
        };

        function showICD10Html(row) {
            return '&nbsp;&nbsp;<a class="btn-sm btn-info" ng-click="vm.showICD10(' + row + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderTplDeleteController',PatientOrderTplDeleteController);

    PatientOrderTplDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientOrderTpl'];

    function PatientOrderTplDeleteController($uibModalInstance, entity, PatientOrderTpl) {
        var vm = this;

        vm.tpl = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientOrderTpl.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('patient-order-tpl', {
                parent: 'entity',
                url: '/patient-order-tpl',
                ncyBreadcrumb: {
                    label: 'Patient Order Templates'
                },
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Order Templates'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-order-tpl/patient-order-tpl.html',
                        controller: 'PatientOrderTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('patient-order-tpl.new', {
                url: '/new',
                ncyBreadcrumb: {
                    label: 'New Order Template'
                },
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'New Patient Order Template'
                },
                params: {
                    orderType: 'ONE_TIME',
                    clone: false
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-order-tpl/patient-order-tpl-new.html',
                        controller: 'PatientOrderNewTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    patientOrderTpl: ['$stateParams', function ($stateParams) {
                        return {
                            patientOrderJson: {
                                orderType: $stateParams.orderType,
                                id: null,
                                patientOrderTests: [],
                                ordStatus: 'SCHEDULED'
                            }
                        };
                    }],
                }
            })
            .state('patient-order-tpl.edit', {
                parent: 'patient-order-tpl',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                params: {
                    orderType: 'ONE_TIME',
                    clone: false
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-order-tpl/patient-order-tpl-new.html',
                        controller: 'PatientOrderNewTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    patientOrderTpl: ['$stateParams', 'PatientOrderTpl', function ($stateParams, PatientOrderTpl) {
                        return PatientOrderTpl.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('patient-order-tpl.delete', {
                parent: 'patient-order-tpl',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/patient-order-tpl/patient-order-tpl-delete-dialog.html',
                        controller: 'PatientOrderTplDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['PatientOrderTpl', function (PatientOrderTpl) {
                                return PatientOrderTpl.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-order-tpl', null, {reload: 'patient-order-tpl'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientOrderTpl', PatientOrderTpl);

    PatientOrderTpl.$inject = ['$resource'];

    function PatientOrderTpl($resource) {
        var resourceUrl = 'api/patient-orders-tpl/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET', isArray: true, transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        for (var i = 0; i < data.length; i++){
                            data[i].patientOrderJson = angular.fromJson(data[i].patientOrderJson);
                        }
                    }

                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.patientOrderJson = angular.fromJson(data.patientOrderJson);
                    }

                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.patientOrderJson = angular.toJson(copy.patientOrderJson);

                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.patientOrderJson = angular.toJson(copy.patientOrderJson);

                    return angular.toJson(copy);
                }
            },
            'byCorp': {url: "api/patient-orders-tpl/by-corporation/:id", method: 'GET', isArray: true},
            'withOutCorp': {url: "api/patient-orders-tpl/with-out-corporation", method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientOrderTplSearch', PatientOrderTplSearch);

    PatientOrderTplSearch.$inject = ['$resource'];

    function PatientOrderTplSearch($resource) {
        var resourceUrl =  'api/_search/patient-orders-tpl/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderTemplateController', PatientOrderTemplateController);

    PatientOrderTemplateController.$inject = ['$state', 'ROLES', '$scope', '$compile', '$q', 'Principal', 'CoreService', 'PatientOrderTplSearch',
        'DTColumnBuilder', 'DTOptionsBuilder', 'PatientOrderTpl', 'GUIUtils', '$uibModal', '$filter', 'lodash', 'dialogs', 'Compendium'];

    function PatientOrderTemplateController($state, ROLES, $scope, $compile, $q, Principal, CoreService, PatientOrderTplSearch,
                                            DTColumnBuilder, DTOptionsBuilder, PatientOrderTpl, GUIUtils, $uibModal, $filter, _, $dialogs, Compendium) {

        var vm = this;

        vm.orders = [];
        vm.dtInstance = {};
        vm.patients = [];

        vm.search = search;
        vm.cloneTemplate = cloneTemplate;
        vm.selectPatients = selectPatients;
        vm.selectInterval = selectInterval;
        vm.checkTpl = checkTpl;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                if (!Principal.hasRole(ROLES.ROLE_ADMIN)) {
                    PatientOrderTpl.byCorp({id: CoreService.getCurrentEmployee().corporation.id}, function (result) {
                        vm.orders = result;
                        defer.resolve(result);
                    });
                } else {
                    vm.orders = PatientOrderTpl.withOutCorp(function (result) {
                        vm.orders = result;
                        defer.resolve(vm.orders);
                    });
                }
            } else {
                defer.resolve($filter('filter')(vm.orders, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withBootstrap().withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('description').withTitle('Description'),
            DTColumnBuilder.newColumn(null).withTitle('Corporation').renderWith(function (data, type, full) {
                return data.corporation ? data.corporation.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Order Type').renderWith(function (data, type, full) {
                return data.orderType;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Created Date').renderWith(function (data, type, full) {
                return data.createdDate ? moment(data.createdDate).format("MM/DD/YYYY") : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '200px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = "";
            stButtons += '<a class="btn-sm btn-primary" ng-click="vm.checkTpl(' + data.id + ', 0)"> <i class="fa fa-clone"></i></a>&nbsp;';
            stButtons += Principal.hasRole(ROLES.ROLE_ADMIN) ? '' :
                '<a class="btn-sm btn-primary" ng-click="vm.checkTpl(' + data.id + ', 1)"> <i class="glyphicon glyphicon-paste"></i></a>&nbsp;';

            if (data.corporation || (!data.corporation && Principal.hasRole(ROLES.ROLE_ADMIN))) {
                return stButtons + GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
            } else {
                return stButtons;
            }
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function selectPatients(id) {
            var _order = $.grep(vm.orders, function (order, i) {
                return order.id == id;
            })[0];

            if (_order.orderType == 'STANDING') {
                $uibModal.open({
                    templateUrl: 'app/entities/patient/patient-select-dialog.html',
                    controller: 'PatientStandingSelectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        clinic: CoreService.getCurrentClinic(),
                        patients: {selected: vm.patients}
                    }
                }).result.then(function (result) {
                    vm.patients = result.patients;
                    vm.selectInterval(id);
                }, function () {
                });
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/patient/patient-select-dialog.html',
                    controller: 'PatientSelectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        clinic: CoreService.getCurrentClinic(),
                        patients: {selected: vm.patients}
                    }
                }).result.then(function (result) {
                    vm.patients = result.patients;
                    vm.selectInterval(id);
                }, function () {
                });
            }
        }

        function selectInterval(id) {
            $uibModal.open({
                templateUrl: 'app/entities/window-picker/patient-order-test-interval-dialog.html',
                controller: 'PatientOrderTestIntervalDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    patientOrderTpl: ['PatientOrderTpl', function (PatientOrderTpl) {
                        return PatientOrderTpl.get({id: id}).$promise;
                    }],
                    clinic: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentClinic()
                    }]
                }
            }).result.then(function (result) {
                var patient = vm.patients[0];

                $state.go("patient-order-current.new",
                    {id: patient.id, orderTpl: result.tpl, patients: {selected: vm.patients}}, {reload: true});
            }, function () {
            });
        }

        function cloneTemplate(id) {
            $state.go("patient-order-tpl.edit", {id: id, clone: true}, {reload: true});
        }

        function checkTpl(id, action) {
            PatientOrderTpl.get({id: id}, function (tpl) {
                var compendiums = _.map(tpl.patientOrderJson.patientOrderTests, 'compendium');

                Compendium.check({compendiums: compendiums}, function (result) {
                    if (result.compendiums.length > 0) {
                        var msg = _.map(result.compendiums, function (compendium) {
                            return "Test: " + compendium.code + ' - ' + compendium.description;
                        }).join('<br>');

                        $dialogs.error("Warning.", "This template need review some tests don't exist and need to be removed or changed from the template <br>" + msg);
                    } else {
                        switch (action) {
                            case 0: {
                                cloneTemplate(id);
                                break;
                            }
                            case 1: {
                                selectPatients(id);
                                break;
                            }
                        }
                    }
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderTestTplNewDialogController', PatientOrderTestTplNewDialogController);

    PatientOrderTestTplNewDialogController.$inject = ['CompendiumSearch', 'DiagnosisSearch', 'OrderFrequency', 'patientOrder',
        'patientOrderTest', '$uibModalInstance'];

    function PatientOrderTestTplNewDialogController(CompendiumSearch, DiagnosisSearch, OrderFrequency, patientOrder,
                                                    patientOrderTest, $uibModalInstance) {
        var vm = this;

        vm.patientOrder = patientOrder;
        vm.patientOrderTest = patientOrderTest;

        vm.form = {};
        vm.formProblem = {};

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.orderfrequencies = [];

        vm.compendiums = [];

        vm.getCompendium = getCompendium;

        function getCompendium(query) {
            if (query && query.length > 2) {
                CompendiumSearch.query({query: query}, function (result) {
                    vm.compendiums = result;
                });
            }
        }

        vm.diagnoses = [];

        vm.getDiagnoses = getDiagnoses;

        function getDiagnoses(query) {
            if (query && query.length > 2) {
                DiagnosisSearch.query({query: query}, function (result) {
                    vm.diagnoses = result;
                });
            }
        }

        changeOrderType();
        vm.changeOrderType = changeOrderType;

        function changeOrderType() {
            vm.orderfrequencies = OrderFrequency.byordertype({orderType: vm.patientOrder.orderType}).$promise.then(function (data) {
                vm.orderfrequencies = data;
            });
        }

        vm.accept = function () {
            $uibModalInstance.close({patientOrderTest: vm.patientOrderTest});
        }

        vm.addProblemDiagnosis = function (index) {
            var i = vm.patientOrderTest.diagnoses.indexOf(vm.problems[index].diagnosis);

            if (vm.problemsChk[index].in) {
                if (i == -1) {
                    vm.patientOrderTest.diagnoses.push(vm.problems[index].diagnosis);
                }
            } else {
                if (i > -1) {
                    vm.patientOrderTest.diagnoses.splice(i, 1);
                }
            }

            vm.change();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderTestNewDialogController', PatientOrderTestNewDialogController);

    PatientOrderTestNewDialogController.$inject = ['CoreService', 'DateUtils', 'problems', 'CompendiumSearch', 'DiagnosisSearch', 'OrderFrequency', 'patientOrder', 'patientOrderTest', 'PatientOrder', '$uibModalInstance'];

    function PatientOrderTestNewDialogController(CoreService, DateUtils, problems, CompendiumSearch, DiagnosisSearch, OrderFrequency, patientOrder, patientOrderTest, PatientOrder, $uibModalInstance) {
        var vm = this;

        vm.patientOrder = patientOrder;
        vm.patientOrderTest = patientOrderTest;
        vm.is_new = vm.patientOrderTest.patientOrderItems.length == 0;
        angular.copy(problems.problems, vm.problems = []);
        angular.copy(problems.problems, vm.problemsChk = []);
        vm.clinic = CoreService.getCurrentClinic();

        if (!vm.patientOrder.patient.clinic) {
            vm.patientOrder.patient.clinic = vm.clinic;
        }

        if (vm.patientOrder.orderType == 'STANDING') {
            vm.patientOrderTest.endDate = DateUtils.convertLocalDateFromServer(vm.clinic.standingEnd);
        }

        var days = !vm.patientOrder.patient.drawDays || vm.patientOrder.patient.drawDays == '0000000' ? vm.clinic.drawDays : vm.patientOrder.patient.drawDays;

        vm.form = {};
        vm.formProblem = {};
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.staringDate = false;

        vm.startOptions = {
            minDate: new Date(),
            dateDisabled: disabled,
            startingDay: 1
        }

        vm.endOptions = {
            minDate: new Date(),
            // dateDisabled: disabled,
            startingDay: 1
        }

        vm.change = function () {
            if (vm.patientOrderTest.staringDate && (vm.patientOrder.orderType == 'ONE_TIME' || vm.patientOrderTest.endDate) &&
                vm.patientOrderTest.orderFrequency && vm.patientOrderTest.compendium) {

                vm.scheduleTest();
            }

            vm.endOptions.minDate = vm.patientOrderTest.staringDate;
        }

        function disabled(date) {
            if (vm.patientOrder.orderType == "ONE_TIME") {
                return false;
            }

            var match = false;
            if (date.date.getDay() == 0) {
                //sunday js(0) -> java(6)
                match = date.mode === 'day' && days[6] == "0";
            } else {
                //others days
                match = date.mode === 'day' && days[date.date.getDay() - 1] == "0";
            }

            if (!match) {
                switch (vm.clinic.pDrawWeek) {
                    case 'FIRST_HALF_WEEK': {
                        if (date.date.getDate() < 8) {
                            match = false;
                        } else {
                            match = true;
                        }

                        break;
                    }
                    case 'FIRST_FULL_WEEK': {
                        var x = date.date.getDate() + 1 - (date.date.getDay() == 0 ? 7 : date.date.getDay());
                        match = x <= 0 || x >= 8;

                        break;
                    }
                    case 'SECOND_FULL_WEEK': {
                        var x = date.date.getDate() + 1 - (date.date.getDay() == 0 ? 7 : date.date.getDay()) - 7;
                        match = x <= 0 || x >= 8;

                        break;
                    }
                }
            }

            return match;
        }

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.openCalendar = openCalendar;
        vm.orderfrequencies = [];

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.compendiums = [];

        vm.getCompendium = getCompendium;

        function getCompendium(query) {
            if (query && query.length > 0) {
                CompendiumSearch.query({query: query}, function (result) {
                    vm.compendiums = result;
                });
            }
        }

        vm.diagnoses = [];

        vm.getDiagnoses = getDiagnoses;

        function getDiagnoses(query) {
            if (query && query.length > 0) {
                DiagnosisSearch.query({query: query}, function (result) {
                    vm.diagnoses = result;
                });
            }
        }

        vm.scheduleTest = scheduleTest;

        function scheduleTest() {
            var orderCopy = {};
            angular.copy(vm.patientOrder, orderCopy);
            angular.copy([vm.patientOrderTest], orderCopy.patientOrderTests);

            PatientOrder.schedule(orderCopy, function (data) {
                vm.patientOrderTest = data.patientOrderTests[0];

                vm.alerts = [];
                vm.alerts.push({msg: 'Dates may have been adjusted!'});
            }, function () {
                vm.alerts = [];
                vm.alerts.push({type: 'danger', msg: 'There was an error planning the test, check the dates!'});
            });
        }

        changeOrderType();
        vm.changeOrderType = changeOrderType;

        function changeOrderType() {
            vm.orderfrequencies = OrderFrequency.byordertype({orderType: vm.patientOrder.orderType}).$promise.then(function (data) {
                vm.orderfrequencies = data;
            });
        }

        vm.accept = function () {
            $uibModalInstance.close({patientOrderTest: vm.patientOrderTest, is_new: vm.is_new});
        }

        vm.addProblemDiagnosis = function (index) {
            var i = vm.patientOrderTest.diagnoses.indexOf(vm.problems[index].diagnosis);

            if (vm.problemsChk[index].in) {
                if (i == -1) {
                    vm.patientOrderTest.diagnoses.push(vm.problems[index].diagnosis);
                }
            } else {
                if (i > -1) {
                    vm.patientOrderTest.diagnoses.splice(i, 1);
                }
            }

            vm.change();
        }

        vm.alerts = [];

        vm.closeAlert = function(index) {
            vm.alerts.splice(index, 1);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderTestDetailDialogController', PatientOrderTestDetailDialogController);

    PatientOrderTestDetailDialogController.$inject = ['patientOrderTest', '$uibModalInstance', 'PatientOrderItem', 'patientOrder', 'dialogs'];

    function PatientOrderTestDetailDialogController (patientOrderTest, $uibModalInstance, PatientOrderItem, patientOrder, $dialogs) {
        var vm = this;

        vm.patientOrderTest = patientOrderTest;
        vm.patientOrder = patientOrder;

        vm.items = PatientOrderItem.by_test({id: patientOrderTest.id});

        vm.form = {};

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.accept = function () {
            $uibModalInstance.close();
        }

        vm.cancelOrderTestItem = function (item) {
            if (!item.canceled) {
                var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to Cancel Test?', {size: 'md'});
                dlg.result.then(function (btn) {
                    PatientOrderItem.cancel({id: item.id}, function () {
                    }, function () {
                        $state.reload("patient-order-update", {oid: vm.patientOrder.id});
                    });
                }, function () {
                    item.canceled = false;
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderTestDeleteNewController',PatientOrderTestDeleteNewController);

    PatientOrderTestDeleteNewController.$inject = ['$uibModalInstance', 'entity'];

    function PatientOrderTestDeleteNewController($uibModalInstance, entity) {
        var vm = this;

        vm.patientOrderTest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            $uibModalInstance.close({id: id});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderTestDeleteController',PatientOrderTestDeleteController);

    PatientOrderTestDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientOrderTest'];

    function PatientOrderTestDeleteController($uibModalInstance, entity, PatientOrderTest) {
        var vm = this;

        vm.patientOrderTest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientOrderTest.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('patient-order-update.patient-order-test-detail', {
                parent: 'patient-order-update',
                url: '/{tid}/detail',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'PatientOrderTest'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/patient-order-test/patient-order-test-detail-dialog.html',
                        controller: 'PatientOrderTestDetailDialogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            patientOrderTest: ['PatientOrderTest', function (PatientOrderTest) {
                                return PatientOrderTest.with_all({id: $stateParams.tid}).$promise;
                            }],
                            patientOrder: ['PatientOrder', function (PatientOrder) {
                                return PatientOrder.get({id: $stateParams.oid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-order-update', null, {reload: 'patient-order-update'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('patient-order-view.patient-order-test-detail', {
                parent: 'patient-order-view',
                url: '/{tid}/detail',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'PatientOrderTest'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/patient-order-test/patient-order-test-detail-dialog.html',
                        controller: 'PatientOrderTestDetailDialogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            patientOrderTest: ['PatientOrderTest', function (PatientOrderTest) {
                                return PatientOrderTest.with_all({id: $stateParams.tid}).$promise;
                            }],
                            patientOrder: ['PatientOrder', function (PatientOrder) {
                                return PatientOrder.get({id: $stateParams.oid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-order-update', null, {reload: 'patient-order-update'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientOrderTest', PatientOrderTest);

    PatientOrderTest.$inject = ['$resource', 'DateUtils'];

    function PatientOrderTest($resource, DateUtils) {
        var resourceUrl = 'api/patient-order-tests/:id';

        return $resource(resourceUrl, {}, {
            'order': {url: 'api/patient-order-tests/by-order/:id', method: 'GET', isArray: true},
            'findAllWithoutBarcode': {
                url: 'api/patient-order-tests/without-barcode', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);

                    return angular.toJson(copy);
                }
            },
            //TODO remove with dashboard v2
            'findAllByBarcode': {url: 'api/patient-order-tests/by-barcode/:barcode', method: 'GET', isArray: true},
            'findAllByBarcode2': {url: 'api/patient-order-tests/by-barcode2/:barcode', method: 'GET', isArray: true},
            'with_all': {url: 'api/patient-order-tests/with-all/:id', method: 'GET'},
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.staringDate = DateUtils.convertLocalDateFromServer(data.staringDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.staringDate = DateUtils.convertLocalDateToServer(copy.staringDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.staringDate = DateUtils.convertLocalDateToServer(copy.staringDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientOrderTestSearch', PatientOrderTestSearch);

    PatientOrderTestSearch.$inject = ['$resource'];

    function PatientOrderTestSearch($resource) {
        var resourceUrl =  'api/_search/patient-order-tests/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderTestController', PatientOrderTestController);

    PatientOrderTestController.$inject = ['canCancel', 'CoreService', '$state', '$compile', '$scope', 'GUIUtils', '$q', '$uibModal', 'PatientOrderTest', 'patientOrder', 'DTOptionsBuilder', 'DTColumnBuilder'];

    function PatientOrderTestController (canCancel, CoreService, $state, $compile, $scope, GUIUtils, $q, $uibModal, PatientOrderTest, patientOrder, DTOptionsBuilder, DTColumnBuilder) {
        var vm = this;

        vm.patientOrder = patientOrder;
        vm.patientOrderTests = [];
        vm.dtInstance = {};

        vm.canCancel = false;

        if (vm.patientOrder.ordStatus == 'SCHEDULED' && canCancel) {
            vm.canCancel = CoreService.getCurrentEmployee().id == vm.patientOrder.signedBy.id;
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            PatientOrderTest.order({id: patientOrder.id}, function(result) {
                vm.patientOrderTests = result;
                defer.resolve(result);
            });

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')
            .withOption('paging', false).withOption('aaSorting', []).withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Test').renderWith(function (data, type, full) {
                return data.compendium.code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.compendium.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Frequency').renderWith(function (data, type, full) {
                return data.orderFrequency.name;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Diagnosis (ICD10)').renderWith(function (data, type, full, meta) {
                return data.diagnoses != null && data.diagnoses.length > 1 ? data.diagnoses[0].icd10Code + showICD10Html(meta.row): data.diagnoses[0].icd10Code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Renal').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.renal);//colorHtml(data.renal);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.staringDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            if (canCancel) {
                stButtons += '<a class="btn-sm btn-warning" ui-sref="patient-order-update.patient-order-test-detail({tid:' + data.id + '})">' +
                    '   <i class="fa fa-edit"></i></a>&nbsp;';
            } else {
                stButtons += '<a class="btn-sm btn-warning" ui-sref="patient-order-view.patient-order-test-detail({tid:' + data.id + '})">' +
                    '   <i class="fa fa-edit"></i></a>&nbsp;';
            }

            return stButtons;
        }

        function showICD10Html(row) {
            return '&nbsp;&nbsp;<a class="btn-sm btn-info" ng-click="vm.showICD10(' + row + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        }

        vm.showICD10 = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/diagnosis/diagnosis-dialog.html',
                controller: 'DiagnosisDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: vm.patientOrderTests[index]
                }
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientOrderItem', PatientOrderItem);

    PatientOrderItem.$inject = ['$resource', 'DateUtils'];

    function PatientOrderItem ($resource, DateUtils) {
        var resourceUrl =  'api/patient-order-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'by_test': {url: 'api/patient-orders-items/by-test/:id', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.collectedDate = DateUtils.convertLocalDateFromServer(data.collectedDate);
                        data.scheduleDate = DateUtils.convertLocalDateFromServer(data.scheduleDate);
                        data.sentDate = DateUtils.convertLocalDateFromServer(data.sentDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.collectedDate = DateUtils.convertLocalDateToServer(copy.collectedDate);
                    copy.scheduleDate = DateUtils.convertLocalDateToServer(copy.scheduleDate);
                    copy.sentDate = DateUtils.convertLocalDateToServer(copy.sentDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.collectedDate = DateUtils.convertLocalDateToServer(copy.collectedDate);
                    copy.scheduleDate = DateUtils.convertLocalDateToServer(copy.scheduleDate);
                    copy.sentDate = DateUtils.convertLocalDateToServer(copy.sentDate);
                    return angular.toJson(copy);
                }
            },
            'cancel': { url: 'api/patient-order-items/cancel/:id', method: 'GET'},
            'scheduleDate': { url: 'api/patient-order-items/schedule/:barcode', method: 'GET'},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderViewController', PatientOrderViewController);

    PatientOrderViewController.$inject = ['$state', 'patientOrder', 'entity'];

    function PatientOrderViewController($state, patientOrder, entity) {
        var vm = this;

        vm.patientOrder = patientOrder;
        vm.patient = entity;

        if (vm.patientOrder.ordStatus == 'SCHEDULED') {
            $state.go("patient-order-update", {id: vm.patient.id, oid: vm.patientOrder.id});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderUpdateController', PatientOrderUpdateController);

    PatientOrderUpdateController.$inject = ['$state', 'patientOrder', 'entity', '$stateParams',
        'CoreService', 'PatientOrder', 'Via', 'Employee'];

    function PatientOrderUpdateController($state, patientOrder, entity, $stateParams,
                                        CoreService, PatientOrder,  Via, Employee) {
        var vm = this;

        vm.patientOrder = patientOrder;
        vm.patient = entity;
        vm.canSign = !vm.patientOrder.signed && CoreService.getCurrentEmployee().id == vm.patientOrder.signedBy.id;
        vm.canFinish = false;
        vm.canCancel = true;

        if (vm.patientOrder.ordStatus == 'SCHEDULED') {
            // for (var i = 0; i < patientOrder.patientOrderTests.length && vm.canCancel; i++) {
            //     for (var j = 0; j < patientOrder.patientOrderTests[i].patientOrderItems.length && vm.canCancel; j++) {
            //         vm.canCancel = !patientOrder.patientOrderTests[i].patientOrderItems[j].collected
            //             || patientOrder.patientOrderTests[i].patientOrderItems[j].canceled;
            //     }
            // }

            // vm.canFinish = !vm.canCancel;
            vm.canCancel = true;
        }

        vm.form = {};
        vm.save = save;
        vm.vias = Via.query();
        vm.employees = Employee.employeeCorpPhysicians();

        function save() {
            vm.isSaving = true;
            PatientOrder.update(vm.patientOrder, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $state.go("patient-order-current", {orderType: result.orderType});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.signIn = signIn;

        function signIn() {
            if (vm.canSign) {
                vm.patientOrder.signed = true;
            }

            PatientOrder.update(vm.patientOrder, onSaveSuccess, onSaveError);
        }
    }
})();

  (function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderNewController', PatientOrderNewController);

    PatientOrderNewController.$inject = ['ROLES', '$scope', '$compile', '$state', 'ProblemList', 'patientOrder', 'entity', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils',
        'CoreService', 'EMPLOYEE_TYPE', 'hasStanding', 'patients', 'patientList', 'orderFrequencies',
        'OrderFrequency', 'PatientOrder', 'Via', 'Employee', '$uibModal', 'Patient', '$stateParams'];

    function PatientOrderNewController(ROLES, $scope, $compile, $state, ProblemList, patientOrder, entity, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils,
                                       CoreService, EMPLOYEE_TYPE, hasStanding, patients, patientList, orderFrequencies,
                                       OrderFrequency, PatientOrder, Via, Employee, $uibModal, Patient, $stateParams) {

        var vm = this;

        vm.patient = entity;
        vm.clinic = CoreService.getCurrentClinic();
        vm.patientOrder = patientOrder;
        vm.patientOrder.patient = vm.patient;
        vm.patientOrder.employee = CoreService.getCurrentEmployee();
        vm.access = ROLES.ROLE_SUPERVISOR;

        vm.patients = patients ? patients.selected : [entity];

        vm.patientList = patientList;
        vm.orderfrequencies = orderFrequencies;

        if (vm.patientOrder.employee.employeeType.name == EMPLOYEE_TYPE.PHYSICIAN && CoreService.currentHasEmployeeRole(ROLES.ROLE_DOCTOR)) {
            vm.patientOrder.signedBy = vm.patientOrder.employee;
            vm.patientOrder.signed = true;
        }

        vm.problems = ProblemList.getAllActiveByPatientId({id: vm.patient.id});
        vm.hasStanding = hasStanding.value;

        vm.form = {};
        vm.save = save;
        vm.vias = Via.query();
        vm.employees = Employee.employeeCorpPhysicians();

        function save() {
            vm.isSaving = true;
            vm.patientOrder.icd10Codes = '';

            for (var i = 0; i < vm.problems.length; i++) {
                if (i > 0) {
                    vm.patientOrder.icd10Codes += ','
                }
                vm.patientOrder.icd10Codes += vm.problems[i].diagnosis.icd10Code;
            }

            var req = {
                patientOrder: vm.patientOrder,
                ids: [],
                orderTplId: $stateParams.orderTpl ? $stateParams.orderTpl.id : null
            };

            if (vm.patients.length > 0) {
                for (var j = 0; j < vm.patients.length; j++) {
                    req.ids.push(vm.patients[j].id);
                }
            } else {
                req.ids.push(vm.patientOrder.patient.id);
            }

            PatientOrder.save_many(req, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            $state.go("patient-order-current", {orderType: vm.patientOrder.orderType});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.changeOrderType = changeOrderType;

        function changeOrderType() {
            if (vm.patientOrder.orderType == 'STANDING') {
                vm.patientList = Patient.getWithOutStanding({id: CoreService.getCurrentClinic().id});
            } else {
                vm.patientList = Patient.getAllByClinic({id: CoreService.getCurrentClinic().id});
            }

            vm.patients = [];

            vm.orderfrequencies = OrderFrequency.byordertype({orderType: vm.patientOrder.orderType}).$promise.then(function (data) {
                vm.orderfrequencies = data;
            });
        }

        vm.addPatientOrderTest = function () {
            var test = {
                renal: false,
                staringDate: null,
                id: null,
                orderFrequency: vm.orderfrequencies[0],
                patientOrderItems: [],
                diagnoses: []
            };

            vm.popupTest(test, -1);
        };

        vm.editPatientOrderTest = function (index) {
            vm.popupTest(vm.patientOrder.patientOrderTests[index], index);
        };

        vm.deletePatientOrderTest = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order-test/patient-order-test-delete-dialog.html',
                controller: 'PatientOrderTestDeleteNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: {id: index}
                }
            }).result.then(function () {
                vm.patientOrder.patientOrderTests.splice(index, 1);

                vm.dtInstance.reloadData();
            }, function () {
            });
        };

        vm.showICD10 = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/diagnosis/diagnosis-dialog.html',
                controller: 'DiagnosisDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: vm.patientOrder.patientOrderTests[index]
                }
            });
        };

        vm.popupTest = function (patientOrderTest, index) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order-test/patient-order-test-new-dialog.html',
                controller: 'PatientOrderTestNewDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: entity,
                    patientOrder: vm.patientOrder,
                    patientOrderTest: patientOrderTest,
                    problems: {problems: vm.problems}
                }
            }).result.then(function (result) {
                if (index < 0) {
                    vm.patientOrder.patientOrderTests.push(result.patientOrderTest);
                } else {
                    vm.patientOrder.patientOrderTests[index] = result.patientOrderTest;
                }
                vm.dtInstance.reloadData();
            }, function () {
            });
        };

        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            defer.resolve(vm.patientOrder.patientOrderTests);

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('paging', false).withOption('aaSorting', []).withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Test').renderWith(function (data, type, full) {
                return data.compendium.code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.compendium.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Frequency').renderWith(function (data, type, full) {
                return data.orderFrequency.name;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Diagnosis (ICD10)').renderWith(function (data, type, full, meta) {
                return data.diagnoses != null && data.diagnoses.length == 1 ? data.diagnoses[0].icd10Code : data.diagnoses[0].icd10Code + showICD10Html(meta.row);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Renal').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.renal);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.staringDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ng-click="vm.editPatientOrderTest(' + meta.row + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';
            stButtons += '<a class="btn-sm btn-danger" ng-click="vm.deletePatientOrderTest(' + meta.row + ')">' +
                '   <i class="fa fa-trash"></i></a>';

            return stButtons;
        };

        function showICD10Html(row) {
            return '&nbsp;&nbsp;<a class="btn-sm btn-info" ng-click="vm.showICD10(' + row + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        };

        vm.selectPatients = function () {
            if (vm.patientOrder.orderType == 'STANDING') {
                $uibModal.open({
                    templateUrl: 'app/entities/patient/patient-select-dialog.html',
                    controller: 'PatientStandingSelectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        clinic: vm.clinic,
                        patients: {selected: vm.patients}
                    }
                }).result.then(function (result) {
                    vm.patientOrder.patient = result.patients[0];
                    vm.patients = result.patients;
                }, function () {
                });
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/patient/patient-select-dialog.html',
                    controller: 'PatientSelectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        clinic: vm.clinic,
                        patients: {selected: vm.patients}
                    }
                }).result.then(function (result) {
                    vm.patientOrder.patient = result.patients[0];
                    vm.patients = result.patients;
                }, function () {
                });
            }
        }

        vm.f = function() {
            vm.patientOrder.patient = vm.patients[0];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderFinishController', PatientOrderFinishController);

    PatientOrderFinishController.$inject = ['$uibModalInstance', 'patientOrder', 'PatientOrder'];

    function PatientOrderFinishController($uibModalInstance, patientOrder, PatientOrder) {
        var vm = this;

        vm.patientOrder = patientOrder;
        vm.clear = clear;
        vm.confirmFinish = confirmFinish;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmFinish(id) {
            PatientOrder.finish({id: id},
                function () {
                    $uibModalInstance.close(true);
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderCancelController', PatientOrderCancelController);

    PatientOrderCancelController.$inject = ['$uibModalInstance', 'patientOrder', 'PatientOrder'];

    function PatientOrderCancelController($uibModalInstance, patientOrder, PatientOrder) {
        var vm = this;

        vm.patientOrder = patientOrder;
        vm.clear = clear;
        vm.confirmCancel = confirmCancel;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmCancel(id) {
            PatientOrder.cancel({id: id},
                function () {
                    $uibModalInstance.close(true);
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('patient-order-current', {
                parent: 'patient-abs',
                url: '/current-orders',
                ncyBreadcrumb: {
                    label: 'Current Orders'
                },
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Orders'
                },
                params: {
                    orderType: 'ONE_TIME'
                },
                views: {
                    'content@patient-abs': {
                        templateUrl: 'app/entities/patient-order/current-order/patient-order-current.html',
                        controller: 'PatientOrderCurrentController',
                        controllerAs: 'vm'
                    },
                    'onetime@patient-order-current': {
                        templateUrl: 'app/entities/patient-order/current-order/patient-order-onetime.html',
                        controller: 'OneTimeCurrentOrderController',
                        controllerAs: 'vm'
                    },
                    'standing@patient-order-current': {
                        templateUrl: 'app/entities/patient-order/current-order/patient-order-standing.html',
                        controller: 'StandingCurrentOrderController',
                        controllerAs: 'vm'
                    },
                    'recurring@patient-order-current': {
                        templateUrl: 'app/entities/patient-order/current-order/patient-order-recurring.html',
                        controller: 'RecurringCurrentOrderController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('patient-order-history', {
                parent: 'patient-abs',
                url: '/history-orders',
                ncyBreadcrumb: {
                    label: 'History Orders'
                },
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Orders'
                },
                params: {
                    orderType: 'ONE_TIME'
                },
                views: {
                    'content@patient-abs': {
                        templateUrl: 'app/entities/patient-order/history-order/patient-order-history.html',
                        controller: 'PatientOrderHistoryController',
                        controllerAs: 'vm'
                    },
                    'onetime@patient-order-history': {
                        templateUrl: 'app/entities/patient-order/history-order/patient-order-onetime.html',
                        controller: 'OneTimeHistoryOrderController',
                        controllerAs: 'vm'
                    },
                    'standing@patient-order-history': {
                        templateUrl: 'app/entities/patient-order/history-order/patient-order-standing.html',
                        controller: 'StandingHistoryOrderController',
                        controllerAs: 'vm'
                    },
                    'recurring@patient-order-history': {
                        templateUrl: 'app/entities/patient-order/history-order/patient-order-recurring.html',
                        controller: 'RecurringHistoryOrderController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('patient-order-current.new', {
                url: '/new-order',
                ncyBreadcrumb: {
                    label: 'New',
                    parent: 'patient-order-current'
                },
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Orders'
                },
                params: {
                    orderType: 'ONE_TIME',
                    orderTpl: null,
                    patients: null
                },
                views: {
                    'content@patient-abs': {
                        templateUrl: 'app/entities/patient-order/patient-order-new.html',
                        controller: 'PatientOrderNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    patientOrder: ['$stateParams', 'entity', 'PatientOrder', function ($stateParams, entity, PatientOrder) {
                        var tpl = $stateParams.orderTpl;

                        if (tpl) {
                            var order = tpl.patientOrderJson;
                            if (order.patientOrderTests.length > 0) {
                                order.patient = entity;

                                return PatientOrder.schedule(order).$promise;
                            }

                            return tpl.patientOrderJson;
                        }

                        return {
                            signatureDate: null,
                            ordStatus: 'SCHEDULED',
                            orderType: $stateParams.orderType,
                            signed: false,
                            id: null,
                            patientOrderTests: []
                        };
                    }],
                    hasStanding: ['PatientOrder', '$stateParams', function (PatientOrder, $stateParams) {
                        return PatientOrder.hasStanding({id: $stateParams.id}).$promise;
                    }],
                    patients: ['$stateParams', function ($stateParams) {
                        return $stateParams.patients ? $stateParams.patients : null;
                    }],
                    patientList: ['Patient', '$stateParams', 'CoreService', function (Patient, $stateParams, CoreService) {
                        if ($stateParams.orderType == 'STANDING') {
                            return Patient.getWithOutStanding({id: CoreService.getCurrentClinic().id});
                        } else {
                            return Patient.getAllByClinic({id: CoreService.getCurrentClinic().id});
                        }
                    }],
                    orderFrequencies: ['OrderFrequency', '$stateParams', function (OrderFrequency, $stateParams) {
                        return OrderFrequency.byordertype({orderType: $stateParams.orderType})
                    }]
                }
            })
            .state('patient-order-update', {
                parent: 'patient-order-current',
                url: '/{oid}/update',
                ncyBreadcrumb: {
                    label: 'Order details',
                    parent: 'patient-order-current'
                },
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Order Details'
                },
                params: {
                    orderType: 'ONE_TIME'
                },
                views: {
                    'content@patient-abs': {
                        templateUrl: 'app/entities/patient-order/patient-order-update.html',
                        controller: 'PatientOrderUpdateController',
                        controllerAs: 'vm'
                    },
                    'order-tests@patient-order-update': {
                        templateUrl: 'app/entities/patient-order-test/patient-order-tests.html',
                        controller: 'PatientOrderTestController',
                        controllerAs: 'vm',
                        resolve: {
                            canCancel: function () {
                                return true;
                            }
                        }
                    }
                },
                resolve: {
                    patientOrder: ['$stateParams', 'PatientOrder', function ($stateParams, PatientOrder) {
                        return PatientOrder.get({id: $stateParams.oid}).$promise;
                    }]
                }
            })
            .state('patient-order-update.cancel', {
                url: '/cancel',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/patient-order/patient-order-cancel-dialog.html',
                        controller: 'PatientOrderCancelController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            patientOrder: ['PatientOrder', '$stateParams', function (PatientOrder, $stateParams) {
                                return PatientOrder.get({id: $stateParams.oid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-order-current', {"id": $stateParams.id}, {reload: 'patient-order-current'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('patient-order-update.finish', {
                url: '/finish',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/patient-order/patient-order-finish-dialog.html',
                        controller: 'PatientOrderFinishController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            patientOrder: ['PatientOrder', '$stateParams', function (PatientOrder, $stateParams) {
                                return PatientOrder.get({id: $stateParams.oid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-order-current', {"id": $stateParams.id}, {reload: 'patient-order-current'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('finish-new', {
                parent: 'patient-order-update',
                url: '/finish-new',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/patient-order/current-order/patient-order-standing-confirm.html',
                        controller: 'PatientOrderStandingFinishController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            patientOrder: ['PatientOrder', '$stateParams', function (PatientOrder, $stateParams) {
                                return PatientOrder.get({id: $stateParams.oid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-order-current.new', {
                            "id": $stateParams.id,
                            orderType: 'STANDING'
                        }, {reload: 'patient-order-current.new'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('patient-order-view', {
                parent: 'patient-order-history',
                url: '/{oid}/view',
                ncyBreadcrumb: {
                    label: 'Order details',
                    parent: 'patient-order-history'
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Order Details'
                },
                params: {
                    orderType: 'ONE_TIME'
                },
                views: {
                    'content@patient-abs': {
                        templateUrl: 'app/entities/patient-order/patient-order-view.html',
                        controller: 'PatientOrderViewController',
                        controllerAs: 'vm'
                    },
                    'order-tests@patient-order-view': {
                        templateUrl: 'app/entities/patient-order-test/patient-order-tests.html',
                        controller: 'PatientOrderTestController',
                        controllerAs: 'vm',
                        resolve: {
                            canCancel: function () {
                                return false;
                            }
                        }
                    }
                },
                resolve: {
                    patientOrder: ['$stateParams', 'PatientOrder', function ($stateParams, PatientOrder) {
                        return PatientOrder.get({id: $stateParams.oid}).$promise;
                    }]
                }
            })
            .state('patient-order-unsigned', {
                parent: 'entity',
                url: '/patient-orders/unsigned',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Unsigned Results'
                },
                ncyBreadcrumb: {
                    label: 'Unsigned Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-order/dashboard/patient-orders-unsigned.html',
                        controller: 'PatientOrdersUnsignedController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientOrder', PatientOrder);

    PatientOrder.$inject = ['$resource', 'DateUtils', 'DataUtils'];

    function PatientOrder ($resource, DateUtils, DataUtils) {
        var resourceUrl =  'api/patient-orders/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.signatureDate = DateUtils.convertLocalDateFromServer(data.signatureDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }

                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.signatureDate = DateUtils.convertLocalDateToServer(copy.signatureDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.signatureDate = DateUtils.convertLocalDateToServer(copy.signatureDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);

                    return angular.toJson(copy);
                }
            },
            'save_many': {
                url: "api/patient-orders/save-many", method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.patientOrder.signatureDate = DateUtils.convertLocalDateToServer(copy.patientOrder.signatureDate);
                    copy.patientOrder.endDate = DateUtils.convertLocalDateToServer(copy.patientOrder.endDate);

                    return angular.toJson(copy);
                }
            },
            'active': {
                url: 'api/patient-orders/get-by-type-status/:type/:status/:id', method: 'GET', isArray: true
            },
            'no_active': {
                url: 'api/patient-orders/get-by-type-not-active/:type/:id', method: 'GET', isArray: true
            },
            'schedule': {
                url: 'api/patient-orders-schedule',  method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.patientOrderTests) {
                        for (var i = 0; i < data.patientOrderTests.length; i++) {
                            copy.patientOrderTests[i].staringDate =  DateUtils.convertLocalDateToServer(copy.patientOrderTests[i].staringDate);
                            if (copy.patientOrderTests[i].endDate) {
                                copy.patientOrderTests[i].endDate =  DateUtils.convertLocalDateToServer(copy.patientOrderTests[i].endDate);
                            }
                        }
                    }

                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.signatureDate = DateUtils.convertLocalDateFromServer(data.signatureDate);
                    data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);

                    for (var i = 0; i < data.patientOrderTests.length; i++) {
                        data.patientOrderTests[i].staringDate =  DateUtils.convertLocalDateFromServer(data.patientOrderTests[i].staringDate);
                        if (data.patientOrderTests[i].endDate) {
                            data.patientOrderTests[i].endDate =  DateUtils.convertLocalDateFromServer(data.patientOrderTests[i].endDate);
                        }

                        for (var j = 0; j < data.patientOrderTests[i].patientOrderItems.length; j++) {
                            data.patientOrderTests[i].patientOrderItems[j].scheduleDate =
                                DateUtils.convertLocalDateFromServer(data.patientOrderTests[i].patientOrderItems[j].scheduleDate);

                            data.patientOrderTests[i].patientOrderItems[j].collectedDate =
                                DateUtils.convertLocalDateFromServer(data.patientOrderTests[i].patientOrderItems[j].collectedDate);
                        }
                    }

                    return data;
                }
            },
            'hasStanding': {
                url: "api/patient-orders/has-standing/:id", method: 'GET',
                transformResponse: function (data) {
                    return data == "false" ? {value: false} : {value: true};
                }
            },
            'cancel': {url: "api/cancel-patient-order/:id", method: 'GET'},
            'finish': {url: "api/finish-patient-order/:id", method: 'GET'},
            'dashboardSchedule': {
                url: 'api/patient-orders/dashboard-schedule', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);

                    return angular.toJson(copy);
                }
            },
            'getSchedule': {
                url: 'api/patient-orders/schedule-list', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);

                    return angular.toJson(copy);
                }
            },
            'collect': {
                url: 'api/patient-order/collect', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);

                    return angular.toJson(copy);
                }
            },
            'genBarcodes': {
                url: 'api/patient-order/generate-barcode', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);

                    return angular.toJson(copy);
                }
            },
            'not_collected' : {url : "api/count-orders-not-collected-by-date/:id/:date", method: 'GET',
                transformResponse: function (data) {
                    return {value: data};
                }},
            'unsignedOrders' : {url : "api/patient-orders/unsigned/:id", method: 'GET', isArray: true},
            'signOrders': {url: 'api/patient-orders/sign', method: 'POST', isArray: true},
            'getBarcodeLabels': {url: 'api/patient-orders/get-barcode-labels', method: 'POST', isArray: true},
            'get_barcode': {url: 'api/patient-orders/get-barcode/:id/:date', method: 'GET'},
            'markDates': {url: "api/patient-orders/mark-dates", method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);

                    if (copy.date) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }

                    return angular.toJson(copy);

                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        for (var i = 0; i < data.length; i++) {
                            data[i] = {date: data[i].date, class: data[i].sent ? 'markSentClass' : 'markNotSentClass'};
                        }
                    }

                    return data;
                }
            },
            'byBarcode': {url: "api/patient-orders/by-barcode/:barcode", method: 'GET'},
            'changeDrawDay': {url: 'api/patient-orders/change-draw-day', method: 'POST', isArray: true},
            'pending': {
                url: 'api/patient-orders/pending', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);

                    return angular.toJson(copy);
                }
            },
            'getManifest': {
                url: 'api/patient-orders/manifest', method: 'POST', isArray: false,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                },
                transformResponse: function (data, headers) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.footer = function (currentPage, pageCount) {
                            return {
                                columns: [
                                    {
                                        text: 'Date: ' + moment().format('MM/DD/YYYY hh:mm') + '\n' +
                                        'Page ' + currentPage.toString() + ' of ' + pageCount,
                                        alignment: 'right',
                                        margin: [0, 0, 20, 0],
                                        fontSize: 8
                                    }
                                ]
                            };
                        };
                    }
                    return data;
                }
            },
            'countUnsigned': {url: 'api/patient-orders/count-unsigned/:id', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data = {value: data};
                    }
                    return data;
                }
            },
            'getManifestPdf': {
                url: 'api/patient-orders/manifest_pdf',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            },
            'getBarcodeLabelsPdf': {
                url: 'api/patient-orders/barcode_labels_pdf',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            },
            'cancelRequisition': {
                url: 'api/patient-orders/cancelRequisition',
                method: 'POST'
            },
            'changeDrawDayV2': {url: 'api/patient-orders/change-draw-day-v2', method: 'POST'},
            'validateManifest': {url: 'api/patient-orders/validate-manifest', method: 'POST'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientOrderSearch', PatientOrderSearch);

    PatientOrderSearch.$inject = ['$resource'];

    function PatientOrderSearch($resource) {
        var resourceUrl =  'api/_search/patient-orders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('StandingHistoryOrderController', StandingHistoryOrderController);

    StandingHistoryOrderController.$inject = ['$compile', '$scope', '$state', 'PatientOrder', 'entity',
        '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', 'moment', '$parse', 'CoreService'];

    function StandingHistoryOrderController($compile, $scope, $state, PatientOrder, entity,
                                     $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, moment, $parse, CoreService) {
        var vm = this;

        vm.patient = entity;
        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PatientOrder.no_active({id : vm.patient.id, type: "STANDING"}, function (result) {
                    vm.orders = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patients, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withBootstrap().withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('Order Number'),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(function (data, type, full) {
                return data.ordStatus;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.startDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed').renderWith(function (data, type, full) {
                return data.signed ? GUIUtils.getStatusTemplate('Yes', 'success') : GUIUtils.getStatusTemplate('No', 'danger');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed By').renderWith(function (data, type, full) {
                return data.signed ? 'Dr. ' + data.signedBy.name + ' ' + data.signedBy.lastName : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="patient-order-view({oid:' + data.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RecurringHistoryOrderController', RecurringHistoryOrderController);

    RecurringHistoryOrderController.$inject = ['$compile', '$scope', '$state', 'PatientOrder', 'entity',
        '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', 'moment', '$parse', 'CoreService'];

    function RecurringHistoryOrderController($compile, $scope, $state, PatientOrder, entity,
                                      $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, moment, $parse, CoreService) {
        var vm = this;

        vm.patient = entity;
        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PatientOrder.no_active({id : vm.patient.id, type: "RECURRING"}, function (result) {
                    vm.orders = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patients, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withBootstrap().withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('Order Number'),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(function (data, type, full) {
                return data.ordStatus;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.startDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed').renderWith(function (data, type, full) {
                return data.signed ? GUIUtils.getStatusTemplate('Yes', 'success') : GUIUtils.getStatusTemplate('No', 'danger');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed By').renderWith(function (data, type, full) {
                return data.signed ? 'Dr. ' + data.signedBy.name + ' ' + data.signedBy.lastName : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="patient-order-view({oid:' + full.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('OneTimeHistoryOrderController', OneTimeHistoryOrderController);

    OneTimeHistoryOrderController.$inject = ['$compile', '$scope', '$state', 'PatientOrder', 'entity',
        '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', 'moment', '$parse', 'CoreService'];

    function OneTimeHistoryOrderController($compile, $scope, $state, PatientOrder, entity,
                                                    $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, moment, $parse, CoreService) {
        var vm = this;

        vm.patient = entity;
        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PatientOrder.no_active({id : vm.patient.id, type: "ONE_TIME"}, function (result) {
                    vm.orders = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patients, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('Order Number'),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(function (data, type, full) {
                return data.ordStatus;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Collected Date').renderWith(function (data, type, full) {
                return moment(data.startDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed').renderWith(function (data, type, full) {
                return data.signed ? GUIUtils.getStatusTemplate('Yes', 'success') : GUIUtils.getStatusTemplate('No', 'danger');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed By').renderWith(function (data, type, full) {
                return data.signed ? 'Dr. ' + data.signedBy.name + ' ' + data.signedBy.lastName : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="patient-order-view({oid:' + data.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderHistoryController', PatientOrderHistoryController);

    PatientOrderHistoryController.$inject = ['$scope', '$state', 'PatientOrder', 'PatientOrderSearch', 'entity'];

    function PatientOrderHistoryController($scope, $state, PatientOrder, PatientOrderSearch, entity) {
        var vm = this;

        vm.patientOrders = [];
        vm.search = search;
        vm.patient = entity;
        vm.activeTab = $state.params.orderType == 'ONE_TIME' ? 0 : $state.orderType == 'STANDING' ? 1 : 2;

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PatientOrderSearch.query({query: vm.searchQuery}, function (result) {
                vm.patientOrders = result;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderDetailDialogController', PatientOrderDetailDialogController);

    PatientOrderDetailDialogController.$inject = ['$uibModalInstance', 'patientOrder', '$compile', '$scope', 'GUIUtils',
        '$q', '$uibModal', 'PatientOrderTest', 'DTOptionsBuilder', 'DTColumnBuilder'];

    function PatientOrderDetailDialogController($uibModalInstance, patientOrder, $compile, $scope, GUIUtils,
                                                $q, $uibModal, PatientOrderTest, DTOptionsBuilder, DTColumnBuilder) {
        var vm = this;

        vm.signatureOpts = {
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };

        vm.patientOrderTests = [];
        vm.dtInstance = {};
        vm.patientOrder = patientOrder;

        vm.clear = clear;
        vm.showTestDetail = showTestDetail;
        vm.showICD10 = showICD10;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            PatientOrderTest.order({id: patientOrder.id}, function (result) {
                vm.patientOrderTests = result;
                defer.resolve(result);
            });

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')
            .withOption('paging', false).withOption('aaSorting', []).withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Test').renderWith(function (data, type, full) {
                return data.compendium.code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.compendium.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Frequency').renderWith(function (data, type, full) {
                return data.orderFrequency.name;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Diagnosis (ICD10)').renderWith(function (data, type, full, meta) {
                return data.diagnoses != null && data.diagnoses.length > 1 ? data.diagnoses[0].icd10Code + showICD10Html(meta.row) : data.diagnoses[0].icd10Code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Renal').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.renal);//colorHtml(data.renal);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.staringDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format("MM/DD/YYYY");
            })
            ,
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function actionsHtml(data, type, full, meta) {
            return '<a class="btn-sm btn-warning" ng-click="vm.showTestDetail(' + data.id + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';
        }

        function showICD10Html(row) {
            return '&nbsp;&nbsp;<a class="btn-sm btn-info" ng-click="vm.showICD10(' + row + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        }

        function showICD10(index) {
            $uibModal.open({
                templateUrl: 'app/entities/diagnosis/diagnosis-dialog.html',
                controller: 'DiagnosisDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: vm.patientOrderTests[index]
                }
            });
        }

        function showTestDetail(id) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order-test/patient-order-test-detail-dialog.html',
                controller: 'PatientOrderTestDetailDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    patientOrderTest: ['PatientOrderTest', function (PatientOrderTest) {
                        return PatientOrderTest.with_all({id: id}).$promise;
                    }],
                    patientOrder: patientOrder
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrdersUnsignedController', PatientOrdersUnsignedController);

    PatientOrdersUnsignedController.$inject = ['ROLES', 'EMPLOYEE_TYPE', '$compile', '$scope', 'PatientOrder', '$q',
        'DTColumnBuilder', 'DTOptionsBuilder', 'CoreService', '$filter', 'moment', '$rootScope', 'GUIUtils',
        '$uibModal', 'DataTablesService', 'toastr'];

    function PatientOrdersUnsignedController(ROLES, EMPLOYEE_TYPE, $compile, $scope, PatientOrder, $q, DTColumnBuilder,
                                             DTOptionsBuilder, CoreService, $filter, moment, $rootScope, GUIUtils,
                                             $uibModal, DataTablesService, toastr) {
        var vm = this;

        vm.orders = [];
        vm.dtInstance = {};
        vm.title = "Unsigned Orders";
        vm.clinic = CoreService.getCurrentClinic();
        vm.selected = {};
        vm.selectAll = false;

        vm.search = search;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.signOrders = signOrders;
        vm.modalSignDialog = modalSignDialog;
        vm.detail = detail;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';
        vm.orderStatuses = {
            'CANCELED': {label: 'Cancelled', template: 'danger'},
            'IN_PROCESS': {label: 'Ongoing', template: 'info'},
            'FINISHED': {label: 'Finalized', template: 'success'},
            'SCHEDULED': {label: 'Schedule', template: 'warning'}
        };

        vm.employee = CoreService.getCurrentEmployee();
        vm.signOrdersAllowed = signOrdersAllowed;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PatientOrder.unsignedOrders({id: vm.clinic.id}, function (result) {
                    vm.selected = {};
                    vm.selectAll = false;
                    vm.orders = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.orders, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withOption('aaSorting', [])
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                }).withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            signOrdersAllowed() ?
                DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                    vm.selected[full.id] = false;

                    return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
                }) : DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                    vm.selected[full.id] = false;

                    return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
                }).notVisible()
            ,
            DTColumnBuilder.newColumn(null).withTitle('Patient').renderWith(function (data, type, full) {
                return data.firstName + ' ' + data.middleInitial + ' ' + data.lastName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return data ? moment(data.dob).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Physician').renderWith(function (data, type, full) {
                return data.physician;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return data ? moment(data.startDate).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(orderStatusHtml),
            DTColumnBuilder.newColumn('id').withTitle('Order Number').withOption('width', '120px'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '90px').withOption('class', 'col-btn').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="btn btn-sm btn-default" ng-click="vm.detail(' + data.id + ')">' +
                '   <i class="fa fa-eye"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function signOrders() {
            var orderIds = DataTablesService.getSelectedIds(vm.selected);

            if (orderIds.length > 0) {
                vm.isSaving = true;
                PatientOrder.signOrders({orderIds: orderIds}, function () {
                    vm.dtInstance.reloadData();
                    vm.isSaving = false;
                }, function () {
                })
            }
        }

        function signOrdersAllowed() {
            var isDoctor = $.grep(vm.employee.user.authorities, function (authority, i) {
                return authority.name == ROLES.ROLE_DOCTOR;
            }).length > 0;

            return vm.employee.employeeType.name == EMPLOYEE_TYPE.PHYSICIAN && isDoctor;
        }

        function orderStatusHtml(data, type, full) {
            var orderStatus = vm.orderStatuses[data.ordStatus];
            return GUIUtils.getStatusTemplate(orderStatus.label, orderStatus.template);
        }

        function modalSignDialog(orderId) {
            var selectedOrderIds = orderId ? [orderId] : DataTablesService.getSelectedIds(vm.selected);

            if (selectedOrderIds.length > 0) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-order/dashboard/patient-orders-sign-dialog.html',
                    controller: 'PatientOrdersSignDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        orderIds: function () {
                            return {values: selectedOrderIds};
                        },
                    }
                }).result.then(function () {
                    vm.dtInstance.reloadData();
                });
            } else toastr.error('No order selected. Please select one to proceed.')
        }

        function detail(orderId) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order/detail/patient-order-detail-dialog.html',
                controller: 'PatientOrderDetailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    patientOrder: function () {
                        return PatientOrder.get({id: orderId}).$promise;
                    }
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrdersSignDialogController', PatientOrdersSignDialogController);

    PatientOrdersSignDialogController.$inject = ['$uibModalInstance', 'orderIds', 'PatientOrder', 'toastr'];

    function PatientOrdersSignDialogController($uibModalInstance, orderIds, PatientOrder, toastr) {
        var vm = this;

        vm.signatureOpts = {
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };

        vm.signature = '';
        vm.signaturePin = null;

        vm.wizardTitle = 'Sign Order(s)';

        vm.patientOrderTests = [];
        vm.dtInstance = {};
        vm.orderIds = orderIds.values;

        vm.signOrders = signOrders;
        vm.showSignature = showSignature;
        vm.clear = clear;

        function signOrders() {
            vm.isSaving = true;
            PatientOrder.signOrders({
                orderIds: vm.orderIds,
                signature: vm.signature,
                pin: vm.signaturePin
            }, function (result) {
                if (result.length > 0) {
                    toastr.warning('Sign operation fail for some Patient Orders');
                } else {
                    toastr.success('Sign operation successful');
                }
                vm.isSaving = false;
                $uibModalInstance.close();
            }, function () {
                vm.isSaving = false;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function showSignature() {
            return vm.signaturePin == null || vm.signaturePin == '';
        }
    }
})();

/**
 * Created by maykel on 2/2/2017.
 */
(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderStandingFinishController', PatientOrderStandingFinishController);

    PatientOrderStandingFinishController.$inject = ['$uibModalInstance', 'patientOrder', 'PatientOrder'];

    function PatientOrderStandingFinishController($uibModalInstance, id, PatientOrder) {
        var vm = this;

        vm.patientOrder = id;
        vm.clear = clear;
        vm.confirmFinish = confirmFinish;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmFinish(id) {
            PatientOrder.finish({id: id},
                function () {
                    $uibModalInstance.close(true);
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('StandingCurrentOrderController', StandingCurrentOrderController);

    StandingCurrentOrderController.$inject = ['$compile', '$scope', '$state', 'PatientOrder', 'entity', '$uibModal',
        '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', 'moment'];

    function StandingCurrentOrderController($compile, $scope, $state, PatientOrder, entity, $uibModal,
                                            $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, moment) {
        var vm = this;

        vm.patient = entity;
        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PatientOrder.active({id : vm.patient.id, type: "STANDING", status: "SCHEDULED"}, function (result) {
                    vm.orders = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.orders, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withBootstrap().withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('Order Number'),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.startDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed').renderWith(function (data, type, full) {
                return data.signed ? GUIUtils.getStatusTemplate('Yes', 'success') : GUIUtils.getStatusTemplate('No', 'danger');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed By').renderWith(function (data, type, full) {
                return data.signedBy ? 'Dr. ' + data.signedBy.name + ' ' + data.signedBy.lastName : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="patient-order-update({oid:' + data.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        vm.finishActiveConfirm = finishActiveConfirm;

        function finishActiveConfirm(id) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order/current-order/patient-order-standing-confirm.html',
                controller: 'PatientOrderStandingFinishController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    patientOrder: id
                }
            }).result.then(function (result) {
                $state.go("patient-order-current.new", {orderType: 'STANDING'});
            }, function () {
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RecurringCurrentOrderController', RecurringCurrentOrderController);

    RecurringCurrentOrderController.$inject = ['$compile', '$scope', '$state', 'PatientOrder', 'entity',
        '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', 'moment', '$parse', 'CoreService'];

    function RecurringCurrentOrderController($compile, $scope, $state, PatientOrder, entity,
                                      $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, moment, $parse, CoreService) {
        var vm = this;

        vm.patient = entity;
        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PatientOrder.active({id : vm.patient.id, type: "RECURRING", status: "SCHEDULED"}, function (result) {
                    vm.orders = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.orders, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withBootstrap().withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('Order Number'),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.startDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed').renderWith(function (data, type, full) {
                return data.signed ? GUIUtils.getStatusTemplate('Yes', 'success') : GUIUtils.getStatusTemplate('No', 'danger');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed By').renderWith(function (data, type, full) {
                return data.signedBy ? 'Dr. ' + data.signedBy.name + ' ' + data.signedBy.lastName : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="patient-order-update({oid:' + full.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('OneTimeCurrentOrderController', OneTimeCurrentOrderController);

    OneTimeCurrentOrderController.$inject = ['$compile', '$scope', '$state', 'PatientOrder', 'entity', 'PatientOrderSearch',
        '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', 'moment', '$parse', 'CoreService'];

    function OneTimeCurrentOrderController($compile, $scope, $state, PatientOrder, entity, PatientOrderSearch,
                                                    $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, moment, $parse, CoreService) {
        var vm = this;

        vm.patient = entity;
        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                PatientOrder.active({id : vm.patient.id, type: "ONE_TIME", status: "SCHEDULED"}, function (result) {
                    vm.orders = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.orders, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('Order Number'),
            DTColumnBuilder.newColumn(null).withTitle('Collected Date').renderWith(function (data, type, full) {
                return moment(data.startDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed').renderWith(function (data, type, full) {
                return data.signed ? GUIUtils.getStatusTemplate('Yes', 'success') : GUIUtils.getStatusTemplate('No', 'danger');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed By').renderWith(function (data, type, full) {
                return 'Dr. ' + data.signedBy.name + ' ' + data.signedBy.lastName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('STATUS').renderWith(function (data, type, full) {
                return data.ordStatus;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="patient-order-update({oid:' + data.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientOrderCurrentController', PatientOrderCurrentController);

    PatientOrderCurrentController.$inject = ['$state'];

    function PatientOrderCurrentController($state) {
        var vm = this;

        vm.activeTab = $state.params.orderType == 'ONE_TIME' ? 0 : $state.params.orderType == 'STANDING' ? 2 : 1;
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientImgDialogController', PatientImgDialogController);

    PatientImgDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'DataUtils', 'entity', 'GUIUtils'];

    function PatientImgDialogController ($timeout, $scope, $uibModalInstance, DataUtils, entity, GUIUtils) {
        var vm = this;

        vm.patient = entity;
        vm.patientTmp = {};
        angular.copy(vm.patient, vm.patientTmp);
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            stopWebCam();

            $uibModalInstance.dismiss('cancel');
            angular.copy(vm.patientTmp, vm.patient);
        }

        function save () {
            stopWebCam();

            $uibModalInstance.dismiss('success');
        }

        vm.setPicture = function ($file, patient) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        patient.patientPicture.picture = base64Data;
                        patient.patientPicture.pictureContentType = $file.type;
                    });
                });
            }
        };

        vm.resetUserPicture = function () {
            GUIUtils.resetUserPicture(vm.patient);
        };

        var _video = null,
            patData = null;

        vm.patOpts = {x: 0, y: 0, w: 25, h: 25};

        // Setup a channel to receive a video property
        // with a reference to the video element
        // See the HTML binding in main.html
        vm.channel = {};

        vm.webcamError = false;
        vm.onError = function (err) {
            $scope.$apply(
                function() {
                    $scope.webcamError = err;
                }
            );
        };

        vm.onSuccess = function () {
            // The video element contains the captured camera data
            _video = vm.channel.video;
            $scope.$apply(function() {
                vm.patOpts.w = _video.width;
                vm.patOpts.h = _video.height;
                //$scope.showDemos = true;
            });
        };

        vm.onStream = function (stream) {
            // You could do something manually with the stream.
        };

        vm.makeSnapshot = function() {
            if (_video) {
                var patCanvas = document.querySelector('#snapshot');
                if (!patCanvas) return;

                patCanvas.width = _video.width;
                patCanvas.height = _video.height;
                var ctxPat = patCanvas.getContext('2d');

                var idata = getVideoData(vm.patOpts.x, vm.patOpts.y, vm.patOpts.w, vm.patOpts.h);
                ctxPat.putImageData(idata, 0, 0);

                sendSnapshotToServer(patCanvas.toDataURL().split("base64,")[1]);

                patData = idata;
            }
        };

        /**
         * Redirect the browser to the URL given.
         * Used to download the image by passing a dataURL string
         */
        vm.downloadSnapshot = function downloadSnapshot(dataURL) {
            window.location.href = dataURL;
        };

        var getVideoData = function getVideoData(x, y, w, h) {
            var hiddenCanvas = document.createElement('canvas');
            hiddenCanvas.width = _video.width;
            hiddenCanvas.height = _video.height;
            var ctx = hiddenCanvas.getContext('2d');
            ctx.drawImage(_video, 0, 0, _video.width, _video.height);
            return ctx.getImageData(x, y, w, h);
        };

        /**
         * This function could be used to send the image data
         * to a backend server that expects base64 encoded images.
         *
         * In this example, we simply store it in the scope for display.
         */
        var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
            vm.patient.patientPicture.picture = imgBase64;
        };

        function stopWebCam() {
            var MediaStream = window.MediaStream;

            if (typeof MediaStream === 'undefined' && typeof webkitMediaStream !== 'undefined') {
                MediaStream = webkitMediaStream;
            }

            if (typeof MediaStream !== 'undefined' && !('stop' in MediaStream.prototype)) {
                MediaStream.prototype.stop = function() {
                    this.getAudioTracks().forEach(function(track) {
                        track.stop();
                    });

                    this.getVideoTracks().forEach(function(track) {
                        track.stop();
                    });
                };
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-picture-edit', {
            parent: 'patient-edit',
            url: '/picture',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-img/patient-img-dialog.html',
                    controller: 'PatientImgDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: entity
                    }
                }).result.then(function() {
                    $state.go('patient-edit', null, { reload: 'patient-edit'});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-picture-new', {
            parent: 'patient-new',
            url: '/picture-new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-img/patient-img-dialog.html',
                    controller: 'PatientImgDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: entity
                    }
                }).result.then(function() {
                    $state.go('patient-new', null, { reload: 'patient-new'});
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientGroupDialogController', PatientGroupDialogController);

    PatientGroupDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'PatientGroup', 'clinic', 'Patient'];

    function PatientGroupDialogController ($timeout, $scope, $uibModalInstance, entity, PatientGroup, clinic, Patient) {
        var vm = this;

        vm.patientGroup = entity;
        vm.clear = clear;
        vm.save = save;
        vm.patients = Patient.getAllByClinic({id : vm.patientGroup.clinic.id});

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.patientGroup.id !== null) {
                PatientGroup.update(vm.patientGroup, onSaveSuccess, onSaveError);
            } else {
                PatientGroup.save(vm.patientGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:patientGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientGroupDetailController', PatientGroupDetailController);

    PatientGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PatientGroup', 'Clinic', 'Patient'];

    function PatientGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, PatientGroup, Clinic, Patient) {
        var vm = this;

        vm.patientGroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:patientGroupUpdate', function(event, result) {
            vm.patientGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientGroupDeleteController',PatientGroupDeleteController);

    PatientGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientGroup'];

    function PatientGroupDeleteController($uibModalInstance, entity, PatientGroup) {
        var vm = this;

        vm.patientGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-group', {
            parent: 'entity',
            url: '/patient-group',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PatientGroups'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-group/patient-groups.html',
                    controller: 'PatientGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                clinic: ['CoreService', function (CoreService) {
                    return CoreService.getCurrentClinic();
                }]
            }
        })
        .state('patient-group-detail', {
            parent: 'patient-group',
            url: '/patient-group/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'PatientGroup'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-group/patient-group-detail.html',
                    controller: 'PatientGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'PatientGroup', function($stateParams, PatientGroup) {
                    return PatientGroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'patient-group',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('patient-group-detail.edit', {
            parent: 'patient-group-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-group/patient-group-dialog.html',
                    controller: 'PatientGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientGroup', function(PatientGroup) {
                            return PatientGroup.get({id : $stateParams.id}).$promise;
                        }],
                        clinic: ['CoreService', function (CoreService) {
                            return CoreService.getCurrentClinic();
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-group.new', {
            parent: 'patient-group',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-group/patient-group-dialog.html',
                    controller: 'PatientGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                name: null,
                                id: null,
                                clinic: CoreService.getCurrentClinic()
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-group', null, { reload: 'patient-group' });
                }, function() {
                    $state.go('patient-group');
                });
            }]
        })
        .state('patient-group.edit', {
            parent: 'patient-group',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-group/patient-group-dialog.html',
                    controller: 'PatientGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PatientGroup', function(PatientGroup) {
                            return PatientGroup.get({id : $stateParams.id}).$promise;
                        }],
                        clinic: ['CoreService', function (CoreService) {
                            return CoreService.getCurrentClinic();
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-group', null, { reload: 'patient-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('patient-group.delete', {
            parent: 'patient-group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-group/patient-group-delete-dialog.html',
                    controller: 'PatientGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PatientGroup', function(PatientGroup) {
                            return PatientGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-group', null, { reload: 'patient-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientGroup', PatientGroup);

    PatientGroup.$inject = ['$resource'];

    function PatientGroup ($resource) {
        var resourceUrl =  'api/patient-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByClinic': { 'url': 'api/patient-groups/clinic/:id', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientGroupSearch', PatientGroupSearch);

    PatientGroupSearch.$inject = ['$resource'];

    function PatientGroupSearch($resource) {
        var resourceUrl =  'api/_search/patient-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientGroupController', PatientGroupController);

    PatientGroupController.$inject = ['PatientGroup', 'PatientGroupSearch', 'clinic'];

    function PatientGroupController(PatientGroup, PatientGroupSearch, clinic) {

        var vm = this;

        vm.patientGroups = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            PatientGroup.getAllByClinic({id : clinic.id}, function(result) {
                vm.patientGroups = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PatientGroupSearch.query({query: vm.searchQuery}, function(result) {
                vm.patientGroups = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientStandingSelectDialogController', PatientStandingSelectDialogController);

    PatientStandingSelectDialogController.$inject = ['$uibModalInstance', '$scope', 'clinic', 'Patient', 'dialogs',
        '$q', 'DTColumnBuilder', 'DTOptionsBuilder', '$filter', '$compile', 'patients', 'GUIUtils'];

    function PatientStandingSelectDialogController($uibModalInstance, $scope, clinic, Patient, $dialogs,
                                                   $q, DTColumnBuilder, DTOptionsBuilder, $filter, $compile, patients, GUIUtils) {
        var vm = this;
        vm.clinic = clinic;
        vm.patients = patients.selected;

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.accept = function () {
            var dlg = $dialogs.confirm('Please Confirm',
                'Some selected patients may have active standing orders and will be finalized?', {size: 'md'});
            dlg.result.then(function (btn) {
                var patients = [];
                for (var id in vm.selected) {
                    if (vm.selected[id]) {
                        var _patient = $.grep(vm.patientsList, function (patient, i) {
                            return patient.id == id;
                        })[0];

                        patients.push(_patient);
                    }
                }

                if (patients.length > 0) {
                    $uibModalInstance.close({patients: patients});
                }
            }, function () {
                $uibModalInstance.dismiss('cancel');
            });
        };

        vm.patientsList = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.patientsList);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                // vm.patientList = Patient.getWithOutStanding({id: vm.clinic.id}, function (result) {
                vm.patientList = Patient.withOrderStatus({id: vm.clinic.id}, function (result) {
                    vm.patientsList = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patientsList, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withOption('aaSorting', [[0, 'asc']]).withDOM('tip')
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                var _patient = $.grep(vm.patients, function (patient, i) {
                    return patient.id == data.id;
                })[0];

                vm.selected[full.id] = _patient != null;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Name').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + (data.middleInitial ? data.middleInitial : "");
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('gender').withTitle('Gender'),
            DTColumnBuilder.newColumn(null).withTitle('Has Standing').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.hasStanding == 'true');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Diabetic').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.diabetic);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Physician').renderWith(function (data, type, full) {
                return data.employee ? 'Dr. ' + data.employee.name + ' ' + data.employee.lastName: '';
            })
        ];

        function search() {
            vm.dtInstance.reloadData();
        };

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        };

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }

            vm.selectAll = true;
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientSelectFilter', PatientSelectFilter);

    PatientSelectFilter.$inject = ['$scope', '$state', 'CoreService', 'Patient', 'DataUtils', 'ROLES'];

    function PatientSelectFilter($scope, $state, CoreService, Patient, DataUtils, ROLES) {
        var vm = this;
        vm.patients = [];
        vm.currentClinic = CoreService.getCurrentClinic();
        vm.patient = CoreService.getCurrentPatient();

        vm.importAccess = ROLES.ROLE_SUPERVISOR;

        vm.filterPatients = filterPatients;
        vm.importPatients = importPatients;

        function filterPatients(query) {
            if (query && query.length > 1) {
                vm.currentClinic = CoreService.getCurrentClinic();
                Patient._4filter({
                    query: {
                        bool: {
                            should: [
                                {match: {firstName: {query: query, fuzziness: 1}}},
                                {match: {lastName: {query: query, fuzziness: 1}}}
                            ],
                            must: [
                                {term: {"clinic.id": vm.currentClinic.id}},
                                {term: {"status": false}},
                                {term: {"delStatus": false}}
                            ]
                        }
                    }
                }, function (result) {
                    vm.patients = result;
                });
            }
        }

        function importPatients($file) {
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    var patientImport = {
                        clinicId: CoreService.getCurrentClinic().id,
                        file: base64Data
                    };
                    Patient.import(patientImport, onSaveSuccess, onSaveError);
                });
            }
        }

        function onSaveSuccess(result) {
            //$state.go("patient-detail", {"id": result.id});
            if (result.success) {
                alert('Importing patients was successfully.');
                $state.go("patient", null, {reload: 'patient'});
            } else {
                alert('Error importing patients.');
            }
        }

        function onSaveError(result) {
            //vm.isSaving = false;
            console.log('false');
        }

        $scope.$on('dialysisApp:patientSelected', function (event, result) {
            vm.patient = result;
            vm.patients = [vm.patient];

            if (vm.patient.clinic !== CoreService.getCurrentClinic()) {
                CoreService.setCurrentClinic(vm.patient.clinic);
                vm.currentClinic = vm.patient.clinic;
            }
        });

        vm.onSelectCallback = function (item, model) {
            vm.patient = model;

            if (model) {
                $state.go("patient-detail", {"id": model.id});
            }
        };

        vm.clearPatient = function () {
            vm.patient = null;
            CoreService.setCurrentPatient(null);
            $state.go("patient");
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientSelectDialogController', PatientSelectDialogController);

    PatientSelectDialogController.$inject = ['$uibModalInstance', '$scope', 'clinic', 'Patient', 'GUIUtils',
        '$q', 'DTColumnBuilder', 'DTOptionsBuilder', '$filter', '$compile', 'patients'];

    function PatientSelectDialogController($uibModalInstance, $scope, clinic, Patient, GUIUtils,
                                           $q, DTColumnBuilder, DTOptionsBuilder, $filter, $compile, patients) {
        var vm = this;
        vm.clinic = clinic;
        vm.patients = patients.selected;

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.accept = function () {
            var patients = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    var _patient = $.grep(vm.patientsList, function (patient, i) {
                        return patient.id == id;
                    })[0];

                    patients.push(_patient);
                }
            }

            if (patients.length > 0) {
                $uibModalInstance.close({patients: patients});
            }
        };

        vm.patientsList = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.patientsList);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                Patient.getAllByClinic({id: vm.clinic.id}, function (result) {
                    vm.patientsList = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patientsList, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('aaSorting', [[1, 'asc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                var _patient = $.grep(vm.patients, function (patient, i) {
                    return patient.id == data.id;
                })[0];

                vm.selected[full.id] = _patient != null;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Name').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + (data.middleInitial ? data.middleInitial : "");
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('gender').withTitle('Gender'),
            DTColumnBuilder.newColumn(null).withTitle('Diabetic').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.diabetic);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Physician').renderWith(function (data, type, full) {
                return data.employee ? 'Dr. ' + data.employee.name + ' ' + data.employee.lastName: '';
            })
        ];

        function search() {
            vm.dtInstance.reloadData();
        };

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }

            vm.selectAll = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientNewController', PatientNewController);

    PatientNewController.$inject = ['DiagnosisSearch', '$state', 'entity', 'Patient', 'CoreService',
        'Race', 'Language', 'Employee', 'Modality', 'PatientType', 'PatientTemplate',
        'CountryState', 'InsuranceType', 'InsuranceLevel', 'InsuranceRelation',
        'GUIUtils', 'InsuranceCarrierSearch', 'dialogs', '$sessionStorage'
    ];

    function PatientNewController(DiagnosisSearch, $state, entity, Patient, CoreService,
                                     Race, Language, Employee, Modality, PatientType, PatientTemplate,
                                     CountryState, InsuranceType, InsuranceLevel, InsuranceRelation,
                                     GUIUtils, InsuranceCarrierSearch, $dialogs, $sessionStorage) {
        var vm = this;
        vm.patient = entity;
        vm.carriers = [];

        vm.form = {};
        vm.activeTab = 0;

        vm.datePickerOpenStatus = {};
        vm.days = GUIUtils.weekCodeStringToDays(CoreService.getCurrentClinic().drawDays);
        vm.days2 = GUIUtils.getDays();
        vm.editing = true;

        vm.activeTab = $sessionStorage.activePatientTab ? ($sessionStorage.activePatientTab.id == entity.id ?
            ($sessionStorage.activePatientTab.activeTab > 3 ? 0 : $sessionStorage.activePatientTab.activeTab) : 0) : 0;

        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.changeEditingState = changeEditingState;
        vm.cancelEditing = cancelEditing;
        vm.deactivate = deactivate;

        vm.insurancestypes = InsuranceType.query();
        vm.races = Race.query();
        vm.languages = Language.query();
        vm.physicians = Employee.employeeCorpPhysicians();
        vm.modalities = Modality.query();
        vm.patienttypes = PatientType.query();
        vm.patienttemplates = PatientTemplate.query();
        vm.countrystates = CountryState.query();
        vm.insurancelevels = InsuranceLevel.query();
        vm.insurancerelations = InsuranceRelation.query();

        function save () {
            vm.isSaving = true;
            vm.patient.treatmentDays = GUIUtils.daysToWeekCodeString(vm.patient.treatmentDays2);
            vm.patient.drawDays = GUIUtils.daysToWeekCodeString(vm.patient.drawDays2);

            if (vm.patient.id !== null) {
                Patient.update(vm.patient, onSaveSuccess, onSaveError);
            } else {
                Patient.save(vm.patient, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $state.go("patient-detail", {"id": result.id}, {reload: true});
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dob = false;
        vm.datePickerOpenStatus.fddDate = false;
        vm.datePickerOpenStatus.fDayDialysis = false;
        vm.datePickerOpenStatus.clinicAdmission = false;
        vm.datePickerOpenStatus.placementDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.insuranceDob = [false, false];

        vm.isOpeninsuranceDatePicker = isOpeninsuranceDatePicker;
        function isOpeninsuranceDatePicker(index) {
            return vm.datePickerOpenStatus.insuranceDob[index];
        }

        vm.openInsuranceCalendar = openInsuranceCalendar;
        function openInsuranceCalendar(index) {
            vm.datePickerOpenStatus.insuranceDob[index] = true;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function changeEditingState() {
            vm.editing = !vm.editing;
        }

        function cancelEditing() {
            if (vm.patient.id !== null) {
                $state.go("patient-detail", {"id": vm.patient.id}, {reload: true});
            } else {
                $state.go("patient");
            }
        }

        vm.addAddress = function addAddress() {
            vm.patient.addresses[vm.patient.addresses.length] = {};
            vm.patient.addresses[vm.patient.addresses.length - 1].patientAddressType = vm.patient.addresses.length;
        }

        vm.deleteAddress = function (index) {
            if (index == 0) {
                if (vm.patient.addresses.length > 1) {
                    vm.swapAddresses();
                    vm.patient.addresses.splice(1, 1);
                } else {
                    vm.patient.addresses.splice(0, 1);
                }
            } else {
                vm.patient.addresses.splice(1, 1);
            }
        }

        vm.swapAddresses = function () {
            var tempAddress = {};

            angular.copy(vm.patient.addresses[0], tempAddress);
            angular.copy(vm.patient.addresses[1], vm.patient.addresses[0]);
            angular.copy(tempAddress, vm.patient.addresses[1]);

            vm.patient.addresses[0].patientAddressType = 1;
            vm.patient.addresses[1].patientAddressType = 2;
        }

        vm.addInsurance = function() {
            vm.patient.insurances[vm.patient.insurances.length] = {};
            vm.patient.insurances[vm.patient.insurances.length - 1].insuranceOrder = vm.patient.insurances.length;
        }

        vm.deleteInsurance = function (index) {
            if (index == 0) {
                if (vm.patient.insurances.length > 1) {
                    vm.swapInsurances();
                    vm.patient.insurances.splice(1, 1);
                } else {
                    vm.patient.insurances.splice(0, 1);
                }
            } else {
                vm.patient.insurances.splice(1, 1);
            }
        }

        vm.swapInsurances = function () {
            var tempInsurance = {};

            angular.copy(vm.patient.insurances[0], tempInsurance);
            angular.copy(vm.patient.insurances[1], vm.patient.insurances[0]);
            angular.copy(tempInsurance, vm.patient.insurances[1]);

            vm.patient.insurances[0].insuranceOrder = 1;
            vm.patient.insurances[1].insuranceOrder = 2;
        }

        vm.getInsuranceCarrier = function (query) {
            if (query && query.length > 2) {
                InsuranceCarrierSearch.query({query: query}, function (result) {
                    vm.carriers = result;
                });
            }
        }

        vm.keepActiveTab = keepActiveTab;

        function keepActiveTab($index) {
            if (vm.patient.id) {
                $sessionStorage.activePatientTab = {id: vm.patient.id, activeTab: $index};
            }
        }

        vm.diagnoses = [];

        vm.getDiagnoses = getDiagnoses;

        function getDiagnoses(query) {
            if (query && query.length > 2) {
                DiagnosisSearch.query({query: query}, function (result) {
                    vm.diagnoses = result;
                });
            }
        }

        function deactivate() {
            if (vm.patient.id) {
                if (!vm.patient.status) {
                    var dlg = $dialogs.confirm('Please Confirm','Confirm deactivate patient <b>' +
                        vm.patient.lastName + ', ' + vm.patient.firstName + ' ' + vm.patient.middleInitial +
                        '</b>. All scheduled orders will be canceled', {size: 'md'});
                    dlg.result.then(function(btn){
                        Patient.deactivate({patientId: vm.patient.id}, function () {
                            $state.go("patient-detail", {"id": vm.patient.id}, {reload: true});
                        });
                    },function(btn){
                        vm.patient.status = true;
                    });
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientMenuController',PatientMenuController);

    PatientMenuController.$inject = ['$rootScope', '$stateParams', '$state', '$uibModal', 'CoreService'];

    function PatientMenuController($rootScope, $stateParams, $state, $uibModal, CoreService) {
        var patient = CoreService.getCurrentPatient();

        if (patient) {
            switch ($stateParams.state1) {
                case 'patient-detail' :  $state.go("patient-detail", {"id": patient.id}); break;
                case 'hospitalization' :  $state.go("hospitalization", {"id": patient.id}); break;
                case 'infection' :  $state.go("infection", {"id": patient.id}); break;
                case 'vaccination' :  $state.go("vaccination", {"id": patient.id}); break;
                case 'latest-result' : $state.go("patient-result", {"id": patient.id}); break;
                case 'trending' : $state.go("trending", {"id": patient.id}); break;
                case 'patient-order-current' : $state.go("patient-order-current", {"id": patient.id}); break;
                case 'kinetic' : $state.go("kinetic", {"id": patient.id}); break;
                case 'patient-reports' : $state.go("patient-reports", {"id": patient.id}); break;
                case 'patient-report-card' : $state.go("patient-report-card", {"id": patient.id}); break;
                case 'latest-result-all': $state.go("latest-result"); break;
                default: $state.go("patient-detail", {"id": patient.id}); break;
            }
        } else {
            switch ($stateParams.state1) {
                case 'latest-result' : $state.go("latest-result"); break;
                case 'latest-result-all' : $state.go("latest-result"); break;
                default : {
                    $state.go("patient");
                    // $uibModal.open({
                    //     templateUrl: 'app/entities/patient/patient-menu-dialog.html',
                    //     controller: ['$uibModalInstance', function ($uibModalInstance) {
                    //         var vm = this;
                    //
                    //         vm.dashboard = dashboard;
                    //
                    //         function dashboard () {
                    //             $uibModalInstance.dismiss('cancel');
                    //             $state.go("home");
                    //         }
                    //
                    //         vm.roster = roster;
                    //
                    //         function roster () {
                    //             $uibModalInstance.dismiss('cancel');
                    //             $state.go("patient");
                    //         }
                    //     }],
                    //     controllerAs: 'vm',
                    //     backdrop: 'static',
                    //     size: 'sm'
                    // });
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientIController', PatientIController);

    PatientIController.$inject = ['clinic', '$compile', '$scope', 'Patient', 'patient', 'Employee', 'Modality',
        'PatientSearch', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', 'moment', '$parse', 'CoreService'];

    function PatientIController(clinic, $compile, $scope, Patient, patient, Employee, Modality,
                               PatientSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, moment, $parse, CoreService) {
        var vm = this;

        vm.patient = patient;
        vm.patients = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.clinic = clinic;
        vm.physicians = Employee.employeeCorpPhysicians();
        vm.modalities = Modality.query();

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.patients);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                Patient.roster({id : CoreService.getCurrentClinic().id, status: false}, function (result) {
                    vm.patients = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patients, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withOption('aaSorting', [[0, 'asc']]).withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                 $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Name').withOption('width', '180px').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + (data.middleInitial ? data.middleInitial : "");
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('gender').withTitle('Gender'),
            DTColumnBuilder.newColumn(null).withTitle('Modality').renderWith(function (data, type, full) {
                return data.dialysisModality ? data.dialysisModality.replace("_", " ") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Days').renderWith(function (data, type, full) {
                return data.drawDays ? GUIUtils.expandWeekCodeString(data.drawDays, ',') : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Shift').renderWith(function (data, type, full) {
                return data.shift ? data.shift : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(function (data, type, full) {
                return data.status ? 'Active' : 'Inactive';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Physician').withOption('width', '180px').renderWith(function (data, type, full) {
                return data.physicianFirstName ? (data.physicianLastName + ', ' + data.physicianFirstName) : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('FDD Date').renderWith(function (data, type, full) {
                return data.fDayDialysis ? moment(data.fDayDialysis).format("MM/DD/YYYY") : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Diabetic').renderWith(function (data, type, full) {
                return data.diabetic !== undefined ? GUIUtils.colorHtmlYesNo(data.diabetic) : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle("").withOption('width', '180px').notSortable().renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div>' +
                '<div class="btn-group" uib-dropdown>' +
                '<button type="button" class="btn btn-default" ui-sref="patient-detail({id:' + data.id + '})" href="#/patient/' + data.id + '">Demographics</button>' +
                '<button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle ng-disabled="disabled" data-toggle="dropdown" aria-expanded="false">' +
                '<span class="caret"></span>' +
                '<span class="sr-only">Toggle Dropdown</span>' +
                '</button>' +
                '<ul class="dropdown-menu" uib-dropdown-menu role="menu">' +
                '<li><a ui-sref="hospitalization({id:' + data.id + '})">Hospitalizations</a></li>' +
                '<li><a ui-sref="infection({id:' + data.id + '})">Infections</a></li>' +
                // '<li><a ui-sref="patient-order-current({id:' + data.id + '})">Orders - Current</a></li>' +
                '<li><a ui-sref="patient-order-history({id:' + data.id + '})">Orders - History</a></li>' +
                '<li><a ui-sref="patient-result({id:' + data.id + '})">Results</a></li>' +
                '<li><a ui-sref="trending({id:' + data.id + '})">Results Trending</a></li>' +
                // '<li has-any-authority="ROLE_SUPERVISOR"><a ui-sref="patient-change({id:' + data.id + '})">Change Clinic</a></li>' +
                '</ul>' +
                '</div></div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        vm.popoverFilterEnable = popoverFilterEnable;
        vm.showFilter = false;

        function popoverFilterEnable(){
            vm.showFilter = !vm.showFilter;
        }

        vm.filter = filter;
        vm.isFilter = false;
        vm.patientCopy = {};

        function filter() {
            vm.isFilter = true;

            var must = [];
            must.push({term: {"clinic.id": vm.clinic.id}});
            must.push({term: {"delStatus": false}});
            must.push({term: {"status": false}});

            if (vm.patient.diabetic != null && vm.patient.diabetic.length > 0){
                must.push({match: {diabetic: {query : vm.patient.diabetic}}});
            }

            if (vm.patient.firstName != null && vm.patient.firstName.length > 0){
                must.push({match: {firstName: {query :vm.patient.firstName, fuzziness: 2}}});
            }

            if (vm.patient.lastName && vm.patient.lastName.length > 0){
                must.push({match: {lastName: {query :vm.patient.lastName, fuzziness: 2}}});
            }

            if (vm.patient.gender != null && vm.patient.gender.length > 0){
                must.push({match: {gender: {query :vm.patient.gender}}});
            }

            if (vm.patient.shift){
                must.push({term: {shift: vm.patient.shift}});
            }

            if (vm.patient.treatmentDays && vm.patient.treatmentDays.length > 0){
                must.push({match: {treatmentDays: {query : GUIUtils.daysToWeekCodeString(vm.patient.treatmentDays)}}});
            }

            if (vm.patient.dob && vm.patient.dob.length > 0){
                must.push({match: {dob: {query : GUIUtils.daysToWeekCodeString(vm.patient.dob)}}});
            }

            if (vm.patient.physician.id !== undefined){
                must.push({term: {"employee.id": vm.patient.physician.id}});
            }

            if (vm.patient.modality.id !== undefined){
                must.push({term: {"modality.id": vm.patient.modality.id}});
            }

            PatientSearch.query(
                {
                    query: {
                        bool: {
                            must: must
                        }
                    }
                }, function(result) {
                vm.patients = result;
                vm.dtInstance.reloadData();
            });
        }

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dob = false;
        vm.days = GUIUtils.getDays();

        vm.openCalendar = openCalendar;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.clear = clear;

        function clear() {
            vm.patient = {
                firstName: null,
                lastName: null,
                dob: null,
                gender: null,
                shift: null,
                diabetic: null,
                treatmentDays: null,
                status: true,
                physician: {},
                modality: {}};

            vm.isFilter = false;
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientHealthDialogController', PatientHealthDialogController);

    PatientHealthDialogController.$inject = ['$uibModalInstance', '$scope', 'clinic', 'Patient', '$q',
        'DTColumnBuilder', 'DTOptionsBuilder', '$filter', '$compile', 'patientResultHealth', 'patientResultHealthItem'];

    function PatientHealthDialogController($uibModalInstance, $scope, clinic, Patient, $q,
                                           DTColumnBuilder, DTOptionsBuilder, $filter, $compile, patientResultHealth, patientResultHealthItem) {
        var vm = this;
        vm.clinic = clinic;
        vm.patientResultHealth = patientResultHealth;
        vm.patientResultHealthItem = patientResultHealthItem;

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.patientsList = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.patientsList);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                Patient.byHealthParams({
                    clinicId: vm.clinic.id,
                    patientResultHealth: patientResultHealth,
                    patientResultHealthItem: patientResultHealthItem
                }, function (result) {
                    vm.patientsList = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patientsList, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withOption('aaSorting', [[0, 'asc']]).withDOM('tip')
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Name').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + (data.middleInitial ? data.middleInitial : "");
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('gender').withTitle('Gender'),
        ];

        function search() {
            vm.dtInstance.reloadData();
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientDetailController', PatientDetailController);

    PatientDetailController.$inject = ['entity', 'GUIUtils', '$sessionStorage'];

    function PatientDetailController(entity, GUIUtils, $sessionStorage) {

        var vm = this;
        vm.patient = entity;
        vm.patient.drawDays2 = GUIUtils.weekCodeStringToDays(entity.drawDays);
        vm.patient.treatmentDays2 = GUIUtils.weekCodeStringToDays(entity.treatmentDays);

        vm.carriers = [];
        vm.activeTab = $sessionStorage.activePatientTab ? ($sessionStorage.activePatientTab.id == entity.id ?
            $sessionStorage.activePatientTab.activeTab : 0) : 0;

        vm.form = {};

        vm.editing = false;

        vm.races = vm.patient.race ? [vm.patient.race] : [];
        vm.languages = vm.patient.language ? [vm.patient.language] : [];
        vm.physicians = [vm.patient.employee];
        vm.modalities = vm.patient.modality ? [vm.patient.modality] : [];
        vm.patienttypes = vm.patient.patientType ? [vm.patient.patientType] : [];
        vm.patienttemplates = vm.patient.patientTemplate ? [vm.patient.patientTemplate] : [];
        vm.countrystates = [];
        vm.insurancelevels = [];
        vm.insurancerelations = [];
        vm.insurancestypes = [];

        vm.diagnoses = [];

        for (var i = 0; i < vm.patient.insurances.length; i++) {
            if (vm.patient.insurances[i].insuranceLevel) {
                vm.insurancelevels.push(vm.patient.insurances[i].insuranceLevel);
            }
            if (vm.patient.insurances[i].insuranceRelation) {
                vm.insurancerelations.push(vm.patient.insurances[i].insuranceRelation);
            }
            if (vm.patient.insurances[i].insuranceType) {
                vm.insurancestypes.push(vm.patient.insurances[i].insuranceType);
            }
            if (vm.patient.insurances[i].state) {
                vm.countrystates.push(vm.patient.insurances[i].state);
            }
        }

        for (var i = 0; i < vm.patient.addresses.length; i++) {
            vm.countrystates.push(vm.patient.addresses[i].countryState);
        }

        vm.keepActiveTab = keepActiveTab;
        function keepActiveTab($index) {
            $sessionStorage.activePatientTab = {id: vm.patient.id, activeTab: $index};
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientDeleteController',PatientDeleteController);

    PatientDeleteController.$inject = ['$uibModalInstance', 'entity', 'Patient'];

    function PatientDeleteController($uibModalInstance, entity, Patient) {
        var vm = this;

        vm.patient = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Patient.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientChangeController', PatientChangeController);

    PatientChangeController.$inject = ['clinic', '$compile', '$scope', 'Patient', 'patient', 'Employee', 'Modality', 'Clinic',
        'PatientSearch', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', 'moment', 'id', 'CoreService', 'dialogs'];

    function PatientChangeController(clinic, $compile, $scope, Patient, patient, Employee, Modality, Clinic,
                               PatientSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, moment, id, CoreService, $dialogs) {
        var vm = this;

        vm.patient = patient;
        vm.patientId = id;
        vm.search = search;
        vm.dtInstance = {};
        vm.clinic = clinic;
        vm.physicians = Employee.employeeCorpPhysicians();
        vm.modalities = Modality.query();
        vm.clear = clear;
        vm.newClinic = null;
        vm.clinics = Clinic.except({id: vm.clinic.id});
        vm.changeClinic = changeClinic;

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.patients);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                Patient.roster({id : CoreService.getCurrentClinic().id, status: true}, function (result) {
                    vm.patients = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patients, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')
            .withOption('createdRow', function(row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = (full.id == vm.patientId ? true : false);

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Name').withOption('width', '180px').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + (data.middleInitial ? data.middleInitial : "");
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('gender').withTitle('Gender'),
            DTColumnBuilder.newColumn(null).withTitle('Modality').renderWith(function (data, type, full) {
                return data.dialysisModality ? data.dialysisModality.replace("_", " ") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Days').renderWith(function (data, type, full) {
                return data.drawDays ? GUIUtils.expandWeekCodeString(data.drawDays, ',') : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Shift').renderWith(function (data, type, full) {
                return data.shift ? data.shift : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(function (data, type, full) {
                return data.status ? 'Active' : 'Inactive';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Physician').withOption('width', '180px').renderWith(function (data, type, full) {
                return data.physicianFirstName ? (data.physicianLastName + ', ' + data.physicianFirstName) : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('FDD Date').renderWith(function (data, type, full) {
                return data.fDayDialysis ? moment(data.fDayDialysis).format("MM/DD/YYYY") : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Diabetic').renderWith(function (data, type, full) {
                return data.diabetic !== undefined ? GUIUtils.colorHtmlYesNo(data.diabetic) : '';
            }),
        ];

        function search() {
            vm.dtInstance.reloadData();
        }

        vm.popoverFilterEnable = popoverFilterEnable;
        vm.showFilter = false;

        function popoverFilterEnable(){
            vm.showFilter = !vm.showFilter;
        }

        vm.filter = filter;
        vm.isFilter = false;
        vm.patientCopy = {};

        function filter() {
            vm.isFilter = true;

            var must = [];
            must.push({term: {"clinic.id": vm.clinic.id}});
            must.push({term: {"delStatus": false}});

            if (vm.patient.diabetic != null && vm.patient.diabetic.length > 0){
                must.push({match: {diabetic: {query : vm.patient.diabetic}}});
            }

            if (vm.patient.firstName != null && vm.patient.firstName.length > 0){
                must.push({match: {firstName: {query :vm.patient.firstName, fuzziness: 2}}});
            }

            if (vm.patient.lastName && vm.patient.lastName.length > 0){
                must.push({match: {lastName: {query :vm.patient.lastName, fuzziness: 2}}});
            }

            if (vm.patient.gender != null && vm.patient.gender.length > 0){
                must.push({match: {gender: {query :vm.patient.gender}}});
            }

            if (vm.patient.shift){
                must.push({term: {shift: vm.patient.shift}});
            }

            if (vm.patient.treatmentDays && vm.patient.treatmentDays.length > 0){
                must.push({match: {treatmentDays: {query : GUIUtils.daysToWeekCodeString(vm.patient.treatmentDays)}}});
            }

            if (vm.patient.dob && vm.patient.dob.length > 0){
                must.push({match: {dob: {query : GUIUtils.daysToWeekCodeString(vm.patient.dob)}}});
            }

            if (vm.patient.status != null && vm.patient.status.length > 0){
                must.push({match: {status: {query : vm.patient.status}}});
            }

            if (vm.patient.physician.id !== undefined){
                must.push({term: {"physician.id": vm.patient.physician.id}});
            }

            if (vm.patient.modality.id !== undefined){
                must.push({term: {"modality.id": vm.patient.modality.id}});
            }

            PatientSearch.query(
                {
                    query: {
                        bool: {
                            must: must
                        }
                    }
                }, function(result) {
                vm.patients = result;
                vm.dtInstance.reloadData();
            });
        }

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dob = false;
        vm.days = GUIUtils.getDays();

        vm.openCalendar = openCalendar;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            vm.patient = {
                firstName: null,
                lastName: null,
                dob: null,
                gender: null,
                shift: null,
                diabetic: null,
                treatmentDays: null,
                status: true,
                physician: {},
                modality: {}};

            vm.isFilter = false;
            vm.dtInstance.reloadData();
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }
            vm.selectAll = true;
        }

        function getSelectedIds() {
            var orders = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    orders.push(id);
                }
            }

            return orders;
        }

        function changeClinic() {
            var dlg = $dialogs.confirm('Please Confirm','Move selected patients to <b>' + vm.newClinic.name + '</b>?', {size: 'md'});
            dlg.result.then(function(btn){
                var ids = getSelectedIds();

                if (ids.length > 0) {
                    Patient.change({clinicId: vm.newClinic.id, ids: ids}, function () {
                        vm.searchQuery = null;
                        vm.isFilter = false;

                        search();
                    });
                }
            },function(btn){
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientAbstractController', PatientAbstractController);

    PatientAbstractController.$inject = ['entity', 'GUIUtils', '$rootScope', 'CoreService'];

    function PatientAbstractController(entity, GUIUtils, $rootScope, CoreService) {
        var vm = this;

        vm.patient = entity;

        if (CoreService.getCurrentPatient() != vm.patient) {
            CoreService.setCurrentPatient(vm.patient);
            $rootScope.$broadcast('dialysisApp:patientSelected', vm.patient);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('patient', {
                parent: 'entity',
                url: '/patient',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Patients'
                },
                ncyBreadcrumb: {
                    label: 'Patients',
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient/patients.html',
                        controller: 'PatientController',
                        controllerAs: 'vm'
                    }
                    // 'select-filter@patient': {
                    //     templateUrl: 'app/entities/patient/patient-select-filter.html',
                    //     controller: 'PatientSelectFilter',
                    //     controllerAs: 'vm'
                    // }
                },
                resolve: {
                    patient: [function () {
                        return {
                            firstName: null,
                            lastName: null,
                            dob: null,
                            gender: null,
                            shift: null,
                            diabetic: null,
                            treatmentDays: null,
                            status: null,
                            physician: {},
                            modality: {}
                        }
                    }],
                    clinic: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentClinic();
                    }]
                }
            })
            .state('patient-i', {
                parent: 'entity',
                url: '/patient-i',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Patients'
                },
                ncyBreadcrumb: {
                    label: 'Inactive Patients',
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient/patients-i.html',
                        controller: 'PatientIController',
                        controllerAs: 'vm'
                    },
                    'select-filter@patient': {
                        templateUrl: 'app/entities/patient/patient-select-filter.html',
                        controller: 'PatientSelectFilter',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    patient: [function () {
                        return {
                            firstName: null,
                            lastName: null,
                            dob: null,
                            gender: null,
                            shift: null,
                            diabetic: null,
                            treatmentDays: null,
                            status: null,
                            physician: {},
                            modality: {}
                        }
                    }],
                    clinic: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentClinic();
                    }]
                }
            })
            .state('patient-abs', {
                parent: 'entity',
                url: '/patient/{id}',
                abstract: true,
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Patients'
                },
                ncyBreadcrumb: {
                    label: 'Demographics',
                    parent: 'patient-detail'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient/tpl/patient-tpl.html',
                        controller: 'PatientAbstractController',
                        controllerAs: 'vm'
                    },
                    'select-filter@patient-abs': {
                        templateUrl: 'app/entities/patient/patient-select-filter.html',
                        controller: 'PatientSelectFilter',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Patient', function ($stateParams, Patient) {
                        return Patient.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('patient-detail', {
                parent: 'patient-abs',
                url: '/detail',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Patient'
                },
                ncyBreadcrumb: {
                    label: 'Demographics',
                    parent: 'patient'
                },
                views: {
                    'content@patient-abs': {
                        templateUrl: 'app/entities/patient/patient-detail.html',
                        controller: 'PatientDetailController',
                        controllerAs: 'vm'
                    },
                    'problem-list@patient-detail': {
                        templateUrl: 'app/entities/problem-list/problem-list.html',
                        controller: 'ProblemListController',
                        controllerAs: 'vm'
                    },
                    'care-team@patient-detail': {
                        templateUrl: 'app/entities/care-team/care-teams.html',
                        controller: 'CareTeamController',
                        controllerAs: 'vm'
                    },
                    'patient-medications@patient-detail': {
                        templateUrl: 'app/entities/medication/medications.html',
                        controller: 'MedicationController',
                        controllerAs: 'vm'
                    },
                    'patient-access@patient-detail': {
                        templateUrl: 'app/entities/access/accesses.html',
                        controller: 'AccessController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('patient-detail-menu', {
                parent: 'entity',
                url: '/patient-menu/{state1}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Patient'
                },
                views: {
                    'content@': {
                        controller: 'PatientMenuController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('patient-new', {
                parent: 'entity',
                url: '/patient-new',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'New Patient'
                },
                ncyBreadcrumb: {
                    label: 'New Patient',
                    parent: 'patient'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient/patient-new.html',
                        controller: 'PatientNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['GUIUtils', 'CoreService', function (GUIUtils, CoreService) {
                        return {
                            firstName: null,
                            lastName: null,
                            middleInitial: null,
                            dob: null,
                            ssn: null,
                            gender: null,
                            shift: null,
                            diabetic: false,
                            mrn: null,
                            fDayDialysis: null,
                            clinicAdmission: null,
                            treatmentDays: '0000000',
                            drawDays: '0000000',
                            kidneyTransplant: false,
                            status: true,
                            id: null,
                            externalMrn: null,
                            externalBillingId: null,
                            addresses: [],
                            insurances: [],
                            patientPicture: {
                                picture: GUIUtils.getDefaultUserPicture(),
                                pictureContentType: GUIUtils.getDefaultUserPictureContentType(),
                            },
                            clinic: CoreService.getCurrentClinic()
                        };
                    }]
                }
            })
            .state('patient-edit', {
                parent: 'patient-abs',
                url: '/edit',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Patient Edit'
                },
                ncyBreadcrumb: {
                    label: 'Edit',
                    parent: 'patient-abs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient/patient-new.html',
                        controller: 'PatientNewController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('patient-change', {
                parent: 'entity',
                url: '/patient-change',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Patient Change Clinic'
                },
                ncyBreadcrumb: {
                    label: 'Patient Change Clinic',
                },
                params: {
                    id: null,
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient/patient-change.html',
                        controller: 'PatientChangeController',
                        controllerAs: 'vm'
                    },
                    'select-filter@patient-change': {
                        templateUrl: 'app/entities/patient/patient-select-filter.html',
                        controller: 'PatientSelectFilter',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    patient: [function () {
                        return {
                            firstName: null,
                            lastName: null,
                            dob: null,
                            gender: null,
                            shift: null,
                            diabetic: null,
                            treatmentDays: null,
                            status: null,
                            physician: {},
                            modality: {}
                        }
                    }],
                    clinic: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentClinic();
                    }],
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }]
                }
            })
            .state('patient-health', {
                parent: 'dashboard-doc',
                url: '/patient-health',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Patient Change Clinic'
                },
                ncyBreadcrumb: {
                    label: 'Patient Change Clinic',
                },
                params: {
                    id: null,
                    patientResultHealth: null,
                    patientResultHealthItem: null
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    if ($stateParams.patientResultHealth && $stateParams.patientResultHealth) {
                        $uibModal.open({
                            templateUrl: 'app/entities/patient/patient-health-dialog.html',
                            controller: 'PatientHealthDialogController',
                            controllerAs: 'vm',
                            size: 'md',
                            resolve: {
                                clinic: ['CoreService', function (CoreService) {
                                    return CoreService.getCurrentClinic();
                                }],
                                patientResultHealth: $stateParams.patientResultHealth,
                                patientResultHealthItem: $stateParams.patientResultHealthItem
                            }
                        }).result.then(function () {
                            $state.go('^');
                        }, function () {
                            $state.go('^');
                        });
                    } else {
                        $state.go('dashboard-doc');
                    }
                }]
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Patient', Patient);

    Patient.$inject = ['$resource', 'DateUtils', 'GUIUtils'];

    function Patient($resource, DateUtils, GUIUtils) {
        var resourceUrl = 'api/patients/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                        data.fddDate = DateUtils.convertLocalDateFromServer(data.fddDate);
                        data.fDayDialysis = DateUtils.convertLocalDateFromServer(data.fDayDialysis);
                        data.clinicAdmission = DateUtils.convertLocalDateFromServer(data.clinicAdmission);

                        if (data.patientPictures && data.patientPictures.length > 0) {
                            data.patientPicture = data.patientPictures[0];
                        } else {
                            GUIUtils.resetUserPicture(data);
                        }

                        if (data.patientAccess) {
                            data.patientAccess.placementDate = DateUtils.convertLocalDateFromServer(data.patientAccess.placementDate);
                            data.patientAccess.endDate = DateUtils.convertLocalDateFromServer(data.patientAccess.endDate);
                        }

                        if (data.insurances) {
                            for (var i = 0; i < data.insurances.length; i++) {
                                if (data.insurances[i].dob) {
                                    data.insurances[i].dob = DateUtils.convertLocalDateFromServer(data.insurances[i].dob);
                                }
                            }
                        }
                    }

                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    copy.fddDate = DateUtils.convertLocalDateToServer(copy.fddDate);
                    copy.fDayDialysis = DateUtils.convertLocalDateToServer(copy.fDayDialysis);
                    copy.clinicAdmission = DateUtils.convertLocalDateToServer(copy.clinicAdmission);

                    copy.patientPictures = [copy.patientPicture];

                    if (copy.patientAccess) {
                        copy.patientAccess.placementDate = DateUtils.convertLocalDateToServer(copy.patientAccess.placementDate);
                        copy.patientAccess.endDate = DateUtils.convertLocalDateToServer(copy.patientAccess.endDate);
                    }

                    for (var i = 0; i < copy.insurances.length; i++) {
                        if (copy.insurances[i].dob) {
                            copy.insurances[i].dob = DateUtils.convertLocalDateToServer(copy.insurances[i].dob);
                        }
                    }

                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    copy.fddDate = DateUtils.convertLocalDateToServer(copy.fddDate);
                    copy.fDayDialysis = DateUtils.convertLocalDateToServer(copy.fDayDialysis);
                    copy.clinicAdmission = DateUtils.convertLocalDateToServer(copy.clinicAdmission);

                    copy.patientPictures = [copy.patientPicture];

                    if (copy.patientAccess) {
                        copy.patientAccess.placementDate = DateUtils.convertLocalDateToServer(copy.patientAccess.placementDate);
                        copy.patientAccess.endDate = DateUtils.convertLocalDateToServer(copy.patientAccess.endDate);
                    }

                    for (var i = 0; i < copy.insurances.length; i++) {
                        if (copy.insurances[i].dob) {
                            copy.insurances[i].dob = DateUtils.convertLocalDateToServer(copy.insurances[i].dob);
                        }
                    }

                    return angular.toJson(copy);
                }
            },
            "getAllByClinic": {'url': 'api/patients/clinic/:id', method: 'GET', isArray: true},
            'import': {
                'url': 'api/patients/import',
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {

                    var response = {
                        success: (data === 'true')
                    }
                    return response;
                }
            },
            'getWithOutStanding': {'url': 'api/patients/clinic/:id/with-out-standing', method: 'GET', isArray: true},
            'roster': {'url': 'api/patients/roster/:id/:status', method: 'GET', isArray: true},
            '_4filter': {url: 'api/patients/_4filter/by-clinic/:id', method: 'GET', isArray: true},
            'get_shift': {
                url: 'api/patients/shift/by-clinic/:id', method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        var shifts = [{id: -1, shift: 'Any'}];
                        for (var i = 0; i < data.length; i++) {
                            if (data[i] == null) {
                                shifts.push({id: 0, shift: 'No Shift'});
                            } else {
                                shifts.push({id: data[i], shift: data[i]});
                            }
                        }
                    }

                    return shifts;
                }
            },
            'change' : {
                url: 'api/patients/change', method: 'POST'
            },
            'deactivate': {url: 'api/patients/deactivate', method: 'POST'},
            'byBarcode': {url: 'api/patients/by-barcode/:barcode', method: 'GET', transformResponse: function (data) {
                if (data) {
                    data = angular.fromJson(data);
                    data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                    data.fddDate = DateUtils.convertLocalDateFromServer(data.fddDate);
                    data.fDayDialysis = DateUtils.convertLocalDateFromServer(data.fDayDialysis);
                    data.clinicAdmission = DateUtils.convertLocalDateFromServer(data.clinicAdmission);

                    if (data.patientPictures && data.patientPictures.length > 0) {
                        data.patientPicture = data.patientPictures[0];
                    } else {
                        GUIUtils.resetUserPicture(data);
                    }

                    if (data.patientAccess) {
                        data.patientAccess.placementDate = DateUtils.convertLocalDateFromServer(data.patientAccess.placementDate);
                        data.patientAccess.endDate = DateUtils.convertLocalDateFromServer(data.patientAccess.endDate);
                    }

                    if (data.insurances) {
                        for (var i = 0; i < data.insurances.length; i++) {
                            if (data.insurances[i].dob) {
                                data.insurances[i].dob = DateUtils.convertLocalDateFromServer(data.insurances[i].dob);
                            }
                        }
                    }
                }

                return data;
            }},
            'withoutBarcode': {
            url: 'api/patients/by-patientId/:patient', method: 'GET', transformResponse: function (data) {
                if (data) {
                    data = angular.fromJson(data);
                    data.dob = DateUtils.convertLocalDateFromServer(data.dob);

                    if (data.patientPictures && data.patientPictures.length > 0) {
                        data.patientPicture = data.patientPictures[0];
                    } else {
                        GUIUtils.resetUserPicture(data);
                    }
                }

                return data;
            }
        },
            'byHealthParams': {url: 'api/patients/by-health', method: 'POST', isArray: true},
            'withOrderStatus': {url: 'api/patients/all/:id', method: 'GET', isArray: true},
            'allRoster': {'url': 'api/patients/roster/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientSearch', PatientSearch);

    PatientSearch.$inject = ['$resource'];

    function PatientSearch($resource) {
        var resourceUrl = 'api/_search/patients/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientController', PatientController);

    PatientController.$inject = ['clinic', '$compile', '$scope', 'Patient', 'patient', 'Employee', 'Modality', 'DateUtils',
        'PatientSearch', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', 'moment', '$parse', 'CoreService'];

    function PatientController(clinic, $compile, $scope, Patient, patient, Employee, Modality, DateUtils,
                               PatientSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, moment, $parse, CoreService) {
        var vm = this;

        vm.patient = patient;
        vm.patients = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.clinic = clinic;
        vm.physicians = Employee.employeeCorpPhysicians();
        vm.modalities = Modality.query();

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.patients);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                Patient.roster({id : CoreService.getCurrentClinic().id, status: true}, function (result) {
                    vm.patients = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patients, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withOption('aaSorting', [[0, 'asc']]).withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                 $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Name').withOption('width', '180px').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + (data.middleInitial ? data.middleInitial : "");
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('gender').withTitle('Gender'),
            DTColumnBuilder.newColumn(null).withTitle('Modality').renderWith(function (data, type, full) {
                return data.dialysisModality ? data.dialysisModality.replace("_", " ") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Shift').renderWith(function (data, type, full) {
                return data.shift ? data.shift : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(function (data, type, full) {
                return data.status ? 'Active' : 'Inactive';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Physician').withOption('width', '180px').renderWith(function (data, type, full) {
                return data.physicianFirstName ? (data.physicianLastName + ', ' + data.physicianFirstName) : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Diabetic').renderWith(function (data, type, full) {
                return data.diabetic !== undefined ? GUIUtils.colorHtmlYesNo(data.diabetic) : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle("").withOption('width', '200px').notSortable().renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div>' +
                '<div class="btn-group" uib-dropdown>' +
                '<button type="button" class="btn btn-default" ui-sref="patient-detail({id:' + data.id + '})" href="#/patient/' + data.id + '">Demographics</button>' +
                '<button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle ng-disabled="disabled" data-toggle="dropdown" aria-expanded="false">' +
                '<span class="caret"></span>' +
                '<span class="sr-only">Toggle Dropdown</span>' +
                '</button>' +
                '<ul class="dropdown-menu" uib-dropdown-menu role="menu">' +
                '<li><a ui-sref="hospitalization({id:' + data.id + '})">Hospitalizations</a></li>' +
                '<li><a ui-sref="infection({id:' + data.id + '})">Infections</a></li>' +
                '<li><a ui-sref="patient-order-current({id:' + data.id + '})">Orders - Current</a></li>' +
                '<li><a ui-sref="patient-order-history({id:' + data.id + '})">Orders - History</a></li>' +
                '<li><a ui-sref="patient-result({id:' + data.id + '})">Results</a></li>' +
                '<li><a ui-sref="trending({id:' + data.id + '})">Results Trending</a></li>' +
                '<li has-any-authority="ROLE_SUPERVISOR"><a ui-sref="patient-change({id:' + data.id + '})">Change Clinic</a></li>' +
                '</ul>' +
                '</div></div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        vm.popoverFilterEnable = popoverFilterEnable;
        vm.showFilter = false;

        function popoverFilterEnable(){
            vm.showFilter = !vm.showFilter;
        }

        vm.filter = filter;
        vm.isFilter = false;
        vm.patientCopy = {};

        function filter() {
            vm.isFilter = true;

            var must = [];
            must.push({term: {"clinic.id": vm.clinic.id}});
            must.push({term: {"delStatus": false}});
            must.push({term: {"status": true}});

            if (vm.patient.diabetic != null && vm.patient.diabetic.length > 0){
                must.push({match: {diabetic: {query : vm.patient.diabetic}}});
            }

            if (vm.patient.firstName != null && vm.patient.firstName.length > 0){
                must.push({match: {firstName: {query :vm.patient.firstName, fuzziness: 2}}});
            }

            if (vm.patient.lastName && vm.patient.lastName.length > 0){
                must.push({match: {lastName: {query :vm.patient.lastName, fuzziness: 2}}});
            }

            if (vm.patient.gender != null && vm.patient.gender.length > 0){
                must.push({match: {gender: {query :vm.patient.gender}}});
            }

            if (vm.patient.shift){
                must.push({term: {shift: vm.patient.shift}});
            }

            if (vm.patient.treatmentDays && vm.patient.treatmentDays.length > 0){
                must.push({match: {treatmentDays: {query : GUIUtils.daysToWeekCodeString(vm.patient.treatmentDays)}}});
            }

            if (vm.patient.dob && vm.patient.dob.length > 0){
                must.push({match: {dob: {query : moment(vm.patient.dob).format('Y-MM-DD')}}});
            }

            if (vm.patient.physician.id !== undefined){
                must.push({term: {"employee.id": vm.patient.physician.id}});
            }

            if (vm.patient.modality.id !== undefined){
                must.push({term: {"modality.id": vm.patient.modality.id}});
            }

            PatientSearch.query(
                {
                    query: {
                        bool: {
                            must: must
                        }
                    }
                }, function(result) {
                vm.patients = result;
                vm.dtInstance.reloadData();
            });
        }

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dob = false;
        vm.days = GUIUtils.getDays();

        vm.openCalendar = openCalendar;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.clear = clear;

        function clear() {
            vm.patient = {
                firstName: null,
                lastName: null,
                dob: null,
                gender: null,
                shift: null,
                diabetic: null,
                treatmentDays: null,
                status: true,
                physician: {},
                modality: {}};

            vm.isFilter = false;
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('OrderFrequency', OrderFrequency);

    OrderFrequency.$inject = ['$resource'];

    function OrderFrequency ($resource) {
        var resourceUrl =  'api/order-frequencies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byordertype': { url: 'api/order-frequencies-by-order-type/:orderType', method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ModalityDialogController', ModalityDialogController);

    ModalityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Modality'];

    function ModalityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Modality) {
        var vm = this;

        vm.modality = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.modality.id !== null) {
                Modality.update(vm.modality, onSaveSuccess, onSaveError);
            } else {
                Modality.save(vm.modality, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:modalityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ModalityDetailController', ModalityDetailController);

    ModalityDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Modality', 'Patient', 'Corporation'];

    function ModalityDetailController($scope, $rootScope, $stateParams, previousState, entity, Modality, Patient, Corporation) {
        var vm = this;

        vm.modality = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:modalityUpdate', function(event, result) {
            vm.modality = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ModalityDeleteController',ModalityDeleteController);

    ModalityDeleteController.$inject = ['$uibModalInstance', 'entity', 'Modality'];

    function ModalityDeleteController($uibModalInstance, entity, Modality) {
        var vm = this;

        vm.modality = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Modality.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('modality', {
            parent: 'entity',
            url: '/modality',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Modalities'
            },
            ncyBreadcrumb: {
                label: 'Modalities',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modality/modalities.html',
                    controller: 'ModalityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('modality-detail', {
            parent: 'entity',
            url: '/modality/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Modality'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modality/modality-detail.html',
                    controller: 'ModalityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Modality', function($stateParams, Modality) {
                    return Modality.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'modality',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('modality-detail.edit', {
            parent: 'modality-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modality/modality-dialog.html',
                    controller: 'ModalityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modality', function(Modality) {
                            return Modality.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modality.new', {
            parent: 'modality',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modality/modality-dialog.html',
                    controller: 'ModalityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modality', null, { reload: 'modality' });
                }, function() {
                    $state.go('modality');
                });
            }]
        })
        .state('modality.edit', {
            parent: 'modality',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modality/modality-dialog.html',
                    controller: 'ModalityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modality', function(Modality) {
                            return Modality.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modality', null, { reload: 'modality' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modality.delete', {
            parent: 'modality',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modality/modality-delete-dialog.html',
                    controller: 'ModalityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Modality', function(Modality) {
                            return Modality.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modality', null, { reload: 'modality' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Modality', Modality);

    Modality.$inject = ['$resource'];

    function Modality ($resource) {
        var resourceUrl =  'api/modalities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('ModalitySearch', ModalitySearch);

    ModalitySearch.$inject = ['$resource'];

    function ModalitySearch($resource) {
        var resourceUrl =  'api/_search/modalities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ModalityController', ModalityController);

    ModalityController.$inject = ['$scope', '$state', 'Modality', 'ModalitySearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function ModalityController ($scope, $state, Modality, ModalitySearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;

        vm.modalities = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  Modality.query(function(result) {
                  vm.modalities = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.modalities, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            Modality.query(function(result) {
                vm.modalities = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedicationDialogController', MedicationDialogController);

    MedicationDialogController.$inject = ['GUIUtils', '$timeout', '$scope', 'medication', '$uibModalInstance', 'Medication', 'MedDosageUnit', 'MedRoute', 'MedFrequencyFrom', 'MedFrequencyTo', 'MedLocation', 'Patient'];

    function MedicationDialogController (GUIUtils, $timeout, $scope, medication, $uibModalInstance, Medication, MedDosageUnit, MedRoute, MedFrequencyFrom, MedFrequencyTo, MedLocation, Patient) {
        var vm = this;

        vm.medication = medication;
        vm.clear = clear;
        vm.save = save;
        vm.meddosageunits = MedDosageUnit.query();
        vm.medroutes = MedRoute.query();
        vm.medfrequencyfroms = MedFrequencyFrom.query();
        vm.medfrequencytos = MedFrequencyTo.query();
        vm.medlocations = MedLocation.query();

        vm.days = GUIUtils.getDays();

        if (vm.medication.days) {
            vm.medication.days2 = GUIUtils.weekCodeStringToDays(vm.medication.days);
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.medication.days = GUIUtils.daysToWeekCodeString(vm.medication.days2);

            if (vm.medication.id !== null) {
                Medication.update(vm.medication, onSaveSuccess, onSaveError);
            } else {
                Medication.save(vm.medication, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:medicationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedicationDetailController', MedicationDetailController);

    MedicationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Medication', 'MedDosageUnit', 'MedRoute', 'MedFrequencyFrom', 'MedFrequencyTo', 'MedLocation', 'Patient'];

    function MedicationDetailController($scope, $rootScope, $stateParams, previousState, entity, Medication, MedDosageUnit, MedRoute, MedFrequencyFrom, MedFrequencyTo, MedLocation, Patient) {
        var vm = this;

        vm.medication = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:medicationUpdate', function(event, result) {
            vm.medication = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedicationDeleteController',MedicationDeleteController);

    MedicationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Medication'];

    function MedicationDeleteController($uibModalInstance, entity, Medication) {
        var vm = this;

        vm.medication = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Medication.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('medication-new', {
            parent: 'patient-detail',
            url: '/medication-new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/entities/medication/medication-dialog.html',
                    controller: 'MedicationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        medication: function () {
                            return {
                                mType: null,
                                brand: null,
                                dosage: null,
                                physician: null,
                                otherFreq: null,
                                days: null,
                                adminOnDialysis: false,
                                instructions: null,
                                specialInstructions: null,
                                id: null,
                                patient: entity
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('patient-detail', null, { reload: 'patient-detail'});
                }, function() {
                    $state.go('patient-detail');
                });
            }]
        })
        .state('medication-edit', {
            parent: 'patient-detail',
            url: '/{mid}/medit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medication/medication-dialog.html',
                    controller: 'MedicationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        medication: ['Medication', function(Medication) {
                            return Medication.get({id : $stateParams.mid}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-detail', null, { reload: 'patient-detail'});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('medication-delete', {
            parent: 'patient-detail',
            url: '/{mid}/medelete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medication/medication-delete-dialog.html',
                    controller: 'MedicationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Medication', function(Medication) {
                            return Medication.get({id : $stateParams.mid}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('patient-detail', null, { reload: 'patient-detail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Medication', Medication);

    Medication.$inject = ['$resource'];

    function Medication ($resource) {
        var resourceUrl =  'api/medications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByPatientId': { 'url': 'api/medications/patient/:id', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('MedicationSearch', MedicationSearch);

    MedicationSearch.$inject = ['$resource'];

    function MedicationSearch($resource) {
        var resourceUrl =  'api/_search/medications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedicationController', MedicationController);

    MedicationController.$inject = ['entity', '$scope', '$state', 'Medication', 'MedicationSearch', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function MedicationController(entity, $scope, $state, Medication, MedicationSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile) {
        var vm = this;
        vm.title = 'Medications';
        vm.entityClassHumanized = 'Medication';
        vm.entityClass = 'medication';

        vm.medications = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.patient = entity;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                Medication.getAllByPatientId({id: vm.patient.id}, function (result) {
                    vm.medications = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.medications, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('mType').withTitle('Type'),
            DTColumnBuilder.newColumn('brand').withTitle('Brand'),
            DTColumnBuilder.newColumn('dosage').withTitle('Dosage'),
            DTColumnBuilder.newColumn(null).withTitle('Units').renderWith(function (data, type, full) {
                return data.unit.name;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="medication-edit({mid:' + data.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            if (vm.patient.status) {
                stButtons += '<a class="btn-sm btn-danger" ui-sref="medication-delete({mid:' + data.id + '})">' +
                    '   <i class="fa fa-trash"></i></a>';
            }

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedRouteDialogController', MedRouteDialogController);

    MedRouteDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'MedRoute', 'Medication'];

    function MedRouteDialogController ($timeout, $scope, $uibModalInstance, entity, MedRoute, Medication) {
        var vm = this;

        vm.medRoute = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medRoute.id !== null) {
                MedRoute.update(vm.medRoute, onSaveSuccess, onSaveError);
            } else {
                MedRoute.save(vm.medRoute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:medRouteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedRouteDetailController', MedRouteDetailController);

    MedRouteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MedRoute', 'Medication', 'Corporation'];

    function MedRouteDetailController($scope, $rootScope, $stateParams, previousState, entity, MedRoute, Medication, Corporation) {
        var vm = this;

        vm.medRoute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:medRouteUpdate', function(event, result) {
            vm.medRoute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedRouteDeleteController',MedRouteDeleteController);

    MedRouteDeleteController.$inject = ['$uibModalInstance', 'entity', 'MedRoute'];

    function MedRouteDeleteController($uibModalInstance, entity, MedRoute) {
        var vm = this;

        vm.medRoute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MedRoute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-route', {
            parent: 'entity',
            url: '/med-route',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Routes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-route/med-routes.html',
                    controller: 'MedRouteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('med-route-detail', {
            parent: 'entity',
            url: '/med-route/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Route'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-route/med-route-detail.html',
                    controller: 'MedRouteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MedRoute', function($stateParams, MedRoute) {
                    return MedRoute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'med-route',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('med-route-detail.edit', {
            parent: 'med-route-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-route/med-route-dialog.html',
                    controller: 'MedRouteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedRoute', function(MedRoute) {
                            return MedRoute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-route.new', {
            parent: 'med-route',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-route/med-route-dialog.html',
                    controller: 'MedRouteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-route', null, { reload: 'med-route' });
                }, function() {
                    $state.go('med-route');
                });
            }]
        })
        .state('med-route.edit', {
            parent: 'med-route',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-route/med-route-dialog.html',
                    controller: 'MedRouteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedRoute', function(MedRoute) {
                            return MedRoute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-route', null, { reload: 'med-route' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-route.delete', {
            parent: 'med-route',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-route/med-route-delete-dialog.html',
                    controller: 'MedRouteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedRoute', function(MedRoute) {
                            return MedRoute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-route', null, { reload: 'med-route' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('MedRoute', MedRoute);

    MedRoute.$inject = ['$resource'];

    function MedRoute ($resource) {
        var resourceUrl =  'api/med-routes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('MedRouteSearch', MedRouteSearch);

    MedRouteSearch.$inject = ['$resource'];

    function MedRouteSearch($resource) {
        var resourceUrl =  'api/_search/med-routes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedRouteController', MedRouteController);

    MedRouteController.$inject = ['$scope', '$state', 'MedRoute', 'MedRouteSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function MedRouteController ($scope, $state, MedRoute, MedRouteSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile ) {
        var vm = this;
        vm.title = 'Med Routes';
        vm.entityClassHumanized = 'Med Route';
        vm.entityClass = 'med-route';

        vm.medRoutes = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  MedRoute.query(function(result) {
                  vm.medRoutes = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.medRoutes, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
        .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $compile(nRow)($scope);
        });

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            MedRoute.query(function(result) {
                vm.medRoutes = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedLocationDialogController', MedLocationDialogController);

    MedLocationDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'MedLocation', 'Medication'];

    function MedLocationDialogController ($timeout, $scope, $uibModalInstance, entity, MedLocation, Medication) {
        var vm = this;

        vm.medLocation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medLocation.id !== null) {
                MedLocation.update(vm.medLocation, onSaveSuccess, onSaveError);
            } else {
                MedLocation.save(vm.medLocation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:medLocationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedLocationDetailController', MedLocationDetailController);

    MedLocationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MedLocation', 'Medication', 'Corporation'];

    function MedLocationDetailController($scope, $rootScope, $stateParams, previousState, entity, MedLocation, Medication, Corporation) {
        var vm = this;

        vm.medLocation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:medLocationUpdate', function(event, result) {
            vm.medLocation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedLocationDeleteController',MedLocationDeleteController);

    MedLocationDeleteController.$inject = ['$uibModalInstance', 'entity', 'MedLocation'];

    function MedLocationDeleteController($uibModalInstance, entity, MedLocation) {
        var vm = this;

        vm.medLocation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MedLocation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-location', {
            parent: 'entity',
            url: '/med-location',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Locations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-location/med-locations.html',
                    controller: 'MedLocationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('med-location-detail', {
            parent: 'entity',
            url: '/med-location/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Location'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-location/med-location-detail.html',
                    controller: 'MedLocationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MedLocation', function($stateParams, MedLocation) {
                    return MedLocation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'med-location',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('med-location-detail.edit', {
            parent: 'med-location-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-location/med-location-dialog.html',
                    controller: 'MedLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedLocation', function(MedLocation) {
                            return MedLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-location.new', {
            parent: 'med-location',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-location/med-location-dialog.html',
                    controller: 'MedLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-location', null, { reload: 'med-location' });
                }, function() {
                    $state.go('med-location');
                });
            }]
        })
        .state('med-location.edit', {
            parent: 'med-location',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-location/med-location-dialog.html',
                    controller: 'MedLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedLocation', function(MedLocation) {
                            return MedLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-location', null, { reload: 'med-location' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-location.delete', {
            parent: 'med-location',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-location/med-location-delete-dialog.html',
                    controller: 'MedLocationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedLocation', function(MedLocation) {
                            return MedLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-location', null, { reload: 'med-location' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('MedLocation', MedLocation);

    MedLocation.$inject = ['$resource'];

    function MedLocation ($resource) {
        var resourceUrl =  'api/med-locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('MedLocationSearch', MedLocationSearch);

    MedLocationSearch.$inject = ['$resource'];

    function MedLocationSearch($resource) {
        var resourceUrl =  'api/_search/med-locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedLocationController', MedLocationController);

    MedLocationController.$inject = ['$scope', '$state', 'MedLocation', 'MedLocationSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function MedLocationController ($scope, $state, MedLocation, MedLocationSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile ) {
        var vm = this;
        vm.title = 'Med Locations';
        vm.entityClassHumanized = 'Med Location';
        vm.entityClass = 'med-location';

        vm.medLocations = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  MedLocation.query(function(result) {
                  vm.medLocations = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.medLocations, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
        .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $compile(nRow)($scope);
        });

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            MedLocation.query(function(result) {
                vm.medLocations = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyToDialogController', MedFrequencyToDialogController);

    MedFrequencyToDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MedFrequencyTo', 'Medication', 'Corporation'];

    function MedFrequencyToDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MedFrequencyTo, Medication, Corporation) {
        var vm = this;

        vm.medFrequencyTo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medFrequencyTo.id !== null) {
                MedFrequencyTo.update(vm.medFrequencyTo, onSaveSuccess, onSaveError);
            } else {
                MedFrequencyTo.save(vm.medFrequencyTo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:medFrequencyToUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyToDetailController', MedFrequencyToDetailController);

    MedFrequencyToDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MedFrequencyTo', 'Medication', 'Corporation'];

    function MedFrequencyToDetailController($scope, $rootScope, $stateParams, previousState, entity, MedFrequencyTo, Medication, Corporation) {
        var vm = this;

        vm.medFrequencyTo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:medFrequencyToUpdate', function(event, result) {
            vm.medFrequencyTo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyToDeleteController',MedFrequencyToDeleteController);

    MedFrequencyToDeleteController.$inject = ['$uibModalInstance', 'entity', 'MedFrequencyTo'];

    function MedFrequencyToDeleteController($uibModalInstance, entity, MedFrequencyTo) {
        var vm = this;

        vm.medFrequencyTo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MedFrequencyTo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-frequency-to', {
            parent: 'entity',
            url: '/med-frequency-to',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Frequency To'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-frequency-to/med-frequency-tos.html',
                    controller: 'MedFrequencyToController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('med-frequency-to-detail', {
            parent: 'entity',
            url: '/med-frequency-to/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Frequency To'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-frequency-to/med-frequency-to-detail.html',
                    controller: 'MedFrequencyToDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MedFrequencyTo', function($stateParams, MedFrequencyTo) {
                    return MedFrequencyTo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'med-frequency-to',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('med-frequency-to-detail.edit', {
            parent: 'med-frequency-to-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-to/med-frequency-to-dialog.html',
                    controller: 'MedFrequencyToDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedFrequencyTo', function(MedFrequencyTo) {
                            return MedFrequencyTo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-frequency-to.new', {
            parent: 'med-frequency-to',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-to/med-frequency-to-dialog.html',
                    controller: 'MedFrequencyToDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-frequency-to', null, { reload: 'med-frequency-to' });
                }, function() {
                    $state.go('med-frequency-to');
                });
            }]
        })
        .state('med-frequency-to.edit', {
            parent: 'med-frequency-to',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-to/med-frequency-to-dialog.html',
                    controller: 'MedFrequencyToDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedFrequencyTo', function(MedFrequencyTo) {
                            return MedFrequencyTo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-frequency-to', null, { reload: 'med-frequency-to' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-frequency-to.delete', {
            parent: 'med-frequency-to',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-to/med-frequency-to-delete-dialog.html',
                    controller: 'MedFrequencyToDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedFrequencyTo', function(MedFrequencyTo) {
                            return MedFrequencyTo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-frequency-to', null, { reload: 'med-frequency-to' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('MedFrequencyTo', MedFrequencyTo);

    MedFrequencyTo.$inject = ['$resource'];

    function MedFrequencyTo ($resource) {
        var resourceUrl =  'api/med-frequency-tos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('MedFrequencyToSearch', MedFrequencyToSearch);

    MedFrequencyToSearch.$inject = ['$resource'];

    function MedFrequencyToSearch($resource) {
        var resourceUrl =  'api/_search/med-frequency-tos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyToController', MedFrequencyToController);

    MedFrequencyToController.$inject = ['$scope', '$state', 'MedFrequencyTo', 'MedFrequencyToSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function MedFrequencyToController ($scope, $state, MedFrequencyTo, MedFrequencyToSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile ) {
        var vm = this;
        vm.title = 'Med Frequency Tos';
        vm.entityClassHumanized = 'Med Frequency To';
        vm.entityClass = 'med-frequency-to';

        vm.medFrequencyTos = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  MedFrequencyTo.query(function(result) {
                  vm.medFrequencyTos = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.medFrequencyTos, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
        .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $compile(nRow)($scope);
        });

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            MedFrequencyTo.query(function(result) {
                vm.medFrequencyTos = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyFromDialogController', MedFrequencyFromDialogController);

    MedFrequencyFromDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'MedFrequencyFrom', 'Medication'];

    function MedFrequencyFromDialogController ($timeout, $scope, $uibModalInstance, entity, MedFrequencyFrom, Medication) {
        var vm = this;

        vm.medFrequencyFrom = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medFrequencyFrom.id !== null) {
                MedFrequencyFrom.update(vm.medFrequencyFrom, onSaveSuccess, onSaveError);
            } else {
                MedFrequencyFrom.save(vm.medFrequencyFrom, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:medFrequencyFromUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyFromDetailController', MedFrequencyFromDetailController);

    MedFrequencyFromDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MedFrequencyFrom', 'Medication', 'Corporation'];

    function MedFrequencyFromDetailController($scope, $rootScope, $stateParams, previousState, entity, MedFrequencyFrom, Medication, Corporation) {
        var vm = this;

        vm.medFrequencyFrom = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:medFrequencyFromUpdate', function(event, result) {
            vm.medFrequencyFrom = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyFromDeleteController',MedFrequencyFromDeleteController);

    MedFrequencyFromDeleteController.$inject = ['$uibModalInstance', 'entity', 'MedFrequencyFrom'];

    function MedFrequencyFromDeleteController($uibModalInstance, entity, MedFrequencyFrom) {
        var vm = this;

        vm.medFrequencyFrom = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MedFrequencyFrom.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-frequency-from', {
            parent: 'entity',
            url: '/med-frequency-from',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Frequency From'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-frequency-from/med-frequency-froms.html',
                    controller: 'MedFrequencyFromController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('med-frequency-from-detail', {
            parent: 'entity',
            url: '/med-frequency-from/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Frequency From'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-frequency-from/med-frequency-from-detail.html',
                    controller: 'MedFrequencyFromDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MedFrequencyFrom', function($stateParams, MedFrequencyFrom) {
                    return MedFrequencyFrom.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'med-frequency-from',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('med-frequency-from-detail.edit', {
            parent: 'med-frequency-from-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-from/med-frequency-from-dialog.html',
                    controller: 'MedFrequencyFromDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedFrequencyFrom', function(MedFrequencyFrom) {
                            return MedFrequencyFrom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-frequency-from.new', {
            parent: 'med-frequency-from',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-from/med-frequency-from-dialog.html',
                    controller: 'MedFrequencyFromDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-frequency-from', null, { reload: 'med-frequency-from' });
                }, function() {
                    $state.go('med-frequency-from');
                });
            }]
        })
        .state('med-frequency-from.edit', {
            parent: 'med-frequency-from',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-from/med-frequency-from-dialog.html',
                    controller: 'MedFrequencyFromDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedFrequencyFrom', function(MedFrequencyFrom) {
                            return MedFrequencyFrom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-frequency-from', null, { reload: 'med-frequency-from' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-frequency-from.delete', {
            parent: 'med-frequency-from',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-from/med-frequency-from-delete-dialog.html',
                    controller: 'MedFrequencyFromDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedFrequencyFrom', function(MedFrequencyFrom) {
                            return MedFrequencyFrom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-frequency-from', null, { reload: 'med-frequency-from' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('MedFrequencyFrom', MedFrequencyFrom);

    MedFrequencyFrom.$inject = ['$resource'];

    function MedFrequencyFrom ($resource) {
        var resourceUrl =  'api/med-frequency-froms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('MedFrequencyFromSearch', MedFrequencyFromSearch);

    MedFrequencyFromSearch.$inject = ['$resource'];

    function MedFrequencyFromSearch($resource) {
        var resourceUrl =  'api/_search/med-frequency-froms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyFromController', MedFrequencyFromController);

    MedFrequencyFromController.$inject = ['$scope', '$state', 'MedFrequencyFrom', 'MedFrequencyFromSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function MedFrequencyFromController ($scope, $state, MedFrequencyFrom, MedFrequencyFromSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile ) {
        var vm = this;
        vm.title = 'Med Frequency Froms';
        vm.entityClassHumanized = 'Med Frequency From';
        vm.entityClass = 'med-frequency-from';

        vm.medFrequencyFroms = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  MedFrequencyFrom.query(function(result) {
                  vm.medFrequencyFroms = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.medFrequencyFroms, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
        .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $compile(nRow)($scope);
        });

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            MedFrequencyFrom.query(function(result) {
                vm.medFrequencyFroms = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedDosageUnitDialogController', MedDosageUnitDialogController);

    MedDosageUnitDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MedDosageUnit', 'Medication', 'Corporation'];

    function MedDosageUnitDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MedDosageUnit, Medication, Corporation) {
        var vm = this;

        vm.medDosageUnit = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.medDosageUnit.id !== null) {
                MedDosageUnit.update(vm.medDosageUnit, onSaveSuccess, onSaveError);
            } else {
                MedDosageUnit.save(vm.medDosageUnit, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:medDosageUnitUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedDosageUnitDetailController', MedDosageUnitDetailController);

    MedDosageUnitDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MedDosageUnit', 'Medication', 'Corporation'];

    function MedDosageUnitDetailController($scope, $rootScope, $stateParams, previousState, entity, MedDosageUnit, Medication, Corporation) {
        var vm = this;

        vm.medDosageUnit = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:medDosageUnitUpdate', function(event, result) {
            vm.medDosageUnit = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedDosageUnitDeleteController',MedDosageUnitDeleteController);

    MedDosageUnitDeleteController.$inject = ['$uibModalInstance', 'entity', 'MedDosageUnit'];

    function MedDosageUnitDeleteController($uibModalInstance, entity, MedDosageUnit) {
        var vm = this;

        vm.medDosageUnit = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MedDosageUnit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-dosage-unit', {
            parent: 'entity',
            url: '/med-dosage-unit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Dosage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-dosage-unit/med-dosage-units.html',
                    controller: 'MedDosageUnitController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('med-dosage-unit-detail', {
            parent: 'entity',
            url: '/med-dosage-unit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Dosage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-dosage-unit/med-dosage-unit-detail.html',
                    controller: 'MedDosageUnitDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MedDosageUnit', function($stateParams, MedDosageUnit) {
                    return MedDosageUnit.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'med-dosage-unit',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('med-dosage-unit-detail.edit', {
            parent: 'med-dosage-unit-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-dosage-unit/med-dosage-unit-dialog.html',
                    controller: 'MedDosageUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedDosageUnit', function(MedDosageUnit) {
                            return MedDosageUnit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-dosage-unit.new', {
            parent: 'med-dosage-unit',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-dosage-unit/med-dosage-unit-dialog.html',
                    controller: 'MedDosageUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-dosage-unit', null, { reload: 'med-dosage-unit' });
                }, function() {
                    $state.go('med-dosage-unit');
                });
            }]
        })
        .state('med-dosage-unit.edit', {
            parent: 'med-dosage-unit',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-dosage-unit/med-dosage-unit-dialog.html',
                    controller: 'MedDosageUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedDosageUnit', function(MedDosageUnit) {
                            return MedDosageUnit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-dosage-unit', null, { reload: 'med-dosage-unit' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-dosage-unit.delete', {
            parent: 'med-dosage-unit',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-dosage-unit/med-dosage-unit-delete-dialog.html',
                    controller: 'MedDosageUnitDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedDosageUnit', function(MedDosageUnit) {
                            return MedDosageUnit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-dosage-unit', null, { reload: 'med-dosage-unit' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('MedDosageUnit', MedDosageUnit);

    MedDosageUnit.$inject = ['$resource'];

    function MedDosageUnit ($resource) {
        var resourceUrl =  'api/med-dosage-units/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('MedDosageUnitSearch', MedDosageUnitSearch);

    MedDosageUnitSearch.$inject = ['$resource'];

    function MedDosageUnitSearch($resource) {
        var resourceUrl =  'api/_search/med-dosage-units/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedDosageUnitController', MedDosageUnitController);

    MedDosageUnitController.$inject = ['$scope', '$state', 'MedDosageUnit', 'MedDosageUnitSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function MedDosageUnitController ($scope, $state, MedDosageUnit, MedDosageUnitSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile ) {
        var vm = this;
        vm.title = 'Med Dosage Units';
        vm.entityClassHumanized = 'Med Dosage Unit';
        vm.entityClass = 'med-dosage-unit';

        vm.medDosageUnits = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  MedDosageUnit.query(function(result) {
                  vm.medDosageUnits = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.medDosageUnits, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
        .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $compile(nRow)($scope);
        });

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            MedDosageUnit.query(function(result) {
                vm.medDosageUnits = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MachineSelectFilter', MachineSelectFilter);

    MachineSelectFilter.$inject = ['clinic', '$state', 'Machine', 'CoreService', '$uibModal'];

    function MachineSelectFilter(clinic, $state, Machine, CoreService, $uibModal) {
        var vm = this;
        vm.title = 'Sites';
        vm.entityClassHumanized = 'Sites';
        vm.entityClass = 'machine';

        vm.machines = [{id: -1, name: '<b>All Machines</b>', location: 'All locations', mType: 'All types'}];
        vm.machinesOrigin = [];

        Machine.get_all_active({"id": clinic.id
        // MachineSearch.query({
        //     query: {
        //         bool: {
        //             must: [
        //                 {term: {"clinic.id": clinic.id}},
        //                 {term: {"delStatus": false}},
        //                 {term: {"mStatus": true}}
        //             ]
        //         }
        //     }
        }, function (result) {
            vm.machinesOrigin = result;
            result.forEach(function (item) {
                vm.machines.push(item);
            })
        });

        vm.machine = CoreService.getCurrentMachine();

        vm.selectMachine = function () {
            if (vm.machine.id == -1) {
                $uibModal.open({
                    templateUrl: 'app/entities/machine/machine-select-dialog.html',
                    controller: 'MachineSelectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        clinic: clinic,
                        machines: {selected: []}
                    }
                }).result.then(function (result) {
                    $state.go("env-order-new-all", {machines: result.machines, allMachines: vm.machinesOrigin}, {reload: true});
                }, function () {
                    vm.machine = CoreService.getCurrentMachine();
                });
            } else {
                CoreService.setCurrentMachine(vm.machine);
                $state.go("env-order", {id: vm.machine.id}, {reload: true});
            }
        };

        vm.removeMachine = function () {
            CoreService.removeCurrentMachine();
            $state.go("machine", {}, {reload: true});
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MachineSelectDialogController', MachineSelectDialogController);

    MachineSelectDialogController.$inject = ['$uibModalInstance', '$scope', 'clinic', 'Machine', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'machines'];

    function MachineSelectDialogController($uibModalInstance, $scope, clinic, Machine, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, machines) {
        var vm = this;
        vm.machines = machines.selected;

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.accept = function () {
            var machines = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    var _machine = $.grep(vm.machinesList, function (machine, i) {
                        return machine.id == id;
                    })[0];

                    machines.push(_machine);
                }
            }

            if (machines.length > 0) {
                $uibModalInstance.close({machines: machines});
            }
        }

        vm.machinesList = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.machinesList);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                // MachineSearch.query({
                //     query: {
                //         bool: {
                //             must: [
                //                 {term: {"clinic.id": clinic.id}},
                //                 {term: {"delStatus": false}},
                //                 {term: {"mStatus": true}}
                //             ]
                //         }
                //     }
                // }, function (result) {
                //     vm.machinesList = result;
                //     defer.resolve(result);
                // });

                Machine.get_all_active({"id": clinic.id
                }, function (result) {
                    vm.machinesList = result;
                    defer.resolve(result);
                });

            } else {
                defer.resolve($filter('filter')(vm.machinesList, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            }).withOption('aaSorting', [[1, 'ASC']]);

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                var _machine = $.grep(vm.machines, function (machine, i) {
                    return machine.id == data.id;
                })[0];

                vm.selected[full.id] = _machine != null;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Location').renderWith(function (data, type, full) {
                return data.siteLocation ? data.siteLocation.name : null;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Active').renderWith(function (data, type, full) {
                return data.mStatus ? GUIUtils.getStatusTemplate('Yes', 'success') : GUIUtils.getStatusTemplate('No', 'danger');
            }),
            DTColumnBuilder.newColumn('mType').withTitle('Type'),
        ];

        function search() {
            vm.dtInstance.reloadData();
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }

            vm.selectAll = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MachineMenuController', MachineMenuController);

    MachineMenuController.$inject = ['$stateParams', '$state', '$uibModal', 'CoreService'];

    function MachineMenuController($stateParams, $state, $uibModal, CoreService) {
        var machine = CoreService.getCurrentMachine();

        if (machine) {
            switch ($stateParams.statem) {
                case 'env-order':
                    $state.go("env-order", {"id": machine.id});
                    break;
                case 'latest-env-result':
                    $state.go("machine-env-result", {"id": machine.id});
                    break;
            }
        } else {
            switch ($stateParams.statem) {
                case 'latest-env-result' :
                    $state.go("latest-env-result");
                    break;
                default : {
                    $state.go("machine");
                    // $uibModal.open({
                    //     templateUrl: 'app/entities/machine/machine-menu-dialog.html',
                    //     controller: ['$uibModalInstance', function ($uibModalInstance) {
                    //         var vm = this;
                    //
                    //         vm.dashboard = dashboard;
                    //
                    //         function dashboard() {
                    //             $uibModalInstance.dismiss('cancel');
                    //             $state.go("home");
                    //         }
                    //
                    //         vm.machine = machine;
                    //
                    //         function machine() {
                    //             $uibModalInstance.dismiss('cancel');
                    //             $state.go("machine");
                    //         }
                    //     }],
                    //     controllerAs: 'vm',
                    //     backdrop: 'static',
                    //     size: 'sm'
                    // });
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MachineDialogController', MachineDialogController);

    MachineDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Machine', 'SiteLocation'];

    function MachineDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Machine, SiteLocation) {
        var vm = this;

        vm.machine = entity;
        vm.clear = clear;
        vm.save = save;
        vm.siteLocations  =  SiteLocation.getAllByClinic({id: vm.machine.clinic.id});

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.machine.id !== null) {
                Machine.update(vm.machine, onSaveSuccess, onSaveError);
            } else {
                Machine.save(vm.machine, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:machineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MachineDetailController', MachineDetailController);

    MachineDetailController.$inject = ['$scope', '$rootScope', 'CoreService', 'previousState', 'machine', 'Machine', 'EnvOrder', 'Clinic'];

    function MachineDetailController($scope, $rootScope, CoreService, previousState, machine, Machine, EnvOrder, Clinic) {
        var vm = this;

        vm.machine = machine;
        CoreService.setCurrentMachine(machine);
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:machineUpdate', function(event, result) {
            vm.machine = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MachineDeleteController',MachineDeleteController);

    MachineDeleteController.$inject = ['$uibModalInstance', 'entity', 'Machine'];

    function MachineDeleteController($uibModalInstance, entity, Machine) {
        var vm = this;

        vm.machine = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Machine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('machine', {
                parent: 'entity',
                url: '/machine',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Sites'
                },
                ncyBreadcrumb: {
                    label: 'Sites'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/machine/machines.html',
                        controller: 'MachineController',
                        controllerAs: 'vm'
                    },
                    // 'select-filter@machine': {
                    //     templateUrl: 'app/entities/machine/machine-select-filter.html',
                    //     controller: 'MachineSelectFilter',
                    //     controllerAs: 'vm'
                    // }
                },
                resolve: {
                    clinic: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentClinic();
                    }]
                }
            })
            .state('machine-detail', {
                abstract: true,
                parent: 'entity',
                url: '/machine/{id}',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Site'
                },
                ncyBreadcrumb: {
                    label: 'Orders',
                    parent: 'machine'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/machine/machine-detail.html',
                        controller: 'MachineDetailController',
                        controllerAs: 'vm'
                    },
                    'select-filter@machine-detail': {
                        templateUrl: 'app/entities/machine/machine-select-filter.html',
                        controller: 'MachineSelectFilter',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    machine: ['$state', '$stateParams', 'Machine', function ($state, $stateParams, Machine) {
                        return Machine.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'machine',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }],
                    clinic: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentClinic();
                    }]
                }
            })
            .state('machine-detail-menu', {
                parent: 'entity',
                url: '/machine-menu/{statem}',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Machine'
                },
                views: {
                    'content@': {
                        controller: 'MachineMenuController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('machine.new', {
                parent: 'machine',
                url: '/new',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/machine/machine-dialog.html',
                        controller: 'MachineDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: ['CoreService', function (CoreService) {
                                return {
                                    name: null,
                                    location: null,
                                    mStatus: true,
                                    mType: null,
                                    notes: null,
                                    id: null,
                                    clinic: CoreService.getCurrentClinic()
                                };
                            }]
                        }
                    }).result.then(function () {
                        $state.go('machine', null, {reload: 'machine'});
                    }, function () {
                        $state.go('machine');
                    });
                }]
            })
            .state('machine.edit', {
                parent: 'machine',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/machine/machine-dialog.html',
                        controller: 'MachineDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            entity: ['Machine', function (Machine) {
                                return Machine.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('machine', null, {reload: 'machine'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('machine.delete', {
                parent: 'machine',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/machine/machine-delete-dialog.html',
                        controller: 'MachineDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Machine', function (Machine) {
                                return Machine.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('machine', null, {reload: 'machine'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Machine', Machine);

    Machine.$inject = ['$resource'];

    function Machine ($resource) {
        var resourceUrl =  'api/machines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByClinic': { 'url': 'api/machines/clinic/:id', method: 'GET', isArray: true},
            'get_all_active': { 'url': 'api/machines/clinic/active/:id', method: 'GET', isArray: true},
            'byBarcode': {url: 'api/machines/by-barcode/:barcode', method: 'GET'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('MachineSearch', MachineSearch);

    MachineSearch.$inject = ['$resource'];

    function MachineSearch($resource) {
        var resourceUrl =  'api/_search/machines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MachineController', MachineController);

    MachineController.$inject = ['$scope', 'clinic', 'Machine', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function MachineController($scope, clinic, Machine, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile) {
        var vm = this;
        vm.title = 'Sites';
        vm.entityClassHumanized = 'Sites';
        vm.entityClass = 'machine';

        vm.machines = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.machines);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                Machine.getAllByClinic({id : clinic.id}, function (result) {
                    vm.machines = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.machines, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Location').renderWith(function (data, type, full) {
                return data.siteLocation ? data.siteLocation.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Active').renderWith(function (data, type, full) {
                return data.mStatus ? GUIUtils.getStatusTemplate('Yes', 'success') : GUIUtils.getStatusTemplate('No', 'danger');
            }),
            DTColumnBuilder.newColumn('mType').withTitle('Type'),
            DTColumnBuilder.newColumn(null).withTitle("").withOption('width', '180px').notSortable().renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div>' +
                '<div class="btn-group" uib-dropdown>' +
                '<button type="button" class="btn btn-default" ui-sref="machine.edit({id:' + data.id + '})">Details</button>' +
                '<button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle ng-disabled="disabled" data-toggle="dropdown" aria-expanded="false">' +
                '<span class="caret"></span>' +
                '<span class="sr-only">Toggle Dropdown</span>' +
                '</button>' +
                '<ul class="dropdown-menu" uib-dropdown-menu role="menu">' +
                '<li><a ui-sref="env-order({id:' + data.id + '})">Orders</a></li>' +
                '<li><a ui-sref="machine-env-result({id:' + data.id + '})">Results</a></li>' +
                '</ul>' +
                '</div></div>';
        };

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LanguageDialogController', LanguageDialogController);

    LanguageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Language', 'Patient', 'Corporation'];

    function LanguageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Language, Patient, Corporation) {
        var vm = this;

        vm.language = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.language.id !== null) {
                Language.update(vm.language, onSaveSuccess, onSaveError);
            } else {
                Language.save(vm.language, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:languageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LanguageDetailController', LanguageDetailController);

    LanguageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Language', 'Patient', 'Corporation'];

    function LanguageDetailController($scope, $rootScope, $stateParams, previousState, entity, Language, Patient, Corporation) {
        var vm = this;

        vm.language = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:languageUpdate', function(event, result) {
            vm.language = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LanguageDeleteController',LanguageDeleteController);

    LanguageDeleteController.$inject = ['$uibModalInstance', 'entity', 'Language'];

    function LanguageDeleteController($uibModalInstance, entity, Language) {
        var vm = this;

        vm.language = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Language.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('language', {
            parent: 'entity',
            url: '/language',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Languages'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/language/languages.html',
                    controller: 'LanguageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('language-detail', {
            parent: 'entity',
            url: '/language/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Language'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/language/language-detail.html',
                    controller: 'LanguageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Language', function($stateParams, Language) {
                    return Language.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'language',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('language-detail.edit', {
            parent: 'language-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language/language-dialog.html',
                    controller: 'LanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Language', function(Language) {
                            return Language.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('language.new', {
            parent: 'language',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language/language-dialog.html',
                    controller: 'LanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('language', null, { reload: 'language' });
                }, function() {
                    $state.go('language');
                });
            }]
        })
        .state('language.edit', {
            parent: 'language',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language/language-dialog.html',
                    controller: 'LanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Language', function(Language) {
                            return Language.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('language', null, { reload: 'language' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('language.delete', {
            parent: 'language',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/language/language-delete-dialog.html',
                    controller: 'LanguageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Language', function(Language) {
                            return Language.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('language', null, { reload: 'language' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Language', Language);

    Language.$inject = ['$resource'];

    function Language ($resource) {
        var resourceUrl =  'api/languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('LanguageSearch', LanguageSearch);

    LanguageSearch.$inject = ['$resource'];

    function LanguageSearch($resource) {
        var resourceUrl =  'api/_search/languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LanguageController', LanguageController);

    LanguageController.$inject = ['$scope', '$state', 'Language', 'LanguageSearch', '$q', 'DTColumnBuilder' ,
        'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function LanguageController ($scope, $state, Language, LanguageSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.languages = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  Language.query(function(result) {
                  vm.languages = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.languages, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            Language.query(function(result) {
                vm.languages = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LabNotificationDialogController', LabNotificationDialogController);

    LabNotificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LabNotification', 'Clinic'];

    function LabNotificationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LabNotification, Clinic) {
        var vm = this;

        vm.labNotification = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.clinics = Clinic.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.labNotification.id !== null) {
                LabNotification.update(vm.labNotification, onSaveSuccess, onSaveError);
            } else {
                LabNotification.save(vm.labNotification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:labNotificationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LabNotificationDetailController', LabNotificationDetailController);

    LabNotificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'LabNotification', 'Clinic'];

    function LabNotificationDetailController($scope, $rootScope, $stateParams, previousState, entity, LabNotification, Clinic) {
        var vm = this;

        vm.labNotification = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:labNotificationUpdate', function(event, result) {
            vm.labNotification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LabNotificationDeleteController',LabNotificationDeleteController);

    LabNotificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'LabNotification'];

    function LabNotificationDeleteController($uibModalInstance, entity, LabNotification) {
        var vm = this;

        vm.labNotification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            LabNotification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lab-notification', {
            parent: 'entity',
            url: '/lab-notification',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'LabNotifications'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lab-notification/lab-notifications.html',
                    controller: 'LabNotificationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('lab-notification-detail', {
            parent: 'lab-notification',
            url: '/lab-notification/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'LabNotification'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lab-notification/lab-notification-detail.html',
                    controller: 'LabNotificationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'LabNotification', function($stateParams, LabNotification) {
                    return LabNotification.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'lab-notification',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('lab-notification-detail.edit', {
            parent: 'lab-notification-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-notification/lab-notification-dialog.html',
                    controller: 'LabNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LabNotification', function(LabNotification) {
                            return LabNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lab-notification.new', {
            parent: 'lab-notification',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-notification/lab-notification-dialog.html',
                    controller: 'LabNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                startDate: null,
                                endDate: null,
                                active: true,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lab-notification', null, { reload: 'lab-notification' });
                }, function() {
                    $state.go('lab-notification');
                });
            }]
        })
        .state('lab-notification.edit', {
            parent: 'lab-notification',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-notification/lab-notification-dialog.html',
                    controller: 'LabNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LabNotification', function(LabNotification) {
                            return LabNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('lab-notification', null, { reload: 'lab-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lab-notification.delete', {
            parent: 'lab-notification',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-notification/lab-notification-delete-dialog.html',
                    controller: 'LabNotificationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LabNotification', function(LabNotification) {
                            return LabNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('lab-notification', null, { reload: 'lab-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('LabNotification', LabNotification);

    LabNotification.$inject = ['$resource', 'DateUtils'];

    function LabNotification ($resource, DateUtils) {
        var resourceUrl =  'api/lab-notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'findAllActiveByClinic': {url: 'api/lab-notifications/by-clinic/:id', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('LabNotificationSearch', LabNotificationSearch);

    LabNotificationSearch.$inject = ['$resource'];

    function LabNotificationSearch($resource) {
        var resourceUrl =  'api/_search/lab-notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LabNotificationController', LabNotificationController);

    LabNotificationController.$inject = ['$scope', '$state', 'LabNotification', '$q', 'moment', '$rootScope',
        'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function LabNotificationController ($scope, $state, LabNotification, $q, moment, $rootScope,
                                        DTColumnBuilder , DTOptionsBuilder, GUIUtils, $filter, $compile) {
        var vm = this;
        vm.labNotification = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.entityClassHumanized = 'Lab Notification';
        vm.title = 'Lab Notifications';
        vm.entityStateName = 'lab-notification';

        vm.loadAll = loadAll();

        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                LabNotification.query( function (result) {
                    vm.labNotification = result;
                    defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.labNotification, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.description && data.description.length > 30 ? data.description.substr(1, 30) + "..." : data.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return data.startDate ? moment(data.startDate).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return data.endDate ? moment(data.endDate).format($rootScope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Type').renderWith(function (data) {
                return data.type ? data.type.replace("_", " ") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Active').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.active);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Top Priority').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.topPriority);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }


        function loadAll() {
            LabNotification.query(function(result) {
                vm.labNotifications = result;
                vm.searchQuery = null;
            });
        }

        function search () {
            vm.dtInstance.reloadData();
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LabBundleBillingCodeDialogController', LabBundleBillingCodeDialogController);

    LabBundleBillingCodeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LabBundleBillingCode'];

    function LabBundleBillingCodeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LabBundleBillingCode) {
        var vm = this;

        vm.labBundleBillingCode = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.labBundleBillingCode.id !== null) {
                LabBundleBillingCode.update(vm.labBundleBillingCode, onSaveSuccess, onSaveError);
            } else {
                LabBundleBillingCode.save(vm.labBundleBillingCode, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:labBundleBillingCodeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LabBundleBillingCodeDeleteController',LabBundleBillingCodeDeleteController);

    LabBundleBillingCodeDeleteController.$inject = ['$uibModalInstance', 'entity', 'LabBundleBillingCode'];

    function LabBundleBillingCodeDeleteController($uibModalInstance, entity, LabBundleBillingCode) {
        var vm = this;

        vm.labBundleBillingCode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            LabBundleBillingCode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lab-bundle-billing-code', {
            parent: 'entity',
            url: '/lab-bundle-billing-code',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'LabBundleBillingCodes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lab-bundle-billing-code/lab-bundle-billing-codes.html',
                    controller: 'LabBundleBillingCodeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('lab-bundle-billing-code-detail.edit', {
            parent: 'lab-bundle-billing-code-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-bundle-billing-code/lab-bundle-billing-code-dialog.html',
                    controller: 'LabBundleBillingCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['LabBundleBillingCode', function(LabBundleBillingCode) {
                            return LabBundleBillingCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lab-bundle-billing-code.new', {
            parent: 'lab-bundle-billing-code',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-bundle-billing-code/lab-bundle-billing-code-dialog.html',
                    controller: 'LabBundleBillingCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                testCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lab-bundle-billing-code', null, { reload: 'lab-bundle-billing-code' });
                }, function() {
                    $state.go('lab-bundle-billing-code');
                });
            }]
        })
        .state('lab-bundle-billing-code.edit', {
            parent: 'lab-bundle-billing-code',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-bundle-billing-code/lab-bundle-billing-code-dialog.html',
                    controller: 'LabBundleBillingCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LabBundleBillingCode', function(LabBundleBillingCode) {
                            return LabBundleBillingCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('lab-bundle-billing-code', null, { reload: 'lab-bundle-billing-code' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lab-bundle-billing-code.delete', {
            parent: 'lab-bundle-billing-code',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-bundle-billing-code/lab-bundle-billing-code-delete-dialog.html',
                    controller: 'LabBundleBillingCodeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LabBundleBillingCode', function(LabBundleBillingCode) {
                            return LabBundleBillingCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('lab-bundle-billing-code', null, { reload: 'lab-bundle-billing-code' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('LabBundleBillingCode', LabBundleBillingCode);

    LabBundleBillingCode.$inject = ['$resource'];

    function LabBundleBillingCode ($resource) {
        var resourceUrl =  'api/lab-bundle-billing-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'init2': { method:'GET', url: 'api/lab-bundle-billing-codes/init'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('LabBundleBillingCodeSearch', LabBundleBillingCodeSearch);

    LabBundleBillingCodeSearch.$inject = ['$resource'];

    function LabBundleBillingCodeSearch($resource) {
        var resourceUrl =  'api/_search/lab-bundle-billing-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LabBundleBillingCodeController', LabBundleBillingCodeController);

    LabBundleBillingCodeController.$inject = ['dialogs', '$state', 'LabBundleBillingCode', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils'];

    function LabBundleBillingCodeController ($dialogs, $state, LabBundleBillingCode, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils) {
        var vm = this;

        vm.labBundleBillingCodes = [];

        vm.search = search;
        vm.loadAll = loadAll;
        vm.init = init;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                LabBundleBillingCode.query(function (result) {
                    vm.labBundleBillingCodes = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.races, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('testCode').withTitle('Test Code'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function loadAll() {
            Race.query(function (result) {
                vm.labBundleBillingCodes = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function init() {
            var dlg = $dialogs.confirm('Please Confirm','Reset all Codes? All current codes will be removed', {size: 'md'});
            dlg.result.then(function(btn){
                LabBundleBillingCode.init2(function () {
                    vm.dtInstance.reloadData();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('KineticSentController', KineticSentController);

    KineticSentController.$inject = ['KineticSearch', '$q', 'DTColumnBuilder', 'Clinic', '$scope', '$compile', '$uibModal',
        'DTOptionsBuilder', 'CoreService', '$filter', 'GUIUtils', 'filterData', 'DateUtils'];

    function KineticSentController(KineticSearch, $q, DTColumnBuilder, Clinic, $scope, $compile, $uibModal,
                                   DTOptionsBuilder, CoreService, $filter, GUIUtils, filterData, DateUtils) {
        var vm = this;
        vm.title = 'Kinetics';
        vm.entityClassHumanized = 'Kinetic';
        vm.entityStateName = 'kinetic';
        vm.editForm = {};
        vm.filterData = filterData;
        vm.clinics = Clinic.query();

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dob = false;
        vm.datePickerOpenStatus.sentStart = false;
        vm.datePickerOpenStatus.sentEnd = false;
        vm.datePickerOpenStatus.scheduleStart = false;
        vm.datePickerOpenStatus.scheduleEnd = false;

        vm.dtInstance = {};
        vm.clinic = CoreService.getCurrentClinic();
        vm.showFilter = false;

        vm.openCalendar = openCalendar;
        vm.filter = filter;
        vm.lessFilter = lessFilter;
        vm.search = search;
        vm.addKinetic = addKinetic;

        vm.popoverFilterEnable = popoverFilterEnable;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                KineticSearch.query({
                    query: {
                        bool: {
                            must: filter()
                        }
                    }
                }, function (result) {
                    vm.kinetic = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.kinetic, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('tip')
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('ID').renderWith(function (data, type, full) {
                return data.id;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Name').renderWith(function (data, type, full) {
                return data.patient ?
                    (data.patient.lastName + ', ' + data.patient.firstName + ' ' + (data.patient.middleInitial ? data.patient.middleInitial : ""))
                    : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return data.patient ? moment(data.patient.dob).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.barcode;
            }),
            DTColumnBuilder.newColumn('preWeight').withTitle('Pre Weight'),
            DTColumnBuilder.newColumn('posWeight').withTitle('Pos Weight'),
            DTColumnBuilder.newColumn('dialysisLength').withTitle('Length'),
            DTColumnBuilder.newColumn(null).withTitle('Created Date').renderWith(function (data, type, full) {
                return data.createdDate ? moment(data.createdDate).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Sent').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.sent);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Sent Date').renderWith(function (data, type, full) {
                return data.sent ? moment(data.sentDate).format("MM/DD/YYYY") : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Schedule Date').renderWith(function (data, type, full) {
                return data.patientOrderItem ? moment(data.patientOrderItem.scheduleDate).format("MM/DD/YYYY") : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '55px').notSortable().renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a uib-tooltip="Recalculate" class="btn btn-default btn-sm details" ' +
                'ng-click="vm.addKinetic(' + data.id + ')">' +
                '   <i class="fa fa-external-link" aria-hidden="true"></i></>&nbsp;';

            return stButtons;
        }

        function addKinetic(id) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-result-missing-data/patient-result-missing-data-dialog.html',
                controller: 'PatientResultMissingDataDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: ['Kinetic', function (Kinetic) {
                        return Kinetic.get({id: id}).$promise;
                    }],
                }
            }).result.then(function (result) {
                vm.searchQuery = '';
                vm.dtInstance.reloadData();
            });
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function filter() {
            var must = [{term: {"delStatus": false}}];

            if (vm.filterData.scheduleStart != null) {
                must.push({range: {"patientOrderItem.scheduleDate": {gte: DateUtils.convertLocalDateToServer(vm.filterData.scheduleStart)}}});
            }

            if (vm.filterData.scheduleEnd != null) {
                var end = new Date(vm.filterData.scheduleEnd);
                end.setHours(23, 59, 59);
                must.push({range: {"patientOrderItem.scheduleDate": {lte: DateUtils.convertLocalDateToServer(vm.filterData.scheduleEnd)}}});
            }

            if (vm.filterData.sentStart != null) {
                must.push({range: {createdDate: {gte: vm.filterData.sentStart}}});
            }

            if (vm.filterData.sentEnd != null) {
                var end = new Date(vm.filterData.sentEnd);
                end.setHours(23, 59, 59);
                must.push({range: {createdDate: {lte: vm.filterData.sentEnd}}});
            }

            if (vm.filterData.firstName != null && vm.filterData.firstName.length > 0) {
                must.push({match: {"patient.firstName": {query: vm.filterData.firstName, fuzziness: 2}}});
            }

            if (vm.filterData.lastName && vm.filterData.lastName.length > 0) {
                must.push({match: {"patient.lastName": {query: vm.filterData.lastName, fuzziness: 2}}});
            }

            if (vm.filterData.dob) {
                must.push({match: {"patient.dob": {query: DateUtils.convertLocalDateToServer(vm.filterData.dob)}}});
            }

            if (vm.filterData.sent) {
                must.push({term: {sent: vm.filterData.sent}});
            }

            if (vm.filterData.skipped) {
                must.push({term: {skipped: vm.filterData.skipped}});
            }

            if (vm.filterData.barcode && vm.filterData.barcode.length > 0) {
                must.push({match: {"patientOrderItem.groupNumberId": vm.filterData.barcode}});
            }

            if (vm.filterData.clinic != null && vm.filterData.clinic.id !== undefined) {
                must.push({term: {"patient.clinic.id": vm.filterData.clinic.id}});
            }

            return must;
            // KineticSearch.query({
            //     query: {
            //         bool: {
            //             must: must
            //         }
            //     }
            // }, function (result) {
            //     vm.kinetic = result;
            //     vm.dtInstance.reloadData();
            // });
        }

        function popoverFilterEnable() {
            vm.showFilter = !vm.showFilter;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function lessFilter() {
            vm.filterData.scheduleStart = null;
            vm.filterData.scheduleEnd = null;
            vm.filterData.firstName = null;
            vm.filterData.lastName = null;
            vm.filterData.dob = null;
            vm.filterData.sent = null;
            vm.filterData.skipped = null;
            vm.filterData.barcode = null;

            search();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('KineticInfoSkipController', KineticInfoSkipController);

    KineticInfoSkipController.$inject = ['Kinetic', 'dialogs'];

    function KineticInfoSkipController(Kinetic, $dialogs) {
        var vm = this;

        vm.barcode = "";

        vm.skip = function() {
            var dlg = $dialogs.confirm('Please Confirm','Do you want to skip this kinetics?', {size: 'md'});

            dlg.result.then(function(btn){
                Kinetic.skip({barcode: vm.barcode}, function () {
                    vm.barcode = "";
                    alert("Success!")
                });
            },function(btn){
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('KineticInfoController', KineticInfoController);

    KineticInfoController.$inject = ['Kinetic', 'CoreService', 'patients', '$state', 'dialogs', 'lodash'];

    function KineticInfoController(Kinetic, CoreService, patients, $state, $dialogs, _) {
        var vm = this;
        vm.clinic = CoreService.getCurrentClinic();
        vm.missing = [];
        vm.editForm = {};
        vm.date = new Date();

        if (!patients || patients.length == 0) {
            $state.go("kinetic", null, {reload: true});
        } else {
            vm.patients = patients;
            var ids = [];

            for (var i = 0; i < vm.patients.length; i++) {
                ids.push(vm.patients[i].id);
            }

            Kinetic.missing({ids: ids}, function (result) {
                vm.missing = result;

                _.forEach(vm.missing, function (k) {
                    vm.datePickerOpenStatus.begin.push(false);
                    vm.datePickerOpenStatus.end.push(false);

                    k.hhmm = vm.clinic.kineticTimeFormat == 'HHMM';
                });
            });
        }

        vm.openCalendar = openCalendar;
        function openCalendar(field, index) {
            vm.datePickerOpenStatus[field][index] = true;
        }

        vm.datePickerOpenStatus = {
            begin: [],
            end: []
        };

        vm.save = function () {
            var kinetics = [];

            for (var i = 0; i < vm.missing.length; i++) {
                var kinetic = {};

                angular.copy(vm.missing[i], kinetic);

                if (!kinetic.kg) {
                    kinetic.preWeight = kinetic.preWeight * 0.453592;
                    kinetic.posWeight = kinetic.posWeight * 0.453592;
                }

                if (kinetic.hhmm) {
                    kinetic.dialysisLength = moment(kinetic.dialysisLengthHhmm, 'HH:mm').get('hour') * 60;
                    kinetic.dialysisLength += moment(kinetic.dialysisLengthHhmm, 'HH:mm').get('minutes');
                }

                //TODO This code must be fixed, this is only a tmp solution
                if(kinetic.dialysisLength !== null && kinetic.preWeight !== null && kinetic.posWeight !== null) {
                    kinetics.push(kinetic);
                }
            }

            if (kinetics.length > 0) {
                Kinetic.save({kinetics: kinetics}, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            $state.go("kinetic", null, {reload: true});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.remove = function (index) {
            vm.missing.splice(index, 1);
        }

        vm.discard = function(index) {
            var dlg = $dialogs.confirm('Please Confirm','Do you want to skip this kinetics?', {size: 'md'});
            dlg.result.then(function(btn){
                var kinetic = vm.missing.splice(index, 1);
                kinetic[0].sent = true;
                kinetic[0].preWeight = 0;
                kinetic[0].posWeight = 0;
                kinetic[0].beginDate = new Date();
                kinetic[0].endDate = new Date();
                kinetic[0].dialysisLength = 0;

                Kinetic.save({kinetics: kinetic}, function () {
                    vm.isSaving = false;
                    if (vm.missing.length == 0) {
                        $state.go("kinetic", null, {reload: true});
                    }
                }, onSaveError);
            },function(btn){
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('kinetic', {
                parent: 'entity',
                url: '/kinetic',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Kinetics'
                },
                ncyBreadcrumb: {
                    label: 'Kinetic',
                    parent: 'clinic'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/kinetic/kinetics.html',
                        controller: 'KineticController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('kinetic-info', {
                parent: 'kinetic',
                url: '/kinetic-info',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Kinetic Info'
                },
                ncyBreadcrumb: {
                    label: 'Kinetic Info',
                },
                params: {
                    patients: null,
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/kinetic/kinetic-info.html',
                        controller: 'KineticInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    patients: ['$stateParams', function ($stateParams) {
                        return $stateParams.patients;
                    }]
                }
            })
            .state('kinetic-sent', {
                parent: 'entity',
                url: '/kinetic-sent',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Kinetics Sent Monthly'
                },
                ncyBreadcrumb: {
                    label: 'Kinetic Sent Monthly',
                    parent: 'clinic'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/kinetic/kinetic-sent.html',
                        controller: 'KineticSentController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterData: [function () {
                        var start = new Date();
                        start.setDate(1);
                        start.setHours(0, 0, 0);

                        var end = new Date(start.getFullYear(), start.getMonth() + 1, 0);

                        return {
                            scheduleStart: null,
                            scheduleEnd: null,
                            sentStart: start,
                            sentEnd: end,
                            firstName: null,
                            lastName: null,
                            dob: null,
                            sent: null,
                            skipped: null,
                            barcode: null,
                            clinic: {},
                        }
                    }],
                }
            })
            .state('kinetic-skip', {
                parent: 'entity',
                url: '/kinetic-skip',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Skip Kinetics'
                },
                ncyBreadcrumb: {
                    label: 'Kinetic Sent Monthly',
                    parent: 'clinic'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/kinetic/kinetic-info-skip.html',
                        controller: 'KineticInfoSkipController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Kinetic', Kinetic);

    Kinetic.$inject = ['$resource', 'DateUtils'];

    function Kinetic($resource, DateUtils) {
        var resourceUrl = 'api/kinetics/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.beginDate = DateUtils.convertDateTimeFromServer(data.beginDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                // transformRequest: function (data) {
                //     var copy = angular.copy(data);
                //     copy.beginDate = DateUtils.convertLocalDateToServer(copy.beginDate);
                //     copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                //
                //     return angular.toJson(copy);
                // }
            },
            'save': {'url': 'api/kinetics/missing-info/save-all',
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);

                    for (var i = 0; i < data.length; i++) {
                        copy[i].beginDate = DateUtils.convertLocalDateToServer(copy.beginDate);
                        copy[i].endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    }

                    return angular.toJson(copy);
                }
            },
            'skip': {'url': 'api/kinetics/skip/:barcode',
                method: 'GET',
            },
            'patients': {'url': 'api/kinetics/patients/:id', method: 'GET', isArray: true},
            'missing': {url: 'api/kinetics/missing-info', method: 'POST', isArray: true,
                transformResponse: function (data) {
                if (data) {
                    data = angular.fromJson(data);

                    for (var i = 0; i < data.length; i++){
                        data[i].kg = true;
                        data[i].hhmm = true;
                    }
                }

                return data;
            }},
            'countMissing' : {url : 'api/kinetics/count-missing/:id', method: 'GET',
                transformResponse: function (data) {
                    return {value: data};
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('KineticSearch', KineticSearch);

    KineticSearch.$inject = ['$resource'];

    function KineticSearch($resource) {
        var resourceUrl =  'api/_search/kinetics/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('KineticController', KineticController);

    KineticController.$inject = ['$state', '$scope', 'Kinetic', 'CoreService', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function KineticController($state, $scope, Kinetic, CoreService, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile) {

        var vm = this;
        vm.title = 'Kinetics';
        vm.entityClassHumanized = 'Kinetic';
        vm.entityStateName = 'kinetic';

        vm.clinic = CoreService.getCurrentClinic();
        vm.patients = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                Kinetic.patients({id: vm.clinic.id}, function (result) {
                    vm.patients = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patients, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Name').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + (data.middleInitial ? data.middleInitial : "");
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('gender').withTitle('Gender'),
            DTColumnBuilder.newColumn(null).withTitle('Modality').renderWith(function (data, type, full) {
                return data.modality ? data.modality.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Days').renderWith(function (data, type, full) {
                return data.drawDays ? GUIUtils.expandWeekCodeString(data.drawDays, ',') : "";
            }),
            DTColumnBuilder.newColumn('shift').withTitle('Shift'),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(function (data, type, full) {
                return data.status ? 'Active' : 'Inactive';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Physician').renderWith(function (data, type, full) {
                return data.employee ? 'Dr. ' + data.employee.name + ' ' + data.employee.lastName : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('FDD Date').renderWith(function (data, type, full) {
                return moment(data.fddDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Diabetic').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.diabetic);
            })
        ];

        function search() {
            vm.dtInstance.reloadData();
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }

            vm.selectAll = true;
        }

        vm.addKinetics = function () {
            var patients = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    var _patient = $.grep(vm.patients, function (patient, i) {
                        return patient.id == id;
                    })[0];

                    patients.push(_patient);
                }
            }

            if (patients.length > 0) {
                $state.go('kinetic-info', {patients: patients});
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoicePatientDialogController', InvoicePatientDialogController);

    InvoicePatientDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InvoicePatient'];

    function InvoicePatientDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InvoicePatient) {
        var vm = this;

        vm.invoicePatient = entity;
        vm.datePickerOpenStatus = {};

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            InvoicePatient.adjust(vm.invoicePatient, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:invoicePatientUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoicePatientDetailController', InvoicePatientDetailController);

    InvoicePatientDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InvoicePatient', 'Invoice'];

    function InvoicePatientDetailController($scope, $rootScope, $stateParams, previousState, entity, InvoicePatient, Invoice) {
        var vm = this;

        vm.invoicePatient = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:invoicePatientUpdate', function(event, result) {
            vm.invoicePatient = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice-patient', {
            parent: 'invoice-detail',
            url: '/invoice-patient',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Invoice Patients'
            },
            ncyBreadcrumb: {
                label: 'Invoice Patients',
                parent: 'invoice'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-patient/invoice-patients.html',
                    controller: 'InvoicePatientController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('invoice-patient-detail', {
            parent: 'entity',
            url: '/invoice-patient/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InvoicePatient'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-patient/invoice-patient-detail.html',
                    controller: 'InvoicePatientDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InvoicePatient', function($stateParams, InvoicePatient) {
                    return InvoicePatient.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'invoice-patient',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('invoice-patient-detail.edit', {
            parent: 'invoice-patient-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-patient/invoice-patient-dialog.html',
                    controller: 'InvoicePatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InvoicePatient', function(InvoicePatient) {
                            return InvoicePatient.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice-patient.edit', {
            parent: 'invoice-patient',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-patient/invoice-patient-dialog.html',
                    controller: 'InvoicePatientDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InvoicePatient', function(InvoicePatient) {
                            return InvoicePatient.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice-patient', null, { reload: 'invoice-patient' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('InvoicePatient', InvoicePatient);

    InvoicePatient.$inject = ['$resource', 'DateUtils'];

    function InvoicePatient ($resource, DateUtils) {
        var resourceUrl =  'api/invoice-patients/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                        data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                    }
                    return data;
                }
            },
            'adjust': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InvoicePatientSearch', InvoicePatientSearch);

    InvoicePatientSearch.$inject = ['$resource'];

    function InvoicePatientSearch($resource) {
        var resourceUrl =  'api/_search/invoice-patients/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoicePatientController', InvoicePatientController);

    InvoicePatientController.$inject = ['$scope', '$state', 'InvoicePatient', 'InvoicePatientSearch', 'DTOptionsBuilder',
        '$q', 'DTColumnBuilder', 'invoice', 'GUIUtils', '$uibModal', '$compile'];

    function InvoicePatientController($scope, $state, InvoicePatient, InvoicePatientSearch, DTOptionsBuilder,
                                      $q, DTColumnBuilder, invoice, GUIUtils, $uibModal, $compile) {
        var vm = this;

        vm.invoicePatients = [];
        vm.invoice = invoice;
        vm.dtInstance = {};

        vm.edit = edit;
        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (!vm.searchQuery || vm.searchQuery == '') {
                InvoicePatientSearch.query({
                    query: {
                        bool: {
                            must: [
                                {
                                    bool: {
                                        "should": [
                                            {"term": {"invoiceId": vm.invoice.id}},
                                            {"term": {"invoice.id": vm.invoice.id}}
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                }, function (result) {
                    vm.invoicePatients = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.invoicePatients, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('tip')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('accessionNumber').withTitle('Accession #'),
            DTColumnBuilder.newColumn('patientName').withTitle('Patient Name'),
            DTColumnBuilder.newColumn(null).withTitle('DOS').renderWith(function (data, type, full) {
                return data.date ? moment(data.date).format("MM/DD/YYYY") : '';
            }),
            DTColumnBuilder.newColumn('description').withTitle('Service Description'),
            DTColumnBuilder.newColumn(null).withTitle('Price').renderWith(function (data, type, full) {
                return data.price ? '$' + data.price : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Adjustment').renderWith(function (data, type, full) {
                return data.adjustment ? '$' + data.adjustment : '';
            }),
            DTColumnBuilder.newColumn('adjustmentComment').withTitle('Adjustment Comment'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '55px').withOption('class', 'col-btn').notSortable().renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a uib-tooltip="See Details" class="btn btn-default btn-sm details" ng-click="vm.edit(' + data.id + ')">' +
                '   <i class="fa fa-external-link" aria-hidden="true"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/invoice-patient/invoice-patient-dialog.html',
                controller: 'InvoicePatientDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['InvoicePatient', function (InvoicePatient) {
                        return InvoicePatient.get({id: id}).$promise;
                    }]
                }
            }).result.then(function() {
                vm.search();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoiceEnvironmentalDialogController', InvoiceEnvironmentalDialogController);

    InvoiceEnvironmentalDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InvoiceEnvironmental'];

    function InvoiceEnvironmentalDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InvoiceEnvironmental) {
        var vm = this;

        vm.invoiceEnvironmental = entity;
        vm.datePickerOpenStatus = {};

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            InvoiceEnvironmental.adjust(vm.invoiceEnvironmental, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:invoiceEnvironmentalUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoiceEnvironmentalDetailController', InvoiceEnvironmentalDetailController);

    InvoiceEnvironmentalDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InvoiceEnvironmental', 'Invoice'];

    function InvoiceEnvironmentalDetailController($scope, $rootScope, $stateParams, previousState, entity, InvoiceEnvironmental, Invoice) {
        var vm = this;

        vm.invoiceEnvironmental = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:invoiceEnvironmentalUpdate', function(event, result) {
            vm.invoiceEnvironmental = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice-environmental', {
            parent:'invoice-detail',
            url: '/invoice-environmental',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Invoice Environmental'
            },
            ncyBreadcrumb: {
                label: 'Invoice Environmental',
                parent: 'invoice'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-environmental/invoice-environmentals.html',
                    controller: 'InvoiceEnvironmentalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('invoice-environmental-detail', {
            parent: 'entity',
            url: '/invoice-environmental/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InvoiceEnvironmental'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-environmental/invoice-environmental-detail.html',
                    controller: 'InvoiceEnvironmentalDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InvoiceEnvironmental', function($stateParams, InvoiceEnvironmental) {
                    return InvoiceEnvironmental.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'invoice-environmental',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('invoice-environmental-detail.edit', {
            parent: 'invoice-environmental-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-environmental/invoice-environmental-dialog.html',
                    controller: 'InvoiceEnvironmentalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InvoiceEnvironmental', function(InvoiceEnvironmental) {
                            return InvoiceEnvironmental.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice-environmental.edit', {
            parent: 'invoice-environmental',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-environmental/invoice-environmental-dialog.html',
                    controller: 'InvoiceEnvironmentalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InvoiceEnvironmental', function(InvoiceEnvironmental) {
                            return InvoiceEnvironmental.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice-environmental', null, { reload: 'invoice-environmental' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('InvoiceEnvironmental', InvoiceEnvironmental);

    InvoiceEnvironmental.$inject = ['$resource', 'DateUtils'];

    function InvoiceEnvironmental ($resource, DateUtils) {
        var resourceUrl =  'api/invoice-environmentals/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'adjust': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InvoiceEnvironmentalSearch', InvoiceEnvironmentalSearch);

    InvoiceEnvironmentalSearch.$inject = ['$resource'];

    function InvoiceEnvironmentalSearch($resource) {
        var resourceUrl =  'api/_search/invoice-environmentals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoiceEnvironmentalController', InvoiceEnvironmentalController);

    InvoiceEnvironmentalController.$inject = ['$scope', '$state', 'InvoiceEnvironmental', 'InvoiceEnvironmentalSearch', 'DTOptionsBuilder',
        '$q', 'DTColumnBuilder', 'invoice', 'GUIUtils', '$uibModal', '$compile'];

    function InvoiceEnvironmentalController($scope, $state, InvoiceEnvironmental, InvoiceEnvironmentalSearch, DTOptionsBuilder,
                                            $q, DTColumnBuilder, invoice, GUIUtils, $uibModal, $compile) {

        var vm = this;

        vm.invoiceEnvironmentals = [];
        vm.invoice = invoice;
        vm.dtInstance = {};

        vm.edit = edit;
        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (!vm.searchQuery || vm.searchQuery == '') {
                InvoiceEnvironmentalSearch.query({
                    query: {
                        bool: {
                            must: [
                                {
                                    bool: {
                                        "should": [
                                            {"term": {"invoiceId": vm.invoice.id}},
                                            {"term": {"invoice.id": vm.invoice.id}}
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                }, function (result) {
                    vm.invoiceEnvironmentals = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.invoiceEnvironmentals, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('tip')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('accessionNumber').withTitle('Accession #'),
            DTColumnBuilder.newColumn('siteName').withTitle('Site Name'),
            DTColumnBuilder.newColumn(null).withTitle('DOS').renderWith(function (data, type, full) {
                return data.date ? moment(data.date).format("MM/DD/YYYY") : '';
            }),
            DTColumnBuilder.newColumn('description').withTitle('Service Description'),
            DTColumnBuilder.newColumn(null).withTitle('Price').renderWith(function (data, type, full) {
                return data.price ? '$' + data.price : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Adjustment').renderWith(function (data, type, full) {
                return data.adjustment ? '$' + data.adjustment : '';
            }),
            DTColumnBuilder.newColumn('adjustmentComment').withTitle('Adjustment Comment'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '55px').withOption('class', 'col-btn').notSortable().renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a uib-tooltip="See Details" class="btn btn-default btn-sm details" ng-click="vm.edit(' + data.id + ')">' +
                '   <i class="fa fa-external-link" aria-hidden="true"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/invoice-environmental/invoice-environmental-dialog.html',
                controller: 'InvoiceEnvironmentalDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['InvoiceEnvironmental', function (InvoiceEnvironmental) {
                        return InvoiceEnvironmental.get({id: id}).$promise;
                    }]
                }
            }).result.then(function() {
                vm.search();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoiceDialogController', InvoiceDialogController);

    InvoiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Invoice', 'CoreService'];

    function InvoiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Invoice, CoreService) {
        var vm = this;

        vm.invoice = entity;
        vm.datePickerOpenStatus = {};
        vm.clinic = CoreService.getCurrentClinic();

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;

        if (!vm.invoice.id) {
            vm.invoice.clinic = CoreService.getCurrentClinic();
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.invoice.id !== null) {
                Invoice.adjust(vm.invoice, onSaveSuccess, onSaveError);
            } else {
                Invoice.save(vm.invoice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:invoiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoiceDetailController', InvoiceDetailController);

    InvoiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'invoice', 'Invoice'];

    function InvoiceDetailController($scope, $rootScope, $stateParams, previousState, invoice, Invoice) {
        var vm = this;

        vm.invoice = invoice;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:invoiceUpdate', function(event, result) {
            vm.invoice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoiceDeleteController',InvoiceDeleteController);

    InvoiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Invoice'];

    function InvoiceDeleteController($uibModalInstance, entity, Invoice) {
        var vm = this;

        vm.invoice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Invoice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice', {
            parent: 'entity',
            url: '/invoice',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Invoices'
            },
            ncyBreadcrumb: {
                label: 'Invoices',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice/invoices.html',
                    controller: 'InvoiceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('invoice-detail', {
            parent: 'entity',
            url: '/invoice/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Invoice'
            },
            ncyBreadcrumb: {
                label: 'Invoice Detail',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice/invoice-detail.html',
                    controller: 'InvoiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                invoice: ['$stateParams', 'Invoice', function($stateParams, Invoice) {
                    return Invoice.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'invoice',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('invoice-detail.edit', {
            parent: 'invoice-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-dialog.html',
                    controller: 'InvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice.new', {
            parent: 'invoice',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-dialog.html',
                    controller: 'InvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startDate: null,
                                endDate: null,
                                adjustment: 0,
                                adjustmentComment: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('invoice', null, { reload: 'invoice' });
                }, function() {
                    $state.go('invoice');
                });
            }]
        })
        .state('invoice.edit', {
            parent: 'invoice',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-dialog.html',
                    controller: 'InvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice', null, { reload: 'invoice' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice.delete', {
            parent: 'invoice',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-delete-dialog.html',
                    controller: 'InvoiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice', null, { reload: 'invoice' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Invoice', Invoice);

    Invoice.$inject = ['$resource', 'DateUtils', 'DataUtils'];

    function Invoice($resource, DateUtils, DataUtils) {
        var resourceUrl = 'api/invoices/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'adjust': {
                method: 'POST',
                url: 'api/invoices/adjust',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'getPdf': {
                url: "api/invoices/get-pdf/:id",
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InvoiceSearch', InvoiceSearch);

    InvoiceSearch.$inject = ['$resource'];

    function InvoiceSearch($resource) {
        var resourceUrl =  'api/_search/invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InvoiceController', InvoiceController);

    InvoiceController.$inject = ['$scope', '$state', 'Invoice', 'InvoiceSearch', 'CoreService', 'DTOptionsBuilder',
        '$q', 'DTColumnBuilder', 'GUIUtils', '$compile'];

    function InvoiceController($scope, $state, Invoice, InvoiceSearch, CoreService, DTOptionsBuilder,
                               $q, DTColumnBuilder, GUIUtils, $compile) {
        var vm = this;

        vm.invoices = [];
        vm.clinic = CoreService.getCurrentClinic();
        vm.dtInstance = {};

        vm.search = search;
        vm.getPdf = getPdf;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                InvoiceSearch.query({
                    query: {
                        bool: {
                            must: [
                                {
                                    bool: {
                                        "should": [
                                            {"term": {"clinicId": vm.clinic.id}},
                                            {"term": {"clinic.id": vm.clinic.id}}
                                        ]
                                    }
                                },
                                {term: {"delStatus": false}}
                            ]
                        }
                    }
                }, function (result) {
                    vm.invoices = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.invoices, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return data.startDate ? moment(data.startDate).format("MM/DD/YYYY") : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return data.endDate ? moment(data.endDate).format("MM/DD/YYYY") : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Grand Total').renderWith(function (data, type, full) {
                return '$' + (data.grandTotal ? data.grandTotal : "0");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(function (data, type, full) {
                return data.status;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Adjustment').renderWith(function (data, type, full) {
                return '$' + (data.adjustment ? data.adjustment : "0");
            }),
            DTColumnBuilder.newColumn('adjustmentComment').withTitle('Adjustment Comment'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('class', 'col-btn').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<a class="btn btn-default btn-sm details" ui-sref="invoice.edit({id: ' + data.id + '})" uib-tooltip="Edit"><i class="fa fa-external-link" aria-hidden="true"></i></a>' +
                '<a class="btn btn-default btn-sm delete" ui-sref="invoice.delete({id: ' + data.id + '})" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a>' +
                '<a class="dt-btn primary" ng-click="vm.getPdf(' + full.id + ')" uib-tooltip="View Invoice"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></a>' +
                '<a class="dt-btn primary" ui-sref="invoice-patient({id: ' + full.id + '})" uib-tooltip="Edit Patient Invoice"><i class="fa fa-user" aria-hidden="true"></i></a>' +
                '<a class="dt-btn primary" ui-sref="invoice-environmental({id: ' + full.id + '})" uib-tooltip="Edit Site Invoice"><i class="fa fa-gear" aria-hidden="true"></i></a>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function getPdf(id) {
            Invoice.getPdf({id: id});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceTypeDialogController', InsuranceTypeDialogController);

    InsuranceTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InsuranceType', 'Insurance', 'Corporation'];

    function InsuranceTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InsuranceType, Insurance, Corporation) {
        var vm = this;

        vm.insuranceType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.insuranceType.id !== null) {
                InsuranceType.update(vm.insuranceType, onSaveSuccess, onSaveError);
            } else {
                InsuranceType.save(vm.insuranceType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:insuranceTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceTypeDetailController', InsuranceTypeDetailController);

    InsuranceTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InsuranceType', 'Insurance', 'Corporation'];

    function InsuranceTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, InsuranceType, Insurance, Corporation) {
        var vm = this;

        vm.insuranceType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:insuranceTypeUpdate', function(event, result) {
            vm.insuranceType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceTypeDeleteController',InsuranceTypeDeleteController);

    InsuranceTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'InsuranceType'];

    function InsuranceTypeDeleteController($uibModalInstance, entity, InsuranceType) {
        var vm = this;

        vm.insuranceType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InsuranceType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('insurance-type', {
            parent: 'entity',
            url: '/insurance-type',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Insurance Types'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insurance-type/insurance-types.html',
                    controller: 'InsuranceTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('insurance-type-detail', {
            parent: 'entity',
            url: '/insurance-type/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Insurance Type'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insurance-type/insurance-type-detail.html',
                    controller: 'InsuranceTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InsuranceType', function($stateParams, InsuranceType) {
                    return InsuranceType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'insurance-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('insurance-type-detail.edit', {
            parent: 'insurance-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-type/insurance-type-dialog.html',
                    controller: 'InsuranceTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InsuranceType', function(InsuranceType) {
                            return InsuranceType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insurance-type.new', {
            parent: 'insurance-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-type/insurance-type-dialog.html',
                    controller: 'InsuranceTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('insurance-type', null, { reload: 'insurance-type' });
                }, function() {
                    $state.go('insurance-type');
                });
            }]
        })
        .state('insurance-type.edit', {
            parent: 'insurance-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-type/insurance-type-dialog.html',
                    controller: 'InsuranceTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InsuranceType', function(InsuranceType) {
                            return InsuranceType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insurance-type', null, { reload: 'insurance-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insurance-type.delete', {
            parent: 'insurance-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-type/insurance-type-delete-dialog.html',
                    controller: 'InsuranceTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InsuranceType', function(InsuranceType) {
                            return InsuranceType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insurance-type', null, { reload: 'insurance-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('InsuranceType', InsuranceType);

    InsuranceType.$inject = ['$resource'];

    function InsuranceType ($resource) {
        var resourceUrl =  'api/insurance-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InsuranceTypeSearch', InsuranceTypeSearch);

    InsuranceTypeSearch.$inject = ['$resource'];

    function InsuranceTypeSearch($resource) {
        var resourceUrl =  'api/_search/insurance-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceTypeController', InsuranceTypeController);

    InsuranceTypeController.$inject = ['$scope', '$state', 'InsuranceType', 'InsuranceTypeSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function InsuranceTypeController ($scope, $state, InsuranceType, InsuranceTypeSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.insuranceTypes = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  InsuranceType.query(function(result) {
                  vm.insuranceTypes = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.insuranceTypes, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            InsuranceType.query(function(result) {
                vm.insuranceTypes = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceRelationDialogController', InsuranceRelationDialogController);

    InsuranceRelationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InsuranceRelation', 'Insurance', 'Corporation'];

    function InsuranceRelationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InsuranceRelation, Insurance, Corporation) {
        var vm = this;

        vm.insuranceRelation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.insuranceRelation.id !== null) {
                InsuranceRelation.update(vm.insuranceRelation, onSaveSuccess, onSaveError);
            } else {
                InsuranceRelation.save(vm.insuranceRelation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:insuranceRelationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceRelationDetailController', InsuranceRelationDetailController);

    InsuranceRelationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InsuranceRelation', 'Insurance', 'Corporation'];

    function InsuranceRelationDetailController($scope, $rootScope, $stateParams, previousState, entity, InsuranceRelation, Insurance, Corporation) {
        var vm = this;

        vm.insuranceRelation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:insuranceRelationUpdate', function(event, result) {
            vm.insuranceRelation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceRelationDeleteController',InsuranceRelationDeleteController);

    InsuranceRelationDeleteController.$inject = ['$uibModalInstance', 'entity', 'InsuranceRelation'];

    function InsuranceRelationDeleteController($uibModalInstance, entity, InsuranceRelation) {
        var vm = this;

        vm.insuranceRelation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InsuranceRelation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('insurance-relation', {
            parent: 'entity',
            url: '/insurance-relation',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Insurance Relations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insurance-relation/insurance-relations.html',
                    controller: 'InsuranceRelationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('insurance-relation-detail', {
            parent: 'entity',
            url: '/insurance-relation/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Insurance Relation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insurance-relation/insurance-relation-detail.html',
                    controller: 'InsuranceRelationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InsuranceRelation', function($stateParams, InsuranceRelation) {
                    return InsuranceRelation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'insurance-relation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('insurance-relation-detail.edit', {
            parent: 'insurance-relation-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-relation/insurance-relation-dialog.html',
                    controller: 'InsuranceRelationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InsuranceRelation', function(InsuranceRelation) {
                            return InsuranceRelation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insurance-relation.new', {
            parent: 'insurance-relation',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-relation/insurance-relation-dialog.html',
                    controller: 'InsuranceRelationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('insurance-relation', null, { reload: 'insurance-relation' });
                }, function() {
                    $state.go('insurance-relation');
                });
            }]
        })
        .state('insurance-relation.edit', {
            parent: 'insurance-relation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-relation/insurance-relation-dialog.html',
                    controller: 'InsuranceRelationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InsuranceRelation', function(InsuranceRelation) {
                            return InsuranceRelation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insurance-relation', null, { reload: 'insurance-relation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insurance-relation.delete', {
            parent: 'insurance-relation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-relation/insurance-relation-delete-dialog.html',
                    controller: 'InsuranceRelationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InsuranceRelation', function(InsuranceRelation) {
                            return InsuranceRelation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insurance-relation', null, { reload: 'insurance-relation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('InsuranceRelation', InsuranceRelation);

    InsuranceRelation.$inject = ['$resource'];

    function InsuranceRelation ($resource) {
        var resourceUrl =  'api/insurance-relations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InsuranceRelationSearch', InsuranceRelationSearch);

    InsuranceRelationSearch.$inject = ['$resource'];

    function InsuranceRelationSearch($resource) {
        var resourceUrl =  'api/_search/insurance-relations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceRelationController', InsuranceRelationController);

    InsuranceRelationController.$inject = ['$scope', '$state', 'InsuranceRelation', 'InsuranceRelationSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function InsuranceRelationController ($scope, $state, InsuranceRelation, InsuranceRelationSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.insuranceRelations = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  InsuranceRelation.query(function(result) {
                  vm.insuranceRelations = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.insuranceRelations, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            InsuranceRelation.query(function(result) {
                vm.insuranceRelations = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceLevelDialogController', InsuranceLevelDialogController);

    InsuranceLevelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InsuranceLevel', 'Insurance', 'Corporation'];

    function InsuranceLevelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InsuranceLevel, Insurance, Corporation) {
        var vm = this;

        vm.insuranceLevel = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.insuranceLevel.id !== null) {
                InsuranceLevel.update(vm.insuranceLevel, onSaveSuccess, onSaveError);
            } else {
                InsuranceLevel.save(vm.insuranceLevel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:insuranceLevelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceLevelDetailController', InsuranceLevelDetailController);

    InsuranceLevelDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InsuranceLevel', 'Insurance', 'Corporation'];

    function InsuranceLevelDetailController($scope, $rootScope, $stateParams, previousState, entity, InsuranceLevel, Insurance, Corporation) {
        var vm = this;

        vm.insuranceLevel = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:insuranceLevelUpdate', function(event, result) {
            vm.insuranceLevel = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceLevelDeleteController',InsuranceLevelDeleteController);

    InsuranceLevelDeleteController.$inject = ['$uibModalInstance', 'entity', 'InsuranceLevel'];

    function InsuranceLevelDeleteController($uibModalInstance, entity, InsuranceLevel) {
        var vm = this;

        vm.insuranceLevel = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InsuranceLevel.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('insurance-level', {
            parent: 'entity',
            url: '/insurance-level',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Insurance Levels'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insurance-level/insurance-levels.html',
                    controller: 'InsuranceLevelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('insurance-level-detail', {
            parent: 'entity',
            url: '/insurance-level/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'InsuranceLevel'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insurance-level/insurance-level-detail.html',
                    controller: 'InsuranceLevelDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InsuranceLevel', function($stateParams, InsuranceLevel) {
                    return InsuranceLevel.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'insurance-level',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('insurance-level-detail.edit', {
            parent: 'insurance-level-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-level/insurance-level-dialog.html',
                    controller: 'InsuranceLevelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InsuranceLevel', function(InsuranceLevel) {
                            return InsuranceLevel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insurance-level.new', {
            parent: 'insurance-level',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-level/insurance-level-dialog.html',
                    controller: 'InsuranceLevelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('insurance-level', null, { reload: 'insurance-level' });
                }, function() {
                    $state.go('insurance-level');
                });
            }]
        })
        .state('insurance-level.edit', {
            parent: 'insurance-level',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-level/insurance-level-dialog.html',
                    controller: 'InsuranceLevelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InsuranceLevel', function(InsuranceLevel) {
                            return InsuranceLevel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insurance-level', null, { reload: 'insurance-level' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insurance-level.delete', {
            parent: 'insurance-level',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-level/insurance-level-delete-dialog.html',
                    controller: 'InsuranceLevelDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InsuranceLevel', function(InsuranceLevel) {
                            return InsuranceLevel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insurance-level', null, { reload: 'insurance-level' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('InsuranceLevel', InsuranceLevel);

    InsuranceLevel.$inject = ['$resource'];

    function InsuranceLevel ($resource) {
        var resourceUrl =  'api/insurance-levels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InsuranceLevelSearch', InsuranceLevelSearch);

    InsuranceLevelSearch.$inject = ['$resource'];

    function InsuranceLevelSearch($resource) {
        var resourceUrl =  'api/_search/insurance-levels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceLevelController', InsuranceLevelController);

    InsuranceLevelController.$inject = ['$scope', '$state', 'InsuranceLevel', 'InsuranceLevelSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function InsuranceLevelController ($scope, $state, InsuranceLevel, InsuranceLevelSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.insuranceLevels = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  InsuranceLevel.query(function(result) {
                  vm.insuranceLevels = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.insuranceLevels, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            InsuranceLevel.query(function(result) {
                vm.insuranceLevels = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceCarrierDialogController', InsuranceCarrierDialogController);

    InsuranceCarrierDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'InsuranceCarrier'];

    function InsuranceCarrierDialogController ($timeout, $scope, $uibModalInstance, entity, InsuranceCarrier) {
        var vm = this;

        vm.insuranceCarrier = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.insuranceCarrier.id !== null) {
                InsuranceCarrier.update(vm.insuranceCarrier, onSaveSuccess, onSaveError);
            } else {
                InsuranceCarrier.save(vm.insuranceCarrier, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:insuranceCarrierUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceCarrierDetailController', InsuranceCarrierDetailController);

    InsuranceCarrierDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InsuranceCarrier', 'Insurance'];

    function InsuranceCarrierDetailController($scope, $rootScope, $stateParams, previousState, entity, InsuranceCarrier, Insurance) {
        var vm = this;

        vm.insuranceCarrier = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:insuranceCarrierUpdate', function(event, result) {
            vm.insuranceCarrier = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceCarrierDeleteController',InsuranceCarrierDeleteController);

    InsuranceCarrierDeleteController.$inject = ['$uibModalInstance', 'entity', 'InsuranceCarrier'];

    function InsuranceCarrierDeleteController($uibModalInstance, entity, InsuranceCarrier) {
        var vm = this;

        vm.insuranceCarrier = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InsuranceCarrier.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('insurance-carrier', {
            parent: 'entity',
            url: '/insurance-carrier',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
                pageTitle: 'Insurance Carriers'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insurance-carrier/insurance-carriers.html',
                    controller: 'InsuranceCarrierController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('insurance-carrier-detail.edit', {
            parent: 'insurance-carrier-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-carrier/insurance-carrier-dialog.html',
                    controller: 'InsuranceCarrierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InsuranceCarrier', function(InsuranceCarrier) {
                            return InsuranceCarrier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insurance-carrier.new', {
            parent: 'insurance-carrier',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-carrier/insurance-carrier-dialog.html',
                    controller: 'InsuranceCarrierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                acctno: null,
                                name: null,
                                address: null,
                                address2: null,
                                city: null,
                                state: null,
                                zip: null,
                                phone: null,
                                iType: null,
                                etin: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('insurance-carrier', null, { reload: 'insurance-carrier' });
                }, function() {
                    $state.go('insurance-carrier');
                });
            }]
        })
        .state('insurance-carrier.edit', {
            parent: 'insurance-carrier',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-carrier/insurance-carrier-dialog.html',
                    controller: 'InsuranceCarrierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InsuranceCarrier', function(InsuranceCarrier) {
                            return InsuranceCarrier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insurance-carrier', null, { reload: 'insurance-carrier' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insurance-carrier.delete', {
            parent: 'insurance-carrier',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-carrier/insurance-carrier-delete-dialog.html',
                    controller: 'InsuranceCarrierDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InsuranceCarrier', function(InsuranceCarrier) {
                            return InsuranceCarrier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insurance-carrier', null, { reload: 'insurance-carrier' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('InsuranceCarrier', InsuranceCarrier);

    InsuranceCarrier.$inject = ['$resource'];

    function InsuranceCarrier ($resource) {
        var resourceUrl =  'api/insurance-carriers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InsuranceCarrierSearch', InsuranceCarrierSearch);

    InsuranceCarrierSearch.$inject = ['$resource'];

    function InsuranceCarrierSearch($resource) {
        var resourceUrl =  'api/_search/insurance-carriers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InsuranceCarrierController', InsuranceCarrierController);

    InsuranceCarrierController.$inject = ['$scope', '$state', 'InsuranceCarrier', 'InsuranceCarrierSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function InsuranceCarrierController ($scope, $state, InsuranceCarrier, InsuranceCarrierSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.insuranceCarriers = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  InsuranceCarrier.query(function(result) {
                  vm.insuranceCarriers = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.insuranceCarriers, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('acctno').withTitle('Acctno'),
              DTColumnBuilder.newColumn('name').withTitle('Name'),
              DTColumnBuilder.newColumn('address').withTitle('Address'),
              DTColumnBuilder.newColumn('address2').withTitle('Address2'),
              DTColumnBuilder.newColumn('city').withTitle('City'),
              DTColumnBuilder.newColumn('state').withTitle('State'),
              DTColumnBuilder.newColumn('zip').withTitle('Zip'),
              DTColumnBuilder.newColumn('phone').withTitle('Phone'),
              DTColumnBuilder.newColumn('iType').withTitle('IType'),
              DTColumnBuilder.newColumn('etin').withTitle('Etin'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            InsuranceCarrier.query(function(result) {
                vm.insuranceCarriers = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionPrimaryAccessDialogController', InfectionPrimaryAccessDialogController);

    InfectionPrimaryAccessDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InfectionPrimaryAccess', 'Infection', 'Corporation'];

    function InfectionPrimaryAccessDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InfectionPrimaryAccess, Infection, Corporation) {
        var vm = this;

        vm.infectionPrimaryAccess = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.infectionPrimaryAccess.id !== null) {
                InfectionPrimaryAccess.update(vm.infectionPrimaryAccess, onSaveSuccess, onSaveError);
            } else {
                InfectionPrimaryAccess.save(vm.infectionPrimaryAccess, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:infectionPrimaryAccessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionPrimaryAccessDetailController', InfectionPrimaryAccessDetailController);

    InfectionPrimaryAccessDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InfectionPrimaryAccess', 'Infection', 'Corporation'];

    function InfectionPrimaryAccessDetailController($scope, $rootScope, $stateParams, previousState, entity, InfectionPrimaryAccess, Infection, Corporation) {
        var vm = this;

        vm.infectionPrimaryAccess = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:infectionPrimaryAccessUpdate', function(event, result) {
            vm.infectionPrimaryAccess = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionPrimaryAccessDeleteController',InfectionPrimaryAccessDeleteController);

    InfectionPrimaryAccessDeleteController.$inject = ['$uibModalInstance', 'entity', 'InfectionPrimaryAccess'];

    function InfectionPrimaryAccessDeleteController($uibModalInstance, entity, InfectionPrimaryAccess) {
        var vm = this;

        vm.infectionPrimaryAccess = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InfectionPrimaryAccess.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('infection-primary-access', {
            parent: 'entity',
            url: '/infection-primary-access',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Infection Primary Accesses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/infection-primary-access/infection-primary-accesses.html',
                    controller: 'InfectionPrimaryAccessController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('infection-primary-access-detail', {
            parent: 'entity',
            url: '/infection-primary-access/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'InfectionPrimaryAccess'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/infection-primary-access/infection-primary-access-detail.html',
                    controller: 'InfectionPrimaryAccessDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InfectionPrimaryAccess', function($stateParams, InfectionPrimaryAccess) {
                    return InfectionPrimaryAccess.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'infection-primary-access',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('infection-primary-access-detail.edit', {
            parent: 'infection-primary-access-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infection-primary-access/infection-primary-access-dialog.html',
                    controller: 'InfectionPrimaryAccessDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfectionPrimaryAccess', function(InfectionPrimaryAccess) {
                            return InfectionPrimaryAccess.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('infection-primary-access.new', {
            parent: 'infection-primary-access',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infection-primary-access/infection-primary-access-dialog.html',
                    controller: 'InfectionPrimaryAccessDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('infection-primary-access', null, { reload: 'infection-primary-access' });
                }, function() {
                    $state.go('infection-primary-access');
                });
            }]
        })
        .state('infection-primary-access.edit', {
            parent: 'infection-primary-access',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infection-primary-access/infection-primary-access-dialog.html',
                    controller: 'InfectionPrimaryAccessDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InfectionPrimaryAccess', function(InfectionPrimaryAccess) {
                            return InfectionPrimaryAccess.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('infection-primary-access', null, { reload: 'infection-primary-access' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('infection-primary-access.delete', {
            parent: 'infection-primary-access',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infection-primary-access/infection-primary-access-delete-dialog.html',
                    controller: 'InfectionPrimaryAccessDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InfectionPrimaryAccess', function(InfectionPrimaryAccess) {
                            return InfectionPrimaryAccess.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('infection-primary-access', null, { reload: 'infection-primary-access' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('InfectionPrimaryAccess', InfectionPrimaryAccess);

    InfectionPrimaryAccess.$inject = ['$resource'];

    function InfectionPrimaryAccess ($resource) {
        var resourceUrl =  'api/infection-primary-accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InfectionPrimaryAccessSearch', InfectionPrimaryAccessSearch);

    InfectionPrimaryAccessSearch.$inject = ['$resource'];

    function InfectionPrimaryAccessSearch($resource) {
        var resourceUrl =  'api/_search/infection-primary-accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionPrimaryAccessController', InfectionPrimaryAccessController);

    InfectionPrimaryAccessController.$inject = ['$scope', '$state', 'InfectionPrimaryAccess', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function InfectionPrimaryAccessController ($scope, $state, InfectionPrimaryAccess, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;

        vm.infectionPrimaryAccesses = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  InfectionPrimaryAccess.query(function(result) {
                  vm.infectionPrimaryAccesses = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.infectionPrimaryAccesses, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            InfectionPrimaryAccess.query(function(result) {
                vm.infectionPrimaryAccesses = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionDialogController', InfectionDialogController);

    InfectionDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'infection', '$state',
        'Infection', 'Source', 'InfectionPrimaryAccess', 'DialyserType', 'Symptom'];

    function InfectionDialogController ($timeout, $scope, $uibModalInstance, infection, $state,
                                        Infection, Source, InfectionPrimaryAccess, DialyserType, Symptom) {
        var vm = this;

        vm.infection = infection;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.sources = Source.query();
        vm.infectionprimaryaccesses = InfectionPrimaryAccess.query();
        vm.dialysertypes = DialyserType.query();
        vm.symptoms = Symptom.query();
        vm.editing = $state.current.name != "infection.view";

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.infection.id !== null) {
                Infection.update(vm.infection, onSaveSuccess, onSaveError);
            } else {
                Infection.save(vm.infection, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:infectionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.suspectedDate = false;
        vm.datePickerOpenStatus.confirmedDate = false;
        vm.datePickerOpenStatus.hospitalizationDate = false;
        vm.datePickerOpenStatus.drInfectionDate = false;
        vm.datePickerOpenStatus.aStartedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionDeleteController',InfectionDeleteController);

    InfectionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Infection'];

    function InfectionDeleteController($uibModalInstance, entity, Infection) {
        var vm = this;

        vm.infection = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Infection.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('infection', {
            parent: 'patient-abs',
            url: '/infection',
            ncyBreadcrumb: {
                label: 'Infections',
            },
            data: {
                authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                pageTitle: 'Infections'
            },
            views: {
                'content@patient-abs': {
                    templateUrl: 'app/entities/infection/infections.html',
                    controller: 'InfectionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('infection.new', {
            parent: 'infection',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/entities/infection/infection-dialog.html',
                    controller: 'InfectionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        infection: function () {
                            return {
                                suspectedDate: null,
                                confirmedDate: null,
                                accessCondition: null,
                                lvAccess: null,
                                hospitalization: false,
                                hospitalizationDate: null,
                                drInfection: null,
                                drInfectionDate: null,
                                aStarted: null,
                                aStartedDate: null,
                                intervention: null,
                                id: null,
                                patient: entity
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('infection', null, { reload: 'infection' });
                }, function() {
                    $state.go('infection', null, { reload: 'infection' });
                });
            }]
        })
        .state('infection.view', {
            parent: 'infection',
            url: '/{iid}/view',
            data: {
                authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infection/infection-dialog.html',
                    controller: 'InfectionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        infection: ['Infection', function(Infection) {
                            return Infection.get({id : $stateParams.iid}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('infection', {id: $stateParams.id}, { reload: 'infection' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('infection.delete', {
            parent: 'infection',
            url: '/{iid}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/infection/infection-delete-dialog.html',
                    controller: 'InfectionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Infection', function(Infection) {
                            return Infection.get({id : $stateParams.iid}).$promise;
                        }],
                    }
                }).result.then(function() {
                    $state.go('infection', null, { reload: 'infection' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Infection', Infection);

    Infection.$inject = ['$resource', 'DateUtils'];

    function Infection ($resource, DateUtils) {
        var resourceUrl =  'api/infections/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.suspectedDate = DateUtils.convertLocalDateFromServer(data.suspectedDate);
                        data.confirmedDate = DateUtils.convertLocalDateFromServer(data.confirmedDate);
                        data.hospitalizationDate = DateUtils.convertLocalDateFromServer(data.hospitalizationDate);
                        data.drInfectionDate = DateUtils.convertLocalDateFromServer(data.drInfectionDate);
                        data.aStartedDate = DateUtils.convertLocalDateFromServer(data.aStartedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.suspectedDate = DateUtils.convertLocalDateToServer(copy.suspectedDate);
                    copy.confirmedDate = DateUtils.convertLocalDateToServer(copy.confirmedDate);
                    copy.hospitalizationDate = DateUtils.convertLocalDateToServer(copy.hospitalizationDate);
                    copy.drInfectionDate = DateUtils.convertLocalDateToServer(copy.drInfectionDate);
                    copy.aStartedDate = DateUtils.convertLocalDateToServer(copy.aStartedDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.suspectedDate = DateUtils.convertLocalDateToServer(copy.suspectedDate);
                    copy.confirmedDate = DateUtils.convertLocalDateToServer(copy.confirmedDate);
                    copy.hospitalizationDate = DateUtils.convertLocalDateToServer(copy.hospitalizationDate);
                    copy.drInfectionDate = DateUtils.convertLocalDateToServer(copy.drInfectionDate);
                    copy.aStartedDate = DateUtils.convertLocalDateToServer(copy.aStartedDate);
                    return angular.toJson(copy);
                }
            },
            'getAllByPatientId': { 'url': 'api/infections/patient/:id', method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InfectionSearch', InfectionSearch);

    InfectionSearch.$inject = ['$resource'];

    function InfectionSearch($resource) {
        var resourceUrl =  'api/_search/infections/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('InfectionController', InfectionController);

    InfectionController.$inject = ['$compile', '$scope', '$state', 'Infection', 'InfectionSearch', '$q', 'DTColumnBuilder', 'entity',
        'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function InfectionController($compile, $scope, $state, Infection, InfectionSearch, $q, DTColumnBuilder, entity,
                                 DTOptionsBuilder, GUIUtils, $filter) {
        var vm = this;

        vm.patient = entity;
        vm.infections = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                Infection.getAllByPatientId({id: vm.patient.id}, function (result) {
                    vm.infections = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.infections, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('suspectedDate').withTitle('Suspected').renderWith(function (data, type, full) {
                return data ? moment(data).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn('confirmedDate').withTitle('Confirmed').renderWith(function (data, type, full) {
                return data ? moment(data).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn('accessCondition').withTitle('Access Condition').renderWith(function (data, type, full) {
                return data ? 'Y' : 'N';
            }),
            DTColumnBuilder.newColumn('hospitalization').withTitle('Hospital').renderWith(function (data, type, full) {
                return data ? 'Y' : 'N';
            }),
            DTColumnBuilder.newColumn('hospitalizationDate').withTitle('Hospital Date').renderWith(function (data, type, full) {
                return data ? moment(data).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn('aStarted').withTitle('Antimicrobial Started').renderWith(function (data, type, full) {
                return data ? 'Y' : 'N';
            }),
            DTColumnBuilder.newColumn('aStartedDate').withTitle('Antimicrobial Started Date').renderWith(function (data, type, full) {
                return data ? moment(data).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="infection.view({iid:' + data.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            if (vm.patient.status) {
                stButtons += '<a class="btn-sm btn-danger" ui-sref="infection.delete({iid:' + data.id + '})">' +
                    '   <i class="fa fa-trash"></i></a>';
            }

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hotfix', {
            parent: 'entity',
            url: '/hotfix',
            ncyBreadcrumb: {
                label: 'HotFix',
            },
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'HotFix'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hotfix/hotfix.html',
                    controller: 'HotFixController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('HotFix', HotFix);

    HotFix.$inject = ['$resource', 'DateUtils'];

    function HotFix($resource, DateUtils) {
        var resourceUrl = 'api/hotfix';

        return $resource(resourceUrl, {}, {
            'patientResultStatus': {'url': 'api/hotfix/patient-results/update', method: 'POST'},

            //mobile
            'clinicDetails': {'url': 'mobile/clinics', method: 'GET', isArray: true},
            'patients': {'url': 'mobile/patients/by-clinic/:id', method: 'GET', isArray: true},
            'pdetail': {'url': 'mobile/patients/detail/:id', method: 'GET'},
            'criticals': {'url': 'mobile/patient-result-dets/by-patient/criticals/:id', method: 'GET', isArray: true},
            '_6M': {'url': 'mobile/patient-result-dets/6M/:id/:detailId', method: 'GET', isArray: true},
            'comments': {'url': 'mobile/patient-result-dets/comments/:id', method: 'GET', isArray: true},
            'acknowledge': {'url': 'mobile/patient-result-dets/acknowledge/:id', method: 'POST'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HotFixController', HotFixController);

    HotFixController.$inject = ['HotFix', 'dialogs', 'CoreService'];

    function HotFixController(HotFix, $dialogs, CoreService) {
        var vm = this;

        vm.patientResultStatus = patientResultStatus;

        function patientResultStatus() {
            var dlg = $dialogs.confirm('Please Confirm', 'This hot fix run a patient result status update based in the range values', {size: 'md'});
            dlg.result.then(function (btn) {
                HotFix.patientResultStatus();
            });
        }

        // vm.clinics = HotFix.clinicDetails();
        //
        // HotFix.patients({id: 17302}, function (result) {
        //     vm.patients = result;
        //     vm.count = 0;
        //
        //     for (var i = 0; i < vm.patients.length; i++) {
        //         vm.count += vm.patients[i].criticals;
        //     }
        // });
        //
        // vm.pdetail = HotFix.pdetail({id: 60082});
        // vm.criticals = HotFix.criticals({id: 60109});
        // vm.comments = HotFix.comments({id: 277840});
        // vm._6m = HotFix._6M({id: 60149, detailId: 289050});
        // vm.acknowledge = HotFix.acknowledge({id: 268668});
        // vm.acknowledge = HotFix.acknowledge({id: 268669});
        // vm.acknowledge = HotFix.acknowledge({id: 273094});
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HospitalizationDischargeToDialogController', HospitalizationDischargeToDialogController);

    HospitalizationDischargeToDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HospitalizationDischargeTo', 'Hospitalization', 'Corporation'];

    function HospitalizationDischargeToDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HospitalizationDischargeTo, Hospitalization, Corporation) {
        var vm = this;

        vm.hospitalizationDischargeTo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.hospitalizationDischargeTo.id !== null) {
                HospitalizationDischargeTo.update(vm.hospitalizationDischargeTo, onSaveSuccess, onSaveError);
            } else {
                HospitalizationDischargeTo.save(vm.hospitalizationDischargeTo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:hospitalizationDischargeToUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HospitalizationDischargeToDetailController', HospitalizationDischargeToDetailController);

    HospitalizationDischargeToDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HospitalizationDischargeTo', 'Hospitalization', 'Corporation'];

    function HospitalizationDischargeToDetailController($scope, $rootScope, $stateParams, previousState, entity, HospitalizationDischargeTo, Hospitalization, Corporation) {
        var vm = this;

        vm.hospitalizationDischargeTo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:hospitalizationDischargeToUpdate', function(event, result) {
            vm.hospitalizationDischargeTo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HospitalizationDischargeToDeleteController',HospitalizationDischargeToDeleteController);

    HospitalizationDischargeToDeleteController.$inject = ['$uibModalInstance', 'entity', 'HospitalizationDischargeTo'];

    function HospitalizationDischargeToDeleteController($uibModalInstance, entity, HospitalizationDischargeTo) {
        var vm = this;

        vm.hospitalizationDischargeTo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HospitalizationDischargeTo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hospitalization-discharge-to', {
            parent: 'entity',
            url: '/hospitalization-discharge-to',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'HospitalizationDischargeTos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization-discharge-to/hospitalization-discharge-tos.html',
                    controller: 'HospitalizationDischargeToController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('hospitalization-discharge-to-detail', {
            parent: 'entity',
            url: '/hospitalization-discharge-to/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'HospitalizationDischargeTo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization-discharge-to/hospitalization-discharge-to-detail.html',
                    controller: 'HospitalizationDischargeToDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'HospitalizationDischargeTo', function($stateParams, HospitalizationDischargeTo) {
                    return HospitalizationDischargeTo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'hospitalization-discharge-to',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('hospitalization-discharge-to-detail.edit', {
            parent: 'hospitalization-discharge-to-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-discharge-to/hospitalization-discharge-to-dialog.html',
                    controller: 'HospitalizationDischargeToDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HospitalizationDischargeTo', function(HospitalizationDischargeTo) {
                            return HospitalizationDischargeTo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hospitalization-discharge-to.new', {
            parent: 'hospitalization-discharge-to',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-discharge-to/hospitalization-discharge-to-dialog.html',
                    controller: 'HospitalizationDischargeToDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hospitalization-discharge-to', null, { reload: 'hospitalization-discharge-to' });
                }, function() {
                    $state.go('hospitalization-discharge-to');
                });
            }]
        })
        .state('hospitalization-discharge-to.edit', {
            parent: 'hospitalization-discharge-to',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-discharge-to/hospitalization-discharge-to-dialog.html',
                    controller: 'HospitalizationDischargeToDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HospitalizationDischargeTo', function(HospitalizationDischargeTo) {
                            return HospitalizationDischargeTo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization-discharge-to', null, { reload: 'hospitalization-discharge-to' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hospitalization-discharge-to.delete', {
            parent: 'hospitalization-discharge-to',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-discharge-to/hospitalization-discharge-to-delete-dialog.html',
                    controller: 'HospitalizationDischargeToDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HospitalizationDischargeTo', function(HospitalizationDischargeTo) {
                            return HospitalizationDischargeTo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization-discharge-to', null, { reload: 'hospitalization-discharge-to' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('HospitalizationDischargeTo', HospitalizationDischargeTo);

    HospitalizationDischargeTo.$inject = ['$resource'];

    function HospitalizationDischargeTo ($resource) {
        var resourceUrl =  'api/hospitalization-discharge-tos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('HospitalizationDischargeToSearch', HospitalizationDischargeToSearch);

    HospitalizationDischargeToSearch.$inject = ['$resource'];

    function HospitalizationDischargeToSearch($resource) {
        var resourceUrl =  'api/_search/hospitalization-discharge-tos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HospitalizationDischargeToController', HospitalizationDischargeToController);

    HospitalizationDischargeToController.$inject = ['$scope', '$state', 'HospitalizationDischargeTo', 'HospitalizationDischargeToSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function HospitalizationDischargeToController ($scope, $state, HospitalizationDischargeTo, HospitalizationDischargeToSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.hospitalizationDischargeTos = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  HospitalizationDischargeTo.query(function(result) {
                  vm.hospitalizationDischargeTos = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.hospitalizationDischargeTos, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            HospitalizationDischargeTo.query(function(result) {
                vm.hospitalizationDischargeTos = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HospitalizationDialogController', HospitalizationDialogController);

    HospitalizationDialogController.$inject = ['$timeout', '$scope', 'hospitalization', '$uibModalInstance',
        'Hospitalization', 'HospitalizationDischargeTo', '$state'
    ];

    function HospitalizationDialogController($timeout, $scope, hospitalization, $uibModalInstance,
                                             Hospitalization, HospitalizationDischargeTo, $state) {
        var vm = this;
        vm.hospitalization = hospitalization;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.hospitalizationdischargetos = HospitalizationDischargeTo.query();
        vm.editing = $state.current.name != "hospitalization.view";

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.hospitalization.id !== null) {
                Hospitalization.update(vm.hospitalization, onSaveSuccess, onSaveError);
            } else {
                Hospitalization.save(vm.hospitalization, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('dialysisApp:hospitalizationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.admissionDate = false;
        vm.datePickerOpenStatus.dischargeDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HospitalizationDeleteController',HospitalizationDeleteController);

    HospitalizationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Hospitalization'];

    function HospitalizationDeleteController($uibModalInstance, entity, Hospitalization) {
        var vm = this;

        vm.hospitalization = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Hospitalization.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('hospitalization', {
                parent: 'patient-abs',
                url: '/hospitalization',
                ncyBreadcrumb: {
                    label: 'Hospitalizations',
                },
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Hospitalizations'
                },
                views: {
                    'content@patient-abs': {
                        templateUrl: 'app/entities/hospitalization/hospitalizations.html',
                        controller: 'HospitalizationController',
                        controllerAs: 'vm'
                    }
                },
            })
            .state('hospitalization.view', {
                parent: 'hospitalization',
                url: '/{hid}/view',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/hospitalization/hospitalization-dialog.html',
                        controller: 'HospitalizationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            hospitalization: ['Hospitalization', function (Hospitalization) {
                                return Hospitalization.get({id: $stateParams.hid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('hospitalization', {id: $stateParams.id}, {reload: 'hospitalization'});
                    }, function () {
                        $state.go('hospitalization', {id: $stateParams.id}, {reload: 'hospitalization'});
                    });
                }]
            })
            .state('hospitalization.new', {
                parent: 'hospitalization',
                url: '/new',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function ($stateParams, $state, $uibModal, entity) {
                    $uibModal.open({
                        templateUrl: 'app/entities/hospitalization/hospitalization-dialog.html',
                        controller: 'HospitalizationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            hospitalization: function () {
                                return {
                                    admissionDiagnosis: null,
                                    admissionDate: null,
                                    hospital: null,
                                    admittingPhysician: null,
                                    dischargeDate: null,
                                    dueToBsi: null,
                                    renalRelatedInfection: false,
                                    renalRelatedOther: null,
                                    nonRenalRelatedOther: null,
                                    id: null,
                                    patient: entity
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('hospitalization', {id: $stateParams.id}, {reload: 'hospitalization'});
                    }, function () {
                        $state.go('hospitalization', {id: $stateParams.id}, {reload: 'hospitalization'});
                    });
                }]
            })
            .state('hospitalization.delete', {
                parent: 'hospitalization',
                url: '/{hid}/delete',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/hospitalization/hospitalization-delete-dialog.html',
                        controller: 'HospitalizationDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Hospitalization', function (Hospitalization) {
                                return Hospitalization.get({id: $stateParams.hid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('hospitalization', null, {reload: 'hospitalization'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Hospitalization', Hospitalization);

    Hospitalization.$inject = ['$resource', 'DateUtils'];

    function Hospitalization ($resource, DateUtils) {
        var resourceUrl =  'api/hospitalizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.admissionDate = DateUtils.convertLocalDateFromServer(data.admissionDate);
                        data.dischargeDate = DateUtils.convertLocalDateFromServer(data.dischargeDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.admissionDate = DateUtils.convertLocalDateToServer(copy.admissionDate);
                    copy.dischargeDate = DateUtils.convertLocalDateToServer(copy.dischargeDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.admissionDate = DateUtils.convertLocalDateToServer(copy.admissionDate);
                    copy.dischargeDate = DateUtils.convertLocalDateToServer(copy.dischargeDate);
                    return angular.toJson(copy);
                }
            },
            'getAllByPatientId': { 'url': 'api/hospitalizations/patient/:id', method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('HospitalizationSearch', HospitalizationSearch);

    HospitalizationSearch.$inject = ['$resource'];

    function HospitalizationSearch($resource) {
        var resourceUrl =  'api/_search/hospitalizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('HospitalizationController', HospitalizationController);

    HospitalizationController.$inject = ['$compile', '$scope', 'Hospitalization', 'entity', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', '$filter', 'moment'];

    function HospitalizationController($compile, $scope, Hospitalization, entity, $q, DTColumnBuilder, DTOptionsBuilder, $filter, moment) {
        var vm = this;

        vm.patient = entity;
        vm.hospitalization = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                Hospitalization.getAllByPatientId({id : vm.patient.id}, function (result) {
                    vm.hospitalization = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.patients, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('admissionDate').withTitle('Admission Date').renderWith(function (data, type, full) {
                return data ? moment(data).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn('dischargeDate').withTitle('Discharge Date').renderWith(function (data, type, full) {
                return data ? moment(data).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn('numDays').withTitle('Number of Days'),
            DTColumnBuilder.newColumn(null).withTitle('Due to BSI').renderWith(function (data, type, full) {
                return data.dueToBsi ? 'Y' : 'N';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Renal Related').renderWith(function (data, type, full) {
                return data.renalRelatedInfection ? 'Y' : 'N';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="hospitalization.view({hid:' + data.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            if (vm.patient.status) {
                stButtons += '<a class="btn-sm btn-danger" ui-sref="hospitalization.delete({hid:' + data.id + '})">' +
                    '   <i class="fa fa-trash"></i></a>';
            }

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('EnvTestSchedule', EnvTestSchedule);

    EnvTestSchedule.$inject = ['$resource', 'DateUtils'];

    function EnvTestSchedule ($resource, DateUtils) {
        var resourceUrl =  'api/env-test-schedules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'by_test': {url: 'api/env-test-schedules/by-test/:id', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.collectedDate = DateUtils.convertLocalDateFromServer(data.collectedDate);
                        data.scheduleDate = DateUtils.convertLocalDateFromServer(data.scheduleDate);
                        data.sentDate = DateUtils.convertLocalDateFromServer(data.sentDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.collectedDate = DateUtils.convertLocalDateToServer(copy.collectedDate);
                    copy.scheduleDate = DateUtils.convertLocalDateToServer(copy.scheduleDate);
                    copy.sentDate = DateUtils.convertLocalDateToServer(copy.sentDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.collectedDate = DateUtils.convertLocalDateToServer(copy.collectedDate);
                    copy.scheduleDate = DateUtils.convertLocalDateToServer(copy.scheduleDate);
                    copy.sentDate = DateUtils.convertLocalDateToServer(copy.sentDate);
                    return angular.toJson(copy);
                }
            },
            'cancel': { url: 'api/env-test-schedules/cancel/:id', method: 'GET'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvTestNewDialogController', EnvTestNewDialogController);

    EnvTestNewDialogController.$inject = ['envTest' , 'order', 'CompendiumSearch', 'OrderFrequency', '$uibModalInstance', 'EnvOrder', 'CoreService'];

    function EnvTestNewDialogController(envTest, order, CompendiumSearch, OrderFrequency, $uibModalInstance, EnvOrder, CoreService) {
        var vm = this;

        vm.order = order;
        vm.envTest = envTest;
        vm.is_new = vm.envTest.schedules.length == 0;

        vm.form = {};
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.staringDate = false;

        vm.orderfrequencies = OrderFrequency.query().$promise.then(function (data) {
          vm.orderfrequencies =  _.filter(data, { 'days': 0 });
        });

        vm.startOptions = {
            minDate: new Date(),
            startingDay: 1
        }

        vm.endOptions = {
            minDate: new Date(),
            startingDay: 1
        }

        vm.change = function () {
            if (vm.envTest.staringDate && vm.envTest.orderFrequency &&
                (vm.envTest.endDate || vm.envTest.orderFrequency.days == 0) &&
                vm.envTest.compendium) {

                vm.scheduleTest();
            }

            vm.endOptions.minDate = vm.envTest.staringDate;
        }

        vm.clinic = CoreService.getCurrentClinic();
        var days = vm.clinic.wDrawDays;

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.openCalendar = openCalendar;
        vm.orderfrequencies = [];

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.compendiums = [];

        vm.getCompendium = getCompendium;

        function getCompendium(query) {
            if (query && query.length > 2) {
                CompendiumSearch.query({query: query}, function (result) {
                    vm.compendiums = result;
                });
            }
        }

        vm.scheduleTest = scheduleTest;

        function scheduleTest() {
            var orderCopy = {};
            angular.copy(vm.order, orderCopy);
            angular.copy([vm.envTest], orderCopy.envTests);

            EnvOrder.schedule(orderCopy, function (data) {
                vm.envTest = data.envTests[0];
            }, function () {
                alert('Error creating test');
            });
        }

        vm.accept = function () {
            $uibModalInstance.close({envTest: vm.envTest, is_new: vm.is_new});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvTestDialogController', EnvTestDialogController);

    EnvTestDialogController.$inject = ['envTest', '$uibModalInstance', 'EnvTestSchedule'];

    function EnvTestDialogController (envTest, $uibModalInstance, EnvTestSchedule) {
        var vm = this;

        vm.envTest = envTest;

        vm.schedules = EnvTestSchedule.by_test({id: envTest.id});

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.accept = function () {
            $uibModalInstance.close();
        }

        vm.cancelOrderTestItem = function (item) {
            if (!item.canceled) {
                EnvTestSchedule.cancel({id: item.id}, function () {
                }, function () {
                    $state.reload("env-order", {oid: vm.patientOrder.id});
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvTestDeleteNewController',EnvTestDeleteNewController);

    EnvTestDeleteNewController.$inject = ['$uibModalInstance', 'entity'];

    function EnvTestDeleteNewController($uibModalInstance, entity) {
        var vm = this;

        vm.envTest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            $uibModalInstance.close({id: id});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvTestDeleteController',EnvTestDeleteController);

    EnvTestDeleteController.$inject = ['$uibModalInstance', 'entity', 'EnvTest'];

    function EnvTestDeleteController($uibModalInstance, entity, EnvTest) {
        var vm = this;

        vm.envTest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EnvTest.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('env-order-detail.test-detail', {
                parent: 'env-order-detail',
                url: '/{tid}/detail2',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_ENVIRONMENTAL', 'ROLE_DOCTOR'],
                    pageTitle: 'EnvTest'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/env-test/env-test-dialog.html',
                        controller: 'EnvTestDialogController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            envTest: ['EnvTest', function (EnvTest) {
                                return EnvTest.with_all({id: $stateParams.tid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('env-order-detail', null, {reload: 'env-order-detail'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('EnvTest', EnvTest);

    EnvTest.$inject = ['$resource', 'DateUtils'];

    function EnvTest ($resource, DateUtils) {
        var resourceUrl =  'api/env-tests/:id';

        return $resource(resourceUrl, {}, {
            'order': { url: 'api/env-tests/by-order/:id', method: 'GET', isArray: true},
            'test_order_by_date': { url: 'api/env-tests/by-order/:id/:date', method: 'GET', isArray: true},
            'findAllWithoutBarcode': {
                url: 'api/env-tests/without-barcode', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);

                    return angular.toJson(copy);
                }
            },
            'with_all': { url: 'api/env-tests/with-all/:id', method: 'GET'},
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.staringDate = DateUtils.convertLocalDateFromServer(data.staringDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.staringDate = DateUtils.convertLocalDateToServer(copy.staringDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.staringDate = DateUtils.convertLocalDateToServer(copy.staringDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'findAllByBarcode': {url: 'api/env-tests/by-barcode/:barcode', method: 'GET', isArray: true},
            'findAllByBarcode2': {url: 'api/env-tests/by-barcode2/:barcode', method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('EnvTestSearch', EnvTestSearch);

    EnvTestSearch.$inject = ['$resource'];

    function EnvTestSearch($resource) {
        var resourceUrl =  'api/_search/env-tests/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvTestController', EnvTestController);

    EnvTestController.$inject = ['order', '$compile', '$scope', 'EnvTest', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', '$filter', '$uibModal'];

    function EnvTestController(order, $compile, $scope, EnvTest, $q, DTColumnBuilder, DTOptionsBuilder, $filter, $uibModal) {
        var vm = this;

        vm.order = order;
        vm.envTests = [];
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                EnvTest.order({id: vm.order.id}, function (result) {
                    vm.envTests = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.envTests, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withBootstrap().withDOM('tip').withOption('aaSorting', []).withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Test').renderWith(function (data, type, full) {
                return data.compendium.code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.compendium.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.staringDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return data.endDate ? moment(data.endDate).format("MM/DD/YYYY") : moment(data.staringDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';
            stButtons += '<a class="btn-sm btn-warning" ui-sref="env-order-detail.test-detail({tid:' + data.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            return stButtons;
        }

        // function actionsHtml(data, type, full, meta){
        //     var stButtons = '';
        //
        //     stButtons += '<a class="btn-sm btn-warning" ng-click="vm.edit(' + meta.row + ')">' +
        //         '   <i class="fa fa-edit"></i></a>&nbsp;';
        //
        //     return stButtons;
        // }

        // vm.edit = function (index) {
        //     $uibModal.open({
        //         templateUrl: 'app/entities/env-test/env-test-dialog.html',
        //         controller: 'EnvTestDialogController',
        //         controllerAs: 'vm',
        //         backdrop: 'static',
        //         size: 'lg',
        //         resolve: {
        //             order: vm.order,
        //             envTest: vm.envTests[index],
        //             canCancel : vm.canCancel
        //         }
        //     }).result.then(function(result) {
        //
        //     }, function() {
        //     });
        // }
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('EnvResultFile', EnvResultFile);

    EnvResultFile.$inject = ['$resource', 'DataUtils'];

    function EnvResultFile ($resource, DataUtils) {
        var resourceUrl =  'api/env-result-files/:id';

        return $resource(resourceUrl, {}, {
            'getAllByEnvResult': {
                url: 'api/env-result-files/by-env-result/all/:id',
                method: 'GET',
                isArray: true
            },
            'getPdf': {
                url: 'api/env-result-files/get-pdf',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            },
            'getByEnvResult': {
                url: 'api/env-result-files/by-machine-result/getpdf',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            },
            'getAllInOnePdf': {
                url: 'api/env-result-files/get-all-in-one-pdf',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('latest-env-result-det', {
                parent: 'latest-env-result',
                url: '/{id}/edetails',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_ENVIRONMENTAL', 'ROLE_DOCTOR'],
                    pageTitle: 'Environmental Result Details'
                },
                ncyBreadcrumb: {
                    label: 'Result Details',
                    parent: 'latest-env-result'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/env-result-det/env-result-dets.html',
                        controller: 'EnvResultDetController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    envResult: ['$stateParams', 'EnvResult', function ($stateParams, EnvResult) {
                        return EnvResult.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('EnvResultDet', EnvResultDet);

    EnvResultDet.$inject = ['$resource'];

    function EnvResultDet($resource) {
        var resourceUrl = 'api/env-result-dets/:id';

        return $resource(resourceUrl, {}, {
            'get': {method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('EnvResultDetSearch', EnvResultDetSearch);

    EnvResultDetSearch.$inject = ['$resource'];

    function EnvResultDetSearch($resource) {
        var resourceUrl =  'api/_search/env-result-dets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvResultDetController', EnvResultDetController);

    EnvResultDetController.$inject = ['envResult', 'EnvResultDetSearch', 'EnvResultFile', '$compile', '$scope', 'EnvResult',
        '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$uibModalInstance', 'lodash'];

    function EnvResultDetController(envResult, EnvResultDetSearch, EnvResultFile, $compile, $scope, EnvResult,
                                    $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $uibModalInstance, _) {
        var vm = this;

        vm.envResultDets = [];
        vm.envResult = envResult;
        vm.dtInstance = {};
        vm.pdf = {};

        vm.envResultFiles = EnvResultFile.getAllByEnvResult({id: envResult.id});

        vm.groups = [];
        vm.groupsAll = {name: 'All', value: true};
        vm.levels = {
            all: true,
            abnormals: true,
            criticals: true,
            L: true,
            LL: true,
            N: true,
            H: true,
            HH: true
        };

        vm.clear = clear;
        vm.search = search;
        vm.toggleFilters = toggleFilters;
        vm.search = search;

        vm.dtColumns = [
            DTColumnBuilder.newColumn('testCode').withOption('width', '190px').withTitle('Test Code'),
            DTColumnBuilder.newColumn('testName').withOption('width', '350px').withTitle('Test'),
            DTColumnBuilder.newColumn('rGroup').withOption('width', '250px').withTitle('Group').notVisible(),
            DTColumnBuilder.newColumn(null).withTitle('Result').renderWith(function (data, type, full) {
                return decorateResult(full.status, full.result);
            }),
            DTColumnBuilder.newColumn('cutOff').withTitle('Ranges'),
            DTColumnBuilder.newColumn('units').withTitle('Units'),
        ];

        if (vm.envResult.reviewedStatus == false || vm.envResult.reviewedStatus == null) {
            EnvResult.markAsReviewed({id: vm.envResult.id});
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.envResultDets.length == 0) {
                EnvResultDetSearch.query(
                    {
                        query: {
                            bool: {
                                must: getFilter()
                            }
                        }
                    }, function (result) {
                        vm.envResultDets = result;

                        var groupsIndex = {};

                        vm.envResultDets.forEach(function (detail) {
                            if (detail.rGroup && groupsIndex[detail.rGroup] == undefined) {
                                groupsIndex[detail.rGroup] = detail.rGroup;
                                vm.groups.push({name: detail.rGroup, value: true});
                            }
                        });

                        defer.resolve(vm.envResultDets);
                    });
            } else {
                //groupsNames actives
                var groupsNames = _.map(_.filter(vm.groups, {'value': true}), function (group) {
                    return group.name;
                });

                //status actives
                var levelsIn = [];
                //status inactives
                var levelsOut = [];

                _.forOwn(vm.levels, function (value, key) {
                    if (['L', 'LL', 'N', 'H', 'HH'].indexOf(key) != -1) {
                        if (value) {
                            levelsIn.push(key);
                        } else {
                            levelsOut.push(key)
                        }
                    }
                });

                var resultsDets = _.filter(vm.envResultDets, function (det) {
                    var status = det.status;

                    return groupsNames.indexOf(det.rGroup) != -1 &&
                        //check if appear a value different of L, LL, N, H, HH like A
                        levelsIn.indexOf(status) != -1 || levelsOut.indexOf(status) == -1;
                });

                defer.resolve($filter('filter')(resultsDets, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[2, 'asc'], [0, 'asc']])
            .withOption('fnDrawCallback', function (oSettings) {
                var api = this.api();
                var rows = api.rows({page: 'current'}).nodes();
                var last = null;
                api.column(2, {page: 'current'}).data().each(function (group, i) {
                    if (last !== group) {
                        $(rows).eq(i).before(
                            '<tr class="group"><td colspan="6"><strong>' + group + '</strong></td></tr>'
                        );
                        last = group;
                    }
                });
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });


        function decorateResult(status, result) {
            switch (status) {
                case 'N': {
                    return result;
                }
                case 'L':
                case 'H': {
                    return GUIUtils.getStatusTemplate(result + ' ' + status, 'primary');
                }
                case 'LL':
                case 'HH': {
                    return GUIUtils.getStatusTemplate(result + ' ' + status, 'danger');
                }
                default: {
                    return '';
                }
            }
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        vm.getPDF = function () {
            EnvResultFile.getPdf(vm.pdf.id);
        }

        function getFilter() {
            var must = [];
            must.push({term: {"delStatus": false}});
            must.push({term: {"envResultId": vm.envResult.id}});

            return must;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function toggleFilters() {
            angular.element('.filters-wrapper').slideToggle()
        }

        vm.groupsCheck = groupsCheck;
        vm.groupCheckAll = groupCheckAll;
        vm.levelAll = levelAll;
        vm.abnormals = abnormals;
        vm.criticals = criticals;
        vm.normal = normal;
        vm.notNormal = notNormal;

        function levelAll() {
            for (var key in vm.levels) {
                vm.levels[key] = vm.levels.all;
            }

            search();
        }

        function abnormals() {
            if (vm.levels.abnormals) {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'abnormals':
                        case 'L':
                        case 'LL':
                        case 'H':
                        case 'HH':
                            vm.levels[key] = true;
                            break;
                        default:
                            vm.levels[key] = false;
                    }
                }
            } else {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'all':
                        case 'criticals':
                        case 'L':
                        case 'LL':
                        case 'H':
                        case 'HH':
                            vm.levels[key] = false;
                            break;
                    }
                }
            }

            search();
        }

        function criticals() {
            if (vm.levels.criticals) {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'criticals':
                        case 'LL':
                        case 'HH':
                            vm.levels[key] = true;
                            break;
                        default:
                            vm.levels[key] = false;
                    }
                }
            } else {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'all':
                        case 'abnormals':
                        case 'LL':
                        case 'HH':
                            vm.levels[key] = false;
                            break;
                    }
                }
            }

            search();
        }

        function normal() {
            if (vm.levels.N) {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'abnormals':
                        case 'criticals':
                            vm.levels[key] = false;
                            break;
                        case 'all':
                            vm.levels[key] = vm.levels.L && vm.levels.LL && vm.levels.H && vm.levels.HH && vm.levels.N;
                            break;
                    }
                }
            } else {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'abnormals':
                            vm.levels[key] = vm.levels.L && vm.levels.LL && vm.levels.H && vm.levels.HH;
                            break;
                        case 'criticals':
                            vm.levels[key] = !vm.levels.L && vm.levels.LL && !vm.levels.H && vm.levels.HH;
                            break;
                        case 'all':
                            vm.levels[key] = false;
                            break;
                    }
                }
            }

            search();
        }

        function notNormal() {
            vm.levels['abnormals'] = vm.levels.L && vm.levels.LL && vm.levels.H && vm.levels.HH && !vm.levels.N;
            vm.levels['criticals'] = !vm.levels.L && vm.levels.LL && !vm.levels.h && vm.levels.hh && !vm.levels.N;
            vm.levels['all'] = vm.levels.L && vm.levels.LL && vm.levels.H && vm.levels.HH && vm.levels.N;

            search();
        }

        function groupsCheck() {
            var all = true;

            vm.groups.forEach(function (group) {
                all = all && group.value;
            });

            vm.groupsAll.value = all;

            search();
        }

        function groupCheckAll() {
            vm.groups.forEach(function (group) {
                group.value = vm.groupsAll.value;
            });

            search();
        }

    }
})();

// EnvResultUpdateDatesController
(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvResultUpdateDatesController', EnvResultUpdateDatesController);

    EnvResultUpdateDatesController.$inject = ['EnvResult', 'toastr', '$state', 'dialogs'];

    function EnvResultUpdateDatesController(EnvResult, toastr, $state, $dialogs) {
        var vm = this;

        vm.barcode = '';
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.receivedDate = false;
        vm.datePickerOpenStatus.collectionDate = false;
        vm.openCalendar = openCalendar;
        vm.saveDates=saveDates;
        vm.clear = clear;
        vm.clean = clean;

        function saveDates() {
            var dlg = $dialogs.confirm('Please Confirm','Do you want to update this result?', {size: 'md'});
            dlg.result.then(function(btn){
                vm.isSaving = true;
                EnvResult.updateDates({
                    barcode: vm.barcode,
                    startDate: vm.receivedDate,
                    endDate: vm.collectionDate
                }, function (result) {
                    toastr.success('Update dates operation successfully completed');
                    vm.isSaving = false;
                    vm.clean();
                }, function () {
                    vm.isSaving = false;
                });
            },function(btn){
            });
        }

        function clear() {
            $state.go("latest-env-result", {});
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clean(){
            vm.barcode = "";
            vm.receivedDate = "";
            vm.collectionDate = "";
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvResultLatestController', EnvResultLatestController);

    EnvResultLatestController.$inject = ['$scope', 'EnvResultSearch', 'EnvResultFile', 'clinic', '$q',
        'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'filterRes',
        'PopupService', 'DataTablesService', 'CoreService'];

    function EnvResultLatestController($scope, EnvResultSearch, EnvResultFile, clinic, $q,
                                       DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter,
                                       $compile, filterRes, PopupService, DataTablesService, CoreService) {

        var vm = this;

        vm.title = 'Latest Site Results';
        vm.entityClassHumanized = 'Latest Sites Results';
        vm.entityStateName = 'env-result';
        vm.currentMonth = false;
        vm.envResults = [];
        vm.dtInstance = {};
        vm.clinic = clinic;
        vm.filterRes = filterRes;
        vm.selected = {};
        vm.selectAll = false;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;
        vm.isFilter = false;

        vm.search = search;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.printPDFs = printPDFs;
        vm.openCalendar = openCalendar;
        vm.updateStatusButtonFilter = updateStatusButtonFilter;
        vm.updateCurrentMonthFilter = updateCurrentMonthFilter;
        vm.showFiltersPanel = showFiltersPanel;
        vm.clear = clear;
        vm.getFilter = getFilter;
        vm.details = details;

        angular.element('.filter-box').hide();

        function showFiltersPanel() {
            angular.element('.filter-box').toggleClass('active');

            if (angular.element('.filter-box').hasClass('active')) {
                angular.element('.toggle-filters').addClass('open');
                angular.element('.filter-box').slideDown();
            } else {
                angular.element('.toggle-filters').removeClass('open');
                angular.element('.filter-box').slideUp();
            }
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (!vm.searchQuery || vm.searchQuery == '') {
                EnvResultSearch.query(
                    {
                        query: {
                            bool: {
                                must: getFilter()
                            }
                        },
                        clinic: clinic.id
                    }, function (result) {
                        vm.envResults = result;
                        defer.resolve(vm.envResults);
                    });
            } else {
                defer.resolve($filter('filter')(vm.envResults, vm.searchQuery, undefined));
            }

            vm.selected = {};
            vm.selectAll = false;
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[6, 'desc'], [2, 'asc']])
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('machine').withTitle('Machine'),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.accessionNumber ? data.accessionNumber : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Order ID').renderWith(function (data, type, full) {
                return data.orderId ? data.orderId : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Collection Date').renderWith(function (data, type, full) {
                return moment(data.collectionDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Collection Date').notVisible().renderWith(function (data, type, full) {
                return moment(data.collectionDate).format("YYYYMMDD");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Result Date').renderWith(function (data, type, full) {
                return moment(data.createdDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('').withTitle('Alert').withOption('width', '155px').notSortable()
                .renderWith(abnormalHtml),
            DTColumnBuilder.newColumn('status').withTitle('Status').renderWith(statusHtml),
            DTColumnBuilder.newColumn('').withTitle('Actions').withOption('class', 'col').withOption('width', '175px').notSortable()
                .renderWith(actionsHtml)
        ];

        function abnormalHtml(data, type, full, meta) {
            if (full.abnormal) {
                return GUIUtils.getStatusTemplate('ABNORMAL', 'danger');
            } else {
                return GUIUtils.getStatusTemplate('NORMAL', 'success');
            }
        }

        function statusHtml(data, type, full, meta) {
            if (full.status == 'PARTIAL') {
                return GUIUtils.getStatusTemplate(full.status, 'warning');
            } else {
                return GUIUtils.getStatusTemplate(full.status, 'primary');
            }
        }

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="dt-btn warning"  ng-click="vm.details(' + full.id + ')" uib-tooltip="View Details"><i class="fa fa-file-text" aria-hidden="true"></i></a>';

            stButtons += '<a class="dt-btn danger" ng-click="vm.printPDFs(' + full.id + ')" uib-tooltip="View PDF"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></a>';

            return stButtons;
        }

        function search() {
            CoreService.setStorage('filterEnvironmental', vm.filterRes);
            vm.dtInstance.reloadData();
        }

        function getFilter() {
            var must = [];
            must.push({
                bool: {
                    "should": [
                        {"term": {"clinicId": vm.clinic.id}},
                        {"term": {"clinic.id": vm.clinic.id}}
                    ]
                }
            });
            must.push({term: {"delStatus": false}});
            must.push({exists: {"field": "accessionNumber"}});

            if (vm.filterRes.name != null && vm.filterRes.name.length > 0) {
                must.push({match: {machine: {query: vm.filterRes.name + "%"}}});
            }

            if (vm.filterRes.status != null && vm.filterRes.status.length > 0) {
                must.push({match: {status: {query: vm.filterRes.status}}});
            }

            if (vm.filterRes.start) {
                must.push({range: {collectionDate: {gte: moment(vm.filterRes.start).format("YYYY-MM-DD")}}});
            }

            if (vm.filterRes.end) {
                must.push({range: {collectionDate: {lte: moment(vm.filterRes.end).format("YYYY-MM-DD")}}});
            }

            if (vm.filterRes.barcode != null && vm.filterRes.barcode.length > 0) {
                must.push({match: {accessionNumber: {query: vm.filterRes.barcode}}});
            }

            if (vm.filterRes.abnormal != null && vm.filterRes.abnormal.length > 0) {
                must.push({match: {abnormal: {query: vm.filterRes.abnormal}}});
            }

            if (vm.filterRes.reviewedStatus != null && vm.filterRes.reviewedStatus.length > 0) {
                must.push({term: {reviewedStatus: vm.filterRes.reviewedStatus}});
            }

            return must;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            vm.filterRes = CoreService.initEnvResultFilter();
            CoreService.setStorage('filterEnvironmental', vm.filterRes);
            vm.dtInstance.reloadData();
        }

        function printPDFs(id) {
            var ids;

            if (id) {
                ids = [id];
            } else {
                ids = DataTablesService.getSelectedIds(vm.selected);
            }

            if (ids.length > 0) {
                EnvResultFile.getAllInOnePdf({ids: ids});
            }
        }

        function updateStatusButtonFilter(status) {
            vm.filterRes.status = status;
            CoreService.setStorage('filterEnvironmental', vm.filterRes);
            vm.dtInstance.reloadData();
        }

        function updateCurrentMonthFilter() {
            if (vm.currentMonth) {
                var nowdate = new Date();
                var monthStartDay = new Date(nowdate.getFullYear(), nowdate.getMonth(), 1);
                var monthEndDay = new Date(nowdate.getFullYear(), nowdate.getMonth() + 1, 0);
                vm.filterRes.start = monthStartDay;
                vm.filterRes.end = monthEndDay;
            } else {
                vm.filterRes = CoreService.initEnvResultFilter();
            }
            CoreService.setStorage('filterEnvironmental', vm.filterRes);
            vm.dtInstance.reloadData();
        }

        function details(id) {
            var envResult = vm.envResults.find(function (el) {
                return el.id === id;
            });

            PopupService.showEnvResultDetPopup(envResult);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvResultDialogController', EnvResultDialogController);

    EnvResultDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'EnvResult', 'EnvOrder', 'EnvResultDet'];

    function EnvResultDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, EnvResult, EnvOrder, EnvResultDet) {
        var vm = this;

        vm.envResult = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.orders = EnvOrder.query({filter: 'result-is-null'});
        $q.all([vm.envResult.$promise, vm.orders.$promise]).then(function() {
            if (!vm.envResult.order || !vm.envResult.order.id) {
                return $q.reject();
            }
            return EnvOrder.get({id : vm.envResult.order.id}).$promise;
        }).then(function(order) {
            vm.orders.push(order);
        });
        vm.envresultdets = EnvResultDet.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.envResult.id !== null) {
                EnvResult.update(vm.envResult, onSaveSuccess, onSaveError);
            } else {
                EnvResult.save(vm.envResult, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:envResultUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dob = false;
        vm.datePickerOpenStatus.collectionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvResultDetailController', EnvResultDetailController);

    EnvResultDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EnvResult', 'EnvOrder', 'EnvResultDet'];

    function EnvResultDetailController($scope, $rootScope, $stateParams, previousState, entity, EnvResult, EnvOrder, EnvResultDet) {
        var vm = this;

        vm.envResult = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:envResultUpdate', function(event, result) {
            vm.envResult = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvResultDeleteController',EnvResultDeleteController);

    EnvResultDeleteController.$inject = ['dialogs', 'EnvResult', 'toastr'];

    function EnvResultDeleteController($dialogs, EnvResult, toastr) {
        var vm = this;

        vm.barcode = "";

        vm.deleteResult = deleteResult;

        function deleteResult() {
            var dlg = $dialogs.confirm('Please Confirm','Do you want to delete this env result?', {size: 'md'});

            dlg.result.then(function(btn){
                EnvResult.byBarcode({barcode: vm.barcode}, function (result) {
                    EnvResult.delete({id: result.id}, function () {
                        vm.barcode = "";

                        toastr.success('Delete successfully!');
                    });
                });
            },function(btn) {
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('latest-env-result', {
                parent: 'entity',
                url: '/latest-env-result',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_ENVIRONMENTAL', 'ROLE_DOCTOR'],
                    pageTitle: 'Latest Environmental Results'
                },
                ncyBreadcrumb: {
                    label: 'Latest Site Results',
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/env-result/env-result-latest.html',
                        controller: 'EnvResultLatestController',
                        controllerAs: 'vm'
                    },
                    'select-filter@latest-env-result': {
                        templateUrl: 'app/entities/machine/machine-select-filter.html',
                        controller: 'MachineSelectFilter',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    filter: null
                },
                resolve: {
                    clinic: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentClinic();
                    }],
                    filterRes: ['$stateParams', 'CoreService', function ($stateParams, CoreService) {
                        if ($stateParams.filter) {
                            return CoreService.readEnvResultFilter($stateParams.filter)
                        } else {
                            var filterPatient = CoreService.getStorage('filterEnvironmental');

                            if (filterPatient == undefined) {
                                return CoreService.initEnvResultFilter();
                            } else {
                                return CoreService.readEnvResultFromLocalStore(filterPatient);
                            }
                        }
                    }]
                }
            })
            .state('machine-env-result', {
                parent: 'machine-detail',
                url: '/results',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_ENVIRONMENTAL', 'ROLE_DOCTOR'],
                    pageTitle: 'Site Results'
                },
                ncyBreadcrumb: {
                    label: 'Results',
                    parent: 'machine-detail'
                },
                views: {
                    'content@machine-detail': {
                        templateUrl: 'app/entities/env-result/env-result.html',
                        controller: 'EnvResultController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterRes: function () {
                        return {
                            name: null,
                            start: null,
                            end: null,
                            status: null
                        }
                    },
                }
            })
            .state('env-result-update-dates', {
                parent: 'entity',
                url: '/env-result-update-dates',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Update Environmental Result Dates'
                },
                ncyBreadcrumb: {
                    label: 'Update Result Dates',
                    parent: 'latest-env-result'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/env-result/env-result-update-dates.html',
                        controller: 'EnvResultUpdateDatesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                }
            })
            .state('env-result-delete', {
                parent: 'entity',
                url: '/env-result-delete',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Delete env result'
                },
                ncyBreadcrumb: {
                    label: 'Delete env result',
                    parent: 'entity'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/env-result/env-result-delete-dialog.html',
                        controller: 'EnvResultDeleteController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('EnvResult', EnvResult);

    EnvResult.$inject = ['$resource', 'DateUtils', 'DataUtils'];

    function EnvResult($resource, DateUtils, DataUtils) {
        var resourceUrl = 'api/env-results/:id';

        function transformCountResponse(data) {
            if (data) {
                data = angular.fromJson(data);
                data = {value: data};
            }
            return data;
        }

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                        data.collectionDate = DateUtils.convertLocalDateFromServer(data.collectionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    copy.collectionDate = DateUtils.convertLocalDateToServer(copy.collectionDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    copy.collectionDate = DateUtils.convertLocalDateToServer(copy.collectionDate);
                    return angular.toJson(copy);
                }
            },
            'by_clinic': {url: "api/env-results/by-clinic/:id", method: 'GET', isArray: true},
            'by_machine': {
                url: "api/env-results/by-machine/:id", method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertLocalDateFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'byBarcode': {
                url: "api/env-results/barcode/:barcode/",
                method: 'GET',
                // transformResponse: function (data) {
                //     if (data) {
                //         data = angular.fromJson(data);
                //         data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                //         data.collectionData = DateUtils.convertLocalDateFromServer(data.collectionData);
                //         data.reviewedOn = DateUtils.convertLocalDateFromServer(data.reviewedOn);
                //     }
                //     return data;
                // }
            },
            'countAbnormalNotReviewedLast7Days': {url: 'api/env-results/count-abnormal-not-reviewed-last-7days/:id', method: 'GET', isArray: true},
            'markAsReviewed': {url: 'api/env-result/mark-as-reviewed', method: 'POST'},
            'updateDates': {method: 'POST', url: "api/env-results/update-dates"},
            'countAbnormalNotReviewed': {
                url: 'api/env-results/count-abnormal-not-reviewed/:id', method: 'GET',
                transformResponse: transformCountResponse
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('EnvResultSearch', EnvResultSearch);

    EnvResultSearch.$inject = ['$resource'];

    function EnvResultSearch($resource) {
        var resourceUrl =  'api/_search/env-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvResultController', EnvResultController);

    EnvResultController.$inject = ['machine', '$scope', 'EnvResultSearch', 'EnvResult', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'filterRes', 'EnvResultFile', 'PopupService'];

    function EnvResultController(machine, $scope, EnvResultSearch, EnvResult, $q, DTColumnBuilder,
                                 DTOptionsBuilder, GUIUtils, $filter, $compile, filterRes, EnvResultFile, PopupService) {
        var vm = this;
        vm.title = 'Latest Site Results';
        vm.entityClassHumanized = 'Latest Environmental Results';
        vm.entityStateName = 'env-result';

        vm.machine = machine;
        vm.envResults = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.filterRes = filterRes;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.isFilter) {
                defer.resolve(vm.envResults);
                vm.isFilter = false;
            } else if (!vm.searchQuery || vm.searchQuery == '') {
                EnvResult.by_machine({id: vm.machine.id}, function (result) {
                    vm.envResults = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.envResults, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('machine').withTitle('Machine'),
            DTColumnBuilder.newColumn('accessionNumber').withTitle('BarCode'),
            DTColumnBuilder.newColumn(null).withTitle('Order ID').renderWith(function (data, type, full) {
                return data.order ? data.order.id : "";
            }),
            DTColumnBuilder.newColumn('status').withTitle('Status'),
            DTColumnBuilder.newColumn(null).withTitle('Collection Date').renderWith(function (data, type, full) {
                return moment(data.collectionDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Result Date').renderWith(function (data, type, full) {
                return moment(data.createdDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('').withTitle('').withOption('width', '155px').notSortable()
                .renderWith(abnormalHtml),
            DTColumnBuilder.newColumn('').withTitle('').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function abnormalHtml(data, type, full, meta) {
            if (full.abnormal) {
                return GUIUtils.getStatusTemplate('ABNORMAL', 'danger');
            } else {
                return GUIUtils.getStatusTemplate('NORMAL', 'success');
            }
        }

        function actionsHtml(data, type, full, meta) {
            return '<div>' +
                '<div class="btn-group" uib-dropdown>' +
                '<button type="button" class="btn btn-default" ng-click="vm.getPDF(' + full.id + ')">View PDF</button>' +
                '<button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle ng-disabled="disabled" data-toggle="dropdown" aria-expanded="false">' +
                '<span class="caret"></span>' +
                '<span class="sr-only">Toggle Dropdown</span>' +
                '</button>' +
                '<ul class="dropdown-menu" uib-dropdown-menu role="menu">' +
                '<li><a ng-click="vm.details(' + full.id + ')">Details</a></li>' +
                '</ul>' +
                '</div></div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        vm.getPDF = function (id) {
            EnvResultFile.getByEnvResult(id);
        }

        vm.popoverFilterEnable = popoverFilterEnable;
        vm.showFilter = false;

        function popoverFilterEnable() {
            vm.showFilter = !vm.showFilter;
        }

        vm.isFilter = false;
        vm.filter = filter;

        function filter() {
            if (!vm.filterRes.name && !vm.filterRes.start && !vm.filterRes.end && !vm.filterRes.status) {
                return;
            }

            vm.isFilter = true;

            var must = [];
            must.push({term: {"order.machine.id": machine.id}});
            must.push({term: {"delStatus": false}});

            if (vm.filterRes.status != null && vm.filterRes.status.length > 0) {
                must.push({match: {status: {query: vm.filterRes.status}}});
            }

            if (vm.filterRes.start) {
                must.push({range: {createdDate: {gte: vm.filterRes.start}}});
            }

            if (vm.filterRes.end) {
                var end = new Date(vm.filterRes.end);
                end.setHours(23, 59, 59);
                must.push({range: {createdDate: {lte: end}}});
            }

            EnvResultSearch.query(
                {
                    query: {
                        bool: {
                            must: must
                        }
                    }
                }, function (result) {
                    vm.envResults = result;
                    vm.dtInstance.reloadData();
                });
        }

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;

        vm.openCalendar = openCalendar;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.clear = clear;

        function clear() {
            vm.filterRes = {
                name: null,
                start: null,
                end: null,
                status: null
            };

            vm.isFilter = false;
            vm.dtInstance.reloadData();
        }

        vm.details = details;

        function details(id) {
            PopupService.showEnvResultDetPopup(id);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvOrderNewTemplateController', EnvOrderNewTemplateController);

    EnvOrderNewTemplateController.$inject = ['$scope', '$compile', '$state', 'envOrderTpl', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', '$stateParams', 'ROLES',
        'CoreService', 'EnvOrderTpl', '$uibModal', 'Principal', 'Corporation', 'Compendium', 'lodash'];

    function EnvOrderNewTemplateController($scope, $compile, $state, envOrderTpl, $q, DTColumnBuilder, DTOptionsBuilder, $stateParams, ROLES,
                                               CoreService, EnvOrderTpl, $uibModal, Principal, Corporation, Compendium, _) {

        var vm = this;

        vm.envOrderTpl = envOrderTpl;
        vm.envOrder = envOrderTpl.envOrderJson;
        vm.compendiumErrors = [];

        vm.form = {};
        vm.save = save;

        if (Principal.hasRole(ROLES.ROLE_ADMIN)) {
            vm.corporations = Corporation.query();
        } else {
            vm.corporations = [CoreService.getCurrentEmployee().corporation];
            vm.envOrderTpl.corporation = CoreService.getCurrentEmployee().corporation;
            vm.envOrder.corporation = CoreService.getCurrentEmployee().corporation;
        }

        if ($stateParams.clone) {
            vm.envOrderTpl.id = null;
        }

        function save() {
            vm.isSaving = true;

            vm.envOrderTpl.envOrderJson = vm.envOrder;
            vm.envOrderTpl.corporation = vm.envOrder.corporation;

            vm.isSaving = true;
            if (vm.envOrderTpl.id !== null) {
                EnvOrderTpl.update(vm.envOrderTpl, onSaveSuccess, onSaveError);
            } else {
                EnvOrderTpl.save(vm.envOrderTpl, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            $state.go("env-order-tpl");
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.addEnvOrderTest = function () {
            var test = {
                id: null
            };

            vm.popupTest(test, -1);
        };

        vm.editEnvOrderTest = function (index) {
            vm.popupTest(vm.envOrder.envTests[index], index);
        };

        vm.deleteEnvOrderTest = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/env-test/env-test-delete-dialog.html',
                controller: 'EnvTestDeleteNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: {id: index}
                }
            }).result.then(function () {
                vm.envOrder.envTests.splice(index, 1);

                vm.dtInstance.reloadData();
            }, function () {
            });
        };

        vm.popupTest = function (envOrderTest, index) {
            $uibModal.open({
                templateUrl: 'app/entities/env-order-tpl/env-order-test-tpl-new-dialog.html',
                controller: 'EnvOrderTestTplNewDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    envOrder: vm.envOrder,
                    envOrderTest: envOrderTest,
                }
            }).result.then(function (result) {
                if (index < 0) {
                    vm.envOrder.envTests.push(result.envTest);
                } else {
                    vm.envOrder.envTests[index] = result.envTest;
                }
                vm.dtInstance.reloadData();
            }, function () {
            });
        };

        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            vm.compendiumErrors = [];
            var compendiums = _.map(vm.envOrder.envTests, 'compendium');

            Compendium.check({compendiums: compendiums}, function (result) {
                if (result.compendiums.length > 0) {
                    _.forEach(result.compendiums, function (compendium) {
                        return vm.compendiumErrors.push(compendium.code);
                    });
                }

                defer.resolve(vm.envOrder.envTests);
            });

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('paging', false).withOption('aaSorting', []).withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Test').renderWith(function (data, type, full) {
                return (vm.compendiumErrors.indexOf(data.compendium.code) == -1 ? data.compendium.code : '<span class="label label-danger">' + data.compendium.code + '</span>');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.compendium.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.orderFrequency.name;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ng-click="vm.editEnvOrderTest(' + meta.row + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';
            stButtons += '<a class="btn-sm btn-danger" ng-click="vm.deleteEnvOrderTest(' + meta.row + ')">' +
                '   <i class="fa fa-trash"></i></a>';

            return stButtons;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvOrderTplDeleteController',EnvOrderTplDeleteController);

    EnvOrderTplDeleteController.$inject = ['$uibModalInstance', 'entity', 'EnvOrderTpl'];

    function EnvOrderTplDeleteController($uibModalInstance, entity, EnvOrderTpl) {
        var vm = this;

        vm.tpl = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EnvOrderTpl.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('env-order-tpl', {
                parent: 'entity',
                url: '/env-order-tpl',
                ncyBreadcrumb: {
                    label: 'Site Order Templates'
                },
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_ENVIRONMENTAL', 'ROLE_DOCTOR'],
                    pageTitle: 'Site Order Templates'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/env-order-tpl/env-order-tpl.html',
                        controller: 'EnvOrderTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('env-order-tpl.new', {
                url: '/new',
                ncyBreadcrumb: {
                    label: 'New Order Template'
                },
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_ENVIRONMENTAL', 'ROLE_DOCTOR'],
                    pageTitle: 'New Site Order Template'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/env-order-tpl/env-order-tpl-new.html',
                        controller: 'EnvOrderNewTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    envOrderTpl: ['$stateParams', function ($stateParams) {
                        return {
                            envOrderJson: {
                                orderType: $stateParams.orderType,
                                id: null,
                                envTests: [],
                                ordStatus: 'SCHEDULED'
                            }
                        };
                    }],
                }
            })
            .state('env-order-tpl.edit', {
                parent: 'env-order-tpl',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
                },
                params: {
                    orderType: 'ONE_TIME',
                    clone: false
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/env-order-tpl/env-order-tpl-new.html',
                        controller: 'EnvOrderNewTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    envOrderTpl: ['$stateParams', 'EnvOrderTpl', function($stateParams, EnvOrderTpl) {
                        return EnvOrderTpl.get({id : $stateParams.id}).$promise;
                    }]
                }
            })
            .state('env-order-tpl.delete', {
                parent: 'env-order-tpl',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/env-order-tpl/env-order-tpl-delete-dialog.html',
                        controller: 'EnvOrderTplDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['EnvOrderTpl', function(EnvOrderTpl) {
                                return EnvOrderTpl.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('env-order-tpl', null, { reload: 'env-order-tpl' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('EnvOrderTpl', EnvOrderTpl);

    EnvOrderTpl.$inject = ['$resource', 'DateUtils'];

    function EnvOrderTpl($resource, DateUtils) {
        var resourceUrl = 'api/env-orders-tpl/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET', isArray: true, transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        for (var i = 0; i < data.length; i++){
                            data[i].envOrderJson = angular.fromJson(data[i].envOrderJson);
                        }
                    }

                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.envOrderJson = angular.fromJson(data.envOrderJson);
                    }

                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.envOrderJson = angular.toJson(copy.envOrderJson);

                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.envOrderJson = angular.toJson(copy.envOrderJson);

                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('EnvOrderTplSearch', EnvOrderTplSearch);

    EnvOrderTplSearch.$inject = ['$resource'];

    function EnvOrderTplSearch($resource) {
        var resourceUrl =  'api/_search/env-orders-tpl/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvOrderTemplateController', EnvOrderTemplateController);

    EnvOrderTemplateController.$inject = ['$state', 'ROLES', '$scope', '$compile', '$q', 'Principal', 'CoreService', 'EnvOrderTplSearch',
        'DTColumnBuilder', 'DTOptionsBuilder', 'EnvOrderTpl', 'GUIUtils', '$uibModal', '$filter', 'Compendium', 'dialogs'];

    function EnvOrderTemplateController($state, ROLES, $scope, $compile, $q, Principal, CoreService, EnvOrderTplSearch,
                                            DTColumnBuilder, DTOptionsBuilder, EnvOrderTpl, GUIUtils, $uibModal, $filter, Compendium, $dialogs) {

        var vm = this;

        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.machines = [];

        vm.selectMachines = selectMachines;
        vm.selectInterval = selectInterval;
        vm.cloneTemplate = cloneTemplate;
        vm.checkTpl = checkTpl;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                if (!Principal.hasRole(ROLES.ROLE_ADMIN)) {
                    EnvOrderTplSearch.query({
                        query: {
                            bool: {
                                must: [
                                    {term: {"delStatus": false}},
                                    {not: {exists: {"field": "corporation"}}}
                                ]
                            }
                        }
                    }, function (result) {
                        vm.orders = result;

                        EnvOrderTplSearch.query({
                            query: {
                                bool: {
                                    must: [
                                        {term: {"delStatus": false}},
                                        {match: {"corporation.id": CoreService.getCurrentEmployee().corporation.id}}
                                    ]
                                }
                            }
                        }, function (result) {
                            vm.orders = result.concat(vm.orders);
                            defer.resolve(vm.orders);
                        });
                    });
                } else {
                    EnvOrderTplSearch.query({
                        query: {
                            bool: {
                                must: [
                                    {term: {"delStatus": false}},
                                    {not: {exists: {"field": "corporation"}}}
                                ]
                            }
                        }
                    }, function (result) {
                        vm.orders = result;
                        defer.resolve(result);
                    });
                }
            } else {
                defer.resolve($filter('filter')(vm.orders, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withBootstrap().withDOM('tip').withOption('aaSorting', [[1, 'asc']]).withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('description').withTitle('Description'),
            DTColumnBuilder.newColumn(null).withTitle('Corporation').renderWith(function (data, type, full) {
                return data.corporation ? data.corporation.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Created Date').renderWith(function (data, type, full) {
                return moment(data.createdDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '200px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = "";
            stButtons += '<a class="btn-sm btn-primary" ng-click="vm.checkTpl(' + data.id + ', 0)"> <i class="fa fa-clone"></i></a>&nbsp;';
            stButtons += Principal.hasRole(ROLES.ROLE_ADMIN) ? '' :
                '<a class="btn-sm btn-primary" ng-click="vm.checkTpl(' + data.id + ', 1)"> <i class="glyphicon glyphicon-paste"></i></a>&nbsp;';

            // return stButtons + GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);

            if (data.corporation || (!data.corporation && Principal.hasRole(ROLES.ROLE_ADMIN))) {
                return stButtons + GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
            } else {
                return stButtons;
            }
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function selectMachines(id) {
            $uibModal.open({
                templateUrl: 'app/entities/machine/machine-select-dialog.html',
                controller: 'MachineSelectDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    clinic: CoreService.getCurrentClinic(),
                    machines: {selected: vm.machines}
                }
            }).result.then(function (result) {
                vm.machines = result.machines;
                vm.selectInterval(id);
            }, function () {
            });
        }

        function selectInterval (id) {
            $uibModal.open({
                templateUrl: 'app/entities/window-picker/env-test-interval-dialog.html',
                controller: 'EnvTestIntervalDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    envOrderTpl: ['EnvOrderTpl', function (EnvOrderTpl) {
                        return EnvOrderTpl.get({id: id}).$promise;
                    }],
                    clinic: CoreService.getCurrentClinic()
                }
            }).result.then(function (result) {
                $state.go("env-order-new-all", {orderTpl: result.tpl, machines: vm.machines, allMachines: vm.machinesOrigin}, {reload: true});
            }, function () {
            });
        }

        function cloneTemplate(id) {
            $state.go("env-order-tpl.edit", {id: id, clone: true}, {reload: true});
        }

        function checkTpl(id, action) {
            EnvOrderTpl.get({id: id}, function (tpl) {
                var compendiums = _.map(tpl.envOrderJson.envTests, 'compendium');

                Compendium.check({compendiums: compendiums}, function (result) {
                    if (result.compendiums.length > 0) {
                        var msg = _.map(result.compendiums, function (compendium) {
                            return "Test: " + compendium.code + (compendium.description ? ' - ' + compendium.description : '');
                        }).join('<br>');

                        $dialogs.error("Warning.", "This template need review some tests don't exist and need to be removed or changed from the template <br>" + msg);
                    } else {
                        switch (action) {
                            case 0: {
                                cloneTemplate(id);
                                break;
                            }
                            case 1: {
                                selectMachines(id);
                                break;
                            }
                        }
                    }
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvOrderTestTplNewDialogController', EnvOrderTestTplNewDialogController);

    EnvOrderTestTplNewDialogController.$inject = ['CompendiumSearch', 'DiagnosisSearch', 'OrderFrequency', 'envOrder',
        'envOrderTest', '$uibModalInstance'];

    function EnvOrderTestTplNewDialogController(CompendiumSearch, DiagnosisSearch, OrderFrequency, envOrder,
                                                envOrderTest, $uibModalInstance) {
        var vm = this;

        vm.envOrder = envOrder;
        vm.envTest = envOrderTest;

        vm.form = {};

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.orderfrequencies = OrderFrequency.query().$promise.then(function (data) {
            vm.orderfrequencies = data;
        });

        vm.compendiums = [];

        vm.getCompendium = getCompendium;

        function getCompendium(query) {
            if (query && query.length > 2) {
                CompendiumSearch.query({query: query}, function (result) {
                    vm.compendiums = result;
                });
            }
        }

        vm.accept = function () {
            $uibModalInstance.close({envTest: vm.envTest});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvOrderNewController', EnvOrderNewController);

    EnvOrderNewController.$inject = ['$scope', '$compile', '$state', 'machine', '$q', 'DTColumnBuilder' ,
        'DTOptionsBuilder', 'order', 'EnvOrder', '$uibModal'];

    function EnvOrderNewController($scope, $compile, $state, machine, $q, DTColumnBuilder,
                                   DTOptionsBuilder, order, EnvOrder, $uibModal) {
        var vm = this;

        vm.machine = machine;
        vm.order = order;
        vm.order.ordStatus = 'SCHEDULED';
        vm.order.machine = machine;

        vm.form = {};

        vm.save = save;

        vm.orderfrequencies = [];

        function save() {
            vm.isSaving = true;
            EnvOrder.save(vm.order, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            $state.go("env-order", {id: vm.machine.id});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.addEnvTest = function () {
            var test = {
                staringDate: null,
                id: null,
                schedules: []
            };

            vm.popupTest(test, -1);
        };

        vm.editPatientOrderTest = function (index) {
            vm.popupTest(vm.order.envTests[index], index);
        };

        vm.deletePatientOrderTest = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order-test/patient-order-test-delete-dialog.html',
                controller: 'PatientOrderTestDeleteNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: {id: index}
                }
            }).result.then(function(result) {
                vm.order.envTests.splice(index, 1);

                vm.dtInstance.reloadData();
            }, function() {
            });
        }

        vm.popupTest = function(envTest, index) {
            $uibModal.open({
                templateUrl: 'app/entities/env-test/env-test-new-dialog.html',
                controller: 'EnvTestNewDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    order: vm.order,
                    envTest: envTest
                }
            }).result.then(function(result) {
                if (index < 0) {
                    vm.order.envTests.push(result.envTest);
                } else {
                    vm.order.envTests[index] = result.envTest;
                }

                vm.dtInstance.reloadData();
            }, function() {
            });
        }

        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            defer.resolve(vm.order.envTests);

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('paging', false).withOption('aaSorting', []).withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Test Code').renderWith(function (data, type, full) {
                return data.compendium.code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.compendium.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.staringDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ng-click="vm.editPatientOrderTest(' + meta.row + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';
            stButtons += '<a class="btn-sm btn-danger" ng-click="vm.deletePatientOrderTest(' + meta.row + ')">' +
                '   <i class="fa fa-trash"></i></a>';

            return stButtons;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvOrderDialogController', EnvOrderDialogController);

    EnvOrderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EnvOrder', 'EnvTest', 'Machine'];

    function EnvOrderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EnvOrder, EnvTest, Machine) {
        var vm = this;

        vm.envOrder = entity;
        vm.clear = clear;
        vm.save = save;
        vm.envtests = EnvTest.query();
        vm.machines = Machine.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.envOrder.id !== null) {
                EnvOrder.update(vm.envOrder, onSaveSuccess, onSaveError);
            } else {
                EnvOrder.save(vm.envOrder, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:envOrderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvOrderDetailController', EnvOrderDetailController);

    EnvOrderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'order', 'EnvOrder', 'EnvTest', 'machine'];

    function EnvOrderDetailController($scope, $rootScope, $stateParams, previousState, order, EnvOrder, EnvTest, machine) {
        var vm = this;

        vm.order = order;
        vm.machine = machine;
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvOrderDeleteController',EnvOrderDeleteController);

    EnvOrderDeleteController.$inject = ['$uibModalInstance', 'entity', 'EnvOrder'];

    function EnvOrderDeleteController($uibModalInstance, entity, EnvOrder) {
        var vm = this;

        vm.envOrder = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EnvOrder.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvOrderNewAllController', EnvOrderNewAllController);

    EnvOrderNewAllController.$inject = ['$scope', '$compile', '$state', 'machines', 'allMachines', '$q', 'DTColumnBuilder' ,
        'DTOptionsBuilder', 'order', 'EnvOrder', '$uibModal', '$stateParams'];

    function EnvOrderNewAllController($scope, $compile, $state, machines, allMachines, $q, DTColumnBuilder,
                                   DTOptionsBuilder, order, EnvOrder, $uibModal, stateParams) {
        var vm = this;

        vm.machines = machines ? machines : allMachines;
        vm.allMachines = allMachines;

        vm.order = order;
        vm.order.ordStatus = 'SCHEDULED';

        if (vm.machines) {
            vm.order.machine = vm.machines[0];
        } else {
            $state.go("machine");
        }

        vm.form = {};

        vm.save = save;

        vm.orderfrequencies = [];

        if (vm.order.envTests.length > 0) {
            vm.order.machine = vm.machines[0];
            EnvOrder.schedule(vm.order, function (data) {
                vm.order = data;
            }, function () {
            });
        }

        function save() {
            vm.isSaving = true;

            if (vm.machines.length > 0) {
                var req = {
                    envOrder: vm.order,
                    ids: [],
                    orderTplId: stateParams.orderTpl ? stateParams.orderTpl.id : null
                };

                for (var j = 0; j < vm.machines.length; j++) {
                    req.ids.push(vm.machines[j].id);
                }

                EnvOrder.save_many(req, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            $state.go("machine", null, {reload: true});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.addEnvTest = function () {
            var test = {
                staringDate: null,
                id: null,
                schedules: []
            };

            vm.popupTest(test, -1);
        };

        vm.editPatientOrderTest = function (index) {
            vm.popupTest(vm.order.envTests[index], index);
        };

        vm.deletePatientOrderTest = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order-test/patient-order-test-delete-dialog.html',
                controller: 'PatientOrderTestDeleteNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: {id: index}
                }
            }).result.then(function(result) {
                vm.order.envTests.splice(index, 1);

                vm.dtInstance.reloadData();
            }, function() {
            });
        }

        vm.popupTest = function(envTest, index) {
            $uibModal.open({
                templateUrl: 'app/entities/env-test/env-test-new-dialog.html',
                controller: 'EnvTestNewDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    order: vm.order,
                    envTest: envTest
                }
            }).result.then(function(result) {
                if (index < 0) {
                    vm.order.envTests.push(result.envTest);
                } else {
                    vm.order.envTests[index] = result.envTest;
                }

                vm.dtInstance.reloadData();
            }, function() {
            });
        }

        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            defer.resolve(vm.order.envTests);

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('paging', false).withOption('aaSorting', []).withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Test Code').renderWith(function (data, type, full) {
                return data.compendium.code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.compendium.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.staringDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ng-click="vm.editPatientOrderTest(' + meta.row + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';
            stButtons += '<a class="btn-sm btn-danger" ng-click="vm.deletePatientOrderTest(' + meta.row + ')">' +
                '   <i class="fa fa-trash"></i></a>';

            return stButtons;
        }

        vm.select = function() {
            $uibModal.open({
                templateUrl: 'app/entities/machine/machine-select-dialog.html',
                controller: 'MachineSelectDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    clinic: vm.order.machine.clinic,
                    machines: {machines: vm.machines}
                }
            }).result.then(function (result) {
                vm.machines = result.machines;
            }, function () {
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('env-order', {
                parent: 'machine-detail',
                url: '/orders',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_ENVIRONMENTAL', 'ROLE_DOCTOR'],
                    pageTitle: 'Site Orders'
                },
                ncyBreadcrumb: {
                    label: 'Site Orders',
                    parent: 'machine-detail'
                },
                views: {
                    'content@machine-detail': {
                        templateUrl: 'app/entities/env-order/env-orders.html',
                        controller: 'EnvOrderController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('env-order-detail', {
                parent: 'env-order',
                url: '/{oid}/details',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_ENVIRONMENTAL', 'ROLE_DOCTOR'],
                    pageTitle: 'EnvOrder'
                },
                ncyBreadcrumb: {
                    label: 'Order Details'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/env-order/env-order-detail.html',
                        controller: 'EnvOrderDetailController',
                        controllerAs: 'vm'
                    },
                    'order-tests@env-order-detail': {
                        templateUrl: 'app/entities/env-test/env-tests.html',
                        controller: 'EnvTestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    order: ['$stateParams', 'EnvOrder', function ($stateParams, EnvOrder) {
                        return EnvOrder.get({id: $stateParams.oid}).$promise;
                    }]
                }
            })
            .state('env-order-new', {
                parent: 'env-order',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_ENVIRONMENTAL', 'ROLE_DOCTOR'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/env-order/env-order-new.html',
                        controller: 'EnvOrderNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    order: ['$stateParams', function ($stateParams) {
                        return {
                            id: null,
                            envTests: [],
                            ordStatus: 'SCHEDULED'
                        };
                    }]
                }
            })
            .state('env-order-new-all', {
                parent: 'machine',
                url: '/new-orders',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_ENVIRONMENTAL', 'ROLE_DOCTOR'],
                },
                ncyBreadcrumb: {
                    label: 'Site Orders For Selected Machines',
                    parent: 'machine'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/env-order/env-order-all-new.html',
                        controller: 'EnvOrderNewAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    machines: null,
                    allMachines: null,
                    orderTpl: null
                },
                resolve: {
                    order: ['$stateParams', function ($stateParams) {
                        var tpl = $stateParams.orderTpl;

                        if (tpl) {
                            return tpl.envOrderJson;
                        }

                        return {
                            id: null,
                            envTests: [],
                            ordStatus: 'SCHEDULED'
                        };
                    }],
                    machines: ['$stateParams', function ($stateParams) {
                        return $stateParams.machines;
                    }],
                    allMachines: ['$stateParams', function ($stateParams) {
                        return $stateParams.allMachines;
                    }]
                }
            })
            .state('env-order-schedule.detail', {
                parent: 'patient-order-schedule',
                url: '/{oid}',
                ncyBreadcrumb: {
                    label: 'Schedule Detail',
                    parent: 'patient-order-schedule'
                },
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_ENVIRONMENTAL', 'ROLE_DOCTOR'],
                    pageTitle: 'Schedule'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-order/schedule/patient-order-schedule-detail.html',
                        controller: 'PatientOrderScheduleDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    patientOrder: ['$stateParams', 'PatientOrder', function ($stateParams, PatientOrder) {
                        return PatientOrder.get({id: $stateParams.oid}).$promise;
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('EnvOrder', EnvOrder);

    EnvOrder.$inject = ['$resource', 'DateUtils', 'DataUtils'];

    function EnvOrder ($resource, DateUtils, DataUtils) {
        var resourceUrl =  'api/env-orders/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }

                    return data;
                }
            },
            'update': { method:'PUT' },
            'schedule': {
                url: 'api/env-orders-schedule',  method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.envTests) {
                        for (var i = 0; i < data.envTests.length; i++) {
                            copy.envTests[i].staringDate =  DateUtils.convertLocalDateToServer(copy.envTests[i].staringDate);
                            if (copy.envTests[i].endDate) {
                                copy.envTests[i].endDate =  DateUtils.convertLocalDateToServer(copy.envTests[i].endDate);
                            }
                        }
                    }

                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.signatureDate = DateUtils.convertLocalDateFromServer(data.signatureDate);
                    data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);

                    for (var i = 0; i < data.envTests.length; i++) {
                        data.envTests[i].staringDate =  DateUtils.convertLocalDateFromServer(data.envTests[i].staringDate);
                        if (data.envTests[i].endDate) {
                            data.envTests[i].endDate =  DateUtils.convertLocalDateFromServer(data.envTests[i].endDate);
                        }

                        for (var j = 0; j < data.envTests[i].schedules.length; j++) {
                            data.envTests[i].schedules[j].scheduleDate =
                                DateUtils.convertLocalDateFromServer(data.envTests[i].schedules[j].scheduleDate);
                        }
                    }

                    return data;
                }
            },
            'collect': {
                url: 'api/env-order/collect', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);

                    return angular.toJson(copy);
                }
            },
            'collect2': {
                url: 'api/env-order/collect2', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);

                    return angular.toJson(copy);
                }
            },
            'not_collected' : {url : "api/count-env-orders-not-collected-by-date/:id/:date", method: 'GET',
                transformResponse: function (data) {
                    return {value: data};
                }},
            'byMachine': {url : "api/env-orders/machine/:id", method: 'GET', isArray: true},
            'save_many': {
                url: "api/env-orders/save-many", method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.envOrder.signatureDate = DateUtils.convertLocalDateToServer(copy.envOrder.signatureDate);
                    copy.envOrder.endDate = DateUtils.convertLocalDateToServer(copy.envOrder.endDate);

                    return angular.toJson(copy);
                }
            },
            'changeDrawDay': {url: 'api/env-orders/change-draw-day', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);
                    copy.newDate = DateUtils.convertLocalDateToServer(data.newDate);

                    return angular.toJson(copy);
                }
            },
            'getBarcodeLabels': {url: 'api/env-orders/get-barcode-labels', method: 'POST', isArray: true},
            'get_barcode': {url: 'api/env-orders/get-barcode/:id/:date', method: 'GET'},
            'dashboardSchedule': {
                url: 'api/env-orders/dashboard-schedule', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);

                    return angular.toJson(copy);
                }
            },
            'getSchedule': {
                url: 'api/env-orders/schedule-list', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);

                    return angular.toJson(copy);
                }
            },
            'markDates': {url: "api/env-orders/mark-dates", method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);

                    if (copy.date) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }

                    return angular.toJson(copy);

                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        for (var i = 0; i < data.length; i++) {
                            data[i] = {date: data[i].date, class: data[i].sent ? 'markSentClass' : 'markNotSentClass'};
                        }
                    }

                    return data;
                }
            },
            'getManifestPdf': {
                url: 'api/env-orders/manifest_pdf',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            },
            'getBarcodeLabelsPdf': {
                url: 'api/env-orders/barcode_labels_pdf',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            },
            'getBarcodeLabelsPdf2': {
                url: 'api/env-orders/barcode_labels_pdf2',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadAndOpenPDFFile(data, headers);
                }
            },
            'cancelRequisition': { url: 'api/env-orders/cancel_requisition', method: 'POST', isArray: true},
            'changeDrawDayV2': {url: 'api/env-orders/change-draw-day-v2', method: 'POST', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('EnvOrderSearch', EnvOrderSearch);

    EnvOrderSearch.$inject = ['$resource'];

    function EnvOrderSearch($resource) {
        var resourceUrl =  'api/_search/env-orders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvOrderController', EnvOrderController);

    EnvOrderController.$inject = ['$compile', 'moment', 'machine', '$scope', '$state', 'EnvOrder', 'EnvOrderSearch', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function EnvOrderController($compile, moment, machine, $scope, $state, EnvOrder, EnvOrderSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter) {
        var vm = this;

        vm.machine = machine;
        vm.envOrders = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                EnvOrder.byMachine({id: vm.machine.id}, function (result) {
                    vm.envOrders = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.envOrders, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withBootstrap().withDOM('tip').withOption('aaSorting', []).withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('Order Number'),
            DTColumnBuilder.newColumn('startDate').withTitle('Start Date').renderWith(function (data, type, full) {
                return data ? moment(data).format("MM/DD/YYYY") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return data.endDate ? moment(data.endDate).format("MM/DD/YYYY") : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-warning" ui-sref="env-order-detail({oid:' + data.id + '})">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app',
            ncyBreadcrumb: {
                label: 'Entity',
                parent: 'app'
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('EmployeeType', EmployeeType);

    EmployeeType.$inject = ['$resource'];

    function EmployeeType ($resource) {
        var resourceUrl =  'api/employee-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EmployeeDialogController', EmployeeDialogController);

    EmployeeDialogController.$inject = ['$timeout', '$scope', 'Clinic', '$uibModalInstance',
        'entity', 'Employee', 'ROLES', 'Utils', 'CoreService',
        'EmployeeType', 'Principal', 'Corporation'];

    function EmployeeDialogController($timeout, $scope, Clinic, $uibModalInstance,
                                      entity, Employee, ROLES, Utils, CoreService,
                                      EmployeeType, Principal, Corporation) {

        var vm = this;

        vm.employee = entity;
        vm.clear = clear;
        vm.save = save;
        vm.clinics = [];
        vm.corporations = [];
        vm.changeCorporation = changeCorporation;

        Principal.hasAuthority(ROLES.ROLE_ADMIN).then(function(data){
            if (data == true) {
                vm.corporations = Corporation.query();
            } else {
                vm.corporations = [CoreService.getCurrentEmployee().corporation];
            }
        },function(btn){
        });

        if (vm.employee.corporation && vm.employee.corporation.id) {
            Clinic.byCorp({id: vm.employee.corporation.id}, function (results) {
                vm.clinics = results;
            });
        }

        function changeCorporation() {
            if (!vm.employee.corporation || !vm.employee.corporation.id) {
                vm.clinics = [];
                vm.employee.clinics = [];

                return;
            }

            Clinic.byCorp({id: vm.employee.corporation.id}, function (results) {
                vm.employee.clinics = [];
                vm.clinics = results;
            });
        };

        vm.employeeTypes = EmployeeType.query();
        vm.authorities = Utils.objectToArray(ROLES);
        vm.authorities.splice(vm.authorities.indexOf(ROLES.ROLE_ADMIN), 1);

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            vm.employee.user.firstName = vm.employee.name;
            vm.employee.user.lastName = vm.employee.lastName;
            var employee = {};
            angular.copy(vm.employee, employee);
            employee.user.authorities = [];
            for (var i = 0; i < vm.employee.user.authorities.length; i++) {
                var authority = {
                    name: vm.employee.user.authorities[i]
                }
                employee.user.authorities.push(authority);
            }
            if (vm.employee.id !== null) {
                Employee.update(employee, onSaveSuccess, onSaveError);
            } else {
                Employee.save(employee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('dialysisApp:employeeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EmployeeDetailController', EmployeeDetailController);

    EmployeeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Employee', 'User', 'Corporation'];

    function EmployeeDetailController($scope, $rootScope, $stateParams, previousState, entity, Employee, User, Corporation) {
        var vm = this;

        vm.employee = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:employeeUpdate', function(event, result) {
            vm.employee = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EmployeeDeleteController',EmployeeDeleteController);

    EmployeeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Employee'];

    function EmployeeDeleteController($uibModalInstance, entity, Employee) {
        var vm = this;

        vm.employee = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Employee.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('employee', {
            parent: 'entity',
            url: '/employee',
            ncyBreadcrumb: {
                label: 'Employees',
                parent: 'app'
            },
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
                pageTitle: 'Employees'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee/employees.html',
                    controller: 'EmployeeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('employee-detail', {
            parent: 'entity',
            url: '/employee/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
                pageTitle: 'Employee'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee/employee-detail.html',
                    controller: 'EmployeeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Employee', function($stateParams, Employee) {
                    return Employee.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'employee',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('employee-detail.edit', {
            parent: 'employee-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee/employee-dialog.html',
                    controller: 'EmployeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Employee', function(Employee) {
                            return Employee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('employee.new', {
            parent: 'employee',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee/employee-dialog.html',
                    controller: 'EmployeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                name: null,
                                lastName: null,
                                title: null,
                                gender: null,
                                id: null,
                                clinics: [],
                                corporation: CoreService.getCurrentEmployee().corporation
                            }
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee', null, { reload: 'employee' });
                }, function() {
                    $state.go('employee', null, { reload: 'employee' });
                });
            }]
        })
        .state('employee.edit', {
            parent: 'employee',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee/employee-dialog.html',
                    controller: 'EmployeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Employee', function(Employee) {
                            return Employee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee', null, { reload: 'employee' });
                }, function() {
                    $state.go('employee', null, { reload: 'employee' });
                });
            }]
        })
        .state('employee.delete', {
            parent: 'employee',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee/employee-delete-dialog.html',
                    controller: 'EmployeeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Employee', function(Employee) {
                            return Employee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee', null, { reload: 'employee' });
                }, function() {
                    $state.go('employee', null, { reload: 'employee' });
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Employee', Employee);

    Employee.$inject = ['$resource', 'Utils'];

    function Employee($resource, Utils) {
        var resourceUrl = 'api/employees/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            data[i].user.authorities = Utils.objectRoleToArray(data[i].user.authorities);
                        }
                    }
                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.user.authorities = Utils.objectRoleToArray(data.user.authorities);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'employeeAccount': {url: 'api/employeeAccount', method: 'GET'},
            'employeeCorporations': {
                url: 'api/employeeCorporations', method: 'GET', isArray: true
            },
            'employeeCorpPhysicians': {url: 'api/employeeCorpPhysicians', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('EmployeeSearch', EmployeeSearch);

    EmployeeSearch.$inject = ['$resource'];

    function EmployeeSearch($resource) {
        var resourceUrl =  'api/_search/employees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EmployeeController', EmployeeController);

    EmployeeController.$inject = ['$compile', '$scope', '$state', 'Employee', 'EmployeeSearch', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function EmployeeController($compile, $scope, $state, Employee, EmployeeSearch, $q, DTColumnBuilder,
                                DTOptionsBuilder, GUIUtils, $filter) {
        var vm = this;

        vm.employees = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                Employee.query(function (result) {
                    vm.employees = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.employees, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('scrollX', '100%')
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('title').withTitle('Title').withOption('width', '20px'),
            DTColumnBuilder.newColumn(null).withTitle('Full Name').renderWith(function (data, type, full) {
                return data.name + ' ' + data.lastName;
            }),
            DTColumnBuilder.newColumn('gender').withTitle('Gender').withOption('width', '20px'),
            DTColumnBuilder.newColumn(null).withTitle('Email').renderWith(function (data, type, full) {
                return GUIUtils.mailto(data.user.email, []);
            }),
            DTColumnBuilder.newColumn('employeeType.name').withTitle('Type'),
            DTColumnBuilder.newColumn(null).withTitle('Corporation').renderWith(function (data, type, full) {
                return data.corporation ? data.corporation.name : '';
            }),
            DTColumnBuilder.newColumn('user.login').withTitle('User'),
            DTColumnBuilder.newColumn(null).withTitle('Roles').renderWith(function (data, type, full) {
                var template = '';
                for (var i = 0; i < data.user.authorities.length; i++) {
                    template += GUIUtils.getStatusTemplate(data.user.authorities[i], 'primary') + '&nbsp';
                }
                return template;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Active').renderWith(function (data, type, full) {
                if (data.user.activated) {
                    return GUIUtils.getStatusTemplate("Yes", 'success');
                } else {
                    return GUIUtils.getStatusTemplate("No", 'danger');
                }
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '100px').notSortable()
                .renderWith(actionsHtml)
        ];

        function loadAll() {
            Employee.query(function (result) {
                vm.employees = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DialyserTypeDialogController', DialyserTypeDialogController);

    DialyserTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DialyserType', 'Infection', 'Corporation'];

    function DialyserTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DialyserType, Infection, Corporation) {
        var vm = this;

        vm.dialyserType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dialyserType.id !== null) {
                DialyserType.update(vm.dialyserType, onSaveSuccess, onSaveError);
            } else {
                DialyserType.save(vm.dialyserType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:dialyserTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DialyserTypeDetailController', DialyserTypeDetailController);

    DialyserTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DialyserType', 'Infection', 'Corporation'];

    function DialyserTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, DialyserType, Infection, Corporation) {
        var vm = this;

        vm.dialyserType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:dialyserTypeUpdate', function(event, result) {
            vm.dialyserType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DialyserTypeDeleteController',DialyserTypeDeleteController);

    DialyserTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'DialyserType'];

    function DialyserTypeDeleteController($uibModalInstance, entity, DialyserType) {
        var vm = this;

        vm.dialyserType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DialyserType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dialyser-type', {
            parent: 'entity',
            url: '/dialyser-type',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Types of Dialyser'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dialyser-type/dialyser-types.html',
                    controller: 'DialyserTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('dialyser-type-detail', {
            parent: 'entity',
            url: '/dialyser-type/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'DialyserType'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dialyser-type/dialyser-type-detail.html',
                    controller: 'DialyserTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'DialyserType', function($stateParams, DialyserType) {
                    return DialyserType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dialyser-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dialyser-type-detail.edit', {
            parent: 'dialyser-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dialyser-type/dialyser-type-dialog.html',
                    controller: 'DialyserTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DialyserType', function(DialyserType) {
                            return DialyserType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dialyser-type.new', {
            parent: 'dialyser-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dialyser-type/dialyser-type-dialog.html',
                    controller: 'DialyserTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dialyser-type', null, { reload: 'dialyser-type' });
                }, function() {
                    $state.go('dialyser-type');
                });
            }]
        })
        .state('dialyser-type.edit', {
            parent: 'dialyser-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dialyser-type/dialyser-type-dialog.html',
                    controller: 'DialyserTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DialyserType', function(DialyserType) {
                            return DialyserType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dialyser-type', null, { reload: 'dialyser-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dialyser-type.delete', {
            parent: 'dialyser-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dialyser-type/dialyser-type-delete-dialog.html',
                    controller: 'DialyserTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DialyserType', function(DialyserType) {
                            return DialyserType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dialyser-type', null, { reload: 'dialyser-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('DialyserType', DialyserType);

    DialyserType.$inject = ['$resource'];

    function DialyserType ($resource) {
        var resourceUrl =  'api/dialyser-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('DialyserTypeSearch', DialyserTypeSearch);

    DialyserTypeSearch.$inject = ['$resource'];

    function DialyserTypeSearch($resource) {
        var resourceUrl =  'api/_search/dialyser-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DialyserTypeController', DialyserTypeController);

    DialyserTypeController.$inject = ['$scope', '$state', 'DialyserType', 'DialyserTypeSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function DialyserTypeController ($scope, $state, DialyserType, DialyserTypeSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;

        vm.dialyserTypes = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  DialyserType.query(function(result) {
                  vm.dialyserTypes = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.dialyserTypes, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            DialyserType.query(function(result) {
                vm.dialyserTypes = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DiagnosisDialogController', DiagnosisDialogController);

    DiagnosisDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity'];

    function DiagnosisDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity) {
        var vm = this;

        vm.diagnoses = entity.diagnoses;
        vm.clear = clear;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Diagnosis', Diagnosis);

    Diagnosis.$inject = ['$resource'];

    function Diagnosis ($resource) {
        var resourceUrl =  'api/diagnoses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byPatientOrderTest': {url: 'api/diagnoses/by-patient-order-test/:id', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('DiagnosisSearch', DiagnosisSearch);

    DiagnosisSearch.$inject = ['$resource'];

    function DiagnosisSearch($resource) {
        var resourceUrl =  'api/_search/diagnoses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DiagnosisDialogController2', DiagnosisDialogController2);

    DiagnosisDialogController2.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Diagnosis','DTOptionsBuilder', 'DTColumnBuilder', '$q','$compile'];

    function DiagnosisDialogController2 ($timeout, $scope, $stateParams, $uibModalInstance, entity, Diagnosis, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {
        var vm = this;

        vm.diagnoses = entity;
        vm.clear = clear;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
                Diagnosis.byPatientOrderTest({id: vm.diagnoses.orderTestId}, function (result) {
                    vm.Diagnosis = result;
                    defer.resolve(result);
                });


            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')
            .withOption('paging', false).withOption('aaSorting', []).withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('ICD 10').renderWith(function (data, type, full) {
                return data.icd10Code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Test').renderWith(function (data, type, full) {
                return data.description;
            }),

        ];


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('UnsignedOrdersBoxController', UnsignedOrdersBoxController);

    UnsignedOrdersBoxController.$inject = ['clinic', '$state', '$q', 'DTColumnBuilder', 'PatientOrder'];

    function UnsignedOrdersBoxController(clinic, $state, $q, DTColumnBuilder, PatientOrder) {
        var vm = this;

        vm.unsigned = 0;

        vm.unsigned = PatientOrder.countUnsigned({id: clinic.id});
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('UnassignedResultsTopBoxController', UnassignedResultsTopBoxController);

    UnassignedResultsTopBoxController.$inject = ['clinic', '$scope', '$state', '$q', 'DTColumnBuilder', 'PatientResult'];

    function UnassignedResultsTopBoxController(clinic, $scope, $state, $q, DTColumnBuilder, PatientResult) {
        var vm = this;
        vm.unassigned = 0;

        vm.unassigned = PatientResult.countUnassigned({account: clinic.account});
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PendingResultsTopBoxController', PendingResultsTopBoxController);

    PendingResultsTopBoxController.$inject = ['clinic', '$scope', '$state', '$q', 'DTColumnBuilder', 'PatientResult',
        'DTOptionsBuilder', '$filter', '$compile', 'GUIUtils', '$uibModal'];

    function PendingResultsTopBoxController(clinic, $scope, $state, $q, DTColumnBuilder, PatientResult,
                              DTOptionsBuilder, $filter, $compile, GUIUtils, $uibModal) {
        var vm = this;
        vm.pending = 0;

        vm.pending = PatientResult.countPending({id: clinic.id});
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientResultAbnormalController', PatientResultAbnormalController);

    PatientResultAbnormalController.$inject = ['clinic', 'PatientResult', 'lodash', 'moment', '$scope'];

    function PatientResultAbnormalController(clinic, PatientResult, _, moment, $scope) {
        var vm = this;

        vm.abnormalNotReviewed = 0;
        vm.labels = [];
        vm.data = [
            []
        ];
        vm.totalCount = 0;

        vm.abnormalNotReviewed = PatientResult.countAbnormalNotReviewed({id: clinic.id});

        vm.getResults = getResults;

        getResults();

        function getResults() {
            PatientResult.countAbnormalNotReviewedLast7Days({
                id: clinic.id
            }, function (results) {
                _.forEach(results, function (result) {
                    vm.labels.push(moment(result[1]).format($scope.displayDateformat));
                    vm.data[0].push(result[0]);
                    vm.totalCount += result[0];
                });
            });
        }

        vm.series = ['Abnormal Results'];
        vm.colors = ['#45b7cd', '#ff6384', '#ff8e72'];
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MissingPDAdequacyBoxController', MissingPDAdequacyBoxController);

    MissingPDAdequacyBoxController.$inject = ['PdAdequacy', 'clinic'];

    function MissingPDAdequacyBoxController(PdAdequacy, clinic) {
        var vm = this;

        vm.countMissingPDAdequacy = 0;

        PdAdequacy.countMissing({id: clinic.id}, function (result) {
            vm.countMissingPDAdequacy = result.value;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MissingKineticsTopBoxController', MissingKineticsTopBoxController);

    MissingKineticsTopBoxController.$inject = ['Kinetic', 'clinic'];

    function MissingKineticsTopBoxController(Kinetic, clinic) {
        var vm = this;

        vm.countMissingKinetics = 0;

        Kinetic.countMissing({id: clinic.id}, function (result) {
            vm.countMissingKinetics = result.value;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LabNotificationsAreaController', LabNotificationsAreaController);

    LabNotificationsAreaController.$inject = ['clinic', 'LabNotification', 'CoreService', 'showNotifications'];

    function LabNotificationsAreaController(clinic, LabNotification, CoreService, showNotifications) {
        var vm = this;
        vm.notifications = [];
        vm.showNotifications = showNotifications;

        vm.dismiss = dismiss;

        LabNotification.findAllActiveByClinic({id: clinic.id}, function (result) {
            vm.notifications = result;

            if (vm.showNotifications == undefined) {
                CoreService.setStorage('showNotifications', true);
            }
        });

        function dismiss(index) {
            vm.notifications.splice(index, 1);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EnvResultAbnormalController', EnvResultAbnormalController);

    EnvResultAbnormalController.$inject = ['EnvResult', 'lodash', 'moment', '$scope', 'clinic'];

    function EnvResultAbnormalController(EnvResult, _, moment, $scope, clinic) {
        var vm = this;

        vm.abnormalNotReviewed = 0;
        vm.labels = [];
        vm.data = [
            []
        ];
        vm.totalCount = 0;

        vm.getResults = getResults;

        vm.abnormalNotReviewed = EnvResult.countAbnormalNotReviewed({id: clinic.id});

        getResults();

        function getResults() {
            EnvResult.countAbnormalNotReviewedLast7Days({
                id: clinic.id
            }, function (results) {
                _.forEach(results, function (result) {
                    vm.labels.push(moment(result[1]).format($scope.displayDateformat));
                    vm.data[0].push(result[0]);
                    vm.totalCount += result[0];
                });
            });
        }

        vm.series = ['Abnormal Results'];
        vm.colors = ['#45b7cd', '#ff6384', '#ff8e72'];
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CriticalResultsTopBoxController', CriticalResultsTopBoxController);

    CriticalResultsTopBoxController.$inject = ['clinic', '$scope', '$state', '$q', 'DTColumnBuilder', 'PatientResult', '$uibModal','openModalCritical','CoreService'];

    function CriticalResultsTopBoxController(clinic, $scope, $state, $q, DTColumnBuilder, PatientResult, $uibModal, openModalCritical, CoreService) {
        var vm = this;
        vm.openModalCritical = openModalCritical;
        vm.criticals = 0;
        PatientResult.countCriticals({id: clinic.id}, function (result) {
            vm.criticals = result;

            if (result.value > 0 && vm.openModalCritical == undefined ) {
                modalCriticalResults(vm.criticals);
                CoreService.setStorage('openModalCritical', true);
            }
        });

        vm.modalCriticalResults = modalCriticalResults;

        function modalCriticalResults(criticals) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-result/dashboard/patient-result-critical-alert-dialog.html',
                controller: 'PatientResultCriticalAlertDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    criticals: criticals
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardPatientOrderSchedule2Controller', DashboardPatientOrderSchedule2Controller);

    DashboardPatientOrderSchedule2Controller.$inject = ['PopupService', 'CoreService', '$rootScope', 'OdsReportsService',
        '$uibModal', '$stateParams', 'dialogs', 'toastr',
        '$compile', '$q', '$scope', 'GUIUtils', 'PatientOrder', 'DTOptionsBuilder',
        'DTColumnBuilder', 'DateUtils', 'DataTablesService', 'clinic', 'date', 'lodash',
        '$filter', 'hasPrinter'];

    function DashboardPatientOrderSchedule2Controller(PopupService, CoreService, $rootScope, OdsReportsService,
                                                      $uibModal, $stateParams, $dialogs, toastr,
                                                      $compile, $q, $scope, GUIUtils, PatientOrder, DTOptionsBuilder,
                                                      DTColumnBuilder, DateUtils, DataTablesService, clinic, date, _,
                                                      $filter, hasPrinter) {
        var vm = this;

        vm.clinic = clinic;
        vm.dtInstance = {};
        vm.selectedDate = date;
        vm.selected = {};
        vm.selectAll = false;
        vm.hasPrinter = hasPrinter;

        vm.search = search;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';
        vm.statuses = {
            'MANIFESTED': {label: 'Manifested', template: 'success'},
            'PRINTED': {label: 'Printed', template: 'warning'},
            'SCHEDULED': {label: 'Scheduled', template: 'info'},
            'CANCELED': {label: 'Cancelled', template: 'danger'}
        };

        vm.showCalendar = showCalendar;
        vm.getManifestPdf = getManifestPdf;
        vm.getBarcodeLabelsPdf = getBarcodeLabelsPdf;
        vm.cancelRequisition = cancelRequisition;
        vm.showChangeDrawDayCalendar = showChangeDrawDayCalendar;

        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.setUniqueIds = DataTablesService.setUniqueIds;
        vm.modalPendingResults = modalPendingResults;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            vm.selected = {};
            vm.selectAll = false;

            if (!vm.searchQuery || vm.searchQuery == '') {
                if (vm.clinic) {
                    PatientOrder.getSchedule({
                        clinicId: vm.clinic.id,
                        date: vm.selectedDate,
                        shift: -1
                    }, function (result) {
                        vm.orders = vm.setUniqueIds(result);
                        defer.resolve(result);
                    });
                } else {
                    defer.resolve(vm.orders);
                }
            } else {
                defer.resolve($filter('filter')(vm.orders, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withOption('aaSorting', [[1, 'asc'], [3, 'asc']])
            .withDOM('tip')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;
                return '<input type="checkbox" ng-model="vm.selected[' + "'" + full.id + "'" + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Patient').renderWith(function (data, type, full) {
                return data.patientLastName + ', ' + data.patientFirstName + (data.patientMiddleName ? ' ' + data.patientMiddleName : "");
            }),
            DTColumnBuilder.newColumn(null).withTitle('DOB').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('SpecimenId').renderWith(function (data, type, full) {
                return data.barcode ? data.barcode : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(orderStatusHtml),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '55px').withOption('class', 'col-btn').notSortable().renderWith(actionsHtml)
        ];

        function orderStatusHtml(data, type, full) {
            var patientStatus = vm.statuses[data.status];
            return GUIUtils.getStatusTemplate(patientStatus.label, patientStatus.template);
        }

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a uib-tooltip="See Details" class="btn btn-default btn-sm details" ng-click="vm.modalPendingResults(' + data.id + ')">' +
                '   <i class="fa fa-external-link" aria-hidden="true"></i></>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function modalPendingResults(index) {
            PopupService.showPatientBarcodePopup(vm.orders[index].barcode, vm.orders[index]);
        }

        function showCalendar() {
            $uibModal.open({
                templateUrl: 'app/entities/dashboard/dashboard2/dashboard2-select-day.dialog.html',
                controller: 'DashboardSelectDateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    date: vm.selectedDate,
                    isPatient: {value: true},
                    clinic: vm.clinic
                }
            }).result.then(function (result) {
                vm.selectedDate = result.value;
                vm.searchQuery = '';
                vm.dtInstance.reloadData();
            });
        }

        function showChangeDrawDayCalendar() {
            $uibModal.open({
                templateUrl: 'app/entities/dashboard/dashboard2/dashboard2-select-day.dialog.html',
                controller: 'DashboardSelectDateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    date: vm.selectedDate,
                    isPatient: {value: true},
                    clinic: vm.clinic
                }
            }).result.then(function (result) {
                vm.searchQuery = '';
                changeDrawDay(result.value);
            });
        }

        function changeDrawDay(newDrawDay) {
            var newDrawDays = [];

            for (var id in vm.selected) {
                if (vm.selected[id] && _.includes(['SCHEDULED', 'PRINTED'], vm.orders[id].status)) {
                    newDrawDays.push(
                        {
                            patientId: vm.orders[id].patientId,
                            date: vm.orders[id].scheduleDate,
                            physicianId: vm.orders[id].physicianId,
                            status: vm.orders[id].status,
                            newDate: DateUtils.convertLocalDateToServer(newDrawDay)
                        }
                    );
                }
            }

            if (newDrawDays.length > 0) {
                var dlg = $dialogs.confirm('Please Confirm', 'Do you want to change the draw day for selected requisitions?', {size: 'md'});

                dlg.result.then(function (btn) {
                    PatientOrder.changeDrawDayV2({drawDays: newDrawDays}, function () {
                        vm.dtInstance.reloadData();
                    });
                });
            } else {
                toastr.error('There is not requisition selected');
            }
        }

        function getManifestPdf() {
            var barcodes = getSelectedBarcodes();

            if (barcodes.length > 0) {
                PatientOrder.validateManifest({drawDays: barcodes}, function (result) {
                    if (result.barcodes.length > 0) {
                        $dialogs.error("Error. Pending items for print", "This item can't be manifested, all items must be printed first. " + _.join(result.barcodes, ', '));
                    } else {
                        PatientOrder.getManifestPdf({clinicId: clinic.id, drawDays: barcodes}, function () {
                            vm.searchQuery = '';
                            vm.dtInstance.reloadData();
                        }, function () {
                            toastr.error('"Error manifesting orders"');
                        });
                    }
                });
            } else {
                toastr.error('There is not requisition selected or printed');
            }
        }

        function getSelectedBarcodes() {
            var patientBarcodes = [];

            for (var id in vm.selected) {
                if (vm.selected[id] && vm.orders[id].barcode != null && vm.orders[id].status != 'SCHEDULED') {
                    patientBarcodes.push(
                        {
                            date: DateUtils.convertLocalDateToServer(vm.selectedDate),
                            barcode: vm.orders[id].barcode,
                        }
                    );
                }
            }

            return patientBarcodes;
        }

        function getBarcodeLabelsPdf() {
            var patientBarcodes = [];

            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    patientBarcodes.push(
                        {
                            patientId: vm.orders[id].patientId,
                            date: DateUtils.convertLocalDateToServer(vm.selectedDate),
                            physicianId: vm.orders[id].physicianId,
                            barcode: vm.orders[id].barcode,
                            status: vm.orders[id].status
                        }
                    );
                }
            }

            if (patientBarcodes.length > 0) {
                vm.isSaving = true;

                PatientOrder.getBarcodeLabelsPdf({drawDays: patientBarcodes}, function () {
                    vm.searchQuery = '';
                    vm.dtInstance.reloadData();
                    vm.isSaving = false;
                }, function () {
                    toastr.error('"Error collecting orders"');
                    vm.isSaving = false;
                });
            } else {
                toastr.error('There is not requisition selected');
                vm.dtInstance.reloadData();
                vm.isSaving = false;
            }
        }

        function cancelRequisition() {
            var patientBarcodes = [];

            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    patientBarcodes.push(
                        {
                            patientId: vm.orders[id].patientId,
                            date: DateUtils.convertLocalDateToServer(vm.selectedDate),
                            physicianId: vm.orders[id].physicianId,
                            barcode: vm.orders[id].barcode,
                            status: vm.orders[id].status
                        }
                    );
                }
            }

            if (patientBarcodes.length > 0) {
                var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to Cancel Requisition?', {size: 'md'});
                dlg.result.then(function (btn) {
                    PatientOrder.cancelRequisition({drawDays: patientBarcodes}, function () {
                        vm.searchQuery = '';
                        vm.dtInstance.reloadData();
                    }, function () {
                        toastr.error('"Error collecting orders"');
                    });
                });
            } else {
                toastr.error('There is not requisition selected');
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardEnvOrderSchedule2Controller', DashboardEnvOrderSchedule2Controller);

    DashboardEnvOrderSchedule2Controller.$inject = ['PopupService', 'CoreService', '$rootScope', 'OdsReportsService',
        '$uibModal', 'dialogs', '$compile', '$q', '$scope', 'GUIUtils', 'EnvOrder', 'DTOptionsBuilder',
        'DTColumnBuilder', 'DateUtils', 'DataTablesService', 'clinic', 'dateEnv', 'lodash', 'toastr',
        '$filter', 'hasPrinter', 'DYMO'];

    function DashboardEnvOrderSchedule2Controller(PopupService, CoreService, $rootScope, OdsReportsService,
                                                  $uibModal, $dialogs, $compile, $q, $scope, GUIUtils, EnvOrder, DTOptionsBuilder,
                                                  DTColumnBuilder, DateUtils, DataTablesService, clinic, dateEnv, _, toastr,
                                                  $filter, hasPrinter, DYMO) {
        var vm = this;
        vm.clinic = clinic;
        vm.dtInstance = {};
        vm.selectedDate = dateEnv;
        vm.selected = {};
        vm.selectAll = false;
        vm.hasPrinter = hasPrinter;
        vm.search = search;
        vm.modalPendingResults = modalPendingResults;
        vm.getBarcodeLabelsPdf = getBarcodeLabelsPdf;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';
        vm.statuses = {
            'MANIFESTED': {label: 'Manifested', template: 'success'},
            'PRINTED': {label: 'Printed', template: 'warning'},
            'SCHEDULED': {label: 'Scheduled', template: 'info'},
            'CANCELED': {label: 'Cancelled', template: 'danger'}
        };

        vm.showCalendar = showCalendar;
        vm.showChangeDrawDayCalendar = showChangeDrawDayCalendar;
        vm.getManifestPdf = getManifestPdf;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.cancelRequisition = cancelRequisition;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            vm.selected = {};
            vm.selectAll = false;

            if (!vm.searchQuery || vm.searchQuery == '') {
                if (vm.clinic) {
                    EnvOrder.getSchedule({clinicId: vm.clinic.id, date: vm.selectedDate}, function (result) {
                        vm.orders = result;
                        defer.resolve(result);
                    });
                } else {
                    defer.resolve(vm.orders);
                }
            } else {
                defer.resolve($filter('filter')(vm.orders, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withOption('aaSorting', [[1, 'asc'], [2, 'asc']])
            .withDOM('tip')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;
                return '<input type="checkbox" ng-model="vm.selected[' + full.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Machine').renderWith(function (data, type, full) {
                return data.machineName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.barcode ? data.barcode : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(orderStatusHtml),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '55px').withOption('class', 'col-btn').notSortable().renderWith(actionsHtml)

        ];

        function orderStatusHtml(data, type, full) {
            var patientStatus = vm.statuses[data.status];
            return GUIUtils.getStatusTemplate(patientStatus.label, patientStatus.template);
        }

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a uib-tooltip="See Details" class="btn btn-default btn-sm details" ' +
                'ng-click="vm.modalPendingResults(' + data.id + ')">' +
                '   <i class="fa fa-external-link" aria-hidden="true"></i></>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function modalPendingResults(index) {
            PopupService.showEnvironmentalBarcodePopup(_.filter(vm.orders, {id: index})[0]);
        }

        function showCalendar() {
            $uibModal.open({
                templateUrl: 'app/entities/dashboard/dashboard2/dashboard2-select-day.dialog.html',
                controller: 'DashboardSelectDateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    date: vm.selectedDate,
                    isPatient: {value: false},
                    clinic: vm.clinic
                }
            }).result.then(function (result) {
                vm.selectedDate = result.value;
                vm.searchQuery = '';
                vm.dtInstance.reloadData();
            });
        }

        function showChangeDrawDayCalendar() {
            $uibModal.open({
                templateUrl: 'app/entities/dashboard/dashboard2/dashboard2-select-day.dialog.html',
                controller: 'DashboardSelectDateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    date: vm.selectedDate,
                    isPatient: {value: false},
                    clinic: vm.clinic
                }
            }).result.then(function (result) {
                vm.searchQuery = '';
                changeDrawDay(result.value);
            });
        }

        function changeDrawDay(newDrawDay) {
            var newDrawDays = [];

            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    var order = _.keyBy(vm.orders, 'id')[id];

                    if (_.includes(['SCHEDULED', 'PRINTED'], order.status)) {
                        newDrawDays.push(
                            {
                                date: order.scheduleDate,
                                orderId: id,
                                status: order.status,
                                newDate: DateUtils.convertLocalDateToServer(newDrawDay)
                            }
                        );
                    }
                }
            }

            if (newDrawDays.length > 0) {
                var dlg = $dialogs.confirm('Please Confirm', 'Do you want to change the draw day for selected requisitions?', {size: 'md'});

                dlg.result.then(function (btn) {
                    EnvOrder.changeDrawDayV2({drawDays: newDrawDays}, function (results) {
                        if (results.length > 0) {
                            $dialogs.error("Error", "This item can't be change to selected date. " +
                                _.map(results, function (result) {
                                        return "Order: " + result.orderId + " - " + result.machine;
                                    }
                                ).join(', ')
                            );
                        } else {
                            vm.dtInstance.reloadData();
                        }
                    });
                });
            } else {
                toastr.error('There is not requisition selected');
            }
        }

        function getManifestPdf() {
            var barcodes = getSelectedBarcodes();

            if (barcodes.length > 0) {
                EnvOrder.getManifestPdf({clinicId: clinic.id, barcodes: barcodes}, function () {
                    vm.searchQuery = '';
                    vm.dtInstance.reloadData();
                }, function () {
                    toastr.error('"Error manifesting orders"');
                });
            } else {
                toastr.error('There is not requisition selected');
            }
        }

        function getSelectedBarcodes() {
            var barcodes = [];

            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    var order = _.filter(vm.orders, function (order) {
                        return id == '' + order.id && order.barcode && order.status != 'SCHEDULED';
                    })[0];

                    if (order != null) {
                        barcodes.push(order.barcode);
                    }
                }
            }

            return barcodes;
        }

        function getBarcodeLabelsPdf() {
            var orders = DataTablesService.getSelectedIds(vm.selected);
            if (orders.length > 0) {
                vm.isSaving = true;
                var envBarcodes = _.map(orders, function (id) {
                    return {
                        orderId: id,
                        date: DateUtils.convertLocalDateToServer(vm.selectedDate),
                        barcode: _.keyBy(vm.orders, 'id')[id].barcode
                    }
                });

                EnvOrder.getBarcodeLabelsPdf({drawDays: envBarcodes}, function () {
                    vm.searchQuery = '';
                    vm.dtInstance.reloadData();
                    vm.isSaving = false;
                }, function () {
                    toastr.error('"Error collecting orders"');
                    vm.isSaving = false;
                });
            } else {
                toastr.error('There is not requisition selected');
                vm.dtInstance.reloadData();
                vm.isSaving = false;
            }
        }

        vm.printLabels = function () {
            var orders = DataTablesService.getSelectedIds(vm.selected);
            if (orders.length > 0) {
                vm.isSaving = true;
                EnvOrder.collect2({ids: orders, date: vm.selectedDate}, function (result) {
                    vm.barcodes = getSelectedBarcodes().concat(result);
                    vm.isSaving = false;

                    if (vm.hasPrinter) {
                        if (vm.barcodes.length > 0) {
                            EnvOrder.getBarcodeLabels({barcodes: vm.barcodes}, function (result) {
                                DYMO.printEnvBarcodes(result);
                                vm.dtInstance.reloadData();
                                vm.barcodes = [];
                            });
                        }
                    }
                }, function () {
                    alert("Error collecting orders");
                    vm.isSaving = false;
                })
            }
        }

        function cancelRequisition() {
            var envOrderTestIds = DataTablesService.getSelectedIds(vm.selected);

            if (envOrderTestIds.length > 0) {
                var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to change Cancel Requisition?', {size: 'md'});
                dlg.result.then(function (btn) {
                    EnvOrder.cancelRequisition({
                        ids: envOrderTestIds,
                        date: DateUtils.convertLocalDateToServer(vm.selectedDate)
                    }, function () {
                        vm.searchQuery = '';
                        vm.dtInstance.reloadData();
                    });
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardSelectDateDialogController', DashboardSelectDateDialogController);

    DashboardSelectDateDialogController.$inject = ['$uibModalInstance', 'PatientOrder', 'EnvOrder', 'isPatient', 'CoreService', '$rootScope', 'date', 'clinic'];

    function DashboardSelectDateDialogController($uibModalInstance, PatientOrder, EnvOrder, isPatient, CoreService, $rootScope, date, clinic) {
        var vm = this;

        vm.isPatient = isPatient.value;
        vm.date = date;
        vm.clinic = clinic;
        vm.options = {
            initDate: new Date(),
            showWeeks: true
        };

        vm.rmConfig1 = {
            mondayStart: false,
            initState: "month", /* decade || year || month */
            maxState: "decade",
            minState: "month",
            decadeSize: 12,
            monthSize: 42, /* "auto" || fixed nr. (35 or 42) */
            min: new Date("2016-01-01"),
            max: null,
            format: "yyyy-MM-dd",
            markDates: vm.isPatient ? markPatientDates : markEnvDates
        };

        vm.clear = clear;
        vm.selectDate = selectDate;
        vm.markPatientDates = markPatientDates;
        vm.markEnvDates = markEnvDates;

        function selectDate() {
            vm.isPatient ? CoreService.setStorage('activeScheduleDate', vm.date) : CoreService.setStorage('activeScheduleDateEnv', vm.date);
            $uibModalInstance.close({value: vm.date});
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function markPatientDates(oDate) {
            return vm.clinic ? PatientOrder.markDates({clinicId: vm.clinic.id, date: oDate}) : [];
        }

        function markEnvDates(oDate) {
            return vm.clinic ? EnvOrder.markDates({clinicId: vm.clinic.id, date: oDate}) : [];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('Dashboard2Controller', Dashboard2Controller);

    Dashboard2Controller.$inject = ['$scope',  'CoreService', 'activeTab'];

    function Dashboard2Controller ($scope,  CoreService, activeTab) {
        var vm = this;

        vm.activeTab = activeTab;
        vm.keepActiveTab = keepActiveTab;

        function keepActiveTab(index) {
            CoreService.setStorage('activeScheduleTab', index);
            vm.activeTab = index;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardEnvController', DashboardEnvController);

    DashboardEnvController.$inject = ['$rootScope', 'Dashboard', 'CoreService', 'EMPLOYEE_TYPE', 'DYMO'];

    function DashboardEnvController ($rootScope, Dashboard, CoreService, EMPLOYEE_TYPE, DYMO) {
        var vm = this;
        vm.clinic = CoreService.getCurrentClinic();

        reload();

        vm.labels = ["Final Results", "Partial Results", "Results Not Reviewed"];
        vm.data = [0, 0, 0];
        vm.colors =  ['#00A65A', '#F39C12', '#FB434A'];

        function reload() {
            if (vm.clinic != undefined) {
                Dashboard.environmental({id : vm.clinic.id}, function(result2) {
                    vm.dashboard = result2;
                    vm.data = [vm.dashboard.finalResult, vm.dashboard.partialResult, vm.dashboard.resultNotReceived];
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardPatientOrderScheduleController', DashboardPatientOrderScheduleController);

    DashboardPatientOrderScheduleController.$inject = ['CoreService', 'hasPrinter', '$rootScope', 'OdsReportsService',
        '$uibModal', 'DYMO', '$stateParams', 'dialogs',
        '$compile', '$q', '$scope', 'GUIUtils', 'PatientOrder', 'DTOptionsBuilder', 'DTColumnBuilder', 'DateUtils', 'date'];

    function DashboardPatientOrderScheduleController(CoreService, hasPrinter, $rootScope, OdsReportsService,
                                                     $uibModal, DYMO, $stateParams, $dialogs,
                                                     $compile, $q, $scope, GUIUtils, PatientOrder, DTOptionsBuilder, DTColumnBuilder, DateUtils, date) {
        var vm = this;
        vm.clinic = CoreService.getCurrentClinic();

        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.barCode = {};
        vm.oDate1 = date;
        vm.hasPrinter = hasPrinter;

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        vm.getManifest = getManifest;

        vm.barcodes = [];

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (vm.clinic) {
                PatientOrder.dashboardSchedule({clinicId: vm.clinic.id, date: vm.oDate1, shift: -1}, function (result) {
                    vm.orders = setUniqueIds(result);
                    defer.resolve(vm.orders);

                    if (vm.hasPrinter) {
                        if (vm.barcodes.length > 0) {
                            $rootScope.$broadcast('dialysisApp:dashboardRedrawPatientCalendar' + $stateParams.state);

                            PatientOrder.getBarcodeLabels({barcodes: vm.barcodes}, function (result) {
                                DYMO.printPatientBarcodes(result);

                                vm.barcodes = [];
                            });
                        }
                    }

                    vm.selected = {};
                    vm.selectAll = false;


                });
            } else {
                defer.resolve(vm.orders);
            }

            return defer.promise;
        }).withBootstrap().withDOM('tip')
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Patient Name').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + data.middleName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('D.O.B').withOption('width', '110px').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.barcode ? showBarcode(data) : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Tests').withOption('width', '90px').renderWith(function (data, type, full, meta) {
                return showCompendiumHtml(data.id);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Collected').withOption('width', '80px').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.collected);
            })
        ];

        vm.printLabels = function () {
            var patientBarcodes = [];

            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    if (vm.orders[id].barcode == null) {
                        patientBarcodes.push(
                            {
                                patientId: vm.orders[id].patientId,
                                date: DateUtils.convertLocalDateToServer(vm.oDate1),
                                physicianId: vm.orders[id].pId
                            }
                        );
                    }
                }
            }

            if (patientBarcodes.length > 0) {
                vm.isSaving = true;

                PatientOrder.genBarcodes({drawDays: patientBarcodes}, function (result) {
                    vm.barcodes = getSelectedBarcodes().concat(result);

                    vm.dtInstance.reloadData();
                    vm.isSaving = false;
                }, function () {
                    alert("Error collecting orders");
                    vm.isSaving = false;
                });
            } else {
                vm.barcodes = getSelectedBarcodes();
                vm.dtInstance.reloadData();
                vm.isSaving = false;
            }
        }

        vm.changeDrawDay = function () {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to change the draw day? Items with results or kinetcs data will not be changed', {size: 'md'});
            dlg.result.then(function (btn) {
                vm.isSaving = true;
                $uibModal.open({
                    templateUrl: 'app/entities/window-picker/date-picker-dialog.html',
                    controller: 'DatePickerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        date: new Date()
                    }
                }).result.then(function (result) {
                    var patientBarcodes = [];

                    for (var id in vm.selected) {
                        if (vm.selected[id]) {
                            if (vm.orders[id].barcode) {
                                patientBarcodes.push({
                                    patientId: vm.orders[id].patientId,
                                    barcode: vm.orders[id].barcode,
                                    newDate: DateUtils.convertLocalDateToServer(result.date)
                                });
                            } else {
                                patientBarcodes.push({
                                    patientId: vm.orders[id].patientId,
                                    barcode: null,
                                    date: vm.orders[id].scheduleDate,
                                    newDate: DateUtils.convertLocalDateToServer(result.date),
                                    physicianId: vm.orders[id].pId
                                });
                            }
                        }
                    }

                    if (patientBarcodes.length > 0) {
                        vm.isSaving = false;

                        PatientOrder.changeDrawDay({drawDays: patientBarcodes}, function (result) {
                            vm.barcodes = result;
                            vm.dtInstance.reloadData();
                            vm.isSaving = false;
                            $rootScope.$broadcast('dialysisApp:dashboardRedrawPatientCalendar' + $stateParams.state);
                        }, function () {
                            alert("Error change draw days orders");
                            vm.isSaving = false;
                        });
                    } else {
                        vm.barcodes = getSelectedBarcodes();
                        vm.dtInstance.reloadData();
                        vm.isSaving = false;
                    }
                }, function () {
                    vm.isSaving = false;
                });
            });
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }
            vm.selectAll = true;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        $scope.$on('dialysisApp:dashboardCalendarUpdate', function (event, result) {
            vm.oDate1 = result;
            vm.selected = {};
            vm.selectAll = false;
            vm.search();
        });

        function showBarcode(row) {
            return '<a ui-sref="' + "clinic-schedule-pdetail-barcode({barcode:'" + row.barcode + "'})" + '">' + row.barcode + '</a>';
        }

        function showCompendiumHtml(row) {
            return '<a class="btn-sm btn-info" ng-click="vm.showCompendiums(' + row + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        };

        vm.showCompendiums = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/compendium/compendium-list-dialog.html',
                controller: 'CompendiumListDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    compendiums: ['Compendium', function (Compendium) {
                        if (vm.orders[index].barcode) {
                            return Compendium.by_patient_with_barcode({barcode: vm.orders[index].barcode}).$promise;
                        } else {
                            return Compendium.by_patient_without_barcode({
                                patient: vm.orders[index].patientId,
                                date: DateUtils.convertLocalDateToServer(vm.oDate1),
                                physician: vm.orders[index].pId
                            }).$promise;
                        }
                    }]
                }
            });
        };

        function getSelectedIds() {
            var patients = [];

            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    patients.push(vm.orders[id].patientId);
                }
            }

            return patients;
        }

        function setUniqueIds(data) {
            for (var i = 0; i < data.length; i++) {
                data[i].id = i;
            }

            return data;
        }

        function getSelectedBarcodes() {
            var barcodes = [];

            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    if (vm.orders[id].barcode != null) {
                        barcodes.push(vm.orders[id].barcode);
                    }
                }
            }

            return barcodes;
        }

        function getManifest() {
            PatientOrder.getManifest({clinicId: vm.clinic.id, date: vm.oDate1}, function (data) {
                $rootScope.$broadcast('dialysisApp:dashboardRedrawPatientCalendar' + $stateParams.state);
                OdsReportsService.forceDownloadAndOpenPDFObject(data);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardEnvOrderScheduleController', DashboardEnvOrderScheduleController);

    DashboardEnvOrderScheduleController.$inject = ['CoreService', '$rootScope', 'hasPrinter', 'DYMO', '$stateParams', 'dialogs',
        '$uibModal', '$compile', '$q', '$scope', 'GUIUtils', 'EnvOrder', 'DTOptionsBuilder', 'DTColumnBuilder',
        'DateUtils', 'date', 'DataTablesService', 'toastr'];

    function DashboardEnvOrderScheduleController(CoreService, $rootScope, hasPrinter, DYMO, $stateParams, $dialogs,
                                                 $uibModal, $compile, $q, $scope, GUIUtils, EnvOrder, DTOptionsBuilder,
                                                 DTColumnBuilder, DateUtils, date, DataTablesService, toastr) {
        var vm = this;
        vm.clinic = CoreService.getCurrentClinic();

        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.barCode = {};
        vm.oDate1 = new Date(date);
        vm.hasPrinter = hasPrinter;

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getBarcodeLabelsPdf = getBarcodeLabelsPdf2;

        vm.barcodes = [];

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            vm.selected = {};
            vm.selectAll = false;

            if (vm.clinic) {
                EnvOrder.dashboardSchedule({clinicId: vm.clinic.id, date: vm.oDate1}, function (result) {
                    vm.orders = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve(vm.orders);
            }

            return defer.promise;
        }).withBootstrap().withDOM('tip')
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.orderId] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.orderId + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Machine').renderWith(function (data, type, full) {
                return data.machine;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.barcode ? showBarcode(data) : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Order ID').renderWith(function (data, type, full) {
                return data.orderId;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Tests').withOption('width', '90px').renderWith(function (data, type, full, meta) {
                return showCompendiumHtml(data.orderId);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Collected').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.collected);
            })
        ];

        vm.printLabels = function () {
            var orders = getSelectedIds();

            if (orders.length > 0) {
                vm.isSaving = true;
                EnvOrder.collect({ids: orders, date: vm.oDate1}, function (result) {
                    vm.barcodes = getSelectedBarcodes().concat(result);

                    if (vm.hasPrinter) {
                        if (vm.barcodes.length > 0) {
                            $rootScope.$broadcast('dialysisApp:dashboardRedrawEnvCalendar' + $stateParams.state);

                            EnvOrder.getBarcodeLabels({barcodes: vm.barcodes}, function (result) {
                                DYMO.printEnvBarcodes(result);

                                vm.barcodes = [];

                                vm.dtInstance.reloadData();
                            });
                        }
                    }

                }, function () {
                    alert("Error collecting orders");
                    vm.isSaving = false;
                })
            }
        }

        vm.changeDrawDay = function () {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to change the draw day? Items with results will not be changed', {size: 'md'});
            dlg.result.then(function (btn) {
                $uibModal.open({
                    templateUrl: 'app/entities/window-picker/date-picker-dialog.html',
                    controller: 'DatePickerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        date: new Date()
                    }
                }).result.then(function (result) {
                    var envBarCodes = [];

                    for (var id in vm.selected) {
                        if (vm.selected[id]) {
                            var order = $.grep(vm.orders, function (order, i) {
                                return order.orderId == id;
                            })[0];

                            if (order.barcode == null) {
                                envBarCodes.push({
                                    machineId: order.machineId,
                                    barcode: null,
                                    date: order.scheduleDate,
                                    newDate: DateUtils.convertLocalDateToServer(result.date),
                                    orderId: order.orderId
                                });
                            } else {
                                envBarCodes.push({
                                    machineId: order.machineId,
                                    barcode: order.barcode,
                                    newDate: DateUtils.convertLocalDateToServer(result.date),
                                    orderId: order.orderId
                                });
                            }
                        }
                    }

                    if (envBarCodes.length > 0) {
                        vm.isSaving = false;

                        EnvOrder.changeDrawDay({drawDays: envBarCodes}, function (result) {
                            vm.barcodes = result;
                            vm.dtInstance.reloadData();
                            vm.isSaving = false;

                            $rootScope.$broadcast('dialysisApp:dashboardRedrawEnvCalendar' + $stateParams.state);
                        }, function () {
                            alert("Error change draw days orders");
                            vm.isSaving = false;
                        });
                    } else {
                        vm.barcodes = getSelectedBarcodes();
                        vm.dtInstance.reloadData();
                        vm.isSaving = false;
                    }
                }, function () {
                });
            });
        }

        function getBarcodeLabelsPdf2() {
            var orders = DataTablesService.getSelectedIds(vm.selected);
            if (orders.length > 0) {
                vm.isSaving = true;
                var envBarcodes = _.map(orders, function (id) {
                    return {
                        orderId: id,
                        date: DateUtils.convertLocalDateToServer(vm.oDate1),
                        barcode: _.keyBy(vm.orders, 'orderId')[id].barcode
                    }
                });

                EnvOrder.getBarcodeLabelsPdf2({drawDays: envBarcodes}, function () {
                    vm.searchQuery = '';
                    vm.dtInstance.reloadData();
                }, function () {
                    toastr.error('"Error collecting orders"');
                });
            } else {
                toastr.error('There is not requisition selected');
                vm.dtInstance.reloadData();
            }
        }

        // function toggleAll() {
        //     for (var id in vm.selected) {
        //         if (vm.selected.hasOwnProperty(id)) {
        //             vm.selected[id] = vm.selectAll;
        //         }
        //     }
        // }
        //
        // function toggleOne() {
        //     for (var id in vm.selected) {
        //         if (vm.selected.hasOwnProperty(id)) {
        //             if (!vm.selected[id]) {
        //                 vm.selectAll = false;
        //                 return;
        //             }
        //         }
        //     }
        //     vm.selectAll = true;
        // }

        function search() {
            vm.dtInstance.reloadData();
        }

        $scope.$on('dialysisApp:dashboardCalendarUpdate', function (event, result) {
            vm.oDate1 = result;
            vm.selected = {};
            vm.selectAll = false;
            vm.search();
        });

        function showCompendiumHtml(row) {
            return '<a class="btn-sm btn-info" ng-click="vm.showCompendiums(' + row + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        }

        vm.showCompendiums = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/compendium/compendium-list-dialog.html',
                controller: 'CompendiumListDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    compendiums: ['Compendium', function (Compendium) {
                        return Compendium.by_env_order({
                            id: index,
                            date: DateUtils.convertLocalDateToServer(vm.oDate1)
                        }).$promise;
                    }]
                }
            });
        };

        function getSelectedIds() {
            var orders = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    orders.push(id);
                }
            }

            return orders;
        }

        function getSelectedBarcodes() {
            var barcodes = [];

            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    var order = $.grep(vm.orders, function (order, i) {
                        return order.orderId == id;
                    })[0];

                    if (order.barcode != null) {
                        barcodes.push(order.barcode);
                    }
                }
            }

            return barcodes;
        }

        function showBarcode(row) {
            return '<a ui-sref="' + "clinic-schedule-edetail-barcode({barcode:'" + row.barcode + "'})" + '">' + row.barcode + '</a>';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardAllOrdersScheduleController', DashboardAllOrdersScheduleController);

    DashboardAllOrdersScheduleController.$inject = ['$rootScope', 'hasPrinter', 'EnvOrder', 'date', '$stateParams',
        'PatientOrder', 'CoreService'];

    function DashboardAllOrdersScheduleController($rootScope, hasPrinter, EnvOrder, date, $stateParams,
                                                  PatientOrder, CoreService) {
        var vm = this;
        vm.clinic = CoreService.getCurrentClinic();

        vm.hasPrinter = hasPrinter;

        vm.rmConfig1 = {
            mondayStart: false,
            initState: "month", /* decade || year || month */
            maxState: "decade",
            minState: "month",
            decadeSize: 12,
            monthSize: 42, /* "auto" || fixed nr. (35 or 42) */
            min: new Date("2016-01-01"),
            max: null,
            format: "yyyy-MM-dd",
            markDates: markPatientDates,
            subscribe: 'dialysisApp:dashboardCalendarUpdate1',
            broadcast: 'dialysisApp:dashboardCalendarUpdate2',
            redraw: 'dialysisApp:dashboardRedrawPatientCalendar' + $stateParams.state
        };

        vm.rmConfig2 = {
            mondayStart: false,
            initState: "month", /* decade || year || month */
            maxState: "decade",
            minState: "month",
            decadeSize: 12,
            monthSize: 42, /* "auto" || fixed nr. (35 or 42) */
            min: new Date("2016-01-01"),
            max: null,
            format: "yyyy-MM-dd",
            markDates: markEnvDates,
            subscribe: 'dialysisApp:dashboardCalendarUpdate2',
            broadcast: 'dialysisApp:dashboardCalendarUpdate1',
            redraw: 'dialysisApp:dashboardRedrawEnvCalendar' + $stateParams.state
        };

        vm.oDate1 = new Date(date);
        vm.oDate2 = new Date(date);

        //load active tab from storage
        vm.activeTab = CoreService.getStorage('activeScheduleTab');

        vm.select1 = function (oDate) {
            //save active schedule date
            CoreService.setStorage('activeScheduleDate', oDate);
            $rootScope.$broadcast('dialysisApp:dashboardCalendarUpdate2', oDate);
            $rootScope.$broadcast('dialysisApp:dashboardCalendarUpdate', oDate);
        }

        vm.select2 = function (oDate) {
            CoreService.setStorage('activeScheduleDate', oDate);
            $rootScope.$broadcast('dialysisApp:dashboardCalendarUpdate1', oDate);
            $rootScope.$broadcast('dialysisApp:dashboardCalendarUpdate', oDate);
        }

        function markPatientDates(oDate) {
            return vm.clinic ? PatientOrder.markDates({clinicId: vm.clinic.id, date: oDate}) : [];
        }

        function markEnvDates(oDate) {
            return vm.clinic ? EnvOrder.markDates({clinicId: vm.clinic.id, date: oDate}) : [];
        }

        vm.keepActiveTab = keepActiveTab;

        function keepActiveTab(index) {
            //save current tab
            CoreService.setStorage('activeScheduleTab', index);
            vm.activeTab = index;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardDocController', DashboardDocController);

    DashboardDocController.$inject = ['$timeout', 'Dashboard', 'CoreService', 'EMPLOYEE_TYPE', 'dashboard', '$state'];

    function DashboardDocController($timeout, Dashboard, CoreService, EMPLOYEE_TYPE, dashboard, $state) {
        var vm = this;
        vm.dashboard = dashboard;
        vm.clinic = CoreService.getCurrentClinic();

        reload();

        vm.labels = ["Final Results", "Partial Results", "Results Not Reviewed"];
        vm.data = [0, 0, 0];
        vm.colors = ['#00A65A', '#F39C12', '#FB434A'];

        function reload() {
            if (vm.clinic != undefined) {
                Dashboard.get({id: vm.clinic.id}, function (result2) {
                    vm.dashboard = result2;
                    vm.employee = CoreService.getCurrentEmployee();

                    if (vm.employee.employeeType && vm.employee.employeeType.name == EMPLOYEE_TYPE.PHYSICIAN) {
                        vm.dashboard.unsignedOrders = vm.dashboard.unsignedOrdersByDoctor;
                    }

                    // vm.data = [vm.dashboard.finalResult, vm.dashboard.partialResult, vm.dashboard.resultNotReceived];

                    //build graph options and data
                    //for troubles with render angular tabs
                    $timeout(function () {
                        for (var i = 0; i < vm.dashboard.panels.length; i++) {
                            for (var j = 0; j < vm.dashboard.panels[i].patientResultHealths.length; j++) {
                                vm.dashboard.panels[i].patientResultHealths[j].data = getData(vm.dashboard.panels[i].patientResultHealths[j]);
                                vm.dashboard.panels[i].patientResultHealths[j].options = getOptions(vm.dashboard.panels[i].patientResultHealths[j]);
                                vm.dashboard.panels[i].patientResultHealths[j].colors = getColors(vm.dashboard.panels[i].patientResultHealths[j]);
                                vm.dashboard.panels[i].patientResultHealths[j].labels = getLabels(vm.dashboard.panels[i].patientResultHealths[j]);
                            }
                        }
                    }, 1);
                });
            }
        }

        function getData(patientResultHealth) {
            var data = [];

            patientResultHealth.patientResultHealthItems.forEach(function a(item, index) {
                data.push(item.count);
            });

            return data;
        }

        function getColors(patientResultHealth) {
            var color = [];

            patientResultHealth.patientResultHealthItems.forEach(function a(item, index) {
                color.push({
                    backgroundColor: item.color,
                    pointBackgroundColor: item.color
                });
            });

            return color;
        }

        function getLabels(patientResultHealth) {
            var labels = [];

            patientResultHealth.patientResultHealthItems.forEach(function a(item, index) {
                labels.push(item.range);
            });

            return labels;
        }

        function getOptions(patientResultHealth) {
            return vm.options = {
                responsive: true,
                patientResultHealth: angular.copy(patientResultHealth),
                legend: {display: true, position: 'right', fullWidth: false, labels:{'boxWidth': 10}},
                title: {display: true, text: patientResultHealth.testName},
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                pieceLabel: {
                    render: 'value',
                    showZero: true
                },
                onClick: function(e) {
                    var element = this.getElementAtEvent(e);
                    if (element.length) {
                        $state.go("patient-health", {
                            patientResultHealth: element[0]._chart.options.patientResultHealth,
                            patientResultHealthItem: element[0]._chart.options.patientResultHealth.patientResultHealthItems[element[0]._index]
                        });
                    }
                },
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardAdminPatientOrderScheduleController', DashboardAdminPatientOrderScheduleController);

    DashboardAdminPatientOrderScheduleController.$inject = ['CoreService', 'hasPrinter', '$rootScope', 'date', '$uibModal', '$compile', '$q', '$scope', 'GUIUtils', 'PatientOrder', 'DTOptionsBuilder', 'DTColumnBuilder', 'DateUtils', 'DYMO'];

    function DashboardAdminPatientOrderScheduleController(CoreService, hasPrinter, $rootScope, date, $uibModal, $compile, $q, $scope, GUIUtils, PatientOrder, DTOptionsBuilder, DTColumnBuilder, DateUtils, DYMO) {
        var vm = this;
        vm.clinic = CoreService.getCurrentClinic();

        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.barCode = {};
        vm.oDate1 = new Date(date);
        vm.hasPrinter = hasPrinter;

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;

        vm.barcodes = [];

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (vm.clinic) {
                PatientOrder.dashboardSchedule({
                    clinicId: vm.clinic.id,
                    date: vm.oDate1,
                    shift: -1
                }, function (result) {
                    vm.orders = setUniqueIds(result);
                    defer.resolve(vm.orders);

                    vm.selected = {};
                    vm.selectAll = false;
                });
            } else {
                defer.resolve(vm.orders);
            }

            return defer.promise;
        }).withBootstrap().withDOM('tip')
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Patient Name').renderWith(function (data, type, full) {
                return data.lastName + ', ' + data.firstName + ' ' + data.middleName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('D.O.B').withOption('width', '110px').renderWith(function (data, type, full) {
                return moment(data.dob).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.barcode ? showBarcode(data) : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Tests').withOption('width', '90px').renderWith(function (data, type, full, meta) {
                return showCompendiumHtml(data.id);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Collected').withOption('width', '80px').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.collected);
            })
        ];

        vm.printLabels = function () {
            if (vm.hasPrinter) {
                vm.barcodes = getSelectedBarcodes();

                if (vm.barcodes.length > 0) {
                    PatientOrder.getBarcodeLabels({barcodes: vm.barcodes}, function (result) {
                        DYMO.printPatientBarcodes(result);

                        vm.barcodes = [];
                    });
                }
            }
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }
            vm.selectAll = true;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        $scope.$on('dialysisApp:dashboardAdminCalendarUpdate', function (event, result) {
            vm.oDate1 = result;
            vm.selected = {};
            vm.selectAll = false;
            vm.search();
        });

        function showBarcode(row) {
            return '<a ui-sref="' + "clinic-schedule-pdetail-barcode({barcode:'" + row.barcode + "'})" + '">' + row.barcode + '</a>';
        }

        function showCompendiumHtml(row) {
            return '<a class="btn-sm btn-info" ng-click="vm.showCompendiums(' + row + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        };

        vm.showCompendiums = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/compendium/compendium-list-dialog.html',
                controller: 'CompendiumListDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    compendiums: ['Compendium', function (Compendium) {
                        if (vm.orders[index].barcode) {
                            return Compendium.by_patient_with_barcode({barcode: vm.orders[index].barcode}).$promise;
                        } else {
                            return Compendium.by_patient_without_barcode({
                                patient: vm.orders[index].patientId,
                                date: DateUtils.convertLocalDateToServer(vm.oDate1),
                                physician: vm.orders[index].pId
                            }).$promise;
                        }
                    }]
                }
            });
        };

        function getSelectedIds() {
            var orders = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    orders.push(id);
                }
            }

            return orders;
        }

        function setUniqueIds(data) {
            for (var i = 0; i < data.length; i++) {
                data[i].id = i;
            }

            return data;
        }

        function getSelectedBarcodes() {
            var barcodes = [];

            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    if (vm.orders[id].barcode != null) {
                        barcodes.push(vm.orders[id].barcode);
                    }
                }
            }

            return barcodes;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardAdminEnvOrderScheduleController', DashboardAdminEnvOrderScheduleController);

    DashboardAdminEnvOrderScheduleController.$inject = ['CoreService', '$rootScope', 'hasPrinter', 'date', '$uibModal', '$compile', '$q', '$scope', 'GUIUtils', 'EnvOrder', 'DTOptionsBuilder', 'DTColumnBuilder', 'DateUtils', 'DYMO'];

    function DashboardAdminEnvOrderScheduleController(CoreService, $rootScope, hasPrinter, date, $uibModal, $compile, $q, $scope, GUIUtils, EnvOrder, DTOptionsBuilder, DTColumnBuilder, DateUtils, DYMO) {
        var vm = this;
        vm.clinic = CoreService.getCurrentClinic();

        vm.orders = [];
        vm.search = search;
        vm.dtInstance = {};
        vm.barCode = {};
        vm.oDate1 = new Date(date);
        vm.hasPrinter = hasPrinter;

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (vm.clinic) {
                EnvOrder.dashboardSchedule({clinicId: vm.clinic.id, date: vm.oDate1}, function (result) {
                    vm.orders = result;
                    defer.resolve(result);
                    vm.selected = {};
                    vm.selectAll = false;
                });
            } else {
                defer.resolve(vm.orders);
            }

            return defer.promise;
        }).withBootstrap().withDOM('tip')
            .withOption('createdRow', function(row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('headerCallback', function(header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function(data, type, full, meta) {
                vm.selected[full.orderId] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.orderId + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Machine').renderWith(function (data, type, full) {
                return data.machine;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.barcode ? showBarcode(data) : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Tests').withOption('width', '90px').renderWith(function (data, type, full, meta) {
                return showCompendiumHtml(data.orderId);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Collected').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.collected);
            }),
        ];

        vm.printLabels = function() {
            var orders = getSelectedIds();

            if (vm.hasPrinter) {
                var orders = getSelectedIds();
                if (orders.length > 0) {
                    EnvOrder.get_barcodes({
                        ids: orders,
                        date: DateUtils.convertLocalDateToServer(vm.oDate1)
                    }, function (result) {
                        DYMO.printEnvBarcodes(result);
                    });
                }
            }
        }

        function toggleAll () {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne () {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if(!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }
            vm.selectAll = true;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        $scope.$on('dialysisApp:dashboardAdminCalendarUpdate', function(event, result) {
            vm.oDate1 = result;
            vm.selected = {};
            vm.selectAll = false;
            vm.search();
        });

        function showCompendiumHtml(row) {
            return '<a class="btn-sm btn-info" ng-click="vm.showCompendiums(' + row + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        };

        vm.showCompendiums = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/compendium/compendium-list-dialog.html',
                controller: 'CompendiumListDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    compendiums: ['Compendium', function (Compendium) {
                        return Compendium.by_env_order({
                            id: index,
                            date: DateUtils.convertLocalDateToServer(vm.oDate1)
                        }).$promise;
                    }]
                }
            });
        };

        function getSelectedIds() {
            var orders = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    orders.push(id);
                }
            }

            return orders;
        }

        function showBarcode(row) {
            return '<a ui-sref="' + "clinic-schedule-edetail-barcode({barcode:'" + row.barcode + "'})" + '">' + row.barcode + '</a>';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardAdminAllOrdersScheduleController', DashboardAdminAllOrdersScheduleController);

    DashboardAdminAllOrdersScheduleController.$inject = ['$rootScope', 'date', '$scope', 'hasPrinter', 'EnvOrder',
        'PatientOrder', 'DateUtils', 'CoreService'];

    function DashboardAdminAllOrdersScheduleController($rootScope, date, $scope, hasPrinter, EnvOrder,
                                                  PatientOrder, DateUtils, CoreService) {
        var vm = this;
        vm.clinic = CoreService.getCurrentClinic();

        vm.hasPrinter = hasPrinter;
        vm.patientOrders = 0;
        vm.envOrders = 0;
        vm.dashboard = {
            printedBarcodes: 0,
            unPrintedBarcodes: 0,
            printedWaterLabel: 0,
            unPrintedWaterLabel: 0
        };

        vm.activeTab = 0;

        vm.rmConfig1 = {
            mondayStart: false,
            initState: "month", /* decade || year || month */
            maxState: "decade",
            minState: "month",
            decadeSize: 12,
            monthSize: 42, /* "auto" || fixed nr. (35 or 42) */
            min: new Date("2016-01-01"),
            max: null,
            format: "yyyy-MM-dd",
            markDates: markPatientDates,
            subscribe: 'dialysisApp:dashboardAdminCalendarUpdate1',
            broadcast: 'dialysisApp:dashboardAdminCalendarUpdate2',
            redraw: 'dialysisApp:dashboardAdminRedrawPatientCalendar'
        };

        vm.rmConfig2 = {
            mondayStart: false,
            initState: "month", /* decade || year || month */
            maxState: "decade",
            minState: "month",
            decadeSize: 12,
            monthSize: 42, /* "auto" || fixed nr. (35 or 42) */
            min: new Date("2016-01-01"),
            max: null,
            format: "yyyy-MM-dd",
            markDates: markEnvDates,
            subscribe: 'dialysisApp:dashboardAdminCalendarUpdate2',
            broadcast: 'dialysisApp:dashboardAdminCalendarUpdate1',
            redraw: 'dialysisApp:dashboardAdminRedrawEnvCalendar'
        };

        vm.oDate1 = new Date(date);
        vm.oDate2 = new Date(date);

        //load active tab from storage
        vm.activeTab = CoreService.getStorage('activeScheduleTab');

        vm.select1 = function (oDate) {
            CoreService.setStorage('activeScheduleDate', oDate);
            $rootScope.$broadcast('dialysisApp:dashboardAdminCalendarUpdate2', oDate);
            $rootScope.$broadcast('dialysisApp:dashboardAdminCalendarUpdate', oDate);
        }

        vm.select2 = function (oDate) {
            CoreService.setStorage('activeScheduleDate', oDate);
            $rootScope.$broadcast('dialysisApp:dashboardAdminCalendarUpdate1', oDate);
            $rootScope.$broadcast('dialysisApp:dashboardAdminCalendarUpdate', oDate);
        }

        $scope.$on('dialysisApp:dashboardAdminCalendarUpdate', function (event, result) {
            if (vm.clinic) {
                PatientOrder.not_collected({
                    id: vm.clinic.id,
                    date: DateUtils.convertLocalDateToServer(result)
                }, function (result) {
                    vm.patientOrders = result.value;
                });
            }
        });

        $scope.$on('dialysisApp:dashboardAdminCalendarUpdate', function (event, result) {
            if (vm.clinic) {
                EnvOrder.not_collected({
                    id: vm.clinic.id,
                    date: DateUtils.convertLocalDateToServer(result)
                }, function (result) {
                    vm.envOrders = result.value;
                });
            }
        });

        function markPatientDates(oDate) {
            return vm.clinic ? PatientOrder.markDates({clinicId: vm.clinic.id, date: oDate}) : [];
        }

        function markEnvDates(oDate) {
            return vm.clinic ? EnvOrder.markDates({clinicId: vm.clinic.id, date: oDate}) : [];
        }

        vm.keepActiveTab = keepActiveTab;

        function keepActiveTab(index) {
            //save current tab
            CoreService.setStorage('activeScheduleTab', index);
            vm.activeTab = index;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DashboardAdminController', DashboardAdminController);

    DashboardAdminController.$inject = ['$interval', 'Dashboard', '$scope', 'dashboard'];

    function DashboardAdminController ($interval, Dashboard, $scope, dashboard) {
        var vm = this;
        vm.dashboard = dashboard;

        reload();

        var myInterval = $interval(function(){
            reload();
        }, 120000);

        function reload() {
            Dashboard.admin(function(result) {
                vm.dashboard = result;
            });
        }

        $scope.$on('$destroy', function(){
            $interval.cancel(myInterval)
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('dashboard-admin', {
                parent: 'entity',
                url: '/admin',
                ncyBreadcrumb: {
                    label: 'Home',
                    parent: 'app'
                },
                data: {
                    pageTitle: 'Dialysis',
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/dashboard/dashboard-admin2.html',
                        controller: 'DashboardAdminController',
                        controllerAs: 'vm'
                    },
                    'schedule@dashboard-admin': {
                        templateUrl: 'app/entities/dashboard/dashboard-admin/all-orders-schedule.html',
                        controller: 'DashboardAdminAllOrdersScheduleController',
                        controllerAs: 'vm'
                    },
                    'patients@dashboard-admin': {
                        templateUrl: 'app/entities/dashboard/dashboard-admin/patient-order-schedule.html',
                        controller: 'DashboardAdminPatientOrderScheduleController',
                        controllerAs: 'vm'
                    },
                    'machines@dashboard-admin': {
                        templateUrl: 'app/entities/dashboard/dashboard-admin/env-order-schedule.html',
                        controller: 'DashboardAdminEnvOrderScheduleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    date: ['CoreService', function (CoreService) {
                        return new Date(CoreService.getStorage('activeScheduleDate'));
                    }],
                    dashboard: function () {
                        return {
                            critical: 0,
                            testNotPerformed: 0,
                            unassignedResult: 0,
                            unsignedOrdersByDoctor: 0,
                            unsignedOrders: 0,
                            finalResult: 0,
                            partialResult: 0,
                            resultNotReceived: -1,
                            missingInfo: 0,
                            invoice: 0,

                            printedBarcodes: 0,
                            unPrintedBarcodes: 0,
                            printedWaterLabel: -1,
                            unPrintedWaterLabel: -1,

                            hdPatients: 0,
                            hdPatientsPer: 0,
                            pdPatients: 0,
                            pdPatientsPer: 0,
                            patients: 0,
                            machines: 0,

                            sentPatientsBarcodes: 0,
                            unsendPatientsBarcodes: 0,
                            sentEnvBarcodes: 0,
                            unsendEnvBarcodes: 0,
                            unsendBarcodes: 0,
                            sentKinetics: 0,
                            unsendKinetics: 0,
                            missingInfoTotal: 0,
                            patientsTotal: 0,
                            machinesTotal: 0,
                            corporationsTotal: 0,
                            clinicsTotal: 0
                        }
                    },
                    hasPrinter: ['DYMO', function (DYMO) {
                        return DYMO.loadPrinters();
                    }],
                },
            })
            .state('dashboard-env', {
                parent: 'entity',
                url: '/environmental',
                ncyBreadcrumb: {
                    label: 'Home',
                    parent: 'app'
                },
                data: {
                    pageTitle: 'Dialysis',
                    authorities: ['ROLE_ENVIRONMENTAL']
                },
                params: {
                    state: 'dashboard-env'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/dashboard/dashboard-env.html',
                        controller: 'DashboardEnvController',
                        controllerAs: 'vm'
                    },
                    'schedule@dashboard-env': {
                        templateUrl: 'app/entities/dashboard/dashboard-env/all-orders-schedule.html',
                        controller: 'DashboardAllOrdersScheduleController',
                        controllerAs: 'vm'
                    },
                    'machines@dashboard-env': {
                        templateUrl: 'app/entities/dashboard/dashboard-doc/env-order-schedule.html',
                        controller: 'DashboardEnvOrderScheduleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    date: ['$stateParams', function ($stateParams) {
                        return $stateParams.date ? moment($stateParams.date).format("Y/MM/DD") : moment(new Date()).format("Y/MM/DD");
                    }],
                    hasPrinter: ['DYMO', function (DYMO) {
                        return DYMO.loadPrinters();
                    }],
                    dashboard: function () {
                        return {
                            critical: 0,
                            testNotPerformed: 0,
                            unassignedResult: 0,
                            unsignedOrdersByDoctor: 0,
                            unsignedOrders: 0,
                            finalResult: 0,
                            partialResult: 0,
                            resultNotReceived: -1,
                            missingInfo: 0,
                            invoice: 0,

                            printedBarcodes: 0,
                            unPrintedBarcodes: 0,
                            printedWaterLabel: -1,
                            unPrintedWaterLabel: -1,

                            hdPatients: 0,
                            hdPatientsPer: 0,
                            pdPatients: 0,
                            pdPatientsPer: 0,
                            patients: 0,
                            machines: 0
                        }
                    }
                }
            })
            .state('dashboard2', {
                parent: 'entity',
                url: '/dashboard-v2',
                ncyBreadcrumb: {
                    label: ' ',
                    parent: 'app'
                },
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Dialysis'
                },
                params: {
                    state: 'dashboard-doc'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/dashboard/dashboard2.html',
                        controller: 'Dashboard2Controller',
                        controllerAs: 'vm'
                    },
                    'critical-results@dashboard2': {
                        templateUrl: 'app/entities/dashboard/layout/critical-results-top-box.html',
                        controller: 'CriticalResultsTopBoxController',
                        controllerAs: 'vm'
                    },
                    'unsigned-orders@dashboard2': {
                        templateUrl: 'app/entities/dashboard/layout/unsigned-orders-box.html',
                        controller: 'UnsignedOrdersBoxController',
                        controllerAs: 'vm'
                    },
                    'pending-results@dashboard2': {
                        templateUrl: 'app/entities/dashboard/layout/pending-results-top-box.html',
                        controller: 'PendingResultsTopBoxController',
                        controllerAs: 'vm'
                    },
                    'unassigned-results@dashboard2': {
                        templateUrl: 'app/entities/dashboard/layout/unassigned-results-top-box.html',
                        controller: 'UnassignedResultsTopBoxController',
                        controllerAs: 'vm'
                    },
                    'abnormal-patient-results@dashboard2': {
                        templateUrl: 'app/entities/dashboard/layout/patient-result-abnormal.html',
                        controller: 'PatientResultAbnormalController',
                        controllerAs: 'vm'
                    },
                    'abnormal-env-results@dashboard2': {
                        templateUrl: 'app/entities/dashboard/layout/env-result-abnormal.html',
                        controller: 'EnvResultAbnormalController',
                        controllerAs: 'vm'
                    },
                    'patient-order-schedule@dashboard2': {
                        templateUrl: 'app/entities/dashboard/dashboard2/patient-order-schedule2.html',
                        controller: 'DashboardPatientOrderSchedule2Controller',
                        controllerAs: 'vm'
                    },
                    'env-order-schedule@dashboard2': {
                        templateUrl: 'app/entities/dashboard/dashboard2/env-order-schedule2.html',
                        controller: 'DashboardEnvOrderSchedule2Controller',
                        controllerAs: 'vm'
                    },
                    'missing-kinetics@dashboard2': {
                        templateUrl: 'app/entities/dashboard/layout/missing-kinetics-top-box.html',
                        controller: 'MissingKineticsTopBoxController',
                        controllerAs: 'vm'
                    },
                    'missing-pd-adequacy@dashboard2': {
                        templateUrl: 'app/entities/dashboard/layout/missing-pd-adequacy-box.html',
                        controller: 'MissingPDAdequacyBoxController',
                        controllerAs: 'vm'
                    },
                    'lab-notifications-area@dashboard2': {
                        templateUrl: 'app/entities/dashboard/layout/lab-notifications-area.html',
                        controller: 'LabNotificationsAreaController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    clinic: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentClinic();
                    }],
                    activeTab: ['CoreService', function (CoreService) {
                        return CoreService.getStorage('activeScheduleTab');
                    }],
                    date: ['CoreService', function (CoreService) {
                        return new Date(CoreService.getActiveScheduleDate());
                    }],
                    dateEnv: ['CoreService', function (CoreService) {
                        return new Date(CoreService.getActiveScheduleDateEnv());
                    }],
                    openModalCritical: ['CoreService', function (CoreService) {
                        return CoreService.getStorage('openModalCritical');
                    }],
                    showNotifications: ['CoreService', function (CoreService) {
                        return CoreService.getStorage('showNotifications');
                    }],
                    hasPrinter: ['DYMO', function (DYMO) {
                        return DYMO.loadPrinters();
                    }],
                }
            })
            .state('dashboard-doc', {
                parent: 'entity',
                url: '/dashboard',
                ncyBreadcrumb: {
                    label: 'Home',
                    parent: 'app'
                },
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_NURSE', 'ROLE_DOCTOR'],
                    pageTitle: 'Dialysis'
                },
                params: {
                    state: 'dashboard-doc'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/dashboard/dashboard-doc.html',
                        controller: 'DashboardDocController',
                        controllerAs: 'vm'
                    },
                    'schedule@dashboard-doc': {
                        templateUrl: 'app/entities/dashboard/dashboard-doc/all-orders-schedule.html',
                        controller: 'DashboardAllOrdersScheduleController',
                        controllerAs: 'vm'
                    },
                    'patients@dashboard-doc': {
                        templateUrl: 'app/entities/dashboard/dashboard-doc/patient-order-schedule.html',
                        controller: 'DashboardPatientOrderScheduleController',
                        controllerAs: 'vm'
                    },
                    'machines@dashboard-doc': {
                        templateUrl: 'app/entities/dashboard/dashboard-doc/env-order-schedule.html',
                        controller: 'DashboardEnvOrderScheduleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    date: ['CoreService', function (CoreService) {
                        return new Date(CoreService.getStorage('activeScheduleDate'));
                    }],
                    hasPrinter: ['DYMO', function (DYMO) {
                        return DYMO.loadPrinters();
                    }],
                    dashboard: function () {
                        return {
                            critical: 0,
                            testNotPerformed: 0,
                            unassignedResult: 0,
                            unsignedOrdersByDoctor: 0,
                            unsignedOrders: 0,
                            finalResult: 0,
                            partialResult: 0,
                            resultNotReceived: -1,
                            missingInfo: 0,
                            invoice: 0,
                            pendingResult: 0,

                            printedBarcodes: 0,
                            unPrintedBarcodes: 0,
                            printedWaterLabel: -1,
                            unPrintedWaterLabel: -1,

                            hdPatients: 0,
                            hdPatientsPer: 0,
                            pdPatients: 0,
                            pdPatientsPer: 0,
                            patients: 0,
                            machines: 0,
                        }
                    }
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Dashboard', Dashboard);

    Dashboard.$inject = ['$resource'];

    function Dashboard ($resource) {
        var resourceUrl =  'api/dashboard/:id';

        return $resource(resourceUrl, {}, {
            'get': {method: 'GET'},
            'environmental': {url: 'api/dashboard/environmental/:id', method: 'GET'},
            'admin': {method: 'GET', url: 'api/dashboard/admin'},
            'labels': {method: 'GET', url: 'api/dashboard/labels/:id'},
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('CountryState', CountryState);

    CountryState.$inject = ['$resource'];

    function CountryState ($resource) {
        var resourceUrl =  'api/country-states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CorporationDialogController', CorporationDialogController);

    CorporationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Corporation'];

    function CorporationDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Corporation) {
        var vm = this;

        vm.corporation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.corporation.id !== null) {
                Corporation.update(vm.corporation, onSaveSuccess, onSaveError);
            } else {
                Corporation.save(vm.corporation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('dialysisApp:corporationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CorporationDetailController', CorporationDetailController);

    CorporationDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'corporation'];

    function CorporationDetailController($scope, $rootScope, previousState, corporation) {
        var vm = this;

        vm.corporation = corporation;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:corporationUpdate', function(event, result) {
            vm.corporation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CorporationDeleteController',CorporationDeleteController);

    CorporationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Corporation'];

    function CorporationDeleteController($uibModalInstance, entity, Corporation) {
        var vm = this;

        vm.corporation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Corporation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('corporation', {
            parent: 'entity',
            url: '/corporation',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Corporations'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/corporation/corporations.html',
                    controller: 'CorporationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('corporation-detail', {
            parent: 'entity',
            url: '/corporation/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Corporation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/corporation/corporation-detail.html',
                    controller: 'CorporationDetailController',
                    controllerAs: 'vm'
                },
                'clinics@corporation-detail': {
                    templateUrl: 'app/entities/corporation/clinics.html',
                    controller: 'ClinicController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                corporation: ['$stateParams', 'Corporation', function($stateParams, Corporation) {
                    return Corporation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'corporation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('corporation-detail.edit', {
            parent: 'corporation-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/corporation/corporation-dialog.html',
                    controller: 'CorporationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Corporation', function(Corporation) {
                            return Corporation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('corporation.new', {
            parent: 'corporation',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/corporation/corporation-dialog.html',
                    controller: 'CorporationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('corporation', null, { reload: 'corporation' });
                }, function() {
                    $state.go('corporation');
                });
            }]
        })
        .state('corporation.edit', {
            parent: 'corporation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/corporation/corporation-dialog.html',
                    controller: 'CorporationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Corporation', function(Corporation) {
                            return Corporation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('corporation', null, { reload: 'corporation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('corporation.delete', {
            parent: 'corporation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/corporation/corporation-delete-dialog.html',
                    controller: 'CorporationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Corporation', function(Corporation) {
                            return Corporation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('corporation', null, { reload: 'corporation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Corporation', Corporation);

    Corporation.$inject = ['$resource'];

    function Corporation ($resource) {
        var resourceUrl =  'api/corporations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CorporationSearch', CorporationSearch);

    CorporationSearch.$inject = ['$resource'];

    function CorporationSearch($resource) {
        var resourceUrl =  'api/_search/corporations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CorporationController', CorporationController);

    CorporationController.$inject = ['$scope', '$state', 'Corporation', 'CorporationSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function CorporationController ($scope, $state, Corporation, CorporationSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.corporations = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  Corporation.query(function(result) {
                  vm.corporations = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.corporations, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            Corporation.query(function(result) {
                vm.corporations = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompositeDialogController', CompositeDialogController);

    CompositeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Composite',
        'Compendium', 'BillingFrequency', 'CoreService'];

    function CompositeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Composite,
                                        Compendium, BillingFrequency, CoreService) {
        var vm = this;

        vm.composite = entity;
        vm.compendiums = [];
        vm.billingfrequencies = BillingFrequency.query();

        vm.clear = clear;
        vm.save = save;
        vm.onChangeDialysisModality = onChangeDialysisModality;

        if (vm.composite.id) {
            Compendium.byClinicCompositeDif({
                id: vm.composite.clinic.id, modality: vm.composite.dialysisModality
            }, function (result) {
                vm.compendiums = result;
                vm.compendiums.push(vm.composite.compendium);
            });
        } else {
            vm.composite.clinic = CoreService.getCurrentClinic();
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.composite.id !== null) {
                Composite.update(vm.composite, onSaveSuccess, onSaveError);
            } else {
                Composite.save(vm.composite, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:compositeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function onChangeDialysisModality() {
            vm.composite.compendium = null;

            vm.compendiums = [];

            Compendium.byClinicCompositeDif({
                id: vm.composite.clinic.id, modality: vm.composite.dialysisModality
            }, function (result) {
                vm.compendiums = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompositeDetailController', CompositeDetailController);

    CompositeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Composite', 'Compendium', 'BillingFrequency', 'Clinic'];

    function CompositeDetailController($scope, $rootScope, $stateParams, previousState, entity, Composite, Compendium, BillingFrequency, Clinic) {
        var vm = this;

        vm.composite = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:compositeUpdate', function(event, result) {
            vm.composite = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompositeDeleteController',CompositeDeleteController);

    CompositeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Composite'];

    function CompositeDeleteController($uibModalInstance, entity, Composite) {
        var vm = this;

        vm.composite = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Composite.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('composite', {
            parent: 'entity',
            url: '/composite',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Composites'
            },
            ncyBreadcrumb: {
                label: 'Composite',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/composite/composites.html',
                    controller: 'CompositeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('composite-detail', {
            parent: 'entity',
            url: '/composite/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Composite'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/composite/composite-detail.html',
                    controller: 'CompositeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Composite', function($stateParams, Composite) {
                    return Composite.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'composite',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('composite-detail.edit', {
            parent: 'composite-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/composite/composite-dialog.html',
                    controller: 'CompositeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Composite', function(Composite) {
                            return Composite.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('composite.new', {
            parent: 'composite',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/composite/composite-dialog.html',
                    controller: 'CompositeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dialysisModality: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('composite', null, { reload: 'composite' });
                }, function() {
                    $state.go('composite');
                });
            }]
        })
        .state('composite.edit', {
            parent: 'composite',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/composite/composite-dialog.html',
                    controller: 'CompositeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Composite', function(Composite) {
                            return Composite.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('composite', null, { reload: 'composite' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('composite.delete', {
            parent: 'composite',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/composite/composite-delete-dialog.html',
                    controller: 'CompositeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Composite', function(Composite) {
                            return Composite.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('composite', null, { reload: 'composite' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Composite', Composite);

    Composite.$inject = ['$resource'];

    function Composite ($resource) {
        var resourceUrl =  'api/composites/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CompositeSearch', CompositeSearch);

    CompositeSearch.$inject = ['$resource'];

    function CompositeSearch($resource) {
        var resourceUrl =  'api/_search/composites/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompositeController', CompositeController);

    CompositeController.$inject = ['$scope', '$state', 'Composite', 'CompositeSearch', 'CoreService', 'DTOptionsBuilder',
        'DTColumnBuilder', '$q', 'GUIUtils'];

    function CompositeController ($scope, $state, Composite, CompositeSearch, CoreService, DTOptionsBuilder,
                                  DTColumnBuilder, $q, GUIUtils) {
        var vm = this;

        vm.composites = [];
        vm.clinic = CoreService.getCurrentClinic();

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                CompositeSearch.query({
                    query: {
                        bool: {
                            must: [
                                {term: {"clinic.id": vm.clinic.id}},
                                {term: {"delStatus": false}}
                            ]
                        }
                    }
                }, function (result) {
                    vm.composites = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.bundles, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('compendium.code').withTitle('Compendium Code'),
            DTColumnBuilder.newColumn('compendium.description').withTitle('Description'),
            DTColumnBuilder.newColumn('billingFrequency.name').withTitle('Frequency'),
            DTColumnBuilder.newColumn('billingFrequency.days').withTitle('Days'),
            DTColumnBuilder.newColumn(null).withTitle('Modality').renderWith(function (data, type, full) {
                return data.dialysisModality ? data.dialysisModality.replace("_", " ") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumSpecialPriceDialogController', CompendiumSpecialPriceDialogController);

    CompendiumSpecialPriceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'entity', 'CompendiumSpecialPrice', 'Clinic', 'Compendium', 'CoreService'];

    function CompendiumSpecialPriceDialogController ($timeout, $scope, $stateParams, $uibModalInstance,
                                                     entity, CompendiumSpecialPrice, Clinic, Compendium, CoreService) {
        var vm = this;

        vm.compendiumSpecialPrice = entity;

        if (vm.compendiumSpecialPrice.id) {
            Compendium.byClinicSpecialPriceDif({id: vm.compendiumSpecialPrice.clinic.id}, function (results) {
                vm.compendiums = results;
                vm.compendiums.push(vm.compendiumSpecialPrice.compendium);
            });
        } else {
            vm.compendiumSpecialPrice.clinic = CoreService.getCurrentClinic();
            vm.compendiums = Compendium.byClinicSpecialPriceDif({id: vm.compendiumSpecialPrice.clinic.id});
        }

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.compendiumSpecialPrice.id !== null) {
                CompendiumSpecialPrice.update(vm.compendiumSpecialPrice, onSaveSuccess, onSaveError);
            } else {
                CompendiumSpecialPrice.save(vm.compendiumSpecialPrice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:compendiumSpecialPriceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumSpecialPriceDetailController', CompendiumSpecialPriceDetailController);

    CompendiumSpecialPriceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CompendiumSpecialPrice', 'Clinic', 'Compendium', 'Employee'];

    function CompendiumSpecialPriceDetailController($scope, $rootScope, $stateParams, previousState, entity, CompendiumSpecialPrice, Clinic, Compendium, Employee) {
        var vm = this;

        vm.compendiumSpecialPrice = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:compendiumSpecialPriceUpdate', function(event, result) {
            vm.compendiumSpecialPrice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumSpecialPriceDeleteController',CompendiumSpecialPriceDeleteController);

    CompendiumSpecialPriceDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompendiumSpecialPrice'];

    function CompendiumSpecialPriceDeleteController($uibModalInstance, entity, CompendiumSpecialPrice) {
        var vm = this;

        vm.compendiumSpecialPrice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CompendiumSpecialPrice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('compendium-special-price', {
            parent: 'entity',
            url: '/compendium-special-price',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Compendium Special Prices'
            },
            ncyBreadcrumb: {
                label: 'Compendium Special Prices',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/compendium-special-price/compendium-special-prices.html',
                    controller: 'CompendiumSpecialPriceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('compendium-special-price-detail', {
            parent: 'entity',
            url: '/compendium-special-price/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'CompendiumSpecialPrice'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/compendium-special-price/compendium-special-price-detail.html',
                    controller: 'CompendiumSpecialPriceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CompendiumSpecialPrice', function($stateParams, CompendiumSpecialPrice) {
                    return CompendiumSpecialPrice.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'compendium-special-price',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('compendium-special-price-detail.edit', {
            parent: 'compendium-special-price-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-special-price/compendium-special-price-dialog.html',
                    controller: 'CompendiumSpecialPriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CompendiumSpecialPrice', function(CompendiumSpecialPrice) {
                            return CompendiumSpecialPrice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compendium-special-price.new', {
            parent: 'compendium-special-price',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-special-price/compendium-special-price-dialog.html',
                    controller: 'CompendiumSpecialPriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                price: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('compendium-special-price', null, { reload: 'compendium-special-price' });
                }, function() {
                    $state.go('compendium-special-price');
                });
            }]
        })
        .state('compendium-special-price.edit', {
            parent: 'compendium-special-price',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-special-price/compendium-special-price-dialog.html',
                    controller: 'CompendiumSpecialPriceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CompendiumSpecialPrice', function(CompendiumSpecialPrice) {
                            return CompendiumSpecialPrice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('compendium-special-price', null, { reload: 'compendium-special-price' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compendium-special-price.delete', {
            parent: 'compendium-special-price',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-special-price/compendium-special-price-delete-dialog.html',
                    controller: 'CompendiumSpecialPriceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CompendiumSpecialPrice', function(CompendiumSpecialPrice) {
                            return CompendiumSpecialPrice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('compendium-special-price', null, { reload: 'compendium-special-price' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('CompendiumSpecialPrice', CompendiumSpecialPrice);

    CompendiumSpecialPrice.$inject = ['$resource'];

    function CompendiumSpecialPrice ($resource) {
        var resourceUrl =  'api/compendium-special-prices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CompendiumSpecialPriceSearch', CompendiumSpecialPriceSearch);

    CompendiumSpecialPriceSearch.$inject = ['$resource'];

    function CompendiumSpecialPriceSearch($resource) {
        var resourceUrl =  'api/_search/compendium-special-prices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumSpecialPriceController', CompendiumSpecialPriceController);

    CompendiumSpecialPriceController.$inject = ['$scope', '$state', 'CompendiumSpecialPrice', 'GUIUtils',
        'CompendiumSpecialPriceSearch', 'CoreService', 'DTOptionsBuilder', 'DTColumnBuilder', '$q'];

    function CompendiumSpecialPriceController ($scope, $state, CompendiumSpecialPrice, GUIUtils,
                                               CompendiumSpecialPriceSearch, CoreService, DTOptionsBuilder, DTColumnBuilder, $q) {
        var vm = this;

        vm.compendiumSpecialPrices = [];
        vm.clinic = CoreService.getCurrentClinic();
        vm.dtInstance = {};

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                CompendiumSpecialPriceSearch.query({
                    query: {
                        bool: {
                            must: [
                                {term: {"clinic.id": vm.clinic.id}},
                                {term: {"delStatus": false}}
                            ]
                        }
                    }
                }, function (result) {
                    vm.compendiumSpecialPrices = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.compendiumSpecialPrices, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('compendium.code').withTitle('Code'),
            DTColumnBuilder.newColumn('compendium.description').withTitle('Description'),
            DTColumnBuilder.newColumn(null).withTitle('Price').renderWith(function (data, type, full) {
                return "$" + data.price;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumReportGroupDialogController', CompendiumReportGroupDialogController);

    CompendiumReportGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompendiumReportGroup'];

    function CompendiumReportGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CompendiumReportGroup) {
        var vm = this;

        vm.compendiumReportGroup = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.compendiumReportGroup.id !== null) {
                CompendiumReportGroup.update(vm.compendiumReportGroup, onSaveSuccess, onSaveError);
            } else {
                CompendiumReportGroup.save(vm.compendiumReportGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:compendiumReportGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumReportGroupDetailController', CompendiumReportGroupDetailController);

    CompendiumReportGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CompendiumReportGroup', 'Compendium'];

    function CompendiumReportGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, CompendiumReportGroup, Compendium) {
        var vm = this;

        vm.compendiumReportGroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:compendiumReportGroupUpdate', function(event, result) {
            vm.compendiumReportGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumReportGroupDeleteController',CompendiumReportGroupDeleteController);

    CompendiumReportGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'CompendiumReportGroup'];

    function CompendiumReportGroupDeleteController($uibModalInstance, entity, CompendiumReportGroup) {
        var vm = this;

        vm.compendiumReportGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CompendiumReportGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('compendium-report-group', {
            parent: 'entity',
            url: '/compendium-report-group',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'CompendiumReportGroups'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/compendium-report-group/compendium-report-groups.html',
                    controller: 'CompendiumReportGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('compendium-report-group-detail', {
            parent: 'entity',
            url: '/compendium-report-group/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'CompendiumReportGroup'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/compendium-report-group/compendium-report-group-detail.html',
                    controller: 'CompendiumReportGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CompendiumReportGroup', function($stateParams, CompendiumReportGroup) {
                    return CompendiumReportGroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'compendium-report-group',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('compendium-report-group-detail.edit', {
            parent: 'compendium-report-group-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-report-group/compendium-report-group-dialog.html',
                    controller: 'CompendiumReportGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['CompendiumReportGroup', function(CompendiumReportGroup) {
                            return CompendiumReportGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compendium-report-group.new', {
            parent: 'compendium-report-group',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-report-group/compendium-report-group-dialog.html',
                    controller: 'CompendiumReportGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('compendium-report-group', null, { reload: 'compendium-report-group' });
                }, function() {
                    $state.go('compendium-report-group');
                });
            }]
        })
        .state('compendium-report-group.edit', {
            parent: 'compendium-report-group',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-report-group/compendium-report-group-dialog.html',
                    controller: 'CompendiumReportGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['CompendiumReportGroup', function(CompendiumReportGroup) {
                            return CompendiumReportGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('compendium-report-group', null, { reload: 'compendium-report-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compendium-report-group.delete', {
            parent: 'compendium-report-group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-report-group/compendium-report-group-delete-dialog.html',
                    controller: 'CompendiumReportGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CompendiumReportGroup', function(CompendiumReportGroup) {
                            return CompendiumReportGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('compendium-report-group', null, { reload: 'compendium-report-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('CompendiumReportGroup', CompendiumReportGroup);

    CompendiumReportGroup.$inject = ['$resource'];

    function CompendiumReportGroup ($resource) {
        var resourceUrl =  'api/compendium-report-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CompendiumReportGroupSearch', CompendiumReportGroupSearch);

    CompendiumReportGroupSearch.$inject = ['$resource'];

    function CompendiumReportGroupSearch($resource) {
        var resourceUrl =  'api/_search/compendium-report-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumReportGroupController', CompendiumReportGroupController);

    CompendiumReportGroupController.$inject = ['$scope', '$state', 'CompendiumReportGroup', 'CompendiumReportGroupSearch', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function CompendiumReportGroupController($scope, $state, CompendiumReportGroup, CompendiumReportGroupSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile) {
        var vm = this;
        vm.title = 'Compendium Report Groups';
        vm.entityClassHumanized = 'Compendium Report Group';
        vm.entityStateName = 'compendium-report-group';

        vm.compendiumReportGroups = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                CompendiumReportGroup.query(function (result) {
                    vm.compendiumReportGroups = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.compendiumReportGroups, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function loadAll() {
            CompendiumReportGroup.query(function (result) {
                vm.compendiumReportGroups = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumListDialogController', CompendiumListDialogController);

    CompendiumListDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'compendiums'];

    function CompendiumListDialogController ($timeout, $scope, $stateParams, $uibModalInstance, compendiums) {
        var vm = this;

        vm.compendiums = compendiums;
        vm.clear = clear;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumDialogController', CompendiumDialogController);

    CompendiumDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity',
        'Compendium', 'Tube', 'RptMetadata', 'CompendiumReportGroup'];

    function CompendiumDialogController($timeout, $scope, $uibModalInstance, entity,
                                        Compendium, Tube, RptMetadata, CompendiumReportGroup) {
        var vm = this;

        vm.compendium = entity;
        vm.compendiums =  Compendium.query();
        vm.tubes = Tube.query();

        if (vm.compendium.intCode) {
            vm.compendium.intCode = RptMetadata.getByIntCode({intCode: vm.compendium.intCode});
        }

        vm.rptMetadatas = RptMetadata.queryDiff();
        vm.compendiumReportGroups = CompendiumReportGroup.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.clear = clear;
        vm.save = save;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            vm.compendium.intCode = vm.compendium.intCode ? vm.compendium.intCode.intCode : null;
            if (vm.compendium.id !== null) {
                Compendium.update(vm.compendium, onSaveSuccess, onSaveError);
            } else {
                Compendium.save(vm.compendium, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('dialysisApp:compendiumUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumDetailController', CompendiumDetailController);

    CompendiumDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Compendium', 'PatientOrderTest'];

    function CompendiumDetailController($scope, $rootScope, $stateParams, previousState, entity, Compendium, PatientOrderTest) {
        var vm = this;

        vm.compendium = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:compendiumUpdate', function(event, result) {
            vm.compendium = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumDeleteController',CompendiumDeleteController);

    CompendiumDeleteController.$inject = ['$uibModalInstance', 'entity', 'Compendium'];

    function CompendiumDeleteController($uibModalInstance, entity, Compendium) {
        var vm = this;

        vm.compendium = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Compendium.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('compendium', {
            parent: 'entity',
            url: '/compendium',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Compendiums'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/compendium/compendiums.html',
                    controller: 'CompendiumController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('compendium-detail.edit', {
            parent: 'compendium-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium/compendium-dialog.html',
                    controller: 'CompendiumDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Compendium', function(Compendium) {
                            return Compendium.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compendium.new', {
            parent: 'compendium',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium/compendium-dialog.html',
                    controller: 'CompendiumDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                description: null,
                                wGroup: null,
                                specimen: null,
                                units: null,
                                id: null,
                                cutOff: null,
                                abbr: null,
                                compendiumReportGroup: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('compendium', null, { reload: 'compendium' });
                }, function() {
                    $state.go('compendium');
                });
            }]
        })
        .state('compendium.edit', {
            parent: 'compendium',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium/compendium-dialog.html',
                    controller: 'CompendiumDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Compendium', function(Compendium) {
                            return Compendium.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('compendium', null, { reload: 'compendium' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('compendium.delete', {
            parent: 'compendium',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium/compendium-delete-dialog.html',
                    controller: 'CompendiumDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Compendium', function(Compendium) {
                            return Compendium.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('compendium', null, { reload: 'compendium' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Compendium', Compendium);

    Compendium.$inject = ['$resource'];

    function Compendium($resource) {
        var resourceUrl = 'api/compendiums/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'by_patient_order': {url: 'api/compendiums/by-patient-order/:id/:date', method: 'GET', isArray: true},
            'by_env_order': {url: 'api/compendiums/by-env-order/:id/:date', method: 'GET', isArray: true},
            'by_patient_without_barcode': {url: 'api/compendiums/by-patient-without-barcode/:patient/:date/:physician', method: 'GET', isArray: true},
            'by_patient_with_barcode': {url: 'api/compendiums/by-patient-with-barcode/:barcode', method: 'GET', isArray: true},
            'by_clinic_result_range_dif': {url: 'api/compendiums/by-clinic-result-range-dif/:id', method: 'GET', isArray: true},
            'check': {url: 'api/compendiums/check', method: 'POST', isArray: false},
            'byClinicSpecialPriceDif': {url: 'api/compendiums/by-clinic-special-price-dif/:id', method: 'GET', isArray: true},
            'byClinicBundleDif': {url: 'api/compendiums/by-clinic-bundle-dif/:id/:modality', method: 'GET', isArray: true},
            'byClinicCompositeDif': {url: 'api/compendiums/by-clinic-composite-dif/:id/:modality', method: 'GET', isArray: true},
            'byRptCompendiumDefaultMessageDif': {url: 'api/compendiums/by-rpt-compendium-default-message-dif/:id/:modality', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CompendiumSearch', CompendiumSearch);

    CompendiumSearch.$inject = ['$resource'];

    function CompendiumSearch($resource) {
        var resourceUrl =  'api/_search/compendiums/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompendiumController', CompendiumController);

    CompendiumController.$inject = ['$scope', '$state', 'Compendium', 'CompendiumSearch', '$q',
        'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function CompendiumController($scope, $state, Compendium, CompendiumSearch, $q,
                                  DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter) {
        var vm = this;

        vm.compendiums = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                Compendium.query(function (result) {
                    vm.compendiums = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.compendiums, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('code').withTitle('Code'),
            DTColumnBuilder.newColumn('intCode').withTitle('Internal Code'),
            DTColumnBuilder.newColumn('description').withTitle('Description'),
            DTColumnBuilder.newColumn('abbr').withTitle('Abbr'),
            DTColumnBuilder.newColumn('wGroup').withTitle('WGroup'),
            DTColumnBuilder.newColumn('specimen').withTitle('Specimen'),
            DTColumnBuilder.newColumn('units').withTitle('Units'),
            DTColumnBuilder.newColumn(null).withTitle('Rep Group').renderWith(function (data, type, full) {
                return data.compendiumReportGroup ? data.compendiumReportGroup.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()

                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientBarcodeDetailController', PatientBarcodeDetailController);

    PatientBarcodeDetailController.$inject = ['patientResult', 'barcode', 'moment', '$compile', '$scope', 'GUIUtils',
        '$q', '$uibModal', 'PatientOrderTest', 'DTOptionsBuilder', 'DTColumnBuilder',
        'patient'];

    function PatientBarcodeDetailController(patientResult, barcode, moment, $compile, $scope, GUIUtils,
                                            $q, $uibModal, PatientOrderTest, DTOptionsBuilder, DTColumnBuilder,
                                            patient) {
        var vm = this;

        vm.barcode = barcode;
        vm.patient = patient;
        vm.patientResult = patientResult;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            PatientOrderTest.findAllByBarcode({barcode: vm.barcode.id}, function (result) {
                vm.patientOrderTests = result;
                defer.resolve(result);
            });

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')
            .withOption('paging', false).withOption('aaSorting', []).withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Test').renderWith(function (data, type, full) {
                return data.compendium.code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.compendium.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Frequency').renderWith(function (data, type, full) {
                return data.orderFrequency.name;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Order').renderWith(function (data, type, full) {
                return showOrder(data);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Diagnosis (ICD10)').renderWith(function (data, type, full, meta) {
                return data.diagnoses != null && data.diagnoses.length > 1 ? data.diagnoses[0].icd10Code + showICD10Html(meta.row) : data.diagnoses[0].icd10Code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Renal').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.renal);//colorHtml(data.renal);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.staringDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format("MM/DD/YYYY");
            })
        ];

        function showICD10Html(row) {
            return '&nbsp;&nbsp;<a class="btn-sm btn-info" ng-click="vm.showICD10(' + row + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        }

        vm.showICD10 = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/diagnosis/diagnosis-dialog.html',
                controller: 'DiagnosisDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: vm.patientOrderTests[index]
                }
            });
        }

        function showOrder(row) {
            return '<a ui-sref="' + "patient-order-view({id:" + vm.patient.id + ", oid:" + row.patientOrderId + "})" + '">' + row.patientOrderId + '</a>';
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MachineBarcodeDetailController', MachineBarcodeDetailController);

    MachineBarcodeDetailController.$inject = ['moment', 'machine', 'EnvTest', 'barcode', 'envResult',
        '$compile', '$scope', '$q', '$uibModal', 'DTOptionsBuilder', 'DTColumnBuilder'
    ];

    function MachineBarcodeDetailController(moment, machine, EnvTest, barcode, envResult,
                                              $compile, $scope, $q, $uibModal, DTOptionsBuilder, DTColumnBuilder) {
        var vm = this;

        vm.machine = machine;
        vm.barcode = barcode;
        vm.envResult = envResult;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            EnvTest.findAllByBarcode({barcode: vm.barcode.id}, function(result) {
                defer.resolve(result);
            });

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')
            .withOption('paging', false).withOption('aaSorting', []).withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Test').renderWith(function (data, type, full) {
                return data.compendium.code;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.compendium.description;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Frequency').renderWith(function (data, type, full) {
                return data.orderFrequency.name;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.staringDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return data.endDate? moment(data.endDate).format("MM/DD/YYYY") : moment(data.staringDate).format("MM/DD/YYYY");
            })
        ];

        function showICD10Html(row) {
            return '&nbsp;&nbsp;<a class="btn-sm btn-info" ng-click="vm.showICD10(' + row + ')">' +
                '   <i class="fa fa-list-ol"></i></a>';
        }

        vm.showICD10 = function (index) {
            $uibModal.open({
                templateUrl: 'app/entities/diagnosis/diagnosis-dialog.html',
                controller: 'DiagnosisDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: vm.patientOrderTests[index]
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientBarcodeDetail2Controller', PatientBarcodeDetail2Controller);

    PatientBarcodeDetail2Controller.$inject = ['barcode', 'moment', '$compile', '$scope', 'GUIUtils',
        '$q', '$uibModal', 'PatientOrderTest', 'DTOptionsBuilder', 'DTColumnBuilder',
        'patient', '$uibModalInstance', 'patientOrder', 'lodash', 'Diagnosis', 'dialogs', 'PatientOrderItem'];

    function PatientBarcodeDetail2Controller(barcode, moment, $compile, $scope, GUIUtils,
                                             $q, $uibModal, PatientOrderTest, DTOptionsBuilder, DTColumnBuilder,
                                             patient, $uibModalInstance, patientOrder, _, Diagnosis, $dialogs, PatientOrderItem) {
        var vm = this;
        vm.barcode = barcode;
        vm.patient = patient;
        vm.patientOrder = patientOrder;
        vm.diagnosis = [];

        vm.clear = clear;
        vm.showCancelTestDialog = showCancelTestDialog;
        vm.loadAll = loadAll;
        vm.showDescription = showDescription;

        loadAll();

        function loadAll() {
            if (vm.barcode) {
                PatientOrderTest.findAllByBarcode2({barcode: vm.barcode.id}, function (result) {
                    vm.patientOrderTests = result;
                });
            } else {
                PatientOrderTest.findAllWithoutBarcode({
                    patientId: vm.patient.id,
                    date: vm.patientOrder.scheduleDate,
                    physicianId: vm.patientOrder.physicianId
                }, function (result) {
                    vm.patientOrderTests = result;
                });
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function showDescription($event, testId) {
            Diagnosis.byPatientOrderTest({id: testId}, function (result) {
                vm.diagnosis[testId] = result;
                var t = angular.element($event.currentTarget);
                t.parent().parent().toggleClass('hideDescription');
            });
        };

        function showCancelTestDialog(item) {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to Cancel Test?', {size: 'md'});
            dlg.result.then(function (btn) {
                PatientOrderItem.cancel({id: item}, function () {
                    loadAll();
                });
            }, function () {
                item.canceled = false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MachineBarcodeDetail2Controller', MachineBarcodeDetail2Controller);

    MachineBarcodeDetail2Controller.$inject = ['moment', 'machine', 'EnvTest', 'barcode', '$compile', '$scope', '$q', '$uibModal',
        'DTOptionsBuilder', 'DTColumnBuilder', '$uibModalInstance'];

    function MachineBarcodeDetail2Controller(moment, machine, EnvTest, barcode, $compile, $scope, $q, $uibModal,
                                             DTOptionsBuilder, DTColumnBuilder, $uibModalInstance) {
        var vm = this;
        vm.machine = machine;
        vm.barcode = barcode;
        vm.clear = clear;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (vm.barcode) {
                EnvTest.findAllByBarcode2({barcode: vm.barcode.id}, function (result) {
                    defer.resolve(result);
                });
            }
            else {
                EnvTest.findAllWithoutBarcode({id: vm.machine.id, date: vm.machine.scheduleDate, envStatus: vm.machine.status}, function(result) {
                    defer.resolve(result);
                });
            }

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')
            .withOption('paging', false).withOption('aaSorting', []).withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

            vm.dtColumns = [
                DTColumnBuilder.newColumn(null).withTitle('Test').renderWith(function (data, type, full) {
                    return data.code;
                }),
                DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                    return data.description;
                }),
                DTColumnBuilder.newColumn(null).withTitle('Frequency').renderWith(function (data, type, full) {
                    return data.frequencyName;
                }),
                DTColumnBuilder.newColumn('tplId').withTitle('Template Id')
            ];

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('clinic-schedule-pdetail-barcode', {
                parent: 'entity',
                url: '/pbarcode/{barcode}',
                ncyBreadcrumb: {
                    label: 'Patient Barcode Detail'
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Schedule Details'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/clinic-schedule-detail/patient-barcode-detail.html',
                        controller: 'PatientBarcodeDetailController',
                        controllerAs: 'vm'
                    },
                    'results@clinic-schedule-pdetail-barcode': {
                        templateUrl: 'app/entities/clinic-schedule-detail/patient-barcode-result-dets.html',
                        controller: 'PatientResultDetController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    patientResult: ['$stateParams', 'PatientResult', function ($stateParams, PatientResult) {
                        return PatientResult.byBarcode({barcode: $stateParams.barcode});
                    }],
                    barcode: ['$stateParams', 'PatientBarcode', function ($stateParams, PatientBarcode) {
                        return PatientBarcode.get({barcode: $stateParams.barcode}).$promise;
                    }],
                    patient: ['Patient', '$stateParams', function (Patient, $stateParams) {
                        return Patient.byBarcode({barcode: $stateParams.barcode}).$promise;
                    }]
                }
            })
            .state('clinic-schedule-edetail-barcode', {
                parent: 'entity',
                url: '/ebarcode/{barcode}',
                ncyBreadcrumb: {
                    label: 'Machine Barcode Detail'
                },
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Schedule Details'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/clinic-schedule-detail/machine-barcode-detail.html',
                        controller: 'MachineBarcodeDetailController',
                        controllerAs: 'vm'
                    },
                    'results@clinic-schedule-edetail-barcode': {
                        templateUrl: 'app/entities/clinic-schedule-detail/patient-barcode-result-dets.html',
                        controller: 'EnvResultDetController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    envResult: ['$stateParams', 'EnvResult', function ($stateParams, EnvResult) {
                        return EnvResult.byBarcode({barcode: $stateParams.barcode});
                    }],
                    barcode: ['$stateParams', 'MachineBarcode', function ($stateParams, MachineBarcode) {
                        return MachineBarcode.get({barcode: $stateParams.barcode}).$promise;
                    }],
                    machine: ['Machine', '$stateParams', function (Machine, $stateParams) {
                        return Machine.byBarcode({barcode: $stateParams.barcode}).$promise;
                    }]
                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ClinicAdminViewController', ClinicAdminViewController);

    ClinicAdminViewController.$inject = ['$uibModal'];

    function ClinicAdminViewController($uibModal) {
        var vm = this;

        vm.title = 'Clinic Admin View';
        vm.entityClassHumanized = 'Clinic Admin View';
        vm.entityStateName = 'clinic-admin-view';
        vm.del = del;
        vm.cancelWizard = cancelWizard;

        vm.secondBilling = false;
        vm.companyBilling = false;

        vm.toggleSecondBilling = toggleSecondBilling;
        vm.toggleCompanyBilling = toggleCompanyBilling;

        function toggleSecondBilling() {
            if (vm.secondBilling) {
                // Clear all associated models ...
            }
            vm.secondBilling = !vm.secondBilling;
        }

        function toggleCompanyBilling() {
            if (vm.companyBilling) {
                // Clear all associated models ...
            }
            vm.companyBilling = !vm.companyBilling;
        }

        function del() {
            $uibModal.open({
                templateUrl: 'app/entities/clinic/dashboard2/clinic-admin-delete-dialog.html',
                controller: 'ClinicAdminDeleteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {

                }
            }).result.then(function () {

            }, function () {

            });
        }

        function cancelWizard() {
            $uibModal.open({
                templateUrl: 'app/entities/clinic/dashboard2/clinic-admin-cancel-wizard-dialog.html',
                controller: 'ClinicAdminCancelWizardDialog',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {

                }
            }).result.then(function () {
                //apply
            }, function (result) {
                //cancel
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ClinicAdminDeleteDialogController', ClinicAdminDeleteDialogController);

    ClinicAdminDeleteDialogController.$inject = ['$uibModalInstance'];

    function ClinicAdminDeleteDialogController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ClinicAdminCancelWizardDialog', ClinicAdminCancelWizardDialog);

    ClinicAdminCancelWizardDialog.$inject = ['$uibModalInstance'];

    function ClinicAdminCancelWizardDialog($uibModalInstance) {
        var vm = this;

        vm.title = "Cancel Wizard Confirmation";

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ClinicAdminController', ClinicAdminController);

    ClinicAdminController.$inject = ['$scope', '$state', '$compile', '$q', '$filter', 'DTColumnBuilder', 'DTOptionsBuilder', 'ClinicSearch', 'GUIUtils', '$uibModal'];

    function ClinicAdminController($scope, $state, $compile, $q, $filter, DTColumnBuilder, DTOptionsBuilder, ClinicSearch, GUIUtils, $uibModal) {
        var vm = this;

        vm.title = 'Clinic Admin';
        vm.entityClassHumanized = 'Clinic Admin';
        vm.entityStateName = 'clinic-admin';

        vm.search = search;
        vm.del = del;

        vm.clinics = [];
        vm.dtInstance = {};
        vm.searchQuery = "";

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                ClinicSearch.query({
                    query: {
                        bool: {
                            must: [
                                {term: {"delStatus": false}}
                            ]
                        }
                    }
                }, function (result) {
                    vm.clinics = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.clinics, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[0, 'desc'], [1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn('account').withTitle('Account ID'),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return data.startDate ? moment(data.startDate).format($scope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn('phone').withTitle('Phone'),
            DTColumnBuilder.newColumn('fieldServiceRep').withTitle('Field Service Rep.'),
            DTColumnBuilder.newColumn('status').withTitle('Status').renderWith(function (data, type, full) {
                return full.status ? "Active" : "Inactive";
            }),
            DTColumnBuilder.newColumn('').withTitle('Actions').withOption('class', 'col').withOption('width', '175px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return toStateLink() + '<a class="dt-btn danger" uib-tooltip="Delete" ng-click="vm.del()"><i class="fa fa-trash" aria-hidden="true"></i></a>';
        }

        function toStateLink() {
            return '<a class="dt-btn warning" ui-sref="clinic-admin-view" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function del() {
            $uibModal.open({
                templateUrl: 'app/entities/clinic/dashboard2/clinic-admin-delete-dialog.html',
                controller: 'ClinicAdminDeleteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {

                }
            }).result.then(function () {

            }, function () {

            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ClinicNewController', ClinicNewController);

    ClinicNewController.$inject = ['$scope', '$sessionStorage', 'GUIUtils', 'CoreService', '$state',
        'entity', 'Corporation',
        'Clinic', 'ReportGroup', 'CountryState'];

    function ClinicNewController($scope, $sessionStorage, GUIUtils, CoreService, $state,
                                 entity, Corporation,
                                 Clinic, ReportGroup, CountryState) {
        var vm = this;
        vm.editing = true;
        vm.clinic = entity;
        vm.clinic.drawDays2 = GUIUtils.weekCodeStringToDays(vm.clinic.drawDays);
        vm.clinic.wDrawDays2 = GUIUtils.weekCodeStringToDays(vm.clinic.wDrawDays);
        vm.clinic.quarterlies2 = GUIUtils.monthsCodeStringToMonths(vm.clinic.quarterlies);
        vm.corporations = Corporation.query();

        vm.form = {};
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.days = GUIUtils.getDays();
        vm.months = GUIUtils.getMonths();
        // vm.reportgroups = ReportGroup.query();
        vm.countrystates = CountryState.query();
        vm.changeInterfaceR = changeInterfaceR;
        vm.changeInterfaceG = changeInterfaceG;

        function save() {
            vm.isSaving = true;

            vm.clinic.wDrawDays = GUIUtils.daysToWeekCodeString(vm.clinic.wDrawDays2);
            vm.clinic.drawDays = GUIUtils.daysToWeekCodeString(vm.clinic.drawDays2);
            vm.clinic.quarterlies = GUIUtils.monthsToMonthCodeString(vm.clinic.quarterlies2);

            if (vm.clinic.id !== null) {
                Clinic.update(vm.clinic, onSaveSuccess, onSaveError);
            } else {
                Clinic.save(vm.clinic, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('dialysisApp:clinicNew', result);
            CoreService.setCurrentClinic(result);
            $state.go("clinic", null, {reload: true});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.cancelEditing = cancelEditing;

        function cancelEditing() {
            $state.reload("clinic");
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.contractExp = false;
        vm.datePickerOpenStatus.annualReview = false;
        vm.datePickerOpenStatus.standingEnd = false;
        vm.datePickerOpenStatus.startPickup = false;
        vm.datePickerOpenStatus.endPickup = false;
        vm.timepickerOptions = {
            readonlyInput: false,
            showMeridian: false
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.keepActiveTab = keepActiveTab;

        function keepActiveTab($index) {
            $sessionStorage.activeClinicTab = {id: vm.clinic.id, activeTab: $index};
        }

        function changeInterfaceR() {
            if (vm.clinic.renesanIntegration) {
                vm.clinic.gaiaIntegration = false;
            }
        }

        function changeInterfaceG() {
            if (vm.clinic.gaiaIntegration) {
                vm.clinic.renesanIntegration = false;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ClinicDetailController', ClinicDetailController);

    ClinicDetailController.$inject = ['$scope', '$sessionStorage', 'GUIUtils', '$state',
        'entity', 'Clinic', 'ReportGroup', 'CountryState'];

    function ClinicDetailController($scope, $sessionStorage, GUIUtils, $state,
                                    entity, Clinic, ReportGroup, CountryState) {
        var vm = this;
        vm.clinic = entity;
        vm.clinic.drawDays2 = GUIUtils.weekCodeStringToDays(vm.clinic.drawDays);
        vm.clinic.wDrawDays2 = GUIUtils.weekCodeStringToDays(vm.clinic.wDrawDays);
        vm.clinic.quarterlies2 = GUIUtils.monthsCodeStringToMonths(vm.clinic.quarterlies);

        vm.activeTab = $sessionStorage.activeClinicTab ? ($sessionStorage.activeClinicTab.id == entity.id ?
            $sessionStorage.activeClinicTab.activeTab : 0) : 0;

        vm.form = {};
        vm.editing = false;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.days = GUIUtils.getDays();
        vm.months = GUIUtils.getMonths();

        vm.reportgroups = [];
        if (vm.clinic.reportGroup) {
            vm.reportgroups = [vm.clinic.reportGroup];
        }

        vm.countrystates = CountryState.query();

        function save () {
            vm.isSaving = true;

            vm.clinic.drawDays = GUIUtils.daysToWeekCodeString(vm.clinic.drawDays2);
            vm.clinic.wDrawDays = GUIUtils.daysToWeekCodeString(vm.clinic.wDrawDays2);
            vm.clinic.quarterlies = GUIUtils.monthsToMonthCodeString(vm.clinic.quarterlies2);

            Clinic.update(vm.clinic, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:clinicUpdate', result);
            $state.reload("clinic");
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.changeEditingState = changeEditingState;

        function changeEditingState() {
            vm.editing = !vm.editing;
        }

        vm.cancelEditing = cancelEditing;

        function cancelEditing() {
            $state.reload("clinic");
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.contractExp = false;
        vm.datePickerOpenStatus.annualReview = false;
        vm.datePickerOpenStatus.standingEnd = false;
        vm.datePickerOpenStatus.startPickup = false;
        vm.datePickerOpenStatus.endPickup = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.keepActiveTab = keepActiveTab;

        function keepActiveTab($index) {
            $sessionStorage.activeClinicTab = {id: vm.clinic.id, activeTab: $index};
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ClinicDeleteController',ClinicDeleteController);

    ClinicDeleteController.$inject = ['$uibModalInstance', 'entity', 'Clinic'];

    function ClinicDeleteController($uibModalInstance, entity, Clinic) {
        var vm = this;

        vm.clinic = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Clinic.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('clinics', {
                parent: 'entity',
                url: '/clinics',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Clinics'
                },
                params: {
                    corporation: null
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/clinic/clinics.html',
                        controller: 'ClinicController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    corporation: ['$stateParams', function ($stateParams) {
                        return $stateParams.corporation;
                    }]
                }
            })
            .state('clinic', {
                parent: 'entity',
                url: '/clinic',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Clinic'
                },
                ncyBreadcrumb: {
                    label: 'Clinic',
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/clinic/clinic-detail.html',
                        controller: 'ClinicDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Clinic', 'CoreService', function ($stateParams, Clinic, CoreService) {
                        return Clinic.get({id: CoreService.getCurrentClinic().id}).$promise;
                    }],
                }
            })
            .state('clinic-new', {
                parent: 'entity',
                url: '/clinic-new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                ncyBreadcrumb: {
                    label: 'New Clinic',
                    parent: 'clinic'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/clinic/clinic-new.html',
                        controller: 'ClinicNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            startDate: null,
                            phone: null,
                            fax: null,
                            email: null,
                            address1: null,
                            address2: null,
                            city: null,
                            zipCode: null,
                            billingAddress1: null,
                            billingAddress2: null,
                            billingCity: null,
                            billingZipCode: null,
                            crownWebId: null,
                            website: null,
                            billingContact: null,
                            billingPhone: null,
                            billingEmail: null,
                            medicareId: null,
                            npi: null,
                            contractExp: null,
                            annuals: null,
                            ssn: null,
                            annualReview: null,
                            semiAnnuals: null,
                            drawDays: "0000000",
                            wDrawDays: "0000000",
                            quarterlies: "000000000000",
                            fdod: null,
                            status: false,
                            gaiaIntegration: false,
                            renesanIntegration: false,
                            id: null,
                            emrIntegration: null,
                        };
                    }
                }
            })
            .state('clinic-edit', {
                parent: 'clinic',
                url: '/edit',
                data: {
                    authorities: ['ROLE_SUPERVISOR', 'ROLE_ADMIN'],
                    pageTitle: 'Clinic'
                },
                ncyBreadcrumb: {
                    label: 'Clinic'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/clinic/clinic-new.html',
                        controller: 'ClinicNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Clinic', 'CoreService', function ($stateParams, Clinic, CoreService) {
                        return Clinic.get({id: CoreService.getCurrentClinic().id}).$promise;
                    }]
                }
            })
            .state('clinic-admin', {
                parent: 'entity',
                url: '/clinic-admin',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Clinic Admin'
                },
                ncyBreadcrumb: {
                    label: 'Clinic Admin'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/clinic/dashboard2/clinic-admin.html',
                        controller: 'ClinicAdminController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                }
            })
            .state('clinic-admin-view', {
                parent: 'clinic-admin',
                url: '/clinic-admin-view',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Clinic Admin View'
                },
                ncyBreadcrumb: {
                    label: 'Clinic Admin View'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/clinic/dashboard2/clinic-admin-view.html',
                        controller: 'ClinicAdminViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                }

            })
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Clinic', Clinic);

    Clinic.$inject = ['$resource', 'DateUtils'];

    function Clinic ($resource, DateUtils) {
        var resourceUrl =  'api/clinics/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.contractExp = DateUtils.convertLocalDateFromServer(data.contractExp);
                        data.annualReview = DateUtils.convertLocalDateFromServer(data.annualReview);
                        data.standingEnd = DateUtils.convertLocalDateFromServer(data.standingEnd);
                        data.endPickup = DateUtils.convertDateTimeFromServer(data.endPickup);
                        data.startPickup = DateUtils.convertDateTimeFromServer(data.startPickup);
                    }

                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.contractExp = DateUtils.convertLocalDateToServer(copy.contractExp);
                    copy.annualReview = DateUtils.convertLocalDateToServer(copy.annualReview);
                    copy.standingEnd = DateUtils.convertLocalDateToServer(copy.standingEnd);

                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.contractExp = DateUtils.convertLocalDateToServer(copy.contractExp);
                    copy.annualReview = DateUtils.convertLocalDateToServer(copy.annualReview);
                    copy.standingEnd = DateUtils.convertLocalDateToServer(copy.standingEnd);

                    return angular.toJson(copy);
                }
            },
            'except': {url: "api/clinics/except/:id", method: 'GET', isArray: true},
            'byCorp': {url: "api/clinics/by-corp/:id", method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('ClinicSearch', ClinicSearch);

    ClinicSearch.$inject = ['$resource'];

    function ClinicSearch($resource) {
        var resourceUrl =  'api/_search/clinics/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ClinicController', ClinicController);

    ClinicController.$inject = ['$scope', '$state', 'Clinic', 'CoreService', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'ClinicSearch', '$filter', '$compile', 'corporation'];

    function ClinicController($scope, $state, Clinic, CoreService, $q, DTColumnBuilder, DTOptionsBuilder, ClinicSearch, $filter, $compile, corporation) {
        var vm = this;
        vm.title = 'Clinics';
        vm.entityClassHumanized = 'Clinic';
        vm.entityStateName = 'clinic';
        vm.entityStateName = 'clinic-new';

        vm.clinics = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                if (corporation) {
                    ClinicSearch.query({
                        query: {
                            bool: {
                                must: [
                                    {term: {"corporation.id": corporation.id}},
                                    {term: {"delStatus": false}}
                                ]
                            }
                        }
                    }, function (result) {
                        vm.clinics = result;
                        defer.resolve(result);
                    });
                } else {
                    Clinic.query(function (result) {
                        vm.clinics = result;
                        defer.resolve(result);
                    });
                }
            } else {
                defer.resolve($filter('filter')(vm.clinics, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('Id'),
            DTColumnBuilder.newColumn('account').withTitle('Account'),
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn('abbr').withTitle('Abbr'),
            DTColumnBuilder.newColumn('corporation.name').withTitle('Corporation'),
            DTColumnBuilder.newColumn(null).withTitle('Start Date'). renderWith(function (data, type, full) {
                return moment(data.startDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('phone').withTitle('Phone'),
            DTColumnBuilder.newColumn('fax').withTitle('Fax'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '<a class="btn-sm btn-primary" ui-sref="clinic({id:' + data.id + '})">' +
                '   <i class="glyphicon glyphicon-eye-open"></i></a>&nbsp;';
            stButtons += '<a class="btn-sm btn-warning" ng-click="vm.editClinic(' + data.id + ')">' +
                '   <i class="glyphicon glyphicon-pencil"></i></a>&nbsp;';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        vm.detailClinic = function (id) {
            var _clinic = $.grep(vm.clinics, function (clinic, i) {
                return clinic.id === id;
            })[0];
            CoreService.setCurrentClinic(_clinic);
            $state.go("clinic");
        };

        vm.editClinic = function (id) {
            var _clinic = $.grep(vm.clinics, function (clinic, i) {
                return clinic.id === id;
            })[0];
            CoreService.setCurrentClinic(_clinic);
            $state.go("clinic-edit");
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamSpecialtyDialogController', CareTeamSpecialtyDialogController);

    CareTeamSpecialtyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CareTeamSpecialty', 'CareTeam', 'Corporation'];

    function CareTeamSpecialtyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CareTeamSpecialty, CareTeam, Corporation) {
        var vm = this;

        vm.careTeamSpecialty = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.careTeamSpecialty.id !== null) {
                CareTeamSpecialty.update(vm.careTeamSpecialty, onSaveSuccess, onSaveError);
            } else {
                CareTeamSpecialty.save(vm.careTeamSpecialty, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:careTeamSpecialtyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamSpecialtyDetailController', CareTeamSpecialtyDetailController);

    CareTeamSpecialtyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CareTeamSpecialty', 'CareTeam', 'Corporation'];

    function CareTeamSpecialtyDetailController($scope, $rootScope, $stateParams, previousState, entity, CareTeamSpecialty, CareTeam, Corporation) {
        var vm = this;

        vm.careTeamSpecialty = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:careTeamSpecialtyUpdate', function(event, result) {
            vm.careTeamSpecialty = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamSpecialtyDeleteController',CareTeamSpecialtyDeleteController);

    CareTeamSpecialtyDeleteController.$inject = ['$uibModalInstance', 'entity', 'CareTeamSpecialty'];

    function CareTeamSpecialtyDeleteController($uibModalInstance, entity, CareTeamSpecialty) {
        var vm = this;

        vm.careTeamSpecialty = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CareTeamSpecialty.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('care-team-specialty', {
            parent: 'entity',
            url: '/care-team-specialty',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'Care Team Specialties'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/care-team-specialty/care-team-specialties.html',
                    controller: 'CareTeamSpecialtyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('care-team-specialty-detail', {
            parent: 'entity',
            url: '/care-team-specialty/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'CareTeamSpecialty'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/care-team-specialty/care-team-specialty-detail.html',
                    controller: 'CareTeamSpecialtyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CareTeamSpecialty', function($stateParams, CareTeamSpecialty) {
                    return CareTeamSpecialty.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'care-team-specialty',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('care-team-specialty-detail.edit', {
            parent: 'care-team-specialty-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/care-team-specialty/care-team-specialty-dialog.html',
                    controller: 'CareTeamSpecialtyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CareTeamSpecialty', function(CareTeamSpecialty) {
                            return CareTeamSpecialty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('care-team-specialty.new', {
            parent: 'care-team-specialty',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/care-team-specialty/care-team-specialty-dialog.html',
                    controller: 'CareTeamSpecialtyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('care-team-specialty', null, { reload: 'care-team-specialty' });
                }, function() {
                    $state.go('care-team-specialty');
                });
            }]
        })
        .state('care-team-specialty.edit', {
            parent: 'care-team-specialty',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/care-team-specialty/care-team-specialty-dialog.html',
                    controller: 'CareTeamSpecialtyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CareTeamSpecialty', function(CareTeamSpecialty) {
                            return CareTeamSpecialty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('care-team-specialty', null, { reload: 'care-team-specialty' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('care-team-specialty.delete', {
            parent: 'care-team-specialty',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/care-team-specialty/care-team-specialty-delete-dialog.html',
                    controller: 'CareTeamSpecialtyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CareTeamSpecialty', function(CareTeamSpecialty) {
                            return CareTeamSpecialty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('care-team-specialty', null, { reload: 'care-team-specialty' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('CareTeamSpecialty', CareTeamSpecialty);

    CareTeamSpecialty.$inject = ['$resource'];

    function CareTeamSpecialty ($resource) {
        var resourceUrl =  'api/care-team-specialties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CareTeamSpecialtySearch', CareTeamSpecialtySearch);

    CareTeamSpecialtySearch.$inject = ['$resource'];

    function CareTeamSpecialtySearch($resource) {
        var resourceUrl =  'api/_search/care-team-specialties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamSpecialtyController', CareTeamSpecialtyController);

    CareTeamSpecialtyController.$inject = ['$scope', '$state', 'CareTeamSpecialty', 'CareTeamSpecialtySearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter'];

    function CareTeamSpecialtyController ($scope, $state, CareTeamSpecialty, CareTeamSpecialtySearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter ) {
        var vm = this;


        vm.careTeamSpecialties = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  CareTeamSpecialty.query(function(result) {
                  vm.careTeamSpecialties = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.careTeamSpecialties, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            CareTeamSpecialty.query(function(result) {
                vm.careTeamSpecialties = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamDialogController', CareTeamDialogController);

    CareTeamDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'careTeam', 'CareTeam', '$state', 'CareTeamSpecialty'];

    function CareTeamDialogController ($timeout, $scope, $uibModalInstance, careTeam, CareTeam, $state, CareTeamSpecialty) {
        var vm = this;

        vm.careTeam = careTeam;
        vm.clear = clear;
        vm.save = save;
        vm.editing = $state.current.name != "care-team-view";
        vm.careteamspecialties = CareTeamSpecialty.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.careTeam.id !== null) {
                CareTeam.update(vm.careTeam, onSaveSuccess, onSaveError);
            } else {
                CareTeam.save(vm.careTeam, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:careTeamUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamDeleteController',CareTeamDeleteController);

    CareTeamDeleteController.$inject = ['$uibModalInstance', 'entity', 'CareTeam'];

    function CareTeamDeleteController($uibModalInstance, entity, CareTeam) {
        var vm = this;

        vm.careTeam = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CareTeam.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('care-team-new', {
                parent: 'patient-detail',
                url: '/care-team-new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function ($stateParams, $state, $uibModal, entity) {
                    $uibModal.open({
                        templateUrl: 'app/entities/care-team/care-team-dialog.html',
                        controller: 'CareTeamDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            careTeam: function () {
                                return {
                                    careTeamSpecialty: null,
                                    email: null,
                                    firstName: null,
                                    lastName: null,
                                    patient: entity,
                                    phone: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', null, {reload: 'patient-detail'});
                    }, function () {
                        $state.go('patient-detail');
                    });
                }]
            })
            .state('care-team-view', {
                parent: 'patient-detail',
                url: '/{ctid}/ctview',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/care-team/care-team-dialog.html',
                        controller: 'CareTeamDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            careTeam: ['CareTeam', function (CareTeam) {
                                return CareTeam.get({id: $stateParams.ctid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', null, {reload: 'patient-detail'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('care-team-edit', {
                parent: 'patient-detail',
                url: '/{ctid}/ctedit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/care-team/care-team-dialog.html',
                        controller: 'CareTeamDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {
                            careTeam: ['CareTeam', function (CareTeam) {
                                return CareTeam.get({id: $stateParams.ctid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', null, {reload: 'patient-detail'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('care-team-delete', {
                parent: 'patient-detail',
                url: '/care-team/{ctid}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/care-team/care-team-delete-dialog.html',
                        controller: 'CareTeamDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CareTeam', function (CareTeam) {
                                return CareTeam.get({id: $stateParams.ctid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', {id: $stateParams.id}, {reload: 'patient-detail'});
                    }, function () {
                        $state.go('patient-detail', {id: $stateParams.id}, {reload: 'patient-detail'});
                    });
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('CareTeam', CareTeam);

    CareTeam.$inject = ['$resource'];

    function CareTeam ($resource) {
        var resourceUrl =  'api/care-teams/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByPatientId': { 'url': 'api/care-teams-by-patient/:id', method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CareTeamSearch', CareTeamSearch);

    CareTeamSearch.$inject = ['$resource'];

    function CareTeamSearch($resource) {
        var resourceUrl =  'api/_search/care-teams/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CareTeamController', CareTeamController);

    CareTeamController.$inject = ['$filter', '$scope', '$q', 'entity', '$compile', 'CareTeam', 'DTColumnBuilder', 'DTOptionsBuilder'];

    function CareTeamController($filter, $scope, $q, entity, $compile, CareTeam, DTColumnBuilder, DTOptionsBuilder) {
        var vm = this;

        vm.form = {};
        vm.patient = entity;

        vm.careTeams = [];
        vm.careTeamsDtInstance = {};

        vm.careTeamsDtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            CareTeam.getAllByPatientId({id: vm.patient.id}, function (result) {
                vm.careTeams = result;
                defer.resolve(result);
            });
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.careTeamsDtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Type/Specialty').renderWith(function (data, type, full) {
                return data.careTeamSpecialty ? data.careTeamSpecialty.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Name').renderWith(function (data, type, full) {
                return data.firstName + ' ' + data.lastName;
            }),
            DTColumnBuilder.newColumn('phone').withTitle('Phone').renderWith(function (data, type, full) {
                return $filter('phone')(data);
            }),
            DTColumnBuilder.newColumn('email').withTitle('Email'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-info" ui-sref="care-team-view({ctid:' + data.id + '})">' +
                '   <i class="fa fa-eye"></i></a>&nbsp;';

            if (vm.patient.status) {
                stButtons += '<a class="btn-sm btn-danger" ui-sref="care-team-delete({ctid:' + data.id + '})">' +
                    '   <i class="fa fa-trash"></i></a>';
            }

            return stButtons;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('calendar', {
                parent: 'entity',
                url: '/calendar',
                ncyBreadcrumb: {
                    label: 'Calendar',
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/calendar/calendar.html',
                        controller: 'CalendarController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Calendar', Calendar);

    Calendar.$inject = ['$resource', 'DateUtils'];

    function Calendar($resource, DateUtils) {
        var resourceUrl = 'api/calendar/';

        return $resource(resourceUrl, {}, {
            'getCalendar': {
                method: 'POST', isArray: true, transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);

                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        var events = [];

                        for (var i = 0; i < data.length; i++) {
                            if (data[i].startPickup && data[i].endPickup) {
                                data[i].startPickup = new Date(data[i].startPickup);
                                data[i].endPickup = new Date(data[i].endPickup);
                            }

                            var allDay = !(data[i].startPickup && data[i].endPickup);

                            for (var j = 0; j < data[i].days.length; j++) {
                                data[i].days[j].date = DateUtils.convertLocalDateFromServer(data[i].days[j].date);

                                if (!allDay) {
                                    data[i].startPickup.setDate(data[i].days[j].date.getDate());
                                    data[i].startPickup.setMonth(data[i].days[j].date.getMonth());
                                    data[i].startPickup.setYear(data[i].days[j].date.getFullYear());

                                    data[i].endPickup.setDate(data[i].days[j].date.getDate());
                                    data[i].endPickup.setMonth(data[i].days[j].date.getMonth());
                                    data[i].endPickup.setYear(data[i].days[j].date.getFullYear());
                                }

                                if (data[i].days[j].collectedPatient > 0) {
                                    events.push({
                                        id: '' + j + '-' + i,
                                        resourceId: '' + data[i].clinicId,
                                        title: data[i].clinic + ' P: ' + data[i].days[j].pendingPatient + ' / C: ' + data[i].days[j].collectedPatient,
                                        start: data[i].startPickup ? new Date(data[i].startPickup) : data[i].days[j].date,
                                        end: data[i].endPickup ? new Date(data[i].endPickup) : data[i].days[j].date,
                                        allDay: allDay,
                                        className: data[i].days[j].collectedPatient > 0 ? "bg-green" : "bg-red"
                                    });
                                }

                                if (data[i].days[j].collectedWater > 0) {
                                    events.push({
                                        id: '' + j + 'x-' + i,
                                        resourceId: '' + data[i].clinicId,
                                        title: data[i].clinic + ' P: ' + data[i].days[j].pendingWater + ' / C: ' + data[i].days[j].collectedWater,
                                        start: data[i].startPickup ? new Date(data[i].startPickup) : data[i].days[j].date,
                                        end: data[i].endPickup ? new Date(data[i].endPickup) : data[i].days[j].date,
                                        allDay: allDay,
                                        className: data[i].days[j].collectedWater > 0 ? "bg-blue" : "bg-aqua"
                                    });
                                }
                            }
                        }

                        return events;
                    }

                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CalendarController', CalendarController);

    CalendarController.$inject = ['Calendar', 'uiCalendarConfig', '$scope', '$compile', 'Clinic', '$interval'];

    function CalendarController(Calendar, uiCalendarConfig, $scope, $compile, Clinic, $interval) {
        var vm = this;
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();

        // vm.calendars = Calendar.getCalendar({date: new Date()});/

        vm.eventRender = function( event, element, view ) {
            element.attr({'tooltip': event.title,
                'tooltip-append-to-body': true});
            $compile(element)($scope);
        };

        vm.clinics = Clinic.query();

        vm.calendarConfig = {
            calendar: {
                height: "100%",
                editable: false,
                header: {
                    left: 'month,agendaWeek,basicDay',
                    center: 'title',
                    right: 'prev,next today'
                }
                // eventClick: $scope.alertEventOnClick,
                // eventDrop: $scope.alertOnDrop,
                // eventResize: $scope.alertOnResize
                // start: new Date(y, m, 1),
                // end: new Date(y, m, 31),
                // eventRender: vm.eventRender,
                // viewRender: function(view, element) {
                //     $log.debug("View Changed: ", view.visStart, view.visEnd, view.start, view.end);
                // }
            }
        };

        var myInterval = $interval(function(){
            reload();
        }, 10000);

        function reload() {
            // vm.calendarConfig.calendar.fullCalendar('rerenderEvents');
            uiCalendarConfig.calendars.myCalendar.fullCalendar('refetchEvents');
        }

        vm.eventsF = function (start, end, timezone, callback) {
            Calendar.getCalendar({startDate: start, endDate: end}).$promise.then(function (data) {
                callback(data);
            });
            // var events = [{title: 'Feed Me ' + m,start: s + (50000),end: s + (100000),allDay: false, className: ['customFeed']}];
        };

        vm.eventSources = [vm.eventsF];
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('BundleDialogController', BundleDialogController);

    BundleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Bundle',
        'Compendium', 'BillingFrequency', 'CoreService'];

    function BundleDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Bundle,
                                    Compendium, BillingFrequency, CoreService) {
        var vm = this;

        vm.bundle = entity;
        vm.compendiums = [];
        vm.billingfrequencies = BillingFrequency.query();

        vm.clear = clear;
        vm.save = save;
        vm.onChangeDialysisModality = onChangeDialysisModality;

        if (vm.bundle.id) {
            Compendium.byClinicBundleDif({
                id: vm.bundle.clinic.id, modality: vm.bundle.dialysisModality
            }, function (result) {
                vm.compendiums = result;
                vm.compendiums.push(vm.bundle.compendium);
            });
        } else {
            vm.bundle.clinic = CoreService.getCurrentClinic();
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.bundle.id !== null) {
                Bundle.update(vm.bundle, onSaveSuccess, onSaveError);
            } else {
                Bundle.save(vm.bundle, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('dialysisApp:bundleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function onChangeDialysisModality() {
            vm.bundle.compendium = null;

            vm.compendiums = [];

            Compendium.byClinicBundleDif({
                id: vm.bundle.clinic.id, modality: vm.bundle.dialysisModality
            }, function (result) {
                vm.compendiums = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('BundleDetailController', BundleDetailController);

    BundleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Bundle', 'Compendium', 'BillingFrequency'];

    function BundleDetailController($scope, $rootScope, $stateParams, previousState, entity, Bundle, Compendium, BillingFrequency) {
        var vm = this;

        vm.bundle = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:bundleUpdate', function(event, result) {
            vm.bundle = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('BundleDeleteController',BundleDeleteController);

    BundleDeleteController.$inject = ['$uibModalInstance', 'entity', 'Bundle'];

    function BundleDeleteController($uibModalInstance, entity, Bundle) {
        var vm = this;

        vm.bundle = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Bundle.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('bundle', {
            parent: 'entity',
            url: '/bundle',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Bundles'
            },
            ncyBreadcrumb: {
                label: 'Bundle',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bundle/bundles.html',
                    controller: 'BundleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('bundle-detail', {
            parent: 'entity',
            url: '/bundle/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Bundle'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bundle/bundle-detail.html',
                    controller: 'BundleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Bundle', function($stateParams, Bundle) {
                    return Bundle.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'bundle',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('bundle-detail.edit', {
            parent: 'bundle-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bundle/bundle-dialog.html',
                    controller: 'BundleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Bundle', function(Bundle) {
                            return Bundle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bundle.new', {
            parent: 'bundle',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bundle/bundle-dialog.html',
                    controller: 'BundleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dialysisModality: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('bundle', null, { reload: 'bundle' });
                }, function() {
                    $state.go('bundle');
                });
            }]
        })
        .state('bundle.edit', {
            parent: 'bundle',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bundle/bundle-dialog.html',
                    controller: 'BundleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Bundle', function(Bundle) {
                            return Bundle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bundle', null, { reload: 'bundle' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bundle.delete', {
            parent: 'bundle',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bundle/bundle-delete-dialog.html',
                    controller: 'BundleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Bundle', function(Bundle) {
                            return Bundle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bundle', null, { reload: 'bundle' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Bundle', Bundle);

    Bundle.$inject = ['$resource'];

    function Bundle ($resource) {
        var resourceUrl =  'api/bundles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('BundleSearch', BundleSearch);

    BundleSearch.$inject = ['$resource'];

    function BundleSearch($resource) {
        var resourceUrl =  'api/_search/bundles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('BundleController', BundleController);

    BundleController.$inject = ['$scope', '$state', 'Bundle', 'BundleSearch', 'CoreService', 'DTOptionsBuilder',
        'DTColumnBuilder', '$q', 'GUIUtils', '$filter'];

    function BundleController($scope, $state, Bundle, BundleSearch, CoreService, DTOptionsBuilder,
                              DTColumnBuilder, $q, GUIUtils, $filter) {
        var vm = this;

        vm.bundles = [];
        vm.clinic = CoreService.getCurrentClinic();
        vm.dtInstance = {};

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                BundleSearch.query({
                    query: {
                        bool: {
                            must: [
                                {term: {"clinic.id": vm.clinic.id}},
                                {term: {"delStatus": false}}
                            ]
                        }
                    }
                }, function (result) {
                    vm.bundles = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.bundles, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('compendium.code').withTitle('Compendium Code'),
            DTColumnBuilder.newColumn('compendium.description').withTitle('Description'),
            DTColumnBuilder.newColumn('billingFrequency.name').withTitle('Frequency'),
            DTColumnBuilder.newColumn('billingFrequency.days').withTitle('Days'),
            DTColumnBuilder.newColumn(null).withTitle('Modality').renderWith(function (data, type, full) {
                return data.dialysisModality ? data.dialysisModality.replace("_", " ") : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('BillingFrequencyDialogController', BillingFrequencyDialogController);

    BillingFrequencyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BillingFrequency'];

    function BillingFrequencyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BillingFrequency) {
        var vm = this;

        vm.billingFrequency = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.billingFrequency.id !== null) {
                BillingFrequency.update(vm.billingFrequency, onSaveSuccess, onSaveError);
            } else {
                BillingFrequency.save(vm.billingFrequency, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:billingFrequencyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('BillingFrequencyDetailController', BillingFrequencyDetailController);

    BillingFrequencyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BillingFrequency'];

    function BillingFrequencyDetailController($scope, $rootScope, $stateParams, previousState, entity, BillingFrequency) {
        var vm = this;

        vm.billingFrequency = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:billingFrequencyUpdate', function(event, result) {
            vm.billingFrequency = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('BillingFrequencyDeleteController',BillingFrequencyDeleteController);

    BillingFrequencyDeleteController.$inject = ['$uibModalInstance', 'entity', 'BillingFrequency'];

    function BillingFrequencyDeleteController($uibModalInstance, entity, BillingFrequency) {
        var vm = this;

        vm.billingFrequency = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BillingFrequency.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('billing-frequency', {
            parent: 'entity',
            url: '/billing-frequency',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Billing Frequencies'
            },
            ncyBreadcrumb: {
                label: 'Billing Frequencies',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/billing-frequency/billing-frequencies.html',
                    controller: 'BillingFrequencyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('billing-frequency-detail', {
            parent: 'entity',
            url: '/billing-frequency/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'BillingFrequency'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/billing-frequency/billing-frequency-detail.html',
                    controller: 'BillingFrequencyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'BillingFrequency', function($stateParams, BillingFrequency) {
                    return BillingFrequency.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'billing-frequency',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('billing-frequency-detail.edit', {
            parent: 'billing-frequency-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/billing-frequency/billing-frequency-dialog.html',
                    controller: 'BillingFrequencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BillingFrequency', function(BillingFrequency) {
                            return BillingFrequency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('billing-frequency.new', {
            parent: 'billing-frequency',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/billing-frequency/billing-frequency-dialog.html',
                    controller: 'BillingFrequencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                days: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('billing-frequency', null, { reload: 'billing-frequency' });
                }, function() {
                    $state.go('billing-frequency');
                });
            }]
        })
        .state('billing-frequency.edit', {
            parent: 'billing-frequency',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/billing-frequency/billing-frequency-dialog.html',
                    controller: 'BillingFrequencyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BillingFrequency', function(BillingFrequency) {
                            return BillingFrequency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('billing-frequency', null, { reload: 'billing-frequency' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('billing-frequency.delete', {
            parent: 'billing-frequency',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/billing-frequency/billing-frequency-delete-dialog.html',
                    controller: 'BillingFrequencyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BillingFrequency', function(BillingFrequency) {
                            return BillingFrequency.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('billing-frequency', null, { reload: 'billing-frequency' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('BillingFrequency', BillingFrequency);

    BillingFrequency.$inject = ['$resource'];

    function BillingFrequency ($resource) {
        var resourceUrl =  'api/billing-frequencies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('BillingFrequencySearch', BillingFrequencySearch);

    BillingFrequencySearch.$inject = ['$resource'];

    function BillingFrequencySearch($resource) {
        var resourceUrl =  'api/_search/billing-frequencies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('BillingFrequencyController', BillingFrequencyController);

    BillingFrequencyController.$inject = ['$scope', '$state', 'BillingFrequency', 'BillingFrequencySearch',
        'DTOptionsBuilder', 'DTColumnBuilder', '$q', 'GUIUtils'];

    function BillingFrequencyController($scope, $state, BillingFrequency, BillingFrequencySearch,
                                        DTOptionsBuilder, DTColumnBuilder, $q, GUIUtils) {
        var vm = this;

        vm.billingFrequencies = [];
        vm.dtInstance = {};

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                BillingFrequencySearch.query({
                    query: {
                        bool: {
                            must: [
                                {term: {"delStatus": false}}
                            ]
                        }
                    }
                }, function (result) {
                    vm.billingFrequencies = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.billingFrequencies, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip');

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('name').withTitle('Frequency'),
            DTColumnBuilder.newColumn('days').withTitle('Interval in days'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }


        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('Billing2Controller', Billing2Controller);

    Billing2Controller.$inject = ['OdsParamType', 'CoreService', 'Corporation', 'Clinic'];

    function Billing2Controller(OdsParamType, CoreService, Corporation, Clinic) {

        var vm = this;

        vm.currentClinic = CoreService.getCurrentClinic();

        vm.reportsGroup = {
            title: 'Billing',
            groups: [{
                id: 1,
                open: true,
                disabled: false,
                title: 'Clinic',
                icon: 'fa fa-dashboard',
                reports: [
                    {
                        id: 1,
                        title: 'Billing All',
                        url: 'api/report/billing/all',
                        base64: false,
                        params: [
                            {
                                title: 'Start Date',
                                name: 'start_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            },
                            {
                                title: 'End Date',
                                name: 'end_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            },
                            {
                                title: 'Price',
                                name: 'end_date',
                                type: OdsParamType.TEXT,
                                value: 60.0,
                                hidden: false
                            }
                        ]
                    },
                    {
                        id: 2,
                        title: 'Billing Total',
                        url: 'api/report/billing/total',
                        base64: false,
                        params: [
                            {
                                title: 'Start Date',
                                name: 'start_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            },
                            {
                                title: 'End Date',
                                name: 'end_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            }
                        ]
                    }
                ]
            }]
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('billing', {
                parent: 'entity',
                url: '/billing',
                ncyBreadcrumb: {
                    label: 'Reports'
                },
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/billing/billing.html',
                        controller: 'BillingController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('billing2', {
                parent: 'entity',
                url: '/billing2',
                ncyBreadcrumb: {
                    label: 'Reports'
                },
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/billing/billing.html',
                        controller: 'Billing2Controller',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('BillingController', BillingController);

    BillingController.$inject = ['OdsParamType', 'CoreService', 'Corporation', 'Clinic'];

    function BillingController(OdsParamType, CoreService, Corporation, Clinic) {

        var vm = this;

        vm.currentClinic = CoreService.getCurrentClinic();
        vm.clinics = Clinic.query();

        vm.reportsGroup = {
            title: 'Billing',
            groups: [{
                id: 1,
                open: true,
                disabled: false,
                title: 'Clinic',
                icon: 'fa fa-dashboard',
                reports: [
                    {
                        id: 1,
                        title: 'Billing bundle renal',
                        url: 'api/report/invoice/patient-results-in-bundle',
                        base64: false,
                        params: [
                            {
                                title: 'Clinic',
                                name: 'id',
                                type: OdsParamType.LIST,
                                hidden: false,
                                list: vm.clinics
                            },
                            {
                                title: 'Start Date',
                                name: 'start_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            },
                            {
                                title: 'End Date',
                                name: 'end_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            },
                            {
                                title: 'Price',
                                name: 'price',
                                type: OdsParamType.TEXT,
                                value: 60.0,
                                hidden: false
                            }
                        ]
                    },
                    {
                        id: 2,
                        title: 'Billing not renal',
                        url: 'api/report/invoice/patient-results-not-in-bundle',
                        base64: false,
                        params: [
                            {
                                title: 'Clinic',
                                name: 'id',
                                type: OdsParamType.LIST,
                                hidden: false,
                                list: vm.clinics
                            },
                            {
                                title: 'Start Date',
                                name: 'start_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            },
                            {
                                title: 'End Date',
                                name: 'end_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            }
                        ]
                    },
                    {
                        id: 3,
                        title: 'Billing a Clinic CSV',
                        url: 'api/report/invoice/clinic-csv',
                        base64: false,
                        pdf: false,
                        params: [
                            {
                                title: 'Clinic',
                                name: 'id',
                                type: OdsParamType.LIST,
                                hidden: false,
                                list: vm.clinics
                            },
                            {
                                title: 'Start Date',
                                name: 'start_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            },
                            {
                                title: 'End Date',
                                name: 'end_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            }
                        ]
                    },
                    {
                        id: 4,
                        title: 'Billing Water',
                        url: 'api/report/invoice/env-results',
                        base64: false,
                        params: [
                            {
                                title: 'Clinic',
                                name: 'id',
                                type: OdsParamType.LIST,
                                hidden: false,
                                list: vm.clinics
                            },
                            {
                                title: 'Start Date',
                                name: 'start_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            },
                            {
                                title: 'End Date',
                                name: 'end_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            }
                        ]
                    },
                    {
                        id: 5,
                        title: 'Billing Medicare HL7',
                        url: 'api/report/invoice/medicare-hl7',
                        base64: false,
                        pdf: false,
                        params: [
                            {
                                title: 'Corporation',
                                name: 'corporationId',
                                type: OdsParamType.LIST,
                                hidden: false,
                                list: [{
                                    id: 6,
                                    name: 'Santa Clarita'
                                }],
                                value: null
                            },
                            {
                                title: 'Clinics',
                                name: 'clinics',
                                placeholder: 'Select clinics...',
                                type: OdsParamType.MULTI_SELECT,
                                valueField: 'id',
                                titleField: 'name',
                                required: false,
                                value: [{
                                    id: 21,
                                    name: 'Laurel Canyon Dialysis'
                                }, {
                                    id: 23,
                                    name: 'Laurel Canyon PD'
                                }, {
                                    id: 13,
                                    name: 'Santa Clarita Dialysis'
                                }, {
                                    id: 22,
                                    name: 'Santa Clarita PD'
                                }],
                                list: [{
                                    id: 21,
                                    name: 'Laurel Canyon Dialysis'
                                }, {
                                    id: 23,
                                    name: 'Laurel Canyon PD'
                                }, {
                                    id: 13,
                                    name: 'Santa Clarita Dialysis'
                                }, {
                                    id: 22,
                                    name: 'Santa Clarita PD'
                                }]//Clinic.byCorp({id: 6})
                            },
                            {
                                title: 'Start Date',
                                name: 'start_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            },
                            {
                                title: 'End Date',
                                name: 'end_date',
                                type: OdsParamType.DATE,
                                value: new Date(),
                                hidden: false
                            }
                        ]
                    }
                ]
            },
                {
                    id: 1,
                    open: true,
                    disabled: false,
                    title: 'Corporation',
                    icon: 'fa fa-dashboard',
                    reports: [
                        {
                            id: 5,
                            title: 'Patient Bill',
                            url: 'api/report/patient-results/billing/corp-patient',
                            base64: false,
                            params: [
                                {
                                    title: 'Corporation',
                                    name: 'id',
                                    type: OdsParamType.LIST,
                                    hidden: false,
                                    list: Corporation.query()
                                },
                                {
                                    title: 'Start Date',
                                    name: 'start_date',
                                    type: OdsParamType.DATE,
                                    value: new Date(),
                                    hidden: false
                                },
                                {
                                    title: 'End Date',
                                    name: 'end_date',
                                    type: OdsParamType.DATE,
                                    value: new Date(),
                                    hidden: false
                                },
                                {
                                    title: 'Price',
                                    name: 'price',
                                    type: OdsParamType.TEXT,
                                    value: 60.0,
                                    hidden: false
                                }
                            ]
                        },
                        {
                            id: 6,
                            title: 'Environmental Bill',
                            url: 'api/report/env-results/billing/corp-env',
                            base64: false,
                            params: [
                                {
                                    title: 'Corporation',
                                    name: 'id',
                                    type: OdsParamType.LIST,
                                    hidden: false,
                                    list: Corporation.query()
                                },
                                {
                                    title: 'Start Date',
                                    name: 'start_date',
                                    type: OdsParamType.DATE,
                                    value: new Date(),
                                    hidden: false
                                },
                                {
                                    title: 'End Date',
                                    name: 'end_date',
                                    type: OdsParamType.DATE,
                                    value: new Date(),
                                    hidden: false
                                }
                            ]
                        },
                        {
                            id: 7,
                            title: 'Test without price',
                            url: 'api/report/patient-results/billing/test-no-price',
                            base64: false,
                            params: [
                                {
                                    title: 'Corporation',
                                    name: 'id',
                                    type: OdsParamType.LIST,
                                    hidden: false,
                                    list: Corporation.query()
                                },
                                {
                                    title: 'Start Date',
                                    name: 'start_date',
                                    type: OdsParamType.DATE,
                                    value: new Date(),
                                    hidden: false
                                },
                                {
                                    title: 'End Date',
                                    name: 'end_date',
                                    type: OdsParamType.DATE,
                                    value: new Date(),
                                    hidden: false
                                }
                            ]
                        },
                        {
                            id: 8,
                            title: 'Insurance CSV(no in bundle no renal)',
                            url: 'api/invoice/csv-no-bundle-no-renal',
                            base64: false,
                            binary: true,
                            params: [
                                {
                                    title: 'Clinic',
                                    name: 'ids',
                                    type: OdsParamType.MULTI_SELECT,
                                    hidden: false,
                                    list: vm.clinics,
                                    value: []
                                },
                                {
                                    title: 'Start Date',
                                    name: 'start_date',
                                    type: OdsParamType.DATE,
                                    value: new Date(2018,3,1),
                                    hidden: false
                                },
                                {
                                    title: 'End Date',
                                    name: 'end_date',
                                    type: OdsParamType.DATE,
                                    value: new Date(2018,3,30),
                                    hidden: false
                                }
                            ]
                        },
                    ]
                }]
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('PatientBarcode', PatientBarcode);

    PatientBarcode.$inject = ['$resource'];

    function PatientBarcode ($resource) {
        var resourceUrl =  'api/patient-barcode/:barcode';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('MachineBarcode', MachineBarcode);

    MachineBarcode.$inject = ['$resource'];

    function MachineBarcode ($resource) {
        var resourceUrl =  'api/machine-barcode/:barcode';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('AccessDialogController', AccessDialogController);

    AccessDialogController.$inject = ['$timeout', '$scope', '$state', '$uibModalInstance', 'access', 'Access'];

    function AccessDialogController ($timeout, $scope, $state, $uibModalInstance, access, Access) {
        var vm = this;

        vm.access = access;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.editing = $state.current.name != "access-view";

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.access.id !== null) {
                Access.update(vm.access, onSaveSuccess, onSaveError);
            } else {
                Access.save(vm.access, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:accessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.placementDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('AccessDetailController', AccessDetailController);

    AccessDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Access', 'Patient'];

    function AccessDetailController($scope, $rootScope, $stateParams, previousState, entity, Access, Patient) {
        var vm = this;

        vm.access = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:accessUpdate', function(event, result) {
            vm.access = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('AccessDeleteController',AccessDeleteController);

    AccessDeleteController.$inject = ['$uibModalInstance', 'entity', 'Access'];

    function AccessDeleteController($uibModalInstance, entity, Access) {
        var vm = this;

        vm.access = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Access.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('access-new', {
                parent: 'patient-detail',
                url: '/access-new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function ($stateParams, $state, $uibModal, entity) {
                    $uibModal.open({
                        templateUrl: 'app/entities/access/access-dialog.html',
                        controller: 'AccessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            access: function () {
                                return {
                                    aType: 'AVF',
                                    isActive: true,
                                    isPrimary: true,
                                    placedBy: null,
                                    placementDate: null,
                                    noActiveOther: null,
                                    placementSiteOther: null,
                                    placementSite: null,
                                    buttonHole: null,
                                    avfgNoActiveSpecify: null,
                                    cvcGt90: null,
                                    cvcNoActiveSpecifyCvc: null,
                                    cvcType: null,
                                    id: null,
                                    patient: entity
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', null, {reload: 'patient-detail'});
                    }, function () {
                        $state.go('patient-detail');
                    });
                }]
            })
            .state('access-view', {
                parent: 'patient-detail',
                url: '/{aid}/aview',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function ($stateParams, $state, $uibModal, entity) {
                    $uibModal.open({
                        templateUrl: 'app/entities/access/access-dialog.html',
                        controller: 'AccessDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            access: ['Access', function (Access) {
                                return Access.get({id: $stateParams.aid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', null, {reload: 'patient-detail'});
                    }, function () {
                        $state.go('patient-detail');
                    });
                }]
            })
            .state('access-delete', {
                parent: 'patient-detail',
                url: '/{aid}/adelete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/access/access-delete-dialog.html',
                        controller: 'AccessDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Access', function (Access) {
                                return Access.get({id: $stateParams.aid}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('patient-detail', null, {reload: 'patient-detail'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Access', Access);

    Access.$inject = ['$resource', 'DateUtils'];

    function Access ($resource, DateUtils) {
        var resourceUrl =  'api/accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.placementDate = DateUtils.convertLocalDateFromServer(data.placementDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.placementDate = DateUtils.convertLocalDateToServer(copy.placementDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.placementDate = DateUtils.convertLocalDateToServer(copy.placementDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('AccessSearch', AccessSearch);

    AccessSearch.$inject = ['$resource'];

    function AccessSearch($resource) {
        var resourceUrl =  'api/_search/accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('AccessController', AccessController);

    AccessController.$inject = ['GUIUtils', '$compile', '$scope', 'AccessSearch', 'entity', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', '$filter', 'moment'];

    function AccessController(GUIUtils, $compile, $scope, AccessSearch, entity, $q, DTColumnBuilder, DTOptionsBuilder, $filter, moment) {
        var vm = this;

        vm.patient = entity;
        vm.accesses = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                var must = [];
                must.push({term: {"patient.id": vm.patient.id}});
                must.push({term: {"delStatus": false}});

                AccessSearch.query({
                    query: {
                        bool: {
                            must: must
                        }
                    }
                }, function (result) {
                    vm.accesses = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.accesses, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('aType'),
            DTColumnBuilder.newColumn(null).withTitle('Placement Date').renderWith(function (data, type, full) {
                return data.placementDate ? moment(data.placementDate).format("MM/DD/YYYY") : '';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Active').renderWith(function (data, type, full) {
                return data.isActive ? GUIUtils.getStatusTemplate('Yes', 'success') : GUIUtils.getStatusTemplate('No', 'danger');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Primary').renderWith(function (data, type, full) {
                return data.isPrimary ? GUIUtils.getStatusTemplate('Yes', 'success') : GUIUtils.getStatusTemplate('No', 'danger');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            var stButtons = '';

            stButtons += '<a class="btn-sm btn-info" ui-sref="access-view({aid:' + data.id + '})">' +
                '   <i class="fa fa-eye"></i></a>&nbsp;';

            if (vm.patient.status) {
                stButtons += '<a class="btn-sm btn-danger" ui-sref="access-delete({aid:' + data.id + '})">' +
                    '   <i class="fa fa-trash"></i></a>';
            }

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('dialysisApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('dialysisApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat,
            formatter: formatter
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function formatter(date, format) {
            if (date) {
                return $filter('date')(date, format);
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window', '$timeout', 'toastr'];

    function DataUtils($window, $timeout, toastr) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64,
            downloadFile: downloadFile,
            downloadAndOpenPDFFile: downloadAndOpenPDFFile
        };

        return service;

        function abbreviate(text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize(base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile(type, data, height, width) {
            if (height && width) {
                $window.open('data:' + type + ';base64,' + data, '_blank', 'height=' + height + ',width=' + width + '');
            } else {
                $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
            }
        }

        function toBase64(file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }

        function downloadFile(data, headers) {
            var contentType = headers('Content-Type');
            var contentDisp = headers('Content-Disposition');

            if (!contentDisp) {
                toastr.error('Error downloading file');

                return;
            }

            var index = contentDisp.indexOf('filename="');

            var filename = "filename";

            if (index != -1) {
                var i = index + 10;
                while (contentDisp[i] != '"') {
                    i++;
                }

                filename = contentDisp.substring(index + 10, i);
            }

            var url = URL.createObjectURL(new Blob([data]));
            var a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.target = '_blank';
            a.click();
        }

        function downloadAndOpenPDFFile(data, headers) {
            var contentType = headers('Content-Type');
            var contentDisp = headers('Content-Disposition');
            var index = contentDisp.indexOf('filename="');

            var filename = "filename";

            if (index != -1) {
                var i = index + 10;

                while (contentDisp[i] != '"') {
                    i++;
                }

                filename = contentDisp.substring(index + 10, i);
            }

            var file = new Blob([data], {type: contentType});
            var fileURL = URL.createObjectURL(file);
            var w = window.open(fileURL);
            w.onload = function(){
                setTimeout(function(){
                    $(w.document).find('html').append('<head><title>' + filename + '</title></head>');
                }, 150);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .directive('bindValidity', bindValidity);

    function bindValidity() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: ['?form', '?ngForm', 'bindValidity'],
            link: linkFunc,
            controller: ['$scope', '$attrs', '$parse', function($scope, $attrs, $parse) {
                var assign = $parse($attrs.bindValidity).assign;

                if (!angular.isFunction(assign)) {
                    throw new Error('the expression of bindValidity is not settable: ' + $attrs.bindValidity);
                }

                this.setFormController = function(formCtrl) {
                    if (!formCtrl) {
                        throw new Error('bindValidity requires one of <form> or ng-form');
                    }
                    $scope.$watch(
                        function () {
                            return formCtrl.$invalid;
                        },
                        function (newval) {
                            assign($scope, newval);
                        }
                    );
                };
            }],
        };

        return directive;

        function linkFunc(scope, element, attrs, ctrls) {
            var formCtrl, bindValidity;
            formCtrl = ctrls[0] || ctrls[1];
            bindValidity = ctrls[2];
            bindValidity.setFormController(formCtrl);
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('dialysisApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt', [])
        .factory('GUIUtils', GUIUtils);

    function GUIUtils() {

        var statusTypes = ['default', 'danger', 'primary', 'success', 'info', 'warning'];

        var service = {
            getActionsTemplate: getActionsTemplate,
            getStatusTemplate: getStatusTemplate,
            expandWeekCodeString: expandWeekCodeString,
            mailto: mailto,
            objectToArray: objectToArray,
            getDays: getDays,
            getDaysAsObject: getDaysAsObject,
            daysToWeekCodeString: daysToWeekCodeString,
            weekCodeStringToDays: weekCodeStringToDays,
            getMonths: getMonths,
            monthsCodeStringToMonths: monthsCodeStringToMonths,
            monthsToMonthCodeString: monthsToMonthCodeString,
            getDefaultUserPicture: getDefaultUserPicture,
            getDefaultUserPictureContentType: getDefaultUserPictureContentType,
            resetUserPicture: resetUserPicture,
            colorHtmlYesNo: colorHtmlYesNo
        };

        return service;

        /**
         * Return a Action Template for grid bootstrap based
         * @param data
         * @param entity
         * @param buttons
         * @returns {string}
         */
        function getActionsTemplate(data, entity, buttons) {
            var stButtons = '';

            // stButtons = '<div class="btn-group">'+
            //     '<a type="button" class="btn btn-primary btn-xs"><i class="glyphicon glyphicon-eye-open"></i></i></a>'+
            //     '<a type="button" class="btn btn-warning btn-xs"><i class="glyphicon glyphicon-pencil"></i></a>'+
            //     '<a type="button" class="btn btn-danger btn-xs"><i class="glyphicon glyphicon-trash"></i></a>'+
            //     '</div>';

            <!-- Single button -->
            // stButtons = '<div class="btn-group-vertical">'+
            //     '<div class="btn-group open" uib-dropdown>'+
            //     '<button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle data-toggle="dropdown" aria-expanded="true">'+
            //     '<span class="caret"></span>'+
            //     '</button>'+
            //     '<ul class="dropdown-menu" uib-dropdown-menu style="min-width: 30px;width: 52px;">'+
            //         '<li><a href="#"><i class="fa fa-eye"></i></a></li>'+
            //         '<li class="divider"></li>'+
            //         '<li><a href="#"><i class="fa fa-edit"></i></a></li>'+
            //         '<li class="divider"></li>'+
            //         '<li><a href="#"><i class="fa fa-trash"></i></a></li>'+
            //     '</ul>'+
            //     '</div>'+
            //     '</div>';


            // stButtons = '<div>' +
            // '<div class="btn-group" uib-dropdown>' +
            // '<button type="button" class="btn btn-default">Actions</button>' +
            // '<button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle ng-disabled="disabled" data-toggle="dropdown" aria-expanded="false">' +
            // '<span class="caret"></span>' +
            // '<span class="sr-only">Toggle Dropdown</span>' +
            // '</button>' +
            // '<ul class="dropdown-menu" uib-dropdown-menu role="menu" style="min-width: 80px;">' +
            // '<li><a ui-sref="hospitalization({id:' + data.id + '})">View</a></li>' +
            // '<li><a ui-sref="infection({id:' + data.id + '})">Edit</a></li>' +
            // '<li><a ui-sref="order({id:' + data.id + '})">Delete</a></li>' +
            // '</ul>' +
            // '</div></div>';

            for (var i = 0, len = buttons.length; i < len; i++) {
                switch (buttons[i]) {
                    case 'view': {
                        stButtons += '<a class="btn-sm btn-primary" ui-sref="' + entity + '-detail({id:' + data.id + '})" href="#/' + entity + '/' + data.id + '">' +
                            '   <i class="glyphicon glyphicon-eye-open"></i></a>&nbsp;';
                        // stButtons += '<a class="btn-sm btn-primary " ui-sref="' + entity + '-detail({id:' + data.id + '})">' +
                        //     '   <i class="glyphicon glyphicon-eye-open"></i></a>';
                        break;
                    }
                    case 'update': {
                        // if (stButtons.length != 0)
                        //     stButtons += '&nbsp;'

                        // stButtons += '<a class="btn-sm btn-warning" ui-sref="' + entity + '.edit({id:' + data.id + '})">' +
                        //     '   <i class="fa fa-edit"></i></a>';
                        stButtons += '<a class="btn-sm btn-warning" ui-sref="' + entity + '.edit({id:' + data.id + '})" href="#/' + entity + '/' + data.id + '/edit">' +
                            '<span class="glyphicon glyphicon-pencil"></span></a>';
                        break;
                    }
                    case 'delete': {
                        if (stButtons.length != 0)
                            stButtons += '&nbsp;'

                        stButtons += '<a class="btn-sm btn-danger" ui-sref="' + entity + '.delete({id:' + data.id + '})"  href="#/' + entity + '/' + data.id + '/delete">' +
                            '<span class="glyphicon glyphicon-trash"></span></a>';
                        // stButtons += '<a class="btn-sm btn-danger" ui-sref="' + entity + '.delete({id:' + data.id + '})">' +
                        //     '   <i class="fa fa-trash"></i></a>';
                        break;
                    }
                    case 'all' : {
                        stButtons += '<a class="btn-sm btn-primary" ui-sref="' + entity + '-detail({id:' + data.id + '})" href="#/' + entity + '/' + data.id + '">' +
                            '   <i class="glyphicon glyphicon-eye-open"></i></a>&nbsp;';
                        stButtons += '<a class="btn-sm btn-warning" ui-sref="' + entity + '.edit({id:' + data.id + '})" href="#/' + entity + '/' + data.id + '/edit">' +
                            '   <i class="glyphicon glyphicon-pencil"></i></a>&nbsp;';
                        stButtons += '<a class="btn-sm btn-danger" ui-sref="' + entity + '.delete({id:' + data.id + '})"  href="#/' + entity + '/' + data.id + '/delete">' +
                            '   <i class="glyphicon glyphicon-trash"></i></a>';
                    }
                }
            }

            return stButtons;
        }

        /**
         * Return a Status Template for grid bootstrap based
         * @param label
         * @param type
         * @returns {string}
         */
        function getStatusTemplate(label, type) {

            var index = statusTypes.indexOf(type);
            if (index != -1) {
                return '<small class="label label-' + statusTypes[index] + '">' + label + '</small>';
            } else {
                return '<small class="label label-' + statusTypes[0] + '">' + label + '</small>';
            }
        }

        /**
         * Expand a week code String '0000000' to human days week
         * @param weekCode binary String length 7 Ex 0100101 ==> MON,THU,SAT
         * @param separator
         */
        function expandWeekCodeString(weekCode, separator) {
            var days = '';
            for (var i = 0; i < weekCode.length; i++) {
                if (weekCode[i] != '0') {
                    if ((days.length > 0) && (i > 0)) {
                        days += separator;
                    }
                    switch (i) {
                        case 1:
                            days += 'MON';
                            break;
                        case 1:
                            days += 'TUE';
                            break;
                        case 2:
                            days += 'WED';
                            break;
                        case 3:
                            days += 'THU';
                            break;
                        case 4:
                            days += 'FRI';
                            break;
                        case 5:
                            days += 'SAT';
                            break;
                        case 6:
                            days += 'SUN';
                            break;
                    }
                }
            }

            return days;
        }

        function getDays() {
            return ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
        }

        function getDaysAsObject() {
            return [{
                id: 1,
                name: 'MON'
            }, {
                id: 2,
                name: 'TUE'
            }, {
                id: 3,
                name: 'WED'
            }, {
                id: 4,
                name: 'THU'
            }, {
                id: 5,
                name: 'FRI'
            }, {
                id: 6,
                name: 'SAT'
            }, {
                id: 7,
                name: 'SUN'
            }];
        }

        function weekCodeStringToDays(weekCode) {
            if (!weekCode) {
                weekCode = '0000000';
            }

            var days = [];
            for (var i = 0; i < weekCode.length; i++) {
                if (weekCode.charAt(i) == '1') {
                    switch (i) {
                        case 0:
                            days.push('MON');
                            break;
                        case 1:
                            days.push('TUE');
                            break;
                        case 2:
                            days.push('WED');
                            break;
                        case 3:
                            days.push('THU');
                            break;
                        case 4:
                            days.push('FRI');
                            break;
                        case 5:
                            days.push('SAT');
                            break;
                        case 6:
                            days.push('SUN');
                            break;
                    }
                }
            }

            return days;
        }

        function daysToWeekCodeString(days) {
            var code = '0000000';

            if (days) {
                code = code.split("");

                for (var i = 0; i < days.length; i++) {
                    switch (days[i]) {
                        case 'MON':
                            code[0] = '1';
                            break;
                        case 'TUE':
                            code[1] = '1';
                            break;
                        case 'WED':
                            code[2] = '1';
                            break;
                        case 'THU':
                            code[3] = '1';
                            break;
                        case 'FRI':
                            code[4] = '1';
                            break;
                        case 'SAT':
                            code[5] = '1';
                            break;
                        case 'SUN':
                            code[6] = '1';
                            break;
                    }
                }

                return code.join("");
            }

            return code;
        }

        function getMonths() {
            return ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
        }

        function monthsCodeStringToMonths(monthCode) {
            var days = [];
            for (var i = 0; i < monthCode.length; i++) {
                if (monthCode.charAt(i) == '1') {
                    switch (i) {
                        case 0:
                            days.push('JAN');
                            break;
                        case 1:
                            days.push('FEB');
                            break;
                        case 2:
                            days.push('MAR');
                            break;
                        case 3:
                            days.push('APR');
                            break;
                        case 4:
                            days.push('MAY');
                            break;
                        case 5:
                            days.push('JUN');
                            break;
                        case 6:
                            days.push('JUL');
                            break;
                        case 7:
                            days.push('AUG');
                            break;
                        case 8:
                            days.push('SEP');
                            break;
                        case 9:
                            days.push('OCT');
                            break;
                        case 10:
                            days.push('NOV');
                            break;
                        case 11:
                            days.push('DEC');
                            break;
                    }
                }
            }

            return days;
        }

        function monthsToMonthCodeString(months) {
            var code = '000000000000';

            if (months) {
                code = code.split("");

                for (var i = 0; i < months.length; i++) {
                    switch (months[i]) {
                        case 'JAN':
                            code[0] = '1';
                            break;
                        case 'FEB':
                            code[1] = '1';
                            break;
                        case 'MAR':
                            code[2] = '1';
                            break;
                        case 'APR':
                            code[3] = '1';
                            break;
                        case 'MAY':
                            code[4] = '1';
                            break;
                        case 'JUN':
                            code[5] = '1';
                            break;
                        case 'JUL':
                            code[6] = '1';
                            break;
                        case 'AUG':
                            code[7] = '1';
                            break;
                        case 'SEP':
                            code[8] = '1';
                            break;
                        case 'OCT':
                            code[9] = '1';
                            break;
                        case 'NOV':
                            code[10] = '1';
                            break;
                        case 'DEC':
                            code[11] = '1';
                            break;
                    }
                }

                return code.join("");
            }

            return code;
        }

        /**
         * Returns a URL for a mailto-link
         * @param  {String} recepient    - Recepient email address
         * @param  {Object} opts         - Options to construct the URL
         * @param  {String} opts.cc      - Cc recepient email address (optional)
         * @param  {String} opts.bcc     - Bcc recepient email address (optional)
         * @param  {String} opts.subject - Email subject (optional)
         * @param  {String} opts.body    - Email body (optional). Separate lines with the newline character (\n)
         * @return {String}              - Returns the URL to put into the href-attribute of a mailto link
         */
        function mailto(recepient, opts) {
            var link = '<a href="mailto:';
            link += recepient;//window.encodeURIComponent(recepient);
            var params = [];
            angular.forEach(opts, function (value, key) {
                params.push(key.toLowerCase() + "=" + window.encodeURIComponent(value));
            });
            if (params.length > 0) {
                link += "?" + params.join("&");
            }
            link += '">' + recepient + '</a>';
            return link;
        };

        /**
         * Return object fields as array
         * @param object
         */
        function objectToArray(object) {

            var toArray = [];
            for (var key in object) {
                if (object.hasOwnProperty(key)) {
                    toArray.push(object[key]);
                }
            }
            return toArray;
        }

        function getDefaultUserPicture() {
            return "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";
        }

        function getDefaultUserPictureContentType() {
            return "image/jpeg";
        }

        function resetUserPicture(patient) {
            patient.patientPicture = {};
            patient.patientPicture.picture = getDefaultUserPicture();
            patient.patientPicture.pictureContentType = getDefaultUserPictureContentType();

            return patient;
        }

        function colorHtmlYesNo(value) {
            if (value) {
                return getStatusTemplate('Yes', 'success');
            } else {
                return getStatusTemplate('No', 'danger');
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .factory('Utils', Utils);

    function Utils() {

        var service = {
            objectToArray: objectToArray,
            arrayToString: arrayToString,
            objectRoleToArray: objectRoleToArray,
        };

        return service;

        /**
         * Return object fields as array.
         *
         * @param object
         */
        function objectToArray(object) {

            var toArray = [];
            for (var key in object) {
                if (object.hasOwnProperty(key)) {
                    toArray.push(object[key]);
                }
            }
            return toArray;
        }

        /**
         * Return a string comma separated of array elements.
         *
         * @param Array
         * @return String comma separated or empty string
         */
        function arrayToString(inArray) {

            var toString = '';
            for (var i = 0; i < inArray.length; i++) {
                if (i === 0) {
                    toString = inArray[i];
                } else {
                    toString += ',' + inArray[i];
                }
            }
            return toString;
        }

        /**
         * Return a array of Roles as simple strings.
         *
         * [{
         *      name: 'ROLE1'
         * },{
         *      name: 'ROLE2'
         * }]
         *
         * @param Array of Roles as Objects
         * @return Array of Roles as String
         *
         * ['ROLE1', 'ROLE2']
         */
        function objectRoleToArray(inArray) {

            var toArray = [];
            for (var i = 0; i < inArray.length; i++) {
                toArray.push(inArray[i].name);
            }
            return toArray;
        }

    }
})();

/*!
 * RM-DATEPICKER v1.0.0
 * http://rubymage.com
 *
 * Copyright 2015 Sergiu Ghenciu, RUBYMAGE
 * Released under the MIT license
 * https://github.com/RUBYMAGE/angular-datepicker/blob/master/LICENSE
 */

(function () {
    'use strict';

    var Module = angular.module('rm3Datepicker', []);

    Module.constant('rm3DatepickerConfig', {
        mondayStart: false,
        initState: "month",
        maxState: "decade",
        minState: "month",
        toggleState: true,

        decadeSize: 12,
        monthSize: 42, /* "auto" || fixed nr. (35 or 42) */

        min: null,
        max: null,
        format: "yyyy-MM-dd",
        markDates: null
    });

    Module.directive("rm3Datepicker", ['rm3DatepickerConfig', '$compile', '$filter', '$document', 'DateUtils', '$rootScope',
        function (rm3DatepickerConfig, $compile, $filter, $document, DateUtils, $rootScope) {

            var link = function (scope, element, attrs, ngModel) {
                var conf = angular.copy(rm3DatepickerConfig);

                if (scope.rmConfig) {
                    for (var prop in conf)
                        if (conf.hasOwnProperty(prop))
                            if (scope.rmConfig[prop] != undefined) conf[prop] = scope.rmConfig[prop];
                }
                if (conf.min) conf.min.setHours(0, 0, 0, 0);
                if (conf.max) conf.max.setHours(23, 59, 59, 999);

                var isInput = element[0].tagName.toUpperCase() == "INPUT";
                var isReached = {
                    min: false,
                    max: false
                };
                var daysInMonth = function (year, month) {
                    return new Date(year, month + 1, 0).getDate();
                };
                var adjustDate = function (date) {
                    var date = parseInt(date, 10);
                    if (!isNaN(date)) {
                        var max = daysInMonth(scope.j.getFullYear(), scope.j.getMonth());
                        if (date < 1) date = 1;
                        if (date > max) date = max;
                        scope.j.setDate(date);
                    }
                };
                var gen = {
                    decade: function (oDate) {
                        var Y = oDate.getFullYear(),
                            m = oDate.getMonth(),
                            d = oDate.getDate(),
                            max,
                            i = 0,
                            n = conf.decadeSize || 12; // count of years in decade
                        var aDecade = new Array(n);

                        Y = Math.floor(Y / n) * n; // begin year of current decade

                        for (; i < n; Y++, i++) {
                            max = daysInMonth(Y, m);
                            if (d > max) d = max;
                            aDecade[i] = new Date(Y, m, d, 3, 0, 1, 0);
                        }
                        return aDecade;
                    },
                    year: function (oDate) {
                        var Y = oDate.getFullYear(),
                            m = 0,
                            d = oDate.getDate(),
                            max;
                        var aYear = [];
                        for (; m < 12; m++) {
                            max = daysInMonth(Y, m);
                            if (d > max) d = max;
                            aYear.push(new Date(Y, m, d, 3, 0, 1, 0));
                        }
                        return aYear;
                    },
                    month: function (oDate) {
                        var Y = oDate.getFullYear(),
                            m = oDate.getMonth(),
                            startDate = new Date(Y, m, 1, 3, 0, 1, 0),
                            n;
                        var startPos = startDate.getDay() || 7;
                        if (scope.mondayStart) startPos = startPos - 1 || 7;

                        if (conf.monthSize == "auto")
                            n = ( startPos + daysInMonth(Y, m) < 35 ) ? 35 : 42;
                        else
                            n = conf.monthSize;

                        startDate.setDate(-startPos + 1);
                        return gen.dates(startDate, n);
                    },
                    dates: function (startDate, n) {
                        var aDates = new Array(n),
                            current = new Date(startDate),
                            i = 0;
                        while (i < n) {
                            aDates[i++] = new Date(current);
                            current.setDate(current.getDate() + 1);
                        }
                        return aDates;
                    }
                };
                var refresh = function (state) {
                    state = state || scope.state;
                    scope.aDates = gen[state](scope.j);

                    if (conf.min) {
                        isReached.min = scope.aDates[0] < conf.min;
                    }
                    if (conf.max) {
                        var oDate = scope.aDates[scope.aDates.length - 1];
                        isReached.max = oDate > conf.max;
                    }
                };
                var init = function () {
                    scope.marks = conf.markDates(scope.j);
                    return refresh();
                };

                //TODO: optimize this method
                var isBefore = function (oDate1, oDate2) {
                    if (scope.state == "decade")
                        return oDate1.getFullYear() < oDate2.getFullYear();

                    if (scope.state == "year") {
                        if (oDate1.getFullYear() == oDate2.getFullYear())
                            return oDate1.getMonth() < oDate2.getMonth();
                        else
                            return oDate1.getFullYear() < oDate2.getFullYear();
                    }

                    return oDate1 < oDate2;
                };
                scope.isOff = function (oDate) {
                    if (!conf.min && !conf.max)
                        return false;
                    if (conf.min && isBefore(oDate, conf.min))
                        return true;
                    if (conf.max && isBefore(conf.max, oDate))
                        return true;
                };
                scope.isActive = {
                    year: function (oDate) {
                        return oDate.getFullYear() == scope.j.getFullYear();
                    },
                    month: function (oDate) {
                        return oDate.getMonth() == scope.j.getMonth();
                    },
                    date: function (oDate) {
                        return oDate.getDate() == scope.j.getDate();
                    }
                };
                scope.isToday = function (oDate) {
                    return scope.isActive.date(oDate)
                        && scope.isActive.month(oDate)
                        && scope.isActive.year(oDate);
                };

                scope.go = function (oDate) {
                    if (scope.isOff(oDate)) return;

                    if (isInput && scope.state == conf.minState && scope.isActive.month(oDate)) {
                        scope.show = false;
                        overlay.css("display", "none");
                    }

                    var m = scope.j.getMonth();
                    var y = scope.j.getYear();

                    scope.j = new Date(oDate);
                    if (conf.toggleState) scope.toggleState(1);

                    if (m != scope.j.getMonth() && y != scope.j.getYear()) {
                        scope.marks = conf.markDates(scope.j);
                        refresh();
                    }
                };
                scope.now = function () {
                    var m = scope.j.getMonth();

                    scope.j = new Date();

                    if (m != scope.j.getMonth()) {
                        scope.marks = conf.markDates(scope.j);
                    }

                    refresh();
                };
                scope.next = function (delta) {
                    delta = delta || 1;

                    if (delta > 0) {
                        if (isReached.max) return;
                    }
                    else {
                        if (isReached.min) return;
                    }

                    var Y = scope.j.getFullYear(),
                        m = scope.j.getMonth(),
                        d = scope.j.getDate();

                    switch (scope.state) {
                        case "decade":
                            delta = delta * scope.aDates.length;
                        case "year":
                            scope.j.setFullYear(Y + delta, m, 15);
                            adjustDate(d);
                            break;
                        case "month":
                            scope.j.setMonth(m + delta, 15);
                            adjustDate(d);
                            break;
                        case "week" :
                            scope.j.setDate(d + (delta * 7));
                            break;
                    }

                    refresh();
                    scope.marks = conf.markDates(scope.j);
                };
                scope.prev = function (delta) {
                    return scope.next(-delta || -1);
                };
                scope.toggleState = function (direction) {
                    direction = direction || 1;

                    if (scope.state == conf.maxState && direction == -1 ||
                        scope.state == conf.minState && direction == 1) {
                        return;
                    }
                    scope.state = scope.aStates[scope.aStates.indexOf(scope.state) + direction];
                    refresh();
                };

                scope.mondayStart = conf.mondayStart;
                scope.aWeekDay = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                if (scope.mondayStart) scope.aWeekDay.push(scope.aWeekDay.shift());

                scope.aStates = ["decade", "year", "month"];
                scope.state = conf.initState;

                //TODO: this(together with rmInclude directive below) is a quick implementation, maybe there is a better idea
                scope.activeDateTpl = {
                    decade: "{{aDates[0].getFullYear()}} - {{aDates[aDates.length-1].getFullYear()}}",
                    year: "{{j.getFullYear()}}",
                    month: "{{j | date: 'MMMM yyyy'}}",
                    week: "{{ j | date: 'd MMMM yyyy' }}"
                };

                init(); // generate initial state

                var offset = function (objElement) {
                    var x = 0, y = 0;

                    if (objElement.offsetParent) {
                        do {
                            x += objElement.offsetLeft;
                            y += objElement.offsetTop;
                        } while (objElement = objElement.offsetParent);
                    }
                    return {top: y, left: x};
                };
                var togglePicker = function (toggle) {
                    overlay.css("display", toggle ? "block" : "none");
                    scope.show = toggle;
                    scope.$apply();
                };
                var adjustPos = function (el) {
                    var scrollX = window.scrollX,
                        scrollY = window.scrollY,
                        innerWidth = window.innerWidth,
                        innerHeight = window.innerHeight;

                    if (window.innerWidth < 481)
                        return {top: scrollY, left: 0};

                    var pos = offset(el),
                        marginBottom = scrollY + innerHeight - pos.top - el.clientHeight,
                        marginRight = scrollX + innerWidth - pos.left - el.clientWidth;

                    if (marginBottom < 0) pos.top += marginBottom;
                    if (pos.top < scrollY) pos.top = scrollY;
                    if (marginRight < 0) pos.left += marginRight;
                    if (pos.left < 0) pos.left = 0;

                    return pos;
                };

                if (isInput) {
                    scope.show = false;

                    ngModel.$parsers.push(function (sDate) {
                        return new Date(sDate);
                    });
                    ngModel.$formatters.push(function (oDate) {
                        return $filter('date')(oDate, conf.format);
                    });

                    element.after($compile(TEMPLATE)(scope));

                    var calendar = element.next();
                    var overlay = angular.element('<div class="rm-overlay" style="display:none"></div>');
                    overlay.on('click', function () {
                        togglePicker(false);
                    });
                    $document.find('body').eq(0).append(overlay);

                    element.on('click', function () {

                        if (window.innerWidth < 481) element[0].blur();
                        var pos = offset(element[0]);
                        pos.top += element[0].offsetHeight + 1;

                        scope.style = {top: pos.top + "px", left: pos.left + "px"};
                        togglePicker(true);
                        pos = adjustPos(calendar[0]);
                        scope.style = {top: pos.top + "px", left: pos.left + "px"};
                        scope.$apply();
                    });

                    $document.on('keydown', function (e) {
                        if ([9, 13, 27].indexOf(e.keyCode) >= 0) togglePicker(false);
                    });
                }
                else {
                    scope.show = true;
                    element.append($compile(TEMPLATE)(scope));
                }
                ;

                scope.checkMark = function (oDate) {
                    var _mark = $.grep(scope.marks, function (mark, i) {
                        return mark.date == DateUtils.convertLocalDateToServer(oDate);
                    });

                    if (_mark == null || _mark.length == 0) {
                        return '';
                    }

                    return _mark[0].class;
                }
            };

            //TODO: template may need optimization :)
            var TEMPLATE =
                '<div class="rm-datepicker" ng-class="{mondayStart: mondayStart}" ng-show="show" ng-style="style">' +
                '<div class="nav">' +
                '<a><i class="fa fa-angle-left"></i></a>' +
                '<a class="back waves-effect" ng-click="toggleState(-1)" rm-include="activeDateTpl[state]"></a>' +
                '<a class="adjacent waves-effect" ng-click="prev()"><i class="fa fa-angle-up"></i></a>' +
                '<a class="adjacent waves-effect" ng-click="next()"><i class="fa fa-angle-down"></i></a>' +
                '<a class="today waves-effect" ng-click="now()">Today</a>' +
                '</div>' +
                '<div class="body" ng-include="\'rm-\' + state + \'.html\'"></div>' +
                '</div>' +

                '<script type="text/ng-template" id="rm-decade.html">' +
                '<div class="ng-class: state; square date">' +
                '<div ng-repeat="oDate in aDates" ng-class="{j: isActive[\'year\'](oDate), off: isOff(oDate)}">' +
                '<a ng-click="go(oDate)" class="waves-effect"><span>{{oDate | date: \'yyyy\'}}</span></a>' +
                '</div>' +
                '</div>' +
                '</script>' +

                '<script type="text/ng-template" id="rm-year.html">' +
                '<div class="ng-class: state; square date">' +
                '<div ng-repeat="oDate in aDates" ng-class="{j: isActive[\'month\'](oDate), off: isOff(oDate)}">' +
                '<a ng-click="go(oDate)" class="waves-effect"><span>{{oDate | date: \'MMM\'}}</span></a>' +
                '</div>' +
                '</div>' +
                '</script>' +

                '<script type="text/ng-template" id="rm-month.html">' +
                '<div class="day sunSat" ng-if="state == \'month\'">' +
                '<a ng-repeat="day in aWeekDay">{{day}}</a>' +
                '</div>' +
                '<div class="ng-class: state; square date">' +
                '<div ng-repeat="oDate in aDates" ng-class="[{j: isActive[\'date\'](oDate), off: isOff(oDate), out: !isActive[\'month\'](oDate)}, checkMark(oDate)]">' +
                '<a ng-click="go(oDate)" class="waves-effect"><span>{{oDate.getDate()}}</span></a>' +
                '</div>' +
                '</div>' +
                '</script>';

            return {
                require: 'ngModel',
                scope: {
                    j: '=ngModel', /* active date */
                    rmConfig: "="
                },
                link: link
            }
        }]);

    Module.directive('rmInclude', ['$compile', function ($compile) {

        var link = function (scope, element, attrs) {
            scope.$watch(
                function (scope) {
                    return scope.$eval(attrs.rmInclude);
                }
                , function (value) {
                    element.html(value);
                    $compile(element.contents())(scope);
                });
        };

        return {
            restrict: "A",
            link: link
        };
    }]);
}());

/*!
 * RM-DATEPICKER v1.0.0
 * http://rubymage.com
 *
 * Copyright 2015 Sergiu Ghenciu, RUBYMAGE
 * Released under the MIT license
 * https://github.com/RUBYMAGE/angular-datepicker/blob/master/LICENSE
 */

(function () {
    'use strict';

    var Module = angular.module('rm2Datepicker', []);

    Module.constant('rm2DatepickerConfig', {
        mondayStart: false,
        initState: "month",
        maxState: "decade",
        minState: "month",
        toggleState: true,

        decadeSize: 12,
        monthSize: 42, /* "auto" || fixed nr. (35 or 42) */

        min: null,
        max: null,
        format: "yyyy-MM-dd",
        markDates: null,
        subscribe: null,
        broadcast: null,
        redraw: null
    });

    Module.directive("rm2Datepicker", ['rm2DatepickerConfig', '$compile', '$filter', '$document', 'DateUtils', '$rootScope',
        function (rm2DatepickerConfig, $compile, $filter, $document, DateUtils, $rootScope) {

            var link = function (scope, element, attrs, ngModel) {
                var conf = angular.copy(rm2DatepickerConfig);

                if (scope.rmConfig) {
                    for (var prop in conf)
                        if (conf.hasOwnProperty(prop))
                            if (scope.rmConfig[prop] != undefined) conf[prop] = scope.rmConfig[prop];
                }
                if (conf.min) conf.min.setHours(0, 0, 0, 0);
                if (conf.max) conf.max.setHours(23, 59, 59, 999);

                var isInput = element[0].tagName.toUpperCase() == "INPUT";
                var isReached = {
                    min: false,
                    max: false
                };
                var daysInMonth = function (year, month) {
                    return new Date(year, month + 1, 0).getDate();
                };
                var adjustDate = function (date) {
                    var date = parseInt(date, 10);
                    if (!isNaN(date)) {
                        var max = daysInMonth(scope.j.getFullYear(), scope.j.getMonth());
                        if (date < 1) date = 1;
                        if (date > max) date = max;
                        scope.j.setDate(date);
                    }
                };
                var gen = {
                    decade: function (oDate) {
                        var Y = oDate.getFullYear(),
                            m = oDate.getMonth(),
                            d = oDate.getDate(),
                            max,
                            i = 0,
                            n = conf.decadeSize || 12; // count of years in decade
                        var aDecade = new Array(n);

                        Y = Math.floor(Y / n) * n; // begin year of current decade

                        for (; i < n; Y++, i++) {
                            max = daysInMonth(Y, m);
                            if (d > max) d = max;
                            aDecade[i] = new Date(Y, m, d, 3, 0, 1, 0);
                        }
                        return aDecade;
                    },
                    year: function (oDate) {
                        var Y = oDate.getFullYear(),
                            m = 0,
                            d = oDate.getDate(),
                            max;
                        var aYear = [];
                        for (; m < 12; m++) {
                            max = daysInMonth(Y, m);
                            if (d > max) d = max;
                            aYear.push(new Date(Y, m, d, 3, 0, 1, 0));
                        }
                        return aYear;
                    },
                    month: function (oDate) {
                        var Y = oDate.getFullYear(),
                            m = oDate.getMonth(),
                            startDate = new Date(Y, m, 1, 3, 0, 1, 0),
                            n;
                        var startPos = startDate.getDay() || 7;
                        if (scope.mondayStart) startPos = startPos - 1 || 7;

                        if (conf.monthSize == "auto")
                            n = ( startPos + daysInMonth(Y, m) < 35 ) ? 35 : 42;
                        else
                            n = conf.monthSize;

                        startDate.setDate(-startPos + 1);
                        return gen.dates(startDate, n);
                    },
                    dates: function (startDate, n) {
                        var aDates = new Array(n),
                            current = new Date(startDate),
                            i = 0;
                        while (i < n) {
                            aDates[i++] = new Date(current);
                            current.setDate(current.getDate() + 1);
                        }
                        return aDates;
                    }
                };
                var refresh = function (state) {
                    state = state || scope.state;
                    // scope.marks = conf.markDates(scope.j);
                    scope.aDates = gen[state](scope.j);

                    if (conf.min) {
                        //if(scope.aDates[0] < conf.min) scope.aDates[0].setDate( conf.min.getDate() );
                        isReached.min = scope.aDates[0] < conf.min;
                    }
                    if (conf.max) {
                        var oDate = scope.aDates[scope.aDates.length - 1];
                        //if(oDate > conf.max) oDate.setDate( conf.max.getDate() );
                        isReached.max = oDate > conf.max;
                    }
                };
                var init = function () {
                    scope.marks = conf.markDates(scope.j);
                    return refresh();
                };

                //TODO: optimize this method
                var isBefore = function (oDate1, oDate2) {
                    if (scope.state == "decade")
                        return oDate1.getFullYear() < oDate2.getFullYear();

                    if (scope.state == "year") {
                        if (oDate1.getFullYear() == oDate2.getFullYear())
                            return oDate1.getMonth() < oDate2.getMonth();
                        else
                            return oDate1.getFullYear() < oDate2.getFullYear();
                    }

                    return oDate1 < oDate2;
                };
                scope.isOff = function (oDate) {
                    if (!conf.min && !conf.max)
                        return false;
                    if (conf.min && isBefore(oDate, conf.min))
                        return true;
                    if (conf.max && isBefore(conf.max, oDate))
                        return true;
                };
                scope.isActive = {
                    year: function (oDate) {
                        return oDate.getFullYear() == scope.j.getFullYear();
                    },
                    month: function (oDate) {
                        return oDate.getMonth() == scope.j.getMonth();
                    },
                    date: function (oDate) {
                        return oDate.getDate() == scope.j.getDate();
                    }
                };
                scope.isToday = function (oDate) {
                    return scope.isActive.date(oDate)
                        && scope.isActive.month(oDate)
                        && scope.isActive.year(oDate);
                };

                scope.go = function (oDate) {
                    if (scope.isOff(oDate)) return;

                    if (isInput && scope.state == conf.minState && scope.isActive.month(oDate)) {
                        scope.show = false;
                        overlay.css("display", "none");
                    }

                    var m = scope.j.getMonth();
                    var y = scope.j.getYear();

                    scope.j = new Date(oDate);
                    if (conf.toggleState) scope.toggleState(1);

                    if (m != scope.j.getMonth() && y != scope.j.getYear()) {
                        scope.marks = conf.markDates(scope.j);
                        refresh();
                    }
                };
                scope.now = function () {
                    var m = scope.j.getMonth();

                    scope.j = new Date();

                    if (m != scope.j.getMonth()) {
                        scope.marks = conf.markDates(scope.j);
                    }

                    refresh();
                    $rootScope.$broadcast(conf.broadcast, scope.j);
                };
                scope.next = function (delta) {
                    delta = delta || 1;

                    if (delta > 0) {
                        if (isReached.max) return;
                    }
                    else {
                        if (isReached.min) return;
                    }

                    var Y = scope.j.getFullYear(),
                        m = scope.j.getMonth(),
                        d = scope.j.getDate();

                    switch (scope.state) {
                        case "decade":
                            delta = delta * scope.aDates.length;
                        case "year":
                            scope.j.setFullYear(Y + delta, m, 15);
                            adjustDate(d);
                            break;
                        case "month":
                            scope.j.setMonth(m + delta, 15);
                            adjustDate(d);
                            break;
                        case "week" :
                            scope.j.setDate(d + (delta * 7));
                            break;
                    }

                    refresh();
                    scope.marks = conf.markDates(scope.j);
                    $rootScope.$broadcast(conf.broadcast, scope.j);
                };
                scope.prev = function (delta) {
                    // delta = (delta == undefined) ? 1 : Math.abs( delta );
                    return scope.next(-delta || -1);
                };
                scope.toggleState = function (direction) {
                    direction = direction || 1;

                    if (scope.state == conf.maxState && direction == -1 ||
                        scope.state == conf.minState && direction == 1) {
                        return;
                    }
                    scope.state = scope.aStates[scope.aStates.indexOf(scope.state) + direction];
                    refresh();
                };

                scope.mondayStart = conf.mondayStart;
                scope.aWeekDay = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                if (scope.mondayStart) scope.aWeekDay.push(scope.aWeekDay.shift());

                scope.aStates = ["decade", "year", "month"];
                scope.state = conf.initState;

                //TODO: this(together with rmInclude directive below) is a quick implementation, maybe there is a better idea
                scope.activeDateTpl = {
                    decade: "{{aDates[0].getFullYear()}} - {{aDates[aDates.length-1].getFullYear()}}",
                    year: "{{j.getFullYear()}}",
                    month: "{{j | date: 'MMMM yyyy'}}",
                    week: "{{ j | date: 'd MMMM yyyy' }}"
                };

                init(); // generate initial state

                var offset = function (objElement) {
                    var x = 0, y = 0;

                    if (objElement.offsetParent) {
                        do {
                            x += objElement.offsetLeft;
                            y += objElement.offsetTop;
                        } while (objElement = objElement.offsetParent);
                    }
                    return {top: y, left: x};
                };
                var togglePicker = function (toggle) {
                    overlay.css("display", toggle ? "block" : "none");
                    scope.show = toggle;
                    scope.$apply();
                };
                var adjustPos = function (el) {
                    var scrollX = window.scrollX,
                        scrollY = window.scrollY,
                        innerWidth = window.innerWidth,
                        innerHeight = window.innerHeight;

                    if (window.innerWidth < 481)
                        return {top: scrollY, left: 0};

                    var pos = offset(el),
                        marginBottom = scrollY + innerHeight - pos.top - el.clientHeight,
                        marginRight = scrollX + innerWidth - pos.left - el.clientWidth;

                    if (marginBottom < 0) pos.top += marginBottom;
                    if (pos.top < scrollY) pos.top = scrollY;
                    if (marginRight < 0) pos.left += marginRight;
                    if (pos.left < 0) pos.left = 0;

                    return pos;
                };

                if (isInput) {
                    scope.show = false;

                    ngModel.$parsers.push(function (sDate) {
                        return new Date(sDate);
                    });
                    ngModel.$formatters.push(function (oDate) {
                        return $filter('date')(oDate, conf.format);
                    });

                    element.after($compile(TEMPLATE)(scope));

                    var calendar = element.next();
                    var overlay = angular.element('<div class="rm-overlay" style="display:none"></div>');
                    overlay.on('click', function () {
                        togglePicker(false);
                    });
                    $document.find('body').eq(0).append(overlay);

                    element.on('click', function () {

                        if (window.innerWidth < 481) element[0].blur();
                        var pos = offset(element[0]);
                        pos.top += element[0].offsetHeight + 1;

                        scope.style = {top: pos.top + "px", left: pos.left + "px"};
                        togglePicker(true);
                        pos = adjustPos(calendar[0]);
                        scope.style = {top: pos.top + "px", left: pos.left + "px"};
                        scope.$apply();
                    });

                    $document.on('keydown', function (e) {
                        if ([9, 13, 27].indexOf(e.keyCode) >= 0) togglePicker(false);
                    });
                }
                else {
                    scope.show = true;
                    element.append($compile(TEMPLATE)(scope));
                }
                ;

                scope.checkMark = function (oDate) {
                    var _mark = $.grep(scope.marks, function (mark, i) {
                        return mark.date == DateUtils.convertLocalDateToServer(oDate);
                    });

                    if (_mark == null || _mark.length == 0) {
                        return '';
                    }

                    return _mark[0].class;
                }

                $rootScope.$on(conf.subscribe, function (event, result) {
                    var m = scope.j.getMonth();

                    scope.j = new Date(result);

                    if (m != scope.j.getMonth()) {
                        scope.marks = conf.markDates(scope.j);
                    }

                    refresh();
                });

                $rootScope.$on(conf.redraw, function (event, result) {
                    scope.marks = conf.markDates(scope.j);

                    refresh();
                });
            };

            //TODO: template may need optimization :)
            var TEMPLATE =
                '<div class="rm-datepicker" ng-class="{mondayStart: mondayStart}" ng-show="show" ng-style="style">' +
                '<div class="nav">' +
                '<a><i class="fa fa-angle-left"></i></a>' +
                '<a class="back waves-effect" ng-click="toggleState(-1)" rm-include="activeDateTpl[state]"></a>' +
                '<a class="adjacent waves-effect" ng-click="prev()"><i class="fa fa-angle-up"></i></a>' +
                '<a class="adjacent waves-effect" ng-click="next()"><i class="fa fa-angle-down"></i></a>' +
                '<a class="today waves-effect" ng-click="now()">Today</a>' +
                '</div>' +
                '<div class="body" ng-include="\'rm-\' + state + \'.html\'"></div>' +
                '</div>' +

                '<script type="text/ng-template" id="rm-decade.html">' +
                '<div class="ng-class: state; square date">' +
                '<div ng-repeat="oDate in aDates" ng-class="{j: isActive[\'year\'](oDate), off: isOff(oDate)}">' +
                '<a ng-click="go(oDate)" class="waves-effect"><span>{{oDate | date: \'yyyy\'}}</span></a>' +
                '</div>' +
                '</div>' +
                '</script>' +

                '<script type="text/ng-template" id="rm-year.html">' +
                '<div class="ng-class: state; square date">' +
                '<div ng-repeat="oDate in aDates" ng-class="{j: isActive[\'month\'](oDate), off: isOff(oDate)}">' +
                '<a ng-click="go(oDate)" class="waves-effect"><span>{{oDate | date: \'MMM\'}}</span></a>' +
                '</div>' +
                '</div>' +
                '</script>' +

                '<script type="text/ng-template" id="rm-month.html">' +
                '<div class="day sunSat" ng-if="state == \'month\'">' +
                '<a ng-repeat="day in aWeekDay">{{day}}</a>' +
                '</div>' +
                '<div class="ng-class: state; square date">' +
                '<div ng-repeat="oDate in aDates" ng-class="[{j: isActive[\'date\'](oDate), off: isOff(oDate), out: !isActive[\'month\'](oDate)}, checkMark(oDate)]">' +
                '<a ng-click="go(oDate)" class="waves-effect"><span>{{oDate.getDate()}}</span></a>' +
                '</div>' +
                '</div>' +
                '</script>';

            return {
                require: 'ngModel',
                scope: {
                    j: '=ngModel', /* active date */
                    rmConfig: "="
                },
                link: link
            }
        }]);

    Module.directive('rmInclude', ['$compile', function ($compile) {

        var link = function (scope, element, attrs) {
            scope.$watch(
                function (scope) {
                    return scope.$eval(attrs.rmInclude);
                }
                , function (value) {
                    element.html(value);
                    $compile(element.contents())(scope);
                });
        };

        return {
            restrict: "A",
            link: link
        };
    }]);


}());

(function () {
    'use strict';

    angular
        .module('udt')
        .filter('propsFilter', propsFilter);

    /**
     * AngularJS default filter with the following expression:
     * "person in people | filter: {name: $select.search, age: $select.search}"
     * performs an AND between 'name: $select.search' and 'age: $select.search'.
     * We want to perform an OR.
     */
    function propsFilter() {
        return function (items, props) {
            var out = [];

            if (angular.isArray(items)) {
                var keys = Object.keys(props);

                items.forEach(function(item) {
                    var itemMatches = false;

                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        if (item[prop] != null && item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                            itemMatches = true;
                            break;
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .filter('phone', phone);

    function phone() {
        return function (phone) {
            if (!phone) {
                return '';
            }

            var value = phone.toString().trim().replace(/^\+/, '');

            if (value.match(/[^0-9]/)) {
                return phone;
            }

            var country, city, number;

            switch (value.length) {
                case 10: // +1PPP####### -> C (PPP) ###-####
                    country = 1;
                    city = value.slice(0, 3);
                    number = value.slice(3);
                    break;

                case 11: // +CPPP####### -> CCC (PP) ###-####
                    country = value[0];
                    city = value.slice(1, 4);
                    number = value.slice(4);
                    break;

                case 12: // +CCCPP####### -> CCC (PP) ###-####
                    country = value.slice(0, 3);
                    city = value.slice(3, 5);
                    number = value.slice(5);
                    break;

                default:
                    return phone;
            }

            if (country == 1) {
                country = "";
            }

            number = number.slice(0, 3) + '-' + number.slice(3);

            return (country + " (" + city + ") " + number).trim();
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .factory('JSignature', JSignature);

    function JSignature() {

        var apinamespace = 'jSignature';

        var exportTypes = {
            DEFAULT: 'default',
            NATIVE: 'native',
            IMAGE: 'image',
            BASE30: 'base30',
            IMAGE_SIGNATURE_BASE30: 'image/jsignature;base30',
            SVG: 'svg',
            SVG_XML: 'image/svg+xml',
            SVG_BASE64: 'svgbase64',
            IMAGE_SVG_XML_BASE64: 'image/svg+xml;base64'
        }

        var importTypes = {
            NATIVE: 'native',
            IMAGE: 'image',
            IMAGE_PNG_BASE64: 'image/png;base64',
            IMAGE_JPEG_BASE64: 'image/jpeg;base64',
            IMAGE_JPG_BASE64: 'image/jpg;base64'
        }

        var object = {
            initialized: false,
            options: {
                width: null,
                height: null,
                color: null,
                'background-color': null,
                lineWidth: null,
                cssclass: null,
                UndoButton: false
            },
            element: null
        };

        var service = {
            getObject:getObject,
            exportTypes: exportTypes,
            importTypes: importTypes,
            initialize: initialize,
            reset: reset,
            getData: getData,
            // setData: setData,
            disable: disable,
            enable: enable
        };

        return service;

        function initialize(element, options) {

            object.initialized = false;

            if (!object.initialized) {
                // object.element = element.find('#jSignature').jSignature(options);
                object.element = $('#jSignature');
                object.initialized = true;
                object.element.jSignature(options);
            }
        };

        function reset() {
            // console.log('reset!!!');
            object.element.jSignature('reset');
        };

        function getData(type) {
            // console.log('getData!!!');
            return object.element.jSignature('getData', type);
        };

        function getDataAsSVG() {
            // console.log('getData!!!');
            // var datapair = object.element.jSignature('getData', 'base30');
            var svg = object.element.jSignature('getData', 'svg');
            return svg;
        };

        function getDataAsBase30() {
            // console.log('getData!!!');
            // var datapair = object.element.jSignature('getData', 'base30');
            var svg = object.element.jSignature('getData', 'svg');
            return svg;
        };

        function setData(sig) {
            // console.log('setData!!!');
            // console.log(sig);
            object.element.jSignature('setData', 'data:' + sig.join(','));
        };

        function disable() {
            // console.log('Disable!!!');
            object.element.jSignature('disable');
        };

        function enable() {
            // console.log('Enable!!!');
            object.element.jSignature('enable');
        };

        function undo() {
            var eventName = apinamespace + '.undo'
            object.element.jSignature('events');
        };

        function getObject() {
            // $('#signature').on('change', function(e){
            //     var undef
            //     if ($(e.target).jSignature('getData','native').length) {
            //         $tools.find('input').prop('disabled', false)
            //     } else {
            //         $tools.find('input').prop('disabled', true)
            //     }
            //
            // })
            return object.element;
        }



    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .directive('jSignature', jSignature);

    jSignature.$inject = ['$timeout', 'JSignature'];

    function jSignature($timeout, JSignature) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/udt/j-signature.html',
            scope: {
                sig: '=',
                width: '@',
                height: '@',
                color: '@',
                bgColor: '@',
                lineWidth: '@',
                cssclass: '@',
                undo: '@',
                save: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc($scope, $element) {

            // console.log('jSignatureDirective: link');
            // console.dir($scope, $element);

            var options = {
                width: $scope.width,
                height: $scope.height,
                color: $scope.color,
                'background-color': $scope.bgColor,
                lineWidth: $scope.lineWidth,
                cssClass: $scope.cssClass,
                UndoButton: $scope.undo
            };

            JSignature.initialize($scope, options);

            $scope.reset = function () {
                JSignature.reset();
            };

//             $scope.initialized = false;
//
//             var options = {
//                 width: $scope.width,
//                 height: $scope.height,
//                 color: $scope.color,
//                 'background-color': $scope.bgColor,
//                 lineWidth: $scope.lineWidth,
//                 cssclass: $scope.cssclass
//             };
//
//             $scope.initialize = function() {
//                 if (!$scope.initialized) {
//                     $element.find('#jSignature').jSignature(options);
//                     $scope.initialized = true;
//                 }
//             };
//
//             $scope.reset = function() {
//                 console.log('reset!!!');
//                 $element.jSignature('reset');
//             };
//
//             $scope.getData = function() {
//                 console.log('getData!!!');
//                 var datapair = $element.jSignature('getData', 'base30');
//                 var svg = $element.jSignature('getData', 'svg');
//                 console.dir(datapair);
//                 //alert(datapair);
//                 //              alert(svg);
//                 $scope.save(svg);
//             };
//
//             $scope.setData = function(sig) {
//                 console.log('setData!!!');
//
//
//
//                 if (sig) {
//                     datapair = sig;
//                 }
//                 console.log(datapair);
//                 $element.jSignature('setData', 'data:' + datapair.join(','));
//             };
//
//
//             $scope.initialize();
// //            $scope.setData();
//
//
//             $scope.$watch('sig', function(sig) {
//                 if (sig) {
//                     console.log('watch if ' + sig);
//                     $scope.setData(sig);
//                     //alert('watch if ' + sig);
//
//                     return;
//                 }
//                 console.log('watch else');
//
//             });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .directive('embedSrc', embedSrc);

    function embedSrc() {

        var directive = {
            restrict: 'A',
            link: linkFunc
        }

        return directive;

        /* private helper methods*/

        function linkFunc(scope, element, attrs) {
            var current = element;
            scope.$watch(
                function () {
                    return attrs.embedSrc;
                },
                function () {
                    var clone = element
                        .clone()
                        .attr('src', attrs.embedSrc);
                    current.replaceWith(clone);
                    current = clone;
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .factory('DYMO', DYMO);

    DYMO.$inject = ['XMLConfig', 'Base64', 'moment'];

    function DYMO(XMLConfig, Base64, moment) {
        var service = {
            loadPrinters: loadPrinters,
            loadDYMOOrderTemplate: loadDYMOOrderTemplate,
            loadDYMOEnvOrderTemplate: loadDYMOEnvOrderTemplate,
            printPatientOrderLabel: printPatientOrderLabel,
            printEnvOrderLabel: printEnvOrderLabel,
            loadDefaultDYMOOrderTemplate: loadDefaultDYMOOrderTemplate,
            loadDefaultDYMOEnvOrderTemplate: loadDefaultDYMOEnvOrderTemplate,
            testPatientLabel: testPatientLabel,
            testEnvironmentalLabel: testEnvironmentalLabel,
            printPatientBarcodes: printPatientBarcodes,
            printEnvBarcodes: printEnvBarcodes
       };

        return service;

        var printersSelect = '';
        var orderTemplate;
        var envOrdertemplate;

        loadPrinters();
        function loadPrinters() {
            var printers = dymo.label.framework.getLabelWriterPrinters();
            if (printers.length == 0) {
                // alert("No DYMO printers are installed. Install DYMO printers.");
                return false;
            }

            for (var i = 0; i < printers.length; i++) {
                var printer = printers[i];

                var printerName = printer.name;
                printersSelect = printerName;
            }

            return true;
        }

        function loadDYMOOrderTemplate(xml) {
            orderTemplate = dymo.label.framework.openLabelXml(xml);
        }

        function loadDYMOEnvOrderTemplate(xml) {
            envOrdertemplate = dymo.label.framework.openLabelXml(xml);
        }

        function printPatientOrderLabel(data) {
            if (!orderTemplate){
                loadDefaultDYMOOrderTemplate();
            }

            orderTemplate.setObjectText('barcode', data.barcode);
            orderTemplate.setObjectText('name', data.name);
            orderTemplate.setObjectText('dob', moment(data.dob).format("MM/DD/YYYY"));
            orderTemplate.setObjectText('collectedDate', moment(data.collectedDate).format("MM/DD/YYYY"));
            orderTemplate.setObjectText('tube', data.tube);
            orderTemplate.setObjectText('account', data.account);

            orderTemplate.print(printersSelect);
        }

        function printEnvOrderLabel(data) {
            if (!envOrdertemplate) {
                loadDefaultDYMOEnvOrderTemplate();
            }

            envOrdertemplate.setObjectText('barcode', data.barcode);
            envOrdertemplate.setObjectText('name', data.machine);
            envOrdertemplate.setObjectText('collectedDate', moment(data.collectedDate).format("MM/DD/YYYY"));
            envOrdertemplate.setObjectText('tube', data.tube);
            envOrdertemplate.setObjectText('account', data.account);

            envOrdertemplate.print(printersSelect);
        }

        function loadDefaultDYMOOrderTemplate() {
            XMLConfig.patient().$promise.then(function(data) {
                orderTemplate = dymo.label.framework.openLabelXml(Base64.decode(data.file.replace("77u/", "")));
            }, function() {
                orderTemplate = dymo.label.framework.openLabelXml('<?xml version="1.0" encoding="utf-8"?><DieCutLabel Version="8.0" Units="twips"><PaperOrientation>Landscape</PaperOrientation><Id>Address</Id><IsOutlined>false</IsOutlined><PaperName>30252 Address</PaperName><DrawCommands><RoundRectangle X="0" Y="0" Width="1581" Height="5040" Rx="270" Ry="270" /></DrawCommands><ObjectInfo><BarcodeObject><Name>barcode</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>True</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><Text>1234567890</Text><Type>Code128Auto</Type><Size>Medium</Size><TextPosition>Bottom</TextPosition><TextFont Family="Arial" Size="7.3125" Bold="False" Italic="False" Underline="False" Strikeout="False" /><CheckSumFont Family="Arial" Size="7.3125" Bold="False" Italic="False" Underline="False" Strikeout="False" /><TextEmbedding>None</TextEmbedding><ECLevel>0</ECLevel><HorizontalAlignment>Center</HorizontalAlignment><QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" /></BarcodeObject><Bounds X="331" Y="150.600006103516" Width="2672" Height="750" /></ObjectInfo><ObjectInfo><TextObject><Name>name</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>False</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><HorizontalAlignment>Left</HorizontalAlignment><VerticalAlignment>Top</VerticalAlignment><TextFitMode>ShrinkToFit</TextFitMode><UseFullFontHeight>True</UseFullFontHeight><Verticalized>False</Verticalized><StyledText><Element><String xml:space="preserve">Jhon Doe</String><Attributes><Font Family="Arial" Size="8" Bold="True" Italic="False" Underline="False" Strikeout="False" /><ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" /></Attributes></Element></StyledText></TextObject><Bounds X="1601" Y="953" Width="1940" Height="230" /></ObjectInfo><ObjectInfo><TextObject><Name>dob</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>False</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><HorizontalAlignment>Left</HorizontalAlignment><VerticalAlignment>Top</VerticalAlignment><TextFitMode>ShrinkToFit</TextFitMode><UseFullFontHeight>True</UseFullFontHeight><Verticalized>False</Verticalized><StyledText><Element><String xml:space="preserve">01/01/2016</String><Attributes><Font Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" /><ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" /></Attributes></Element></StyledText></TextObject><Bounds X="751" Y="1178" Width="870" Height="270" /></ObjectInfo><ObjectInfo><TextObject><Name>collectedDate</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>False</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><HorizontalAlignment>Left</HorizontalAlignment><VerticalAlignment>Top</VerticalAlignment><TextFitMode>ShrinkToFit</TextFitMode><UseFullFontHeight>True</UseFullFontHeight><Verticalized>False</Verticalized><StyledText><Element><String xml:space="preserve">01/01/2016</String><Attributes><Font Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" /><ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" /></Attributes></Element></StyledText></TextObject><Bounds X="738.000000000001" Y="953" Width="870.000000000002" Height="270" /></ObjectInfo><ObjectInfo><TextObject><Name>compendium</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>False</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><HorizontalAlignment>Left</HorizontalAlignment><VerticalAlignment>Top</VerticalAlignment><TextFitMode>ShrinkToFit</TextFitMode><UseFullFontHeight>True</UseFullFontHeight><Verticalized>False</Verticalized><StyledText><Element><String xml:space="preserve">test te test</String><Attributes><Font Family="Tahoma" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" /><ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" /></Attributes></Element></StyledText></TextObject><Bounds X="1998" Y="1163" Width="2250" Height="270" /></ObjectInfo><ObjectInfo><TextObject><Name>TEXTO____1</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>False</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><HorizontalAlignment>Left</HorizontalAlignment><VerticalAlignment>Top</VerticalAlignment><TextFitMode>ShrinkToFit</TextFitMode><UseFullFontHeight>True</UseFullFontHeight><Verticalized>False</Verticalized><StyledText><Element><String xml:space="preserve">COL:</String><Attributes><Font Family="Arial" Size="8" Bold="True" Italic="False" Underline="False" Strikeout="False" /><ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" /></Attributes></Element></StyledText></TextObject><Bounds X="331" Y="953" Width="445.000000000001" Height="270" /></ObjectInfo><ObjectInfo><TextObject><Name>TEXTO_____1</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>False</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><HorizontalAlignment>Left</HorizontalAlignment><VerticalAlignment>Top</VerticalAlignment><TextFitMode>ShrinkToFit</TextFitMode><UseFullFontHeight>True</UseFullFontHeight><Verticalized>False</Verticalized><StyledText><Element><String xml:space="preserve">Test:</String><Attributes><Font Family="Arial" Size="8" Bold="True" Italic="False" Underline="False" Strikeout="False" /><ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" /></Attributes></Element></StyledText></TextObject><Bounds X="1606" Y="1178" Width="435.000000000001" Height="270" /></ObjectInfo><ObjectInfo><TextObject><Name>TEXTO__2</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>False</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><HorizontalAlignment>Left</HorizontalAlignment><VerticalAlignment>Top</VerticalAlignment><TextFitMode>ShrinkToFit</TextFitMode><UseFullFontHeight>True</UseFullFontHeight><Verticalized>False</Verticalized><StyledText><Element><String xml:space="preserve">DOB:</String><Attributes><Font Family="Arial" Size="8" Bold="True" Italic="False" Underline="False" Strikeout="False" /><ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" /></Attributes></Element></StyledText></TextObject><Bounds X="331" Y="1178" Width="584.999999999999" Height="270" /></ObjectInfo></DieCutLabel>');
            });
        }

        function loadDefaultDYMOEnvOrderTemplate() {
            XMLConfig.environmental().$promise.then(function(data) {
                envOrdertemplate = dymo.label.framework.openLabelXml(Base64.decode(data.file.replace("77u/", "")));
            }, function() {
                envOrdertemplate = dymo.label.framework.openLabelXml('<?xml version="1.0" encoding="utf-8"?><DieCutLabel Version="8.0" Units="twips"><PaperOrientation>Landscape</PaperOrientation><Id>Address</Id><IsOutlined>false</IsOutlined><PaperName>30252 Address</PaperName><DrawCommands><RoundRectangle X="0" Y="0" Width="1581" Height="5040" Rx="270" Ry="270" /></DrawCommands><ObjectInfo><BarcodeObject><Name>barcode</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>True</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><Text>1234567890</Text><Type>Code128Auto</Type><Size>Medium</Size><TextPosition>Bottom</TextPosition><TextFont Family="Arial" Size="7.3125" Bold="False" Italic="False" Underline="False" Strikeout="False" /><CheckSumFont Family="Arial" Size="7.3125" Bold="False" Italic="False" Underline="False" Strikeout="False" /><TextEmbedding>None</TextEmbedding><ECLevel>0</ECLevel><HorizontalAlignment>Center</HorizontalAlignment><QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" /></BarcodeObject><Bounds X="331" Y="150.600006103516" Width="2672" Height="580" /></ObjectInfo><ObjectInfo><TextObject><Name>name</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>False</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><HorizontalAlignment>Left</HorizontalAlignment><VerticalAlignment>Top</VerticalAlignment><TextFitMode>ShrinkToFit</TextFitMode><UseFullFontHeight>True</UseFullFontHeight><Verticalized>False</Verticalized><StyledText><Element><String xml:space="preserve">Jhon Doe</String><Attributes><Font Family="Arial" Size="8" Bold="True" Italic="False" Underline="False" Strikeout="False" /><ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" /></Attributes></Element></StyledText></TextObject><Bounds X="331" Y="798" Width="1740" Height="220" /></ObjectInfo><ObjectInfo><TextObject><Name>collectedDate</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>False</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><HorizontalAlignment>Left</HorizontalAlignment><VerticalAlignment>Top</VerticalAlignment><TextFitMode>ShrinkToFit</TextFitMode><UseFullFontHeight>True</UseFullFontHeight><Verticalized>False</Verticalized><StyledText><Element><String xml:space="preserve">01/01/2016</String><Attributes><Font Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" /><ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" /></Attributes></Element></StyledText></TextObject><Bounds X="753.000000000001" Y="998" Width="1290" Height="270" /></ObjectInfo><ObjectInfo><TextObject><Name>tube</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>False</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><HorizontalAlignment>Left</HorizontalAlignment><VerticalAlignment>Top</VerticalAlignment><TextFitMode>ShrinkToFit</TextFitMode><UseFullFontHeight>True</UseFullFontHeight><Verticalized>False</Verticalized><StyledText><Element><String xml:space="preserve">test te test</String><Attributes><Font Family="Tahoma" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" /><ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" /></Attributes></Element></StyledText></TextObject><Bounds X="332.999999999999" Y="1223" Width="2250" Height="270" /></ObjectInfo><ObjectInfo><TextObject><Name>TEXTO____1</Name><ForeColor Alpha="255" Red="0" Green="0" Blue="0" /><BackColor Alpha="0" Red="255" Green="255" Blue="255" /><LinkedObjectName /><Rotation>Rotation0</Rotation><IsMirrored>False</IsMirrored><IsVariable>False</IsVariable><GroupID>-1</GroupID><IsOutlined>False</IsOutlined><HorizontalAlignment>Left</HorizontalAlignment><VerticalAlignment>Top</VerticalAlignment><TextFitMode>ShrinkToFit</TextFitMode><UseFullFontHeight>True</UseFullFontHeight><Verticalized>False</Verticalized><StyledText><Element><String xml:space="preserve">COL:</String><Attributes><Font Family="Arial" Size="8" Bold="True" Italic="False" Underline="False" Strikeout="False" /><ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" /></Attributes></Element></StyledText></TextObject><Bounds X="331" Y="1013" Width="945" Height="270" /></ObjectInfo></DieCutLabel>');
            });
        }

        function testPatientLabel(xml) {
            var template;
            if (xml){
                template = dymo.label.framework.openLabelXml(Base64.decode(xml.replace("77u/", "")));
            } else {
                template = orderTemplate;
            }

            template.setObjectText('barcode', 'P000001');
            template.setObjectText('name', 'Jhon Doe');
            template.setObjectText('dob', moment(new Date()).format("MM/DD/YYYY"));
            template.setObjectText('collectedDate', moment(new Date()).format("MM/DD/YYYY"));
            template.setObjectText('tube', 'Some tube name');
            template.setObjectText('account', 'DXX001');

            template.print(printersSelect);
        }

        function testEnvironmentalLabel(xml) {
            var template;
            if (xml){
                template = dymo.label.framework.openLabelXml(Base64.decode(xml.replace("77u/", "")));
            } else {
                template = envOrdertemplate;
            }

            template.setObjectText('barcode', 'E000001');
            template.setObjectText('name', 'TheMachinen');
            template.setObjectText('collectedDate', moment(new Date()).format("MM/DD/YYYY"));
            template.setObjectText('tube', 'Some tube name');
            template.setObjectText('account', 'DXX001');

            template.print(printersSelect);
        }

        function printPatientBarcodes(result) {
            for (var l = 0; l < result.length; l++) {
                printPatientOrderLabel({
                    barcode: result[l].barcode,
                    name: result[l].patientName,
                    dob: result[l].dob,
                    collectedDate: result[l].date,
                    tube: result[l].tube,
                    account: result[l].account
                });
            }
        }

        function printEnvBarcodes(result) {
            for (var l = 0; l < result.length; l++) {
                printEnvOrderLabel({
                    barcode: result[l].barcode,
                    machine: result[l].machine,
                    collectedDate: result[l].date,
                    tube: result[l].tube,
                    account: result[l].account
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .directive('compareTo', compareTo);

    function compareTo() {

        var directive = {
            require: 'ngModel',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, elem, attrs, ctrl) {
            var firstPassword = '#' + attrs.compareTo;
            elem.add(firstPassword).on('keyup', function () {
                scope.$apply(function () {
                    // console.info(elem.val() === $(firstPassword).val());
                    ctrl.$setValidity('notmatch', elem.val() === $(firstPassword).val());
                });
            });
        }
    }
})();

'use strict';

angular
    .module('ods-lib-old', [
        'ui.bootstrap',
        'ui.select',
        'webcam',
        // 'pdf',
        'ui.bootstrap.datetimepicker',
        'datatables',
        'datatables.factory',
        'datatables.bootstrap',
        'datatables.colreorder',
        'datatables.columnfilter',
        'angularMoment',
        'ui.toggle'
        // ,
        // 'dndLists',
        // 'ngTable'
    ])
    .value('version', '1.0');


(function () {
    'use strict';

    angular
        .module('ods-lib-old')
        .directive('uiSelectRequired', UiSelectRequired);

    UiSelectRequired.$inject = ['$parse'];

    function UiSelectRequired($parse) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {

                //console.log($scope.required);
                scope.riquired = $parse(attrs.uiSelectRequired)(scope);//JSON.parse(attrs.ngRequired);

                ctrl.$validators.uiSelectRequired = function (modelValue, viewValue) {

                    if (scope.riquired) {
                        var determineVal;
                        if (angular.isArray(modelValue)) {
                            determineVal = modelValue;
                        } else if (angular.isArray(viewValue)) {
                            determineVal = viewValue;
                        } else if (isEmpty(modelValue)) {
                            return false;
                        } else {
                            return true;
                        }
                        return determineVal.length > 0;
                    } else {
                        return true;
                    }
                };
            }
        };
    }

    function isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }
})();

/**
 * Created by hermeslm on 3/28/17.
 */
(function () {
    'use strict';

    angular
        .module('ods-lib-old')
        .factory('ReportsService', OdsReportsService);

    OdsReportsService.$inject = ['$q', '$http', 'moment', 'ReportParamType', 'DateUtils', '$window', '$document', 'DataUtils'];

    function OdsReportsService($q, $http, moment, OdsParamType, DateUtils, $window, $document, DataUtils) {

        var pdfFooter = function (currentPage, pageCount) {
            return {
                columns: [
                    {
                        text: 'Report filter used',
                        margin: [20, 0],
                        fontSize: 10
                    },
                    {
                        text: 'Date: ' + moment().format('MM/DD/YYYY hh:mm') + '\n' +
                        'Page ' + currentPage.toString() + ' of ' + pageCount,
                        alignment: 'right',
                        margin: [0, 0, 20, 0],
                        fontSize: 10
                    }
                ]
            };
        };

        function pdfFooterWithFilters(report) {
            if (report.params.length > 0) {

                var filters = '';
                for (var i = 0; i < report.params.length; i++) {
                    var hideParam = report.params[i].hideInFooter !== undefined ?
                        report.params[i].hideInFooter : false;
                    if (!hideParam) {
                        switch (report.params[i].type) {
                            case OdsParamType.DATE:
                                filters += report.params[i].title + ': ' +
                                    DateUtils.formatter(report.params[i].value, 'MM/dd/yyyy') + '\n';
                                break;
                            // case ParamType.NUMBER:
                            //     filters += report.params[i].title + ': ' + report.params[i].value + '\n';
                            //     break;
                            case OdsParamType.MULTI_SELECT: {
                                break;
                            }

                            default:
                                filters += report.params[i].title + ': ' + report.params[i].value + '\n';
                                break;
                        }
                    }
                }

                return function (currentPage, pageCount) {
                    return {
                        columns: [
                            {
                                text: filters,
                                margin: [20, 0],
                                fontSize: 8
                            },
                            {
                                image: 'data:image/jpeg;base64,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',
                                fit: [100, 100],
                                margin: [0, 0, 0, 0]
                            },
                            {
                                text: 'Date: ' + moment().format('MM/DD/YYYY hh:mm') + '\n' +
                                'Page ' + currentPage.toString() + ' of ' + pageCount,
                                alignment: 'right',
                                margin: [0, 0, 20, 0],
                                fontSize: 8
                            }
                        ]
                    };
                };
            } else {
                return function (currentPage, pageCount) {
                    return {
                        columns: [
                            {
                                text: 'No Filters',
                                margin: [20, 0],
                                fontSize: 8
                            },
                            {
                                text: 'Date: ' + moment().format('MM/DD/YYYY hh:mm') + '\n' +
                                'Page ' + currentPage.toString() + ' of ' + pageCount,
                                alignment: 'right',
                                margin: [0, 0, 20, 0],
                                fontSize: 8
                            }
                        ]
                    };
                };
            }

        }

        var pdfContent = [];

        var service = {
            getHttpResource: getHttpResource,
            postHttpResource: postHttpResource,
            getReport: getReport,
            downloadReport: downloadReport,
            downloadReportFromSource: downloadReportFromSource,
            getSourceReport: getSourceReport,
            isMimeSupported: isMimeSupported,
            forceDownload: forceDownload,
            forceDownloadAndOpenPDFObject: forceDownloadAndOpenPDFObject
        };

        function postHttpResource(url, data) {
            // var dataPromise = $http.post(url, data);
            // return dataPromise;

            return $http({
                method: 'POST',
                url: url,
                data: data,
                responseType: data.binary ? 'arraybuffer' : ""
            });
        }

        function getHttpResource(url) {
            var dataPromise = $http.get(url);
            return dataPromise;
        }

        return service;

        function getReport(report) {

            return $q(function (resolve, reject) {

                var postReport = buildPost(report);

                postHttpResource(report.url, postReport).then(function success(response) {
                    if (report.binary) {
                        if (report.open) {
                            DataUtils.downloadAndOpenPDFFile(response.data, response.headers);
                        } else {
                            DataUtils.downloadFile(response.data, response.headers);
                        }
                    } else {
                        //Check if the pdf is in base64
                        if (report.base64) {
                            resolve('data:application/pdf;base64,' + response.data.file);
                        } else {
                            var pdfData = response.data;
                            pdfData.footer = pdfFooterWithFilters(report);
                            var pdfFile = pdfMake.createPdf(pdfData);
                            // var pdfFile = pdfMake.createPdf(response.data);
                            pdfFile.getBase64(function (output) {
                                // resolve(base64ToUint8Array(output));
                                resolve('data:application/pdf;base64,' + output);
                            });
                        }
                    }
                }, function error(response) {
                    var pdfFile = pdfMake.createPdf(createErrorPdf(response));
                    // var pdfFile = pdfMake.createPdf(response.data);
                    pdfFile.getBase64(function (output) {
                        // resolve(base64ToUint8Array(output));
                        resolve('data:application/pdf;base64,' + output);
                    });
                    // console.log(response);
                });
            });
        }

        function downloadReport(report) {

            var postReport = buildPost(report);

            postHttpResource(report.url, postReport).then(function success(response) {

                //Check if the pdf is in base64
                if (report.base64) {
                    download(response.data.file, report.title);
                } else {
                    var pdfData = response.data;
                    pdfData.footer = pdfFooterWithFilters(report);
                    pdfMake.createPdf(pdfData).download(report.title);
                }
            }, function error(response) {
                pdfMake.createPdf(createErrorPdf(response)).download(report.title);
            });
        }

        function download(base64Data, title) {

            var arrBuffer = base64ToArrayBuffer(base64Data);

            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([arrBuffer], {type: "application/pdf"});

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);
                return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            var data = window.URL.createObjectURL(newBlob);

            var link = document.createElement('a');
            document.body.appendChild(link); //required in FF, optional for Chrome
            link.href = data;
            link.download = title + ".pdf";
            link.click();
            window.URL.revokeObjectURL(data);
            link.remove();
        }

        function base64ToArrayBuffer(data) {

            var binaryString = window.atob(data);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        }

        function downloadReportFromSource(pdfSource, report) {
            var pdfData = pdfSource;
            pdfData.footer = pdfFooterWithFilters(report);
            pdfMake.createPdf(pdfData).download(report.title);
        }

        function getSourceReport(report) {

            return $q(function (resolve, reject) {

                var postReport = buildPost(report);

                postHttpResource(report.url, postReport).then(function success(response) {

                    //Check if the pdf is in base64
                    if (report.base64) {
                        resolve('data:application/pdf;base64,' + response.data.file);
                    } else {
                        var pdfData = response.data;
                        pdfData.footer = pdfFooterWithFilters(report);
                        resolve(pdfData);
                    }
                }, function error(response) {
                    var pdfFile = createErrorPdf(response);
                    resolve(pdfFile);
                });
            });
        }

        function createErrorPdf(response) {

            var dd = {
                'content': [
                    {text: 'Error loading report with status: ' + response.status, color: '#ff0000'},
                    {text: 'Status text: ' + response.statusText, color: '#ff0000'},
                ]
            };

            return dd;
        }

        function isMimeSupported() {

            if ($window.navigator && $window.navigator.mimeTypes && $window.navigator.mimeTypes['application/pdf']) {
                // You may add extra attributes (eg. to allow transparency) or style the iframe
                return true;
            } else {
                return false;
            }
        }

        function buildUrl(report) {

            var url = report.url;
            for (var i = 0; i < report.params.length; i++) {
                var value;
                switch (report.params[i].type) {
                    case OdsParamType.DATE:
                        value = DateUtils.convertLocalDateToServer(report.params[i].value);
                        break;
                    default:
                        value = report.params[i].value;
                        break;
                }
                url += '/' + value;
            }
            return url;
        }

        function buildPost(report) {

            // var url = report.url;
            var params = [];
            for (var i = 0; i < report.params.length; i++) {
                var param = {
                    name: report.params[i].name,
                    type: report.params[i].type,
                    value: null
                };
                switch (report.params[i].type) {
                    case OdsParamType.DATE:
                        param.value = [DateUtils.convertLocalDateToServer(report.params[i].value)];
                        break;
                    case OdsParamType.LIST:
                        param.value = [report.params[i].value];
                        break;
                    case OdsParamType.SINGLE_SELECT:
                        var idField = report.params[i].valueField !== undefined ? report.params[i].valueField : 'id';
                        param.value = [report.params[i].value[idField]];
                        break;
                    case OdsParamType.MULTI_SELECT:
                        var tmpParams = [];
                        for (var j = 0; j < report.params[i].value.length; j++) {
                            var idField = report.params[i].valueField !== undefined ? report.params[i].valueField : 'id';
                            tmpParams.push(report.params[i].value[j][idField]);
                        }
                        param.value = tmpParams;
                        break;
                    case OdsParamType.TABLE_SELECT:
                        var tmpParams = [];
                        for (var key in report.params[i].value) {
                            if (key === 'length' || !report.params[i].value.hasOwnProperty(key)) continue;
                            var value = key;
                            if (report.params[i].value[key]) {
                                tmpParams.push(value);
                            }

                        }
                        param.value = tmpParams;
                        break;
                    default:
                        param.value = [report.params[i].value];
                        break;
                }
                params.push(param);
            }

            var postReport = {
                title: report.title,
                params: params,
                pageOrientation: report.pageOrientation,
                binary: report.binary
            };

            return postReport;
        }

        function forceDownload(report) {
            var postReport = buildPost(report);

            postHttpResource(report.url, postReport).then(function success(response) {
                var contentType = response.headers('Content-Type');
                var contentDisp = response.headers('Content-Disposition');
                var index = contentDisp.indexOf('filename="');

                var filename = "filename";

                if (index != -1) {
                    var i = index + 10;
                    while (contentDisp[i] != '"') {
                        i++;
                    }

                    filename = contentDisp.substring(index + 10, i);
                }

                var a = document.createElement("a");
                a.href = URL.createObjectURL(new Blob([response.data], {type: contentType}));
                a.download = filename;
                a.click();
            }, function error(response) {
                pdfMake.createPdf(createErrorPdf(response)).download(report.title);
            });
        }

        function forceDownloadAndOpenPDFObject(data) {
            pdfMake.createPdf(data).open();
        }
    }
})();

/**
 * Created by hermeslm on 3/28/17.
 */
'use strict';

angular
    .module('ods-lib-old')
    .directive('reports', ReportsDirective);

ReportsDirective.$inject = ['ReportsService', '$uibModal', '$sce', '$q'];

function ReportsDirective(OdsReportsService, $uibModal, $sce, $q) {

    var directive = {
        restrict: 'E',
        templateUrl: 'app/components/ods-lib/reports/reports.html',
        scope: {
            reportsGroup: '='
        },
        link: linkFunc
    };

    return directive;

    /* private helper methods*/

    function linkFunc($scope, $element) {

        var BASE64_MARKER = ';base64,';

        function convertDataURIToBinary(uri, buffer) {

            var marker = ';base64,',
                raw = window.atob(uri.substring(uri.indexOf(marker) + marker.length)),
                n = raw.length,
                a = new Uint8Array(new ArrayBuffer(n));
            for(var i = 0; i < n ; i++){
                a[i] = raw.charCodeAt(i);
            }
            return buffer ? a.buffer : a;


            // let base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
            // let base64 = dataURI.substring(base64Index);
            // let raw = window.atob(base64);
            // let rawLength = raw.length;
            // let array = new Uint8Array(new ArrayBuffer(rawLength));
            //
            // for(let i = 0; i < rawLength; i++) {
            //     array[i] = raw.charCodeAt(i);
            // }
            // return array;
        }

        $scope.infoMessage = true;
        $scope.selectReport = null;
        $scope.reportFile = getUrlReport();
        $scope.hideInfoMessage = hideInfoMessage;
        $scope.downloadReport = downloadReport;
        $scope.openReport = openReport;

        function getUrlReport(url) {
            return $sce.trustAsResourceUrl(url);
        }

        function hideInfoMessage() {
            $scope.infoMessage = false;
        }

        function openReport(groupIndex, reportIndex) {

            $scope.selectReport = null;

            var report = angular.copy($scope.reportsGroup.groups[groupIndex].reports[reportIndex]);
            var size = report.modalSize ? report.modalSize : 'sm';

            if (report.params.length > 0 &&
                $.grep(report.params, function (param, i) {
                    if (param.hidden) {
                        return param.hidden === false;
                    } else {
                        return true;
                    }
                }).length > 0) {
                $uibModal.open({
                    templateUrl: 'app/components/ods-lib/reports/params.html',
                    controller: 'OdsParamsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: size,
                    resolve: {
                        report: [function () {
                            var deferred = $q.defer();
                            deferred.resolve(report);
                            return deferred.promise;
                        }]
                    }
                }).result.then(function (report) {
                    $scope.selectReport = report;
                    open(report);
                }, function () {
                });
            } else {
                $scope.selectReport = report;
                open(report);
            }
        }

        function open(report) {
            if (report.pdf !== undefined && !report.pdf) {
                forceDownload();
            } else {
                OdsReportsService.getReport(report).then(function (outReport) {
                    $scope.reportFile = convertDataURIToBinary(outReport);//getUrlReport(outReport);
                }, function () {

                });
            }
        }

        function downloadReport() {
            OdsReportsService.downloadReport($scope.selectReport);
        }

        function forceDownload() {
            OdsReportsService.forceDownload($scope.selectReport);
        }
    }
}

(function() {
    'use strict';

    angular
        .module('ods-lib-old')
        .constant('ReportParamType', {
            "DATE": "DATE",
            "TEXT": "TEXT",
            "NUMBER": "NUMBER",
            "LIST": "LIST",
            "SINGLE_SELECT": "SINGLE_SELECT",
            "MULTI_SELECT": "MULTI_SELECT",
            "TABLE_SELECT": "TABLE_SELECT"
        });
})();

/**
 * Created by hermeslm on 3/28/17.
 */
(function () {
    'use strict';

    angular
        .module('ods-lib-old')
        .controller('OdsParamsController', OdsParamsController);

    OdsParamsController.$inject = ['ReportParamType', 'report', '$uibModalInstance', '$q',
        'DTOptionsBuilder', 'DTColumnBuilder', '$filter', '$compile', 'moment', '$scope'];

    function OdsParamsController(OdsParamType, report, $uibModalInstance, $q,
                                 DTOptionsBuilder, DTColumnBuilder, $filter, $compile, moment, $scope) {

        var vm = this;

        vm.clear = clear;
        vm.openReport = openReport;
        vm.openCalendar = openCalendar;
        vm.paramType = OdsParamType;
        vm.report = report;
        vm.getSelectTitleField = getSelectTitleField;
        vm.getRequired = getRequired;
        vm.hideParam = hideParam;
        vm.hideTitle = hideTitle;

        //TABLE_SELECT
        // vm.selected = {};
        // vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        vm.getDtOptions = getDtOptions;
        vm.getDtColumns = getDtColumns;
        vm.search = search;
        initTables();

        function initTables() {
            for (var i = 0; i < vm.report.params.length; i++) {
                if (vm.report.params[i].type === OdsParamType.TABLE_SELECT) {
                    vm.report.params[i].dtInstance = {};
                    vm.report.params[i].dtOptions = undefined;
                    vm.report.params[i].dtColumns = undefined;
                    vm.report.params[i].isFilter = false;
                    vm.report.params[i].selected = [];
                    vm.report.params[i].selectedAll = false;
                    //init pre-selections
                    var valueField = vm.report.params[i].valueField;
                    var gridOptions = vm.report.params[i].gridOptions;
                    for (var j = 0; j < gridOptions.preSelected.length; j++) {
                        var preSelectedId = gridOptions.preSelected[j][valueField];
                        vm.report.params[i].selected[preSelectedId] = true;
                    }
                }
            }
        }

        function getDtOptions(param, index) {

            if (param.dtOptions === undefined) {
                //We set the new dtOptions into array
                vm.report.params[index].dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                    var defer = $q.defer();
                    if (param.isFilter) {
                        defer.resolve(param.gridOptions.data);
                        vm.report.params[index].isFilter = false;
                    } else if (!vm.report.params[index].searchQuery || vm.report.params[index].searchQuery === '') {
                        defer.resolve(param.gridOptions.data);
                    } else {
                        defer.resolve($filter('filter')(param.gridOptions.data, vm.report.params[index].searchQuery, undefined));
                    }
                    return defer.promise;
                }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('aaSorting', [[1, 'asc']])
                    .withOption('createdRow', function (row, data, dataIndex) {
                        $compile(angular.element(row).contents())($scope);
                    })
                    .withOption('headerCallback', function (header) {
                        if (!vm.headerCompiled) {
                            vm.headerCompiled = true;
                            $compile(angular.element(header).contents())($scope);
                        }
                    });
                return vm.report.params[index].dtOptions;
            } else {
                return vm.report.params[index].dtOptions;
            }
        }

        function getDtColumns(param, index) {

            if (param.dtColumns === undefined) {
                //We build all columns
                var gridOptions = param.gridOptions;
                var columns = [];
                for (var i = 0; i < gridOptions.columnDef.length; i++) {
                    var columnDef = gridOptions.columnDef[i];
                    if (columnDef.id) {
                        columns.push(DTColumnBuilder.newColumn(null).withTitle(
                            '<input type="checkbox" ng-model="vm.report.params[' + index + '].selectedAll" ng-change="vm.toggleAll(' + index + ')">')
                            .notSortable()
                            .renderWith(function (data, type, full, meta) {
                                return '<input type="checkbox" ng-model="vm.report.params[' + index + '].selected[' + data[param.valueField] + ']" ng-click="vm.toggleOne(' + index + ')">';
                            }));
                    } else {
                        if (columnDef.render === undefined) {
                            var column = DTColumnBuilder.newColumn(columnDef.field).withTitle(columnDef.title);
                            columns.push(column);
                        } else {
                            var column = DTColumnBuilder.newColumn(columnDef.field).withTitle(columnDef.title)
                                .renderWith(columnDef.render);
                            columns.push(column);
                        }
                    }
                }

                vm.report.params[index].dtColumns = columns;
                return vm.report.params[index].dtColumns;
            } else {
                return vm.report.params[index].dtColumns;
            }
        }

        function search(index) {
            vm.report.params[index].dtInstance.reloadData();
        }

        function toggleAll(index) {

            var param = vm.report.params[index];

            for (var i = 0; i < param.gridOptions.data.length; i++) {
                var valueField = param.valueField;
                var value = param.gridOptions.data[i][valueField];
                vm.report.params[index].selected[value] = vm.report.params[index].selectedAll;
            }

            vm.report.params[index].value = vm.report.params[index].selected;
        }

        function toggleOne(index) {
            for (var id in vm.report.params[index].selected) {
                if (vm.report.params[index].selected.hasOwnProperty(id)) {
                    if (!vm.report.params[index].selected[id]) {
                        vm.report.params[index].selectedAll = false;
                        return;
                    }
                }
            }
            vm.report.params[index].selectedAll = true;
            vm.report.params[index].value = vm.report.params[index].selected;
        }

        initDateParams(vm.report);

        function initDateParams(report) {
            for (var i = 0; i < report.params.length; i++) {
                if (vm.report.params[i].type === OdsParamType.DATE) {
                    vm.report.params[i].datePickerOpenStatus = false;
                }
            }
        }

        function openCalendar(index) {
            vm.report.params[index].datePickerOpenStatus = true;
        }

        function hideParam(param) {

            return param.hidden ? true : false;
        }

        function hideTitle(param) {

            return param.hidden || param.hideTitle ? true : false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function openReport() {
            $uibModalInstance.close(vm.report);
        }

        function getSelectTitleField(param, element) {

            if (element) {
                if (param.render) {
                    return param.render(element);
                } else {
                    return param.titleField !== undefined ? element[param.titleField] : element.name;
                }
            } else {
                return param.placeholder;
            }
        }

        function getRequired(param) {

            return param.required !== undefined ? param.required : false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('dialysisApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('dialysisApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-dialysisApp-error');
                var entityKey = httpResponse.headers('X-dialysisApp-params');
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('dialysisApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-dialysisApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-dialysisApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('dialysisApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'dialysis' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('dia-');
        $sessionStorageProvider.setKeyPrefix('dia-');
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except system api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$breadcrumbProvider', 'IdleProvider', 'IDLE'];

    function stateConfig($stateProvider, $breadcrumbProvider, IdleProvider, IDLE) {

        /**
         * Config the BreadCrumb
         */

        $breadcrumbProvider.setOptions({
            prefixStateName: 'home',
            templateUrl: 'app/components/tpl/breadcrumb.tpl.html'
        });

        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'headBar@': {
                        templateUrl: 'app/layouts/header/header.tpl.html',
                        controller: 'HeaderController',
                        controllerAs: 'vm'
                    },
                    'sideBar@': {
                        templateUrl: 'app/layouts/sidebar/sidebar.tpl.html',
                        controller: 'SidebarController',
                        controllerAs: 'vm'
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.tpl.html',
                        controller: 'FooterController',
                        controllerAs: 'vm'
                    },
                    'controlBar@': {
                        templateUrl: 'app/layouts/controlbar/controlsidebar.tpl.html',
                        controller: 'ControlBarController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    authorize: ['Auth',
                        function (Auth) {
                            return Auth.authorize();
                        }
                    ],
                    employee: ['Employee', function (Employee) {
                        return Employee.employeeAccount().$promise;
                    }],
                    clinics: ['Clinic', function (Clinic) {
                        return Clinic.query().$promise;
                    }]
                }
            });

        IdleProvider.idle(IDLE.idle);
        IdleProvider.timeout(IDLE.timeout);
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('dialysisApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('ROLES', {
	"ROLE_ADMIN": "ROLE_ADMIN",
	"ROLE_SUPERVISOR": "ROLE_SUPERVISOR",
	"ROLE_USER": "ROLE_USER",
	"ROLE_DOCTOR": "ROLE_DOCTOR",
	"ROLE_ENVIRONMENTAL": "ROLE_ENVIRONMENTAL",
	"ROLE_NURSE": "ROLE_NURSE",
	"ROLE_LAB_OVERVIEW": "ROLE_LAB_OVERVIEW"
})
        .constant('EMPLOYEE_TYPE', {
	"PHYSICIAN": "PHYSICIAN",
	"NURSER": "NURSER",
	"OTHER": "OTHER"
})
        .constant('APP', {
	"APP_NAME": "Dialysis",
	"APP_SUFFIX_NAME": "",
	"APP_SHORT_NAME": "D"
})
        .constant('IDLE', {
	"idle": 600,
	"timeout": 30
})
;
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User',
        'Utils', 'ROLES'];

    function UserManagementDialogController($stateParams, $uibModalInstance, entity, User, Utils, ROLES) {

        var vm = this;

        vm.authorities = Utils.objectToArray(ROLES);
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            ncyBreadcrumb: {
                label : 'User management'
            },
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'dialysis'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state',
        'pagingParams', 'paginationConstants', 'Utils', 'ROLES'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state,
                                      pagingParams, paginationConstants, Utils, ROLES) {
        var vm = this;


        vm.authorities = Utils.objectToArray(ROLES);
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });

        function setActive(user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll() {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear() {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            ncyBreadcrumb: {
                label : 'Metrics'
            },
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey,
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            ncyBreadcrumb: {
                label : 'Logs'
            },
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            ncyBreadcrumb: {
                label : 'Health'
            },
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('dialysisApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity-audit', {
            parent: 'admin',
            url: '/entity-audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/entity-audit/entity-audits.html',
                    controller: 'EntityAuditController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('EntityAuditService', EntityAuditService);

    EntityAuditService.$inject = ['$http'];

    function EntityAuditService ($http) {

        var service = {
            findAllAudited: findAllAudited,
            findByEntity: findByEntity,
            getPrevVersion: getPrevVersion,
            updateToNewField: updateToNewField
        };

        return service;

        function findAllAudited() {
            return $http.get('api/audits/entity/all').then(function (response) {
                return response.data;
            });
        }

        function findByEntity(entityType, limit) {
            return $http.get('api/audits/entity/changes', {
                params: {
                    entityType: entityType,
                    limit: limit
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function getPrevVersion(qualifiedName, entityId, commitVersion) {
            return $http.get('api/audits/entity/changes/version/previous', {
                params: {
                    qualifiedName: qualifiedName,
                    entityId: entityId,
                    commitVersion: commitVersion
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function updateToNewField() {
            return $http.get('api/audits/update-to-new-field').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('AuditDetailModalCtrl', AuditDetailModalCtrl);

    AuditDetailModalCtrl.$inject = ['$scope', '$uibModalInstance', 'ObjectDiff', 'diff', 'audit'];

    function AuditDetailModalCtrl($scope, $uibModalInstance, ObjectDiff, diff, audit) {
        var vm = this;
        
        vm.diffValue = ObjectDiff.toJsonView(diff);
        vm.diffValueChanges = ObjectDiff.toJsonDiffView(diff);
        vm.audit = audit;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    };
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('EntityAuditController', EntityAuditController);

    EntityAuditController.$inject = ['$scope', '$filter', '$uibModal', 'EntityAuditService', 'AlertService', 'ObjectDiff'];

    function EntityAuditController ($scope, $filter, $uibModal, EntityAuditService, AlertService, ObjectDiff) {
        var vm = this;

        vm.entities = [];
        vm.audits = [];
        vm.limits = [25, 50, 100, 200, 500, 1000, 2000, 5000];
        vm.limit = 25;
        vm.loading = false;
        vm.loadChanges = loadChanges;
        vm.findAllAudited = findAllAudited;
        vm.getEntityName = getEntityName;
        vm.format = format;
        vm.isObject = isObject;
        vm.isDate = isDate;
        vm.openChange = openChange;

        vm.findAllAudited();

        function findAllAudited() {
            EntityAuditService.findAllAudited().then(function (data) {
                vm.entities = data;
            });
        }

        function loadChanges() {
            vm.loading = true;
            var entityType = vm.qualifiedName;
            EntityAuditService.findByEntity(entityType, vm.limit).then(function (data) {
                vm.audits = data.map(function(it){
                    it.entityValue = JSON.parse(it.entityValue);
                    return it;
                });
                vm.loading = false;
            }, function(){
                vm.loading = false;
            });
        }

        function getEntityName(qualifiedName) {
            if (qualifiedName) {
                var splits = qualifiedName.split(".");
                return splits[splits.length - 1];
            }
            else return null;
        }

        function format(val){
            if(val)
                return ObjectDiff.objToJsonView(val);
            else return '';
        }

        function isObject(val){
            return (val && (typeof val) === 'object');
        }

        function isDate(key){
            return (key && key.indexOf("Date") !== -1);
        }

        function openChange(audit){

            if(audit.commitVersion < 2){
                AlertService.warning("There is no previous version available for this entry.\nThis is the first" +
                    " audit entry captured for this object");
            } else {
                EntityAuditService.getPrevVersion(audit.entityType, audit.entityId, audit.commitVersion).then(function (data) {
                    var previousVersion = JSON.parse(data.entityValue),
                        currentVersion = audit.entityValue;
                    // enable below to have the dates formatted
                    //previousVersion = convertDates(previousVersion);
                    //currentVersion = convertDates(currentVersion);
                    var diff = ObjectDiff.diffOwnProperties(previousVersion, currentVersion);

                    $uibModal.open({
                        templateUrl: 'app/admin/entity-audit/entity-audit.detail.html',
                        controller: 'AuditDetailModalCtrl',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            diff: function () {
                                return diff;
                            },
                            audit: function () {
                                return audit;
                            }
                        }
                    });
                });
            }
        }

        function convertDates(obj) {
            for(var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key]) {
                    if (key.indexOf("Date") !== -1 && (obj[key] instanceof Date || Object.prototype.toString.call(obj[key]) === '[object Date]' || (new Date(obj[key]) !== "Invalid Date" && !isNaN(new Date(obj[key]))))) {
                        obj[key] = $filter('date')(obj[key]);
                    }
                }
            }
            return obj;
        }

        vm.updateToNewField = updateToNewField;
        function updateToNewField() {
            EntityAuditService.updateToNewField().then(function (data) {
                alert(data);
            }, function(data){
                alert(data);
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource'];

    function ElasticsearchReindex($resource) {
        var service = $resource('api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            ncyBreadcrumb: {
                label : 'Configuration'
            },
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter, JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            ncyBreadcrumb: {
                label: 'Audits'
            },
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            ncyBreadcrumb: {
                label: 'Settings'
            },
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            // parent: 'account',
            url: '/reset/request',
            templateUrl: 'app/account/reset/request/reset.request.html',
            controller: 'RequestResetController',
            controllerAs: 'vm',
            data: {
                authorities: []
            }
            // views: {
            //     'content@': {
            //         templateUrl: 'app/account/reset/request/reset.request.html',
            //         controller: 'RequestResetController',
            //         controllerAs: 'vm'
            //     }
            // }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            // parent: 'account',
            url: '/reset/finish?key',
            templateUrl: 'app/account/reset/finish/reset.finish.html',
            controller: 'ResetFinishController',
            controllerAs: 'vm',
            data: {
                authorities: []
            }
            // ,
            // views: {
            //     'content@': {
            //         templateUrl: 'app/account/reset/finish/reset.finish.html',
            //         controller: 'ResetFinishController',
            //         controllerAs: 'vm'
            //     }
            // }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            ncyBreadcrumb: {
                label: 'Password'
            },
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app',
            ncyBreadcrumb: {
                label: 'Account'
            }
        });
    }
})();
(function(){angular.module('dialysisApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','');
$templateCache.put('app/layouts/content.tpl.html','<!-- Content Wrapper. Contains page content --><div class="content-wrapper"><!-- Content Header (Page header) --><section class="content-header"><h1>Dashboard <small>version 1.0</small></h1><div ncy-breadcrumb></div></section><!-- Main content --><section class="content"><!-- Info boxes --><div class="row"><div class="col-md-3 col-sm-6 col-xs-12"><div class="info-box"><span class="info-box-icon bg-aqua"><i class="ion ion-ios-gear-outline"></i></span><div class="info-box-content"><span class="info-box-text">Billed units</span> <span class="info-box-number">90<small></small></span></div><!-- /.info-box-content --></div><!-- /.info-box --></div><!-- /.col --><div class="col-md-3 col-sm-6 col-xs-12"><div class="info-box"><span class="info-box-icon bg-red"><i class="fa fa-google-plus"></i></span><div class="info-box-content"><span class="info-box-text">Worked Patients</span> <span class="info-box-number">41,410</span></div><!-- /.info-box-content --></div><!-- /.info-box --></div><!-- /.col --><!-- fix for small devices only --><div class="clearfix visible-sm-block"></div><div class="col-md-3 col-sm-6 col-xs-12"><div class="info-box"><span class="info-box-icon bg-green"><i class="ion ion-ios-cart-outline"></i></span><div class="info-box-content"><span class="info-box-text">Sales</span> <span class="info-box-number">760</span></div><!-- /.info-box-content --></div><!-- /.info-box --></div><!-- /.col --><div class="col-md-3 col-sm-6 col-xs-12"><div class="info-box"><span class="info-box-icon bg-yellow"><i class="ion ion-ios-people-outline"></i></span><div class="info-box-content"><span class="info-box-text">New Members</span> <span class="info-box-number">2,000</span></div><!-- /.info-box-content --></div><!-- /.info-box --></div><!-- /.col --></div><!-- /.row --><div class="row"><div class="col-md-12"><div class="box"><div class="box-header with-border"><h3 class="box-title">Monthly Recap Report</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button><div class="btn-group"><button type="button" class="btn btn-box-tool dropdown-toggle" data-toggle="dropdown"><i class="fa fa-wrench"></i></button><ul class="dropdown-menu" role="menu"><li><a href="#">Action</a></li><li><a href="#">Another action</a></li><li><a href="#">Something else here</a></li><li class="divider"></li><li><a href="#">Separated link</a></li></ul></div><button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body"><div class="row"><div class="col-md-8"><p class="text-center"><strong>Sales: 1 Jan, 2014 - 30 Jul, 2014</strong></p><div class="chart"><!-- Sales Chart Canvas --><canvas id="salesChart" style="height: 177px; width: 651px" width="651" height="177"></canvas></div><!-- /.chart-responsive --></div><!-- /.col --><div class="col-md-4"><p class="text-center"><strong>Goal Completion</strong></p><div class="progress-group"><span class="progress-text">Add Products to Cart</span> <span class="progress-number"><b>160</b>/200</span><div class="progress sm"><div class="progress-bar progress-bar-aqua" style="width: 80%"></div></div></div><!-- /.progress-group --><div class="progress-group"><span class="progress-text">Complete Purchase</span> <span class="progress-number"><b>310</b>/400</span><div class="progress sm"><div class="progress-bar progress-bar-red" style="width: 80%"></div></div></div><!-- /.progress-group --><div class="progress-group"><span class="progress-text">Visit Premium Page</span> <span class="progress-number"><b>480</b>/800</span><div class="progress sm"><div class="progress-bar progress-bar-green" style="width: 80%"></div></div></div><!-- /.progress-group --><div class="progress-group"><span class="progress-text">Send Inquiries</span> <span class="progress-number"><b>250</b>/500</span><div class="progress sm"><div class="progress-bar progress-bar-yellow" style="width: 80%"></div></div></div><!-- /.progress-group --></div><!-- /.col --></div><!-- /.row --></div><!-- ./box-body --><div class="box-footer"><div class="row"><div class="col-sm-3 col-xs-6"><div class="description-block border-right"><span class="description-percentage text-green"><i class="fa fa-caret-up"></i> 17%</span><h5 class="description-header">$35,210.43</h5><span class="description-text">TOTAL REVENUE</span></div><!-- /.description-block --></div><!-- /.col --><div class="col-sm-3 col-xs-6"><div class="description-block border-right"><span class="description-percentage text-yellow"><i class="fa fa-caret-left"></i> 0%</span><h5 class="description-header">$10,390.90</h5><span class="description-text">TOTAL COST</span></div><!-- /.description-block --></div><!-- /.col --><div class="col-sm-3 col-xs-6"><div class="description-block border-right"><span class="description-percentage text-green"><i class="fa fa-caret-up"></i> 20%</span><h5 class="description-header">$24,813.53</h5><span class="description-text">TOTAL PROFIT</span></div><!-- /.description-block --></div><!-- /.col --><div class="col-sm-3 col-xs-6"><div class="description-block"><span class="description-percentage text-red"><i class="fa fa-caret-down"></i> 18%</span><h5 class="description-header">1200</h5><span class="description-text">GOAL COMPLETIONS</span></div><!-- /.description-block --></div></div><!-- /.row --></div><!-- /.box-footer --></div><!-- /.box --></div><!-- /.col --></div><!-- /.row --><!-- Main row --><div class="row"><!-- Left col --><div class="col-md-8"><!-- MAP & BOX PANE --><div class="box box-success"><div class="box-header with-border"><h3 class="box-title">Visitors Report</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button> <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body no-padding"><div class="row"><div class="col-md-9 col-sm-8"><div class="pad"><!-- Map will be created here --><div id="world-map-markers" style="height: 325px"><div class="jvectormap-container" style="width: 100%; height: 100%; position: relative; overflow: hidden; background-color: transparent"><svg width="471" height="325"><g transform="scale(0.5233333333333333) translate(0, 90.15639876806087)"><path d="M652.71,228.85l-0.04,1.38l-0.46,-0.21l-0.42,0.3l0.05,0.65l-0.17,-1.37l-0.48,-1.26l-1.08,-1.6l-0.23,-0.13l-2.31,-0.11l-0.31,0.36l0.21,0.98l-0.6,1.11l-0.8,-0.4l-0.37,0.09l-0.23,0.3l-0.54,-0.21l-0.78,-0.19l-0.38,-2.04l-0.83,-1.89l0.4,-1.5l-0.16,-0.35l-1.24,-0.57l0.36,-0.62l1.5,-0.95l0.02,-0.49l-1.62,-1.26l0.64,-1.31l1.7,1.0l0.12,0.04l0.96,0.11l0.19,1.62l0.25,0.26l2.38,0.37l2.32,-0.04l1.06,0.33l-0.92,1.79l-0.97,0.13l-0.23,0.16l-0.77,1.51l0.05,0.35l1.37,1.37l0.5,-0.14l0.35,-1.46l0.24,-0.0l1.24,3.92Z" data-code="BD" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M429.28,143.95l1.76,0.25l0.13,-0.01l2.16,-0.64l1.46,1.34l1.26,0.71l-0.23,1.8l-0.44,0.08l-0.24,0.25l-0.2,1.36l-1.8,-1.22l-0.23,-0.05l-1.14,0.23l-1.62,-1.43l-1.15,-1.31l-0.21,-0.1l-0.95,-0.04l-0.21,-0.68l1.66,-0.54Z" data-code="BE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M413.48,260.21l-1.22,-0.46l-0.13,-0.02l-1.17,0.1l-0.15,0.06l-0.73,0.53l-0.87,-0.41l-0.39,-0.75l-0.13,-0.13l-0.98,-0.48l-0.14,-1.2l0.63,-0.99l0.05,-0.18l-0.05,-0.73l1.9,-2.01l0.08,-0.14l0.35,-1.65l0.49,-0.44l1.05,0.3l0.21,-0.02l1.05,-0.52l0.13,-0.13l0.3,-0.58l1.87,-1.1l0.11,-0.1l0.43,-0.72l2.23,-1.01l1.21,-0.32l0.51,0.4l0.19,0.06l1.25,-0.01l-0.14,0.89l0.01,0.13l0.34,1.16l0.06,0.11l1.35,1.59l0.07,1.13l0.24,0.28l2.64,0.53l-0.05,1.39l-0.42,0.59l-1.11,0.21l-0.22,0.17l-0.46,0.99l-0.69,0.23l-2.12,-0.05l-1.14,-0.2l-0.19,0.03l-0.72,0.36l-1.07,-0.17l-4.35,0.12l-0.29,0.29l-0.06,1.44l0.25,1.45Z" data-code="BF" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M477.63,166.84l0.51,0.9l0.33,0.14l0.9,-0.21l1.91,0.47l3.68,0.16l0.17,-0.05l1.2,-0.75l2.78,-0.67l1.72,1.05l1.02,0.24l-0.97,0.97l-0.91,2.17l0.0,0.24l0.56,1.19l-1.58,-0.3l-0.16,0.01l-2.55,0.95l-0.2,0.28l-0.02,1.23l-1.92,0.24l-1.68,-0.99l-0.27,-0.02l-1.94,0.8l-1.52,-0.07l-0.15,-1.72l-0.12,-0.21l-0.99,-0.76l0.18,-0.18l0.02,-0.39l-0.17,-0.22l0.33,-0.75l0.91,-0.91l0.01,-0.42l-1.16,-1.25l-0.18,-0.89l0.24,-0.27Z" data-code="BG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M468.39,164.66l0.16,0.04l0.43,-0.0l-0.43,0.93l0.06,0.34l1.08,1.06l-0.28,1.09l-0.5,0.13l-0.47,0.28l-0.86,0.74l-0.1,0.16l-0.28,1.29l-1.81,-0.94l-0.9,-1.22l-1.0,-0.73l-1.1,-1.1l-0.55,-0.96l-1.11,-1.3l0.3,-0.75l0.59,0.46l0.42,-0.04l0.46,-0.54l1.0,-0.06l2.11,0.5l1.72,-0.03l1.06,0.64Z" data-code="BA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M707.34,273.57l0.76,-0.72l1.59,-1.03l-0.18,1.93l-0.9,-0.06l-0.28,0.14l-0.31,0.51l-0.68,-0.78Z" data-code="BN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M263.83,340.79l-0.23,-0.12l-2.86,-0.11l-0.28,0.17l-0.77,1.67l-1.17,-1.51l-0.18,-0.11l-3.28,-0.64l-0.28,0.1l-2.02,2.3l-1.43,0.29l-0.91,-3.35l-1.31,-2.88l0.75,-2.41l-0.09,-0.32l-1.23,-1.03l-0.31,-1.76l-0.05,-0.12l-1.12,-1.6l1.49,-2.62l0.01,-0.28l-1.0,-2.0l0.48,-0.72l0.02,-0.29l-0.37,-0.78l0.87,-1.13l0.06,-0.18l0.05,-2.17l0.12,-1.71l0.5,-0.8l0.01,-0.3l-1.9,-3.58l1.3,0.15l1.34,-0.05l0.23,-0.12l0.51,-0.7l2.12,-0.99l1.31,-0.93l2.81,-0.37l-0.21,1.51l0.01,0.13l0.29,0.91l-0.19,1.64l0.11,0.27l2.72,2.27l0.15,0.07l2.71,0.41l0.92,0.88l0.12,0.07l1.64,0.49l1.0,0.71l0.18,0.06l1.5,-0.02l1.24,0.64l0.1,1.31l0.05,0.14l0.44,0.68l0.02,0.73l-0.44,0.03l-0.27,0.39l0.96,2.99l0.28,0.21l4.43,0.1l-0.28,1.12l0.0,0.15l0.27,1.02l0.15,0.19l1.27,0.67l0.52,1.42l-0.42,1.91l-0.66,1.1l-0.04,0.2l0.21,1.3l-0.19,0.13l-0.01,-0.27l-0.15,-0.24l-2.33,-1.33l-0.14,-0.04l-2.38,-0.03l-4.36,0.76l-0.21,0.16l-1.2,2.29l-0.03,0.13l-0.06,1.37l-0.79,2.53l-0.05,-0.08Z" data-code="BO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M781.17,166.78l1.8,0.67l0.28,-0.04l1.38,-1.01l0.43,2.67l-3.44,0.77l-0.18,0.12l-2.04,2.79l-3.71,-1.94l-0.42,0.15l-1.29,3.11l-2.32,0.04l-0.3,-2.63l1.12,-2.1l2.51,-0.16l0.28,-0.25l0.73,-4.22l0.58,-1.9l2.59,2.84l2.0,1.1ZM773.66,187.36l-0.92,2.24l-0.01,0.2l0.4,1.3l-1.18,1.81l-3.06,1.28l-4.35,0.17l-0.19,0.08l-3.4,3.06l-1.36,-0.87l-0.1,-1.95l-0.34,-0.28l-4.35,0.62l-2.99,1.33l-2.87,0.05l-0.28,0.2l0.09,0.33l2.37,1.93l-1.57,4.44l-1.35,0.97l-0.9,-0.79l0.57,-2.32l-0.15,-0.34l-1.5,-0.77l-0.81,-1.53l2.04,-0.75l0.14,-0.1l1.28,-1.72l2.47,-1.43l1.84,-1.92l4.83,-0.82l2.62,0.57l0.33,-0.16l2.45,-4.77l1.38,1.14l0.38,0.0l5.1,-4.02l0.09,-0.11l1.57,-3.57l0.02,-0.16l-0.42,-3.22l0.94,-1.67l2.27,-0.47l1.26,3.82l-0.07,2.23l-2.26,2.86l-0.06,0.19l0.04,2.93ZM757.85,196.18l0.22,0.66l-1.11,1.33l-0.8,-0.7l-0.33,-0.04l-1.28,0.65l-0.14,0.15l-0.54,1.34l-1.17,-0.57l0.02,-1.03l1.2,-1.45l1.24,0.28l0.29,-0.1l0.9,-1.03l1.51,0.5Z" data-code="JP" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M494.7,295.83l-0.14,-2.71l-0.04,-0.13l-0.34,-0.62l0.93,0.12l0.3,-0.16l0.67,-1.25l0.9,0.11l0.11,0.76l0.08,0.16l0.46,0.48l0.02,0.56l-0.55,0.48l-0.96,1.29l-0.82,0.82l-0.61,0.07Z" data-code="BI" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M427.4,268.94l-1.58,0.22l-0.52,-1.45l0.11,-5.73l-0.08,-0.21l-0.43,-0.44l-0.09,-1.13l-0.09,-0.19l-1.52,-1.52l0.24,-1.01l0.7,-0.23l0.18,-0.16l0.45,-0.97l1.07,-0.21l0.19,-0.12l0.53,-0.73l0.73,-0.65l0.68,-0.0l1.69,1.3l-0.08,0.67l0.02,0.14l0.52,1.38l-0.44,0.9l-0.01,0.24l0.2,0.52l-1.1,1.42l-0.76,0.76l-0.08,0.13l-0.47,1.59l0.05,1.69l-0.13,3.79Z" data-code="BJ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M650.38,213.78l0.88,0.75l-0.13,1.24l-1.77,0.07l-2.1,-0.18l-1.57,0.4l-2.02,-0.91l-0.02,-0.24l1.54,-1.87l1.18,-0.6l1.67,0.59l1.32,0.08l1.01,0.67Z" data-code="BT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M226.67,238.37l1.64,0.23l1.2,0.56l0.11,0.19l-1.25,0.03l-0.14,0.04l-0.65,0.37l-1.24,-0.37l-1.17,-0.77l0.11,-0.22l0.86,-0.15l0.52,0.08Z" data-code="JM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M484.91,331.96l0.53,0.52l0.82,1.53l2.83,2.86l0.14,0.08l0.85,0.22l0.03,0.81l0.74,1.66l0.21,0.17l1.87,0.39l1.17,0.87l-3.13,1.71l-2.3,2.01l-0.07,0.1l-0.82,1.74l-0.66,0.88l-1.24,0.19l-0.24,0.2l-0.65,1.98l-1.4,0.55l-1.9,-0.12l-1.2,-0.74l-1.06,-0.32l-0.22,0.02l-1.22,0.62l-0.14,0.14l-0.58,1.21l-1.16,0.79l-1.18,1.13l-1.5,0.23l-0.4,-0.68l0.22,-1.53l-0.04,-0.19l-1.48,-2.54l-0.11,-0.11l-0.53,-0.31l-0.0,-7.25l2.18,-0.08l0.29,-0.3l0.07,-9.0l1.63,-0.08l3.69,-0.86l0.84,0.93l0.38,0.05l1.53,-0.97l0.79,-0.03l1.3,-0.53l0.23,0.1l0.92,1.96Z" data-code="BW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M259.49,274.87l1.42,0.25l1.97,0.62l0.28,-0.05l0.67,-0.55l1.76,-0.38l2.8,-0.94l0.12,-0.08l0.92,-0.96l0.05,-0.33l-0.15,-0.32l0.73,-0.06l0.36,0.35l-0.27,0.93l0.17,0.36l0.76,0.34l0.44,0.9l-0.58,0.73l-0.06,0.13l-0.4,2.13l0.03,0.19l0.62,1.22l0.17,1.11l0.11,0.19l1.54,1.18l0.15,0.06l1.23,0.12l0.29,-0.15l0.2,-0.36l0.71,-0.11l1.13,-0.44l0.79,-0.63l1.25,0.19l0.65,-0.08l1.32,0.2l0.32,-0.18l0.23,-0.51l-0.05,-0.31l-0.31,-0.37l0.11,-0.31l0.75,0.17l0.13,0.0l1.1,-0.24l1.34,0.5l1.08,0.51l0.33,-0.05l0.67,-0.58l0.27,0.05l0.28,0.57l0.31,0.17l1.2,-0.18l0.17,-0.08l1.03,-1.05l0.76,-1.82l1.39,-2.16l0.49,-0.07l0.52,1.17l1.4,4.37l0.2,0.2l1.14,0.35l0.05,1.39l-1.8,1.97l0.01,0.42l0.78,0.75l0.18,0.08l4.16,0.37l0.08,2.25l0.5,0.22l1.78,-1.54l2.98,0.85l4.07,1.5l1.07,1.28l-0.37,1.23l0.36,0.38l2.83,-0.75l4.8,1.3l3.75,-0.09l3.6,2.02l3.27,2.84l1.93,0.72l2.13,0.11l0.76,0.66l1.22,4.56l-0.96,4.03l-1.22,1.58l-3.52,3.51l-1.63,2.91l-1.75,2.09l-0.5,0.04l-0.26,0.19l-0.72,1.99l0.18,4.76l-0.95,5.56l-0.74,0.96l-0.06,0.15l-0.43,3.39l-2.49,3.34l-0.06,0.13l-0.4,2.56l-1.9,1.07l-0.13,0.16l-0.51,1.38l-2.59,0.0l-3.94,1.01l-1.82,1.19l-2.85,0.81l-3.01,2.17l-2.12,2.65l-0.06,0.13l-0.36,2.0l0.01,0.13l0.4,1.42l-0.45,2.63l-0.53,1.23l-1.76,1.53l-2.76,4.79l-2.16,2.15l-1.69,1.29l-0.09,0.12l-1.12,2.6l-1.3,1.26l-0.45,-1.02l0.99,-1.18l0.01,-0.37l-1.5,-1.95l-1.98,-1.54l-2.58,-1.77l-0.2,-0.05l-0.81,0.07l-2.42,-2.05l-0.25,-0.07l-0.77,0.14l2.75,-3.07l2.8,-2.61l1.67,-1.09l2.11,-1.49l0.13,-0.24l0.05,-2.15l-0.07,-0.2l-1.26,-1.54l-0.35,-0.09l-0.64,0.27l0.3,-0.95l0.34,-1.57l0.01,-1.52l-0.16,-0.26l-0.9,-0.48l-0.27,-0.01l-0.86,0.39l-0.65,-0.08l-0.23,-0.8l-0.23,-2.39l-0.04,-0.12l-0.47,-0.79l-0.14,-0.12l-1.69,-0.71l-0.25,0.01l-0.93,0.47l-2.29,-0.44l0.15,-3.3l-0.03,-0.15l-0.62,-1.22l0.57,-0.39l0.13,-0.3l-0.22,-1.37l0.67,-1.13l0.44,-2.04l-0.01,-0.17l-0.59,-1.61l-0.14,-0.16l-1.25,-0.66l-0.22,-0.82l0.35,-1.41l-0.28,-0.37l-4.59,-0.1l-0.78,-2.41l0.34,-0.02l0.28,-0.31l-0.03,-1.1l-0.05,-0.16l-0.45,-0.68l-0.1,-1.4l-0.16,-0.24l-1.45,-0.76l-0.14,-0.03l-1.48,0.02l-1.04,-0.73l-1.62,-0.48l-0.93,-0.9l-0.16,-0.08l-2.72,-0.41l-2.53,-2.12l0.18,-1.54l-0.01,-0.13l-0.29,-0.91l0.26,-1.83l-0.34,-0.34l-3.28,0.43l-0.14,0.05l-1.3,0.93l-2.16,1.01l-0.12,0.09l-0.47,0.65l-1.12,0.05l-1.84,-0.21l-0.12,0.01l-1.33,0.41l-0.82,-0.21l0.16,-3.6l-0.48,-0.26l-1.97,1.43l-1.96,-0.06l-0.86,-1.23l-0.22,-0.13l-1.23,-0.11l0.34,-0.69l-0.05,-0.33l-1.36,-1.5l-0.92,-2.0l0.45,-0.32l0.13,-0.25l-0.0,-0.87l1.34,-0.64l0.17,-0.32l-0.23,-1.23l0.56,-0.77l0.05,-0.13l0.16,-1.03l2.7,-1.61l2.01,-0.47l0.16,-0.09l0.24,-0.27l2.11,0.11l0.31,-0.25l1.13,-6.87l0.06,-1.12l-0.4,-1.53l-0.1,-0.15l-1.0,-0.82l0.01,-1.45l1.08,-0.32l0.39,0.2l0.44,-0.24l0.08,-0.96l-0.25,-0.32l-1.22,-0.22l-0.02,-1.01l4.57,0.05l0.22,-0.09l0.6,-0.63l0.44,0.5l0.47,1.42l0.45,0.16l0.27,-0.18l1.21,1.16l0.23,0.08l1.95,-0.16l0.23,-0.14l0.43,-0.67l1.76,-0.55l1.05,-0.42l0.18,-0.2l0.25,-0.92l1.65,-0.66l0.18,-0.35l-0.14,-0.53l-0.26,-0.22l-1.91,-0.19l-0.29,-1.33l0.1,-1.64l-0.15,-0.28l-0.44,-0.25Z" data-code="BR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M227.51,216.69l0.3,0.18l-0.24,1.07l0.03,-1.04l-0.09,-0.21ZM226.5,224.03l-0.13,0.03l-0.54,-1.3l-0.09,-0.12l-0.78,-0.64l0.4,-1.26l0.33,0.05l0.79,2.0l0.01,1.24ZM225.76,216.5l-2.16,0.34l-0.07,-0.41l0.85,-0.16l1.36,0.07l0.02,0.16Z" data-code="BS" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M480.08,135.28l2.09,0.02l0.13,-0.03l2.72,-1.3l0.16,-0.19l0.55,-1.83l1.94,-1.06l0.15,-0.31l-0.2,-1.33l1.33,-0.52l2.58,-1.3l2.39,0.8l0.3,0.75l0.37,0.17l1.22,-0.39l2.18,0.75l0.2,1.36l-0.48,0.85l0.01,0.32l1.57,2.26l0.92,0.6l-0.1,0.41l0.19,0.35l1.61,0.57l0.48,0.6l-0.64,0.49l-1.91,-0.11l-0.18,0.05l-0.48,0.32l-0.1,0.39l0.57,1.1l0.51,1.78l-1.79,0.17l-0.18,0.08l-0.77,0.73l-0.09,0.19l-0.13,1.31l-0.75,-0.22l-2.11,0.15l-0.56,-0.66l-0.39,-0.06l-0.8,0.49l-0.79,-0.4l-0.13,-0.03l-1.94,-0.07l-2.76,-0.79l-2.58,-0.27l-1.98,0.07l-0.15,0.05l-1.31,0.86l-0.8,0.09l-0.04,-1.16l-0.03,-0.12l-0.63,-1.28l1.22,-0.56l0.17,-0.27l0.01,-1.35l-0.04,-0.15l-0.66,-1.24l-0.08,-1.12Z" data-code="BY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M198.03,239.7l0.28,0.19l0.43,-0.1l0.82,-1.42l0.0,0.07l0.29,0.29l0.16,0.0l-0.02,0.35l-0.39,1.08l0.02,0.25l0.16,0.29l-0.23,0.8l0.04,0.24l0.09,0.14l-0.25,1.12l-0.38,0.53l-0.33,0.06l-0.21,0.15l-0.41,0.74l-0.25,0.0l0.17,-2.58l0.01,-2.2Z" data-code="BZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M688.57,38.85l0.63,2.39l0.44,0.19l2.22,-1.23l7.18,0.07l5.54,2.49l1.85,1.77l-0.55,2.34l-2.64,1.42l-6.57,2.76l-1.95,1.5l0.12,0.53l3.09,0.68l3.69,1.23l0.21,-0.01l1.98,-0.81l1.16,2.84l0.5,0.08l1.03,-1.18l3.86,-0.74l7.79,0.78l0.56,2.05l0.27,0.22l10.47,0.71l0.32,-0.29l0.13,-3.34l4.98,0.8l3.96,-0.02l3.88,2.43l1.06,2.79l-1.38,1.83l0.01,0.38l3.15,3.64l0.1,0.08l3.94,1.86l0.4,-0.14l2.28,-4.56l3.75,1.94l0.22,0.02l4.18,-1.22l4.76,1.4l0.26,-0.04l1.74,-1.23l3.98,0.63l0.32,-0.41l-1.71,-4.1l3.0,-1.86l22.39,3.04l2.06,2.67l0.1,0.08l6.55,3.51l0.17,0.03l10.08,-0.86l4.86,0.73l1.91,1.72l-0.29,3.13l0.18,0.31l3.08,1.26l0.19,0.01l3.32,-0.9l4.37,-0.11l4.78,0.87l4.61,-0.48l4.26,3.82l0.32,0.05l3.1,-1.4l0.12,-0.45l-1.91,-2.67l0.92,-1.64l7.78,1.22l5.22,-0.26l7.12,2.1l9.6,5.22l6.4,4.15l-0.2,2.44l0.14,0.28l1.69,1.04l0.45,-0.31l-0.51,-2.66l6.31,0.58l4.52,3.61l-2.1,1.52l-4.02,0.42l-0.27,0.29l-0.06,3.83l-0.81,0.67l-2.14,-0.11l-1.91,-1.39l-3.19,-1.13l-0.51,-1.63l-0.21,-0.2l-2.54,-0.67l-0.13,-0.0l-2.69,0.5l-1.12,-1.19l0.48,-1.36l-0.38,-0.39l-3.0,0.98l-0.17,0.44l1.02,1.76l-1.27,1.55l-3.09,1.71l-3.15,-0.29l-0.3,0.18l0.07,0.34l2.22,2.1l1.47,3.22l1.15,1.09l0.25,1.41l-0.48,0.76l-4.47,-0.81l-0.17,0.02l-6.97,2.9l-2.2,0.44l-0.11,0.05l-3.83,2.68l-3.63,2.32l-0.1,0.11l-0.76,1.4l-3.3,-2.4l-0.3,-0.03l-6.31,2.85l-0.99,-1.21l-0.4,-0.06l-2.32,1.54l-3.23,-0.49l-0.33,0.2l-0.79,2.39l-2.97,3.51l-0.07,0.21l0.09,1.47l0.22,0.27l2.62,0.74l-0.3,4.7l-2.06,0.12l-0.26,0.2l-1.07,2.94l0.04,0.27l0.83,1.19l-4.03,1.63l-0.18,0.21l-0.83,3.72l-3.55,0.79l-0.23,0.23l-0.73,3.32l-3.22,2.76l-0.76,-1.88l-1.07,-4.88l-1.39,-7.59l1.17,-4.76l2.05,-2.08l0.09,-0.19l0.11,-1.46l3.67,-0.77l0.15,-0.08l4.47,-4.61l4.29,-3.82l4.48,-3.01l0.11,-0.14l2.01,-5.43l-0.31,-0.4l-3.04,0.33l-0.24,0.17l-1.47,3.11l-5.98,3.94l-1.91,-4.36l-0.33,-0.17l-6.46,1.3l-0.15,0.08l-6.27,6.33l-0.01,0.41l1.7,1.87l-5.04,0.87l-3.51,0.34l0.16,-2.32l-0.26,-0.32l-3.89,-0.56l-0.19,0.04l-3.02,1.77l-7.63,-0.63l-8.24,1.1l-0.16,0.07l-8.11,7.09l-9.6,8.31l0.16,0.52l3.79,0.42l1.16,2.03l0.17,0.14l2.43,0.76l0.31,-0.08l1.5,-1.61l2.49,0.2l3.46,3.6l0.08,2.67l-1.91,3.26l-0.04,0.14l-0.21,3.91l-1.11,5.09l-3.73,4.55l-0.87,2.21l-6.73,7.14l-1.59,1.77l-3.23,1.72l-1.38,0.03l-1.48,-1.39l-0.37,-0.03l-3.36,2.22l-0.11,0.14l-0.16,0.42l-0.01,-1.09l1.0,-0.06l0.28,-0.27l0.36,-3.6l-0.61,-2.51l1.85,-0.94l2.94,0.53l0.32,-0.15l1.71,-3.1l0.84,-3.38l0.97,-1.18l1.32,-2.88l-0.34,-0.42l-4.14,0.95l-2.18,1.25l-3.51,-0.0l-0.95,-2.81l-0.1,-0.14l-2.97,-2.3l-0.11,-0.05l-4.19,-1.0l-0.89,-3.08l-0.87,-2.03l-0.95,-1.46l-1.54,-3.37l-0.12,-0.14l-2.27,-1.28l-3.83,-1.02l-3.37,0.1l-3.11,0.61l-0.13,0.06l-2.07,1.69l0.04,0.49l1.23,0.72l0.03,1.53l-1.34,1.05l-2.26,3.51l-0.05,0.17l0.02,1.27l-3.25,1.9l-2.87,-1.17l-0.14,-0.02l-2.86,0.26l-1.22,-1.02l-0.12,-0.06l-1.5,-0.35l-0.23,0.04l-3.62,2.27l-3.24,0.53l-2.28,0.79l-3.08,-0.51l-2.24,0.03l-1.49,-1.61l-2.45,-1.57l-0.11,-0.04l-2.6,-0.43l-3.17,0.43l-2.31,0.59l-3.31,-1.28l-0.45,-2.31l-0.21,-0.23l-2.94,-0.85l-2.26,-0.39l-2.77,-1.36l-0.37,0.09l-2.59,3.45l-0.03,0.32l0.91,1.74l-2.15,2.01l-3.47,-0.79l-2.44,-0.12l-1.59,-1.46l-0.2,-0.08l-2.55,-0.05l-2.12,-0.98l-0.24,-0.01l-3.85,1.57l-4.74,2.79l-2.59,0.55l-0.79,0.21l-1.21,-1.81l-0.29,-0.13l-3.05,0.41l-0.96,-1.25l-0.14,-0.1l-1.65,-0.6l-1.15,-1.82l-0.13,-0.12l-1.38,-0.6l-0.19,-0.02l-3.49,0.82l-3.35,-1.85l-0.38,0.08l-1.08,1.4l-5.36,-8.17l-3.02,-2.52l0.72,-0.85l0.01,-0.38l-0.37,-0.08l-6.22,3.21l-1.98,0.16l0.17,-1.51l-0.2,-0.31l-3.22,-1.17l-0.19,-0.0l-2.3,0.74l-0.72,-3.27l-0.24,-0.23l-4.5,-0.75l-0.21,0.04l-2.2,1.42l-6.21,1.27l-0.11,0.05l-1.16,0.81l-9.3,1.19l-0.18,0.09l-1.15,1.17l-0.02,0.39l1.56,2.01l-2.02,0.74l-0.16,0.42l0.35,0.68l-2.18,1.49l0.02,0.51l3.83,2.16l-0.45,1.13l-3.31,-0.13l-0.25,0.12l-0.57,0.77l-2.97,-1.59l-0.15,-0.04l-3.97,0.07l-0.13,0.03l-2.53,1.32l-2.84,-1.28l-5.52,-2.3l-0.12,-0.02l-3.91,0.09l-0.16,0.05l-5.17,3.6l-0.13,0.21l-0.25,1.89l-2.17,-1.6l-0.44,0.1l-2.0,3.59l0.06,0.37l0.55,0.5l-1.32,2.23l0.04,0.36l2.13,2.17l0.23,0.09l1.7,-0.08l1.42,1.89l-0.23,1.5l0.19,0.32l0.94,0.38l-0.89,1.44l-2.3,0.49l-0.17,0.11l-2.49,3.2l0.0,0.37l2.2,2.81l-0.23,1.93l0.06,0.22l2.56,3.32l-1.27,1.02l-0.4,0.66l-0.8,-0.15l-1.65,-1.75l-0.18,-0.09l-0.66,-0.09l-1.45,-0.64l-0.72,-1.16l-0.18,-0.13l-2.34,-0.63l-0.17,0.0l-1.32,0.41l-0.31,-0.4l-0.12,-0.09l-3.49,-1.48l-3.67,-0.49l-2.1,-0.52l-0.3,0.1l-0.12,0.14l-2.96,-2.4l-2.89,-1.19l-1.69,-1.42l1.27,-0.35l0.16,-0.1l2.08,-2.61l-0.04,-0.41l-1.02,-0.9l3.21,-1.12l0.2,-0.31l-0.07,-0.69l-0.37,-0.26l-1.86,0.42l0.05,-0.86l1.11,-0.76l2.35,-0.23l0.25,-0.19l0.39,-1.07l0.0,-0.19l-0.51,-1.64l0.95,-1.58l0.04,-0.16l-0.03,-0.95l-0.22,-0.28l-3.69,-1.06l-1.43,0.02l-1.45,-1.44l-0.29,-0.08l-1.83,0.49l-2.88,-1.04l0.04,-0.42l-0.04,-0.18l-0.89,-1.43l-0.23,-0.14l-1.77,-0.14l-0.13,-0.66l0.52,-0.56l0.01,-0.4l-1.6,-1.9l-0.27,-0.1l-2.55,0.32l-0.71,-0.16l-0.3,0.1l-0.53,0.63l-0.58,-0.08l-0.56,-1.97l-0.48,-0.94l0.17,-0.11l1.92,0.11l0.2,-0.06l0.97,-0.74l0.05,-0.42l-0.72,-0.91l-0.13,-0.1l-1.43,-0.51l0.09,-0.36l-0.13,-0.33l-0.97,-0.59l-1.43,-2.06l0.44,-0.77l0.04,-0.19l-0.25,-1.64l-0.2,-0.24l-2.45,-0.84l-0.19,-0.0l-1.05,0.34l-0.25,-0.62l-0.18,-0.17l-2.5,-0.84l-0.74,-1.93l-0.21,-1.7l-0.13,-0.21l-0.92,-0.63l0.83,-0.89l0.07,-0.27l-0.71,-3.26l1.69,-2.01l0.03,-0.34l-0.24,-0.41l2.63,-1.9l-0.01,-0.49l-2.31,-1.57l5.08,-4.61l2.33,-2.24l1.01,-2.08l-0.09,-0.37l-3.52,-2.56l0.94,-2.38l-0.04,-0.29l-2.14,-2.86l1.61,-3.35l-0.01,-0.29l-2.81,-4.58l2.19,-3.04l-0.06,-0.42l-3.7,-2.76l0.32,-2.67l1.87,-0.38l4.26,-1.77l2.46,-1.47l3.96,2.58l0.12,0.05l6.81,1.04l9.37,4.87l1.81,1.92l0.15,2.55l-2.61,2.06l-3.95,1.07l-11.1,-3.15l-0.17,0.0l-1.84,0.53l-0.1,0.53l3.97,2.97l0.15,1.77l0.16,4.14l0.19,0.27l3.21,1.22l1.94,1.03l0.44,-0.22l0.32,-1.94l-0.07,-0.25l-1.32,-1.52l1.25,-1.2l5.87,2.45l0.24,-0.01l2.11,-0.98l0.13,-0.42l-1.55,-2.75l5.52,-3.84l2.13,0.22l2.28,1.42l0.43,-0.12l1.46,-2.87l-0.04,-0.33l-1.97,-2.37l1.14,-2.38l-0.02,-0.3l-1.42,-2.07l6.15,1.22l1.14,1.92l-2.74,0.46l-0.25,0.3l0.02,2.36l0.12,0.24l1.97,1.44l0.25,0.05l3.87,-0.91l0.22,-0.23l0.58,-2.55l5.09,-1.98l8.67,-3.69l1.22,0.14l-2.06,2.2l0.18,0.5l3.11,0.45l0.23,-0.07l1.71,-1.41l4.59,-0.12l0.12,-0.03l3.53,-1.72l2.7,2.48l0.42,-0.01l2.85,-2.88l-0.0,-0.43l-2.42,-2.35l1.0,-1.13l7.2,1.31l3.42,1.36l9.06,4.97l0.39,-0.08l1.67,-2.27l-0.04,-0.4l-2.46,-2.23l-0.06,-0.82l-0.26,-0.27l-2.64,-0.38l0.69,-1.76l0.0,-0.22l-1.32,-3.47l-0.07,-1.27l4.52,-4.09l0.08,-0.11l1.6,-4.18l1.67,-0.84l6.33,1.2l0.46,2.31l-2.31,3.67l0.05,0.38l1.49,1.41l0.77,3.04l-0.56,6.05l0.09,0.24l2.62,2.54l-0.99,2.65l-4.87,5.96l0.17,0.48l2.86,0.61l0.31,-0.13l0.94,-1.42l2.67,-1.04l0.18,-0.19l0.64,-2.01l2.11,-1.98l0.05,-0.37l-1.38,-2.32l1.11,-2.74l-0.24,-0.41l-2.53,-0.33l-0.53,-2.16l1.96,-4.42l-0.05,-0.32l-3.03,-3.48l4.21,-2.94l0.12,-0.3l-0.52,-3.04l0.72,-0.06l1.18,2.35l-0.97,4.39l0.2,0.35l2.68,0.84l0.37,-0.38l-1.05,-3.07l3.89,-1.71l5.05,-0.24l4.55,2.62l0.36,-0.05l0.05,-0.36l-2.19,-3.84l-0.23,-4.78l4.07,-0.92l5.98,0.21l5.47,-0.64l0.2,-0.48l-1.88,-2.37l2.65,-2.99l2.75,-0.13l0.12,-0.03l4.82,-2.48l6.56,-0.67l0.23,-0.14l0.76,-1.27l6.33,-0.46l1.97,1.11l0.28,0.01l5.55,-2.71l4.53,0.08l0.29,-0.21l0.67,-2.18l2.29,-2.15l5.75,-2.13l3.48,1.4l-2.7,1.03l-0.19,0.31l0.26,0.26l5.47,0.78ZM871.83,65.73l0.25,-0.15l1.99,0.01l3.3,1.2l-0.08,0.22l-2.41,1.03l-5.73,0.49l-0.31,-1.0l2.99,-1.8ZM797.64,48.44l-2.22,1.51l-3.85,-0.43l-4.35,-1.85l0.42,-1.13l4.42,0.72l5.59,1.17ZM783.82,46.06l-1.71,3.25l-9.05,-0.14l-4.11,1.15l-4.64,-3.04l1.21,-3.13l3.11,-0.91l6.53,0.22l8.66,2.59ZM780.37,145.71l2.28,5.23l-3.09,-0.89l-0.37,0.19l-1.54,4.65l0.04,0.27l2.38,3.17l-0.05,1.4l-1.41,-1.41l-0.46,0.04l-1.23,1.81l-0.33,-1.86l0.28,-3.1l-0.28,-3.41l0.58,-2.46l0.11,-4.39l-0.03,-0.13l-1.44,-3.2l0.21,-4.39l2.19,-1.49l0.09,-0.41l-0.81,-1.3l0.48,-0.21l0.56,1.94l0.86,3.23l-0.05,3.36l1.03,3.35ZM780.16,57.18l-3.4,0.03l-5.06,-0.53l1.97,-1.59l2.95,-0.42l3.35,1.75l0.18,0.77ZM683.84,31.18l-13.29,1.97l4.16,-6.56l1.88,-0.58l1.77,0.34l6.08,3.02l-0.6,1.8ZM670.94,28.02l-5.18,0.65l-6.89,-1.58l-4.03,-2.07l-1.88,-3.98l-0.18,-0.16l-2.8,-0.93l5.91,-3.62l5.25,-1.29l4.73,2.88l5.63,5.44l-0.57,4.66ZM564.37,68.98l-0.85,0.23l-7.93,-0.57l-0.6,-1.84l-0.21,-0.2l-4.34,-1.18l-0.3,-2.08l2.34,-0.92l0.19,-0.29l-0.08,-2.43l4.85,-4.0l-0.12,-0.52l-1.68,-0.43l5.47,-3.94l0.11,-0.33l-0.6,-2.02l5.36,-2.55l8.22,-3.27l8.29,-0.96l4.34,-1.94l4.67,-0.65l1.45,1.72l-1.43,1.37l-8.8,2.52l-7.65,2.42l-7.92,4.84l-3.73,4.75l-3.92,4.58l-0.07,0.23l0.51,3.88l0.11,0.2l4.32,3.39ZM548.86,18.57l-3.28,0.75l-2.25,0.44l-0.22,0.19l-0.3,0.81l-2.67,0.86l-2.27,-1.14l1.2,-1.51l-0.23,-0.49l-3.14,-0.1l2.48,-0.54l3.55,-0.07l0.44,1.36l0.49,0.12l1.4,-1.35l2.2,-0.9l3.13,1.08l-0.54,0.49ZM477.5,133.25l-4.21,0.05l-2.69,-0.34l0.39,-1.03l3.24,-1.06l2.51,0.58l0.85,0.43l-0.2,0.71l-0.0,0.15l0.12,0.52Z" data-code="RU" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M497.03,288.12l0.78,1.11l-0.12,1.19l-0.49,0.21l-1.25,-0.15l-0.3,0.16l-0.67,1.24l-1.01,-0.13l0.16,-0.92l0.22,-0.12l0.15,-0.24l0.09,-1.37l0.49,-0.48l0.42,0.18l0.25,-0.01l1.26,-0.65Z" data-code="RW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M469.75,168.65l0.21,-0.21l0.36,-1.44l-0.08,-0.29l-1.06,-1.03l0.54,-1.16l-0.28,-0.43l-0.26,0.0l0.55,-0.67l-0.01,-0.39l-0.77,-0.86l-0.45,-0.89l1.56,-0.67l1.39,0.12l1.22,1.1l0.26,0.91l0.16,0.19l1.38,0.66l0.17,1.12l0.14,0.21l1.46,0.9l0.35,-0.03l0.62,-0.54l0.09,0.06l-0.28,0.25l-0.03,0.42l0.29,0.34l-0.44,0.5l-0.07,0.26l0.22,1.12l0.07,0.14l1.02,1.1l-0.81,0.84l-0.42,0.96l0.04,0.3l0.12,0.15l-0.15,0.16l-1.04,0.04l-0.39,0.08l0.33,-0.81l-0.29,-0.41l-0.21,0.01l-0.39,-0.45l-0.13,-0.09l-0.32,-0.11l-0.27,-0.4l-0.14,-0.11l-0.4,-0.16l-0.31,-0.37l-0.34,-0.09l-0.45,0.17l-0.18,0.18l-0.29,0.84l-0.96,-0.65l-0.81,-0.33l-0.32,-0.37l-0.22,-0.18Z" data-code="RS" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M478.13,133.31l-0.14,-0.63l0.25,-0.88l-0.15,-0.35l-1.17,-0.58l-2.43,-0.57l-0.45,-2.51l2.58,-0.97l4.14,0.22l2.3,-0.32l0.26,0.54l0.22,0.17l1.26,0.22l2.25,1.6l0.19,1.23l-1.87,1.01l-0.14,0.18l-0.54,1.83l-2.54,1.21l-2.18,-0.02l-0.52,-0.91l-0.18,-0.14l-1.11,-0.32Z" data-code="LT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M435.95,147.99l0.33,0.49l-0.11,1.07l-0.39,0.04l-0.29,-0.15l0.21,-1.4l0.25,-0.05Z" data-code="LU" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M401.37,273.67l-0.32,0.01l-2.48,-1.15l-2.24,-1.89l-2.14,-1.38l-1.47,-1.42l0.44,-0.59l0.05,-0.13l0.12,-0.65l1.07,-1.3l1.08,-1.09l0.52,-0.07l0.43,-0.18l0.84,1.24l-0.15,0.89l0.07,0.25l0.49,0.54l0.22,0.1l0.71,0.01l0.27,-0.16l0.42,-0.83l0.19,0.02l-0.06,0.52l0.23,1.12l-0.5,1.03l0.06,0.35l0.73,0.69l0.14,0.08l0.71,0.15l0.92,0.91l0.06,0.76l-0.17,0.22l-0.06,0.15l-0.17,1.8Z" data-code="LR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M477.94,155.19l1.02,-0.64l1.49,0.33l1.52,0.01l1.09,0.73l0.32,0.01l0.81,-0.46l1.8,-0.3l0.18,-0.1l0.54,-0.64l0.86,0.0l0.64,0.26l0.71,0.87l0.8,1.35l1.39,1.81l0.07,1.25l-0.26,1.3l0.01,0.15l0.45,1.42l0.15,0.18l1.12,0.57l0.25,0.01l1.05,-0.45l0.86,0.4l0.03,0.43l-0.92,0.51l-0.63,-0.24l-0.4,0.22l-0.64,3.41l-1.12,-0.24l-1.78,-1.09l-0.23,-0.04l-2.95,0.71l-1.25,0.77l-3.55,-0.16l-1.89,-0.47l-0.14,-0.0l-0.75,0.17l-0.61,-1.07l-0.3,-0.36l0.36,-0.32l-0.04,-0.48l-0.62,-0.38l-0.36,0.03l-0.62,0.54l-1.15,-0.71l-0.18,-1.14l-0.17,-0.22l-1.4,-0.67l-0.24,-0.86l-0.09,-0.14l-0.96,-0.87l1.49,-0.44l0.16,-0.11l1.51,-2.14l1.15,-2.09l1.44,-0.63Z" data-code="RO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M383.03,256.73l-1.12,-0.88l-0.14,-0.06l-0.94,-0.15l-0.43,-0.54l0.01,-0.27l-0.13,-0.26l-0.68,-0.48l-0.05,-0.16l0.99,-0.31l0.77,0.08l0.15,-0.02l0.61,-0.26l4.25,0.1l-0.02,0.44l-0.19,0.18l-0.08,0.29l0.17,0.66l-0.17,0.14l-0.44,0.0l-0.16,0.05l-0.57,0.37l-0.66,-0.04l-0.24,0.1l-0.92,1.03Z" data-code="GW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M195.13,249.89l-1.05,-0.35l-1.5,-0.04l-1.06,-0.47l-1.19,-0.93l0.04,-0.53l0.27,-0.55l-0.03,-0.31l-0.24,-0.32l1.02,-1.77l3.04,-0.01l0.3,-0.28l0.06,-0.88l-0.19,-0.3l-0.3,-0.11l-0.23,-0.45l-0.11,-0.12l-0.9,-0.58l-0.35,-0.33l0.37,-0.0l0.3,-0.3l0.0,-1.15l4.05,0.02l-0.02,1.74l-0.2,2.89l0.3,0.32l0.67,-0.0l0.75,0.42l0.4,-0.11l-0.62,0.53l-1.17,0.7l-0.13,0.16l-0.18,0.49l0.0,0.21l0.14,0.34l-0.35,0.44l-0.49,0.13l-0.2,0.41l0.03,0.06l-0.27,0.16l-0.86,0.64l-0.12,0.22ZM199.35,245.38l0.07,-0.13l0.05,0.02l-0.13,0.11Z" data-code="GT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M487.2,174.55l-0.64,1.54l-0.43,0.24l-1.41,-0.08l-1.28,-0.28l-0.14,0.0l-3.03,0.77l-0.13,0.51l1.39,1.34l-0.78,0.29l-1.2,0.0l-1.23,-1.42l-0.47,0.02l-0.47,0.65l-0.04,0.27l0.56,1.76l0.06,0.11l1.02,1.12l-0.66,0.45l-0.04,0.46l1.39,1.35l1.15,0.79l0.02,1.06l-1.91,-0.63l-0.36,0.42l0.56,1.12l-1.2,0.23l-0.22,0.4l0.8,2.14l-1.15,0.02l-1.89,-1.15l-0.89,-2.19l-0.43,-1.91l-0.05,-0.11l-0.98,-1.35l-1.24,-1.62l-0.13,-0.63l1.07,-1.32l0.06,-0.14l0.13,-0.81l0.68,-0.36l0.16,-0.25l0.03,-0.54l1.4,-0.23l0.12,-0.05l0.87,-0.6l1.26,0.05l0.25,-0.11l0.34,-0.43l0.33,-0.07l1.81,0.08l0.13,-0.02l1.87,-0.77l1.64,0.97l0.19,0.04l2.28,-0.28l0.26,-0.29l0.02,-0.95l0.56,0.36ZM480.44,192.0l1.05,0.74l0.01,0.0l-1.26,-0.23l0.2,-0.51ZM481.76,192.79l1.86,-0.15l1.53,0.17l-0.02,0.19l0.34,0.3l-2.28,0.15l0.01,-0.13l-0.25,-0.31l-1.19,-0.22ZM485.65,193.28l0.65,-0.16l-0.05,0.12l-0.6,0.04Z" data-code="GR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M444.81,282.04l-0.21,-0.17l0.74,-2.4l3.56,0.05l0.02,2.42l-3.34,-0.02l-0.76,0.13Z" data-code="GQ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M271.34,264.25l1.43,0.81l1.44,1.53l0.06,1.19l0.28,0.28l0.84,0.05l2.13,1.92l-0.34,1.93l-1.37,0.59l-0.17,0.34l0.12,0.51l-0.43,1.21l0.03,0.26l1.11,1.82l0.26,0.14l0.56,0.0l0.32,1.29l1.25,1.78l-0.08,0.01l-1.34,-0.21l-0.24,0.06l-0.78,0.64l-1.06,0.41l-0.76,0.1l-0.22,0.15l-0.18,0.32l-0.95,-0.1l-1.38,-1.05l-0.19,-1.13l-0.6,-1.18l0.37,-1.96l0.65,-0.83l0.03,-0.32l-0.57,-1.17l-0.15,-0.14l-0.62,-0.27l0.25,-0.85l-0.08,-0.3l-0.58,-0.58l-0.24,-0.09l-1.15,0.1l-1.41,-1.58l0.48,-0.49l0.09,-0.22l-0.04,-0.92l1.31,-0.34l0.73,-0.52l0.04,-0.44l-0.75,-0.82l0.16,-0.66l1.74,-1.3Z" data-code="GY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M525.41,174.19l0.26,-0.88l-0.0,-0.17l-0.63,-2.06l-0.1,-0.15l-1.45,-1.12l-0.11,-0.05l-1.31,-0.33l-0.66,-0.69l1.97,0.48l3.65,0.49l3.3,1.41l0.39,0.5l0.33,0.1l1.43,-0.45l2.14,0.58l0.7,1.14l0.13,0.12l1.06,0.47l-0.18,0.11l-0.08,0.43l1.08,1.41l-0.06,0.06l-1.16,-0.15l-1.82,-0.84l-0.31,0.04l-0.55,0.44l-3.29,0.44l-2.32,-1.41l-0.17,-0.04l-2.25,0.12Z" data-code="GE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M412.82,118.6l-2.31,3.4l-0.0,0.33l0.31,0.13l2.52,-0.49l2.34,0.02l-0.56,2.51l-2.22,3.13l0.22,0.47l2.43,0.21l2.35,4.35l0.17,0.14l1.58,0.51l1.49,3.78l0.73,1.37l0.2,0.15l2.76,0.59l-0.25,1.75l-1.18,0.91l-0.08,0.39l0.87,1.49l-1.96,1.51l-3.31,-0.02l-4.15,0.88l-1.07,-0.59l-0.35,0.04l-1.55,1.44l-2.17,-0.35l-0.22,0.05l-1.61,1.15l-0.78,-0.38l3.31,-3.12l2.18,-0.7l0.21,-0.31l-0.26,-0.27l-3.78,-0.54l-0.48,-0.9l2.3,-0.92l0.13,-0.46l-1.29,-1.71l0.39,-1.83l3.46,0.29l0.32,-0.24l0.37,-1.99l-0.06,-0.24l-1.71,-2.17l-0.18,-0.11l-2.91,-0.58l-0.43,-0.68l0.82,-1.4l-0.03,-0.35l-0.82,-0.97l-0.46,0.01l-0.85,1.05l-0.11,-2.6l-0.05,-0.16l-1.19,-1.7l0.86,-3.53l1.81,-2.75l1.88,0.26l2.38,-0.24ZM406.39,132.84l-1.09,1.92l-1.65,-0.62l-1.26,0.02l0.41,-1.46l0.0,-0.16l-0.42,-1.51l1.62,-0.11l2.39,1.92Z" data-code="GB" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M448.76,294.47l-2.38,-2.34l-1.63,-2.04l-1.46,-2.48l0.06,-0.66l0.54,-0.81l0.61,-1.82l0.46,-1.69l0.63,-0.11l3.62,0.03l0.3,-0.3l-0.02,-2.75l0.88,-0.12l1.47,0.32l0.13,0.0l1.39,-0.3l-0.13,0.87l0.03,0.19l0.7,1.29l0.3,0.16l1.74,-0.19l0.36,0.29l-1.01,2.7l0.05,0.29l1.13,1.42l0.25,1.82l-0.3,1.56l-0.64,0.99l-1.93,-0.09l-1.26,-1.13l-0.5,0.17l-0.16,0.91l-1.48,0.27l-0.12,0.05l-0.86,0.63l-0.08,0.39l0.81,1.42l-1.48,1.08Z" data-code="GA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M399.83,265.31l-0.69,-0.06l-0.3,0.16l-0.43,0.85l-0.39,-0.01l-0.3,-0.33l0.14,-0.87l-0.05,-0.22l-1.05,-1.54l-0.37,-0.11l-0.61,0.27l-0.84,0.12l0.02,-0.54l-0.04,-0.17l-0.35,-0.57l0.07,-0.63l-0.03,-0.17l-0.57,-1.11l-0.7,-0.9l-0.24,-0.12l-2.0,-0.0l-0.19,0.07l-0.51,0.42l-0.6,0.05l-0.21,0.11l-0.43,0.55l-0.3,0.7l-1.04,0.86l-0.91,-1.24l-1.0,-1.02l-0.69,-0.37l-0.52,-0.42l-0.3,-1.11l-0.37,-0.56l-0.1,-0.1l-0.4,-0.23l0.77,-0.85l0.62,0.04l0.18,-0.05l0.58,-0.38l0.46,-0.0l0.19,-0.07l0.39,-0.34l0.1,-0.3l-0.17,-0.67l0.15,-0.14l0.09,-0.2l0.03,-0.57l0.87,0.02l1.76,0.6l0.13,0.01l0.55,-0.06l0.22,-0.13l0.08,-0.12l1.18,0.17l0.17,-0.02l0.09,0.56l0.3,0.25l0.4,-0.0l0.14,-0.03l0.56,-0.29l0.23,0.05l0.63,0.59l0.15,0.07l1.07,0.2l0.24,-0.06l0.65,-0.52l0.77,-0.32l0.55,-0.32l0.3,0.04l0.44,0.45l0.34,0.74l0.84,0.87l-0.35,0.45l-0.06,0.15l-0.1,0.82l0.42,0.31l0.35,-0.16l0.05,0.04l-0.1,0.59l0.09,0.27l0.42,0.4l-0.06,0.02l-0.18,0.21l-0.2,0.86l0.03,0.21l0.56,1.02l0.52,1.71l-0.65,0.21l-0.15,0.12l-0.24,0.35l-0.03,0.28l0.16,0.41l-0.1,0.76l-0.12,0.0Z" data-code="GN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M379.18,251.48l0.15,-0.55l2.51,-0.07l0.21,-0.09l0.48,-0.52l0.58,-0.03l0.91,0.58l0.16,0.05l0.78,0.01l0.14,-0.03l0.59,-0.31l0.16,0.24l-0.71,0.38l-0.94,-0.04l-1.02,-0.51l-0.3,0.01l-0.86,0.55l-0.37,0.02l-0.14,0.04l-0.53,0.31l-1.81,-0.04Z" data-code="GM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M304.13,6.6l8.19,-3.63l8.72,0.28l0.19,-0.06l3.12,-2.28l8.75,-0.61l19.94,0.8l14.93,4.75l-3.92,2.01l-9.52,0.27l-13.48,0.6l-0.27,0.2l0.09,0.33l1.26,1.09l0.22,0.07l8.81,-0.67l7.49,2.07l0.19,-0.01l4.68,-1.78l1.76,1.84l-2.59,3.26l-0.01,0.36l0.34,0.11l6.35,-2.2l12.09,-2.32l7.31,1.14l1.17,2.13l-9.9,4.05l-1.43,1.32l-7.91,0.98l-0.26,0.31l0.29,0.29l5.25,0.25l-2.63,3.72l-2.02,3.61l-0.04,0.15l0.08,6.05l0.07,0.19l2.61,3.0l-3.4,0.2l-4.12,1.66l-0.04,0.54l4.5,2.67l0.53,3.9l-2.39,0.42l-0.19,0.48l2.91,3.83l-5.0,0.32l-0.27,0.22l0.12,0.33l2.69,1.84l-0.65,1.35l-3.36,0.71l-3.46,0.01l-0.21,0.51l3.05,3.15l0.02,1.53l-4.54,-1.79l-0.32,0.06l-1.29,1.26l0.11,0.5l3.33,1.15l3.17,2.74l0.85,3.29l-4.0,0.78l-1.83,-1.66l-3.1,-2.64l-0.36,-0.02l-0.13,0.33l0.8,2.92l-2.76,2.26l-0.09,0.33l0.28,0.2l6.59,0.19l2.47,0.18l-5.86,3.38l-6.76,3.43l-7.26,1.48l-2.73,0.02l-0.16,0.05l-2.67,1.72l-3.44,4.42l-5.28,2.86l-1.73,0.18l-3.33,1.01l-3.59,0.96l-0.15,0.1l-2.15,2.52l-0.07,0.19l-0.03,2.76l-1.21,2.49l-4.03,3.1l-0.1,0.33l0.98,2.94l-2.31,6.57l-3.21,0.21l-3.6,-3.0l-0.19,-0.07l-4.9,-0.02l-2.29,-1.97l-1.69,-3.78l-4.31,-4.86l-1.23,-2.52l-0.34,-3.58l-0.08,-0.17l-3.35,-3.67l0.85,-2.92l-0.09,-0.31l-1.5,-1.34l2.33,-4.7l3.67,-1.57l0.15,-0.13l1.02,-1.93l0.52,-3.47l-0.44,-0.31l-2.85,1.57l-1.33,0.64l-2.12,0.59l-2.81,-1.32l-0.15,-2.79l0.88,-2.17l2.09,-0.06l5.07,1.2l0.34,-0.17l-0.11,-0.37l-4.3,-2.9l-2.24,-1.58l-0.25,-0.05l-2.38,0.62l-1.7,-0.93l2.62,-4.1l-0.03,-0.36l-1.51,-1.75l-1.97,-3.3l-3.01,-5.21l-0.1,-0.11l-3.04,-1.85l0.03,-1.94l-0.18,-0.28l-6.82,-3.01l-5.35,-0.38l-6.69,0.21l-6.03,0.37l-2.81,-1.59l-3.84,-2.9l5.94,-1.5l5.01,-0.28l0.28,-0.29l-0.26,-0.31l-10.68,-1.38l-5.38,-2.1l0.27,-1.68l9.3,-2.6l9.18,-2.68l0.19,-0.16l0.97,-2.05l-0.18,-0.42l-6.29,-1.91l1.81,-1.9l8.58,-4.05l3.6,-0.63l0.23,-0.4l-0.92,-2.37l5.59,-1.5l7.66,-0.95l7.58,-0.05l2.65,1.84l0.31,0.02l6.52,-3.29l5.85,2.24l3.55,0.49l5.17,1.95l0.38,-0.16l-0.13,-0.39l-5.77,-3.16l0.29,-2.26Z" data-code="GL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M540.87,207.81l0.41,0.94l-0.18,0.51l0.0,0.21l0.65,1.66l-1.15,0.05l-0.54,-1.12l-0.24,-0.17l-1.73,-0.2l1.44,-2.06l1.33,0.18Z" data-code="KW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M423.16,269.88l-3.58,1.34l-1.41,0.87l-2.13,0.69l-1.91,-0.61l0.09,-0.75l-0.03,-0.17l-1.04,-2.07l0.62,-2.7l1.04,-2.08l0.03,-0.19l-1.0,-5.46l0.05,-1.12l4.04,-0.11l1.08,0.18l0.18,-0.03l0.72,-0.36l0.75,0.13l-0.11,0.48l0.06,0.26l0.98,1.22l-0.0,1.77l0.24,1.99l0.05,0.13l0.55,0.81l-0.52,2.14l0.19,1.37l0.69,1.66l0.38,0.62Z" data-code="GH" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M568.16,231.0l-0.08,0.1l-0.84,1.61l-0.93,-0.11l-0.27,0.11l-0.58,0.73l-0.4,1.32l-0.01,0.14l0.29,1.61l-0.07,0.09l-1.0,-0.01l-0.16,0.04l-1.56,0.97l-0.14,0.2l-0.23,1.17l-0.41,0.4l-1.44,-0.02l-0.17,0.05l-0.98,0.65l-0.13,0.25l0.01,0.87l-0.97,0.57l-1.27,-0.22l-0.19,0.03l-1.63,0.84l-0.88,0.11l-2.55,-5.57l7.2,-2.49l0.19,-0.19l1.67,-5.23l-0.03,-0.25l-1.1,-1.78l0.05,-0.89l0.68,-1.03l0.05,-0.16l0.01,-0.89l0.96,-0.44l0.07,-0.5l-0.32,-0.26l0.16,-1.31l0.85,-0.01l1.03,1.67l0.09,0.09l1.4,0.96l0.11,0.05l1.82,0.34l1.37,0.45l1.75,2.32l0.13,0.1l0.7,0.26l-0.0,0.3l-1.25,2.19l-1.01,0.8ZM561.88,218.47l-0.01,0.02l-0.15,-0.29l0.3,-0.38l-0.14,0.65Z" data-code="OM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M543.2,261.06l-1.07,1.46l-1.65,1.99l-1.91,0.01l-8.08,-2.95l-0.89,-0.84l-0.9,-1.19l-0.81,-1.23l0.44,-0.73l0.76,-1.12l0.49,0.28l0.52,1.05l1.13,1.06l0.2,0.08l1.24,0.01l2.42,-0.65l2.77,-0.31l2.17,-0.78l1.31,-0.19l0.84,-0.43l1.03,-0.06l-0.01,4.54Z" data-code="_3" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M384.23,230.37l0.07,-0.06l0.28,-0.89l0.99,-1.13l0.07,-0.13l0.8,-3.54l3.4,-2.8l0.09,-0.13l0.76,-2.17l0.07,5.5l-2.07,0.21l-0.24,0.17l-0.61,1.36l-0.02,0.16l0.43,3.46l-4.01,-0.01ZM391.82,218.2l0.07,-0.06l0.75,-1.93l1.86,-0.25l0.94,0.34l1.14,0.0l0.18,-0.06l0.73,-0.56l1.41,-0.08l-0.0,2.72l-7.08,-0.12Z" data-code="_2" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M472.71,172.84l-0.07,-0.43l-0.16,-0.22l-0.53,-0.27l-0.38,-0.58l0.3,-0.43l0.51,-0.19l0.18,-0.18l0.3,-0.87l0.12,-0.04l0.22,0.26l0.12,0.09l0.38,0.15l0.28,0.41l0.15,0.12l0.34,0.12l0.43,0.5l0.15,0.07l-0.12,0.3l-0.27,0.32l-0.03,0.18l-0.31,0.06l-1.48,0.47l-0.15,0.17Z" data-code="_1" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M503.54,192.92l0.09,-0.17l0.41,0.01l-0.08,0.01l-0.42,0.15ZM504.23,192.76l1.02,0.02l0.4,-0.13l-0.09,0.29l0.03,0.08l-0.35,0.16l-0.24,-0.04l-0.06,-0.1l-0.18,-0.17l-0.19,-0.08l-0.33,-0.02Z" data-code="_0" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M510.26,200.93l0.28,-0.57l2.53,1.0l0.27,-0.02l4.57,-2.77l0.84,2.84l-0.28,0.25l-4.95,1.37l-0.14,0.49l2.24,2.48l-0.5,0.28l-0.13,0.14l-0.35,0.78l-1.76,0.35l-0.2,0.14l-0.57,0.94l-0.94,0.73l-2.45,-0.38l-0.03,-0.12l1.23,-4.32l-0.04,-1.1l0.34,-0.75l0.03,-0.12l0.0,-1.63Z" data-code="JO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M455.49,162.73l1.53,0.09l0.24,-0.1l0.29,-0.34l0.64,0.38l0.14,0.04l0.98,0.06l0.32,-0.3l-0.01,-0.66l0.67,-0.25l0.19,-0.22l0.21,-1.11l1.72,-0.72l0.65,0.32l1.94,1.37l2.07,0.6l0.22,-0.02l0.67,-0.33l0.47,0.94l0.67,0.76l-0.63,0.77l-0.91,-0.55l-0.16,-0.04l-1.69,0.04l-2.2,-0.51l-1.17,0.07l-0.21,0.11l-0.36,0.42l-0.67,-0.53l-0.46,0.12l-0.52,1.29l0.05,0.31l1.21,1.42l0.58,0.99l1.15,1.14l0.95,0.68l0.92,1.23l0.1,0.09l1.75,0.91l-1.87,-0.89l-1.5,-1.11l-2.23,-0.88l-1.77,-1.9l0.12,-0.06l0.1,-0.47l-1.07,-1.22l-0.04,-0.94l-0.21,-0.27l-1.61,-0.49l-0.35,0.14l-0.53,0.93l-0.41,-0.57l0.04,-0.73Z" data-code="HR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M237.82,234.68l1.35,0.1l1.95,0.37l0.18,1.15l-0.16,0.83l-0.51,0.37l-0.06,0.44l0.57,0.68l-0.02,0.22l-1.31,-0.35l-1.26,0.17l-1.49,-0.18l-0.15,0.02l-1.03,0.43l-1.02,-0.61l0.09,-0.36l2.04,0.32l1.9,0.21l0.19,-0.05l0.9,-0.58l0.05,-0.47l-1.05,-1.03l0.02,-0.86l-0.23,-0.3l-1.13,-0.29l0.18,-0.23Z" data-code="HT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M461.96,157.92l0.68,-1.66l-0.03,-0.29l-0.15,-0.22l0.84,-0.0l0.3,-0.26l0.12,-0.84l0.88,0.57l0.98,0.38l0.16,0.01l2.1,-0.39l0.23,-0.21l0.14,-0.45l0.88,-0.1l1.06,-0.43l0.13,0.1l0.28,0.04l1.18,-0.4l0.14,-0.1l0.52,-0.67l0.63,-0.15l2.6,0.95l0.26,-0.03l0.38,-0.23l1.12,0.7l0.1,0.49l-1.31,0.57l-0.14,0.13l-1.18,2.14l-1.44,2.04l-1.85,0.55l-1.51,-0.13l-0.14,0.02l-1.92,0.82l-0.85,0.42l-1.91,-0.55l-1.83,-1.31l-0.74,-0.37l-0.44,-0.97l-0.26,-0.18Z" data-code="HU" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M202.48,251.87l-0.33,-0.62l-0.18,-0.14l-0.5,-0.15l0.13,-0.76l-0.11,-0.28l-0.34,-0.28l-0.6,-0.23l-0.18,-0.01l-0.81,0.22l-0.16,-0.24l-0.72,-0.39l-0.51,-0.48l-0.12,-0.07l-0.31,-0.09l0.24,-0.3l0.04,-0.3l-0.16,-0.4l0.1,-0.28l1.14,-0.69l1.0,-0.86l0.09,0.04l0.3,-0.05l0.47,-0.39l0.49,-0.03l0.14,0.13l0.29,0.06l0.31,-0.1l1.16,0.22l1.24,-0.08l0.81,-0.28l0.29,-0.25l0.63,0.1l0.69,0.18l0.65,-0.06l0.49,-0.2l1.04,0.32l0.38,0.06l0.7,0.44l0.71,0.56l0.92,0.41l0.1,0.11l-0.11,-0.01l-0.23,0.09l-0.3,0.3l-0.76,0.29l-0.58,0.0l-0.15,0.04l-0.45,0.26l-0.31,-0.07l-0.37,-0.34l-0.28,-0.07l-0.26,0.07l-0.18,0.15l-0.23,0.43l-0.04,-0.0l-0.33,0.28l-0.03,0.4l-0.76,0.61l-0.45,0.3l-0.15,0.16l-0.51,-0.36l-0.41,0.06l-0.45,0.56l-0.41,-0.01l-0.59,0.06l-0.27,0.31l0.04,0.96l-0.07,0.0l-0.25,0.16l-0.24,0.45l-0.42,0.06Z" data-code="HN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M254.95,238.31l1.15,0.21l0.2,0.23l-0.36,0.36l-1.76,-0.01l-1.2,0.07l-0.09,-0.69l0.17,-0.18l1.89,0.01Z" data-code="PR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M509.66,201.06l-0.0,1.44l-0.29,0.63l-0.59,0.19l0.02,-0.11l0.52,-0.31l-0.02,-0.53l-0.41,-0.2l0.36,-1.28l0.41,0.17Z" data-code="PS" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M398.65,173.6l0.75,-0.63l0.7,-0.3l0.51,1.2l0.28,0.18l1.48,-0.0l0.2,-0.08l0.33,-0.3l1.16,0.08l0.52,1.11l-0.95,0.66l-0.13,0.24l-0.03,2.2l-0.33,0.35l-0.08,0.18l-0.08,1.17l-0.86,0.19l-0.2,0.44l0.93,1.64l-0.64,1.79l0.07,0.31l0.72,0.72l-0.24,0.56l-0.9,1.05l-0.07,0.26l0.17,0.77l-0.73,0.54l-1.18,-0.36l-0.16,-0.0l-0.85,0.21l0.31,-1.81l-0.23,-1.87l-0.23,-0.25l-0.99,-0.24l-0.49,-0.91l0.18,-1.72l0.93,-0.99l0.08,-0.16l0.17,-1.17l0.52,-1.76l-0.04,-1.36l-0.51,-1.14l-0.09,-0.8Z" data-code="PT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M264.33,341.43l0.93,-2.96l0.07,-1.42l1.1,-2.1l4.19,-0.73l2.22,0.04l2.12,1.21l0.07,0.76l0.7,1.38l-0.16,3.48l0.24,0.31l2.64,0.5l0.19,-0.03l0.9,-0.45l1.47,0.62l0.38,0.64l0.23,2.35l0.3,1.07l0.25,0.21l0.93,0.12l0.16,-0.02l0.8,-0.37l0.61,0.33l-0.0,1.25l-0.33,1.53l-0.5,1.57l-0.39,2.26l-2.14,1.94l-1.85,0.4l-2.74,-0.4l-2.13,-0.62l2.26,-3.75l0.03,-0.24l-0.36,-1.18l-0.17,-0.19l-2.55,-1.03l-3.04,-1.95l-2.07,-0.43l-4.4,-4.12Z" data-code="PY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M213.65,263.79l0.18,-0.43l0.02,-0.18l-0.06,-0.28l0.23,-0.18l-0.01,-0.48l-0.4,-0.29l-0.01,-0.62l0.57,-0.13l0.68,0.69l-0.04,0.39l0.26,0.33l1.0,0.11l0.27,-0.1l0.49,0.44l0.24,0.07l1.34,-0.22l1.04,-0.62l1.49,-0.5l0.86,-0.73l0.99,0.11l0.18,0.28l1.35,0.08l1.02,0.4l0.78,0.72l0.71,0.53l-0.1,0.12l-0.05,0.3l0.53,1.34l-0.28,0.44l-0.6,-0.13l-0.36,0.22l-0.2,0.76l-0.41,-0.36l-0.44,-1.12l0.49,-0.53l-0.14,-0.49l-0.51,-0.14l-0.41,-0.72l-0.11,-0.11l-1.25,-0.7l-0.19,-0.04l-1.1,0.16l-0.22,0.15l-0.47,0.81l-0.9,0.56l-0.49,0.08l-0.22,0.17l-0.25,0.52l0.05,0.32l0.93,1.07l-0.41,0.21l-0.29,0.3l-0.81,0.09l-0.36,-1.26l-0.53,-0.1l-0.21,0.28l-0.5,-0.09l-0.44,-0.88l-0.22,-0.16l-0.99,-0.16l-0.61,-0.28l-0.13,-0.03l-1.0,0.0Z" data-code="PA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M808.4,298.6l0.62,0.46l1.19,1.56l1.04,0.77l-0.18,0.37l-0.42,0.15l-0.92,-0.82l-1.05,-1.53l-0.27,-0.96ZM804.09,296.06l-0.3,0.26l-0.36,-1.11l-0.66,-1.06l-2.55,-1.89l-1.42,-0.59l0.17,-0.15l1.16,0.6l0.85,0.55l1.01,0.58l0.97,1.02l0.9,0.76l0.24,1.03ZM796.71,297.99l0.15,0.82l0.34,0.24l1.43,-0.19l0.19,-0.11l0.68,-0.82l1.36,-0.87l0.13,-0.31l-0.21,-1.13l1.04,-0.03l0.3,0.25l-0.04,1.17l-0.74,1.34l-1.17,0.18l-0.22,0.15l-0.35,0.62l-2.51,1.13l-1.21,-0.0l-1.99,-0.71l-1.19,-0.58l0.07,-0.28l1.98,0.32l1.46,-0.2l0.24,-0.21l0.25,-0.79ZM789.24,303.52l0.11,0.15l2.19,1.62l1.6,2.62l0.27,0.14l1.09,-0.06l-0.07,0.77l0.23,0.32l1.23,0.27l-0.14,0.09l0.05,0.53l2.39,0.95l-0.11,0.28l-1.33,0.14l-0.51,-0.55l-0.18,-0.09l-4.59,-0.65l-1.87,-1.55l-1.38,-1.35l-1.28,-2.17l-0.16,-0.13l-3.27,-1.1l-0.19,0.0l-2.12,0.72l-1.58,0.85l-0.15,0.31l0.28,1.63l-1.65,0.73l-1.37,-0.4l-2.3,-0.09l-0.08,-15.65l3.95,1.57l4.58,1.42l1.67,1.25l1.32,1.19l0.36,1.39l0.19,0.21l4.06,1.51l0.39,0.85l-1.9,0.22l-0.25,0.39l0.55,1.68Z" data-code="PG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M246.44,329.21l-0.63,1.25l-1.05,0.54l-2.25,-1.33l-0.19,-0.93l-0.16,-0.21l-4.95,-2.58l-4.46,-2.79l-1.87,-1.52l-0.94,-1.91l0.33,-0.6l-0.01,-0.31l-2.11,-3.33l-2.46,-4.66l-2.36,-5.02l-1.04,-1.18l-0.77,-1.81l-0.08,-0.11l-1.95,-1.64l-1.54,-0.88l0.61,-0.85l0.02,-0.31l-1.15,-2.27l0.69,-1.56l1.59,-1.26l0.12,0.42l-0.56,0.47l-0.11,0.25l0.07,0.92l0.36,0.27l0.97,-0.19l0.85,0.23l0.99,1.19l0.41,0.05l1.42,-1.03l0.11,-0.16l0.46,-1.64l1.45,-2.06l2.92,-0.96l0.11,-0.07l2.73,-2.62l0.84,-1.72l0.02,-0.18l-0.3,-1.65l0.28,-0.1l1.49,1.06l0.77,1.14l0.1,0.09l1.08,0.6l1.43,2.55l0.21,0.15l1.86,0.31l0.18,-0.03l1.25,-0.6l0.77,0.37l0.17,0.03l1.4,-0.2l1.57,0.96l-1.45,2.29l0.23,0.46l0.63,0.05l0.66,0.7l-1.51,-0.08l-0.24,0.1l-0.27,0.31l-1.96,0.46l-2.95,1.74l-0.14,0.21l-0.17,1.1l-0.6,0.82l-0.05,0.23l0.21,1.13l-1.31,0.63l-0.17,0.27l0.0,0.91l-0.53,0.37l-0.1,0.37l1.04,2.27l1.31,1.46l-0.44,0.9l0.24,0.43l1.52,0.13l0.87,1.23l0.24,0.13l2.21,0.07l0.18,-0.06l1.55,-1.13l-0.14,3.22l0.23,0.3l1.14,0.29l0.16,-0.0l1.18,-0.36l1.97,3.71l-0.45,0.71l-0.04,0.14l-0.12,1.8l-0.05,2.07l-0.92,1.2l-0.03,0.31l0.38,0.8l-0.48,0.72l-0.02,0.3l1.01,2.02l-1.5,2.64Z" data-code="PE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M609.08,187.76l1.66,1.21l0.71,2.11l0.2,0.19l3.62,1.01l-1.98,1.95l-2.65,0.4l-3.75,-0.68l-0.26,0.08l-1.23,1.22l-0.07,0.31l0.89,2.46l0.88,1.92l0.1,0.12l1.67,1.14l-1.8,1.35l-0.12,0.25l0.04,1.85l-2.35,2.67l-1.59,2.79l-2.5,2.72l-2.76,-0.2l-0.24,0.09l-2.76,2.83l0.04,0.45l1.54,1.13l0.27,1.94l0.09,0.17l1.34,1.29l0.4,1.83l-5.14,-0.01l-0.22,0.09l-1.53,1.63l-1.52,-0.56l-0.76,-1.88l-1.93,-2.03l-0.25,-0.09l-4.6,0.5l-4.05,0.05l-3.1,0.33l0.77,-2.53l3.48,-1.33l0.19,-0.33l-0.21,-1.24l-0.19,-0.23l-1.01,-0.37l-0.06,-2.18l-0.17,-0.26l-2.32,-1.16l-0.96,-1.57l-0.56,-0.65l3.16,1.05l0.14,0.01l2.45,-0.4l1.44,0.33l0.3,-0.1l0.4,-0.47l1.58,0.22l0.14,-0.01l3.25,-1.14l0.2,-0.27l0.08,-2.23l1.23,-1.38l1.73,0.0l0.28,-0.2l0.22,-0.61l1.68,-0.32l0.86,0.24l0.27,-0.05l0.98,-0.78l0.11,-0.26l-0.13,-1.57l0.96,-1.52l1.51,-0.67l0.14,-0.41l-0.74,-1.4l1.86,0.07l0.26,-0.13l0.69,-1.01l0.05,-0.2l-0.09,-0.94l1.14,-1.09l0.09,-0.28l-0.29,-1.41l-0.51,-1.07l1.23,-1.05l2.6,-0.58l2.86,-0.33l1.33,-0.54l1.3,-0.29Z" data-code="PK" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M737.11,263.82l0.25,1.66l0.14,1.34l-0.54,1.46l-0.64,-1.79l-0.5,-0.1l-1.17,1.28l-0.05,0.32l0.74,1.71l-0.49,0.81l-2.6,-1.28l-0.61,-1.57l0.68,-1.07l-0.07,-0.4l-1.59,-1.19l-0.42,0.06l-0.69,0.91l-1.01,-0.08l-0.21,0.06l-1.58,1.2l-0.17,-0.3l0.87,-1.88l1.48,-0.66l1.18,-0.81l0.71,0.92l0.34,0.1l1.9,-0.69l0.18,-0.18l0.34,-0.94l1.57,-0.06l0.29,-0.32l-0.1,-1.38l1.41,0.83l0.36,2.06ZM734.94,254.42l0.56,2.24l-1.41,-0.49l-0.4,0.3l0.07,0.94l0.51,1.3l-0.54,0.26l-0.08,-1.34l-0.25,-0.28l-0.56,-0.1l-0.23,-0.91l1.03,0.14l0.34,-0.31l-0.03,-0.96l-0.06,-0.18l-1.14,-1.44l1.62,0.04l0.57,0.78ZM724.68,238.33l1.48,0.71l0.33,-0.04l0.44,-0.38l0.05,0.13l-0.37,0.97l0.01,0.23l0.81,1.75l-0.59,1.92l-1.37,0.79l-0.14,0.2l-0.39,2.07l0.01,0.14l0.56,2.04l0.23,0.21l1.33,0.28l0.14,-0.0l1.0,-0.27l2.82,1.28l-0.2,1.16l0.12,0.29l0.66,0.5l-0.13,0.56l-1.54,-0.99l-0.89,-1.29l-0.49,0.0l-0.44,0.65l-1.34,-1.28l-0.26,-0.08l-2.18,0.36l-0.96,-0.44l0.09,-0.72l0.69,-0.57l-0.01,-0.47l-0.75,-0.59l-0.47,0.14l-0.15,0.43l-0.86,-1.02l-0.34,-1.02l-0.07,-1.74l0.49,0.41l0.49,-0.21l0.26,-3.99l0.73,-2.1l1.23,0.0ZM731.12,258.92l-0.82,0.75l-0.83,1.64l-0.52,0.5l-1.17,-1.33l0.36,-0.47l0.62,-0.7l0.07,-0.15l0.24,-1.35l0.73,-0.08l-0.31,1.29l0.16,0.34l0.37,-0.09l1.21,-1.6l-0.12,1.24ZM726.66,255.58l0.85,0.45l0.14,0.03l1.28,-0.0l-0.03,0.62l-1.04,0.96l-1.15,0.55l-0.05,-0.71l0.17,-1.26l-0.01,-0.13l-0.16,-0.51ZM724.92,252.06l-0.45,1.5l-0.7,-0.83l-0.95,-1.43l1.44,0.06l0.67,0.7ZM717.48,261.28l-1.87,1.35l0.21,-0.3l1.81,-1.57l1.5,-1.75l0.97,-1.84l0.23,1.08l-1.56,1.33l-1.29,1.7Z" data-code="PH" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M458.8,144.25l-0.96,-1.98l0.18,-1.06l-0.01,-0.15l-0.62,-1.8l-0.82,-1.11l0.56,-0.73l0.05,-0.28l-0.51,-1.51l1.48,-0.87l3.88,-1.58l3.06,-1.14l2.23,0.52l0.15,0.66l0.29,0.23l2.4,0.04l3.11,0.39l4.56,-0.05l1.12,0.32l0.51,0.89l0.1,1.45l0.03,0.12l0.66,1.23l-0.01,1.08l-1.33,0.61l-0.14,0.41l0.74,1.5l0.07,1.53l1.22,2.79l-0.19,0.66l-1.09,0.33l-0.14,0.09l-2.27,2.72l-0.04,0.31l0.35,0.8l-2.22,-1.16l-0.21,-0.02l-1.72,0.44l-1.1,-0.31l-0.21,0.02l-1.3,0.61l-1.11,-1.02l-0.32,-0.05l-0.81,0.35l-1.15,-1.61l-0.21,-0.12l-1.65,-0.17l-0.19,-0.82l-0.23,-0.23l-1.72,-0.37l-0.34,0.17l-0.25,0.56l-0.88,-0.44l0.12,-0.69l-0.25,-0.35l-1.78,-0.27l-1.08,-0.97Z" data-code="PL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M502.81,308.32l1.09,1.04l0.58,1.94l-0.39,0.66l-0.5,2.05l-0.0,0.14l0.45,1.95l-0.69,0.77l-0.06,0.11l-0.76,2.37l0.15,0.36l0.62,0.31l-6.85,1.9l-0.22,0.33l0.2,1.54l-1.62,0.3l-0.12,0.05l-1.43,1.02l-0.11,0.15l-0.25,0.73l-0.73,0.17l-0.14,0.08l-2.18,2.12l-1.33,1.6l-0.65,0.05l-0.83,-0.29l-2.75,-0.28l-0.24,-0.1l-0.15,-0.27l-0.99,-0.58l-0.12,-0.04l-1.73,-0.14l-1.88,0.54l-1.5,-1.48l-1.61,-2.01l0.11,-7.73l4.92,0.03l0.29,-0.37l-0.19,-0.79l0.34,-0.86l0.0,-0.21l-0.41,-1.11l0.26,-1.14l-0.01,-0.16l-0.12,-0.36l0.18,0.01l0.1,0.56l0.31,0.25l1.14,-0.06l1.44,0.21l0.76,1.05l0.19,0.12l2.01,0.35l0.19,-0.03l1.24,-0.65l0.44,1.03l0.22,0.18l1.81,0.34l0.85,0.99l1.02,1.39l0.24,0.12l1.92,0.02l0.3,-0.32l-0.21,-2.74l-0.47,-0.23l-0.53,0.36l-1.58,-0.89l-0.51,-0.34l0.29,-2.36l0.44,-2.99l-0.03,-0.18l-0.5,-0.99l0.61,-1.38l0.53,-0.24l3.26,-0.41l0.89,0.23l1.01,0.62l1.04,0.44l1.6,0.43l1.35,0.72Z" data-code="ZM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M482.19,120.88l0.23,-1.68l-0.43,-0.31l-0.75,0.37l-1.34,-1.1l-0.18,-1.75l2.92,-0.95l3.07,-0.53l2.66,0.6l2.48,-0.1l0.18,0.31l-1.65,1.96l-0.06,0.26l0.71,3.25l-0.88,0.94l-1.85,-0.01l-2.08,-1.3l-1.14,-0.47l-0.2,-0.01l-1.69,0.51Z" data-code="EE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M508.07,208.8l-0.66,1.06l-0.53,2.03l-0.64,1.32l-0.32,0.26l-1.74,-1.85l-1.77,-3.86l-0.48,-0.09l-0.26,0.25l-0.07,0.32l1.04,2.88l1.55,2.76l1.89,4.18l0.94,1.48l0.83,1.54l2.08,2.73l-0.3,0.28l-0.1,0.23l0.08,1.72l0.11,0.22l2.91,2.37l-28.78,0.0l0.0,-19.06l-0.73,-2.2l0.61,-1.59l0.0,-0.2l-0.34,-1.04l0.73,-1.08l3.13,-0.04l2.36,0.72l2.48,0.81l1.15,0.43l0.23,-0.01l1.93,-0.87l1.02,-0.78l2.08,-0.21l1.59,0.31l0.62,1.24l0.52,0.03l0.46,-0.71l1.86,0.59l1.95,0.16l0.17,-0.04l0.92,-0.52l1.48,4.24Z" data-code="EG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M467.06,373.27l-0.13,-0.29l0.01,-1.58l-0.02,-0.12l-0.71,-1.64l0.59,-0.37l0.14,-0.26l-0.07,-2.13l-0.05,-0.15l-1.63,-2.58l-1.25,-2.31l-1.71,-3.37l0.88,-0.98l0.7,0.52l0.39,1.08l0.23,0.19l1.1,0.19l1.55,0.51l0.14,0.01l1.35,-0.2l0.11,-0.04l2.24,-1.39l0.14,-0.25l0.0,-9.4l0.16,0.09l1.39,2.38l-0.22,1.53l0.04,0.19l0.56,0.94l0.3,0.14l1.79,-0.27l0.16,-0.08l1.23,-1.18l1.17,-0.79l0.1,-0.12l0.57,-1.19l1.02,-0.52l0.9,0.28l1.16,0.73l0.14,0.05l2.04,0.13l0.13,-0.02l1.6,-0.62l0.18,-0.19l0.63,-1.93l1.18,-0.19l0.19,-0.12l0.78,-1.05l0.81,-1.71l2.18,-1.91l3.44,-1.88l0.89,0.02l1.17,0.43l0.21,-0.0l0.76,-0.29l1.07,0.21l1.15,3.55l0.63,1.82l-0.44,2.9l0.1,0.52l-0.74,-0.29l-0.18,-0.01l-0.72,0.19l-0.21,0.2l-0.22,0.74l-0.66,0.97l-0.05,0.18l0.02,0.93l0.09,0.21l1.49,1.46l0.27,0.08l1.47,-0.29l0.22,-0.18l0.43,-1.01l1.29,0.02l-0.51,1.63l-0.29,2.2l-0.59,1.12l-2.2,1.78l-1.06,1.39l-0.72,1.44l-1.39,1.93l-2.81,2.84l-1.75,1.65l-1.85,1.24l-2.55,1.06l-1.23,0.14l-0.24,0.18l-0.22,0.54l-1.27,-0.35l-0.2,0.01l-1.15,0.5l-2.62,-0.52l-0.12,0.0l-1.46,0.33l-0.98,-0.14l-0.16,0.02l-2.55,1.1l-2.11,0.44l-1.59,1.07l-0.93,0.06l-0.97,-0.92l-0.19,-0.08l-0.72,-0.04l-1.0,-1.16l-0.25,0.05ZM493.72,359.24l-1.12,-0.86l-0.31,-0.03l-1.23,0.59l-1.36,1.07l-1.39,1.78l0.01,0.38l1.88,2.11l0.31,0.09l0.9,-0.27l0.18,-0.15l0.4,-0.77l1.28,-0.39l0.18,-0.16l0.42,-0.88l0.76,-1.32l-0.05,-0.37l-0.87,-0.82Z" data-code="ZA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M220.2,293.48l1.25,-1.76l0.02,-0.31l-0.54,-1.09l-0.5,-0.06l-0.78,0.94l-1.03,-0.75l0.33,-0.46l0.05,-0.23l-0.38,-2.04l0.66,-0.28l0.17,-0.19l0.45,-1.52l0.93,-1.58l0.04,-0.2l-0.13,-0.78l1.19,-0.47l1.57,-0.91l2.35,1.34l0.17,0.04l0.28,-0.02l0.52,0.91l0.21,0.15l2.12,0.35l0.2,-0.03l0.55,-0.31l1.08,0.73l0.97,0.54l0.31,1.67l-0.71,1.49l-2.64,2.54l-2.95,0.97l-0.15,0.11l-1.53,2.18l-0.49,1.68l-1.1,0.8l-0.87,-1.05l-0.15,-0.1l-1.01,-0.27l-0.13,-0.0l-0.7,0.14l-0.03,-0.43l0.6,-0.5l0.1,-0.31l-0.26,-0.91Z" data-code="EC" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M470.27,171.7l0.38,0.19l0.45,-0.18l0.4,0.61l0.11,0.1l0.46,0.24l0.13,0.87l-0.3,0.95l-0.0,0.17l0.36,1.28l0.12,0.17l0.9,0.63l-0.03,0.44l-0.67,0.35l-0.16,0.22l-0.14,0.88l-0.96,1.18l-0.06,-0.03l-0.04,-0.48l-0.12,-0.22l-1.28,-0.92l-0.19,-1.25l0.2,-1.96l0.33,-0.89l-0.06,-0.3l-0.36,-0.41l-0.13,-0.75l0.66,-0.9Z" data-code="AL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M461.62,299.93l0.55,1.67l0.73,1.54l1.56,2.18l0.28,0.12l1.66,-0.2l0.81,-0.34l1.28,0.33l0.33,-0.14l0.39,-0.67l0.56,-1.3l1.37,-0.09l0.27,-0.21l0.07,-0.23l0.67,-0.01l-0.13,0.53l0.29,0.37l2.74,-0.02l0.04,1.29l0.03,0.13l0.46,0.87l-0.35,1.52l0.18,1.55l0.07,0.16l0.75,0.85l-0.13,2.89l0.41,0.29l0.56,-0.21l1.11,0.05l1.5,-0.37l0.9,0.12l0.18,0.53l-0.27,1.15l0.01,0.17l0.4,1.08l-0.33,0.85l-0.01,0.18l0.12,0.51l-4.83,-0.03l-0.3,0.3l-0.12,8.13l0.07,0.19l1.69,2.1l1.27,1.25l-4.03,0.92l-5.93,-0.36l-1.66,-1.19l-0.18,-0.06l-10.15,0.11l-0.34,0.13l-1.35,-1.05l-0.17,-0.06l-1.62,-0.08l-1.6,0.45l-0.88,0.36l-0.17,-1.2l0.34,-2.19l0.85,-2.32l0.14,-1.13l0.79,-2.24l0.57,-1.0l1.42,-1.64l0.82,-1.15l0.05,-0.13l0.26,-1.88l-0.13,-1.51l-0.07,-0.16l-0.72,-0.87l-1.23,-2.91l0.09,-0.37l0.73,-0.95l0.05,-0.27l-1.27,-4.12l-1.19,-1.54l0.1,-0.2l0.86,-0.28l0.78,0.03l0.83,-0.29l7.12,0.03ZM451.81,298.94l-0.17,0.07l-0.5,-1.42l0.85,-0.92l0.53,-0.29l0.48,0.44l-0.56,0.32l-0.1,0.1l-0.41,0.65l-0.05,0.14l-0.07,0.91Z" data-code="AO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M598.42,172.08l-1.37,0.54l-3.3,2.09l-0.11,0.12l-1.01,1.97l-0.56,0.01l-0.6,-1.24l-0.26,-0.17l-2.95,-0.09l-0.46,-2.22l-0.29,-0.24l-0.91,-0.02l0.17,-2.72l-0.12,-0.26l-3.0,-2.22l-0.2,-0.06l-4.29,0.24l-2.8,0.42l-2.36,-2.7l-6.4,-3.65l-0.23,-0.03l-6.45,1.83l-0.22,0.29l0.1,10.94l-0.84,0.1l-1.65,-2.21l-0.11,-0.09l-1.69,-0.84l-0.2,-0.02l-2.84,0.63l-0.14,0.07l-0.71,0.64l-0.02,-0.11l0.57,-1.17l0.0,-0.26l-0.48,-1.05l-0.17,-0.16l-2.78,-0.99l-1.08,-2.62l-0.13,-0.15l-1.24,-0.7l-0.04,-0.48l2.07,0.25l0.34,-0.29l0.09,-2.03l1.84,-0.44l2.12,0.45l0.36,-0.25l0.45,-3.04l-0.45,-2.06l-0.31,-0.23l-2.44,0.15l-2.07,-0.75l-0.23,0.01l-2.88,1.38l-2.21,0.62l-0.96,-0.38l0.22,-1.39l-0.06,-0.23l-1.6,-2.12l-0.25,-0.12l-1.72,0.08l-1.87,-1.91l1.33,-2.24l-0.06,-0.38l-0.55,-0.5l1.72,-3.08l2.3,1.7l0.48,-0.2l0.29,-2.26l4.99,-3.48l3.76,-0.08l5.46,2.27l2.96,1.33l0.26,-0.01l2.59,-1.36l3.82,-0.06l3.13,1.67l0.38,-0.09l0.63,-0.85l3.36,0.14l0.29,-0.19l0.63,-1.57l-0.13,-0.37l-3.64,-2.05l2.0,-1.36l0.1,-0.38l-0.32,-0.62l2.09,-0.76l0.13,-0.47l-1.65,-2.13l0.89,-0.91l9.27,-1.18l0.13,-0.05l1.17,-0.82l6.2,-1.27l2.26,-1.43l4.19,0.7l0.74,3.39l0.38,0.22l2.52,-0.81l2.9,1.06l-0.18,1.63l0.32,0.33l2.52,-0.23l5.0,-2.58l0.03,0.39l3.16,2.62l5.57,8.48l0.49,0.02l1.18,-1.53l3.22,1.78l0.21,0.03l3.5,-0.83l1.21,0.52l1.16,1.82l0.15,0.12l1.67,0.61l1.01,1.32l0.28,0.11l3.04,-0.41l1.1,1.64l-1.68,1.89l-1.97,0.28l-0.26,0.29l-0.12,3.09l-1.2,1.23l-4.81,-1.01l-0.35,0.2l-1.77,5.51l-1.14,0.62l-4.92,1.23l-0.2,0.41l2.14,5.06l-1.45,0.67l-0.17,0.31l0.15,1.28l-1.05,-0.3l-1.21,-1.04l-0.17,-0.07l-3.73,-0.32l-4.15,-0.08l-0.92,0.31l-3.46,-1.24l-0.22,0.01l-1.42,0.63l-0.17,0.21l-0.32,1.49l-3.82,-0.97l-0.15,0.0l-1.65,0.43l-0.2,0.17l-0.51,1.21Z" data-code="KZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M516.0,247.63l1.21,0.92l0.3,0.04l1.3,-0.53l0.46,0.41l0.19,0.08l1.65,0.03l2.05,0.96l0.67,0.88l1.07,0.79l1.0,1.45l0.7,0.68l-0.72,0.92l-0.85,1.19l-0.04,0.25l0.19,0.67l0.04,0.74l0.29,0.28l1.4,0.04l0.55,-0.15l0.23,0.19l-0.41,0.67l0.01,0.32l0.92,1.39l0.93,1.23l0.99,0.94l0.1,0.06l8.19,2.99l1.51,0.01l-6.51,6.95l-3.14,0.11l-0.18,0.06l-2.15,1.71l-1.51,0.04l-0.22,0.1l-0.6,0.69l-1.46,-0.0l-0.93,-0.78l-0.32,-0.04l-2.29,1.05l-0.12,0.1l-0.64,0.9l-1.44,-0.17l-0.51,-0.26l-0.17,-0.03l-0.56,0.07l-0.68,-0.02l-3.1,-2.08l-0.17,-0.05l-1.62,0.0l-0.68,-0.65l0.0,-1.28l-0.21,-0.29l-1.19,-0.38l-1.42,-2.63l-0.13,-0.12l-1.05,-0.53l-0.46,-1.0l-1.27,-1.23l-0.17,-0.08l-1.08,-0.13l0.53,-0.9l1.17,-0.05l0.26,-0.17l0.37,-0.77l0.03,-0.14l-0.03,-2.23l0.7,-2.49l1.08,-0.65l0.14,-0.19l0.24,-1.0l1.03,-1.85l1.47,-1.22l0.09,-0.12l1.02,-2.51l0.36,-1.96l2.62,0.48l0.33,-0.18l0.63,-1.55Z" data-code="ET" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M498.95,341.2l-1.16,-0.23l-0.16,0.01l-0.74,0.28l-1.11,-0.41l-1.02,-0.04l-1.52,-1.13l-0.12,-0.05l-1.79,-0.37l-0.65,-1.46l-0.01,-0.86l-0.22,-0.29l-0.99,-0.26l-2.74,-2.77l-0.77,-1.46l-0.52,-0.5l-0.72,-1.54l2.24,0.23l0.78,0.28l0.12,0.02l0.85,-0.06l0.21,-0.11l1.38,-1.66l2.11,-2.05l0.81,-0.18l0.22,-0.2l0.27,-0.8l1.29,-0.93l1.53,-0.28l0.11,0.66l0.3,0.25l2.02,-0.05l1.04,0.48l0.5,0.59l0.18,0.1l1.13,0.18l1.11,0.7l0.01,3.06l-0.49,1.82l-0.11,1.94l0.03,0.16l0.35,0.68l-0.24,1.3l-0.27,0.17l-0.12,0.15l-0.64,1.83l-2.49,2.8Z" data-code="ZW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M398.67,172.8l0.09,-1.45l-0.06,-0.2l-0.82,-1.05l3.16,-1.96l3.01,0.54l3.33,-0.02l2.64,0.52l2.14,-0.15l3.9,0.1l0.91,1.08l0.14,0.09l4.61,1.38l0.26,-0.04l0.77,-0.55l2.66,1.29l0.17,0.03l2.59,-0.35l0.1,1.28l-2.2,1.85l-3.13,0.62l-0.23,0.23l-0.21,0.92l-1.54,1.68l-0.97,2.4l0.02,0.26l0.85,1.46l-1.27,1.14l-0.09,0.14l-0.5,1.73l-1.73,0.53l-0.15,0.1l-1.68,2.1l-3.03,0.04l-2.38,-0.05l-0.17,0.05l-1.57,1.01l-0.9,1.01l-0.96,-0.19l-0.82,-0.86l-0.69,-1.6l-0.22,-0.18l-2.14,-0.41l-0.13,-0.62l0.83,-0.97l0.39,-0.86l-0.06,-0.33l-0.73,-0.73l0.63,-1.74l-0.02,-0.25l-0.8,-1.41l0.69,-0.15l0.23,-0.27l0.09,-1.29l0.33,-0.36l0.08,-0.2l0.03,-2.16l1.03,-0.72l0.1,-0.37l-0.7,-1.5l-0.25,-0.17l-1.46,-0.11l-0.22,0.07l-0.34,0.3l-1.17,0.0l-0.55,-1.29l-0.39,-0.16l-1.02,0.44l-0.45,0.36Z" data-code="ES" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M527.15,253.05l-0.77,-0.74l-1.01,-1.47l-1.14,-0.86l-0.62,-0.84l-0.11,-0.09l-2.18,-1.02l-0.12,-0.03l-1.61,-0.03l-0.52,-0.46l-0.31,-0.05l-1.31,0.54l-1.38,-1.06l-0.46,0.12l-0.69,1.68l-2.49,-0.46l-0.2,-0.76l1.06,-3.69l0.24,-1.65l0.66,-0.66l1.76,-0.4l0.16,-0.1l0.97,-1.13l1.24,2.55l0.68,2.34l0.09,0.14l1.4,1.27l3.39,2.4l1.37,1.43l2.14,2.34l0.94,0.6l-0.32,0.26l-0.85,-0.17Z" data-code="ER" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M469.05,172.9l-0.57,-0.8l-0.1,-0.09l-0.82,-0.46l0.16,-0.33l0.35,-1.57l0.72,-0.62l0.27,-0.16l0.48,0.38l0.35,0.4l0.12,0.08l0.79,0.32l0.66,0.43l-0.43,0.62l-0.28,0.11l-0.07,-0.25l-0.53,-0.1l-1.09,1.49l-0.05,0.23l0.06,0.32Z" data-code="ME" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M488.2,153.75l0.14,-0.11l1.49,-0.28l1.75,0.95l1.06,0.14l0.92,0.7l-0.15,0.9l0.15,0.31l0.8,0.46l0.33,1.2l0.09,0.14l0.72,0.66l-0.11,0.28l0.1,0.33l-0.06,0.02l-1.25,-0.08l-0.17,-0.29l-0.39,-0.12l-0.52,0.25l-0.16,0.36l0.13,0.42l-0.6,0.88l-0.43,1.03l-0.22,0.12l-0.32,-1.0l0.25,-1.34l-0.08,-1.38l-0.06,-0.17l-1.43,-1.87l-0.81,-1.36l-0.78,-0.95l-0.12,-0.09l-0.29,-0.12Z" data-code="MD" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M544.77,316.45l0.64,1.04l0.6,1.62l0.4,3.04l0.63,1.21l-0.22,1.07l-0.15,0.26l-0.59,-1.05l-0.52,-0.01l-0.47,0.76l-0.04,0.23l0.46,1.84l-0.19,0.92l-0.61,0.53l-0.1,0.21l-0.16,2.15l-0.97,2.98l-1.24,3.59l-1.55,4.97l-0.96,3.67l-1.08,2.93l-1.94,0.61l-2.05,1.06l-3.2,-1.53l-0.62,-1.26l-0.18,-2.39l-0.87,-2.07l-0.22,-1.8l0.4,-1.69l1.01,-0.4l0.19,-0.28l0.01,-0.79l1.15,-1.91l0.04,-0.11l0.23,-1.66l-0.03,-0.17l-0.57,-1.21l-0.46,-1.58l-0.19,-2.25l0.82,-1.36l0.33,-1.51l1.11,-0.1l1.4,-0.53l0.9,-0.45l1.03,-0.03l0.21,-0.09l1.41,-1.45l2.12,-1.65l0.75,-1.29l0.03,-0.24l-0.17,-0.56l0.53,0.15l0.32,-0.1l1.38,-1.77l0.06,-0.18l0.04,-1.44l0.54,-0.74l0.62,0.77Z" data-code="MG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M378.66,230.13l0.07,-0.75l0.93,-0.72l0.82,-1.37l0.04,-0.21l-0.14,-0.8l0.8,-1.74l1.33,-1.61l0.79,-0.4l0.14,-0.15l0.66,-1.55l0.08,-1.46l0.83,-1.52l1.6,-0.94l0.11,-0.11l1.56,-2.71l1.2,-0.99l2.24,-0.29l0.17,-0.08l1.95,-1.83l1.3,-0.77l2.09,-2.28l0.07,-0.26l-0.61,-3.34l0.92,-2.3l0.33,-1.44l1.52,-1.79l2.48,-1.27l1.86,-1.16l0.1,-0.11l1.67,-2.93l0.72,-1.59l1.54,0.01l1.43,1.14l0.21,0.06l2.33,-0.19l2.55,0.62l0.97,0.03l0.83,1.6l0.15,1.71l0.86,2.96l0.09,0.14l0.5,0.45l-0.31,0.73l-3.11,0.44l-0.16,0.07l-1.07,0.97l-1.36,0.23l-0.25,0.28l-0.1,1.85l-2.74,1.02l-0.14,0.11l-0.9,1.3l-1.93,0.69l-2.56,0.44l-4.04,2.01l-0.17,0.27l0.02,2.91l-0.08,0.0l-0.3,0.31l0.05,1.15l-1.25,0.07l-0.16,0.06l-0.73,0.55l-0.98,0.0l-0.85,-0.33l-0.15,-0.02l-2.11,0.29l-0.24,0.19l-0.76,1.95l-0.63,0.16l-0.21,0.19l-1.15,3.29l-3.42,2.81l-0.1,0.17l-0.81,3.57l-0.98,1.12l-0.3,0.85l-5.13,0.19Z" data-code="MA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M587.83,186.48l0.06,-1.46l-0.19,-0.29l-3.31,-1.24l-2.57,-1.4l-1.63,-1.38l-2.79,-1.98l-1.2,-2.98l-0.12,-0.14l-0.84,-0.54l-0.18,-0.05l-2.61,0.13l-0.76,-0.48l-0.25,-2.25l-0.17,-0.24l-3.37,-1.6l-0.32,0.04l-2.08,1.73l-2.11,1.02l-0.16,0.35l0.31,1.14l-2.14,0.03l-0.09,-10.68l6.1,-1.74l6.25,3.57l2.36,2.72l0.27,0.1l2.92,-0.44l4.17,-0.23l2.78,2.06l-0.18,2.87l0.29,0.32l0.98,0.02l0.46,2.22l0.28,0.24l3.0,0.09l0.61,1.25l0.28,0.17l0.93,-0.02l0.26,-0.16l1.06,-2.06l3.21,-2.03l1.3,-0.5l0.19,0.08l-1.75,1.62l0.05,0.48l1.85,1.12l0.27,0.02l1.65,-0.69l2.4,1.27l-2.69,1.79l-1.79,-0.27l-0.89,0.06l-0.22,-0.52l0.48,-1.26l-0.34,-0.4l-3.35,0.69l-0.22,0.18l-0.78,1.87l-1.07,1.47l-1.93,-0.13l-0.29,0.16l-0.65,1.29l0.16,0.42l1.69,0.64l0.48,1.91l-1.25,2.6l-1.64,-0.53l-1.18,-0.03Z" data-code="UZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M670.1,233.39l-1.46,1.11l-1.68,0.11l-0.26,0.19l-1.1,2.7l-0.95,0.42l-0.14,0.42l1.21,2.27l1.61,1.92l0.94,1.55l-0.82,1.99l-0.77,0.42l-0.13,0.39l0.64,1.35l1.62,1.97l0.26,1.32l-0.04,1.15l0.02,0.13l0.92,2.18l-1.3,2.23l-0.79,1.69l-0.1,-0.77l0.74,-1.87l-0.02,-0.26l-0.8,-1.42l0.2,-2.68l-0.06,-0.2l-0.98,-1.27l-0.8,-2.98l-0.45,-3.22l-1.11,-2.22l-0.45,-0.1l-1.64,1.28l-2.74,1.76l-1.26,-0.2l-1.27,-0.49l0.79,-2.93l0.0,-0.14l-0.52,-2.42l-1.93,-2.97l0.26,-0.8l-0.22,-0.39l-1.37,-0.31l-1.65,-1.98l-0.12,-1.5l0.41,0.19l0.42,-0.26l0.05,-1.7l1.08,-0.54l0.16,-0.34l-0.24,-1.0l0.5,-0.79l0.05,-0.15l0.08,-2.35l1.58,0.49l0.36,-0.15l1.12,-2.19l0.15,-1.34l1.35,-2.18l0.04,-0.17l-0.07,-1.35l2.97,-1.71l1.67,0.45l0.38,-0.33l-0.18,-1.46l0.7,-0.4l0.15,-0.32l-0.13,-0.72l0.94,-0.13l0.74,1.41l0.11,0.12l0.95,0.56l0.07,1.89l-0.09,2.08l-2.28,2.15l-0.09,0.19l-0.3,3.15l0.35,0.32l2.37,-0.39l0.53,2.17l0.2,0.21l1.3,0.42l-0.63,1.9l0.14,0.36l1.86,0.99l1.1,0.49l0.24,0.0l1.45,-0.6l0.04,0.51l-2.01,1.6l-0.56,0.96l-1.34,0.56Z" data-code="MM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M390.79,248.2l0.67,-0.37l0.14,-0.18l0.36,-1.31l0.51,-0.04l1.68,0.69l0.21,0.0l1.34,-0.48l0.89,0.16l0.3,-0.13l0.29,-0.44l9.89,-0.04l0.29,-0.21l0.56,-1.8l-0.11,-0.33l-0.33,-0.24l-2.37,-22.1l3.41,-0.04l8.37,5.73l8.38,5.68l0.56,1.15l0.14,0.14l1.56,0.75l0.99,0.36l0.03,1.45l0.33,0.29l2.45,-0.22l0.01,5.52l-1.3,1.64l-0.06,0.15l-0.18,1.37l-1.99,0.36l-3.4,0.22l-0.19,0.09l-0.85,0.83l-1.48,0.09l-1.49,0.01l-0.54,-0.43l-0.26,-0.05l-1.38,0.36l-2.39,1.08l-0.13,0.12l-0.44,0.73l-1.88,1.11l-0.11,0.12l-0.3,0.57l-0.86,0.42l-1.1,-0.31l-0.28,0.07l-0.69,0.62l-0.09,0.16l-0.35,1.66l-1.93,2.04l-0.08,0.23l0.05,0.76l-0.63,0.99l-0.04,0.19l0.14,1.23l-0.81,0.29l-0.32,0.17l-0.27,-0.75l-0.39,-0.18l-0.65,0.26l-0.36,-0.04l-0.29,0.14l-0.37,0.6l-1.69,-0.02l-0.63,-0.34l-0.32,0.02l-0.12,0.09l-0.47,-0.45l0.1,-0.6l-0.09,-0.27l-0.31,-0.3l-0.33,-0.05l-0.05,0.02l0.02,-0.21l0.46,-0.59l-0.02,-0.39l-0.99,-1.02l-0.34,-0.74l-0.56,-0.56l-0.17,-0.09l-0.5,-0.07l-0.19,0.04l-0.58,0.35l-0.79,0.33l-0.65,0.51l-0.85,-0.16l-0.63,-0.59l-0.14,-0.07l-0.41,-0.08l-0.2,0.03l-0.59,0.31l-0.07,0.0l-0.1,-0.63l0.11,-0.85l-0.21,-0.98l-0.11,-0.17l-0.86,-0.66l-0.45,-1.34l-0.1,-1.36Z" data-code="ML" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M641.06,150.59l2.41,-0.53l4.76,-2.8l3.67,-1.49l2.06,0.96l0.12,0.03l2.5,0.05l1.59,1.45l0.19,0.08l2.47,0.12l3.59,0.81l0.27,-0.07l2.43,-2.28l0.06,-0.36l-0.93,-1.77l2.33,-3.1l2.66,1.3l2.26,0.39l2.75,0.8l0.44,2.3l0.19,0.22l3.56,1.38l0.18,0.01l2.35,-0.6l3.1,-0.42l2.4,0.41l2.37,1.52l1.49,1.63l0.23,0.1l2.29,-0.03l3.13,0.52l0.15,-0.01l2.28,-0.79l3.27,-0.53l0.11,-0.04l3.56,-2.23l1.31,0.31l1.26,1.05l0.22,0.07l2.45,-0.22l-0.98,1.96l-1.77,3.21l-0.01,0.28l0.64,1.31l0.35,0.16l1.35,-0.38l2.4,0.48l0.22,-0.04l1.78,-1.09l1.82,0.92l2.11,2.07l-0.17,0.68l-1.79,-0.31l-3.74,0.45l-1.85,0.96l-1.78,2.01l-3.74,1.18l-2.46,1.61l-2.45,-0.6l-1.42,-0.28l-0.31,0.13l-1.31,1.99l0.0,0.33l0.78,1.15l0.3,0.74l-1.58,0.93l-1.75,1.59l-2.83,1.03l-3.77,0.12l-4.05,1.05l-2.81,1.54l-0.95,-0.8l-0.19,-0.07l-2.96,0.0l-3.64,-1.8l-2.55,-0.48l-3.38,0.41l-5.13,-0.67l-2.66,0.06l-1.35,-1.65l-1.12,-2.78l-0.21,-0.18l-1.5,-0.33l-2.98,-1.89l-0.12,-0.04l-3.37,-0.43l-2.84,-0.51l-0.75,-1.13l0.93,-3.54l-0.04,-0.24l-1.73,-2.55l-0.15,-0.12l-3.52,-1.18l-1.99,-1.61l-0.54,-1.85Z" data-code="MN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M472.73,173.87l0.08,0.01l0.32,-0.25l0.08,-0.44l1.29,-0.41l1.37,-0.28l1.03,-0.04l1.06,0.82l0.14,1.59l-0.22,0.04l-0.17,0.11l-0.32,0.4l-1.2,-0.05l-0.18,0.05l-0.9,0.61l-1.45,0.23l-0.85,-0.59l-0.3,-1.09l0.22,-0.71Z" data-code="MK" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M507.18,313.84l-0.67,1.85l-0.01,0.16l0.7,3.31l0.31,0.24l0.75,-0.03l0.78,0.71l0.99,1.75l0.2,3.03l-0.91,0.45l-0.14,0.15l-0.59,1.38l-1.24,-1.21l-0.17,-1.62l0.49,-1.12l0.02,-0.16l-0.15,-1.03l-0.13,-0.21l-0.99,-0.65l-0.26,-0.03l-0.53,0.18l-1.31,-1.12l-1.15,-0.59l0.66,-2.06l0.75,-0.84l0.07,-0.27l-0.47,-2.04l0.48,-1.94l0.4,-0.65l0.03,-0.24l-0.64,-2.15l-0.08,-0.13l-0.44,-0.42l1.34,0.26l1.25,1.73l0.67,3.3Z" data-code="MW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M390.54,247.66l-1.48,-1.58l-1.51,-1.88l-0.12,-0.09l-1.64,-0.67l-1.17,-0.74l-0.17,-0.05l-1.4,0.03l-0.12,0.03l-1.14,0.52l-1.15,-0.21l-0.26,0.08l-0.44,0.43l-0.11,-0.72l0.68,-1.29l0.31,-2.43l-0.28,-2.63l-0.29,-1.27l0.24,-1.24l-0.03,-0.2l-0.65,-1.24l-1.19,-1.05l0.32,-0.51l9.64,0.02l0.3,-0.34l-0.46,-3.71l0.51,-1.12l2.17,-0.22l0.27,-0.3l-0.08,-6.5l7.91,0.13l0.31,-0.3l0.01,-3.5l8.17,5.63l-2.89,0.04l-0.29,0.33l2.42,22.56l0.12,0.21l0.26,0.19l-0.43,1.38l-9.83,0.04l-0.25,0.13l-0.27,0.41l-0.77,-0.14l-0.15,0.01l-1.3,0.47l-1.64,-0.67l-0.14,-0.02l-0.79,0.06l-0.27,0.22l-0.39,1.39l-0.53,0.29Z" data-code="MR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M500.74,287.17l-2.84,-0.02l-0.92,0.32l-1.37,0.71l-0.29,-0.12l0.02,-1.6l0.54,-0.89l0.04,-0.13l0.14,-1.96l0.49,-1.09l0.91,-1.24l0.97,-0.68l0.8,-0.89l-0.13,-0.49l-0.79,-0.27l0.13,-2.55l0.78,-0.52l1.45,0.51l0.18,0.01l1.97,-0.57l1.72,0.01l0.18,-0.06l1.29,-0.97l0.98,1.44l0.29,1.24l1.05,2.75l-0.84,1.68l-1.94,2.66l-0.06,0.18l0.02,2.36l-4.8,0.18Z" data-code="UG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M717.6,273.52l-1.51,0.7l-2.13,-0.41l-2.88,-0.0l-0.29,0.21l-0.84,2.77l-0.9,0.82l-0.08,0.12l-1.23,3.34l-1.81,0.47l-2.29,-0.68l-0.14,-0.01l-1.2,0.22l-0.14,0.07l-1.36,1.18l-1.47,-0.17l-0.12,0.01l-1.46,0.46l-1.51,-1.25l-0.24,-0.97l1.26,0.59l0.2,0.02l1.93,-0.47l0.22,-0.22l0.47,-1.98l0.9,-0.4l2.97,-0.54l0.17,-0.09l1.8,-1.98l1.02,-1.32l0.9,1.03l0.48,-0.04l0.43,-0.7l1.02,0.07l0.32,-0.27l0.25,-2.72l1.84,-1.67l1.23,-1.89l0.73,-0.01l1.12,1.11l0.1,0.99l0.18,0.24l1.66,0.71l1.85,0.67l-0.09,0.51l-1.45,0.11l-0.26,0.4l0.35,0.97ZM673.78,269.53l0.17,1.14l0.35,0.25l1.65,-0.3l0.18,-0.11l0.68,-0.86l0.31,0.13l1.41,1.45l0.99,1.59l0.13,1.57l-0.26,1.09l0.0,0.15l0.24,0.84l0.18,1.46l0.11,0.2l0.82,0.64l0.92,2.08l-0.03,0.52l-1.4,0.13l-2.29,-1.79l-2.86,-1.92l-0.27,-1.16l-0.07,-0.13l-1.39,-1.61l-0.33,-1.99l-0.05,-0.12l-0.84,-1.27l0.26,-1.72l-0.03,-0.18l-0.45,-0.87l0.13,-0.13l1.71,0.92Z" data-code="MY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M133.41,213.83l0.61,0.09l0.27,-0.09l0.93,-1.01l0.08,-0.18l0.09,-1.22l-0.09,-0.23l-1.93,-1.94l-1.46,-0.77l-2.96,-5.62l-0.86,-2.1l2.44,-0.18l2.68,-0.25l-0.03,0.08l0.17,0.4l3.79,1.35l5.81,1.97l6.96,-0.02l0.3,-0.3l0.0,-0.84l3.91,0.0l0.87,0.93l1.27,0.87l1.44,1.17l0.79,1.37l0.62,1.49l0.12,0.14l1.35,0.85l2.08,0.82l0.35,-0.1l1.49,-2.04l1.81,-0.05l1.63,1.01l1.21,1.8l0.86,1.58l1.47,1.55l0.53,1.82l0.73,1.32l0.14,0.13l1.98,0.84l1.78,0.59l0.61,-0.03l-0.78,1.89l-0.45,1.96l-0.19,3.58l-0.24,1.27l0.01,0.14l0.43,1.43l0.78,1.31l0.49,1.98l0.06,0.12l1.63,1.9l0.61,1.51l0.98,1.28l0.16,0.11l2.58,0.67l0.98,1.02l0.31,0.08l2.17,-0.71l1.91,-0.26l1.87,-0.47l1.67,-0.49l1.59,-1.06l0.11,-0.14l0.6,-1.52l0.22,-2.21l0.35,-0.62l1.58,-0.64l2.59,-0.59l2.18,0.09l1.43,-0.2l0.39,0.36l-0.07,1.02l-1.28,1.48l-0.65,1.68l0.07,0.32l0.33,0.32l-0.79,2.49l-0.28,-0.3l-0.24,-0.09l-1.0,0.08l-0.24,0.15l-0.74,1.28l-0.19,-0.13l-0.28,-0.03l-0.3,0.12l-0.19,0.29l0.0,0.06l-4.34,-0.02l-0.3,0.3l-0.0,1.16l-0.83,0.0l-0.28,0.19l0.08,0.33l0.93,0.86l0.9,0.58l0.24,0.48l0.16,0.15l0.2,0.08l-0.03,0.38l-2.94,0.01l-0.26,0.15l-1.21,2.09l0.02,0.33l0.25,0.33l-0.21,0.44l-0.04,0.22l-2.42,-2.35l-1.36,-0.87l-2.04,-0.67l-0.13,-0.01l-1.4,0.19l-2.07,0.98l-1.14,0.23l-1.72,-0.66l-1.85,-0.48l-2.31,-1.16l-1.92,-0.38l-2.79,-1.18l-2.04,-1.2l-0.6,-0.66l-0.19,-0.1l-1.37,-0.15l-2.45,-0.78l-1.07,-1.18l-2.63,-1.44l-1.2,-1.56l-0.44,-0.93l0.5,-0.15l0.2,-0.39l-0.2,-0.58l0.46,-0.55l0.07,-0.19l0.01,-0.91l-0.06,-0.18l-0.81,-1.13l-0.25,-1.08l-0.86,-1.36l-2.21,-2.63l-2.53,-2.09l-1.2,-1.63l-0.11,-0.09l-2.08,-1.06l-0.34,-0.48l0.35,-1.53l-0.16,-0.34l-1.24,-0.61l-1.39,-1.23l-0.6,-1.81l-0.24,-0.2l-1.25,-0.2l-1.38,-1.35l-1.11,-1.25l-0.1,-0.76l-0.05,-0.13l-1.33,-2.04l-0.85,-2.02l0.04,-0.99l-0.14,-0.27l-1.81,-1.1l-0.2,-0.04l-0.74,0.11l-1.34,-0.72l-0.42,0.16l-0.4,1.12l-0.0,0.19l0.41,1.3l0.24,2.04l0.06,0.15l0.88,1.16l1.84,1.86l0.4,0.61l0.12,0.1l0.27,0.14l0.29,0.82l0.31,0.2l0.2,-0.02l0.43,1.51l0.09,0.14l0.72,0.65l0.51,0.91l1.58,1.4l0.8,2.42l0.77,1.23l0.66,1.19l0.13,1.34l0.28,0.27l1.08,0.08l0.92,1.1l0.83,1.08l-0.03,0.24l-0.88,0.81l-0.13,-0.0l-0.59,-1.42l-0.07,-0.11l-1.67,-1.53l-1.81,-1.28l-1.15,-0.61l0.07,-1.85l-0.38,-1.45l-0.12,-0.17l-2.91,-2.03l-0.39,0.04l-0.11,0.11l-0.42,-0.46l-0.11,-0.08l-1.49,-0.63l-1.09,-1.16Z" data-code="MX" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M839.92,325.66l0.78,0.73l-0.18,0.07l-0.6,-0.8ZM839.13,322.74l0.27,1.36l-0.13,-0.06l-0.21,-0.02l-0.29,0.08l-0.22,-0.43l-0.03,-1.32l0.61,0.4Z" data-code="VU" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M444.58,172.63l-0.68,1.92l-0.72,-0.38l-0.51,-1.79l0.43,-0.95l1.15,-0.83l0.33,2.04ZM429.71,147.03l1.77,1.57l0.26,0.07l1.16,-0.23l2.12,1.44l0.56,0.28l0.16,0.03l0.61,-0.06l1.09,0.78l0.13,0.05l3.18,0.53l-1.09,1.94l-0.3,2.16l-0.48,0.38l-1.0,-0.26l-0.37,0.32l0.07,0.66l-1.73,1.68l-0.09,0.21l-0.04,1.42l0.41,0.29l0.96,-0.4l0.67,1.07l-0.09,0.78l0.04,0.19l0.61,0.97l-0.71,0.78l-0.07,0.28l0.65,2.39l0.21,0.21l1.09,0.31l-0.2,0.95l-2.08,1.58l-4.81,-0.8l-0.13,0.01l-3.65,0.99l-0.22,0.24l-0.25,1.6l-2.59,0.35l-2.74,-1.33l-0.31,0.03l-0.79,0.57l-4.38,-1.31l-0.79,-0.94l1.16,-1.64l0.05,-0.15l0.48,-6.17l-0.06,-0.21l-2.58,-3.3l-1.89,-1.65l-0.11,-0.06l-3.64,-1.17l-0.2,-1.88l2.92,-0.63l4.14,0.82l0.35,-0.36l-0.65,-3.0l1.77,1.05l0.27,0.02l5.83,-2.54l0.17,-0.19l0.71,-2.54l1.75,-0.53l0.27,0.88l0.27,0.21l1.04,0.05l1.08,1.23ZM289.1,278.45l-0.85,0.84l-0.88,0.13l-0.25,-0.51l-0.21,-0.16l-0.56,-0.1l-0.25,0.07l-0.63,0.55l-0.62,-0.29l0.5,-0.88l0.21,-1.11l0.42,-1.05l-0.03,-0.28l-0.93,-1.42l-0.18,-1.54l1.13,-1.87l2.42,0.78l2.55,2.04l0.33,0.81l-1.4,2.16l-0.77,1.84Z" data-code="FR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M492.26,76.42l-0.38,3.12l0.12,0.28l3.6,2.69l-2.14,2.96l-0.01,0.33l2.83,4.61l-1.61,3.36l0.03,0.31l2.15,2.87l-0.96,2.44l0.1,0.35l3.51,2.55l-0.81,1.72l-2.28,2.19l-5.28,4.79l-4.51,0.31l-4.39,1.37l-3.87,0.75l-1.34,-1.89l-0.11,-0.09l-2.23,-1.14l0.53,-3.54l-0.01,-0.14l-1.17,-3.37l1.12,-2.13l2.23,-2.44l5.69,-4.33l1.65,-0.84l0.16,-0.31l-0.26,-1.73l-0.15,-0.22l-3.4,-1.91l-0.77,-1.47l-0.07,-6.45l-0.12,-0.24l-3.91,-2.94l-3.0,-1.92l0.97,-0.76l2.6,2.17l0.21,0.07l3.2,-0.21l2.63,1.03l0.3,-0.05l2.39,-1.94l0.09,-0.13l1.18,-3.12l3.63,-1.42l2.87,1.59l-0.98,2.87Z" data-code="FI" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M869.98,327.07l-1.31,0.44l-0.14,-0.41l0.96,-0.41l0.85,-0.17l1.43,-0.78l-0.16,0.65l-1.64,0.67ZM867.58,329.12l0.54,0.47l-0.31,1.0l-1.32,0.3l-1.13,-0.26l-0.17,-0.78l0.72,-0.66l0.98,0.27l0.25,-0.04l0.43,-0.29Z" data-code="FJ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M268.15,427.89l2.6,-1.73l1.98,0.77l0.31,-0.05l1.32,-1.17l1.58,1.18l-0.54,0.84l-3.1,0.92l-1.0,-1.04l-0.39,-0.04l-1.9,1.35l-0.86,-1.04Z" data-code="FK" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M202.1,252.6l0.23,-0.0l0.12,-0.11l0.68,-0.09l0.22,-0.15l0.23,-0.43l0.2,-0.01l0.28,-0.31l-0.04,-0.97l0.29,-0.03l0.5,0.02l0.25,-0.11l0.37,-0.46l0.51,0.35l0.4,-0.06l0.23,-0.28l0.45,-0.29l0.87,-0.7l0.11,-0.21l0.02,-0.26l0.23,-0.12l0.25,-0.48l0.29,0.27l0.14,0.07l0.5,0.12l0.22,-0.03l0.48,-0.28l0.66,-0.02l0.87,-0.33l0.36,-0.32l0.21,0.01l-0.11,0.48l0.0,0.14l0.22,0.8l-0.54,0.85l-0.27,1.03l-0.09,1.18l0.14,0.72l0.05,0.95l-0.24,0.15l-0.13,0.19l-0.23,1.09l0.0,0.14l0.14,0.53l-0.42,0.53l-0.06,0.24l0.12,0.69l0.08,0.15l0.18,0.19l-0.26,0.23l-0.49,-0.11l-0.35,-0.44l-0.16,-0.1l-0.79,-0.21l-0.23,0.03l-0.45,0.26l-1.51,-0.62l-0.31,0.05l-0.17,0.15l-1.81,-1.62l-0.6,-0.9l-1.04,-0.79l-0.77,-0.71Z" data-code="NI" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M436.22,136.65l1.82,0.08l0.36,0.89l-0.6,2.96l-0.53,1.06l-1.32,0.0l-0.3,0.34l0.35,2.89l-0.83,-0.47l-1.56,-1.43l-0.29,-0.07l-2.26,0.67l-1.02,-0.15l0.68,-0.48l0.1,-0.12l2.14,-4.84l3.25,-1.35Z" data-code="NL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M491.45,67.31l7.06,3.0l-2.52,0.94l-0.11,0.49l2.43,2.49l-3.82,1.59l-1.48,0.3l0.89,-2.61l-0.14,-0.36l-3.21,-1.78l-0.25,-0.02l-3.89,1.52l-0.17,0.17l-1.2,3.17l-2.19,1.78l-2.53,-0.99l-0.13,-0.02l-3.15,0.21l-2.69,-2.25l-0.38,-0.01l-1.43,1.11l-1.47,0.17l-0.26,0.26l-0.33,2.57l-4.42,-0.65l-0.33,0.22l-0.6,2.19l-2.17,-0.01l-0.27,0.16l-4.15,7.68l-3.88,5.76l-0.0,0.33l0.81,1.23l-0.7,1.27l-2.3,-0.06l-0.28,0.18l-1.63,3.72l-0.02,0.13l0.15,5.17l0.07,0.18l1.51,1.84l-0.79,4.24l-2.04,2.5l-0.92,1.75l-1.39,-1.88l-0.44,-0.05l-4.89,4.21l-3.16,0.81l-3.24,-1.74l-0.86,-3.82l-0.78,-8.6l2.18,-2.36l6.56,-3.28l5.0,-4.16l4.63,-5.74l5.99,-8.09l4.17,-3.23l6.84,-5.49l5.39,-1.92l4.06,0.24l0.23,-0.09l3.72,-3.67l4.51,0.19l4.4,-0.89ZM484.58,19.95l4.42,1.82l-3.25,2.68l-7.14,0.65l-7.16,-0.91l-0.39,-1.37l-0.28,-0.22l-3.48,-0.1l-2.25,-2.15l7.09,-1.48l3.55,1.36l0.28,-0.03l2.42,-1.66l6.18,1.41ZM481.99,33.92l-4.73,1.85l-3.76,-1.06l1.27,-1.02l0.04,-0.43l-1.18,-1.35l4.46,-0.94l0.89,1.83l0.17,0.15l2.83,0.96ZM466.5,23.95l7.64,3.87l-5.63,1.94l-0.19,0.19l-1.35,3.88l-2.08,0.96l-0.16,0.19l-1.14,4.18l-2.71,0.18l-4.94,-2.95l1.95,-1.63l-0.08,-0.51l-3.7,-1.54l-4.79,-4.54l-1.78,-4.01l6.29,-1.88l1.25,1.81l0.25,0.13l3.57,-0.08l0.26,-0.17l0.87,-1.79l3.41,-0.18l3.08,1.94Z" data-code="NO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M461.88,357.98l-1.61,-1.77l-0.94,-1.9l-0.54,-2.58l-0.62,-1.95l-0.83,-4.05l-0.06,-3.13l-0.33,-1.5l-0.07,-0.14l-0.95,-1.06l-1.27,-2.12l-1.3,-3.1l-0.59,-1.71l-1.98,-2.46l-0.13,-1.67l0.99,-0.4l1.44,-0.42l1.48,0.07l1.42,1.11l0.31,0.03l0.32,-0.15l9.99,-0.11l1.66,1.18l0.16,0.06l6.06,0.37l4.69,-1.06l2.01,-0.57l1.5,0.14l0.63,0.37l-1.0,0.41l-0.7,0.01l-0.16,0.05l-1.38,0.88l-0.79,-0.88l-0.29,-0.09l-3.83,0.9l-1.84,0.08l-0.29,0.3l-0.07,8.99l-2.18,0.08l-0.29,0.3l-0.0,17.47l-2.04,1.27l-1.21,0.18l-1.51,-0.49l-0.99,-0.18l-0.36,-1.0l-0.1,-0.14l-0.99,-0.74l-0.4,0.04l-0.98,1.09Z" data-code="NA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M835.87,338.68l2.06,1.63l1.01,0.94l-0.49,0.32l-1.21,-0.62l-1.76,-1.16l-1.58,-1.36l-1.61,-1.79l-0.16,-0.41l0.54,0.02l1.32,0.83l1.08,0.87l0.79,0.73Z" data-code="NC" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M426.67,254.17l0.03,-1.04l-0.24,-0.3l-2.66,-0.53l-0.06,-1.0l-0.07,-0.17l-1.37,-1.62l-0.3,-1.04l0.15,-0.94l1.37,-0.09l0.19,-0.09l0.85,-0.83l3.34,-0.22l2.22,-0.41l0.24,-0.26l0.2,-1.5l1.32,-1.65l0.07,-0.19l-0.01,-5.74l3.4,-1.13l7.24,-5.12l8.46,-4.95l3.76,1.08l1.35,1.39l0.36,0.05l1.39,-0.77l0.55,3.66l0.12,0.2l0.82,0.6l0.03,0.69l0.1,0.21l0.87,0.74l-0.47,0.99l-0.96,5.26l-0.13,3.25l-3.08,2.34l-0.1,0.15l-1.08,3.37l0.08,0.31l0.94,0.86l-0.01,1.51l0.29,0.3l1.25,0.05l-0.14,0.66l-0.51,0.11l-0.24,0.26l-0.06,0.57l-0.04,0.0l-1.59,-2.62l-0.21,-0.14l-0.59,-0.1l-0.23,0.05l-1.83,1.33l-1.79,-0.68l-1.42,-0.17l-0.17,0.03l-0.65,0.32l-1.39,-0.07l-0.19,0.06l-1.4,1.03l-1.12,0.05l-2.97,-1.29l-0.26,0.01l-1.12,0.59l-1.08,-0.04l-0.85,-0.88l-0.11,-0.07l-2.51,-0.95l-0.14,-0.02l-2.69,0.3l-0.16,0.07l-0.65,0.55l-0.1,0.16l-0.34,1.41l-0.69,0.98l-0.05,0.15l-0.13,1.72l-1.47,-1.13l-0.18,-0.06l-0.9,0.01l-0.2,0.08l-0.32,0.28Z" data-code="NE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M442.0,272.7l-2.4,0.83l-0.88,-0.12l-0.19,0.04l-0.89,0.52l-1.78,-0.05l-1.23,-1.44l-0.88,-1.87l-1.77,-1.66l-0.21,-0.08l-3.78,0.03l0.13,-3.75l-0.06,-1.58l0.44,-1.47l0.74,-0.75l1.21,-1.56l0.04,-0.29l-0.22,-0.56l0.44,-0.9l0.01,-0.24l-0.54,-1.44l0.26,-2.97l0.72,-1.06l0.33,-1.37l0.51,-0.43l2.53,-0.28l2.38,0.9l0.89,0.91l0.2,0.09l1.28,0.04l0.15,-0.03l1.06,-0.56l2.9,1.26l0.13,0.02l1.28,-0.06l0.16,-0.06l1.39,-1.02l1.36,0.07l0.15,-0.03l0.64,-0.32l1.22,0.13l1.9,0.73l0.28,-0.04l1.86,-1.35l0.33,0.06l1.62,2.67l0.29,0.14l0.32,-0.04l0.73,0.74l-0.19,0.37l-0.12,0.74l-2.03,1.89l-0.07,0.11l-0.66,1.62l-0.35,1.28l-0.48,0.51l-0.07,0.12l-0.48,1.67l-1.26,0.98l-0.1,0.15l-0.38,1.24l-0.58,1.07l-0.2,0.91l-1.43,0.7l-1.26,-0.93l-0.19,-0.06l-0.95,0.04l-0.2,0.09l-1.41,1.39l-0.61,0.02l-0.26,0.17l-1.19,2.42l-0.61,1.67Z" data-code="NG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M857.9,379.62l1.85,3.1l0.33,0.14l0.22,-0.28l0.04,-1.41l0.57,0.4l0.35,2.06l0.17,0.22l2.02,0.94l1.78,0.26l0.22,-0.06l1.31,-1.01l0.84,0.22l-0.53,2.27l-0.67,1.5l-1.71,-0.05l-0.25,0.12l-0.67,0.89l-0.05,0.23l0.21,1.15l-0.31,0.46l-2.15,3.57l-1.6,0.99l-0.28,-0.51l-0.15,-0.13l-0.72,-0.3l1.27,-2.15l0.01,-0.29l-0.82,-1.63l-0.15,-0.14l-2.5,-1.09l0.05,-0.69l1.67,-0.94l0.15,-0.21l0.42,-2.24l-0.11,-1.95l-0.03,-0.12l-0.97,-1.85l0.05,-0.41l-0.09,-0.25l-1.18,-1.17l-1.94,-2.49l-0.86,-1.64l0.38,-0.09l1.24,1.43l0.12,0.08l1.81,0.68l0.67,2.39ZM853.93,393.55l0.57,1.24l0.44,0.12l1.51,-1.03l0.52,0.91l0.0,1.09l-0.88,1.31l-1.62,2.2l-1.26,1.2l-0.05,0.38l0.64,1.02l-1.4,0.03l-0.14,0.04l-2.14,1.16l-0.14,0.17l-0.67,2.0l-1.38,3.06l-3.07,2.19l-2.12,-0.06l-1.55,-0.99l-0.14,-0.05l-2.53,-0.2l-0.31,-0.84l1.25,-2.15l3.07,-2.97l1.62,-0.59l1.81,-1.17l2.18,-1.63l1.55,-1.65l1.08,-2.18l0.9,-0.72l0.11,-0.17l0.35,-1.56l1.37,-1.07l0.4,0.91Z" data-code="NZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M641.26,213.53l-0.14,0.95l0.32,1.64l-0.21,0.78l-1.83,0.04l-2.98,-0.62l-1.86,-0.25l-1.37,-1.3l-0.18,-0.08l-3.38,-0.34l-3.21,-1.49l-2.38,-1.34l-2.16,-0.92l0.84,-2.2l1.51,-1.18l0.89,-0.57l1.83,0.77l2.5,1.76l1.39,0.41l0.78,1.21l0.17,0.13l1.91,0.53l2.0,1.17l2.92,0.66l2.63,0.24Z" data-code="NP" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M413.53,272.08l-0.83,0.02l-1.79,-0.49l-1.64,0.03l-3.04,0.46l-1.73,0.72l-2.4,0.89l-0.12,-0.02l0.16,-1.7l0.19,-0.25l0.06,-0.2l-0.08,-0.99l-0.09,-0.19l-1.06,-1.05l-0.15,-0.08l-0.71,-0.15l-0.51,-0.48l0.45,-0.92l0.02,-0.19l-0.24,-1.16l0.07,-0.43l0.14,-0.0l0.3,-0.26l0.15,-1.1l-0.02,-0.15l-0.13,-0.34l0.09,-0.13l0.83,-0.27l0.19,-0.37l-0.62,-2.02l-0.55,-1.0l0.14,-0.59l0.35,-0.14l0.24,-0.16l0.53,0.29l0.14,0.04l1.93,0.02l0.26,-0.14l0.36,-0.58l0.39,0.01l0.43,-0.17l0.28,0.79l0.43,0.16l0.56,-0.31l0.89,-0.32l0.92,0.45l0.39,0.75l0.14,0.13l1.13,0.53l0.3,-0.03l0.81,-0.59l1.02,-0.08l1.49,0.57l0.62,3.33l-1.03,2.09l-0.65,2.84l0.02,0.2l1.05,2.08l-0.07,0.64Z" data-code="CI" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M444.71,156.27l0.05,0.3l-0.34,0.69l0.13,0.4l1.13,0.58l1.07,0.1l-0.12,0.81l-0.87,0.42l-1.75,-0.37l-0.34,0.18l-0.47,1.1l-0.86,0.07l-0.33,-0.38l-0.41,-0.04l-1.34,1.01l-1.02,0.13l-0.93,-0.58l-0.82,-1.32l-0.37,-0.12l-0.77,0.32l0.02,-0.84l1.74,-1.69l0.09,-0.25l-0.04,-0.38l0.73,0.19l0.26,-0.06l0.6,-0.48l2.02,0.02l0.24,-0.12l0.38,-0.51l2.31,0.84Z" data-code="CH" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M232.24,284.95l-0.94,-0.52l-1.22,-0.82l-0.31,-0.01l-0.62,0.35l-1.88,-0.31l-0.54,-0.95l-0.29,-0.15l-0.37,0.03l-2.34,-1.33l-0.15,-0.35l0.57,-0.11l0.24,-0.32l-0.1,-1.15l0.46,-0.71l1.11,-0.15l0.21,-0.13l1.05,-1.57l0.95,-1.31l-0.08,-0.43l-0.73,-0.47l0.4,-1.24l0.01,-0.16l-0.53,-2.15l0.44,-0.54l0.06,-0.24l-0.4,-2.13l-0.06,-0.13l-0.93,-1.22l0.21,-0.8l0.52,0.12l0.32,-0.13l0.47,-0.75l0.03,-0.27l-0.52,-1.32l0.09,-0.11l1.14,0.07l0.22,-0.08l1.82,-1.71l0.96,-0.25l0.22,-0.28l0.02,-0.81l0.43,-2.01l1.28,-1.04l1.48,-0.05l0.27,-0.19l0.12,-0.31l1.73,0.19l0.2,-0.05l1.96,-1.28l0.97,-0.56l1.16,-1.16l0.64,0.11l0.43,0.44l-0.31,0.55l-1.49,0.39l-0.19,0.16l-0.6,1.2l-0.97,0.74l-0.73,0.94l-0.06,0.13l-0.3,1.76l-0.68,1.44l0.23,0.43l1.1,0.14l0.27,0.97l0.08,0.13l0.49,0.49l0.17,0.85l-0.27,0.86l-0.01,0.14l0.09,0.53l0.2,0.23l0.52,0.18l0.54,0.79l0.27,0.13l3.18,-0.24l1.31,0.29l1.7,2.08l0.31,0.1l0.96,-0.26l1.75,0.13l1.41,-0.27l0.56,0.27l-0.36,1.07l-0.54,0.81l-0.05,0.13l-0.2,1.8l0.51,1.79l0.07,0.12l0.65,0.68l0.05,0.32l-1.16,1.14l0.05,0.47l0.86,0.52l0.6,0.79l0.31,1.01l-0.7,-0.81l-0.44,-0.01l-0.74,0.77l-4.75,-0.05l-0.3,0.31l0.03,1.57l0.25,0.29l1.2,0.21l-0.02,0.24l-0.1,-0.05l-0.22,-0.02l-1.41,0.41l-0.22,0.29l-0.01,1.82l0.11,0.23l1.04,0.85l0.35,1.3l-0.06,1.02l-1.02,6.26l-0.84,-0.89l-0.19,-0.09l-0.25,-0.02l1.35,-2.13l-0.1,-0.42l-1.92,-1.17l-0.2,-0.04l-1.41,0.2l-0.82,-0.39l-0.26,0.0l-1.29,0.62l-1.63,-0.27l-1.4,-2.5l-0.12,-0.12l-1.1,-0.61l-0.83,-1.2l-1.67,-1.19l-0.27,-0.04l-0.54,0.19Z" data-code="CO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M740.32,148.94l0.22,0.21l4.3,1.03l2.84,2.2l0.99,2.92l0.28,0.2l3.8,0.0l0.15,-0.04l2.13,-1.24l3.5,-0.8l-1.05,2.29l-0.95,1.13l-0.06,0.12l-0.85,3.41l-1.56,2.81l-2.83,-0.51l-0.19,0.03l-2.15,1.09l-0.15,0.34l0.65,2.59l-0.33,3.3l-1.03,0.07l-0.28,0.3l0.01,0.75l-1.09,-1.2l-0.48,0.05l-0.94,1.6l-3.76,1.26l-0.2,0.36l0.29,1.19l-1.67,-0.08l-1.11,-0.88l-0.42,0.05l-1.69,2.08l-2.71,1.57l-2.04,1.88l-3.42,0.84l-0.11,0.05l-1.8,1.34l-1.54,0.46l0.52,-0.53l0.06,-0.33l-0.44,-0.96l1.84,-1.84l0.02,-0.41l-1.32,-1.56l-0.36,-0.08l-2.23,1.08l-2.83,2.06l-1.52,1.85l-2.32,0.13l-0.2,0.09l-1.28,1.37l-0.03,0.37l1.32,1.97l0.18,0.13l1.83,0.43l0.07,1.08l0.18,0.26l1.98,0.84l0.3,-0.03l2.66,-1.96l2.06,1.04l0.12,0.03l1.4,0.07l0.27,1.0l-3.24,0.73l-0.17,0.11l-1.13,1.5l-2.38,1.4l-0.1,0.1l-1.29,1.99l0.1,0.42l2.6,1.5l0.97,2.72l1.52,2.56l1.66,2.08l-0.03,1.76l-1.4,0.67l-0.15,0.38l0.6,1.47l0.13,0.15l1.29,0.75l-0.35,2.0l-0.58,1.96l-1.22,0.21l-0.2,0.14l-1.83,2.93l-2.02,3.51l-2.29,3.13l-3.4,2.42l-3.42,2.18l-2.75,0.3l-0.15,0.06l-1.32,1.01l-0.68,-0.67l-0.41,-0.01l-1.37,1.27l-3.42,1.28l-2.62,0.4l-0.24,0.21l-0.8,2.57l-0.95,0.11l-0.53,-1.54l0.52,-0.89l-0.19,-0.44l-3.36,-0.84l-0.17,0.01l-1.09,0.4l-2.36,-0.64l-1.0,-0.9l0.35,-1.34l-0.23,-0.37l-2.22,-0.47l-1.15,-0.94l-0.36,-0.02l-2.08,1.37l-2.35,0.29l-1.98,-0.01l-0.13,0.03l-1.32,0.63l-1.28,0.38l-0.21,0.33l0.33,2.65l-0.78,-0.04l-0.14,-0.39l-0.07,-1.04l-0.41,-0.26l-1.72,0.71l-0.96,-0.43l-1.63,-0.86l0.65,-1.95l-0.19,-0.38l-1.43,-0.46l-0.56,-2.27l-0.34,-0.22l-2.26,0.38l0.25,-2.65l2.29,-2.15l0.09,-0.2l0.1,-2.21l-0.07,-2.09l-0.15,-0.25l-1.02,-0.6l-0.8,-1.52l-0.31,-0.16l-1.42,0.2l-2.16,-0.32l0.55,-0.74l0.01,-0.35l-1.17,-1.7l-0.41,-0.08l-1.67,1.07l-1.97,-0.63l-0.25,0.03l-2.89,1.73l-2.26,1.99l-1.82,0.3l-1.0,-0.66l-0.15,-0.05l-1.28,-0.06l-1.75,-0.61l-0.24,0.02l-1.35,0.69l-0.1,0.08l-1.2,1.45l-0.14,-1.41l-0.4,-0.25l-1.46,0.55l-2.83,-0.26l-2.77,-0.61l-1.99,-1.17l-1.91,-0.54l-0.78,-1.21l-0.17,-0.13l-1.36,-0.38l-2.54,-1.79l-2.01,-0.84l-0.28,0.02l-0.89,0.56l-3.31,-1.83l-2.35,-1.67l-0.57,-2.49l1.34,0.28l0.36,-0.28l0.08,-1.42l-0.05,-0.19l-0.93,-1.34l0.24,-2.18l-0.07,-0.22l-2.69,-3.32l-0.15,-0.1l-3.97,-1.11l-0.69,-2.05l-0.11,-0.15l-1.79,-1.3l-0.39,-0.73l-0.36,-1.57l0.08,-1.09l-0.18,-0.3l-1.52,-0.66l-0.22,-0.01l-0.51,0.18l-0.52,-2.21l0.59,-0.55l0.06,-0.35l-0.22,-0.44l2.12,-1.24l1.63,-0.55l2.58,0.39l0.31,-0.16l0.87,-1.75l3.05,-0.34l0.21,-0.12l0.84,-1.12l3.87,-1.59l0.15,-0.14l0.35,-0.68l0.03,-0.17l-0.17,-1.51l1.52,-0.7l0.15,-0.39l-2.12,-5.0l4.62,-1.15l1.35,-0.72l0.14,-0.17l1.72,-5.37l4.7,0.99l0.28,-0.08l1.39,-1.43l0.08,-0.2l0.11,-2.95l1.83,-0.26l0.18,-0.1l1.85,-2.08l0.61,-0.17l0.57,1.97l0.1,0.15l2.2,1.75l3.48,1.17l1.59,2.36l-0.93,3.53l0.04,0.24l0.9,1.35l0.2,0.13l2.98,0.53l3.32,0.43l2.97,1.89l1.49,0.35l1.08,2.67l1.52,1.88l0.24,0.11l2.74,-0.07l5.15,0.67l3.36,-0.41l2.39,0.43l3.67,1.81l0.13,0.03l2.92,-0.0l1.02,0.86l0.34,0.03l2.88,-1.59l3.98,-1.03l3.81,-0.13l3.02,-1.12l1.77,-1.61l1.73,-1.01l0.13,-0.37l-0.41,-1.01l-0.72,-1.07l1.09,-1.66l1.21,0.24l2.57,0.63l0.24,-0.04l2.46,-1.62l3.78,-1.19l0.13,-0.09l1.8,-2.03l1.66,-0.84l3.54,-0.41l1.93,0.35l0.34,-0.22l0.27,-1.12l-0.08,-0.29l-2.27,-2.22l-2.08,-1.07l-0.29,0.01l-1.82,1.12l-2.36,-0.47l-0.14,0.01l-1.18,0.34l-0.46,-0.94l1.69,-3.08l1.1,-2.21l2.75,1.12l0.26,-0.02l3.53,-2.06l0.15,-0.26l-0.02,-1.35l2.18,-3.39l1.35,-1.04l0.12,-0.24l-0.03,-1.85l-0.15,-0.25l-1.0,-0.58l1.68,-1.37l3.01,-0.59l3.25,-0.09l3.67,0.99l2.08,1.18l1.51,3.3l0.95,1.45l0.85,1.99l0.92,3.19ZM697.0,237.37l-1.95,1.12l-1.74,-0.68l-0.06,-1.9l1.08,-1.03l2.62,-0.7l1.23,0.05l0.37,0.65l-1.01,1.08l-0.54,1.4Z" data-code="CN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M453.76,278.92l-0.26,-0.11l-0.18,-0.02l-1.42,0.31l-1.56,-0.33l-1.17,0.16l-3.7,-0.05l0.3,-1.63l-0.04,-0.21l-0.98,-1.66l-0.15,-0.13l-1.03,-0.38l-0.46,-1.01l-0.13,-0.14l-0.48,-0.27l0.02,-0.46l0.62,-1.72l1.1,-2.25l0.54,-0.02l0.2,-0.09l1.41,-1.39l0.73,-0.03l1.32,0.97l0.31,0.03l1.72,-0.85l0.16,-0.2l0.22,-1.0l0.57,-1.03l0.36,-1.18l1.26,-0.98l0.1,-0.15l0.49,-1.7l0.48,-0.51l0.07,-0.13l0.35,-1.3l0.63,-1.54l2.06,-1.92l0.09,-0.17l0.12,-0.79l0.24,-0.41l-0.04,-0.36l-0.89,-0.91l0.04,-0.45l0.28,-0.06l0.85,1.39l0.16,1.59l-0.09,1.66l0.04,0.17l1.09,1.84l-0.86,-0.02l-0.72,0.17l-1.07,-0.24l-0.34,0.17l-0.54,1.19l0.06,0.34l1.48,1.47l1.06,0.44l0.32,0.94l0.73,1.6l-0.32,0.57l-1.23,2.49l-0.54,0.41l-0.12,0.21l-0.19,1.95l0.24,1.08l-0.18,0.67l0.07,0.28l1.13,1.25l0.24,0.93l0.92,1.29l1.1,0.8l0.1,1.01l0.26,0.73l-0.12,0.93l-1.65,-0.49l-2.02,-0.66l-3.19,-0.11Z" data-code="CM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M246.8,429.1l-1.14,0.78l-2.25,1.21l-0.16,0.23l-0.37,2.94l-0.75,0.06l-2.72,-1.07l-2.83,-2.34l-3.06,-1.9l-0.71,-1.92l0.67,-1.84l-0.02,-0.25l-1.22,-2.13l-0.31,-5.41l1.02,-2.95l2.59,-2.4l-0.13,-0.51l-3.32,-0.8l2.06,-2.4l0.07,-0.15l0.79,-4.77l2.44,0.95l0.4,-0.22l1.31,-6.31l-0.16,-0.33l-1.68,-0.8l-0.42,0.21l-0.72,3.47l-1.01,-0.27l0.74,-4.06l0.85,-5.46l1.12,-1.96l0.03,-0.22l-0.71,-2.82l-0.19,-2.94l0.76,-0.07l0.26,-0.2l1.53,-4.62l1.73,-4.52l1.07,-4.2l-0.56,-4.2l0.73,-2.2l0.01,-0.12l-0.29,-3.3l1.46,-3.34l0.45,-5.19l0.8,-5.52l0.78,-5.89l-0.18,-4.33l-0.49,-3.47l1.1,-0.56l0.13,-0.13l0.44,-0.88l0.9,1.29l0.32,1.8l0.1,0.18l1.16,0.97l-0.73,2.33l0.01,0.21l1.33,2.91l0.97,3.6l0.35,0.22l1.57,-0.31l0.16,0.34l-0.79,2.51l-2.61,1.25l-0.17,0.28l0.08,4.36l-0.48,0.79l0.01,0.33l0.6,0.84l-1.62,1.55l-1.67,2.6l-0.89,2.47l-0.02,0.13l0.23,2.56l-1.5,2.76l-0.03,0.21l1.15,4.8l0.11,0.17l0.54,0.42l-0.01,2.37l-1.4,2.7l-0.03,0.15l0.06,2.25l-1.8,1.78l-0.09,0.21l0.02,2.73l0.71,2.63l-1.33,0.94l-0.12,0.17l-0.67,2.64l-0.59,3.03l0.4,3.55l-0.84,0.51l-0.14,0.31l0.58,3.5l0.08,0.16l0.96,0.99l-0.7,1.08l0.11,0.43l1.04,0.55l0.19,0.8l-0.89,0.48l-0.16,0.31l0.26,1.77l-0.89,4.06l-1.31,2.67l-0.03,0.19l0.28,1.53l-0.73,1.88l-1.85,1.37l-0.12,0.26l0.22,3.46l0.06,0.16l0.88,1.19l0.28,0.12l1.32,-0.17l-0.04,2.13l0.04,0.15l1.04,1.95l0.24,0.16l5.94,0.44ZM248.79,430.71l0.0,7.41l0.3,0.3l2.67,0.0l1.01,0.06l-0.54,0.91l-1.99,1.01l-1.13,-0.1l-1.42,-0.27l-1.87,-1.06l-2.57,-0.49l-3.09,-1.9l-2.52,-1.83l-2.65,-2.93l0.93,0.32l3.54,2.29l3.32,1.23l0.34,-0.09l1.29,-1.57l0.83,-2.32l2.11,-1.28l1.43,0.32Z" data-code="CL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M280.14,145.66l-1.66,2.88l0.06,0.37l0.37,0.03l1.5,-1.01l1.17,0.49l-0.64,0.83l0.13,0.46l2.22,0.89l0.28,-0.03l1.02,-0.7l2.09,0.83l-0.69,2.1l0.37,0.38l1.43,-0.45l0.27,1.43l0.74,1.88l-0.95,2.5l-0.88,0.09l-1.34,-0.48l0.49,-2.34l-0.14,-0.32l-0.7,-0.4l-0.36,0.04l-2.81,2.66l-0.63,-0.05l1.2,-1.01l-0.1,-0.52l-2.4,-0.77l-2.79,0.18l-4.65,-0.09l-0.22,-0.54l1.37,-0.99l0.01,-0.48l-0.82,-0.65l1.91,-1.79l2.57,-5.17l1.49,-1.81l2.04,-1.07l0.63,0.08l-0.27,0.51l-1.33,2.07ZM193.92,74.85l-0.01,4.24l0.19,0.28l0.33,-0.07l3.14,-3.22l2.65,2.5l-0.71,3.04l0.06,0.26l2.42,2.88l0.46,0.0l2.66,-3.14l1.83,-3.74l0.03,-0.12l0.13,-4.53l3.23,0.31l3.63,0.64l3.18,2.08l0.13,1.91l-1.79,2.22l-0.0,0.37l1.69,2.2l-0.28,1.8l-4.74,2.84l-3.33,0.62l-2.5,-1.21l-0.41,0.17l-0.73,2.05l-2.39,3.44l-0.74,1.78l-2.78,2.61l-3.48,0.26l-0.17,0.07l-1.98,1.68l-0.1,0.21l-0.15,2.33l-2.68,0.45l-0.17,0.09l-3.1,3.2l-2.75,4.38l-0.99,3.06l-0.14,4.31l0.25,0.31l3.5,0.58l1.07,3.24l1.18,2.76l0.34,0.18l3.43,-0.69l4.55,1.52l2.45,1.32l1.76,1.65l0.12,0.07l3.11,0.96l2.63,1.46l0.13,0.04l4.12,0.2l2.41,0.3l-0.36,2.81l0.8,3.51l1.81,3.78l0.08,0.1l3.73,3.17l0.34,0.03l1.93,-1.08l0.13,-0.15l1.35,-3.44l0.01,-0.18l-1.31,-5.38l-0.08,-0.14l-1.46,-1.5l3.68,-1.51l2.84,-2.46l1.45,-2.55l0.04,-0.17l-0.2,-2.39l-0.04,-0.12l-1.7,-3.07l-2.9,-2.64l2.79,-3.66l0.05,-0.27l-1.08,-3.38l-0.8,-5.75l1.45,-0.75l4.18,1.03l2.6,0.38l0.18,-0.03l1.93,-0.95l2.18,1.23l3.01,2.18l0.73,1.42l0.25,0.16l4.18,0.27l-0.06,2.95l0.83,4.7l0.22,0.24l2.19,0.55l1.75,2.08l0.38,0.07l3.63,-2.03l0.11,-0.11l2.38,-4.06l1.36,-1.43l1.76,3.01l3.26,4.68l2.68,4.19l-0.94,2.09l0.12,0.38l3.31,1.98l2.23,1.98l0.13,0.07l3.94,0.89l1.48,1.02l0.96,2.82l0.22,0.2l1.85,0.43l0.88,1.13l0.17,3.53l-1.68,1.16l-1.76,1.14l-4.08,1.17l-0.11,0.06l-3.08,2.65l-4.11,0.52l-5.35,-0.69l-3.76,-0.02l-2.62,0.23l-0.2,0.1l-2.05,2.29l-3.13,1.41l-0.11,0.08l-3.6,4.24l-2.87,2.92l-0.05,0.36l0.33,0.14l2.13,-0.52l0.15,-0.08l3.98,-4.15l5.16,-2.63l3.58,-0.31l1.82,1.3l-2.09,1.91l-0.09,0.29l0.8,3.46l0.82,2.37l0.15,0.17l3.25,1.56l0.16,0.03l4.14,-0.45l0.21,-0.12l2.03,-2.86l0.11,1.46l0.13,0.22l1.26,0.88l-2.7,1.78l-5.51,1.83l-2.52,1.26l-2.75,2.16l-1.52,-0.18l-0.08,-2.16l4.19,-2.47l0.14,-0.34l-0.3,-0.22l-4.01,0.1l-2.66,0.36l-1.45,-1.56l0.0,-4.16l-0.11,-0.23l-1.11,-0.91l-0.28,-0.05l-1.5,0.48l-0.7,-0.7l-0.45,0.02l-1.91,2.39l-0.8,2.5l-0.82,1.31l-0.95,0.43l-0.77,0.15l-0.23,0.2l-0.18,0.56l-8.2,0.02l-0.13,0.03l-1.19,0.61l-2.95,2.45l-0.78,1.13l-4.6,0.01l-0.12,0.02l-1.13,0.48l-0.13,0.44l0.37,0.55l0.2,0.82l-0.01,0.09l-3.1,1.42l-2.63,0.5l-2.84,1.57l-0.47,0.0l-0.72,-0.4l-0.18,-0.27l0.03,-0.15l0.52,-1.0l1.2,-1.71l0.73,-1.8l0.02,-0.17l-1.03,-5.47l-0.15,-0.21l-2.35,-1.32l0.16,-0.29l-0.05,-0.35l-0.37,-0.38l-0.22,-0.09l-0.56,0.0l-0.35,-0.34l-0.11,-0.65l-0.46,-0.2l-0.39,0.26l-0.2,-0.03l-0.11,-0.33l-0.48,-0.25l-0.21,-0.71l-0.15,-0.18l-3.97,-2.07l-4.8,-2.39l-0.25,-0.01l-2.19,0.89l-0.72,0.03l-3.04,-0.82l-0.14,-0.0l-1.94,0.4l-2.4,-0.98l-2.56,-0.51l-1.7,-0.19l-0.62,-0.44l-0.42,-1.67l-0.3,-0.23l-0.85,0.02l-0.29,0.3l-0.01,0.95l-69.26,-0.01l-4.77,-3.14l-1.78,-1.41l-4.51,-1.38l-1.3,-2.73l0.34,-1.96l-0.17,-0.33l-3.06,-1.37l-0.41,-2.58l-0.11,-0.18l-2.92,-2.4l-0.05,-1.53l1.32,-1.59l0.07,-0.2l-0.07,-2.21l-0.16,-0.26l-4.19,-2.22l-2.52,-4.02l-1.56,-2.6l-0.08,-0.09l-2.28,-1.64l-1.65,-1.48l-1.31,-1.89l-0.38,-0.1l-2.51,1.21l-2.28,1.92l-2.03,-2.22l-1.85,-1.71l-2.44,-1.04l-2.28,-0.12l0.03,-37.72l4.27,0.98l4.0,2.13l2.61,0.4l0.24,-0.07l2.17,-1.81l2.92,-1.33l3.63,0.53l0.18,-0.03l3.72,-1.94l3.89,-1.06l1.6,1.72l0.37,0.06l1.87,-1.04l0.14,-0.19l0.48,-1.83l1.37,0.38l4.18,3.96l0.41,0.0l2.89,-2.62l0.28,2.79l0.37,0.26l3.08,-0.73l0.17,-0.12l0.85,-1.16l2.81,0.24l3.83,1.86l5.86,1.61l3.46,0.75l2.44,-0.26l2.89,1.89l-3.12,1.89l-0.14,0.31l0.24,0.24l4.53,0.92l6.84,-0.5l2.04,-0.71l2.54,2.44l0.39,0.02l2.72,-2.16l-0.01,-0.48l-2.26,-1.61l1.27,-1.16l2.94,-0.19l1.94,-0.42l1.89,0.97l2.49,2.32l0.24,0.08l2.71,-0.33l4.35,1.9l0.17,0.02l3.86,-0.67l3.62,0.1l0.31,-0.33l-0.26,-2.44l1.9,-0.65l3.58,1.36l-0.01,3.84l0.23,0.29l0.34,-0.17l1.51,-3.23l1.81,0.1l0.31,-0.22l1.13,-4.37l-0.08,-0.29l-2.68,-2.73l-2.83,-1.76l0.19,-4.73l2.77,-3.15l3.06,0.69l2.44,1.97l3.24,4.88l-2.05,2.02l0.15,0.51l4.41,0.85ZM265.85,150.7l-0.84,0.04l-3.15,-0.99l-1.77,-1.17l0.19,-0.06l3.17,0.79l2.39,1.27l0.01,0.12ZM249.41,3.71l6.68,0.49l5.34,0.79l4.34,1.6l-0.08,1.24l-5.91,2.56l-6.03,1.21l-2.36,1.38l-0.14,0.34l0.29,0.22l4.37,-0.02l-4.96,3.01l-4.06,1.64l-0.11,0.08l-4.21,4.62l-5.07,0.92l-0.12,0.05l-1.53,1.1l-7.5,0.59l-0.28,0.28l0.24,0.31l2.67,0.54l-1.04,0.6l-0.09,0.44l1.89,2.49l-2.11,1.66l-3.83,1.52l-0.15,0.13l-1.14,2.01l-3.41,1.55l-0.16,0.36l0.35,1.19l0.3,0.22l3.98,-0.19l0.03,0.78l-6.42,2.99l-6.44,-1.41l-7.41,0.79l-3.72,-0.62l-4.48,-0.26l-0.25,-2.0l4.37,-1.13l0.21,-0.38l-1.14,-3.55l1.13,-0.28l6.61,2.29l0.35,-0.12l-0.04,-0.37l-3.41,-3.45l-0.14,-0.08l-3.57,-0.92l1.62,-1.7l4.36,-1.3l0.2,-0.18l0.71,-1.94l-0.12,-0.36l-3.45,-2.15l-0.88,-2.43l6.36,0.23l1.94,0.61l0.23,-0.02l3.91,-2.1l0.15,-0.32l-0.26,-0.24l-5.69,-0.67l-8.69,0.37l-4.3,-1.92l-2.12,-2.39l-2.82,-1.68l-0.44,-1.65l3.41,-1.06l2.93,-0.2l4.91,-0.99l3.69,-2.28l2.93,0.31l2.64,1.68l0.42,-0.1l1.84,-3.23l3.17,-0.96l4.45,-0.69l7.56,-0.26l1.26,0.64l0.18,0.03l7.2,-1.06l10.81,0.8ZM203.94,57.59l0.01,0.32l1.97,2.97l0.51,-0.01l2.26,-3.75l6.05,-1.89l4.08,4.72l-0.36,2.95l0.38,0.33l4.95,-1.36l0.11,-0.05l2.23,-1.77l5.37,2.31l3.32,2.14l0.3,1.89l0.36,0.25l4.48,-1.01l2.49,2.8l0.14,0.09l5.99,1.78l2.09,1.74l2.18,3.83l-4.29,1.91l-0.01,0.54l5.9,2.83l3.95,0.94l3.54,3.84l0.2,0.1l3.58,0.25l-0.67,2.51l-4.18,4.54l-2.84,-1.61l-3.91,-3.95l-0.26,-0.09l-3.24,0.52l-0.25,0.26l-0.32,2.37l0.1,0.26l2.63,2.38l3.42,1.89l0.96,1.0l1.57,3.8l-0.74,2.43l-2.85,-0.96l-6.26,-3.15l-0.38,0.09l0.04,0.39l3.54,3.4l2.55,2.31l0.23,0.78l-6.26,-1.43l-5.33,-2.25l-2.73,-1.73l0.67,-0.86l-0.09,-0.45l-7.38,-4.01l-0.44,0.27l0.03,0.89l-6.85,0.61l-1.8,-1.17l1.43,-2.6l4.56,-0.07l5.15,-0.52l0.23,-0.45l-0.76,-1.34l0.8,-1.89l3.21,-4.06l0.05,-0.29l-0.72,-1.95l-0.97,-1.47l-0.11,-0.1l-3.84,-2.1l-4.53,-1.33l1.09,-0.75l0.05,-0.45l-2.65,-2.75l-0.18,-0.09l-2.12,-0.24l-1.91,-1.47l-0.39,0.02l-1.27,1.25l-4.4,0.56l-9.06,-0.99l-5.28,-1.31l-4.01,-0.67l-1.72,-1.31l2.32,-1.85l0.1,-0.33l-0.28,-0.2l-3.3,-0.02l-0.74,-4.36l1.86,-4.09l2.46,-1.88l5.74,-1.15l-1.5,2.55ZM261.28,159.28l0.19,0.14l1.82,0.42l1.66,-0.05l-0.66,0.68l-0.75,0.16l-3.0,-1.25l-0.46,-0.77l0.51,-0.52l0.68,1.19ZM230.87,84.48l-2.48,0.19l-0.52,-1.74l0.96,-2.17l2.03,-0.53l1.71,1.04l0.02,1.6l-0.22,0.46l-1.5,1.16ZM229.52,58.19l0.14,0.82l-4.99,-0.22l-2.73,0.63l-0.59,-0.23l-2.61,-2.4l0.08,-1.38l0.94,-0.25l5.61,0.51l4.14,2.54ZM222.12,105.0l-0.79,1.63l-0.75,-0.22l-0.52,-0.91l0.04,-0.09l0.84,-1.01l0.74,0.06l0.44,0.55ZM183.77,38.22l2.72,1.65l0.16,0.04l4.83,-0.01l1.92,1.52l-0.51,1.75l0.18,0.36l2.84,1.14l1.56,1.19l0.16,0.06l3.37,0.22l3.65,0.42l4.07,-1.1l5.05,-0.43l3.96,0.35l2.53,1.8l0.48,1.79l-1.37,1.16l-3.6,1.03l-3.22,-0.59l-7.17,0.76l-5.1,0.09l-4.0,-0.6l-6.48,-1.56l-0.81,-2.57l-0.3,-2.49l-0.1,-0.19l-2.51,-2.25l-0.16,-0.07l-5.12,-0.63l-2.61,-1.45l0.75,-1.71l4.88,0.32ZM207.46,91.26l0.42,1.62l0.42,0.19l1.12,-0.55l1.35,0.99l2.74,1.39l2.73,1.2l0.2,1.74l0.35,0.26l1.72,-0.29l1.31,0.97l-1.72,0.96l-3.68,-0.9l-1.34,-1.71l-0.43,-0.04l-2.46,2.1l-3.23,1.85l-0.74,-1.98l-0.31,-0.19l-2.47,0.28l1.49,-1.34l0.1,-0.19l0.32,-3.15l0.79,-3.45l1.34,0.25ZM215.59,102.66l-2.73,2.0l-1.49,-0.08l-0.37,-0.7l1.61,-1.56l3.0,0.03l-0.02,0.3ZM202.79,24.07l0.11,0.12l2.54,1.53l-3.01,1.47l-4.55,4.07l-4.3,0.38l-5.07,-0.68l-2.51,-2.09l0.03,-1.72l1.86,-1.4l0.1,-0.34l-0.29,-0.2l-4.49,0.04l-2.63,-1.79l-1.45,-2.36l1.61,-2.38l1.65,-1.69l2.47,-0.4l0.19,-0.48l-0.72,-0.89l5.1,-0.26l3.1,3.05l0.13,0.07l4.21,1.25l3.99,1.06l1.92,3.65ZM187.5,59.3l-0.15,0.1l-2.59,3.4l-2.5,-0.15l-1.47,-3.92l0.04,-2.24l1.22,-1.92l2.34,-1.26l5.11,0.17l4.28,1.06l-3.36,3.86l-2.9,0.9ZM186.19,48.8l-1.15,1.63l-3.42,-0.35l-2.68,-1.15l1.11,-1.88l3.34,-1.27l2.01,1.63l0.79,1.38ZM185.78,35.41l-0.95,0.13l-4.48,-0.33l-0.4,-0.91l4.5,0.07l1.45,0.82l-0.1,0.21ZM180.76,32.56l-3.43,1.03l-1.85,-1.14l-1.01,-1.92l-0.16,-1.87l2.87,0.2l1.39,0.35l2.75,1.75l-0.55,1.6ZM181.03,76.32l-1.21,1.2l-3.19,-1.26l-0.18,-0.01l-1.92,0.45l-2.88,-1.67l1.84,-1.16l1.6,-1.77l2.45,1.17l1.45,0.77l2.05,2.28ZM169.72,54.76l2.83,0.97l0.14,0.01l4.25,-0.58l0.47,1.01l-2.19,2.16l0.07,0.48l3.61,1.95l-0.41,3.84l-3.87,1.68l-2.23,-0.36l-1.73,-1.75l-6.07,-3.53l0.03,-1.01l4.79,0.55l0.3,-0.16l-0.04,-0.34l-2.55,-2.89l2.59,-2.05ZM174.44,40.56l1.49,1.87l0.07,2.48l-1.07,3.52l-3.87,0.48l-2.41,-0.72l0.05,-2.72l-0.33,-0.3l-3.79,0.36l-0.13,-3.31l2.36,0.14l0.15,-0.03l3.7,-1.74l3.44,0.29l0.31,-0.22l0.03,-0.12ZM170.14,31.5l0.75,1.74l-3.52,-0.52l-4.19,-1.77l-4.65,-0.17l1.65,-1.11l-0.05,-0.52l-2.86,-1.26l-0.13,-1.58l4.52,0.7l6.66,1.99l1.84,2.5ZM134.64,58.08l-1.08,1.93l0.34,0.44l5.44,-1.41l3.37,2.32l0.37,-0.02l2.66,-2.28l2.03,1.38l2.01,4.53l0.53,0.04l1.26,-1.93l0.03,-0.27l-1.67,-4.55l1.82,-0.58l2.36,0.73l2.69,1.84l1.53,4.46l0.77,3.24l0.15,0.19l4.22,2.26l4.32,2.04l-0.21,1.51l-3.87,0.34l-0.19,0.5l1.45,1.54l-0.65,1.23l-4.3,-0.65l-4.4,-1.19l-2.97,0.28l-4.67,1.48l-6.31,0.65l-4.27,0.39l-1.26,-1.91l-0.15,-0.12l-3.42,-1.2l-0.16,-0.01l-2.05,0.45l-2.66,-3.02l1.2,-0.34l3.82,-0.76l3.58,0.19l3.27,-0.78l0.23,-0.29l-0.24,-0.29l-4.84,-1.06l-5.42,0.35l-3.4,-0.09l-0.97,-1.22l5.39,-1.7l0.21,-0.33l-0.3,-0.25l-3.82,0.06l-3.95,-1.1l1.88,-3.13l1.68,-1.81l6.54,-2.84l2.11,0.77ZM158.85,56.58l-1.82,2.62l-3.38,-2.9l0.49,-0.39l3.17,-0.18l1.54,0.86ZM149.71,42.7l1.0,1.87l0.37,0.14l2.17,-0.83l2.33,0.2l0.38,2.16l-1.38,2.17l-8.33,0.76l-6.34,2.15l-3.51,0.1l-0.22,-1.13l4.98,-2.12l0.17,-0.34l-0.31,-0.23l-11.27,0.6l-3.04,-0.78l3.14,-4.57l2.2,-1.35l6.87,1.7l4.4,3.0l0.14,0.05l4.37,0.39l0.27,-0.48l-3.41,-4.68l1.96,-1.62l2.28,0.53l0.79,2.32ZM145.44,29.83l-2.18,0.77l-3.79,-0.0l0.02,-0.31l2.34,-1.5l1.2,0.23l2.42,0.83ZM144.83,34.5l-4.44,1.46l-3.18,-1.48l1.6,-1.36l3.51,-0.53l3.1,0.75l-0.6,1.16ZM119.02,65.87l-6.17,2.07l-1.19,-1.82l-0.13,-0.11l-5.48,-2.32l0.92,-1.7l1.73,-3.44l2.16,-3.15l-0.02,-0.36l-2.09,-2.56l7.84,-0.71l3.59,1.02l6.32,0.27l2.35,1.37l2.25,1.71l-2.68,1.04l-6.21,3.41l-3.1,3.28l-0.08,0.21l0.0,1.81ZM129.66,35.4l-0.3,3.55l-1.77,1.67l-2.34,0.27l-4.62,2.2l-3.89,0.76l-2.83,-0.93l3.85,-3.52l5.04,-3.36l3.75,0.07l3.11,-0.7ZM111.24,152.74l-0.82,0.29l-3.92,-1.39l-0.7,-1.06l-0.12,-0.1l-2.15,-1.09l-0.41,-0.84l-0.2,-0.16l-2.44,-0.56l-0.84,-1.56l0.1,-0.36l2.34,0.64l1.53,0.5l2.28,0.34l0.78,1.04l1.24,1.55l0.09,0.08l2.42,1.3l0.81,1.39ZM88.54,134.82l0.14,0.02l2.0,-0.23l-0.67,3.48l0.06,0.24l1.78,2.22l-0.24,-0.0l-1.4,-1.42l-0.91,-1.53l-1.26,-1.08l-0.42,-1.35l0.09,-0.66l0.82,0.31Z" data-code="CA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M453.66,296.61l-0.9,-0.82l-0.35,-0.04l-0.83,0.48l-0.77,0.83l-1.65,-2.13l1.66,-1.2l0.08,-0.39l-0.81,-1.43l0.59,-0.43l1.62,-0.29l0.24,-0.24l0.1,-0.58l0.94,0.84l0.19,0.08l2.21,0.11l0.27,-0.14l0.81,-1.29l0.32,-1.76l-0.27,-1.96l-0.06,-0.15l-1.08,-1.35l1.02,-2.74l-0.09,-0.34l-0.62,-0.5l-0.22,-0.06l-1.66,0.18l-0.55,-1.03l0.12,-0.73l2.85,0.09l1.98,0.65l2.0,0.59l0.38,-0.25l0.17,-1.3l1.26,-2.24l1.34,-1.19l1.54,0.38l1.35,0.12l-0.11,1.15l-0.74,1.34l-0.5,1.61l-0.31,2.22l0.12,1.41l-0.4,0.9l-0.06,0.88l-0.24,0.67l-1.57,1.15l-1.24,1.41l-1.09,2.43l-0.03,0.13l0.08,1.95l-0.55,0.69l-1.46,1.23l-1.32,1.41l-0.61,-0.29l-0.13,-0.57l-0.29,-0.23l-1.36,-0.02l-0.23,0.1l-0.72,0.81l-0.41,-0.16Z" data-code="CG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M459.41,266.56l1.9,-0.17l0.22,-0.12l0.36,-0.5l0.14,0.02l0.55,0.51l0.29,0.07l3.15,-0.96l0.12,-0.07l1.05,-0.97l1.29,-0.87l0.12,-0.33l-0.17,-0.61l0.38,-0.12l2.36,0.15l0.15,-0.03l2.36,-1.17l0.12,-0.1l1.78,-2.72l1.18,-0.96l1.23,-0.34l0.21,0.79l0.07,0.13l1.37,1.5l0.01,0.86l-0.39,1.0l-0.01,0.17l0.16,0.78l0.1,0.17l0.91,0.76l1.89,1.09l1.24,0.92l0.02,0.67l0.12,0.23l1.67,1.3l0.99,1.03l0.61,1.46l0.14,0.15l1.79,0.95l0.2,0.4l-0.44,0.14l-1.54,-0.06l-1.98,-0.26l-0.93,0.22l-0.19,0.14l-0.3,0.48l-0.57,0.05l-0.91,-0.49l-0.26,-0.01l-2.7,1.21l-1.04,-0.23l-0.21,0.03l-0.34,0.19l-0.12,0.13l-0.64,1.3l-1.67,-0.43l-1.77,-0.24l-1.58,-0.91l-2.06,-0.85l-0.27,0.02l-1.42,0.88l-0.97,1.27l-0.06,0.14l-0.19,1.46l-1.3,-0.11l-1.67,-0.42l-0.27,0.07l-1.55,1.41l-0.99,1.76l-0.14,-1.18l-0.13,-0.22l-1.1,-0.78l-0.86,-1.2l-0.2,-0.84l-0.07,-0.13l-1.07,-1.19l0.16,-0.59l0.0,-0.15l-0.24,-1.01l0.18,-1.77l0.5,-0.38l0.09,-0.11l1.18,-2.4Z" data-code="CF" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M497.85,276.25l-0.14,2.77l0.2,0.3l0.57,0.19l-0.47,0.52l-1.0,0.71l-0.96,1.31l-0.56,1.22l-0.16,2.04l-0.54,0.89l-0.04,0.15l-0.02,1.76l-0.63,0.61l-0.09,0.2l-0.08,1.33l-0.2,0.11l-0.15,0.21l-0.23,1.37l0.03,0.2l0.6,1.08l0.16,2.96l0.44,2.29l-0.24,1.25l0.01,0.15l0.5,1.46l0.07,0.12l1.41,1.37l1.09,2.56l-0.51,-0.11l-3.45,0.45l-0.67,0.3l-0.15,0.15l-0.71,1.61l0.01,0.26l0.52,1.03l-0.43,2.9l-0.31,2.55l0.13,0.29l0.7,0.46l1.75,0.99l0.31,-0.01l0.26,-0.17l0.15,1.9l-1.44,-0.02l-0.94,-1.28l-0.94,-1.1l-0.17,-0.1l-1.76,-0.33l-0.5,-1.18l-0.42,-0.15l-1.44,0.75l-1.79,-0.32l-0.77,-1.05l-0.2,-0.12l-1.59,-0.23l-0.97,0.04l-0.1,-0.53l-0.27,-0.25l-0.86,-0.06l-1.13,-0.15l-1.62,0.37l-1.04,-0.06l-0.32,0.09l0.11,-2.56l-0.08,-0.21l-0.77,-0.87l-0.17,-1.41l0.36,-1.47l-0.03,-0.21l-0.48,-0.91l-0.04,-1.52l-0.3,-0.29l-2.65,0.02l0.13,-0.53l-0.29,-0.37l-1.28,0.01l-0.28,0.21l-0.07,0.24l-1.35,0.09l-0.26,0.18l-0.62,1.45l-0.25,0.42l-1.17,-0.3l-0.19,0.01l-0.79,0.34l-1.44,0.18l-1.41,-1.96l-0.7,-1.47l-0.61,-1.86l-0.28,-0.21l-7.39,-0.03l-0.92,0.3l-0.78,-0.03l-0.78,0.25l-0.11,-0.25l0.35,-0.15l0.18,-0.26l0.07,-1.02l0.33,-0.52l0.72,-0.42l0.52,0.2l0.33,-0.08l0.76,-0.86l0.99,0.02l0.11,0.48l0.16,0.2l0.94,0.44l0.35,-0.07l1.46,-1.56l1.44,-1.21l0.68,-0.85l0.06,-0.2l-0.08,-1.99l1.04,-2.33l1.1,-1.23l1.62,-1.19l0.11,-0.14l0.29,-0.8l0.08,-0.94l0.38,-0.82l0.03,-0.16l-0.13,-1.38l0.3,-2.16l0.47,-1.51l0.73,-1.31l0.04,-0.12l0.15,-1.51l0.21,-1.66l0.89,-1.16l1.16,-0.7l1.9,0.79l1.69,0.95l1.81,0.24l1.85,0.48l0.35,-0.16l0.71,-1.43l0.16,-0.09l1.03,0.23l0.19,-0.02l2.65,-1.19l0.86,0.46l0.17,0.03l0.81,-0.08l0.23,-0.14l0.31,-0.5l0.75,-0.17l1.83,0.26l1.64,0.06l0.72,-0.21l1.39,1.9l0.16,0.11l1.12,0.3l0.24,-0.04l0.58,-0.36l1.05,0.15l0.15,-0.02l1.15,-0.44l0.47,0.84l0.08,0.09l2.08,1.57Z" data-code="CD" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M463.29,152.22l-0.88,-0.47l-0.18,-0.03l-1.08,0.15l-1.86,-0.94l-0.21,-0.02l-0.88,0.24l-0.13,0.07l-1.25,1.17l-1.63,-0.91l-1.38,-1.36l-1.22,-0.75l-0.24,-1.24l-0.33,-0.75l1.53,-0.6l0.98,-0.84l1.74,-0.62l0.11,-0.07l0.47,-0.47l0.46,0.27l0.24,0.03l0.96,-0.3l1.06,0.95l0.15,0.07l1.57,0.24l-0.1,0.6l0.16,0.32l1.36,0.68l0.41,-0.15l0.28,-0.62l1.29,0.28l0.19,0.84l0.26,0.23l1.73,0.18l0.74,1.02l-0.17,0.0l-0.25,0.13l-0.32,0.49l-0.46,0.11l-0.22,0.23l-0.13,0.57l-0.32,0.1l-0.2,0.22l-0.03,0.14l-0.65,0.25l-1.05,-0.05l-0.28,0.17l-0.22,0.43Z" data-code="CZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M505.03,193.75l-1.51,0.68l-1.0,-0.3l-0.32,-0.63l0.69,-0.06l0.41,0.13l0.19,-0.0l0.62,-0.22l0.31,0.02l0.06,0.22l0.49,0.17l0.06,-0.01Z" data-code="CY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M213.0,263.84l-0.98,-0.4l-0.3,-0.31l0.16,-0.24l0.05,-0.21l-0.09,-0.56l-0.1,-0.18l-0.76,-0.65l-0.99,-0.5l-0.74,-0.28l-0.13,-0.58l-0.12,-0.18l-0.66,-0.45l-0.34,-0.0l-0.13,0.31l0.13,0.59l-0.17,0.21l-0.34,-0.42l-0.14,-0.1l-0.7,-0.22l-0.23,-0.34l0.01,-0.62l0.31,-0.74l-0.14,-0.38l-0.3,-0.15l0.47,-0.4l1.48,0.6l0.26,-0.02l0.47,-0.27l0.58,0.15l0.35,0.44l0.17,0.11l0.74,0.17l0.27,-0.07l0.3,-0.27l0.52,1.09l0.97,1.02l0.77,0.71l-0.41,0.1l-0.23,0.3l0.01,1.02l0.12,0.24l0.2,0.14l-0.07,0.05l-0.11,0.3l0.08,0.37l-0.23,0.63Z" data-code="CR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M215.01,226.09l2.08,0.18l1.94,0.03l2.24,0.86l0.95,0.92l0.25,0.08l2.22,-0.28l0.79,0.55l3.68,2.81l0.19,0.06l0.77,-0.03l1.18,0.42l-0.12,0.47l0.27,0.37l1.78,0.1l1.59,0.9l-0.11,0.22l-1.5,0.3l-1.64,0.13l-1.75,-0.2l-2.69,0.19l1.0,-0.86l-0.03,-0.48l-1.02,-0.68l-0.13,-0.05l-1.52,-0.16l-0.74,-0.64l-0.57,-1.42l-0.3,-0.19l-1.36,0.1l-2.23,-0.67l-0.71,-0.52l-0.14,-0.06l-3.2,-0.4l-0.42,-0.25l0.56,-0.39l0.12,-0.33l-0.27,-0.22l-2.46,-0.13l-0.2,0.06l-1.72,1.31l-0.94,0.03l-0.25,0.15l-0.29,0.53l-1.04,0.24l-0.29,-0.07l0.7,-0.43l0.1,-0.11l0.5,-0.87l1.04,-0.54l1.23,-0.49l1.86,-0.25l0.62,-0.28Z" data-code="CU" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M500.95,353.41l-0.41,0.97l-1.16,0.23l-1.29,-1.26l-0.02,-0.71l0.63,-0.93l0.23,-0.7l0.47,-0.12l1.04,0.4l0.32,1.05l0.2,1.08Z" data-code="SZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M510.84,199.83l0.09,-0.11l0.07,-0.2l-0.04,-1.08l0.56,-1.4l1.3,-1.01l0.1,-0.34l-0.41,-1.11l-0.24,-0.19l-0.89,-0.11l-0.2,-1.84l0.55,-1.05l1.3,-1.22l0.09,-0.19l0.09,-1.09l0.39,0.27l0.25,0.04l2.66,-0.77l1.35,0.52l2.06,-0.01l2.93,-1.08l1.35,0.04l2.14,-0.34l-0.83,1.16l-1.31,0.68l-0.16,0.3l0.23,2.03l-0.9,3.25l-5.43,2.87l-4.79,2.91l-2.32,-0.92Z" data-code="SY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M599.04,172.15l0.38,-0.9l1.43,-0.37l4.04,1.02l0.37,-0.23l0.36,-1.64l1.17,-0.52l3.45,1.24l0.2,-0.0l0.86,-0.31l4.09,0.08l3.61,0.31l1.18,1.02l0.11,0.06l1.19,0.34l-0.13,0.26l-3.84,1.58l-0.13,0.1l-0.81,1.08l-3.08,0.34l-0.24,0.16l-0.85,1.7l-2.43,-0.37l-0.14,0.01l-1.79,0.61l-2.39,1.4l-0.12,0.39l0.25,0.49l-0.48,0.45l-4.57,0.43l-3.04,-0.94l-2.45,0.18l0.14,-1.02l2.42,0.44l0.27,-0.08l0.81,-0.81l1.76,0.27l0.21,-0.05l3.21,-2.14l-0.03,-0.51l-2.97,-1.57l-0.26,-0.01l-1.64,0.69l-1.38,-0.84l1.81,-1.67l-0.09,-0.5l-0.46,-0.18Z" data-code="KG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M523.3,287.04l0.06,0.17l1.29,1.8l-1.46,0.84l-0.11,0.11l-0.55,0.93l-0.81,0.16l-0.24,0.24l-0.34,1.69l-0.81,1.06l-0.46,1.58l-0.76,0.63l-3.3,-2.3l-0.16,-1.32l-0.15,-0.23l-9.35,-5.28l-0.02,-2.4l1.92,-2.63l0.91,-1.83l0.01,-0.24l-1.09,-2.86l-0.29,-1.24l-1.09,-1.63l2.93,-2.85l0.92,0.3l0.0,1.19l0.09,0.22l0.86,0.83l0.21,0.08l1.65,0.0l3.09,2.08l0.16,0.05l0.79,0.03l0.54,-0.06l0.58,0.28l1.67,0.2l0.28,-0.12l0.69,-0.98l2.04,-0.94l0.86,0.73l0.19,0.07l1.1,0.0l-1.82,2.36l-0.06,0.18l0.03,9.12Z" data-code="KE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M505.7,261.39l0.02,1.64l-0.27,0.55l-1.15,0.05l-0.24,0.15l-0.85,1.44l0.22,0.45l1.44,0.17l1.15,1.12l0.42,0.95l0.14,0.15l1.06,0.54l1.33,2.45l-3.06,2.98l-1.44,1.08l-1.75,0.01l-1.92,0.56l-1.5,-0.53l-0.27,0.03l-0.85,0.57l-1.98,-1.5l-0.56,-1.02l-0.37,-0.13l-1.32,0.5l-1.08,-0.15l-0.2,0.04l-0.56,0.35l-0.9,-0.24l-1.44,-1.97l-0.39,-0.77l-0.13,-0.13l-1.78,-0.94l-0.65,-1.5l-1.08,-1.12l-1.57,-1.22l-0.02,-0.68l-0.12,-0.23l-1.37,-1.02l-1.17,-0.68l0.2,-0.08l0.86,-0.48l0.14,-0.18l0.63,-2.22l0.6,-1.02l1.47,-0.28l0.35,0.56l1.29,1.48l0.14,0.09l0.69,0.22l0.22,-0.02l0.83,-0.4l1.58,0.08l0.26,0.39l0.25,0.13l2.49,0.0l0.3,-0.25l0.06,-0.35l1.13,-0.42l0.18,-0.18l0.22,-0.63l0.68,-0.38l1.95,1.37l0.23,0.05l1.29,-0.26l0.19,-0.12l1.23,-1.8l1.36,-1.37l0.08,-0.25l-0.21,-1.52l-0.06,-0.15l-0.25,-0.3l0.94,-0.08l0.26,-0.21l0.1,-0.32l0.6,0.09l-0.25,1.67l0.3,1.83l0.11,0.19l1.22,0.94l0.25,0.73l-0.04,1.2l0.26,0.31l0.09,0.01Z" data-code="SS" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M278.1,270.26l2.71,0.45l0.31,-0.14l0.19,-0.32l1.82,-0.16l2.25,0.56l-1.09,1.81l-0.04,0.19l0.2,1.72l0.05,0.13l0.9,1.35l-0.39,0.99l-0.21,1.09l-0.48,0.8l-1.2,-0.44l-0.17,-0.01l-1.12,0.24l-0.95,-0.21l-0.35,0.2l-0.25,0.73l0.05,0.29l0.3,0.35l-0.06,0.13l-1.01,-0.15l-1.42,-2.03l-0.32,-1.36l-0.29,-0.23l-0.63,-0.0l-0.95,-1.56l0.41,-1.16l0.01,-0.17l-0.08,-0.35l1.29,-0.56l0.18,-0.22l0.35,-1.97Z" data-code="SR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M680.28,257.89l-0.93,-1.2l-1.24,-2.56l-0.56,-2.9l1.45,-1.92l3.07,-0.46l2.26,0.35l2.03,0.98l0.38,-0.11l1.0,-1.55l1.86,0.79l0.52,1.51l-0.28,2.82l-4.05,1.88l-0.12,0.45l0.79,1.1l-2.2,0.17l-2.08,0.98l-1.89,-0.33Z" data-code="KH" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M197.02,248.89l0.18,-0.05l0.59,0.17l0.55,0.51l0.64,0.35l0.06,0.22l0.37,0.21l1.01,-0.28l0.38,0.13l0.16,0.13l-0.14,0.81l-0.18,0.38l-1.22,-0.03l-0.84,-0.23l-1.11,-0.52l-1.31,-0.15l-0.49,-0.38l0.02,-0.08l0.76,-0.57l0.46,-0.27l0.11,-0.35Z" data-code="SV" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M468.01,150.02l0.05,0.07l0.36,0.1l0.85,-0.37l1.12,1.02l0.33,0.05l1.38,-0.65l1.07,0.3l0.16,0.0l1.69,-0.43l1.95,1.02l-0.51,0.64l-0.45,1.2l-0.32,0.2l-2.55,-0.93l-0.17,-0.01l-0.82,0.2l-0.17,0.11l-0.53,0.68l-0.94,0.32l-0.14,-0.11l-0.29,-0.04l-1.18,0.48l-0.95,0.09l-0.26,0.21l-0.15,0.47l-1.84,0.34l-0.82,-0.31l-1.14,-0.73l-0.2,-0.89l0.42,-0.84l0.91,0.05l0.12,-0.02l0.86,-0.33l0.18,-0.21l0.03,-0.13l0.32,-0.1l0.2,-0.22l0.12,-0.55l0.39,-0.1l0.18,-0.13l0.3,-0.45l0.43,-0.0Z" data-code="SK" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M737.31,185.72l0.84,0.08l0.27,-0.12l0.89,-1.2l1.63,-0.13l1.1,-0.2l0.21,-0.16l0.12,-0.24l1.86,2.95l0.59,1.79l0.02,3.17l-0.84,1.38l-2.23,0.55l-1.95,1.14l-1.91,0.21l-0.22,-1.21l0.45,-2.07l-0.01,-0.17l-0.99,-2.67l1.54,-0.4l0.17,-0.46l-1.55,-2.24Z" data-code="KR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M455.77,159.59l1.79,0.21l0.18,-0.04l1.2,-0.68l2.12,-0.08l0.21,-0.1l0.38,-0.42l0.1,0.01l0.28,0.62l-1.71,0.71l-0.18,0.22l-0.21,1.1l-0.71,0.26l-0.2,0.28l0.01,0.55l-0.59,-0.04l-0.79,-0.47l-0.38,0.06l-0.36,0.41l-0.84,-0.05l0.05,-0.15l-0.56,-1.24l0.21,-1.17Z" data-code="SI" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M747.76,172.02l-0.23,-0.04l-0.26,0.08l-1.09,1.02l-0.78,1.06l-0.06,0.19l0.09,1.95l-1.12,0.57l-0.53,0.58l-0.88,0.82l-1.69,0.51l-1.09,0.79l-0.12,0.22l-0.07,1.17l-0.22,0.25l0.09,0.47l0.96,0.46l1.22,1.1l-0.19,0.37l-0.91,0.16l-1.75,0.14l-0.22,0.12l-0.87,1.18l-0.95,-0.09l-0.3,0.18l-0.97,-0.44l-0.39,0.13l-0.25,0.44l-0.29,0.09l-0.03,-0.2l-0.18,-0.23l-0.62,-0.25l-0.43,-0.29l0.52,-0.97l0.52,-0.3l0.13,-0.38l-0.18,-0.42l0.59,-1.47l0.01,-0.21l-0.16,-0.48l-0.22,-0.2l-1.41,-0.31l-0.82,-0.55l1.74,-1.62l2.73,-1.58l1.62,-1.96l0.96,0.76l0.17,0.06l2.17,0.11l0.31,-0.37l-0.32,-1.31l3.61,-1.21l0.16,-0.13l0.79,-1.34l1.25,1.38Z" data-code="KP" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M543.8,256.48l0.61,-0.05l1.14,-0.37l1.31,-0.25l0.12,-0.05l1.11,-0.81l0.57,-0.0l0.03,0.39l-0.23,1.49l0.01,1.25l-0.52,0.92l-0.7,2.71l-1.19,2.79l-1.54,3.2l-2.13,3.66l-2.12,2.79l-2.92,3.39l-2.47,2.0l-3.76,2.5l-2.33,1.9l-2.77,3.06l-0.61,1.35l-0.28,0.29l-1.22,-1.69l-0.03,-8.92l2.12,-2.76l0.59,-0.68l1.47,-0.04l0.18,-0.06l2.15,-1.71l3.16,-0.11l0.21,-0.09l7.08,-7.55l1.76,-2.12l1.14,-1.57l0.06,-0.18l0.01,-4.67Z" data-code="SO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M379.28,250.34l-0.95,-1.82l-0.09,-0.1l-0.83,-0.6l0.62,-0.28l0.13,-0.11l1.21,-1.8l0.6,-1.31l0.71,-0.68l1.09,0.2l0.18,-0.02l1.17,-0.53l1.25,-0.03l1.17,0.73l1.59,0.65l1.47,1.83l1.59,1.7l0.12,1.56l0.49,1.46l0.1,0.14l0.85,0.65l0.18,0.82l-0.08,0.57l-0.13,0.05l-1.29,-0.19l-0.29,0.13l-0.11,0.16l-0.35,0.04l-1.83,-0.61l-5.84,-0.13l-0.12,0.02l-0.6,0.26l-0.87,-0.06l-1.01,0.32l-0.26,-1.26l1.9,0.04l0.16,-0.04l0.54,-0.32l0.37,-0.02l0.15,-0.05l0.78,-0.5l0.92,0.46l0.12,0.03l1.09,0.04l0.15,-0.03l1.08,-0.57l0.11,-0.44l-0.51,-0.74l-0.39,-0.1l-0.76,0.39l-0.62,-0.01l-0.92,-0.58l-0.18,-0.05l-0.79,0.04l-0.2,0.09l-0.48,0.51l-2.41,0.06Z" data-code="SN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M392.19,267.53l-0.44,-0.12l-1.73,-0.97l-1.24,-1.28l-0.4,-0.84l-0.27,-1.65l1.21,-1.0l0.09,-0.12l0.27,-0.66l0.32,-0.41l0.56,-0.05l0.16,-0.07l0.5,-0.41l1.75,0.0l0.59,0.77l0.49,0.96l-0.07,0.64l0.04,0.19l0.36,0.58l-0.03,0.84l0.24,0.2l-0.64,0.65l-1.13,1.37l-0.06,0.14l-0.12,0.66l-0.43,0.58Z" data-code="SL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M826.74,311.51l0.23,0.29l-0.95,-0.01l-0.39,-0.63l0.65,0.27l0.45,0.09ZM825.01,308.52l-1.18,-1.39l-0.37,-1.06l0.24,0.0l0.82,1.84l0.49,0.6ZM823.21,309.42l-0.44,0.03l-1.43,-0.24l-0.32,-0.24l0.08,-0.5l1.29,0.31l0.72,0.47l0.11,0.18ZM817.9,303.81l2.59,1.44l0.3,0.41l-1.21,-0.66l-1.34,-0.89l-0.34,-0.3ZM813.77,302.4l0.48,0.34l0.1,0.08l-0.33,-0.17l-0.25,-0.25Z" data-code="SB" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M528.24,243.1l-0.2,-0.69l-0.07,-0.12l-0.69,-0.71l-0.18,-0.94l-0.12,-0.19l-1.24,-0.89l-1.28,-2.09l-0.7,-2.08l-0.07,-0.11l-1.73,-1.79l-0.11,-0.07l-1.03,-0.39l-1.57,-2.36l-0.27,-1.72l0.1,-1.53l-0.03,-0.15l-1.44,-2.93l-1.25,-1.13l-1.34,-0.56l-0.72,-1.33l0.11,-0.49l-0.02,-0.2l-0.7,-1.38l-0.08,-0.1l-0.68,-0.56l-0.97,-1.98l-2.8,-4.03l-0.25,-0.13l-0.85,0.01l0.29,-1.11l0.12,-0.97l0.23,-0.81l2.52,0.39l0.23,-0.06l1.08,-0.84l0.6,-0.95l1.78,-0.35l0.22,-0.17l0.37,-0.83l0.74,-0.42l0.08,-0.46l-2.17,-2.4l4.55,-1.26l0.12,-0.06l0.36,-0.32l2.83,0.71l3.67,1.91l7.04,5.5l0.17,0.06l4.64,0.22l2.06,0.24l0.55,1.15l0.28,0.17l1.56,-0.06l0.9,2.15l0.14,0.15l1.14,0.57l0.39,0.85l0.11,0.13l1.59,1.06l0.12,0.91l-0.23,0.83l0.01,0.18l0.32,0.9l0.07,0.11l0.68,0.7l0.33,0.86l0.37,0.65l0.09,0.1l0.76,0.53l0.25,0.04l0.45,-0.12l0.35,0.75l0.1,0.63l0.96,2.68l0.23,0.19l7.53,1.33l0.27,-0.09l0.24,-0.26l0.87,1.41l-1.58,4.96l-7.34,2.54l-7.28,1.02l-2.34,1.17l-0.12,0.1l-1.74,2.63l-0.86,0.32l-0.49,-0.68l-0.28,-0.12l-0.92,0.12l-2.32,-0.25l-0.41,-0.23l-0.15,-0.04l-2.89,0.06l-0.63,0.2l-0.91,-0.59l-0.43,0.11l-0.66,1.27l-0.03,0.21l0.21,0.89l-0.6,0.45Z" data-code="SA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M476.42,90.44l-0.15,0.1l-2.43,2.86l-0.07,0.24l0.36,2.31l-3.84,3.1l-4.83,3.38l-0.11,0.15l-1.82,5.45l0.03,0.26l1.78,2.68l2.27,1.99l-2.13,3.88l-2.49,0.82l-0.2,0.24l-0.95,6.05l-1.32,3.09l-2.82,-0.32l-0.3,0.16l-1.34,2.64l-2.48,0.14l-0.76,-3.15l-2.09,-4.04l-1.85,-5.01l1.03,-1.98l2.06,-2.53l0.06,-0.13l0.83,-4.45l-0.06,-0.25l-1.54,-1.86l-0.15,-5.0l1.52,-3.48l2.28,0.06l0.27,-0.16l0.87,-1.59l-0.01,-0.31l-0.8,-1.21l3.79,-5.63l4.07,-7.54l2.23,0.01l0.29,-0.22l0.59,-2.15l4.46,0.66l0.34,-0.26l0.34,-2.64l1.21,-0.14l3.24,2.08l3.78,2.85l0.06,6.37l0.03,0.14l0.67,1.29l-3.95,1.07Z" data-code="SE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M505.98,259.75l-0.31,-0.9l-0.1,-0.14l-1.2,-0.93l-0.27,-1.66l0.29,-1.83l-0.25,-0.34l-1.16,-0.17l-0.33,0.21l-0.11,0.37l-1.3,0.11l-0.21,0.49l0.55,0.68l0.18,1.29l-1.31,1.33l-1.18,1.72l-1.04,0.21l-2.0,-1.4l-0.32,-0.02l-0.95,0.52l-0.14,0.16l-0.21,0.6l-1.16,0.43l-0.19,0.23l-0.04,0.27l-2.08,0.0l-0.25,-0.39l-0.24,-0.13l-1.81,-0.09l-0.14,0.03l-0.8,0.38l-0.49,-0.16l-1.22,-1.39l-0.42,-0.67l-0.31,-0.14l-1.81,0.35l-0.2,0.14l-0.72,1.24l-0.61,2.14l-0.73,0.4l-0.62,0.22l-0.83,-0.68l-0.12,-0.6l0.38,-0.97l0.01,-1.14l-0.08,-0.2l-1.39,-1.53l-0.25,-0.97l0.03,-0.57l-0.11,-0.25l-0.81,-0.66l-0.03,-1.34l-0.04,-0.14l-0.52,-0.98l-0.31,-0.15l-0.42,0.07l0.12,-0.44l0.63,-1.03l0.03,-0.23l-0.24,-0.88l0.69,-0.66l0.02,-0.41l-0.4,-0.46l0.58,-1.39l1.04,-1.71l1.97,0.16l0.32,-0.3l-0.12,-10.24l0.02,-0.8l2.59,-0.01l0.3,-0.3l0.0,-4.92l29.19,0.0l0.68,2.17l-0.4,0.35l-0.1,0.27l0.36,2.69l0.93,3.15l0.12,0.16l2.05,1.4l-0.99,1.15l-1.75,0.4l-0.15,0.08l-0.79,0.79l-0.08,0.17l-0.24,1.69l-1.07,3.75l-0.0,0.16l0.25,0.96l-0.38,2.1l-0.98,2.41l-1.52,1.3l-1.07,1.94l-0.25,0.99l-1.08,0.64l-0.13,0.18l-0.46,1.65Z" data-code="SD" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M241.7,234.97l0.15,-0.22l1.73,0.01l1.43,0.64l0.15,0.03l0.45,-0.04l0.36,0.74l0.28,0.17l1.02,-0.04l-0.04,0.43l0.27,0.33l1.03,0.09l0.91,0.7l-0.57,0.64l-0.99,-0.47l-0.16,-0.03l-1.11,0.11l-0.79,-0.12l-0.26,0.09l-0.38,0.4l-0.66,0.11l-0.28,-0.45l-0.38,-0.12l-0.83,0.37l-0.14,0.13l-0.85,1.49l-0.27,-0.17l-0.1,-0.58l0.05,-0.67l-0.07,-0.21l-0.44,-0.53l0.35,-0.25l0.12,-0.19l0.19,-1.0l-0.2,-1.4Z" data-code="DO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M528.78,253.36l0.34,0.45l-0.06,0.76l-1.26,0.54l-0.05,0.53l0.82,0.53l-0.57,0.83l-0.3,-0.25l-0.27,-0.05l-0.56,0.17l-1.07,-0.03l-0.04,-0.56l-0.16,-0.56l0.76,-1.07l0.76,-0.97l0.89,0.18l0.25,-0.06l0.51,-0.42Z" data-code="DJ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M452.4,129.07l-1.27,2.39l-2.25,-1.69l-0.26,-1.08l3.15,-1.0l0.63,1.39ZM447.87,126.25l-0.35,0.76l-0.47,-0.24l-0.38,0.09l-1.8,2.53l-0.03,0.29l0.56,1.4l-1.22,0.4l-1.68,-0.41l-0.92,-1.76l-0.07,-3.47l0.38,-0.88l0.62,-0.93l2.07,-0.21l0.19,-0.1l0.84,-0.95l1.5,-0.76l-0.06,1.26l-0.7,1.1l-0.03,0.25l0.3,1.0l0.18,0.19l1.06,0.42Z" data-code="DK" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M445.51,131.69l0.03,0.94l0.21,0.28l2.32,0.74l-0.02,1.0l0.37,0.3l2.55,-0.65l1.36,-0.89l2.63,1.27l1.09,1.01l0.51,1.51l-0.6,0.78l-0.0,0.36l0.88,1.17l0.58,1.68l-0.18,1.08l0.03,0.18l0.87,1.81l-0.66,0.2l-0.55,-0.32l-0.36,0.05l-0.58,0.58l-1.73,0.62l-0.99,0.84l-1.77,0.7l-0.16,0.4l0.42,0.94l0.26,1.34l0.14,0.2l1.25,0.76l1.22,1.2l-0.71,1.2l-0.81,0.37l-0.17,0.32l0.34,1.99l-0.04,0.09l-0.47,-0.39l-0.17,-0.07l-1.2,-0.1l-1.85,0.57l-2.15,-0.13l-0.29,0.18l-0.21,0.5l-0.96,-0.67l-0.24,-0.05l-0.67,0.16l-2.6,-0.94l-0.34,0.1l-0.42,0.57l-1.64,-0.02l0.26,-1.88l1.24,-2.15l-0.21,-0.45l-3.54,-0.58l-0.98,-0.71l0.12,-1.26l-0.05,-0.2l-0.44,-0.64l0.27,-2.18l-0.38,-3.14l1.17,-0.0l0.27,-0.17l0.63,-1.26l0.65,-3.17l-0.02,-0.17l-0.41,-1.0l0.32,-0.47l1.77,-0.16l0.37,0.6l0.47,0.06l1.7,-1.69l0.06,-0.33l-0.55,-1.24l-0.09,-1.51l1.5,0.36l0.16,-0.01l1.22,-0.4Z" data-code="DE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M553.53,242.65l-1.51,0.58l-0.17,0.16l-0.48,1.14l-0.07,0.79l-2.31,1.0l-3.98,1.19l-2.28,1.8l-0.97,0.12l-0.7,-0.14l-0.23,0.05l-1.42,1.03l-1.51,0.47l-2.07,0.13l-0.68,0.15l-0.17,0.1l-0.49,0.6l-0.57,0.16l-0.18,0.13l-0.3,0.49l-1.06,-0.05l-0.13,0.02l-0.73,0.32l-1.48,-0.11l-0.55,-1.26l0.07,-1.32l-0.04,-0.16l-0.39,-0.72l-0.48,-1.85l-0.52,-0.79l0.08,-0.02l0.22,-0.36l-0.23,-1.05l0.24,-0.39l0.04,-0.19l-0.09,-0.95l0.96,-0.72l0.11,-0.31l-0.23,-0.98l0.46,-0.88l0.75,0.49l0.26,0.03l0.63,-0.22l2.76,-0.06l0.5,0.25l2.42,0.26l0.85,-0.11l0.52,0.71l0.35,0.1l1.17,-0.43l0.15,-0.12l1.75,-2.64l2.22,-1.11l6.95,-0.96l2.55,5.58Z" data-code="YE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M463.17,154.15l-0.14,0.99l-1.15,0.01l-0.24,0.47l0.39,0.56l-0.75,1.84l-0.36,0.4l-2.06,0.07l-0.14,0.04l-1.18,0.67l-1.96,-0.23l-3.43,-0.78l-0.5,-0.97l-0.33,-0.16l-2.47,0.55l-0.2,0.16l-0.18,0.37l-1.27,-0.38l-1.28,-0.09l-0.81,-0.41l0.25,-0.51l0.03,-0.18l-0.05,-0.28l0.35,-0.08l1.16,0.81l0.45,-0.13l0.27,-0.64l2.0,0.12l1.84,-0.57l1.05,0.09l0.71,0.59l0.47,-0.11l0.23,-0.54l0.02,-0.17l-0.32,-1.85l0.69,-0.31l0.13,-0.12l0.73,-1.23l1.61,0.89l0.35,-0.04l1.35,-1.27l0.7,-0.19l1.84,0.93l0.18,0.03l1.08,-0.15l0.81,0.43l-0.07,0.15l-0.02,0.2l0.24,1.06Z" data-code="AT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M450.58,224.94l-8.31,4.86l-7.23,5.12l-3.46,1.13l-2.42,0.22l-0.02,-1.33l-0.2,-0.28l-1.15,-0.42l-1.45,-0.69l-0.55,-1.13l-0.1,-0.12l-8.45,-5.72l-17.72,-12.17l0.03,-0.38l-0.02,-3.21l3.84,-1.91l2.46,-0.41l2.1,-0.75l0.14,-0.11l0.9,-1.3l2.84,-1.06l0.19,-0.27l0.09,-1.81l1.21,-0.2l0.15,-0.07l1.06,-0.96l3.19,-0.46l0.23,-0.18l0.46,-1.08l-0.08,-0.34l-0.6,-0.54l-0.83,-2.85l-0.18,-1.8l-0.82,-1.57l2.13,-1.37l2.65,-0.49l0.13,-0.05l1.55,-1.15l2.34,-0.85l4.2,-0.51l4.07,-0.23l1.21,0.41l0.23,-0.01l2.3,-1.11l2.52,-0.02l0.94,0.62l0.2,0.05l1.25,-0.13l-0.36,1.03l-0.01,0.14l0.39,2.66l-0.56,2.2l-1.49,1.52l-0.08,0.24l0.22,2.12l0.11,0.2l1.94,1.58l0.02,0.54l0.12,0.23l1.45,1.06l1.04,4.85l0.81,2.42l0.13,1.19l-0.43,2.17l0.17,1.28l-0.31,1.53l0.2,1.56l-0.9,1.02l-0.01,0.38l1.43,1.88l0.09,1.06l0.04,0.13l0.89,1.48l0.37,0.12l1.03,-0.43l1.79,1.12l0.89,1.34Z" data-code="DZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M892.64,99.05l1.16,0.57l0.21,0.02l1.45,-0.38l1.92,0.99l2.17,0.47l-1.65,0.72l-1.75,-0.79l-0.93,-0.7l-0.21,-0.06l-2.11,0.22l-0.35,-0.2l0.09,-0.87ZM183.29,150.37l0.39,1.54l0.12,0.17l0.78,0.55l0.14,0.05l1.74,0.2l2.52,0.5l2.4,0.98l0.17,0.02l1.96,-0.4l3.01,0.81l0.91,-0.02l2.22,-0.88l4.67,2.33l3.86,2.01l0.21,0.71l0.15,0.18l0.33,0.17l-0.02,0.05l0.23,0.43l0.67,0.1l0.21,-0.05l0.1,-0.07l0.05,0.29l0.09,0.16l0.5,0.5l0.21,0.09l0.56,0.0l0.13,0.13l-0.2,0.36l0.12,0.41l2.49,1.39l0.99,5.24l-0.69,1.68l-1.16,1.64l-0.6,1.18l-0.06,0.31l0.04,0.22l0.28,0.43l0.11,0.1l0.85,0.47l0.15,0.04l0.63,0.0l0.14,-0.04l2.87,-1.58l2.6,-0.49l3.28,-1.5l0.17,-0.23l0.04,-0.43l-0.23,-0.93l-0.24,-0.39l0.74,-0.32l4.7,-0.01l0.25,-0.13l0.77,-1.15l2.9,-2.41l1.04,-0.52l8.35,-0.02l0.28,-0.21l0.2,-0.6l0.7,-0.14l1.06,-0.48l0.13,-0.11l0.92,-1.49l0.75,-2.39l1.67,-2.08l0.59,0.6l0.3,0.07l1.52,-0.49l0.88,0.72l-0.0,4.14l0.08,0.2l1.6,1.72l0.31,0.72l-2.42,1.35l-2.55,1.05l-2.64,0.9l-0.14,0.11l-1.33,1.81l-0.44,0.7l-0.05,0.15l-0.03,1.6l0.03,0.14l0.83,1.59l0.24,0.16l0.78,0.06l-1.15,0.33l-1.25,-0.04l-1.83,0.52l-2.51,0.29l-2.17,0.88l-0.17,0.36l0.33,0.22l3.55,-0.54l0.15,0.11l-2.87,0.73l-1.19,0.0l-0.16,-0.33l-0.36,0.06l-0.76,0.82l0.17,0.5l0.42,0.08l-0.45,1.75l-1.4,1.74l-0.04,-0.17l-0.21,-0.22l-0.48,-0.13l-0.77,-0.69l-0.36,-0.03l-0.12,0.34l0.52,1.58l0.09,0.14l0.52,0.43l0.03,0.87l-0.74,1.05l-0.39,0.63l0.05,-0.12l-0.08,-0.34l-1.19,-1.03l-0.28,-2.31l-0.26,-0.26l-0.32,0.19l-0.48,1.27l-0.01,0.19l0.39,1.33l-1.14,-0.31l-0.36,0.18l0.14,0.38l1.57,0.85l0.1,2.58l0.22,0.28l0.55,0.15l0.21,0.81l0.33,2.72l-1.46,1.94l-2.5,0.81l-0.12,0.07l-1.58,1.58l-1.15,0.17l-0.15,0.06l-1.27,1.03l-0.09,0.13l-0.32,0.85l-2.71,1.79l-1.45,1.37l-1.18,1.64l-0.05,0.12l-0.39,1.96l0.0,0.13l0.44,1.91l0.85,2.37l1.1,1.91l0.03,1.2l1.16,3.07l-0.08,1.74l-0.1,0.99l-0.57,1.48l-0.54,0.24l-0.97,-0.26l-0.34,-1.02l-0.12,-0.16l-0.89,-0.58l-2.44,-4.28l-0.34,-0.94l0.49,-1.71l-0.02,-0.21l-0.7,-1.5l-2.0,-2.35l-0.11,-0.08l-0.98,-0.42l-0.25,0.01l-2.42,1.19l-0.26,-0.08l-1.26,-1.29l-1.57,-0.68l-0.16,-0.02l-2.79,0.34l-2.18,-0.3l-1.98,0.19l-1.12,0.45l-0.14,0.44l0.4,0.65l-0.04,1.02l0.09,0.22l0.29,0.3l-0.06,0.05l-0.77,-0.33l-0.26,0.01l-0.87,0.48l-1.64,-0.08l-1.79,-1.39l-0.23,-0.06l-2.11,0.33l-1.75,-0.61l-0.14,-0.01l-1.61,0.2l-2.11,0.64l-0.11,0.06l-2.25,1.99l-2.53,1.21l-1.43,1.38l-0.58,1.22l-0.03,0.12l-0.03,1.86l0.13,1.32l0.3,0.62l-0.46,0.04l-1.71,-0.57l-1.85,-0.79l-0.63,-1.14l-0.54,-1.85l-0.07,-0.12l-1.45,-1.51l-0.86,-1.58l-1.26,-1.87l-0.09,-0.09l-1.76,-1.09l-0.17,-0.04l-2.05,0.05l-0.23,0.12l-1.44,1.97l-1.84,-0.72l-1.19,-0.76l-0.6,-1.45l-0.9,-1.52l-1.49,-1.21l-1.27,-0.87l-0.89,-0.96l-0.22,-0.1l-4.34,-0.0l-0.3,0.3l-0.0,0.84l-6.62,0.02l-5.66,-1.93l-3.48,-1.24l0.11,-0.25l-0.3,-0.42l-3.18,0.3l-2.6,0.2l-0.35,-1.19l-0.08,-0.13l-1.62,-1.61l-0.13,-0.08l-1.02,-0.29l-0.22,-0.66l-0.25,-0.2l-1.31,-0.13l-0.82,-0.7l-0.16,-0.07l-2.25,-0.27l-0.48,-0.34l-0.28,-1.44l-0.07,-0.14l-2.41,-2.84l-2.03,-3.89l0.08,-0.58l-0.1,-0.27l-1.08,-0.94l-1.87,-2.36l-0.33,-2.31l-0.07,-0.15l-1.24,-1.5l0.52,-2.4l-0.09,-2.57l-0.78,-2.3l0.96,-2.83l0.61,-5.66l-0.46,-4.26l-0.79,-2.71l-0.68,-1.4l0.13,-0.26l3.24,0.97l1.28,2.88l0.52,0.06l0.62,-0.84l0.06,-0.22l-0.4,-2.61l-0.74,-2.29l68.9,-0.0l0.3,-0.3l0.01,-0.95l0.32,-0.01ZM32.5,67.43l1.75,1.99l0.41,0.04l1.02,-0.81l3.79,0.25l-0.1,0.72l0.24,0.34l3.83,0.77l2.6,-0.44l5.21,1.41l4.84,0.43l1.9,0.57l0.15,0.01l3.25,-0.71l3.72,1.32l2.52,0.58l-0.03,38.14l0.29,0.3l2.41,0.11l2.34,1.0l1.7,1.59l2.22,2.42l0.42,0.03l2.41,-2.04l2.25,-1.08l1.23,1.76l1.71,1.53l2.24,1.62l1.54,2.56l2.56,4.09l0.11,0.11l4.1,2.17l0.06,1.93l-1.12,1.35l-1.22,-1.14l-2.08,-1.05l-0.68,-2.94l-0.09,-0.16l-3.18,-2.84l-1.32,-3.35l-0.25,-0.19l-2.43,-0.24l-3.93,-0.09l-2.85,-1.02l-5.24,-3.85l-6.77,-2.04l-3.52,0.3l-4.84,-1.7l-2.96,-1.6l-0.23,-0.02l-2.78,0.8l-0.21,0.35l0.46,2.31l-1.11,0.19l-2.9,0.78l-2.24,1.26l-2.42,0.68l-0.29,-1.79l1.07,-3.49l2.54,-1.11l0.12,-0.45l-0.69,-0.96l-0.41,-0.07l-3.19,2.12l-1.76,2.54l-3.57,2.62l-0.03,0.46l1.63,1.59l-2.14,2.38l-2.64,1.49l-2.49,1.09l-0.16,0.17l-0.58,1.48l-3.8,1.79l-0.14,0.14l-0.75,1.57l-2.75,1.41l-1.62,-0.25l-0.16,0.02l-2.35,0.98l-2.54,1.19l-2.06,1.15l-4.05,0.93l-0.1,-0.15l2.45,-1.45l2.49,-1.1l2.61,-1.88l3.03,-0.39l0.19,-0.1l1.2,-1.41l3.43,-2.11l0.61,-0.75l1.81,-1.24l0.13,-0.2l0.42,-2.7l1.24,-2.12l-0.03,-0.35l-0.34,-0.09l-2.73,1.05l-0.67,-0.53l-0.39,0.02l-1.13,1.11l-1.43,-1.62l-0.49,0.06l-0.41,0.8l-0.67,-1.31l-0.42,-0.12l-2.43,1.43l-1.18,-0.0l-0.18,-1.86l0.43,-1.3l-0.09,-0.33l-1.61,-1.33l-0.26,-0.06l-3.11,0.68l-2.0,-1.66l-1.61,-0.85l-0.01,-1.97l-0.11,-0.23l-1.76,-1.48l0.86,-1.96l2.01,-2.13l0.88,-1.94l1.79,-0.25l1.65,0.6l0.31,-0.06l1.91,-1.8l1.67,0.31l0.22,-0.04l1.91,-1.23l0.13,-0.33l-0.47,-1.82l-0.15,-0.19l-1.0,-0.52l1.51,-1.27l0.09,-0.34l-0.29,-0.19l-1.62,0.06l-2.66,0.88l-0.13,0.09l-0.62,0.72l-1.77,-0.8l-0.16,-0.02l-3.48,0.44l-3.5,-0.92l-1.06,-1.61l-2.78,-2.09l3.07,-1.51l5.52,-2.01l1.65,0.0l-0.28,1.73l0.31,0.35l5.29,-0.16l0.23,-0.49l-2.03,-2.59l-0.1,-0.08l-3.03,-1.58l-1.79,-2.12l-2.4,-1.83l-3.18,-1.27l1.13,-1.84l4.28,-0.14l0.15,-0.05l3.16,-2.0l0.13,-0.17l0.57,-2.07l2.43,-2.02l2.42,-0.52l4.67,-1.98l2.22,0.29l0.2,-0.04l3.74,-2.37l3.57,0.91ZM37.66,123.49l-2.31,1.26l-1.04,-0.75l-0.31,-1.35l2.06,-1.16l1.24,-0.51l1.48,0.22l0.76,0.81l-1.89,1.49ZM30.89,233.84l1.2,0.57l0.35,0.3l0.48,0.69l-1.6,0.86l-0.3,0.31l-0.24,-0.14l0.05,-0.54l-0.02,-0.15l-0.36,-0.83l0.05,-0.12l0.39,-0.38l0.07,-0.31l-0.09,-0.27ZM29.06,231.89l0.5,0.14l0.31,0.19l-0.46,0.1l-0.34,-0.43ZM25.02,230.13l0.2,-0.11l0.4,0.47l-0.43,-0.05l-0.17,-0.31ZM21.29,228.68l0.1,-0.07l0.22,0.02l0.02,0.21l-0.02,0.02l-0.32,-0.18ZM6.0,113.33l-1.19,0.45l-1.5,-0.64l-0.94,-0.63l1.76,-0.46l1.71,0.29l0.16,0.98Z" data-code="US" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M473.99,127.16l0.07,-2.15l1.15,-2.11l2.05,-1.07l1.84,2.48l0.25,0.12l2.01,-0.07l0.29,-0.25l0.45,-2.58l1.85,-0.56l0.98,0.4l2.13,1.33l0.16,0.05l1.97,0.01l1.02,0.7l0.21,1.67l0.71,1.84l-2.44,1.23l-1.36,0.53l-2.28,-1.62l-0.12,-0.05l-1.18,-0.2l-0.28,-0.6l-0.31,-0.17l-2.43,0.35l-4.17,-0.23l-0.12,0.02l-2.45,0.93Z" data-code="LV" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M276.9,363.17l1.3,-0.23l2.4,2.04l0.22,0.07l0.82,-0.07l2.48,1.7l1.93,1.5l1.28,1.67l-0.95,1.14l-0.04,0.31l0.63,1.45l-0.96,1.57l-2.65,1.47l-1.73,-0.53l-0.15,-0.01l-1.25,0.28l-2.22,-1.16l-0.16,-0.03l-1.56,0.08l-1.33,-1.36l0.17,-1.58l0.48,-0.55l0.07,-0.2l-0.02,-2.74l0.66,-2.8l0.57,-2.02Z" data-code="UY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M510.44,198.11l-0.48,0.03l-0.26,0.17l-0.15,0.32l-0.21,-0.0l0.72,-1.85l1.19,-1.9l0.74,0.09l0.27,0.73l-1.19,0.93l-0.09,0.13l-0.54,1.36Z" data-code="LB" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M684.87,248.8l0.61,-0.86l0.05,-0.16l0.11,-2.17l-0.08,-0.22l-1.96,-2.16l-0.15,-2.44l-0.08,-0.18l-1.9,-2.1l-0.19,-0.1l-1.89,-0.18l-0.29,0.15l-0.42,0.76l-1.21,0.06l-0.67,-0.41l-0.31,-0.0l-2.2,1.29l-0.05,-1.77l0.61,-2.7l-0.27,-0.37l-1.44,-0.1l-0.12,-1.31l-0.12,-0.21l-0.87,-0.65l0.38,-0.68l1.76,-1.41l0.08,0.22l0.27,0.2l1.33,0.07l0.31,-0.34l-0.35,-2.75l0.85,-0.25l1.32,1.88l1.11,2.36l0.27,0.17l2.89,0.02l0.78,1.82l-1.32,0.56l-0.12,0.09l-0.72,0.93l0.1,0.45l2.93,1.52l3.62,5.27l1.88,1.78l0.58,1.67l-0.38,2.11l-1.87,-0.79l-0.37,0.11l-0.99,1.54l-1.51,-0.73Z" data-code="LA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M725.6,222.5l-1.5,4.22l-0.82,1.65l-1.01,-1.7l-0.26,-1.8l1.4,-2.48l1.8,-1.81l0.76,0.53l-0.38,1.39Z" data-code="TW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M266.35,259.46l0.41,-0.39l0.09,-0.23l-0.04,-0.75l1.14,-0.26l0.2,0.03l-0.07,1.37l-1.73,0.23Z" data-code="TT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M513.25,175.38l3.63,1.17l0.14,0.01l2.88,-0.45l2.11,0.26l0.18,-0.03l2.9,-1.53l2.51,-0.13l2.25,1.37l0.36,0.88l-0.23,1.36l0.19,0.33l1.81,0.72l0.61,0.53l-1.31,0.64l-0.16,0.34l0.76,3.24l-0.44,0.8l0.01,0.3l1.19,2.02l-0.71,0.29l-0.74,-0.62l-0.15,-0.07l-2.91,-0.37l-0.15,0.02l-1.04,0.43l-2.78,0.44l-1.44,-0.03l-2.83,1.06l-1.95,0.01l-1.28,-0.52l-0.2,-0.01l-2.62,0.76l-0.7,-0.48l-0.47,0.22l-0.13,1.49l-1.01,0.94l-0.58,-0.82l0.79,-0.9l0.04,-0.34l-0.31,-0.15l-1.46,0.23l-2.03,-0.64l-0.3,0.07l-1.65,1.58l-3.58,0.3l-1.94,-1.47l-0.17,-0.06l-2.7,-0.1l-0.28,0.17l-0.51,1.06l-1.47,0.29l-2.32,-1.46l-0.17,-0.05l-2.55,0.05l-1.4,-2.7l-1.72,-1.54l1.11,-2.06l-0.07,-0.37l-1.35,-1.19l2.47,-2.51l3.74,-0.11l0.26,-0.17l0.96,-2.07l4.56,0.38l0.19,-0.05l2.97,-1.92l2.84,-0.83l4.03,-0.06l4.31,2.08ZM488.85,176.8l-1.81,1.38l-0.57,-1.01l0.02,-0.36l0.45,-0.25l0.13,-0.15l0.78,-1.87l-0.11,-0.37l-0.72,-0.47l1.91,-0.71l1.89,0.35l0.25,0.97l0.17,0.2l1.87,0.83l-0.19,0.31l-2.82,0.16l-0.18,0.07l-1.06,0.91Z" data-code="TR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M625.44,266.07l-0.35,2.4l-0.9,0.61l-1.91,0.5l-1.04,-1.75l-0.43,-3.5l1.0,-3.6l1.34,1.09l1.13,1.72l1.16,2.52Z" data-code="LK" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M444.91,206.18l-0.99,-4.57l-0.12,-0.18l-1.43,-1.04l-0.02,-0.53l-0.11,-0.22l-1.95,-1.59l-0.19,-1.85l1.44,-1.47l0.08,-0.14l0.59,-2.34l-0.38,-2.77l0.44,-1.28l2.52,-1.08l1.41,0.28l-0.06,1.2l0.43,0.28l1.81,-0.9l0.02,0.06l-1.14,1.28l-0.08,0.2l-0.02,1.32l0.11,0.24l0.74,0.6l-0.29,2.18l-1.56,1.35l-0.09,0.32l0.48,1.54l0.28,0.21l1.11,0.04l0.55,1.17l0.15,0.14l0.76,0.35l-0.12,1.79l-1.1,0.72l-0.8,0.91l-1.68,1.04l-0.13,0.32l0.25,1.08l-0.18,0.96l-0.74,0.39Z" data-code="TN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M734.21,307.22l0.17,-0.34l1.99,-0.52l1.72,-0.08l0.78,-0.3l0.29,0.1l-0.43,0.32l-2.57,1.09l-1.71,0.59l-0.05,-0.49l-0.19,-0.36Z" data-code="TL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M553.16,173.51l-0.12,1.0l-0.26,-0.65l0.38,-0.34ZM553.54,173.16l0.13,-0.12l0.43,-0.09l-0.56,0.21ZM555.68,172.6l0.65,-0.14l1.53,0.76l1.71,2.29l0.27,0.12l1.27,-0.14l2.81,-0.04l0.29,-0.38l-0.35,-1.27l1.98,-0.97l1.96,-1.63l3.05,1.44l0.25,2.23l0.14,0.22l0.96,0.61l0.18,0.05l2.61,-0.13l0.68,0.44l1.2,2.97l0.1,0.13l2.85,2.03l1.67,1.41l2.66,1.45l3.13,1.17l-0.05,1.23l-0.36,-0.04l-1.12,-0.73l-0.44,0.14l-0.34,0.89l-1.96,0.52l-0.22,0.23l-0.47,2.17l-1.26,0.78l-1.93,0.42l-0.21,0.18l-0.46,1.14l-1.64,0.33l-2.3,-0.97l-0.2,-2.23l-0.28,-0.27l-1.76,-0.1l-2.78,-2.48l-0.15,-0.07l-1.95,-0.31l-2.82,-1.48l-1.78,-0.27l-0.18,0.03l-1.03,0.51l-1.6,-0.08l-0.22,0.08l-1.72,1.6l-1.83,0.46l-0.39,-1.7l0.36,-3.0l-0.16,-0.3l-1.73,-0.88l0.57,-1.77l-0.25,-0.39l-1.33,-0.14l0.41,-1.85l2.05,0.63l0.21,-0.01l2.2,-0.95l0.09,-0.49l-1.78,-1.75l-0.69,-1.66l-0.07,-0.03Z" data-code="TM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M597.99,178.71l-0.23,0.23l-2.57,-0.47l-0.35,0.25l-0.24,1.7l0.32,0.34l2.66,-0.22l3.15,0.95l4.47,-0.42l0.58,2.45l0.39,0.21l0.71,-0.25l1.22,0.53l-0.06,1.01l0.29,1.28l-2.19,-0.0l-1.71,-0.21l-0.23,0.07l-1.51,1.25l-1.05,0.27l-0.77,0.51l-0.71,-0.67l0.22,-2.28l-0.24,-0.32l-0.43,-0.08l0.17,-0.57l-0.16,-0.36l-1.36,-0.66l-0.34,0.05l-1.08,1.01l-0.09,0.15l-0.25,1.09l-0.24,0.26l-1.36,-0.05l-0.27,0.14l-0.65,1.06l-0.58,-0.39l-0.3,-0.02l-1.68,0.86l-0.36,-0.16l1.28,-2.65l0.02,-0.2l-0.54,-2.17l-0.18,-0.21l-1.53,-0.58l0.41,-0.82l1.89,0.13l0.26,-0.12l1.19,-1.63l0.77,-1.82l2.66,-0.55l-0.33,0.87l0.01,0.23l0.36,0.82l0.3,0.18l0.23,-0.02Z" data-code="TJ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M493.32,359.69l0.69,0.65l-0.65,1.12l-0.38,0.8l-1.27,0.39l-0.18,0.15l-0.4,0.77l-0.59,0.18l-1.59,-1.78l1.16,-1.5l1.3,-1.02l0.97,-0.46l0.94,0.72Z" data-code="LS" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M677.42,253.68l-1.7,-0.88l-0.14,-0.03l-1.77,0.04l0.3,-1.64l-0.3,-0.35l-2.21,0.01l-0.3,0.28l-0.2,2.76l-2.15,5.9l-0.02,0.13l0.17,1.83l0.28,0.27l1.45,0.07l0.93,2.1l0.44,2.15l0.08,0.15l1.4,1.44l0.16,0.09l1.43,0.27l1.04,1.05l-0.58,0.73l-1.24,0.22l-0.15,-0.99l-0.15,-0.22l-2.04,-1.1l-0.36,0.06l-0.23,0.23l-0.72,-0.71l-0.41,-1.18l-0.06,-0.11l-1.33,-1.42l-1.22,-1.2l-0.5,0.13l-0.15,0.54l-0.14,-0.41l0.26,-1.48l0.73,-2.38l1.2,-2.57l1.37,-2.35l0.02,-0.27l-0.95,-2.26l0.03,-1.19l-0.29,-1.42l-0.06,-0.13l-1.65,-2.0l-0.46,-0.99l0.62,-0.34l0.13,-0.15l0.92,-2.23l-0.02,-0.27l-1.05,-1.74l-1.57,-1.86l-1.04,-1.96l0.76,-0.34l0.16,-0.16l1.07,-2.63l1.58,-0.1l0.16,-0.06l1.43,-1.11l1.24,-0.52l0.84,0.62l0.13,1.43l0.28,0.27l1.34,0.09l-0.54,2.39l0.05,2.39l0.45,0.25l2.48,-1.45l0.6,0.36l0.17,0.04l1.47,-0.07l0.25,-0.15l0.41,-0.73l1.58,0.15l1.76,1.93l0.15,2.44l0.08,0.18l1.94,2.15l-0.1,1.96l-0.66,0.93l-2.25,-0.34l-3.24,0.49l-0.19,0.12l-1.6,2.12l-0.06,0.24l0.48,2.46Z" data-code="TH" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M593.76,417.73l1.38,0.84l2.15,0.37l0.04,0.31l-0.59,1.24l-3.36,0.19l-0.05,-1.38l0.43,-1.56Z" data-code="TF" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M425.23,269.29l-1.49,0.4l-0.43,-0.68l-0.64,-1.54l-0.18,-1.16l0.54,-2.21l-0.04,-0.24l-0.59,-0.86l-0.23,-1.9l0.0,-1.82l-0.07,-0.19l-0.95,-1.19l0.1,-0.41l1.58,0.04l-0.23,0.97l0.08,0.28l1.55,1.55l0.09,1.13l0.08,0.19l0.42,0.43l-0.11,5.66l0.52,1.53Z" data-code="TG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M457.57,252.46l0.23,-1.08l-0.28,-0.36l-1.32,-0.05l0.0,-1.35l-0.1,-0.22l-0.9,-0.82l0.99,-3.1l3.12,-2.37l0.12,-0.23l0.13,-3.33l0.95,-5.2l0.53,-1.09l-0.07,-0.36l-0.94,-0.81l-0.03,-0.7l-0.12,-0.23l-0.84,-0.61l-0.57,-3.76l2.21,-1.26l19.67,9.88l0.12,9.74l-1.83,-0.15l-0.28,0.14l-1.14,1.89l-0.68,1.62l0.05,0.31l0.33,0.38l-0.61,0.58l-0.08,0.3l0.25,0.93l-0.58,0.95l-0.29,1.01l0.34,0.37l0.67,-0.11l0.39,0.73l0.03,1.4l0.11,0.23l0.8,0.65l-0.01,0.24l-1.38,0.37l-0.11,0.06l-1.27,1.03l-1.83,2.76l-2.21,1.1l-2.34,-0.15l-0.82,0.25l-0.2,0.37l0.19,0.68l-1.16,0.79l-1.01,0.94l-2.92,0.89l-0.5,-0.46l-0.17,-0.08l-0.41,-0.05l-0.28,0.12l-0.38,0.54l-1.36,0.12l0.1,-0.18l0.01,-0.27l-0.78,-1.72l-0.35,-1.03l-0.17,-0.18l-1.03,-0.41l-1.29,-1.28l0.36,-0.78l0.9,0.2l0.14,-0.0l0.67,-0.17l1.36,0.02l0.26,-0.45l-1.32,-2.22l0.09,-1.64l-0.17,-1.68l-0.04,-0.13l-0.93,-1.53Z" data-code="TD" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M457.99,226.38l-1.57,0.87l-1.25,-1.28l-0.13,-0.08l-3.85,-1.11l-1.04,-1.57l-0.09,-0.09l-1.98,-1.23l-0.27,-0.02l-0.93,0.39l-0.72,-1.2l-0.09,-1.07l-0.06,-0.16l-1.33,-1.75l0.83,-0.94l0.07,-0.24l-0.21,-1.64l0.31,-1.43l-0.17,-1.29l0.43,-2.26l-0.15,-1.33l-0.73,-2.18l0.99,-0.52l0.16,-0.21l0.22,-1.16l-0.22,-1.06l1.54,-0.95l0.81,-0.92l1.19,-0.78l0.14,-0.23l0.12,-1.76l2.57,0.84l0.16,0.01l0.99,-0.23l2.01,0.45l3.19,1.2l1.12,2.36l0.2,0.16l2.24,0.53l3.5,1.14l2.65,1.36l0.29,-0.01l1.22,-0.71l1.27,-1.32l0.07,-0.29l-0.55,-2.0l0.69,-1.19l1.7,-1.23l1.61,-0.35l3.2,0.54l0.78,1.14l0.24,0.13l0.85,0.01l0.84,0.47l2.35,0.31l0.42,0.63l-0.79,1.16l-0.04,0.26l0.35,1.08l-0.61,1.6l-0.0,0.2l0.73,2.16l0.0,24.24l-2.58,0.01l-0.3,0.29l-0.02,0.62l-19.55,-9.83l-0.28,0.01l-2.53,1.44Z" data-code="LY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M550.59,223.8l0.12,0.08l1.92,-0.41l3.54,0.15l0.23,-0.09l1.71,-1.79l1.86,-1.7l1.31,-1.36l0.26,0.5l0.28,1.72l-0.93,0.01l-0.3,0.26l-0.21,1.73l0.11,0.27l0.08,0.06l-0.7,0.32l-0.17,0.27l-0.01,0.99l-0.68,1.02l-0.05,0.15l-0.06,0.96l-0.32,0.36l-7.19,-1.27l-0.79,-2.22Z" data-code="AE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M240.66,256.5l0.65,0.91l-0.03,1.13l-1.05,1.39l-0.03,0.31l0.95,2.0l0.32,0.17l1.08,-0.16l0.24,-0.21l0.56,-1.83l-0.06,-0.29l-0.71,-0.81l-0.1,-1.58l2.9,-0.96l0.19,-0.37l-0.29,-1.02l0.45,-0.41l0.72,1.43l0.26,0.16l1.65,0.04l1.46,1.27l0.08,0.72l0.3,0.27l2.28,0.02l2.55,-0.25l1.34,1.06l0.14,0.06l1.92,0.31l0.2,-0.03l1.4,-0.79l0.15,-0.25l0.02,-0.36l2.82,-0.14l1.17,-0.01l-0.41,0.14l-0.14,0.46l0.86,1.19l0.22,0.12l1.93,0.18l1.73,1.13l0.37,1.9l0.31,0.24l1.21,-0.05l0.52,0.32l-1.63,1.21l-0.11,0.17l-0.22,0.92l0.07,0.27l0.63,0.69l-0.31,0.24l-1.48,0.39l-0.22,0.3l0.04,1.03l-0.59,0.6l-0.01,0.41l1.67,1.87l0.23,0.48l-0.72,0.76l-2.71,0.91l-1.78,0.39l-0.13,0.06l-0.6,0.49l-1.84,-0.58l-1.89,-0.33l-0.18,0.03l-0.47,0.23l-0.02,0.53l0.96,0.56l-0.08,1.58l0.35,1.58l0.26,0.23l1.91,0.19l0.02,0.07l-1.54,0.62l-0.18,0.2l-0.25,0.92l-0.88,0.35l-1.85,0.58l-0.16,0.13l-0.4,0.64l-1.66,0.14l-1.22,-1.18l-0.79,-2.52l-0.67,-0.88l-0.66,-0.43l0.99,-0.98l0.09,-0.26l-0.09,-0.56l-0.08,-0.16l-0.66,-0.69l-0.47,-1.54l0.18,-1.67l0.55,-0.85l0.45,-1.35l-0.15,-0.36l-0.89,-0.43l-0.19,-0.02l-1.39,0.28l-1.76,-0.13l-0.92,0.23l-1.64,-2.01l-0.17,-0.1l-1.54,-0.33l-3.05,0.23l-0.5,-0.73l-0.15,-0.12l-0.45,-0.15l-0.05,-0.28l0.28,-0.86l0.01,-0.15l-0.2,-1.01l-0.08,-0.15l-0.5,-0.5l-0.3,-1.08l-0.25,-0.22l-0.89,-0.12l0.54,-1.18l0.29,-1.73l0.66,-0.85l0.94,-0.7l0.09,-0.11l0.3,-0.6Z" data-code="VE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M574.42,192.1l2.24,0.95l0.18,0.02l1.89,-0.38l0.22,-0.18l0.46,-1.14l1.82,-0.4l1.5,-0.91l0.14,-0.19l0.46,-2.12l1.93,-0.51l0.2,-0.18l0.26,-0.68l0.87,0.57l0.13,0.05l0.79,0.09l1.35,0.02l1.83,0.59l0.75,0.34l0.26,-0.01l1.66,-0.85l0.7,0.46l0.42,-0.09l0.72,-1.17l1.32,0.05l0.23,-0.1l0.39,-0.43l0.07,-0.14l0.24,-1.08l0.86,-0.81l0.94,0.46l-0.2,0.64l0.23,0.38l0.49,0.09l-0.21,2.15l0.09,0.25l0.99,0.94l0.38,0.03l0.83,-0.57l1.06,-0.27l0.12,-0.06l1.46,-1.21l1.63,0.2l2.4,0.0l0.17,0.32l-1.12,0.25l-1.23,0.52l-2.86,0.33l-2.69,0.6l-0.13,0.06l-1.46,1.25l-0.07,0.36l0.58,1.18l0.25,1.21l-1.13,1.08l-0.09,0.25l0.09,0.98l-0.53,0.79l-2.22,-0.08l-0.28,0.44l0.83,1.57l-1.3,0.58l-0.13,0.11l-1.06,1.69l-0.05,0.18l0.13,1.51l-0.73,0.58l-0.78,-0.22l-0.14,-0.01l-1.91,0.36l-0.23,0.19l-0.2,0.57l-1.65,-0.0l-0.22,0.1l-1.4,1.56l-0.08,0.19l-0.08,2.13l-2.99,1.05l-1.67,-0.23l-0.27,0.1l-0.39,0.46l-1.43,-0.31l-2.43,0.4l-3.69,-1.23l1.96,-2.15l0.08,-0.24l-0.21,-1.78l-0.23,-0.26l-1.69,-0.42l-0.19,-1.62l-0.77,-2.08l0.98,-1.41l-0.14,-0.45l-0.82,-0.31l0.6,-1.79l0.93,-3.21Z" data-code="AF" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M534.42,190.89l0.13,0.14l1.5,0.78l0.15,1.34l-1.13,0.87l-0.11,0.16l-0.58,2.2l0.04,0.24l1.73,2.67l0.12,0.1l2.99,1.49l1.18,1.94l-0.39,1.89l0.29,0.36l0.5,-0.0l0.02,1.17l0.08,0.2l0.83,0.86l-2.36,-0.29l-0.29,0.13l-1.74,2.49l-4.4,-0.21l-7.03,-5.49l-3.73,-1.94l-2.92,-0.74l-0.89,-3.0l5.33,-2.81l0.15,-0.19l0.95,-3.43l-0.2,-2.0l1.19,-0.61l0.11,-0.09l1.23,-1.73l0.92,-0.38l2.75,0.35l0.81,0.68l0.31,0.05l0.94,-0.38l1.5,3.17Z" data-code="IQ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M384.26,87.96l-0.51,2.35l0.08,0.28l2.61,2.58l-2.99,2.83l-7.16,2.72l-2.08,0.7l-9.51,-1.71l1.89,-1.36l-0.07,-0.53l-4.4,-1.59l3.33,-0.59l0.25,-0.32l-0.11,-1.2l-0.25,-0.27l-4.82,-0.88l1.38,-2.2l3.54,-0.57l3.8,2.74l0.33,0.01l3.68,-2.18l3.02,1.12l0.25,-0.02l4.01,-2.18l3.72,0.27Z" data-code="IS" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M556.2,187.5l2.05,-0.52l0.13,-0.07l1.69,-1.57l1.55,0.08l0.15,-0.03l1.02,-0.5l1.64,0.25l2.82,1.48l1.91,0.3l2.8,2.49l0.18,0.08l1.61,0.09l0.19,2.09l-1.0,3.47l-0.69,2.04l0.18,0.38l0.73,0.28l-0.85,1.22l-0.04,0.28l0.81,2.19l0.19,1.72l0.23,0.26l1.69,0.42l0.17,1.43l-2.18,2.39l-0.01,0.4l1.22,1.42l1.0,1.62l0.12,0.11l2.23,1.11l0.06,2.2l0.2,0.27l1.03,0.38l0.14,0.83l-3.38,1.3l-0.18,0.19l-0.87,2.85l-4.44,-0.76l-2.75,-0.62l-2.64,-0.32l-1.01,-3.11l-0.17,-0.19l-1.2,-0.48l-0.18,-0.01l-1.99,0.51l-2.42,1.25l-2.89,-0.84l-2.48,-2.03l-2.41,-0.79l-1.61,-2.47l-1.84,-3.63l-0.36,-0.15l-1.22,0.4l-1.48,-0.84l-0.37,0.06l-0.72,0.82l-1.08,-1.12l-0.02,-1.35l-0.3,-0.29l-0.43,0.0l0.34,-1.64l-0.04,-0.22l-1.29,-2.11l-0.12,-0.11l-3.0,-1.49l-1.62,-2.49l0.52,-1.98l1.18,-0.92l0.11,-0.27l-0.19,-1.66l-0.16,-0.23l-1.55,-0.81l-1.58,-3.33l-1.3,-2.2l0.41,-0.75l0.03,-0.21l-0.73,-3.12l1.2,-0.59l0.35,0.9l1.26,1.35l0.15,0.09l1.81,0.39l0.91,-0.09l0.15,-0.06l2.9,-2.13l0.7,-0.16l0.48,0.56l-0.75,1.26l0.05,0.37l1.56,1.53l0.28,0.08l0.37,-0.09l0.7,1.89l0.21,0.19l2.31,0.59l1.69,1.4l0.15,0.07l3.66,0.49l3.91,-0.76l0.23,-0.19l0.19,-0.52Z" data-code="IR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M530.51,176.08l2.91,-0.39l0.41,0.63l0.11,0.1l0.66,0.36l-0.32,0.47l0.07,0.41l1.1,0.84l-0.53,0.7l0.06,0.42l1.06,0.8l1.01,0.44l0.04,1.56l-0.44,0.04l-0.88,-1.46l0.01,-0.37l-0.3,-0.31l-0.98,0.01l-0.65,-0.69l-0.26,-0.09l-0.38,0.06l-0.97,-0.82l-1.64,-0.65l0.2,-1.2l-0.02,-0.16l-0.28,-0.69Z" data-code="AM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M451.68,158.58l0.2,0.16l3.3,0.75l-0.22,1.26l0.02,0.18l0.35,0.78l-1.4,-0.32l-0.21,0.03l-2.04,1.1l-0.16,0.29l0.13,1.47l-0.29,0.82l0.02,0.24l0.82,1.57l0.1,0.11l2.28,1.5l1.29,2.53l2.79,2.43l0.2,0.07l1.83,-0.02l0.31,0.34l-0.46,0.39l0.06,0.5l4.06,1.97l2.06,1.49l0.17,0.36l-0.24,0.53l-1.08,-1.07l-0.15,-0.08l-2.18,-0.49l-0.33,0.15l-1.05,1.91l0.11,0.4l1.63,0.98l-0.22,1.12l-0.84,0.14l-0.22,0.15l-1.27,2.38l-0.54,0.12l0.01,-0.47l0.48,-1.46l0.5,-0.58l0.03,-0.35l-0.97,-1.69l-0.76,-1.48l-0.17,-0.15l-0.94,-0.33l-0.68,-1.18l-0.16,-0.13l-1.53,-0.52l-1.03,-1.14l-0.19,-0.1l-1.78,-0.19l-1.88,-1.3l-2.27,-1.94l-1.64,-1.68l-0.76,-2.94l-0.21,-0.21l-1.22,-0.35l-2.01,-1.0l-0.24,-0.01l-1.15,0.42l-0.11,0.07l-1.38,1.36l-0.5,0.11l0.19,-0.87l-0.21,-0.35l-1.19,-0.34l-0.56,-2.06l0.76,-0.82l0.03,-0.36l-0.68,-1.08l0.04,-0.31l0.68,0.42l0.19,0.04l1.21,-0.15l0.14,-0.06l1.18,-0.89l0.25,0.29l0.25,0.1l1.19,-0.1l0.25,-0.18l0.45,-1.04l1.61,0.34l0.19,-0.02l1.1,-0.53l0.17,-0.22l0.15,-0.95l1.19,0.35l0.35,-0.16l0.23,-0.47l2.11,-0.47l0.45,0.89ZM459.35,184.63l-0.71,1.81l0.0,0.23l0.33,0.79l-0.37,1.03l-1.6,-0.91l-1.33,-0.34l-3.24,-1.36l0.23,-0.99l2.73,0.24l3.95,-0.5ZM443.95,175.91l1.26,1.77l-0.31,3.47l-0.82,-0.13l-0.26,0.08l-0.83,0.79l-0.64,-0.52l-0.1,-3.42l-0.44,-1.34l0.91,0.1l0.21,-0.06l1.01,-0.74Z" data-code="IT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M690.8,230.21l-2.86,1.93l-2.09,2.46l-0.06,0.11l-0.55,1.8l0.04,0.26l4.26,6.1l2.31,1.63l1.46,1.97l1.12,4.62l-0.32,4.3l-1.97,1.57l-2.85,1.62l-2.09,2.14l-2.83,2.13l-0.67,-1.19l0.65,-1.58l-0.09,-0.35l-1.47,-1.14l1.67,-0.79l2.57,-0.18l0.22,-0.47l-0.89,-1.24l3.88,-1.8l0.17,-0.24l0.31,-3.05l-0.01,-0.13l-0.56,-1.63l0.44,-2.48l-0.01,-0.15l-0.63,-1.81l-0.08,-0.12l-1.87,-1.77l-3.64,-5.3l-0.11,-0.1l-2.68,-1.39l0.45,-0.59l1.53,-0.65l0.16,-0.39l-0.97,-2.27l-0.27,-0.18l-2.89,-0.02l-1.04,-2.21l-1.28,-1.83l0.96,-0.46l1.97,0.01l2.43,-0.3l0.13,-0.05l1.95,-1.29l1.04,0.85l0.13,0.06l1.98,0.42l-0.32,1.21l0.09,0.3l1.19,1.07l0.12,0.07l1.88,0.51Z" data-code="VN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M258.11,341.34l1.4,1.81l0.51,-0.06l0.89,-1.94l2.51,0.1l0.36,0.49l4.6,4.31l0.15,0.08l1.99,0.39l3.01,1.93l2.5,1.01l0.28,0.91l-2.4,3.97l0.17,0.44l2.57,0.74l2.81,0.41l2.09,-0.44l0.14,-0.07l2.27,-2.06l0.09,-0.17l0.38,-2.2l0.88,-0.36l1.05,1.29l-0.04,1.88l-1.98,1.4l-1.72,1.13l-2.84,2.65l-3.34,3.73l-0.07,0.12l-0.63,2.22l-0.67,2.85l0.02,2.73l-0.47,0.54l-0.07,0.17l-0.36,3.28l0.12,0.27l3.03,2.32l-0.31,1.78l0.11,0.29l1.44,1.15l-0.11,1.17l-2.32,3.57l-3.59,1.51l-4.95,0.6l-2.72,-0.29l-0.32,0.38l0.5,1.67l-0.49,2.13l0.01,0.16l0.4,1.29l-1.27,0.88l-2.41,0.39l-2.33,-1.05l-0.31,0.04l-0.97,0.78l-0.11,0.27l0.35,2.98l0.16,0.23l1.69,0.91l0.31,-0.02l1.08,-0.75l0.46,0.96l-2.1,0.88l-2.01,1.89l-0.09,0.18l-0.36,3.05l-0.51,1.42l-2.16,0.01l-0.19,0.07l-1.96,1.59l-0.1,0.15l-0.72,2.34l0.08,0.31l2.46,2.31l0.13,0.07l2.09,0.56l-0.74,2.45l-2.86,1.75l-0.12,0.14l-1.59,3.71l-2.2,1.24l-0.1,0.09l-1.03,1.54l-0.04,0.23l0.81,3.45l0.06,0.13l1.13,1.32l-2.59,-0.57l-5.89,-0.44l-0.92,-1.73l0.05,-2.4l-0.34,-0.3l-1.49,0.19l-0.72,-0.98l-0.2,-3.21l1.79,-1.33l0.1,-0.13l0.79,-2.04l0.02,-0.16l-0.27,-1.52l1.31,-2.69l0.91,-4.15l-0.23,-1.72l0.91,-0.49l0.15,-0.33l-0.27,-1.16l-0.15,-0.2l-0.87,-0.46l0.65,-1.01l-0.04,-0.37l-1.06,-1.09l-0.54,-3.2l0.83,-0.51l0.14,-0.29l-0.42,-3.6l0.58,-2.98l0.64,-2.5l1.41,-1.0l0.12,-0.32l-0.75,-2.8l-0.01,-2.48l1.81,-1.78l0.09,-0.22l-0.06,-2.3l1.39,-2.69l0.03,-0.14l0.01,-2.58l-0.11,-0.24l-0.57,-0.45l-1.1,-4.59l1.49,-2.73l0.04,-0.17l-0.23,-2.59l0.86,-2.38l1.6,-2.48l1.74,-1.65l0.04,-0.39l-0.64,-0.89l0.42,-0.7l0.04,-0.16l-0.08,-4.26l2.55,-1.23l0.16,-0.18l0.86,-2.75l-0.01,-0.22l-0.22,-0.48l1.84,-2.1l3.0,0.59ZM256.77,438.98l-2.1,0.15l-1.18,-1.14l-0.19,-0.08l-1.53,-0.09l-2.38,-0.0l-0.0,-6.28l0.4,0.65l1.25,2.55l0.11,0.12l3.26,2.07l3.19,0.8l-0.82,1.26Z" data-code="AR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M705.55,353.06l0.09,0.09l0.37,0.05l0.13,-0.35l-0.57,-1.69l0.48,0.3l0.71,0.99l0.34,0.11l0.2,-0.29l-0.04,-1.37l-0.04,-0.14l-1.22,-2.07l-0.28,-0.9l-0.51,-0.69l0.24,-1.33l0.52,-0.7l0.34,-1.32l0.01,-0.13l-0.25,-1.44l0.51,-0.94l0.1,1.03l0.23,0.26l0.32,-0.14l1.01,-1.72l1.94,-0.84l1.27,-1.14l1.84,-0.92l1.0,-0.18l0.6,0.28l0.26,-0.0l1.94,-0.96l1.48,-0.28l0.19,-0.13l0.32,-0.49l0.51,-0.18l1.42,0.05l2.63,-0.76l0.11,-0.06l1.36,-1.15l0.08,-0.1l0.61,-1.33l1.42,-1.27l0.1,-0.19l0.11,-1.03l0.06,-1.32l1.39,-1.74l0.85,1.79l0.4,0.14l1.07,-0.51l0.11,-0.45l-0.77,-1.05l0.53,-0.84l0.86,0.43l0.43,-0.22l0.29,-1.85l1.29,-1.19l0.6,-0.98l1.16,-0.4l0.2,-0.27l0.02,-0.34l0.74,0.2l0.38,-0.27l0.03,-0.44l1.98,-0.61l1.7,1.08l1.36,1.48l0.22,0.1l1.55,0.02l1.57,0.24l0.33,-0.4l-0.48,-1.27l1.09,-1.86l1.06,-0.63l0.1,-0.42l-0.28,-0.46l0.93,-1.24l1.36,-0.8l1.16,0.27l0.14,0.0l2.1,-0.48l0.23,-0.3l-0.05,-1.3l-0.18,-0.26l-1.08,-0.49l0.44,-0.12l1.52,0.58l1.39,1.06l2.11,0.65l0.19,-0.0l0.59,-0.21l1.44,0.72l0.27,0.0l1.37,-0.68l0.84,0.2l0.26,-0.06l0.37,-0.3l0.82,0.89l-0.56,1.14l-0.84,0.91l-0.75,0.07l-0.26,0.38l0.26,0.9l-0.67,1.15l-0.88,1.24l-0.05,0.25l0.18,0.72l0.12,0.17l1.99,1.42l1.96,0.84l1.25,0.86l1.8,1.51l0.19,0.07l0.63,-0.0l1.15,0.58l0.34,0.7l0.17,0.15l2.39,0.88l0.24,-0.02l1.65,-0.88l0.14,-0.16l0.49,-1.37l0.52,-1.19l0.31,-1.39l0.75,-2.02l0.01,-0.19l-0.33,-1.16l0.16,-0.67l0.0,-0.13l-0.28,-1.41l0.3,-1.78l0.42,-0.45l0.05,-0.33l-0.33,-0.73l0.56,-1.25l0.48,-1.39l0.07,-0.69l0.58,-0.59l0.48,0.84l0.17,1.53l0.17,0.24l0.47,0.23l0.09,0.9l0.05,0.14l0.87,1.23l0.17,1.33l-0.09,0.89l0.03,0.15l0.9,2.0l0.43,0.13l1.38,-0.83l0.71,0.92l1.06,0.88l-0.22,0.96l0.0,0.14l0.53,2.2l0.38,1.3l0.15,0.18l0.52,0.26l0.62,2.01l-0.23,1.27l0.02,0.18l0.81,1.76l0.14,0.14l2.69,1.35l3.21,2.21l-0.2,0.4l0.04,0.34l1.39,1.6l0.95,2.78l0.43,0.16l0.79,-0.46l0.85,0.96l0.39,0.05l0.22,-0.15l0.36,2.33l0.09,0.18l1.78,1.63l1.16,1.01l1.9,2.1l0.67,2.05l0.06,1.47l-0.17,1.64l0.03,0.17l1.16,2.22l-0.14,2.28l-0.43,1.24l-0.68,2.44l0.04,1.63l-0.48,1.92l-1.06,2.43l-1.79,1.32l-0.1,0.12l-0.91,2.15l-0.82,1.37l-0.76,2.47l-0.98,1.46l-0.63,2.14l-0.33,2.02l0.1,0.82l-1.21,0.85l-2.71,0.1l-0.13,0.03l-2.31,1.19l-1.21,1.17l-1.34,1.11l-1.89,-1.18l-1.33,-0.46l0.32,-1.24l-0.4,-0.35l-1.46,0.61l-2.06,1.98l-1.99,-0.73l-1.43,-0.46l-1.45,-0.22l-2.32,-0.81l-1.51,-1.67l-0.45,-2.11l-0.6,-1.5l-0.07,-0.11l-1.23,-1.16l-0.16,-0.08l-1.96,-0.28l0.59,-0.99l0.03,-0.24l-0.61,-2.1l-0.54,-0.08l-1.16,1.85l-1.23,0.29l0.73,-0.88l0.06,-0.12l0.37,-1.57l0.93,-1.33l0.05,-0.2l-0.2,-2.07l-0.53,-0.17l-2.01,2.35l-1.52,0.94l-0.12,0.14l-0.82,1.93l-1.5,-0.9l0.07,-1.32l-0.06,-0.2l-1.57,-2.04l-1.15,-0.92l0.3,-0.41l-0.1,-0.44l-3.21,-1.69l-0.13,-0.03l-1.69,-0.08l-2.35,-1.31l-0.16,-0.04l-4.55,0.27l-3.24,0.99l-2.8,0.91l-2.33,-0.18l-0.17,0.03l-2.63,1.41l-2.14,0.64l-0.2,0.19l-0.47,1.42l-0.8,0.99l-1.99,0.06l-1.55,0.24l-2.27,-0.5l-1.79,0.3l-1.71,0.13l-0.19,0.09l-1.38,1.39l-0.58,-0.1l-0.21,0.04l-1.26,0.8l-1.13,0.85l-1.72,-0.1l-1.6,-0.0l-2.58,-1.76l-1.21,-0.49l0.04,-1.19l1.04,-0.32l0.16,-0.12l0.42,-0.64l0.05,-0.19l-0.09,-0.97l0.3,-2.0l-0.28,-1.64l-1.34,-2.84l-0.39,-1.49l0.1,-1.51l-0.04,-0.17l-0.96,-1.72l-0.06,-0.73l-0.09,-0.19l-1.04,-1.01l-0.3,-2.02l-0.05,-0.12l-1.23,-1.83ZM784.95,393.35l2.39,1.01l0.2,0.01l3.26,-0.96l1.19,0.16l0.16,3.19l-0.78,0.95l-0.07,0.16l-0.19,1.83l-0.43,-0.41l-0.44,0.03l-1.61,1.96l-0.4,-0.12l-1.38,-0.09l-1.43,-2.42l-0.37,-2.03l-1.4,-2.53l0.04,-0.94l1.27,0.2Z" data-code="AU" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M509.04,199.22l0.71,0.0l0.27,-0.17l0.15,-0.33l0.19,-0.01l0.02,0.73l-0.27,0.34l0.02,0.08l-0.32,0.62l-0.65,-0.27l-0.41,0.19l-0.52,1.85l0.16,0.35l0.14,0.07l-0.17,0.1l-0.14,0.21l-0.11,0.73l0.39,0.33l0.81,-0.26l0.03,0.64l-0.97,3.43l-1.28,-3.67l0.62,-0.78l-0.03,-0.41l0.58,-1.16l0.5,-2.07l0.27,-0.54Z" data-code="IL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M615.84,192.58l2.4,2.97l-0.24,2.17l0.05,0.2l0.94,1.35l-0.06,0.97l-1.46,-0.3l-0.35,0.36l0.7,3.06l0.12,0.18l2.46,1.75l3.11,1.72l-1.23,0.96l-0.1,0.13l-0.97,2.55l0.16,0.38l2.41,1.02l2.37,1.33l3.27,1.52l3.43,0.37l1.37,1.3l0.17,0.08l1.92,0.25l3.0,0.62l2.15,-0.04l0.28,-0.22l0.29,-1.06l0.0,-0.13l-0.32,-1.66l0.16,-0.94l1.0,-0.37l0.23,2.28l0.18,0.24l2.28,1.02l0.2,0.02l1.52,-0.41l2.06,0.18l2.08,-0.08l0.29,-0.27l0.18,-1.66l-0.1,-0.26l-0.53,-0.44l1.38,-0.23l0.15,-0.07l2.26,-2.0l2.75,-1.65l1.97,0.63l0.25,-0.03l1.54,-0.99l0.89,1.28l-0.72,0.97l0.2,0.48l2.49,0.37l0.11,0.61l-0.69,0.39l-0.15,0.3l0.15,1.22l-1.36,-0.37l-0.23,0.03l-3.24,1.86l-0.15,0.28l0.07,1.44l-1.33,2.16l-0.04,0.13l-0.12,1.24l-0.98,1.91l-1.72,-0.53l-0.39,0.28l-0.09,2.66l-0.52,0.83l-0.04,0.23l0.21,0.89l-0.71,0.36l-1.21,-3.85l-0.29,-0.21l-0.69,0.01l-0.29,0.23l-0.28,1.17l-0.84,-0.84l0.6,-1.17l0.97,-0.13l0.23,-0.16l1.15,-2.25l-0.18,-0.42l-1.54,-0.47l-2.3,0.04l-2.13,-0.33l-0.19,-1.63l-0.26,-0.26l-1.13,-0.13l-1.93,-1.13l-0.42,0.13l-0.88,1.82l0.08,0.37l1.47,1.15l-1.21,0.77l-0.1,0.1l-0.56,0.97l0.13,0.42l1.31,0.61l-0.36,1.35l0.01,0.2l0.85,1.95l0.37,2.05l-0.26,0.68l-1.55,-0.02l-3.09,0.54l-0.25,0.32l0.13,1.84l-1.21,1.4l-3.64,1.79l-2.79,3.04l-1.86,1.61l-2.48,1.68l-0.13,0.25l-0.0,1.0l-1.07,0.55l-2.21,0.9l-1.13,0.13l-0.25,0.19l-0.75,1.96l-0.02,0.15l0.52,3.31l0.13,2.03l-1.03,2.35l-0.03,0.12l-0.01,4.03l-1.02,0.1l-0.23,0.15l-1.14,1.93l0.04,0.36l0.44,0.48l-1.83,0.57l-0.18,0.15l-0.81,1.65l-0.74,0.53l-2.14,-2.12l-1.14,-3.47l-0.96,-2.57l-0.9,-1.26l-1.3,-2.38l-0.61,-3.14l-0.44,-1.62l-2.29,-3.56l-1.03,-4.94l-0.74,-3.29l0.01,-3.12l-0.49,-2.51l-0.41,-0.22l-3.56,1.53l-1.59,-0.28l-2.96,-2.87l0.94,-0.74l0.06,-0.41l-0.74,-1.03l-2.73,-2.1l1.35,-1.43l5.38,0.01l0.29,-0.36l-0.5,-2.29l-0.09,-0.15l-1.33,-1.28l-0.27,-1.96l-0.12,-0.2l-1.36,-1.0l2.42,-2.48l2.77,0.2l0.24,-0.1l2.62,-2.85l1.59,-2.8l2.41,-2.74l0.07,-0.2l-0.04,-1.82l2.01,-1.51l-0.01,-0.49l-1.95,-1.33l-0.83,-1.81l-0.82,-2.27l0.98,-0.97l3.64,0.66l2.89,-0.42l0.17,-0.08l2.18,-2.15Z" data-code="IN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M505.77,287.58l0.36,0.23l8.95,5.03l0.15,1.3l0.13,0.21l3.4,2.37l-1.07,2.88l-0.02,0.14l0.15,1.42l0.15,0.23l1.47,0.84l0.05,0.42l-0.66,1.44l-0.02,0.18l0.13,0.72l-0.16,1.16l0.03,0.19l0.87,1.57l1.03,2.48l0.12,0.14l0.53,0.32l-1.59,1.18l-2.64,0.95l-1.45,-0.04l-0.2,0.07l-0.81,0.69l-1.64,0.06l-0.68,0.3l-2.9,-0.69l-1.71,0.17l-0.65,-3.18l-0.05,-0.12l-1.35,-1.88l-0.19,-0.12l-2.41,-0.46l-1.38,-0.74l-1.63,-0.44l-0.96,-0.41l-0.95,-0.58l-1.31,-3.09l-1.47,-1.46l-0.45,-1.31l0.24,-1.34l-0.39,-1.99l0.71,-0.08l0.18,-0.09l0.91,-0.91l0.98,-1.31l0.59,-0.5l0.11,-0.24l-0.02,-0.81l-0.08,-0.2l-0.47,-0.5l-0.1,-0.67l0.51,-0.23l0.18,-0.25l0.14,-1.47l-0.05,-0.2l-0.76,-1.09l0.45,-0.15l2.71,0.03l5.01,-0.19Z" data-code="TZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M539.36,175.66l0.16,0.09l1.11,0.2l0.32,-0.15l0.4,-0.71l1.22,-0.99l1.11,1.33l1.26,2.09l0.22,0.14l1.06,0.13l0.28,0.29l-1.46,0.17l-0.26,0.24l-0.43,2.26l-0.39,0.92l-0.85,0.63l-0.12,0.25l0.06,1.2l-0.22,0.05l-1.28,-1.25l0.74,-1.25l-0.03,-0.35l-0.74,-0.86l-0.3,-0.1l-1.05,0.27l-2.49,1.82l-0.04,-1.46l-0.18,-0.27l-1.09,-0.47l-0.8,-0.6l0.53,-0.7l-0.06,-0.42l-1.11,-0.84l0.34,-0.51l-0.11,-0.43l-0.89,-0.48l-0.33,-0.49l0.25,-0.2l1.78,0.81l1.35,0.18l0.25,-0.09l0.34,-0.35l0.02,-0.39l-1.04,-1.36l0.28,-0.18l0.49,0.07l1.65,1.74ZM533.53,180.16l0.63,0.67l0.22,0.09l0.8,-0.0l0.04,0.31l0.66,1.09l-0.94,-0.21l-1.16,-1.24l-0.25,-0.71Z" data-code="AZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M405.17,135.35l0.36,2.16l-1.78,2.84l-4.28,1.91l-3.02,-0.43l1.81,-3.13l0.02,-0.26l-1.23,-3.26l3.24,-2.56l1.54,-1.32l0.37,1.33l-0.49,1.77l0.3,0.38l1.49,-0.05l1.68,0.63Z" data-code="IE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M756.56,287.86l0.69,4.02l0.15,0.21l2.59,1.5l0.39,-0.07l2.05,-2.61l2.75,-1.45l2.09,-0.0l2.08,0.85l1.85,0.89l2.52,0.46l0.08,15.44l-1.72,-1.6l-0.15,-0.07l-2.54,-0.51l-0.29,0.1l-0.53,0.62l-2.53,0.06l0.78,-1.51l1.48,-0.66l0.17,-0.34l-0.65,-2.74l-1.23,-2.19l-0.14,-0.13l-4.85,-2.13l-2.09,-0.23l-3.7,-2.28l-0.41,0.1l-0.67,1.11l-0.63,0.14l-0.41,-0.67l-0.01,-1.01l-0.14,-0.25l-1.39,-0.89l2.05,-0.69l1.73,0.05l0.29,-0.39l-0.21,-0.66l-0.29,-0.21l-3.5,-0.0l-0.9,-1.36l-0.19,-0.13l-2.14,-0.44l-0.65,-0.76l2.86,-0.51l1.28,-0.79l3.75,0.96l0.32,0.76ZM758.01,300.37l-0.79,1.04l-0.14,-1.07l0.4,-0.81l0.29,-0.47l0.24,0.31l-0.0,1.0ZM747.45,292.9l0.48,1.02l-1.45,-0.69l-2.09,-0.21l-1.45,0.16l-1.28,-0.07l0.35,-0.81l2.86,-0.1l2.58,0.68ZM741.15,285.69l-0.16,-0.25l-0.72,-3.08l0.47,-1.86l0.35,-0.38l0.1,0.73l0.25,0.26l1.28,0.19l0.18,0.78l-0.11,1.8l-0.96,-0.18l-0.35,0.22l-0.38,1.52l0.05,0.24ZM741.19,285.75l0.76,0.97l-0.11,0.05l-0.65,-1.02ZM739.18,293.52l-0.61,0.54l-1.44,-0.38l-0.25,-0.55l1.93,-0.09l0.36,0.48ZM728.4,295.87l-0.27,-0.07l-2.26,0.89l-0.37,-0.41l0.27,-0.8l-0.09,-0.33l-1.68,-1.37l0.17,-2.29l-0.42,-0.3l-1.67,0.76l-0.17,0.29l0.21,2.92l0.09,3.34l-1.22,0.28l-0.78,-0.54l0.65,-2.1l0.01,-0.14l-0.39,-2.42l-0.29,-0.25l-0.86,-0.02l-0.63,-1.4l0.99,-1.61l0.35,-1.97l1.24,-3.73l0.49,-0.96l1.95,-1.7l1.86,0.69l3.16,0.35l2.92,-0.1l0.17,-0.06l2.24,-1.65l0.11,0.14l-1.8,2.22l-1.72,0.44l-2.41,-0.48l-4.21,0.13l-2.19,0.36l-0.25,0.24l-0.36,1.9l0.08,0.27l2.24,2.23l0.4,0.02l1.29,-1.08l3.19,-0.58l-0.19,0.06l-1.04,1.4l-2.13,0.94l-0.12,0.45l2.26,3.06l-0.37,0.69l0.03,0.32l1.51,1.95ZM728.48,295.97l0.59,0.76l-0.02,1.37l-1.0,0.55l-0.64,-0.58l1.09,-1.84l-0.02,-0.26ZM728.64,286.95l0.79,-0.14l-0.07,0.39l-0.72,-0.24ZM732.38,310.1l-1.89,0.49l-0.06,-0.06l0.17,-0.64l1.0,-1.42l2.14,-0.87l0.1,0.2l0.04,0.58l-1.49,1.72ZM728.26,305.71l-0.17,0.63l-3.53,0.67l-3.02,-0.28l-0.0,-0.42l1.66,-0.44l1.47,0.71l0.16,0.03l1.75,-0.21l1.69,-0.69ZM722.98,310.33l-0.74,0.03l-2.52,-1.35l1.42,-0.3l1.19,0.7l0.72,0.63l-0.06,0.28ZM716.24,305.63l0.66,0.49l0.22,0.06l1.35,-0.18l0.31,0.53l-4.18,0.77l-0.8,-0.01l0.51,-0.86l1.2,-0.02l0.24,-0.12l0.49,-0.65ZM715.84,280.21l0.09,0.34l2.25,1.86l-2.25,0.22l-0.24,0.17l-0.84,1.71l-0.03,0.15l0.1,2.11l-2.27,1.62l-0.13,0.24l-0.06,2.46l-0.74,2.92l-0.02,-0.05l-0.39,-0.16l-2.62,1.04l-0.86,-1.33l-0.23,-0.14l-1.71,-0.14l-1.19,-0.76l-0.25,-0.03l-2.78,0.84l-0.79,-1.05l-0.26,-0.12l-1.61,0.13l-1.8,-0.25l-0.36,-3.13l-0.15,-0.23l-1.18,-0.65l-1.13,-2.02l-0.33,-2.1l0.27,-2.19l1.05,-1.17l0.28,1.12l0.1,0.16l1.71,1.41l0.28,0.05l1.55,-0.49l1.54,0.17l0.23,-0.07l1.4,-1.21l1.05,-0.19l2.3,0.68l0.16,0.0l2.04,-0.53l0.21,-0.19l1.26,-3.41l0.91,-0.82l0.09,-0.14l0.8,-2.64l2.63,0.0l1.71,0.33l-1.19,1.89l0.02,0.34l1.74,2.24l-0.37,1.0ZM692.67,302.0l0.26,0.19l4.8,0.25l0.28,-0.16l0.44,-0.83l4.29,1.12l0.85,1.52l0.23,0.15l3.71,0.45l2.37,1.15l-2.06,0.69l-2.77,-1.0l-2.25,0.07l-2.57,-0.18l-2.31,-0.45l-2.94,-0.97l-1.84,-0.25l-0.13,0.01l-0.97,0.29l-4.34,-0.98l-0.38,-0.94l-0.25,-0.19l-1.76,-0.14l1.31,-1.84l2.81,0.14l1.97,0.96l0.95,0.19l0.28,0.74ZM685.63,299.27l-2.36,0.04l-2.07,-2.05l-3.17,-2.02l-1.06,-1.5l-1.88,-2.02l-1.22,-1.85l-1.9,-3.49l-2.2,-2.11l-0.71,-2.08l-0.94,-1.99l-0.1,-0.12l-2.21,-1.54l-1.35,-2.17l-1.86,-1.39l-2.53,-2.68l-0.14,-0.81l1.22,0.08l3.76,0.47l2.16,2.4l1.94,1.7l1.37,1.04l2.35,2.67l0.22,0.1l2.44,0.04l1.99,1.62l1.42,2.06l0.09,0.09l1.67,1.0l-0.88,1.8l0.11,0.39l1.44,0.87l0.13,0.04l0.68,0.05l0.41,1.62l0.87,1.4l0.22,0.14l1.71,0.21l1.06,1.38l-0.61,3.04l-0.09,3.6Z" data-code="ID" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M500.54,141.42l0.9,0.13l0.27,-0.11l0.52,-0.62l0.68,0.13l2.43,-0.3l1.32,1.57l-0.45,0.48l-0.07,0.26l0.21,1.03l0.27,0.24l1.85,0.15l0.76,1.22l-0.05,0.55l0.2,0.31l3.18,1.15l0.18,0.01l1.75,-0.47l1.42,1.41l0.22,0.09l1.42,-0.03l3.44,0.99l0.02,0.65l-0.97,1.62l-0.03,0.24l0.52,1.67l-0.29,0.79l-2.24,0.22l-0.14,0.05l-1.29,0.89l-0.13,0.23l-0.07,1.16l-1.75,0.22l-0.12,0.04l-1.6,0.98l-2.27,0.16l-0.12,0.04l-2.16,1.17l-0.16,0.29l0.15,1.94l0.14,0.23l1.23,0.75l0.18,0.04l2.06,-0.15l-0.22,0.51l-2.67,0.54l-3.27,1.72l-1.0,-0.45l0.45,-1.19l-0.19,-0.39l-2.34,-0.78l0.15,-0.2l2.32,-1.0l0.09,-0.49l-0.73,-0.72l-0.15,-0.08l-3.69,-0.75l-0.14,-0.96l-0.35,-0.25l-2.32,0.39l-0.21,0.15l-0.91,1.7l-1.77,2.1l-0.93,-0.44l-0.24,-0.0l-1.05,0.45l-0.48,-0.25l0.13,-0.07l0.14,-0.15l0.43,-1.04l0.67,-0.97l0.04,-0.26l-0.1,-0.31l0.04,-0.02l0.11,0.19l0.24,0.15l1.48,0.09l0.78,-0.25l0.07,-0.53l-0.27,-0.19l0.09,-0.25l-0.08,-0.33l-0.81,-0.74l-0.34,-1.24l-0.14,-0.18l-0.73,-0.42l0.15,-0.87l-0.11,-0.29l-1.13,-0.86l-0.15,-0.06l-0.97,-0.11l-1.79,-0.97l-0.2,-0.03l-1.66,0.32l-0.13,0.06l-0.52,0.41l-0.95,-0.0l-0.23,0.11l-0.56,0.66l-1.74,0.29l-0.79,0.43l-1.01,-0.68l-0.16,-0.05l-1.57,-0.01l-1.52,-0.35l-0.23,0.04l-0.71,0.45l-0.09,-0.43l-0.13,-0.19l-1.18,-0.74l0.38,-1.02l0.53,-0.64l0.35,0.12l0.37,-0.41l-0.57,-1.29l2.1,-2.5l1.16,-0.36l0.2,-0.2l0.27,-0.92l-0.01,-0.2l-1.1,-2.52l0.79,-0.09l0.13,-0.05l1.3,-0.86l1.83,-0.07l2.48,0.26l2.84,0.8l1.91,0.06l0.88,0.45l0.29,-0.01l0.72,-0.44l0.49,0.58l0.25,0.11l2.2,-0.16l0.94,0.3l0.39,-0.26l0.15,-1.57l0.61,-0.59l2.01,-0.19Z" data-code="UA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M548.47,221.47l-0.15,-1.72l0.59,-1.23l0.38,-0.16l0.54,0.6l0.04,1.4l-0.47,1.37l-0.41,0.11l-0.53,-0.37Z" data-code="QA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M507.71,314.14l1.65,-0.18l2.96,0.7l0.2,-0.02l0.6,-0.29l1.68,-0.06l0.18,-0.07l0.8,-0.69l1.5,0.02l2.74,-0.98l1.74,-1.27l0.25,0.7l-0.1,2.47l0.31,2.27l0.1,3.97l0.42,1.24l-0.7,1.71l-0.94,1.73l-1.52,1.52l-5.06,2.21l-2.88,2.8l-1.01,0.51l-1.72,1.81l-0.99,0.58l-0.15,0.23l-0.21,1.86l0.04,0.19l1.17,1.95l0.47,1.47l0.03,0.74l0.39,0.28l0.05,-0.01l-0.06,2.13l-0.39,1.19l0.1,0.33l0.42,0.32l-0.28,0.83l-0.95,0.86l-2.03,0.88l-3.08,1.49l-1.1,0.99l-0.09,0.28l0.21,1.13l0.21,0.23l0.38,0.11l-0.14,0.89l-1.39,-0.02l-0.17,-0.94l-0.38,-1.23l-0.2,-0.89l0.44,-2.91l-0.01,-0.14l-0.65,-1.88l-1.15,-3.55l2.52,-2.85l0.68,-1.89l0.29,-0.18l0.14,-0.2l0.28,-1.53l-0.03,-0.19l-0.36,-0.7l0.1,-1.83l0.49,-1.84l-0.01,-3.26l-0.14,-0.25l-1.3,-0.83l-0.11,-0.04l-1.08,-0.17l-0.47,-0.55l-0.1,-0.08l-1.16,-0.54l-0.13,-0.03l-1.83,0.04l-0.32,-2.25l7.19,-1.99l1.32,1.12l0.29,0.06l0.55,-0.19l0.75,0.49l0.11,0.81l-0.49,1.11l-0.02,0.15l0.19,1.81l0.09,0.18l1.63,1.59l0.48,-0.1l0.72,-1.68l0.99,-0.49l0.17,-0.29l-0.21,-3.29l-0.04,-0.13l-1.11,-1.92l-0.9,-0.82l-0.21,-0.08l-0.62,0.03l-0.63,-2.98l0.61,-1.67Z" data-code="MZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path></g><g><circle data-index="0" cx="236.61387413103213" cy="137.93820711383978" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="1" cx="230.00925391282925" cy="135.03678122512682" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="2" cx="439.0507255810284" cy="196.9571497231832" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="3" cx="455.14293516030045" cy="207.45389804037305" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="4" cx="236.62697853622697" cy="134.71657987971312" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="5" cx="232.7742834089419" cy="129.4876082272392" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="6" cx="444.46284492650017" cy="186.9431405942959" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="7" cx="138.09495587617246" cy="173.38135751459242" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="8" cx="316.2493445001173" cy="192.08090906110368" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="9" cx="239.30027719597572" cy="147.15713834518894" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="10" cx="139.37918758526746" cy="180.40987382129654" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="11" cx="140.06061665539954" cy="178.93244623113597" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="12" cx="142.26215672813382" cy="178.93244623113597" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="13" cx="139.248143533319" cy="173.63770250731525" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="14" cx="292.96281646887417" cy="202.3210213954843" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="15" cx="396.5007219133601" cy="186.62702534201094" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="16" cx="222.27765484786948" cy="136.9924595234069" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="17" cx="140.38822678527072" cy="177.7982215088912" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="18" cx="427.5843710355373" cy="187.20648923343165" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="19" cx="356.32261558595934" cy="194.572048435707" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="20" cx="447.044412749885" cy="194.3623389804743" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="21" cx="462.4682976642199" cy="224.37598896518043" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="22" cx="139.8640505774768" cy="176.07170954866515" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="23" cx="295.6492195338178" cy="223.1047160089049" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="24" cx="286.5416579233991" cy="161.40220391425788" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="25" cx="229.11815435957962" cy="195.84326776433264" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle></g></svg><div class="jvectormap-zoomin">+</div><div class="jvectormap-zoomout">\u2212</div></div></div></div></div><!-- /.col --><div class="col-md-3 col-sm-4"><div class="pad box-pane-right bg-green" style="min-height: 280px"><div class="description-block margin-bottom"><div class="sparkbar pad" data-color="#fff"><canvas width="34" height="30" style="display: inline-block; width: 34px; height: 30px; vertical-align: top"></canvas></div><h5 class="description-header">8390</h5><span class="description-text">Visits</span></div><!-- /.description-block --><div class="description-block margin-bottom"><div class="sparkbar pad" data-color="#fff"><canvas width="34" height="30" style="display: inline-block; width: 34px; height: 30px; vertical-align: top"></canvas></div><h5 class="description-header">30%</h5><span class="description-text">Referrals</span></div><!-- /.description-block --><div class="description-block"><div class="sparkbar pad" data-color="#fff"><canvas width="34" height="30" style="display: inline-block; width: 34px; height: 30px; vertical-align: top"></canvas></div><h5 class="description-header">70%</h5><span class="description-text">Organic</span></div><!-- /.description-block --></div></div><!-- /.col --></div><!-- /.row --></div><!-- /.box-body --></div><!-- /.box --><div class="row"><div class="col-md-6"><!-- DIRECT CHAT --><div class="box box-warning direct-chat direct-chat-warning"><div class="box-header with-border"><h3 class="box-title">Direct Chat</h3><div class="box-tools pull-right"><span data-toggle="tooltip" title="3 New Messages" class="badge bg-yellow">3</span> <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button> <button type="button" class="btn btn-box-tool" data-toggle="tooltip" title="Contacts" data-widget="chat-pane-toggle"><i class="fa fa-comments"></i></button> <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body"><!-- Conversations are loaded here --><div class="direct-chat-messages"><!-- Message. Default to the left --><div class="direct-chat-msg"><div class="direct-chat-info clearfix"><span class="direct-chat-name pull-left">Alexander Pierce</span> <span class="direct-chat-timestamp pull-right">23 Jan 2:00 pm</span></div><!-- /.direct-chat-info --> <img class="direct-chat-img" src="dist/img/user1-128x128.jpg" alt="message user image"><!-- /.direct-chat-img --><div class="direct-chat-text">Is this template really for free? That\'s unbelievable!</div><!-- /.direct-chat-text --></div><!-- /.direct-chat-msg --><!-- Message to the right --><div class="direct-chat-msg right"><div class="direct-chat-info clearfix"><span class="direct-chat-name pull-right">Sarah Bullock</span> <span class="direct-chat-timestamp pull-left">23 Jan 2:05 pm</span></div><!-- /.direct-chat-info --> <img class="direct-chat-img" src="dist/img/user3-128x128.jpg" alt="message user image"><!-- /.direct-chat-img --><div class="direct-chat-text">You better believe it!</div><!-- /.direct-chat-text --></div><!-- /.direct-chat-msg --><!-- Message. Default to the left --><div class="direct-chat-msg"><div class="direct-chat-info clearfix"><span class="direct-chat-name pull-left">Alexander Pierce</span> <span class="direct-chat-timestamp pull-right">23 Jan 5:37 pm</span></div><!-- /.direct-chat-info --> <img class="direct-chat-img" src="dist/img/user1-128x128.jpg" alt="message user image"><!-- /.direct-chat-img --><div class="direct-chat-text">Working with AdminLTE on a great new app! Wanna join?</div><!-- /.direct-chat-text --></div><!-- /.direct-chat-msg --><!-- Message to the right --><div class="direct-chat-msg right"><div class="direct-chat-info clearfix"><span class="direct-chat-name pull-right">Sarah Bullock</span> <span class="direct-chat-timestamp pull-left">23 Jan 6:10 pm</span></div><!-- /.direct-chat-info --> <img class="direct-chat-img" src="dist/img/user3-128x128.jpg" alt="message user image"><!-- /.direct-chat-img --><div class="direct-chat-text">I would love to.</div><!-- /.direct-chat-text --></div><!-- /.direct-chat-msg --></div><!--/.direct-chat-messages--><!-- Contacts are loaded here --><div class="direct-chat-contacts"><ul class="contacts-list"><li><a href="#"><img class="contacts-list-img" src="dist/img/user1-128x128.jpg" alt="User Image"><div class="contacts-list-info"><span class="contacts-list-name">Count Dracula <small class="contacts-list-date pull-right">2/28/2015</small> </span><span class="contacts-list-msg">How have you been? I was...</span></div><!-- /.contacts-list-info --></a></li><!-- End Contact Item --><li><a href="#"><img class="contacts-list-img" src="dist/img/user7-128x128.jpg" alt="User Image"><div class="contacts-list-info"><span class="contacts-list-name">Sarah Doe <small class="contacts-list-date pull-right">2/23/2015</small> </span><span class="contacts-list-msg">I will be waiting for...</span></div><!-- /.contacts-list-info --></a></li><!-- End Contact Item --><li><a href="#"><img class="contacts-list-img" src="dist/img/user3-128x128.jpg" alt="User Image"><div class="contacts-list-info"><span class="contacts-list-name">Nadia Jolie <small class="contacts-list-date pull-right">2/20/2015</small> </span><span class="contacts-list-msg">I\'ll call you back at...</span></div><!-- /.contacts-list-info --></a></li><!-- End Contact Item --><li><a href="#"><img class="contacts-list-img" src="dist/img/user5-128x128.jpg" alt="User Image"><div class="contacts-list-info"><span class="contacts-list-name">Nora S. Vans <small class="contacts-list-date pull-right">2/10/2015</small> </span><span class="contacts-list-msg">Where is your new...</span></div><!-- /.contacts-list-info --></a></li><!-- End Contact Item --><li><a href="#"><img class="contacts-list-img" src="dist/img/user6-128x128.jpg" alt="User Image"><div class="contacts-list-info"><span class="contacts-list-name">John K. <small class="contacts-list-date pull-right">1/27/2015</small> </span><span class="contacts-list-msg">Can I take a look at...</span></div><!-- /.contacts-list-info --></a></li><!-- End Contact Item --><li><a href="#"><img class="contacts-list-img" src="dist/img/user8-128x128.jpg" alt="User Image"><div class="contacts-list-info"><span class="contacts-list-name">Kenneth M. <small class="contacts-list-date pull-right">1/4/2015</small> </span><span class="contacts-list-msg">Never mind I found...</span></div><!-- /.contacts-list-info --></a></li><!-- End Contact Item --></ul><!-- /.contatcts-list --></div><!-- /.direct-chat-pane --></div><!-- /.box-body --><div class="box-footer"><form action="#" method="post"><div class="input-group"><input type="text" name="message" placeholder="Type Message ..." class="form-control"> <span class="input-group-btn"><button type="button" class="btn btn-warning btn-flat">Send</button></span></div></form></div><!-- /.box-footer--></div><!--/.direct-chat --></div><!-- /.col --><div class="col-md-6"><!-- USERS LIST --><div class="box box-danger"><div class="box-header with-border"><h3 class="box-title">Latest Members</h3><div class="box-tools pull-right"><span class="label label-danger">8 New Members</span> <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button> <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body no-padding"><ul class="users-list clearfix"><li><img src="dist/img/user1-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">Alexander Pierce</a> <span class="users-list-date">Today</span></li><li><img src="dist/img/user8-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">Norman</a> <span class="users-list-date">Yesterday</span></li><li><img src="dist/img/user7-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">Jane</a> <span class="users-list-date">12 Jan</span></li><li><img src="dist/img/user6-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">John</a> <span class="users-list-date">12 Jan</span></li><li><img src="dist/img/user2-160x160.jpg" alt="User Image"> <a class="users-list-name" href="#">Alexander</a> <span class="users-list-date">13 Jan</span></li><li><img src="dist/img/user5-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">Sarah</a> <span class="users-list-date">14 Jan</span></li><li><img src="dist/img/user4-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">Nora</a> <span class="users-list-date">15 Jan</span></li><li><img src="dist/img/user3-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">Nadia</a> <span class="users-list-date">15 Jan</span></li></ul><!-- /.users-list --></div><!-- /.box-body --><div class="box-footer text-center"><a href="javascript:void(0)" class="uppercase">View All Users</a></div><!-- /.box-footer --></div><!--/.box --></div><!-- /.col --></div><!-- /.row --><!-- TABLE: LATEST ORDERS --><div class="box box-info"><div class="box-header with-border"><h3 class="box-title">Latest Orders</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button> <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body"><div class="table-responsive"><table class="table no-margin"><thead><tr><th>Order ID</th><th>Item</th><th>Status</th><th>Popularity</th></tr></thead><tbody><tr><td><a href="pages/examples/invoice.html">OR9842</a></td><td>Call of Duty IV</td><td><span class="label label-success">Shipped</span></td><td><div class="sparkbar" data-color="#00a65a" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top"></canvas></div></td></tr><tr><td><a href="pages/examples/invoice.html">OR1848</a></td><td>Samsung Smart TV</td><td><span class="label label-warning">Pending</span></td><td><div class="sparkbar" data-color="#f39c12" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top"></canvas></div></td></tr><tr><td><a href="pages/examples/invoice.html">OR7429</a></td><td>iPhone 6 Plus</td><td><span class="label label-danger">Delivered</span></td><td><div class="sparkbar" data-color="#f56954" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top"></canvas></div></td></tr><tr><td><a href="pages/examples/invoice.html">OR7429</a></td><td>Samsung Smart TV</td><td><span class="label label-info">Processing</span></td><td><div class="sparkbar" data-color="#00c0ef" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top"></canvas></div></td></tr><tr><td><a href="pages/examples/invoice.html">OR1848</a></td><td>Samsung Smart TV</td><td><span class="label label-warning">Pending</span></td><td><div class="sparkbar" data-color="#f39c12" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top"></canvas></div></td></tr><tr><td><a href="pages/examples/invoice.html">OR7429</a></td><td>iPhone 6 Plus</td><td><span class="label label-danger">Delivered</span></td><td><div class="sparkbar" data-color="#f56954" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top"></canvas></div></td></tr><tr><td><a href="pages/examples/invoice.html">OR9842</a></td><td>Call of Duty IV</td><td><span class="label label-success">Shipped</span></td><td><div class="sparkbar" data-color="#00a65a" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top"></canvas></div></td></tr></tbody></table></div><!-- /.table-responsive --></div><!-- /.box-body --><div class="box-footer clearfix"><a href="javascript:void(0)" class="btn btn-sm btn-info btn-flat pull-left">Place New Order</a> <a href="javascript:void(0)" class="btn btn-sm btn-default btn-flat pull-right">View All Orders</a></div><!-- /.box-footer --></div><!-- /.box --></div><!-- /.col --><div class="col-md-4"><!-- Info Boxes Style 2 --><div class="info-box bg-yellow"><span class="info-box-icon"><i class="ion ion-ios-pricetag-outline"></i></span><div class="info-box-content"><span class="info-box-text">Inventory</span> <span class="info-box-number">5,200</span><div class="progress"><div class="progress-bar" style="width: 50%"></div></div><span class="progress-description">50% Increase in 30 Days</span></div><!-- /.info-box-content --></div><!-- /.info-box --><div class="info-box bg-green"><span class="info-box-icon"><i class="ion ion-ios-heart-outline"></i></span><div class="info-box-content"><span class="info-box-text">Mentions</span> <span class="info-box-number">92,050</span><div class="progress"><div class="progress-bar" style="width: 20%"></div></div><span class="progress-description">20% Increase in 30 Days</span></div><!-- /.info-box-content --></div><!-- /.info-box --><div class="info-box bg-red"><span class="info-box-icon"><i class="ion ion-ios-cloud-download-outline"></i></span><div class="info-box-content"><span class="info-box-text">Downloads</span> <span class="info-box-number">114,381</span><div class="progress"><div class="progress-bar" style="width: 70%"></div></div><span class="progress-description">70% Increase in 30 Days</span></div><!-- /.info-box-content --></div><!-- /.info-box --><div class="info-box bg-aqua"><span class="info-box-icon"><i class="ion-ios-chatbubble-outline"></i></span><div class="info-box-content"><span class="info-box-text">Direct Messages</span> <span class="info-box-number">163,921</span><div class="progress"><div class="progress-bar" style="width: 40%"></div></div><span class="progress-description">40% Increase in 30 Days</span></div><!-- /.info-box-content --></div><!-- /.info-box --><div class="box box-default"><div class="box-header with-border"><h3 class="box-title">Browser Usage</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button> <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body"><div class="row"><div class="col-md-8"><div class="chart-responsive"><canvas id="pieChart" height="160" width="188" style="width: 188px; height: 160px"></canvas></div><!-- ./chart-responsive --></div><!-- /.col --><div class="col-md-4"><ul class="chart-legend clearfix"><li><i class="fa fa-circle-o text-red"></i> Chrome</li><li><i class="fa fa-circle-o text-green"></i> IE</li><li><i class="fa fa-circle-o text-yellow"></i> FireFox</li><li><i class="fa fa-circle-o text-aqua"></i> Safari</li><li><i class="fa fa-circle-o text-light-blue"></i> Opera</li><li><i class="fa fa-circle-o text-gray"></i> Navigator</li></ul></div><!-- /.col --></div><!-- /.row --></div><!-- /.box-body --><div class="box-footer no-padding"><ul class="nav nav-pills nav-stacked"><li><a href="#">United States of America <span class="pull-right text-red"><i class="fa fa-angle-down"></i> 12%</span></a></li><li><a href="#">India <span class="pull-right text-green"><i class="fa fa-angle-up"></i> 4%</span></a></li><li><a href="#">China <span class="pull-right text-yellow"><i class="fa fa-angle-left"></i> 0%</span></a></li></ul></div><!-- /.footer --></div><!-- /.box --><!-- PRODUCT LIST --><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Recently Added Products</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button> <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body"><ul class="products-list product-list-in-box"><li class="item"><div class="product-img"><img src="dist/img/default-50x50.gif" alt="Product Image"></div><div class="product-info"><a href="javascript:void(0)" class="product-title">Samsung TV <span class="label label-warning pull-right">$1800</span></a> <span class="product-description">Samsung 32" 1080p 60Hz LED Smart HDTV.</span></div></li><!-- /.item --><li class="item"><div class="product-img"><img src="dist/img/default-50x50.gif" alt="Product Image"></div><div class="product-info"><a href="javascript:void(0)" class="product-title">Bicycle <span class="label label-info pull-right">$700</span></a> <span class="product-description">26" Mongoose Dolomite Men\'s 7-speed, Navy Blue.</span></div></li><!-- /.item --><li class="item"><div class="product-img"><img src="dist/img/default-50x50.gif" alt="Product Image"></div><div class="product-info"><a href="javascript:void(0)" class="product-title">Xbox One <span class="label label-danger pull-right">$350</span></a> <span class="product-description">Xbox One Console Bundle with Halo Master Chief Collection.</span></div></li><!-- /.item --><li class="item"><div class="product-img"><img src="dist/img/default-50x50.gif" alt="Product Image"></div><div class="product-info"><a href="javascript:void(0)" class="product-title">PlayStation 4 <span class="label label-success pull-right">$399</span></a> <span class="product-description">PlayStation 4 500GB Console (PS4)</span></div></li><!-- /.item --></ul></div><!-- /.box-body --><div class="box-footer text-center"><a href="javascript:void(0)" class="uppercase">View All Products</a></div><!-- /.box-footer --></div><!-- /.box --></div><!-- /.col --></div><!-- /.row --></section><!-- /.content --></div><!-- /.content-wrapper -->');
$templateCache.put('app/layouts/layout.tpl.html','<div class="wrapper"><div ui-view="headBar" id="headBar"></div><div ui-view="sideBar"></div><div ui-view="content"></div><div ui-view="footer"></div><div ui-view="controlBar"></div></div><!-- ./wrapper -->');
$templateCache.put('app/login/login.html','<div class="login-page" style="background: transparent"><div class="login-box"><div class="login-logo"><!--<a href="../../index2.html"><b>{{vm.appName}}</b>{{vm.appSuffixName}}</a>--><!--<img src="content/images/UCLrenalU_1.png"/>--></div><!-- /.login-logo --><div class="login-box-body" style="opacity: 0.9;border-radius: 4px"><div style="text-align: center"><h3>Sign in</h3></div><br><div class="form-group has-error" ng-show="vm.authenticationError"><span class="help-block"><strong>Failed to sign in!</strong> {{vm.errorMessage}}</span></div><form method="post" name="loginForm" ng-submit="vm.login($event)"><div class="form-group has-feedback" data-ng-class="{\'has-error\': loginForm.username.$invalid && !loginForm.username.$pristine}"><input id="username" name="username" type="text" class="form-control" placeholder="Username" ng-model="vm.username" required="required" maxlength="40"> <span class="glyphicon glyphicon-user form-control-feedback"></span> <span class="help-block" data-ng-show="loginForm.username.$invalid && !loginForm.username.$pristine">Type your username.</span></div><div class="form-group has-feedback" data-ng-class="{\'has-error\': loginForm.password.$invalid && !loginForm.password.$pristine}"><input id="password" name="password" type="password" class="form-control" placeholder="Password" ng-model="vm.password" required="required" maxlength="40"> <span class="glyphicon glyphicon-lock form-control-feedback"></span> <span class="help-block" data-ng-show="loginForm.password.$invalid && !loginForm.password.$pristine">Type your password.</span></div><div class="row"><!--<div class="col-xs-8">--><!--<checkbox--><!--class="angular-bootstrap-checkboxbtn"--><!--ng-class="{\'btn-primary\': checked === true}"--><!--ng-model="vm.rememberMe">--><!--</checkbox>--><!--<span data-translate="login.form.rememberme">  &nbsp;Remember me</span>--><!--</div>&lt;!&ndash; /.col &ndash;&gt;--><div class="col-xs-4 col-lg-offset-8"><button type="submit" class="btn btn-primary btn-block btn-flat" data-ng-disabled="loginForm.$invalid">Sign In</button></div><!-- /.col --></div></form><p></p><!--<div class="alert alert-warning">--><!--<a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a>--><!--</div>--><!--<div class="social-auth-links text-center">--><!--<p>- OR -</p>--><!--<a href="#" class="btn btn-block btn-social btn-facebook btn-flat"><i class="fa fa-facebook"></i> Sign--><!--in using Facebook</a>--><!--<a href="#" class="btn btn-block btn-social btn-google btn-flat"><i class="fa fa-google-plus"></i> Sign--><!--in using Google+</a>--><!--</div>&lt;!&ndash; /.social-auth-links &ndash;&gt;--><!--<a href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">I forgot my password</a><br>--><!--<a href="register.html" class="text-center">Register a new membership</a>--></div><!-- /.login-box-body --></div><!-- /.login-box --></div>');
$templateCache.put('app/reports/reports.html','<section class="content-header"><h1 class="section-title">Reports</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><reports reports-group="vm.reportsGroup"></reports></section>');
$templateCache.put('app/sign/consent.html','<div class="box-header"><div class="text-center"><h3>United Lab: Unity Online\u2122 Terms of Use Amendment</h3></div></div><div class="box-body"><pre class="prettyprint">\n    <code class="text">\n        <ng-include src="\'app/sign/terms/01.html\'"></ng-include>\n    </code>\n</pre><div class="checkbox"><label><input type="checkbox" ng-model="vm.result.agree"> I agree with the Terms and Conditions.</label></div></div><div class="box-footer"><button type="button" class="btn btn-default" ui-sref="sign">Back</button> <button type="button" class="btn btn-info pull-right" ui-sref="sign.signature" ng-disabled="!vm.result.agree">Next</button></div>');
$templateCache.put('app/sign/finish.html','<div class="box-header"><div class="text-center"><h3>In you first login you must define your signature, please follow this wizard.</h3></div></div><div class="box-body"><p>Finish!!!</p></div><div class="box-footer"><button type="button" class="btn btn-default" ui-sref="sign.signature">Back</button> <button type="button" class="btn btn-info pull-right" ui-sref="home">Go Home</button></div>');
$templateCache.put('app/sign/sign.html','<section class="content-header"><h1>Signature Wizard</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-success"><div class="row"><div class="col-lg-1"></div><div class="col-lg-10"><jhi-alert-error></jhi-alert-error></div><div class="col-lg-1"></div></div><!-- use ng-submit to catch the form submission and use our Angular function --><form id="signup-form" ng-submit="processForm()"><!-- our nested state views will be injected here --><div id="form-views" ui-view></div></form></div></div></div></section>');
$templateCache.put('app/sign/signature.html','<div class="box-header"><div class="text-center"><h3>In this step you must sign and then press "Finish".</h3></div></div><div class="box-body"><!--<button class="btn btn-danger" ng-click="vm.getData()">Get Data</button>--><!--<button class="btn btn-danger" ng-click="vm.disable()">Disable</button>--><!--<button class="btn btn-danger" ng-click="vm.enable()">Enable</button>--><!--<img src="{{vm.hash}}" alt="signature image" />--><div class="row"><div class="col-xs-12 col-md-12 col-lg-12"><j-signature sig="customSignature" bg-color="#EEEEEE" color="#00008B"></j-signature></div></div></div><div class="box-footer"><button type="button" class="btn btn-default" ui-sref="sign.consent">Back</button> <button type="button" class="btn btn-info pull-right" ng-disabled="!vm.result.signed" ng-click="vm.save()">Finish</button></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<!-- Content Header (Page header) --><section class="content-header"><h1>Change Password</h1><div ncy-breadcrumb></div></section><!-- Main content --><section class="content"><div class="row"><div class="col-xs-12"><!-- TABLE: LATEST ORDERS --><div class="box"><div class="box-body"><div class="row"><div class="col-md-12"><h2>Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div></div><!-- /.box --></div></div></section><!-- /.content -->');
$templateCache.put('app/account/settings/settings.html','<!-- Content Header (Page header) --><section class="content-header"><h1>Settings</h1><div ncy-breadcrumb></div></section><!-- Main content --><section class="content"><div class="row"><div class="col-md-12"><!-- TABLE: LATEST ORDERS --><div class="box"><div class="box-body"><div class="row"><div class="col-md-12"><h2>User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div></div><!-- /.box --></div></div></section><!-- /.content -->');
$templateCache.put('app/admin/audits/audits.html','<!-- Content Header (Page header) --><section class="content-header"><h1>Audits</h1><div ncy-breadcrumb></div></section><!-- Main content --><section class="content"><div class="row"><div class="col-md-12"><!-- TABLE: LATEST ORDERS --><div class="box"><div class="box-body"><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span><span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div><!-- /.box-body --><div class="box-footer clearfix"><!--<a href="javascript:void(0)" class="btn btn-sm btn-info btn-flat pull-left">Place New Order</a>--><!--<a href="javascript:void(0)" class="btn btn-sm btn-default btn-flat pull-right">View All--><!--Orders</a>--></div><!-- /.box-footer --></div><!-- /.box --></div></div></section><!-- /.content -->');
$templateCache.put('app/admin/configuration/configuration.html','<section class="content-header"><h1>Configuration</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><div class="table-responsive"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div></div></div></div></div></div></div></div></section>');
$templateCache.put('app/admin/docs/docs.html','<section class="content"><div class="row"><div class="col-xs-12"><div class="box-body"><iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe></div></div></div></section>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm" ng-submit="vm.confirmReindex()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span>Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<section class="content-header"><div class="clearfix"><h1>Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p>This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p>This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><button type="button" class="btn btn-primary pull-right" ui-sref="elasticsearch-reindex.dialog"><span class="glyphicon glyphicon-exclamation-sign"></span> <span>Go</span></button></div></section>');
$templateCache.put('app/admin/entity-audit/entity-audit.detail.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Audit Details</h4></div><div class="modal-body pad"><div><strong>{{vm.audit.action}} action was performed on below data</strong><br><br><del class="diff diff-key">Old/Removed value</del> &nbsp; <ins class="diff diff-key">New/Added value</ins></div><br><label>Changed Fields</label><pre id="resultChanges" ng-bind-html="vm.diffValueChanges"></pre><label>All Fields</label><pre id="result" ng-bind-html="vm.diffValue"></pre></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/entity-audit/entity-audits.html','<div ng-cloak class="pad"><div class="row"><h3 class="col-sm-10">Entity Audits</h3><div class="col-lg-2"><button class="btn btn-primary pull-right" ng-click="vm.updateToNewField()"><i class="glyphicon glyphicon-cog"></i>&nbsp;Update to new Field</button></div></div><jhi-alert></jhi-alert><div class="row"><div class="col-md-12 pad"><h4>Filter</h4><form name="auditForm" role="form" novalidate show-validation><div class="row"><div class="col-md-8 form-group"><label>Entity/Table</label><select class="input-sm form-control" name="qualifiedName" id="qualifiedName" required ng-options="vm.getEntityName(entity) for entity in vm.entities" ng-model="vm.qualifiedName"></select><div ng-show="auditForm.qualifiedName.$invalid"><p class="help-block" ng-show="auditForm.qualifiedName.$error.required">This field is required</p></div></div><div class="col-md-4 form-group"><label>Limit to</label><select class="input-sm form-control" name="limit" id="limit" required ng-options="option for option in vm.limits" ng-model="vm.limit"></select></div></div><div class="row pad"><button ng-disabled="auditForm.$invalid" class="btn btn-primary pull-right" ng-click="vm.loadChanges()"><i class="glyphicon glyphicon-import"></i>&nbsp;Load Change List</button></div></form></div></div><div ng-show="!vm.loading"><div class="table-responsive" ng-if="vm.audits.length > 0"><p ng-if="vm.qualifiedName">Last <strong>{{vm.limit}}</strong>Changes for <strong>{{vm.getEntityName(vm.qualifiedName)}}</strong></p><form class="form-inline"><div class="form-group"><label for="searchField">Filter:</label><input type="text" class="form-control" id="searchField" ng-model="filter.$" placeholder="global filter"></div><div class="form-group"><input type="text" class="form-control" id="searchFieldEntityId" ng-model="filter.entityId" placeholder="entity id filter"></div></form><table class="table table-bordered table-hover table-striped"><thead><tr><th>Entity Id</th><th>Action</th><th>Version</th><th>Value</th><th>Modified Date</th><th>Modified By</th><th><i class="glyphicon glyphicon-eye-open"></i></th></tr></thead><tbody><tr ng-repeat="audit in vm.audits | filter:filter"><td>{{audit.entityId}}</td><td>{{audit.action}}</td><td>{{audit.commitVersion}}</td><td><pre class="audit-obj" ng-bind-html="vm.format(audit.entityValue)"></pre></td><!-- comment above line and uncomment below to have Table view of value --><!--td class="no-pad">\n                        <div class="audit-obj">\n                            <table class="table table-bordered table-hover no-margin">\n                                <tr>\n                                    <th>Field</th>\n                                    <th>Value</th>\n                                </tr>\n                                <tr ng-repeat="(k,v) in audit.entityValue" ng-if="!vm.isObject(v)">\n                                    <td>{{k}}</td>\n                                    <td>\n                                        <span ng-if="vm.isDate(k)">{{v | date:\'medium\'}}</span>\n                                        <span ng-if="!vm.isDate(k)">{{v}}</span>\n                                    </td>\n                                </tr>\n                            </table>\n                        </div>\n                    </td--><td>{{audit.modifiedDate | date:\'medium\'}}</td><td>{{audit.modifiedBy}}</td><td><button type="button" ng-click="vm.openChange(audit)" uib-tooltip="View Audit Change Details" uib-tooltip-placement="auto" class="btn btn-info btn-xs"><i class="glyphicon glyphicon-eye-open"></i></button></td></tr></tbody></table></div><p ng-if="vm.displayedChanges.length == 0">No Data found for the filters</p></div></div>');
$templateCache.put('app/admin/health/health.html','<section class="content-header"><h1>Health Checks</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><div class="table-responsive"><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)"> {{ health.status }} </span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div></div></div></div></div></div></div></div></section>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}} </h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<section class="content-header"><h1>Logs</h1><small>There are {{ vm.loggers.length }} loggers.</small><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><span>Filter</span> <input type="text" ng-model="filter" class="form-control"></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div></div></div></div></div></div></div></section>');
$templateCache.put('app/admin/metrics/metrics.html','<section class="content-header"><h1>Application Metrics</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value  | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value  | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value  | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value  | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value  | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value  | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value  | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div></div></div></div></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b>- <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right"> {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}} </td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}} </td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}} </td><td class="text-right"> {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}} </td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right"> {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}} </td><td class="text-right"> {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}} </td><td class="text-right"> {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}} </td><td class="text-right"> {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}} </td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right"> {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}} </td><td class="text-right"> {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}} </td><td class="text-right"> {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}} </td><td class="text-right"> {{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}} </td></tr></tbody></table></div></div></div></div></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div></div></div></div></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><h3>Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Cache name</th><th class="text-right">Objects</th><th class="text-right">Hits</th><th class="text-right">Misses</th><th class="text-right">Eviction count</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td></tr></tbody></table></div></div></div></div></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value  | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div></div></div></div></div></div></div></section>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace"> {{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<section class="content-header"><h1>User "{{vm.user.login}}"</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><!--<div class="box-header">\n                    <span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control">\n                </div>--><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><div class="table-responsive"><dl class="dl-horizontal"><dt><span>Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span>First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span>Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span>Email</span></dt><dd>{{vm.user.email}}</dd><dt><span>Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span>Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span>Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span>Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span>Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span>Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div></div></div></div></div></div></div></div></section>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span>Activated</span></label></div><div class="form-group"><label>Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<section class="content-header"><h1>Users</h1><small>management</small><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span></button></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th><span>Profiles</span></th><th jh-sort-by="createdDate"><span>Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" style="cursor: pointer">Activated</span></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div></div></section>');
$templateCache.put('app/components/tpl/breadcrumb.tpl.html','<ul class="breadcrumb"><li ng-repeat="step in steps" ng-class="{active: $last}" ng-switch="$last || !!step.abstract"><a ng-switch-when="false" href="{{step.ncyBreadcrumbLink}}"><i data-ng-show="$index===0" class="fa fa-home"></i>{{step.ncyBreadcrumbLabel}} </a><span ng-switch-when="true">{{step.ncyBreadcrumbLabel}}</span></li></ul>');
$templateCache.put('app/components/tpl/datatables-tpl.html','<section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4 no-padding-left"></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerypatient-result" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/components/udt/j-signature.html','<div id="signature"><div id="jSignature"></div><button class="btn btn-danger" ng-click="reset()"><span class="glyphicon glyphicon-erase"></span> <span>Clear</span></button><!--<button ng-click="getData()">getData</button>--><!--<button ng-click="setData()">setData</button>--></div>');
$templateCache.put('app/entities/access/access-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.access.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Access?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/access/access-detail.html','<div><h2><span>Access</span> {{vm.access.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>A Type</span></dt><dd><span>{{vm.access.aType}}</span></dd><dt><span>Is Active</span></dt><dd><span>{{vm.access.isActive}}</span></dd><dt><span>Is Primary</span></dt><dd><span>{{vm.access.isPrimary}}</span></dd><dt><span>Placed By</span></dt><dd><span>{{vm.access.placedBy}}</span></dd><dt><span>Placement Date</span></dt><dd><span>{{vm.access.placementDate | date:\'mediumDate\'}}</span></dd><dt><span>No Active Other</span></dt><dd><span>{{vm.access.noActiveOther}}</span></dd><dt><span>Placement Site Other</span></dt><dd><span>{{vm.access.placementSiteOther}}</span></dd><dt><span>Upper Arm Right</span></dt><dd><span>{{vm.access.upperArmRight}}</span></dd><dt><span>Upper Arm Left</span></dt><dd><span>{{vm.access.upperArmLeft}}</span></dd><dt><span>Forearm Right</span></dt><dd><span>{{vm.access.forearmRight}}</span></dd><dt><span>Forearm Left</span></dt><dd><span>{{vm.access.forearmLeft}}</span></dd><dt><span>Femoral Vein Right</span></dt><dd><span>{{vm.access.femoralVeinRight}}</span></dd><dt><span>Femoral Vein Left</span></dt><dd><span>{{vm.access.femoralVeinLeft}}</span></dd><dt><span>Internal Jugular Vein Right</span></dt><dd><span>{{vm.access.internalJugularVeinRight}}</span></dd><dt><span>Internal Jugular Vein Left</span></dt><dd><span>{{vm.access.internalJugularVeinLeft}}</span></dd><dt><span>Axillary Vein Right</span></dt><dd><span>{{vm.access.axillaryVeinRight}}</span></dd><dt><span>Axillary Vein Left</span></dt><dd><span>{{vm.access.axillaryVeinLeft}}</span></dd><dt><span>Subclavian Vein Right</span></dt><dd><span>{{vm.access.subclavianVeinRight}}</span></dd><dt><span>Subclavian Vein Left</span></dt><dd><span>{{vm.access.subclavianVeinLeft}}</span></dd><dt><span>Button Hole</span></dt><dd><span>{{vm.access.buttonHole}}</span></dd><dt><span>Avfg No Active Specify</span></dt><dd><span>{{vm.access.avfgNoActiveSpecify}}</span></dd><dt><span>Cvc Gt 90</span></dt><dd><span>{{vm.access.cvcGt90}}</span></dd><dt><span>Cvc No Active Specify Cvc</span></dt><dd><span>{{vm.access.cvcNoActiveSpecifyCvc}}</span></dd><dt><span>Cvc Type</span></dt><dd><span>{{vm.access.cvcType}}</span></dd><dt><span>Patient</span></dt><dd><a ui-sref="patient-detail({id:vm.access.patient.id})">{{vm.access.patient.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="access-detail.edit({id:vm.access.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/access/access-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAccessLabel">Create or edit a Access - {{vm.access.aType == \'AVF\' ? \'Arteriovenous Fistula (AVF)\' : (vm.access.aType == \'AVG\' ? \'Arteriovenous Graft (AVG)\' : \'Central Venous Catheter (CVC)\')}} </h4></div><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><fieldset ng-disabled="!vm.editing"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_aType">Access Type</label><select class="form-control" name="aType" ng-model="vm.access.aType" id="field_aType" required ng-disabled="vm.access.id"><option value="AVF">Arteriovenous Fistula (AVF)</option><option value="AVG">Arteriovenous Graft (AVG)</option><option value="CVC">Central Venous Catheter (CVC)</option></select><div ng-show="editForm.aType.$invalid"><p class="help-block" ng-show="editForm.aType.$error.required">This field is required.</p></div></div><div ng-if="vm.access.aType==\'AVF\'"><fieldset><ng-include src="\'app/entities/access/tpl/avf-tpl.html\'"></ng-include></fieldset></div><div ng-if="vm.access.aType==\'AVG\'"><fieldset><ng-include src="\'app/entities/access/tpl/avg-tpl.html\'"></ng-include></fieldset></div><div ng-if="vm.access.aType==\'CVC\'"><fieldset><ng-include src="\'app/entities/access/tpl/cvc-tpl.html\'"></ng-include></fieldset></div></div></fieldset><div class="modal-footer"><!--<button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">--><!--<span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span>--><!--</button>--><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" ng-show="vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-primary" ng-click="vm.editing = !vm.editing" ng-if="vm.access.patient.status" ng-show="!vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Edit Information</span></button></div></form>');
$templateCache.put('app/entities/access/accesses.html','<section class="content"><div class="row"><div class="col-xs-12"><button type="button" class="btn btn-primary" ui-sref="access-new" ng-if="vm.patient.status"><span class="glyphicon glyphicon-add"></span> <span>New Access</span></button><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></section>');
$templateCache.put('app/entities/billing/billing.html','<section class="content-header" ui-view="content"><ods-reports reports-group="vm.reportsGroup"></ods-reports></section>');
$templateCache.put('app/entities/billing-frequency/billing-frequencies.html','<section class="content-header"><h1>Billing Frequencies</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="billing-frequency.new"><span class="glyphicon glyphicon-flash"></span> <span>New Billing Frequency</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/billing-frequency/billing-frequency-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.billingFrequency.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Billing Frequency?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/billing-frequency/billing-frequency-detail.html','<div><h2><span>Billing Frequency</span> {{vm.billingFrequency.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.billingFrequency.name}}</span></dd><dt><span>Days</span></dt><dd><span>{{vm.billingFrequency.days}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="billing-frequency-detail.edit({id:vm.billingFrequency.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/billing-frequency/billing-frequency-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBillingFrequencyLabel">Create or edit a Billing Frequency</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.billingFrequency.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.billingFrequency.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.billingFrequency.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_days">Days</label><input type="number" class="form-control" name="days" id="field_days" ng-model="vm.billingFrequency.days" required><div ng-show="editForm.days.$invalid"><p class="help-block" ng-show="editForm.days.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.days.$error.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/bundle/bundle-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.bundle.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Bundle?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/bundle/bundle-detail.html','<div><h2><span>Bundle</span> {{vm.bundle.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Dialysis Modality</span></dt><dd><span>{{vm.bundle.dialysisModality}}</span></dd><dt><span>Compendium</span></dt><dd><a ui-sref="compendium-detail({id:vm.bundle.compendium.id})">{{vm.bundle.compendium.id}}</a></dd><dt><span>Billing Frequency</span></dt><dd><a ui-sref="billing-frequency-detail({id:vm.bundle.billingFrequency.id})">{{vm.bundle.billingFrequency.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="bundle-detail.edit({id:vm.bundle.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/bundle/bundle-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBundleLabel">Create or edit a Bundle</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.bundle.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.bundle.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_dialysisModality">Dialysis Modality</label><select class="form-control" name="dialysisModality" ng-model="vm.bundle.dialysisModality" id="field_dialysisModality" required ng-change="vm.onChangeDialysisModality()"><option value="HEMO_DIALYSIS">HEMO DIALYSIS</option><option value="PERITONEAL_DIALYSIS">PERITONEAL DIALYSIS</option></select><div ng-show="editForm.dialysisModality.$invalid"><p class="help-block" ng-show="editForm.dialysisModality.$error.required">This field is required.</p></div></div><div class="form-group"><label for="field_compendium">Compendium</label><ui-select ng-model="vm.bundle.compendium" close-on-select="true" title="Compendium" id="field_compendium" ng-required="true" name="compendium"><ui-select-match allow-clear="true" placeholder="Select compendium...">{{$select.selected.code +\n                    \', \'+ $select.selected.description}} </ui-select-match><ui-select-choices repeat="compendium in vm.compendiums | filter: $select.search"><div ng-bind-html=" compendium.code + \', \' + compendium.description | highlight: $select.search"></div><small ng-bind-html="(compendium.wGroup ? compendium.wGroup : \'\') +\n                    (compendium.specimen ? (compendium.wGroup ? \', \' : \'\') + compendium.specimen : \'\') | highlight: $select.search"></small></ui-select-choices></ui-select><div ng-show="editForm.compendium.$invalid"><p class="help-block" ng-show="editForm.compendium.$error.required">This field is required.</p></div></div><div class="form-group"><label for="field_billingFrequency">Billing Frequency</label><ui-select ng-model="vm.bundle.billingFrequency" close-on-select="true" title="Billing Frequency" id="field_billingFrequency" ng-required="true" name="billingFrequency"><ui-select-match allow-clear="true" placeholder="Select compendium...">{{$select.selected.name +\n                    \', \'+ $select.selected.days}} </ui-select-match><ui-select-choices repeat="billingFrequency in vm.billingfrequencies | filter: $select.search"><div ng-bind-html=" billingFrequency.name + \', \' + billingFrequency.days | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.billingFrequency.$invalid"><p class="help-block" ng-show="editForm.billingFrequency.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/bundle/bundles.html','<section class="content-header"><h1>Bundle</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="bundle.new"><span class="glyphicon glyphicon-flash"></span> <span>New Bundle</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/calendar/calendar.html','<section class="content"><div class="row"><div class="col-lg-12"><div class="box box-primary"><div class="box-body"><div ui-calendar="vm.calendarConfig.calendar" ng-model="vm.eventSources" calendar="myCalendar"></div></div></div></div></div></section>');
$templateCache.put('app/entities/care-team/care-team-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.careTeam.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Care Team?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/care-team/care-team-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProblemListLabel">Care Team</h4></div><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><fieldset ng-disabled="!vm.editing"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-lg-12"><div class="form-group"><label for="field_care_form_careTeamSpecialty">Care Team Specialty</label><select class="form-control" id="field_care_form_careTeamSpecialty" name="care_form_careTeamSpecialty" ng-model="vm.careTeam.careTeamSpecialty" ng-options="careTeamSpecialty as careTeamSpecialty.name for careTeamSpecialty in vm.careteamspecialties track by careTeamSpecialty.id" required><option value=""></option></select><div ng-show="editForm.care_form_careTeamSpecialty.$invalid"><p class="help-block" ng-show="editForm.care_form_careTeamSpecialty.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_care_form_lastName">Last Name</label><input type="text" class="form-control" name="care_form_lastName" id="field_care_form_lastName" ng-model="vm.careTeam.lastName" required><div ng-show="editForm.care_form_lastName.$invalid"><p class="help-block" ng-show="editForm.care_form_lastName.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_care_form_firstName">First Name</label><input type="text" class="form-control" name="care_form_firstName" id="field_care_form_firstName" ng-model="vm.careTeam.firstName" required><div ng-show="editForm.care_form_firstName.$invalid"><p class="help-block" ng-show="editForm.care_form_firstName.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_care_form_phone">Phone</label><input type="text" class="form-control" name="care_form_phone" id="field_care_form_phone" ng-model="vm.careTeam.phone" ui-mask="(999) 999-9999" required><div ng-show="editForm.care_form_phone.$invalid"><p class="help-block" ng-show="editForm.care_form_phone.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_care_form_email">Email</label><input type="email" class="form-control" name="care_form_email" id="field_care_form_email" ng-model="vm.careTeam.email" required><div ng-show="editForm.care_form_email.$invalid"><p class="help-block" ng-show="editForm.care_form_email.$error.required">This field is required.</p></div><div><p class="help-block" ng-show="editForm.care_form_email.$error.email">Not valid email.</p></div></div></div></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" ng-show="vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-primary" ng-click="vm.editing = !vm.editing" ng-if="vm.careTeam.patient.status" ng-show="!vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Edit Information</span></button></div></form>');
$templateCache.put('app/entities/care-team/care-teams.html','<section class="content"><div class="row"><div class="col-xs-12"><button type="button" class="btn btn-primary" ui-sref="care-team-new" ng-if="vm.patient.status"><span class="glyphicon glyphicon-add"></span> <span>New Care Team</span></button><table datatable="" dt-options="vm.careTeamsDtOptions" dt-columns="vm.careTeamsDtColumns" dt-instance="vm.careTeamsDtInstance" class="table table-striped table-bordered"></table></div></div></section>');
$templateCache.put('app/entities/care-team-specialty/care-team-specialties.html','<section class="content-header"><h1>Care Team Specialties</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="care-team-specialty.new"><span class="glyphicon glyphicon-flash"></span> <span>New Care Team Specialty</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerycare-team-specialty" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/care-team-specialty/care-team-specialty-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.careTeamSpecialty.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Care Team Specialty?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/care-team-specialty/care-team-specialty-detail.html','<div><h2><span>Care Team Specialty</span> {{vm.careTeamSpecialty.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.careTeamSpecialty.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.careTeamSpecialty.corporation.id})">{{vm.careTeamSpecialty.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="care-team-specialty-detail.edit({id:vm.careTeamSpecialty.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/care-team-specialty/care-team-specialty-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCareTeamSpecialtyLabel">Create or edit a Care Team Specialty</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.careTeamSpecialty.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/clinic/clinic-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.clinic.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Clinic?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/clinic/clinic-detail.html','<section class="content-header"><h1 class="section-title"><i class="fa fa-hospital-o"></i> {{vm.clinic.name}} <!--<small>Phone: {{vm.clinic.phone | phone}}</small>--></h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Contract Expire: {{vm.clinic.contractExp | date : mediumDate}}</h3></div><jhi-alert-error></jhi-alert-error><div class="box-body"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" select="vm.keepActiveTab(0)" heading="Clinic Information"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/clinic/tpl/info-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="1" select="vm.keepActiveTab(1)" heading="Billing Information"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/clinic/tpl/billing-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="2" select="vm.keepActiveTab(2)" heading="Clinical Operations"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/clinic/tpl/operation-tpl.html\'"></ng-include></fieldset></uib-tab></uib-tabset><div><div class="pull-right"><button type="button" class="btn btn-info" ui-sref="clinic-edit">Update Information</button></div></div></div></div></div></div></section>');
$templateCache.put('app/entities/clinic/clinic-new.html','<section class="content-header"><h1><i class="fa fa-hospital-o"></i> {{vm.clinic.name}} <small>Phone: {{vm.clinic.phone | phone}}</small></h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Contract Expire: {{vm.clinic.contractExp | date : mediumDate}}</h3></div><jhi-alert-error></jhi-alert-error><div class="box-body"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" select="vm.keepActiveTab(0)" heading="Clinic Information"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/clinic/tpl/info-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="1" select="vm.keepActiveTab(1)" heading="Billing Information"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/clinic/tpl/billing-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="2" select="vm.keepActiveTab(2)" heading="Clinical Operations"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/clinic/tpl/operation-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="3" select="vm.keepActiveTab(3)" heading="Corporation" has-any-authority="ROLE_ADMIN"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/clinic/tpl/corporation-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="4" select="vm.keepActiveTab(4)" heading="Billing Configuration" has-any-authority="ROLE_ADMIN"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/clinic/tpl/billing-price-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="5" select="vm.keepActiveTab(5)" heading="EMR Integration" has-any-authority="ROLE_ADMIN"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/clinic/tpl/emr-integration-tpl.html\'"></ng-include></fieldset></uib-tab></uib-tabset><div><div class="pull-right"><button type="button" class="btn btn-default" ui-sref="home"><i class="fa fa-times"></i> Cancel</button> <button type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="vm.form.clinic_info_form.$invalid || vm.form.billing_form.$invalid ||\n                                    vm.form.clinic_operation.$invalid || vm.form.corp_form.$invalid">Save</button></div></div></div></div></div></div></section>');
$templateCache.put('app/entities/clinic/clinics.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="navbar-form navbar-left" style="margin-left: -15px"><button class="btn btn-primary" ui-sref="{{vm.entityStateName}}"><span class="glyphicon glyphicon-plus"></span><span>New {{vm.entityClassHumanized}}</span></button></div><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input type="text" class="form-control" ng-model="vm.searchQuery" size="80" id="searchQueryclinic" placeholder="Query" ng-change="vm.search()"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/clinic-schedule-detail/machine-barcode-detail.html','<section class="content-header"><h1><i class="fa fa-barcode"></i> Barcode {{vm.barcode.id}} - Details</h1><div ncy-breadcrumb class="breadcrumb"></div></section><div class="pad no-print"><div class="callout callout-success" style="margin-bottom: 0!important; padding: 10px !important"><h4><i class="fa fa-info"></i> Note:</h4>This order has been processed.</div></div><section class="content"><div class="row"><div class="col-md-3"><div class="box box-primary"><div class="box-body box-profile"><!--<img data-ng-src="{{\'data:\' + vm.patient.pictureContentType + \';base64,\' + vm.patient.picture}}"--><!--class="profile-user-img img-responsive img-circle"/>--><h3 class="profile-username text-center">{{vm.machine.name}}</h3><p class="text-muted text-center">ID: {{vm.machine.id}}</p><ul class="list-group list-group-unbordered"><li class="list-group-item"><b>Schedule Day</b> <span class="pull-right">{{vm.barcode.collectedDate | date:\'mediumDate\'}}</span></li><li class="list-group-item"><b>Barcode</b> <span class="pull-right">{{vm.barcode.id}}</span></li><li class="list-group-item"><b>View Order</b> <span class="pull-right"><a ui-sref="env-order-detail({id: vm.machine.id, oid: vm.barcode.orderId})">{{vm.barcode.orderId}}</a></span></li></ul></div></div></div><div class="col-md-9"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-body"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" heading="Test List"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></uib-tab><uib-tab index="1" heading="Results" ng-if="vm.envResult.id"><div ui-view="results"></div></uib-tab></uib-tabset></div></div></div></div></div></div></section>');
$templateCache.put('app/entities/clinic-schedule-detail/patient-barcode-detail.html','<section class="content-header"><h1><i class="fa fa-barcode"></i> Barcode {{vm.barcode.id}} - Details</h1><div ncy-breadcrumb class="breadcrumb"></div></section><div class="pad no-print"><div class="callout callout-success" style="margin-bottom: 0!important; padding: 10px !important"><h4><i class="fa fa-info"></i> Note:</h4>This order has been processed.</div></div><section class="content"><div class="row"><div class="col-md-3"><div class="box box-primary"><div class="box-body box-profile"><img data-ng-src="{{\'data:\' + vm.patient.patientPicture.pictureContentType + \';base64,\' + vm.patient.patientPicture.picture}}" class="profile-user-img img-responsive img-circle"><h3 class="profile-username text-center">{{vm.patient.lastName + \', \' + vm.patient.firstName + \' \' + vm.patient.middleInitial}}</h3><p class="text-muted text-center">MRN: {{vm.patient.mrn}}</p><ul class="list-group list-group-unbordered"><li class="list-group-item"><b>D.O.B</b> <span class="pull-right">{{vm.patient.dob | date:\'mediumDate\'}}</span></li><li class="list-group-item"><b>Schedule Day</b> <span class="pull-right">{{vm.barcode.collectedDate | date:\'mediumDate\'}}</span></li><li class="list-group-item"><b>Physician</b> <span class="pull-right">{{vm.barcode.physicianTitle + \' \'\n                            + vm.barcode.physicianLastName + \', \' + vm.barcode.physicianFirstName}}</span></li><li class="list-group-item"><b>Barcode</b> <span class="pull-right">{{vm.barcode.id}}</span></li></ul></div></div></div><div class="col-md-9"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-body"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" heading="Test List"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></uib-tab><uib-tab index="1" heading="Results" ng-if="vm.patientResult.id"><div ui-view="results"></div></uib-tab></uib-tabset></div></div></div></div></div></div></section>');
$templateCache.put('app/entities/clinic-schedule-detail/patient-barcode-result-dets.html','<section class="content"><div class="row"><div class="col-xs-12"><div class="row"><div class="col-lg-4"><div class="input-group"><ui-select ng-model="vm.pdf" title="Choose a document" ng-disabled="false"><ui-select-match placeholder="Documents"> {{$select.selected.name}}</ui-select-match><ui-select-choices repeat="pdf in vm.patientResultFiles | propsFilter: {name: $select.search}"><div ng-bind-html="pdf.name | highlight: $select.search"></div><small>Date: {{pdf.createdDate | date:\'MM/dd/yy HH:ss\'}} </small></ui-select-choices></ui-select><span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.getPDF()"><span class="glyphicon glyphicon-eye-open"></span></button></span></div></div><div class="col-lg-5 col-lg-offset-3"><div class="input-group"><input type="text" class="form-control" ng-model="vm.searchQuery" popover-class="" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button></span></div></div></div><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></section>');
$templateCache.put('app/entities/compendium/compendium-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.compendium.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Compendium?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/compendium/compendium-detail.html','<div><h2><span>Compendium</span> {{vm.compendium.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Code</span></dt><dd><span>{{vm.compendium.code}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.compendium.description}}</span></dd><dt><span>W Group</span></dt><dd><span>{{vm.compendium.wGroup}}</span></dd><dt><span>Specimen</span></dt><dd><span>{{vm.compendium.specimen}}</span></dd><dt><span>Units</span></dt><dd><span>{{vm.compendium.units}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="compendium-detail.edit({id:vm.compendium.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/compendium/compendium-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCompendiumLabel">Create or edit a Compendium</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.compendium.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.compendium.id" readonly="readonly"></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" required ng-model="vm.compendium.code"><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">Internal Code</label><ui-select ng-model="vm.compendium.intCode" close-on-select="true" title="Internal Code"><ui-select-match allow-clear="true" placeholder="Select internal code..."> {{$select.selected.intCode +\n                            \', \'+ $select.selected.code}} </ui-select-match><ui-select-choices repeat="rptMetadata in vm.rptMetadatas | filter: $select.search"><div ng-bind-html=" rptMetadata.intCode + \', \' + rptMetadata.code | highlight: $select.search"></div><small ng-bind-html="rptMetadata.description | highlight: $select.search"></small></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.compendium.description"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_wGroup">W Group</label><input type="text" class="form-control" name="wGroup" id="field_wGroup" ng-model="vm.compendium.wGroup"></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_abbr">Abbr</label><input type="text" class="form-control" name="abbr" id="field_abbr" ng-model="vm.compendium.abbr"></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_specimen">Specimen</label><input type="text" class="form-control" name="specimen" id="field_specimen" ng-model="vm.compendium.specimen"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_units">Units</label><input type="text" class="form-control" name="units" id="field_units" ng-model="vm.compendium.units"></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_units">Cut Off</label><input type="text" class="form-control" name="cutOff" id="field_cutOff" ng-model="vm.compendium.cutOff"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">Report Group</label><ui-select ng-model="vm.compendium.compendiumReportGroup" close-on-select="true" title="Report Group"><ui-select-match allow-clear="true" placeholder="Select Report Group..."> {{$select.selected.name}} </ui-select-match><ui-select-choices repeat="compendiumReportGroup in vm.compendiumReportGroups | filter: $select.search"><div ng-bind-html="compendiumReportGroup.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label class="control-label">Tubes</label><ui-select id="field_tubes" name="tubes" multiple="multiple" required ng-model="vm.compendium.tubes" close-on-select="false" title="Tubes"><ui-select-match placeholder="Select tubes...">{{$item.name}}</ui-select-match><ui-select-choices repeat="tube in vm.tubes"><div ng-bind-html="tube.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.tubes.$invalid"><p class="help-block" ng-show="editForm.tubes.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label class="control-label">Extra Tubes</label><ui-select id="field_extra_tubes" name="extra_tubes" multiple="multiple" ng-model="vm.compendium.extraTubes" close-on-select="false" title="Extra Tubes"><ui-select-match placeholder="Select extra tubes...">{{$item.name}}</ui-select-match><ui-select-choices repeat="tube in vm.tubes"><div ng-bind-html="tube.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">CPT</label><input type="text" class="form-control" name="cpt" id="field_cpt" ng-model="vm.compendium.cpt"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">List Price</label><input type="number" class="form-control" name="list_price" min="0" id="field_list_price" ng-model="vm.compendium.listPrice"></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label class="control-label">Panel</label><ui-select id="field_panels" name="panels" multiple="multiple" ng-model="vm.compendium.panels" title="Compendium"><ui-select-match placeholder="Select Test...">{{$item.code + \' - \' + $item.description}}</ui-select-match><ui-select-choices repeat="compendium in vm.compendiums  | propsFilter: {code: $select.search, description: $select.search}"><div ng-bind-html="compendium.code"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_description">Revenue Code</label><input type="text" class="form-control" name="revenue_code" id="field_revenue_code" ng-model="vm.compendium.revenueCode"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">Send Out</label><br><toggle ng-model="vm.compendium.sendOut" on="Yes" off="No" id="field_send_out"></toggle></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/compendium/compendium-list-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDiagnosisLabel">List of test</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><table class="table table-bordered"><tbody><tr><th style="width: 10px">#</th><th>Code</th><th>Description</th></tr><tr ng-repeat="compendium in vm.compendiums"><td>{{$index + 1}}</td><td>{{compendium.code}}</td><td>{{compendium.description}}</td></tr></tbody></table><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button></div></div></form>');
$templateCache.put('app/entities/compendium/compendiums.html','<section class="content-header"><h1>Compendiums</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="compendium.new"><span class="glyphicon glyphicon-flash"></span> <span>New Compendium</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerycompendium" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/compendium-report-group/compendium-report-group-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.compendiumReportGroup.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Compendium Report Group?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/compendium-report-group/compendium-report-group-detail.html','<div><h2><span>Compendium Report Group</span> {{vm.compendiumReportGroup.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="compendium-report-group-detail.edit({id:vm.compendiumReportGroup.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/compendium-report-group/compendium-report-group-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCompendiumReportGroupLabel">Create or edit a Compendium Report Group</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.compendiumReportGroup.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/compendium-report-group/compendium-report-groups.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/compendium-special-price/compendium-special-price-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.compendiumSpecialPrice.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Compendium Special Price?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/compendium-special-price/compendium-special-price-detail.html','<div><h2><span>Compendium Special Price</span> {{vm.compendiumSpecialPrice.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Price</span></dt><dd><span>{{vm.compendiumSpecialPrice.price}}</span></dd><dt><span>Clinic</span></dt><dd><a ui-sref="clinic-detail({id:vm.compendiumSpecialPrice.clinic.id})">{{vm.compendiumSpecialPrice.clinic.y}}</a></dd><dt><span>Compendium</span></dt><dd><a ui-sref="compendium-detail({id:vm.compendiumSpecialPrice.compendium.id})">{{vm.compendiumSpecialPrice.compendium.id}}</a></dd><dt><span>Employee</span></dt><dd><a ui-sref="employee-detail({id:vm.compendiumSpecialPrice.employee.id})">{{vm.compendiumSpecialPrice.employee.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="compendium-special-price-detail.edit({id:vm.compendiumSpecialPrice.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/compendium-special-price/compendium-special-price-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCompendiumSpecialPriceLabel">Create or edit a Compendium Special Price</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.compendiumSpecialPrice.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.compendiumSpecialPrice.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_price">Price</label><input type="number" class="form-control" name="price" id="field_price" ng-model="vm.compendiumSpecialPrice.price" required><div ng-show="editForm.price.$invalid"><p class="help-block" ng-show="editForm.price.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.price.$error.number">This field should be a number.</p></div></div><div class="form-group"><label for="field_compendium">Compendium</label><ui-select ng-model="vm.compendiumSpecialPrice.compendium" close-on-select="true" title="Compendium" id="field_compendium" ng-required="true" name="compendium"><ui-select-match allow-clear="true" placeholder="Select compendium...">{{$select.selected.code +\n                    \', \'+ $select.selected.description}} </ui-select-match><ui-select-choices repeat="compendium in vm.compendiums | filter: $select.search"><div ng-bind-html=" compendium.code + \', \' + compendium.description | highlight: $select.search"></div><small ng-bind-html="(compendium.wGroup ? compendium.wGroup : \'\') +\n                    (compendium.specimen ? (compendium.wGroup ? \', \' : \'\') + compendium.specimen : \'\') | highlight: $select.search"></small></ui-select-choices></ui-select><div ng-show="editForm.compendium.$invalid"><p class="help-block" ng-show="editForm.compendium.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/compendium-special-price/compendium-special-prices.html','<section class="content-header"><h1>Compendium Special Prices</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="compendium-special-price.new"><span class="glyphicon glyphicon-flash"></span> <span>New Special Price</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/composite/composite-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.composite.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Composite?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/composite/composite-detail.html','<div><h2><span>Composite</span> {{vm.composite.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Dialysis Modality</span></dt><dd><span>{{vm.composite.dialysisModality}}</span></dd><dt><span>Compendium</span></dt><dd><a ui-sref="compendium-detail({id:vm.composite.compendium.id})">{{vm.composite.compendium.id}}</a></dd><dt><span>Billing Frequency</span></dt><dd><a ui-sref="billing-frequency-detail({id:vm.composite.billingFrequency.id})">{{vm.composite.billingFrequency.id}}</a></dd><dt><span>Clinic</span></dt><dd><a ui-sref="clinic-detail({id:vm.composite.clinic.id})">{{vm.composite.clinic.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="composite-detail.edit({id:vm.composite.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/composite/composite-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCompositeLabel">Create or edit a Composite</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.composite.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.composite.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_dialysisModality">Dialysis Modality</label><select class="form-control" name="dialysisModality" ng-model="vm.composite.dialysisModality" id="field_dialysisModality" required ng-change="vm.onChangeDialysisModality()"><option value="HEMO_DIALYSIS">HEMO DIALYSIS</option><option value="PERITONEAL_DIALYSIS">PERITONEAL DIALYSIS</option></select><div ng-show="editForm.dialysisModality.$invalid"><p class="help-block" ng-show="editForm.dialysisModality.$error.required">This field is required.</p></div></div><div class="form-group"><label for="field_compendium">Compendium</label><ui-select ng-model="vm.composite.compendium" close-on-select="true" title="Compendium" id="field_compendium" ng-required="true" name="compendium"><ui-select-match allow-clear="true" placeholder="Select compendium...">{{$select.selected.code +\n                    \', \'+ $select.selected.description}} </ui-select-match><ui-select-choices repeat="compendium in vm.compendiums | filter: $select.search"><div ng-bind-html=" compendium.code + \', \' + compendium.description | highlight: $select.search"></div><small ng-bind-html="(compendium.wGroup ? compendium.wGroup : \'\') +\n                    (compendium.specimen ? (compendium.wGroup ? \', \' : \'\') + compendium.specimen : \'\') | highlight: $select.search"></small></ui-select-choices></ui-select><div ng-show="editForm.compendium.$invalid"><p class="help-block" ng-show="editForm.compendium.$error.required">This field is required.</p></div></div><div class="form-group"><label for="field_billingFrequency">Billing Frequency</label><ui-select ng-model="vm.composite.billingFrequency" close-on-select="true" title="Billing Frequency" id="field_billingFrequency" ng-required="true" name="billingFrequency"><ui-select-match allow-clear="true" placeholder="Select compendium...">{{$select.selected.name +\n                    \', \'+ $select.selected.days}} </ui-select-match><ui-select-choices repeat="billingFrequency in vm.billingfrequencies | filter: $select.search"><div ng-bind-html=" billingFrequency.name + \', \' + billingFrequency.days | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="editForm.billingFrequency.$invalid"><p class="help-block" ng-show="editForm.billingFrequency.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/composite/composites.html','<section class="content-header"><h1>Composites</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="composite.new"><span class="glyphicon glyphicon-flash"></span> <span>New Composites</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/corporation/clinics.html','<section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Clinics</h3></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/corporation/corporation-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.corporation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Corporation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/corporation/corporation-detail.html','<section class="content-header"><h1><i class="fa fa-archive"></i> Corporation: {{vm.corporation.name}} </h1><div ncy-breadcrumb class="breadcrumb"></div></section><div ui-view="clinics"></div><!--<div>--><!--<h2><span>Corporation</span> {{vm.corporation.id}}</h2>--><!--<hr>--><!--<jhi-alert-error></jhi-alert-error>--><!--<dl class="dl-horizontal jh-entity-details">--><!--<dt><span>Name</span></dt>--><!--<dd>--><!--<span>{{vm.corporation.name}}</span>--><!--</dd>--><!--</dl>--><!--<button type="submit"--><!--ui-sref="{{ vm.previousState }}"--><!--class="btn btn-info">--><!--<span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span>--><!--</button>--><!--<button type="button" ui-sref="corporation-detail.edit({id:vm.corporation.id})" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-xs hidden-sm"> Edit</span>--><!--</button>--><!--</div>-->');
$templateCache.put('app/entities/corporation/corporation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCorporationLabel">Create or edit a Corporation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.corporation.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.corporation.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.corporation.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.corporation.address"></div><div class="form-group"><label class="control-label" for="field_address2">Address2</label><input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.corporation.address2"></div><div class="form-group"><label class="control-label" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.corporation.city"></div><div class="form-group"><label class="control-label" for="field_zipcode">Zip Code</label><input type="text" class="form-control" name="zipcode" id="field_zipCode" ng-model="vm.corporation.zipcode" ui-mask="99999"></div><div class="form-group"><label class="control-label" for="field_countryState">Country State</label><input type="text" class="form-control" name="countryState" id="field_countryState" ng-model="vm.corporation.countryState"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/corporation/corporations.html','<section class="content-header"><h1>Corporations</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="corporation.new"><span class="glyphicon glyphicon-flash"></span> <span>New Corporation</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerycorporation" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/dashboard/dashboard-admin.html','<section class="content-header"><div class="row"><div class="col-md-3"><h3>Basic Info</h3></div><div class="col-md-9"><h3 class="visible-lg visible-md">Lab <small>Need attention!</small></h3></div></div></section><section class="content"><div class="row"><div class="col-md-3"><div class="box box-widget widget-user-2"><div class="widget-user-header bg-yellow"><h3 class="widget-user-username">Overview</h3><!--<h5 class="widget-user-desc">Lead Developer</h5>--></div><div class="box-footer no-padding"><ul class="nav nav-stacked"><li><a ui-sref="corporation">Corporations <span class="pull-right badge bg-blue">{{vm.dashboard.corporationsTotal}}</span></a></li><li><a ui-sref="clinics">Clinics <span class="pull-right badge bg-aqua">{{vm.dashboard.clinicsTotal}}</span></a></li><li><a href="#">Sites <span class="pull-right badge bg-green">{{vm.dashboard.machinesTotal}}</span></a></li><li><a href="#">Patients <span class="pull-right badge bg-yellow">{{vm.dashboard.patientsTotal}}</span></a></li></ul></div></div></div><div class="col-md-9"><h3 class="visible-xs visible-sm">Lab <small>Need attention!</small></h3><div class="row"><div class="col-md-4 col-sm-6 col-xs-12"><div class="info-box bg-green"><span class="info-box-icon">{{vm.dashboard.unsendKinetics}}</span><div class="info-box-content"><span class="info-box-text">Kinetics</span> <span class="info-box-number">Sent today: {{vm.dashboard.sentKineticsToday}}</span><div class="progress"><div class="progress-bar" style="width: 100%"></div></div><span class="progress-description">Monthly: {{vm.dashboard.sentKineticsMonthly}}</span></div></div></div><div class="col-md-4 col-sm-6 col-xs-12"><div class="info-box bg-aqua"><span class="info-box-icon">{{vm.dashboard.pendingEnvOrders}}</span><div class="info-box-content"><span class="info-box-text">Site Orders</span> <span class="info-box-number">Sent today: {{vm.dashboard.sentEnvBarcodesToday}}</span><div class="progress"><div class="progress-bar" style="width: 100%"></div></div><span class="progress-description">Monthly: {{vm.dashboard.sentEnvBarcodesMonthly}}</span></div></div></div><div class="col-md-4 col-sm-6 col-xs-12"><div class="info-box bg-yellow"><span class="info-box-icon">{{vm.dashboard.pendingPatientOrders}}</span><div class="info-box-content"><span class="info-box-text">Patient Orders</span> <span class="info-box-number">Sent today: {{vm.dashboard.sentPatientBarcodesToday}}</span><div class="progress"><div class="progress-bar" style="width: 100%"></div></div><span class="progress-description">Monthly: {{vm.dashboard.sentPatientBarcodesMonthly}} </span></div></div></div></div><div class="row"><div class="col-md-4 col-sm-6 col-xs-12"><div class="info-box bg-red"><span class="info-box-icon">{{vm.dashboard.patientResultNotReceived}}</span><div class="info-box-content"><span class="info-box-text">Patient Result</span> <span class="info-box-number">Received today: {{vm.dashboard.recivedPatientResultToday}}</span><div class="progress"><div class="progress-bar" style="width: 100%"></div></div><span class="progress-description">Monthly: {{vm.dashboard.recivedPatientResultMonthly}}</span></div></div></div><div class="col-md-4 col-sm-6 col-xs-12"><div class="info-box bg-red"><span class="info-box-icon">{{vm.dashboard.envResultNotReceived}}</span><div class="info-box-content"><span class="info-box-text">Site Results</span> <span class="info-box-number">Received today: {{vm.dashboard.recivedEnvResultToday}}</span><div class="progress"><div class="progress-bar" style="width: 100%"></div></div><span class="progress-description">Monthly: {{vm.dashboard.recivedEnvResultMonthly}}</span></div></div></div></div></div></div></section>');
$templateCache.put('app/entities/dashboard/dashboard-admin2.html','<section class="content"><div class="row"><div class="col-lg-2 col-xs-6"><div class="info-box bg-green"><span class="info-box-icon">{{vm.dashboard.unsendKinetics}}</span><div class="info-box-content"><span class="info-box-text">Kinetics</span> <span class="info-box-number">Sent today: {{vm.dashboard.sentKineticsToday}}</span><div class="progress"><div class="progress-bar" style="width: 100%"></div></div><span class="progress-description">Monthly: {{vm.dashboard.sentKineticsMonthly}}</span></div></div></div><div class="col-lg-2 col-xs-6"><div class="info-box bg-aqua"><span class="info-box-icon">{{vm.dashboard.pendingEnvOrders}}</span><div class="info-box-content"><span class="info-box-text">Site Orders</span> <span class="info-box-number">Sent today: {{vm.dashboard.sentEnvBarcodesToday}}</span><div class="progress"><div class="progress-bar" style="width: 100%"></div></div><span class="progress-description">Monthly: {{vm.dashboard.sentEnvBarcodesMonthly}}</span></div></div></div><div class="col-lg-2 col-xs-6"><div class="info-box bg-yellow"><span class="info-box-icon">{{vm.dashboard.pendingPatientOrders}}</span><div class="info-box-content"><span class="info-box-text">Patient Orders</span> <span class="info-box-number">Sent today: {{vm.dashboard.sentPatientBarcodesToday}}</span><div class="progress"><div class="progress-bar" style="width: 100%"></div></div><span class="progress-description">Monthly: {{vm.dashboard.sentPatientBarcodesMonthly}} </span></div></div></div><div class="col-lg-2 col-xs-6"><div class="info-box bg-red"><span class="info-box-icon">{{vm.dashboard.patientResultNotReceived}}</span><div class="info-box-content"><span class="info-box-text">Patient Result</span> <span class="info-box-number">Rec. today: {{vm.dashboard.recivedPatientResultToday}}</span><div class="progress"><div class="progress-bar" style="width: 100%"></div></div><span class="progress-description">Monthly: {{vm.dashboard.recivedPatientResultMonthly}}</span></div></div></div><div class="col-lg-2 col-xs-6"><div class="info-box bg-red"><span class="info-box-icon">{{vm.dashboard.envResultNotReceived}}</span><div class="info-box-content"><span class="info-box-text">Site Results</span> <span class="info-box-number">Rec. today: {{vm.dashboard.recivedEnvResultToday}}</span><div class="progress"><div class="progress-bar" style="width: 100%"></div></div><span class="progress-description">Monthly: {{vm.dashboard.recivedEnvResultMonthly}}</span></div></div></div></div><div class="row"><div class="col-md-12" ui-view="schedule"></div></div></section>');
$templateCache.put('app/entities/dashboard/dashboard-doc.html','<section class="content"><div class="row"><div class="col-lg-2 col-xs-6"><div class="small-box bg-red"><div class="inner"><h3>{{vm.dashboard.critical}}</h3><p>Critical</p></div><div class="icon"><i class="ion ion-android-alert"></i></div><a ui-sref="dashboard-critical-result" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a></div></div><div class="col-lg-2 col-xs-6"><div class="small-box bg-aqua"><div class="inner"><h3>{{vm.dashboard.pendingResult}}</h3><p>Pending Results</p></div><div class="icon"><i class="ion ion-android-cancel"></i></div><a ui-sref="dashboard-pending-result" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a></div></div><div class="col-lg-2 col-xs-6"><div class="small-box bg-yellow"><div class="inner"><h3>{{vm.dashboard.unassignedResult}}</h3><p>Unassigned Result</p></div><div class="icon"><i class="ion ion-help"></i></div><a ui-sref="unassigned-result" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a></div></div><div class="col-lg-2 col-xs-6"><div class="small-box bg-red"><div class="inner"><h3>{{vm.dashboard.unsignedOrders}}</h3><p>Unsigned Orders</p></div><div class="icon"><i class="ion ion-edit"></i></div><a ui-sref="dashboard2-unsigned-orders" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a></div></div><div class="col-lg-2 col-xs-6"><div class="small-box bg-green"><div class="inner"><h3>{{vm.dashboard.missingInfo}}</h3><p>Missing Information</p></div><div class="icon"><i class="ion ion-alert"></i></div><!--<a class="small-box-footer">Under construction <i class="fa fa-arrow-circle-right"></i></a>--> <a ui-sref="kinetic" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a></div></div><div class="col-lg-2 col-xs-6"><div class="small-box bg-gray"><div class="inner"><h3>{{vm.dashboard.invoice}}</h3><p>Invoice</p></div><div class="icon"><i class="ion ion-clipboard"></i></div><a class="small-box-footer">Under construction <i class="fa fa-arrow-circle-right"></i></a></div></div></div><div class="row"><div class="col-md-12" ui-view="schedule"></div><!--<div class="col-md-3">--><!--<ng-include src="\'app/entities/dashboard/tpl/lab-result-diagram-tpl.html\'"></ng-include>--><!--</div>--></div><div class="row"><div class="col-lg-12"><uib-tabset class="nav-tabs-custom"><uib-tab index="$index" heading="{{panel.name}}" ng-repeat="panel in vm.dashboard.panels"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom-grid"><div class="grid-item" ng-repeat="patientResultHealth in panel.patientResultHealths"><canvas id="polar-area" class="chart chart-doughnut" chart-colors="patientResultHealth.colors" chart-data="patientResultHealth.data" chart-labels="patientResultHealth.labels" chart-options="patientResultHealth.options"></canvas></div></div></div></uib-tab></uib-tabset></div></div></section>');
$templateCache.put('app/entities/dashboard/dashboard-env.html','<section class="content"><div class="row"><div class="col-md-9" ui-view="schedule"></div><div class="col-md-3"><ng-include src="\'app/entities/dashboard/tpl/lab-result-diagram-tpl.html\'"></ng-include><div class="info-box bg-blue"><span class="info-box-icon"><i class="ion ion-erlenmeyer-flask"></i></span><div class="info-box-content"><span class="info-box-text">WATERS</span> <span class="info-box-number">{{vm.dashboard.machines}}</span></div></div></div></div></section>');
$templateCache.put('app/entities/dashboard/dashboard2.html','<section class="content-header"><h1 class="section-title">Dashboard.v2</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="notifications-area" ui-view="lab-notifications-area"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 home-dashboard"><div class="dash-box quarter" ui-view="critical-results"></div><div class="dash-box quarter" ui-view="missing-kinetics"></div><div class="dash-box quarter" ui-view="pending-results"></div><div class="dash-box quarter" ui-view="unassigned-results"></div><div class="three-boxes"><div class="dash-box big"><div class="icon green"><i class="fa fa-calendar" aria-hidden="true"></i></div><div class="db-body pt-15"><uib-tabset class="nav-tabs-custom align-right db-tabset" active="vm.activeTab"><uib-tab tabindex="0" select="vm.keepActiveTab(0)" heading="Patient"><div ui-view="patient-order-schedule"></div></uib-tab><uib-tab tabindex="1" select="vm.keepActiveTab(1)" heading="Environmental"><div ui-view="env-order-schedule"></div></uib-tab></uib-tabset></div></div><div class="dash-box small" ui-view="unsigned-orders"></div><div class="dash-box small" ui-view="missing-pd-adequacy"></div></div><div class="two-boxes"><div class="dash-box" ui-view="abnormal-patient-results"></div><div class="dash-box" ui-view="abnormal-env-results"></div></div><!--<div class="three-boxes inverse">--><!--<div class="dash-box small" ui-view="abnormal-patient-results">--><!--</div>--><!--<div class="dash-box small" ui-view="abnormal-env-results">--><!--</div>--><!--<div class="dash-box big">--><!--<div class="icon yellow">--><!--<i class="fa fa-magic" aria-hidden="true"></i>--><!--</div>--><!--<header class="db-header">--><!--<h3>Favorite Reports</h3>--><!--</header>--><!--<div class="db-body">--><!--<div class="table-responsive">--><!--<table class="table table-striped db-table">--><!--<thead>--><!--<tr>--><!--<th><strong>Name</strong></th>--><!--<th><strong>Category</strong></th>--><!--<th><strong>Status</strong></th>--><!--<th></th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr>--><!--<td>Rounding report</td>--><!--<td>Lorem Cat</td>--><!--<td class="status-label"><span class="enable">Enable</span></td>--><!--<td class="links"><a href="" class=""><i class="fa fa-external-link"--><!--aria-hidden="true"></i></a></td>--><!--</tr>--><!--<tr>--><!--<td>Rounding report</td>--><!--<td>Lorem Cat</td>--><!--<td class="status-label"><span class="disable">Disable</span></td>--><!--<td class="links"><a href="" class=""><i class="fa fa-external-link"--><!--aria-hidden="true"></i></a></td>--><!--</tr>--><!--<tr>--><!--<td>Rounding report</td>--><!--<td>Lorem Cat</td>--><!--<td class="status-label"><span class="enable">Enable</span></td>--><!--<td class="links"><a href="" class=""><i class="fa fa-external-link"--><!--aria-hidden="true"></i></a></td>--><!--</tr>--><!--<tr>--><!--<td>Rounding report</td>--><!--<td>Lorem Cat</td>--><!--<td class="status-label"><span class="disable">Disable</span></td>--><!--<td class="links"><a href="" class=""><i class="fa fa-external-link"--><!--aria-hidden="true"></i></a></td>--><!--</tr>--><!--<tr>--><!--<td>Rounding report</td>--><!--<td>Lorem Cat</td>--><!--<td class="status-label"><span class="enable">Enable</span></td>--><!--<td class="links"><a href="" class=""><i class="fa fa-external-link"--><!--aria-hidden="true"></i></a></td>--><!--</tr>--><!--<tr>--><!--<td>Rounding report</td>--><!--<td>Lorem Cat</td>--><!--<td class="status-label"><span class="disable">Disable</span></td>--><!--<td class="links"><a href="" class=""><i class="fa fa-external-link"--><!--aria-hidden="true"></i></a></td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><!--<footer class="db-footer">--><!--<uib-pagination class="pagination pagination-sm custom"--><!--first-text="&#xf100;"--><!--previous-text="&#xf0a8;"--><!--next-text="&#xf0a9;"--><!--last-text="&#xf101;"--><!--total-items="vm.totalItems"--><!--items-per-page="vm.itemsPerPage"--><!--ng-model="vm.page">--><!--</uib-pagination>--><!--</footer>--><!--</div>--><!--</div>--></div><!--  /home-dashboard --></div></section>');
$templateCache.put('app/entities/diagnosis/diagnosis-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDiagnosisLabel">List of diagnosis (ICD10)</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><table class="table table-condensed table-striped table-bordered"><tbody><tr><th style="width: 10px">#</th><th>ICD 10</th><th>Description</th></tr><tr ng-repeat="diagnosis in vm.diagnoses"><td>{{$index + 1}}</td><td>{{diagnosis.icd10Code}}</td><td>{{diagnosis.description}}</td></tr></tbody></table><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button></div></div></form>');
$templateCache.put('app/entities/dialyser-type/dialyser-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dialyserType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Dialyser Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/dialyser-type/dialyser-type-detail.html','<div><h2><span>Dialyser Type</span> {{vm.dialyserType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.dialyserType.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.dialyserType.corporation.id})">{{vm.dialyserType.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="dialyser-type-detail.edit({id:vm.dialyserType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/dialyser-type/dialyser-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDialyserTypeLabel">Create or edit a Dialyser Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.dialyserType.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/dialyser-type/dialyser-types.html','<section class="content-header"><h1>Dialyser Types</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dialyser-type.new"><span class="glyphicon glyphicon-flash"></span> <span>New Dialyser Type</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerydialyser-type" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/employee/employee-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.employee.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Employee?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/employee/employee-detail.html','<div><h2><span>Employee</span> {{vm.employee.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.employee.name}}</span></dd><dt><span>Last Name</span></dt><dd><span>{{vm.employee.lastName}}</span></dd><dt><span>Title</span></dt><dd><span>{{vm.employee.title}}</span></dd><dt><span>Gender</span></dt><dd><span>{{vm.employee.gender}}</span></dd><dt><span>User</span></dt><dd> {{vm.employee.user.id}} </dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.employee.corporation.id})">{{vm.employee.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="employee-detail.edit({id:vm.employee.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/employee/employee-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEmployeeLabel">Create or edit a Employee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><uib-tabset class="nav-tabs-custom"><uib-tab index="0" heading="Employee"><div class="box-body"><div class="row"><div class="col-lg-12"><div class="form-group" ng-show="vm.employee.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.employee.id" readonly="readonly"></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group" ng-class="{\'has-error\': editForm.title.$invalid}"><label class="control-label" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.employee.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group" ng-class="{\'has-error\': editForm.name.$invalid}"><label class="control-label" for="field_name">First Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.employee.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group" ng-class="{\'has-error\': editForm.lastName.$invalid}"><label class="control-label" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.employee.lastName" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group" ng-class="{\'has-error\': editForm.gender.$invalid}"><label class="control-label" for="field_gender">Gender</label><select class="form-control" name="gender" ng-model="vm.employee.gender" id="field_gender" required><option value="MALE">MALE</option><option value="FEMALE">FEMALE</option></select><div ng-show="editForm.gender.$invalid"><p class="help-block" ng-show="editForm.gender.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group" ng-class="{\'has-error\': editForm.employee_type.$invalid}"><label for="employee_type">Type</label><select class="form-control" id="employee_type" name="employee_type" ng-model="vm.employee.employeeType" ng-options="employeeType as employeeType.name for employeeType in vm.employeeTypes track by employeeType.id" required></select><div ng-show="editForm.employee_type.$invalid"><p class="help-block" ng-show="editForm.employee_type.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label for="field_corporation">Corporation</label><select class="form-control" id="field_corporation" name="corporation" ng-change="vm.changeCorporation()" ng-model="vm.employee.corporation" ng-options="corporation as corporation.name for corporation in vm.corporations track by corporation.id"></select><div ng-show="editForm.corporation.$invalid"><p class="help-block" ng-show="editForm.corporation.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-4" ng-show="vm.employee.employeeType.id === 1"><div class="form-group" ng-class="{\'has-error\': editForm.npi.$invalid}"><label class="control-label" for="npi">NPI</label><input type="text" class="form-control" name="npi" id="npi" ng-model="vm.employee.specialist.npi" ng-required="vm.employee.employeeType.id === 1"><div ng-show="editForm.npi.$invalid"><p class="help-block" ng-show="editForm.npi.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label>Clinics</label><ui-select id="clinics" name="clinics" multiple="multiple" ng-model="vm.employee.clinics" title="Cinics"><ui-select-match placeholder="Select Cinics...">{{$item.name}}</ui-select-match><ui-select-choices repeat="clinic in vm.clinics | filter:$select.search"> {{clinic.name}} </ui-select-choices></ui-select></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.employee.phone"><div ng-show="editForm.phone.$invalid"><p class="help-block" ng-show="editForm.phone.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group" ng-class="{\'has-error\': editForm.pin.$invalid}"><label class="control-label" for="password">PIN</label><input type="password" class="form-control" id="pin" name="pin" placeholder="PIN" ng-model="vm.employee.pin" ng-required="vm.employee.id === null" ng-minlength="4" ng-maxlength="4" required><div ng-show="editForm.pin.$dirty && editForm.pin.$invalid"><p class="help-block" ng-show="editForm.pin.$error.required">Your password is required.</p><p class="help-block" ng-show="editForm.pin.$error.minlength">Your password is required to be 4 characters.</p></div></div></div></div></div></uib-tab><uib-tab index="1" heading="User Related"><div><div class="box-body"><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div class="row"><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': editForm.login.$invalid}"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-disabled="vm.employee.id" ng-model="vm.employee.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': editForm.email.$invalid}"><label class="control-label">Email</label><input type="email" class="form-control" name="email" ng-model="vm.employee.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email">Your e-mail is invalid.</p></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': editForm.password.$invalid}"><label class="control-label" for="password">Password</label><input type="password" class="form-control" id="password" name="password" placeholder="Password" ng-model="vm.employee.user.password" ng-required="vm.employee.id === null" ng-minlength="4" ng-maxlength="50" required><div ng-show="editForm.password.$dirty && editForm.password.$invalid"><p class="help-block" ng-show="editForm.password.$error.required">Your password is required.</p><p class="help-block" ng-show="editForm.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="editForm.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.employee.user.password"></password-strength-bar></div></div><div class="col-lg-6"><div class="form-group" ng-class="{\'has-error\': editForm.confirmPassword.$invalid}"><label class="control-label" for="confirmPassword">Password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the Password" ng-model="vm.employee.user.confirmPassword" ng-minlength="4" ng-maxlength="50" ng-required="vm.employee.id === null" compare-to="password"><div ng-show="editForm.confirmPassword.$dirty && editForm.confirmPassword.$invalid"><p class="help-block" ng-show="editForm.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="editForm.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="editForm.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.confirmPassword.$error.notmatch">Your confirmation password not match.</p></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label>Roles</label><ui-select id="authority" name="authority" multiple="multiple" ng-model="vm.employee.user.authorities" title="Roles" required><ui-select-match placeholder="Select Roles...">{{$item}}</ui-select-match><ui-select-choices repeat="authority in vm.authorities | filter:$select.search"> {{authority}} </ui-select-choices></ui-select><div ng-show="editForm.authority.$invalid"><p class="help-block" ng-show="editForm.authority.$error.required">This field is required.</p></div><!--<select class="form-control" multiple name="authority"--><!--ng-model="vm.employee.user.authorities"--><!--ng-options="authority for authority in vm.authorities">--><!--</select>--></div></div><div class="col-lg-6"><div class="form-group"><label><label class="control-label" for="field_diabetic">Active</label><br><toggle ng-model="vm.employee.user.activated" on="Yes" off="No" id="field_diabetic"></toggle><!--<input ng-disabled="vm.user.id === null" type="checkbox" id="activated"--><!--name="activated" ng-model="vm.user.activated">--><!--<span>Activated</span>--></label></div></div></div></div></div></uib-tab></uib-tabset></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/employee/employees.html','<section class="content-header"><h1>Employees</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="navbar-form navbar-left" style="margin-left: -15px"><button class="btn btn-primary" ui-sref="employee.new"><span class="glyphicon glyphicon-plus"></span> <span>New Employee</span></button></div><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryemployee" placeholder="Query" ng-change="vm.search()" size="80"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/env-order/env-order-all-new.html','<section class="content-header"><h1><i class="fa fa-thermometer"></i> New Site Orders<br></h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="input-group"><span class="input-group-addon" ng-click="vm.select()"><i class="fa fa-gears"></i>+ Site</span><ui-select ng-model="vm.machines" title="Choose a Site" ng-disabled="false" multiple="multiple"><ui-select-match placeholder="Select Site..."> {{$item.name}} </ui-select-match><ui-select-choices repeat="machine in vm.allMachines | propsFilter: {name: $select.search}"><div ng-bind-html="machine.name | highlight: $select.search"></div><small>Location: {{machine.location | date:\'MM/dd/yy\'}} | Type: {{machine.mType}} </small></ui-select-choices></ui-select></div></div></div><br><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Tests List</h3></div><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ng-click="vm.addEnvTest()"><span>New Environmental Test</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div></div></div></div><div class="row"><div class="col-xs-12"><div class="pull-right"><button type="button" class="btn btn-success" ng-disabled="vm.form.$invalid || vm.order.envTests.length == 0 || !vm.machines || vm.machines.length == 0 || vm.isSaving" ng-click="vm.save()">Save</button></div></div></div></section>');
$templateCache.put('app/entities/env-order/env-order-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.envOrder.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Env Order?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/env-order/env-order-detail.html','<section class="content-header"><h1><i class="fa fa-thermometer"></i> Environmental {{vm.order.id}} ({{vm.order.ordStatus}})<br><small>Machine: {{vm.machine.name}} | Type: {{vm.machine.mType}} | Status: {{vm.machine.mStatus ? \'Active\' : \'Inactive\'}}</small></h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header" ui-view="order-tests"></section>');
$templateCache.put('app/entities/env-order/env-order-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEnvOrderLabel">Create or edit a Env Order</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.envOrder.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.envOrder.id" readonly="readonly"></div><div class="form-group"><label for="field_machine">Machine</label><select class="form-control" id="field_machine" name="machine" ng-model="vm.envOrder.machine" ng-options="machine as machine.id for machine in vm.machines track by machine.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/env-order/env-order-new.html','<section class="content-header"><h1 class="section-title"><i class="fa fa-thermometer"></i> New Site Order<br><small>Site: {{vm.machine.name}} | Type: {{vm.machine.mType}}</small></h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Tests List</h3></div><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ng-click="vm.addEnvTest()"><span>New Environmental Test</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><!--<input type="text" class="form-control" ng-model="vm.searchQuery"--><!--id="searchQuerymodality" placeholder="Query" ng-change="vm.search()">--><!--<span class="input-group-btn width-min">--><!--<button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)">--><!--<span class="glyphicon glyphicon-filter"></span>--><!--</button>--><!--</span>--><!--<span class="input-group-btn width-min" ng-if="vm.currentSearch">--><!--<button class="btn btn-info" ng-click="vm.clear()">--><!--<span class="glyphicon glyphicon-trash"></span>--><!--</button>--><!--</span>--></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div></div></div></div><div class="row"><div class="col-xs-12"><div class="pull-right"><button type="button" class="btn btn-success" ng-disabled="vm.form.$invalid || vm.order.envTests.length == 0 || vm.isSaving" ng-click="vm.save()">Save</button></div></div></div></section>');
$templateCache.put('app/entities/env-order/env-orders.html','<section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4 no-padding-left"><button ng-if="vm.machine.mStatus" class="btn btn-primary" ui-sref="env-order-new({id: vm.machine.id})"><span class="fa fa-thermometer"></span> <span>New Site Order</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryenv-order" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/env-order-tpl/env-order-test-tpl-new-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientAccessLabel">Create Order Test</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><form name="vm.form" role="form" show-validation><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Test Code</label><ui-select id="field_compendium" name="compendium" reset-search-input="false" ng-change="vm.change()" ng-model="vm.envTest.compendium" title="Compendium" ng-required="true"><ui-select-match placeholder="Select Test...">{{$select.selected.code}}</ui-select-match><ui-select-choices repeat="compendium in vm.compendiums" refresh="vm.getCompendium($select.search)" refresh-delay="0"><div ng-bind-html="compendium.code | highlight: $select.search"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select><div ng-show="vm.form.compendium.$invalid"><p class="help-block" ng-show="vm.form.compendium.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label for="field_orderFrequency">Frequency</label><select class="form-control" id="field_orderFrequency" name="orderFrequency" required ng-model="vm.envTest.orderFrequency" ng-options="orderFrequency as orderFrequency.name for orderFrequency in vm.orderfrequencies track by orderFrequency.id"><option value=""></option></select><div ng-show="vm.form.orderFrequency.$invalid"><p class="help-block" ng-show="vm.form.orderFrequency.$error.required">This field is required.</p></div></div></div></div></form><div class="modal-footer"><div class="pull-right"><button type="button" class="btn btn-danger" ng-click="vm.clear()">Cancel</button> <button type="button" class="btn btn-success" ng-disabled="vm.form.$invalid" ng-click="vm.accept()">Accept</button></div></div></div>');
$templateCache.put('app/entities/env-order-tpl/env-order-tpl-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tpl.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Site Order Template?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/env-order-tpl/env-order-tpl-new.html','<section class="content-header"><h1><i class="fa fa-calendar-check-o"></i> New Site Order Template <small></small></h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header" ui-view="content"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">New Site Order Template</h3></div><jhi-alert-error></jhi-alert-error><ng-include src="\'app/entities/env-order-tpl/tpl/env-order-form-tpl.html\'"></ng-include></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><dl class="dl-horizontal"><dt><strong>Legend:</strong></dt><dd></dd><dt><span class="label label-danger">Red</span>:</dt><dd>This tests need to be deleted o replaced.</dd></dl></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-primary"><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/env-order-tpl/env-order-tpl.html','<section class="content-header"><h1 class="section-title">Site Order Templates</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="env-order-tpl.new"><span class="glyphicon glyphicon-plus"></span> <span>New Site Order Tpl</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryvia" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/env-result/env-result-delete-dialog.html','<section class="content-header"><h1><i class="ion ion-alert"></i> Delete env result for this barcode?</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="box box-primary"><div class="box-body"><form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="row"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="col-md-5"><div class="form-group"><label class="control-label" ng-show="$index == 0">Barcode</label><div class="input-group"><input id="barcode" type="text" class="form-control" name="barcode" ng-model="vm.barcode" ng-required="true"></div></div></div></div></div></form></div><div class="box-footer"><div class="pull-right"><button type="button" class="btn btn-danger" ng-click="vm.deleteResult()" ng-disabled="vm.editForm.$invalid || vm.isSaving">Delete</button></div></div></div></section>');
$templateCache.put('app/entities/env-result/env-result-detail.html','<div><h2><span>Env Result</span> {{vm.envResult.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Machine</span></dt><dd><span>{{vm.envResult.machine}}</span></dd><dt><span>Dob</span></dt><dd><span>{{vm.envResult.dob | date:\'mediumDate\'}}</span></dd><dt><span>Status</span></dt><dd><span>{{vm.envResult.status}}</span></dd><dt><span>Collection Date</span></dt><dd><span>{{vm.envResult.collectionDate | date:\'mediumDate\'}}</span></dd><dt><span>Accession Number</span></dt><dd><span>{{vm.envResult.accessionNumber}}</span></dd><dt><span>Abnormal</span></dt><dd><span>{{vm.envResult.abnormal}}</span></dd><dt><span>Send By</span></dt><dd><span>{{vm.envResult.sendBy}}</span></dd><dt><span>Order</span></dt><dd><a ui-sref="env-order-detail({id:vm.envResult.order.id})">{{vm.envResult.order.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="env-result-detail.edit({id:vm.envResult.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/env-result/env-result-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEnvResultLabel">Create or edit a Env Result</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.envResult.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.envResult.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_machine">Machine</label><input type="text" class="form-control" name="machine" id="field_machine" ng-model="vm.envResult.machine"></div><div class="form-group"><label class="control-label" for="field_dob">Dob</label><div class="input-group"><input id="field_dob" type="text" class="form-control" name="dob" uib-datepicker-popup="{{dateformat}}" ng-model="vm.envResult.dob" is-open="vm.datePickerOpenStatus.dob"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dob\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.envResult.status"></div><div class="form-group"><label class="control-label" for="field_collectionDate">Collection Date</label><div class="input-group"><input id="field_collectionDate" type="text" class="form-control" name="collectionDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.envResult.collectionDate" is-open="vm.datePickerOpenStatus.collectionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'collectionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_accessionNumber">Accession Number</label><input type="text" class="form-control" name="accessionNumber" id="field_accessionNumber" ng-model="vm.envResult.accessionNumber"></div><div class="form-group"><label class="control-label" for="field_abnormal">Abnormal</label><input type="checkbox" class="form-control" name="abnormal" id="field_abnormal" ng-model="vm.envResult.abnormal"></div><div class="form-group"><label class="control-label" for="field_sendBy">Send By</label><input type="text" class="form-control" name="sendBy" id="field_sendBy" ng-model="vm.envResult.sendBy"></div><div class="form-group"><label for="field_order">Order</label><select class="form-control" id="field_order" name="order" ng-model="vm.envResult.order" ng-options="envOrder as envOrder.id for envOrder in vm.orders | orderBy:\'id\' track by envOrder.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/env-result/env-result-latest.html','<section class="content-header"><h1 class="section-title">{{vm.title}}</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button class="btn btn-default btn-lg btn-header green" ng-click="vm.printPDFs()"><i class="fa fa-print" aria-hidden="true"></i> Get All PDF</button><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search..." id="searchQuerypatient" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg" tabindex="0" id="btnSearch" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div><button class="btn btn-default btn-lg btn-header red toggle-filters" uib-tooltip="Show advanced filters" ng-click="vm.showFiltersPanel()" ng-class="active?\'open\':\'\'"><i class="fa fa-sliders" aria-hidden="true"></i> Filters</button><ng-include src="\'app/entities/env-result/tpl/env-result-latest-filter-tpl.html\'"></ng-include></div><div class="btn-group btn-group-lg main-filters"><button type="button" title="All Results" ng-click="vm.updateStatusButtonFilter(null);" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active green\': vm.filterRes.status == null}]"><i class="fa fa-flask" aria-hidden="true"></i> <span class="hidden-xs">All Results</span></button> <button type="button" class="btn btn-default btn-flat" title="Partial" ng-click="vm.updateStatusButtonFilter(\'PARTIAL\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active green\': vm.filterRes.status == \'PARTIAL\'}]"><i class="fa fa-spinner" aria-hidden="true"></i> <span class="hidden-xs">Partial</span></button> <button type="button" class="btn btn-default" title="Final" ng-click="vm.updateStatusButtonFilter(\'FINAL\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active green\': vm.filterRes.status == \'FINAL\'}]"><i class="fa fa-circle-o" aria-hidden="true"></i> <span class="hidden-xs">Final</span></button></div><button type="button" ng-class="[\'btn btn-default btn-lg btn-header grid-button\', {\'green\': vm.currentMonth}]" uib-tooltip="Current Month" tooltip-placement="left" ng-click="vm.updateCurrentMonthFilter()" ng-model="vm.currentMonth" uib-btn-checkbox><i class="fa fa-calendar" aria-hidden="true"></i></button></div><div class="box box-primary"><div class="box-body"><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/env-result/env-result-update-dates.html','<section class="content-header"><h1><i class="ion ion-alert"></i> Update environmental result for this barcode?</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="box box-primary"><div class="box-body"><jhi-alert-error></jhi-alert-error><form name="updateDatesForm" class="form" role="form" novalidate ng-submit="vm.saveDates()" show-validation><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 form-group"><label class="control-label" for="barcode">Barcode</label><input type="text" class="form-control input-sm" placeholder="Barcode..." name="barcode" id="field_barcode" ng-model="vm.barcode" ng-required="true"><div ng-show="updateDatesForm.barcode.$invalid"><p class="help-block" ng-show="updateDatesForm.barcode.$error.required">This field is required.</p></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-3 form-group"><label class="control-label" for="field_received_date">Result Date</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_received_date" name="received_date" uib-datepicker-popup="MM/dd/yyyy" placeholder="Result Date..." ng-model="vm.receivedDate" is-open="vm.datePickerOpenStatus.receivedDate" ng-required="vm.receivedDate == null && vm.collectionDate == null"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'receivedDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><div ng-show="updateDatesForm.received_date.$invalid"><p class="help-block" ng-show="updateDatesForm.received_date.$error.required">This field is required.</p></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-3 form-group"><label class="control-label" for="field_collection_date">Collection Date</label><div class="input-group input-group-sm"><input id="field_collection_date" type="text" class="form-control" name="collection_date" uib-datepicker-popup="MM/dd/yyyy" placeholder="Collection Date..." ng-model="vm.collectionDate" is-open="vm.datePickerOpenStatus.collectionDate" ng-required="vm.receivedDate == null && vm.collectionDate == null"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'collectionDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><div ng-show="updateDatesForm.collection_date.$invalid"><p class="help-block" ng-show="updateDatesForm.collection_date.$error.required">This field is required.</p></div></div></div><div class="box-footer"><div class="pull-right"><button type="submit" class="btn btn-success" ng-disabled="updateDatesForm.$invalid || vm.isSaving"><i class="fa fa-check-square-o" aria-hidden="true"></i> Update</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div></form></div></div></section>');
$templateCache.put('app/entities/env-result/env-result.html','<ng-include src="\'app/entities/env-result/tpl/env-result-filter-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-8 col-lg-offset-4 no-padding-right"><form name="searchForm"><div><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" popover-class="" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button ng-click="vm.popoverFilterEnable()" class="btn btn-primary" type="button" class="btn btn-default"><span class="glyphicon glyphicon-filter"></span></button> <button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div><div popover-class="pop" popover-placement="bottom" uib-popover-template="\'env-result-filter-tpl.html\'" popover-is-open="vm.showFilter" popover-trigger="none"></div></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/env-result-det/env-result-dets.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Environmental Result Details</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="padding: 0 20%"><table class="table table-condensed patient-info"><tbody><tr><td class="tlabel"><strong>Machine Name:</strong></td><td>{{vm.envResult.machine}}</td><td class="tlabel"><strong>Order #:</strong></td><td>{{vm.envResult.accessionNumber ? vm.envResult.accessionNumber : \'-\'}}</td></tr><tr><td class="tlabel"><strong>Collected Date:</strong></td><td>{{vm.envResult.collectionDate | amDateFormat: displayDateformat}}</td><td class="tlabel"><strong>Result Date:</strong></td><td>{{vm.envResult.createdDate | amDateFormat: displayDateformat}}</td></tr></tbody></table></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="filter-query"><div class="filter-input"><input type="text" class="form-control" id="searchQuerypatient" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <button class="btn btn-default" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button></div><button type="button" class="btn btn-danger show-filters" ng-click="vm.toggleFilters()"><i class="fa fa-sliders"></i> Filter</button><div class="filters-wrapper well"><div class="filter-group" ng-if="vm.groups.length > 0"><div class="name"><span><strong>Groups:</strong></span></div><div class="checkboxs"><!-- The filters ID must be the same as the label\'s FOR attribute --> <span class="filter-item"><input type="checkbox" name="filter-name" id="filter-groups-all" ng-model="vm.groupsAll.value" ng-click="vm.groupCheckAll()"><label for="filter-groups-all">{{vm.groupsAll.name}}</label></span><div class="divider"></div><span class="filter-item" ng-repeat="group in vm.groups | orderBy : \'name\'"><input type="checkbox" name="filter-name" id="filter-{{group.name}}" ng-model="group.value" ng-click="vm.groupsCheck()"><label for="filter-{{group.name}}">{{group.name}}</label></span></div></div><div class="filter-group"><div class="name"><span><strong>Status:</strong></span></div><div class="checkboxs"><!-- The filters ID must be the same as the label\'s FOR attribute --> <span class="filter-item"><input type="checkbox" name="" id="filter-all" ng-model="vm.levels.all" ng-click="vm.levelAll()"><label for="filter-all">All</label></span><span class="filter-item"><input type="checkbox" name="" id="filter-abnormals" ng-model="vm.levels.abnormals" ng-click="vm.abnormals()"><label for="filter-abnormals">Abnormals</label></span><span class="filter-item"><input type="checkbox" name="" id="filter-criticals" ng-model="vm.levels.criticals" ng-click="vm.criticals()"><label for="filter-criticals">Criticals</label></span><div class="divider"></div><span class="filter-item"><input type="checkbox" name="" id="filter-ll" ng-model="vm.levels.LL" ng-click="vm.notNormal()"><label for="filter-ll">Critical Low</label></span><span class="filter-item"><input type="checkbox" name="" id="filter-l" ng-model="vm.levels.L" ng-click="vm.notNormal()"><label for="filter-l">Low</label></span><span class="filter-item"><input type="checkbox" name="" id="filter-n" ng-model="vm.levels.N" ng-click="vm.normal()"><label for="filter-n">Normal</label></span><span class="filter-item"><input type="checkbox" name="" id="filter-h" ng-model="vm.levels.H" ng-click="vm.notNormal()"><label for="filter-h">High</label></span><span class="filter-item"><input type="checkbox" name="" id="filter-hh" ng-model="vm.levels.HH" ng-click="vm.notNormal()"><label for="filter-hh">Critical High</label></span></div></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><table datatable="vm.datatable" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" id="xxx" class="table table-striped table-bordered"></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button></div>');
$templateCache.put('app/entities/env-test/env-test-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.envTest.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Env Test?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/env-test/env-test-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientAccessLabel">Test {{\'"\' + vm.envTest.compendium.code + \'"\'}}</h4></div><div class="modal-body"><table class="table table-condensed table-striped table-bordered"><tbody><tr><th>Test Code</th><th>Frequency</th><th>Staring Date</th><th>End Date</th></tr><tr><td>{{vm.envTest.compendium.code}}</td><td>{{vm.envTest.orderFrequency.name}}</td><td>{{vm.envTest.staringDate | amDateFormat:\'MM/DD/YYYY\'}}</td><td>{{vm.envTest.endDate | amDateFormat:\'MM/DD/YYYY\'}}</td></tr></tbody></table><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Test "{{vm.envTest.compendium.code}}" schedule</h3></div><div class="box-body"><table class="table table-condensed table-striped table-bordered"><tbody><tr><th style="width: 10px">#</th><th>Barcode</th><th>Scheduled Day</th><th>Collected</th><th>Collected Day</th><th>Sent</th><th>Sent Day</th><th>Canceled</th><th ng-show="vm.order.ordStatus == \'SCHEDULED\'">Cancel</th></tr><tr ng-repeat="item in vm.schedules"><td>{{$index}}.</td><td>{{item.barcode}}</td><td>{{item.scheduleDate | amDateFormat:\'MM/DD/YYYY\'}}</td><td><span ng-class="item.collected ? \'label label-success\' : \'label label-danger\'">{{item.collected ? \'Yes\' : \'No\'}}</span></td><td>{{item.collectedDate | amDateFormat:\'MM/DD/YYYY\'}}</td><td><span ng-class="item.sent ? \'label label-danger\' : \'label label-success\'">{{item.sent ? \'Yes\' : \'No\'}}</span></td><td>{{item.sentDate | amDateFormat:\'MM/DD/YYYY\'}}</td><td><span ng-class="item.canceled ? \'label label-danger\' : \'label label-success\'">{{item.canceled ? \'Yes\' : \'No\'}}</span></td><td ng-show="vm.order.ordStatus == \'SCHEDULED\'"><nz-toggle ng-model="item.canceled" ng-disabled="item.canceled" ng-click="vm.cancelOrderTestItem(item)"></nz-toggle></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/env-test/env-test-new-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientAccessLabel">Create environmental test</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><form name="vm.form" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Test Code</label><ui-select id="field_compendium" name="compendium" reset-search-input="false" ng-change="vm.change()" ng-model="vm.envTest.compendium" title="Compendium" ng-required="true"><ui-select-match placeholder="Select Test...">{{$select.selected.code}}</ui-select-match><ui-select-choices repeat="compendium in vm.compendiums" refresh="vm.getCompendium($select.search)" refresh-delay="0"><div ng-bind-html="compendium.code | highlight: $select.search"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select><div ng-show="vm.form.compendium.$invalid"><p class="help-block" ng-show="vm.form.compendium.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label for="field_orderFrequency">Frequency</label><select class="form-control" id="field_orderFrequency" name="orderFrequency" required ng-change="vm.change()" ng-model="vm.envTest.orderFrequency" ng-options="orderFrequency as orderFrequency.name for orderFrequency in vm.orderfrequencies track by orderFrequency.id"><option value=""></option></select><div ng-show="vm.form.orderFrequency.$invalid"><p class="help-block" ng-show="vm.form.orderFrequency.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Staring Date</label><div class="input-group"><input id="field_staringDate" type="text" class="form-control" name="staringDate" required ng-change="vm.change()" datepicker-options="vm.startOptions" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.envTest.staringDate" is-open="vm.datePickerOpenStatus.staringDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'staringDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.staringDate.$invalid"><p class="help-block" ng-show="vm.form.staringDate.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" datepicker-options="vm.endOptions" ng-disabled="vm.envTest.orderFrequency != null && vm.envTest.orderFrequency.days == 0" ng-change="vm.change()" ng-required="vm.envTest.orderFrequency == null || vm.envTest.orderFrequency.days > 0" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.envTest.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.endDate.$invalid"><p class="help-block" ng-show="vm.form.endDate.$error.required">This field is required.</p></div></div></div></div></div></form><div class="modal-footer"><div class="pull-right"><button type="button" class="btn btn-danger" ng-click="vm.clear()">Cancel</button> <button type="button" class="btn btn-success" ng-disabled="vm.formProblem.$invalid || vm.form.$invalid || !vm.envTest.schedules || vm.envTest.schedules.length == 0" ng-click="vm.accept()">Accept</button></div></div><div class="row"><div class="col-lg-12"><div class="box-body" ng-show="vm.envTest.schedules != null && vm.envTest.schedules.length > 0"><div class="box box-primary"><div class="box-header"><h3 class="box-title">Test "{{vm.envTest.compendium.code}}" schedule</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button></div></div><div class="box-body"><table class="table table-condensed table-striped table-bordered"><tbody><tr><th style="width: 10px">#</th><th>Scheduled Day</th><th>Collected</th><th>Collected Day</th></tr><tr ng-repeat="item in vm.envTest.schedules"><td>{{$index}}.</td><td>{{item.scheduleDate | amDateFormat:\'MM/DD/YYYY\'}} </td><td><span ng-class="item.collected ? \'label label-success\' : \'label label-danger\'">{{item.collected ? \'Yes\' : \'No\'}}</span></td><td>{{item.collectedDate | amDateFormat:\'MM/DD/YYYY\'}}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/entities/env-test/env-tests.html','<div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Tests List</h3></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div></div></div></div>');
$templateCache.put('app/entities/hospitalization/hospitalization-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.hospitalization.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Hospitalization?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/hospitalization/hospitalization-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHospitalizationLabel">Create or edit a Hospitalization</h4></div><form name="editForm" role="form" novalidate ng-submit="vm.save()"><fieldset ng-disabled="!vm.editing"><div class="modal-body" ng-disabled="!vm.editing"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_admissionDiagnosis">Admission Diagnosis</label><input type="text" class="form-control" name="admissionDiagnosis" id="field_admissionDiagnosis" ng-model="vm.hospitalization.admissionDiagnosis"></div><div class="form-group"><label class="control-label" for="field_hospital">Hospital</label><input type="text" class="form-control" name="hospital" id="field_hospital" ng-model="vm.hospitalization.hospital"></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_admissionDate">Admission Date</label><div class="input-group"><input id="field_admissionDate" type="text" class="form-control" name="admissionDate" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.hospitalization.admissionDate" is-open="vm.datePickerOpenStatus.admissionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'admissionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_admittingPhysician">Admitting Physician</label><input type="text" class="form-control" name="admittingPhysician" id="field_admittingPhysician" ng-model="vm.hospitalization.admittingPhysician"></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" for="field_renalRelatedInfection">Renal Related Infection</label><toggle ng-model="vm.hospitalization.renalRelatedInfection" on="Yes" off="No" id="field_renalRelatedInfection"></toggle></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" for="field_renalRelatedOther">Renal Related Other</label><input type="text" class="form-control" name="renalRelatedOther" id="field_renalRelatedOther" ng-model="vm.hospitalization.renalRelatedOther" ng-disabled="vm.hospitalization.renalRelatedInfection"></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_dischargeDate">Discharge Date</label><div class="input-group"><input id="field_dischargeDate" type="text" class="form-control" name="dischargeDate" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.hospitalization.dischargeDate" is-open="vm.datePickerOpenStatus.dischargeDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dischargeDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-2"><div class="form-group"><label class="control-label" for="field_dueToBsi">Due To Bsi</label><toggle ng-model="vm.hospitalization.dueToBsi" on="Yes" off="No" name="dueToBsi" id="field_dueToBsi"></toggle></div></div><div class="col-md-offset-4 col-md-6"><div class="form-group"><label for="field_hospitalizationDischargeTo">Discharge To</label><select class="form-control" id="field_hospitalizationDischargeTo" name="hospitalizationDischargeTo" ng-model="vm.hospitalization.hospitalizationDischargeTo" ng-options="hospitalizationDischargeTo as hospitalizationDischargeTo.name for hospitalizationDischargeTo in vm.hospitalizationdischargetos track by hospitalizationDischargeTo.id"><option value=""></option></select></div></div></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" ng-show="vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-primary" ng-click="vm.editing = !vm.editing" ng-if="vm.hospitalization.patient.status" ng-show="!vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Edit Information</span></button></div></form>');
$templateCache.put('app/entities/hospitalization/hospitalizations.html','<div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Hospitalizations</h3></div><div class=""><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="hospitalization.new" ng-if="vm.patient.status"><span class="glyphicon glyphicon-flash"></span> <span>New Hospitalization</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></div>');
$templateCache.put('app/entities/hospitalization-discharge-to/hospitalization-discharge-to-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.hospitalizationDischargeTo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Hospitalization Discharge To?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/hospitalization-discharge-to/hospitalization-discharge-to-detail.html','<div><h2><span>Hospitalization Discharge To</span> {{vm.hospitalizationDischargeTo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.hospitalizationDischargeTo.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.hospitalizationDischargeTo.corporation.id})">{{vm.hospitalizationDischargeTo.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="hospitalization-discharge-to-detail.edit({id:vm.hospitalizationDischargeTo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/hospitalization-discharge-to/hospitalization-discharge-to-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHospitalizationDischargeToLabel">Create or edit a Hospitalization Discharge To</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.hospitalizationDischargeTo.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.hospitalizationDischargeTo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.hospitalizationDischargeTo.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/hospitalization-discharge-to/hospitalization-discharge-tos.html','<section class="content-header"><h1>Hospitalization Discharge Tos</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="hospitalization-discharge-to.new"><span class="glyphicon glyphicon-flash"></span> <span>New Hospitalization Discharge To</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryhospitalization-discharge-to" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/hotfix/hotfix.html','<section class="content"><div class="row"><div class="col-xs-12"><button class="btn btn-primary" ng-click="vm.patientResultStatus()"><span class="glyphicon glyphicon-filter">Fix Patient Result Status & Ranges</span></button><!--<pre>{{vm.clinics | json}}</pre>--><!--&lt;!&ndash;<pre>{{vm.count | json}}</pre>&ndash;&gt;--><!--<pre>{{vm.patients.slice(0, 5) | json}}</pre>--><!--<pre>{{vm.pdetail | json}}</pre>--><!--<pre>{{vm.criticals | json}}</pre>--><!--<pre>{{vm.comments | json}}</pre>--><!--<pre>{{vm._6m | json}}</pre>--><!--<pre>{{vm.acknowledge | json}}</pre>--></div></div></section>');
$templateCache.put('app/entities/infection/infection-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.infection.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Infection?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/infection/infection-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInfectionLabel">Create or edit a Infection</h4></div><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><fieldset ng-disabled="!vm.editing"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_suspectedDate">Infection Date (Suspected)</label><div class="input-group"><input id="field_suspectedDate" type="text" class="form-control" name="suspectedDate" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.infection.suspectedDate" is-open="vm.datePickerOpenStatus.suspectedDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'suspectedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.suspectedDate.$invalid"><p class="help-block" ng-show="editForm.suspectedDate.$error.required">This field is required.</p></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_confirmedDate">Infection Date (Confirmed)</label><div class="input-group"><input id="field_confirmedDate" type="text" class="form-control" name="confirmedDate" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.infection.confirmedDate" is-open="vm.datePickerOpenStatus.confirmedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'confirmedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="field_source">Source</label><select class="form-control" id="field_source" name="source" ng-model="vm.infection.source" ng-options="source as source.name for source in vm.sources track by source.id"><option value=""></option></select></div></div><div class="col-md-6"><div class="form-group"><label for="field_infectionPrimaryAccess">Primary Access</label><select class="form-control" id="field_infectionPrimaryAccess" name="infectionPrimaryAccess" ng-model="vm.infection.infectionPrimaryAccess" ng-options="infectionPrimaryAccess as infectionPrimaryAccess.name for infectionPrimaryAccess in vm.infectionprimaryaccesses track by infectionPrimaryAccess.id"><option value=""></option></select></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" for="field_accessCondition">Access Condition</label><br><toggle ng-model="vm.infection.accessCondition" on="Active" off="No" id="field_accessCondition" name="accessCondition"></toggle></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" for="field_lvAccess">Loss of Vascular Access</label><br><toggle ng-model="vm.infection.lvAccess" on="Active" off="Active" id="field_lvAccess" name="lvAccess"></toggle></div></div><div class="col-md-6"><div class="form-group"><label for="field_dialyserType">Dialyser Type</label><select class="form-control" id="field_dialyserType" name="dialyserType" ng-model="vm.infection.dialyserType" ng-options="dialyserType as dialyserType.name for dialyserType in vm.dialysertypes track by dialyserType.id"><option value=""></option></select></div></div></div><div class="row"><div class="col-md-12"><label class="control-label" for="field_symptoms">Symptoms</label><ui-select id="field_symptoms" name="symptoms" multiple="multiple" ng-model="vm.infection.symptoms" close-on-select="false" title="Symptoms" required><ui-select-match placeholder="Select Symptoms...">{{$item.name}}</ui-select-match><ui-select-choices repeat="symptoms in vm.symptoms | filter:$select.search"> {{symptoms.name}} </ui-select-choices></ui-select><div ng-show="editForm.symptoms.$invalid"><p class="help-block" ng-show="editForm.symptoms.$error.required">This field is required.</p></div></div></div><br><div class="row"><div class="col-md-4"><div class="form-group"><div class="form-group"><label class="control-label" for="field_hospitalization">Hospitalization Required</label><br><toggle ng-model="vm.infection.hospitalization" on="Yes" off="No" name="hospitalization" id="field_hospitalization" ng-click="vm.hospitalizationRequired()"></toggle></div></div><div class="form-group"><label class="control-label" for="field_hospitalizationDate">If yes, specify date</label><div class="input-group"><input id="field_hospitalizationDate" type="text" class="form-control" name="hospitalizationDate" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.infection.hospitalizationDate" is-open="vm.datePickerOpenStatus.hospitalizationDate" ng-disabled="!vm.infection.hospitalization"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'hospitalizationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-4"><div class="form-group"><div class="form-group"><label class="control-label" for="field_drInfection">Death related to infection?</label><br><toggle ng-model="vm.infection.drInfection" on="Yes" off="No" name="drInfection" id="field_drInfection" ng-click="vm.deathRequired()"></toggle></div></div><div class="form-group"><label class="control-label" for="field_drInfectionDate">If yes, specify date</label><div class="input-group"><input id="field_drInfectionDate" type="text" class="form-control" name="drInfectionDate" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.infection.drInfectionDate" is-open="vm.datePickerOpenStatus.drInfectionDate" ng-disabled="!vm.infection.drInfection"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'drInfectionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-4"><div class="form-group"><label class="control-label" for="field_aStarted">Antimicrobial Started</label><br><toggle ng-model="vm.infection.aStarted" on="Yes" off="No" name="drInfection" id="field_aStarted" ng-click="vm.aStartedRequired()"></toggle></div><div class="form-group"><label class="control-label" for="field_aStartedDate">If yes, specify date</label><div class="input-group"><input id="field_aStartedDate" type="text" class="form-control" name="aStartedDate" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.infection.aStartedDate" is-open="vm.datePickerOpenStatus.aStartedDate" ng-disabled="!vm.infection.aStarted"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'aStartedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" for="field_intervention">Intervention</label><input type="text" class="form-control" name="intervention" id="field_intervention" ng-model="vm.infection.intervention"></div></div></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" ng-show="vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-primary" ng-click="vm.editing = !vm.editing" ng-if="vm.infection.patient.status" ng-show="!vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Edit Information</span></button></div></form>');
$templateCache.put('app/entities/infection/infections.html','<div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Infections</h3></div><div><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="infection.new" ng-if="vm.patient.status"><span class="glyphicon glyphicon-flash"></span> <span>New Infection</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryinfection" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></div>');
$templateCache.put('app/entities/infection-primary-access/infection-primary-access-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.infectionPrimaryAccess.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Infection Primary Access?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/infection-primary-access/infection-primary-access-detail.html','<div><h2><span>Infection Primary Access</span> {{vm.infectionPrimaryAccess.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.infectionPrimaryAccess.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.infectionPrimaryAccess.corporation.id})">{{vm.infectionPrimaryAccess.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="infection-primary-access-detail.edit({id:vm.infectionPrimaryAccess.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/infection-primary-access/infection-primary-access-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInfectionPrimaryAccessLabel">Create or edit a Infection Primary Access</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.infectionPrimaryAccess.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/infection-primary-access/infection-primary-accesses.html','<section class="content-header"><h1>Infection Primary Accesses</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="infection-primary-access.new"><span class="glyphicon glyphicon-flash"></span> <span>New Infection Primary Access</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryinfection-primary-access" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/insurance-carrier/insurance-carrier-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.insuranceCarrier.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Insurance Carrier?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/insurance-carrier/insurance-carrier-detail.html','<div><h2><span>Insurance Carrier</span> {{vm.insuranceCarrier.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Acctno</span></dt><dd><span>{{vm.insuranceCarrier.acctno}}</span></dd><dt><span>Name</span></dt><dd><span>{{vm.insuranceCarrier.name}}</span></dd><dt><span>Address</span></dt><dd><span>{{vm.insuranceCarrier.address}}</span></dd><dt><span>Address 2</span></dt><dd><span>{{vm.insuranceCarrier.address2}}</span></dd><dt><span>City</span></dt><dd><span>{{vm.insuranceCarrier.city}}</span></dd><dt><span>State</span></dt><dd><span>{{vm.insuranceCarrier.state}}</span></dd><dt><span>Zip</span></dt><dd><span>{{vm.insuranceCarrier.zip}}</span></dd><dt><span>Phone</span></dt><dd><span>{{vm.insuranceCarrier.phone}}</span></dd><dt><span>I Type</span></dt><dd><span>{{vm.insuranceCarrier.iType}}</span></dd><dt><span>Etin</span></dt><dd><span>{{vm.insuranceCarrier.etin}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="insurance-carrier-detail.edit({id:vm.insuranceCarrier.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/insurance-carrier/insurance-carrier-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInsuranceCarrierLabel">Create or edit a Insurance Carrier</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.insuranceCarrier.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.insuranceCarrier.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_acctno">Acctno</label><input type="text" class="form-control" name="acctno" id="field_acctno" ng-model="vm.insuranceCarrier.acctno" required><div ng-show="editForm.acctno.$invalid"><p class="help-block" ng-show="editForm.acctno.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.insuranceCarrier.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.insuranceCarrier.address"></div><div class="form-group"><label class="control-label" for="field_address2">Address 2</label><input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.insuranceCarrier.address2"></div><div class="form-group"><label class="control-label" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.insuranceCarrier.city"></div><div class="form-group"><label class="control-label" for="field_state">State</label><input type="text" class="form-control" name="state" id="field_state" ng-model="vm.insuranceCarrier.state"></div><div class="form-group"><label class="control-label" for="field_zip">Zip</label><input type="text" class="form-control" name="zip" id="field_zip" ng-model="vm.insuranceCarrier.zip"></div><div class="form-group"><label class="control-label" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.insuranceCarrier.phone"></div><div class="form-group"><label class="control-label" for="field_iType">I Type</label><input type="text" class="form-control" name="iType" id="field_iType" ng-model="vm.insuranceCarrier.iType"></div><div class="form-group"><label class="control-label" for="field_etin">Etin</label><input type="text" class="form-control" name="etin" id="field_etin" ng-model="vm.insuranceCarrier.etin"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/insurance-carrier/insurance-carriers.html','<section class="content-header"><h1>Insurance Carriers</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="insurance-carrier.new"><span class="glyphicon glyphicon-flash"></span> <span>New Insurance Carrier</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryinsurance-carrier" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/insurance-level/insurance-level-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.insuranceLevel.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Insurance Level?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/insurance-level/insurance-level-detail.html','<div><h2><span>Insurance Level</span> {{vm.insuranceLevel.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.insuranceLevel.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.insuranceLevel.corporation.id})">{{vm.insuranceLevel.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="insurance-level-detail.edit({id:vm.insuranceLevel.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/insurance-level/insurance-level-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInsuranceLevelLabel">Create or edit a Insurance Level</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.insuranceLevel.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.insuranceLevel.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.insuranceLevel.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/insurance-level/insurance-levels.html','<section class="content-header"><h1>Insurance Levels</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="insurance-level.new"><span class="glyphicon glyphicon-flash"></span> <span>New Insurance Level</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryinsurance-level" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/insurance-relation/insurance-relation-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.insuranceRelation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Insurance Relation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/insurance-relation/insurance-relation-detail.html','<div><h2><span>Insurance Relation</span> {{vm.insuranceRelation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.insuranceRelation.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.insuranceRelation.corporation.id})">{{vm.insuranceRelation.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="insurance-relation-detail.edit({id:vm.insuranceRelation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/insurance-relation/insurance-relation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInsuranceRelationLabel">Create or edit a Insurance Relation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.insuranceRelation.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/insurance-relation/insurance-relations.html','<section class="content-header"><h1>Insurance Relations</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="insurance-relation.new"><span class="glyphicon glyphicon-flash"></span> <span>New Insurance Relation</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryinsurance-relation" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/insurance-type/insurance-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.insuranceType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Insurance Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/insurance-type/insurance-type-detail.html','<div><h2><span>Insurance Type</span> {{vm.insuranceType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.insuranceType.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.insuranceType.corporation.id})">{{vm.insuranceType.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="insurance-type-detail.edit({id:vm.insuranceType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/insurance-type/insurance-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInsuranceTypeLabel">Create or edit a Insurance Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.insuranceType.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/insurance-type/insurance-types.html','<section class="content-header"><h1>Insurance Types</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="insurance-type.new"><span class="glyphicon glyphicon-flash"></span> <span>New Insurance Type</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryinsurance-type" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/invoice/invoice-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.invoice.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Invoice?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/invoice/invoice-detail.html','<div><h2><span>Invoice</span> {{vm.invoice.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Start Date</span></dt><dd><span>{{vm.invoice.startDate | date:\'mediumDate\'}}</span></dd><dt><span>End Date</span></dt><dd><span>{{vm.invoice.endDate | date:\'mediumDate\'}}</span></dd><dt><span>Adjustment</span></dt><dd><span>{{vm.invoice.adjustment}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="invoice-detail.edit({id:vm.invoice.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button> <button type="button" ui-sref="invoice-patient({id:vm.invoice.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Invoice Patient</span></button></div>');
$templateCache.put('app/entities/invoice/invoice-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInvoiceLabel">Create or edit a Invoice</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.invoice.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.invoice.id" readonly="readonly"></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.startDate" is-open="vm.datePickerOpenStatus.startDate" required ng-disabled="vm.invoice.id != null"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.startDate.$invalid"><p class="help-block" ng-show="editForm.startDate.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_endDate">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoice.endDate" is-open="vm.datePickerOpenStatus.endDate" required ng-disabled="vm.invoice.id != null"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.endDate.$invalid"><p class="help-block" ng-show="editForm.endDate.$error.required">This field is required.</p></div></div></div></div><div class="form-group"><label class="control-label" for="field_adjustment">Adjustment</label><input type="number" class="form-control" name="adjustment" id="field_adjustment" ng-model="vm.invoice.adjustment" required><div ng-show="editForm.adjustment.$invalid"><p class="help-block" ng-show="editForm.adjustment.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.adjustment.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_adjustmentComment">Adjustment Comment</label><textarea type="text" class="form-control" name="adjustmentComment" id="field_adjustmentComment" ng-model="vm.invoice.adjustmentComment"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/invoice/invoices.html','<section class="content-header"><h1>Invoices</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="invoice.new"><span class="glyphicon glyphicon-flash"></span> <span>New Invoice</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed custom-table"></table></div></div></div></div></section>');
$templateCache.put('app/entities/invoice-environmental/invoice-environmental-detail.html','<div><h2><span>Invoice Environmental</span> {{vm.invoiceEnvironmental.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Accession Number</span></dt><dd><span>{{vm.invoiceEnvironmental.accessionNumber}}</span></dd><dt><span>Site Name</span></dt><dd><span>{{vm.invoiceEnvironmental.siteName}}</span></dd><dt><span>Date</span></dt><dd><span>{{vm.invoiceEnvironmental.date | date:\'mediumDate\'}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.invoiceEnvironmental.description}}</span></dd><dt><span>Price</span></dt><dd><span>{{vm.invoiceEnvironmental.price}}</span></dd><dt><span>Adjustment</span></dt><dd><span>{{vm.invoiceEnvironmental.adjustment}}</span></dd><dt><span>Adjustment Comment</span></dt><dd><span>{{vm.invoiceEnvironmental.adjustment_comment}}</span></dd><dt><span>Invoice</span></dt><dd><a ui-sref="invoice-detail({id:vm.invoiceEnvironmental.invoice.id})">{{vm.invoiceEnvironmental.invoice.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="invoice-environmental-detail.edit({id:vm.invoiceEnvironmental.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/invoice-environmental/invoice-environmental-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInvoiceEnvironmentalLabel">Edit a Invoice Environmental</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.invoiceEnvironmental.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.invoiceEnvironmental.id" readonly="readonly"></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_accessionNumber">Accession Number</label><input type="text" class="form-control" name="accessionNumber" id="field_accessionNumber" ng-model="vm.invoiceEnvironmental.accessionNumber" disabled="disabled" required><div ng-show="editForm.accessionNumber.$invalid"><p class="help-block" ng-show="editForm.accessionNumber.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoiceEnvironmental.date" is-open="vm.datePickerOpenStatus.date" disabled="disabled"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_siteName">Site Name</label><input type="text" class="form-control" name="siteName" id="field_siteName" ng-model="vm.invoiceEnvironmental.siteName" disabled="disabled"><div ng-show="editForm.siteName.$invalid"><p class="help-block" ng-show="editForm.siteName.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.invoiceEnvironmental.description" required disabled="disabled"><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_price">Price</label><input type="number" class="form-control" name="price" id="field_price" ng-model="vm.invoiceEnvironmental.price" disabled="disabled"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_adjustment">Adjustment</label><input type="number" class="form-control" name="adjustment" id="field_adjustment" ng-model="vm.invoiceEnvironmental.adjustment"></div></div></div><div class="form-group"><label class="control-label" for="field_adjustment_comment">Adjustment Comment</label><textarea class="form-control" name="adjustment_comment" id="field_adjustment_comment" ng-model="vm.invoiceEnvironmental.adjustmentComment"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/invoice-environmental/invoice-environmentals.html','<section class="content-header"><h1>Invoice - Environmentals</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-primary"><div class="box-body"><div class="table-responsive"><table class="table table-striped table-bordered table-condensed custom-table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/invoice-patient/invoice-patient-detail.html','<div><h2><span>Invoice Patient</span> {{vm.invoicePatient.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Accession Number</span></dt><dd><span>{{vm.invoicePatient.accessionNumber}}</span></dd><dt><span>Patient Name</span></dt><dd><span>{{vm.invoicePatient.patientName}}</span></dd><dt><span>Date</span></dt><dd><span>{{vm.invoicePatient.date | date:\'mediumDate\'}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.invoicePatient.description}}</span></dd><dt><span>Price</span></dt><dd><span>{{vm.invoicePatient.price}}</span></dd><dt><span>Adjustment</span></dt><dd><span>{{vm.invoicePatient.adjustment}}</span></dd><dt><span>Invoice</span></dt><dd><a ui-sref="invoice-detail({id:vm.invoicePatient.invoice.id})">{{vm.invoicePatient.invoice.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="invoice-patient-detail.edit({id:vm.invoicePatient.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/invoice-patient/invoice-patient-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInvoicePatientLabel">Edit Invoice Patient</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.invoicePatient.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.invoicePatient.id" readonly="readonly"></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_accessionNumber">Accession Number</label><input type="text" class="form-control" name="accessionNumber" id="field_accessionNumber" ng-model="vm.invoicePatient.accessionNumber" disabled="disabled" required><div ng-show="editForm.accessionNumber.$invalid"><p class="help-block" ng-show="editForm.accessionNumber.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_date">Date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoicePatient.date" is-open="vm.datePickerOpenStatus.date" disabled="disabled"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_patientName">Patient Name</label><input type="text" class="form-control" name="patientName" id="field_patientName" ng-model="vm.invoicePatient.patientName" disabled="disabled" required><div ng-show="editForm.patientName.$invalid"><p class="help-block" ng-show="editForm.patientName.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_dob">D.O.B</label><div class="input-group"><input id="field_dob" type="text" class="form-control" name="dob" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoicePatient.dob" is-open="vm.datePickerOpenStatus.dob" disabled="disabled"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dob\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.invoicePatient.description" required disabled="disabled"><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_price">Price</label><input type="number" class="form-control" name="price" id="field_price" ng-model="vm.invoicePatient.price" disabled="disabled"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_adjustment">Adjustment</label><input type="number" class="form-control" name="adjustment" id="field_adjustment" ng-model="vm.invoicePatient.adjustment"></div></div></div><div class="form-group"><label class="control-label" for="field_adjustmentComment">Adjustment Comment</label><textarea class="form-control" name="adjustmentComment" id="field_adjustmentComment" ng-model="vm.invoicePatient.adjustmentComment"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/invoice-patient/invoice-patients.html','<section class="content-header"><h1>Invoice - Patients</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-primary"><div class="box-body"><div class="table-responsive"><table class="table table-striped table-bordered table-condensed custom-table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/kinetic/kinetic-info-skip.html','<section class="content-header"><h1><i class="ion ion-alert"></i> Skip kinetic for this barcode?</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="box box-primary"><div class="box-body"><form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="row"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="col-md-5"><div class="form-group"><label class="control-label" ng-show="$index == 0">Barcode</label><div class="input-group"><input id="barcode" type="text" class="form-control" name="barcode" ng-model="vm.barcode" ng-required="true"></div></div></div></div></div></form></div><div class="box-footer"><div class="pull-right"><button type="button" class="btn btn-success" ng-click="vm.skip()" ng-disabled="vm.editForm.$invalid || vm.isSaving">Skip</button></div></div></div></section>');
$templateCache.put('app/entities/kinetic/kinetic-info.html','<section class="content-header"><h1>Kinetic Information</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="box box-primary"><div class="box-body"><form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="row pb-15" ng-repeat="info in vm.missing" ng-class-even="\'even-row\'"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 patient-data"><label ng-show="$index == 0">Patient:</label><div class="data"><span class="name">{{info.patient.lastName}}, {{info.patient.firstName}}</span>- <span class="date">{{info.patientOrderItem.collectedDate | date:\'MM/dd/yy\'}}</span>- <span class="r-number">{{info.patientOrderItem.groupNumberId}}</span></div></div><div class="col-xs-6 col-sm-4 col-md-2 col-lg-2" ng-if="info.hhmm"><label class="control-label" for="field_dialysis_length_hh_mm{{$index}}" ng-show="$index == 0">Dialysis Length:</label><div class="input-group" moment-picker="info.dialysisLengthHhmm" show-header="false" format="HH:mm"><span class="input-group-addon" ng-click="info.hhmm=!info.hhmm" uib-tooltip="Change units to {{info.hhmm ? \'mm\' : \'HH:mm\'}}"><i class="fa fa-exchange" aria-hidden="true"></i> </span><input class="form-control" uib-tooltip="Format: {{info.hhmm ? \'HH:mm\' : \'mm\'}}" placeholder="Select time length" show-header="false" format="HH:mm" ng-model="info.dialysisLengthHhmm" ng-model-options="{ updateOn: \'blur\'}" required name="dialysis_length_hh_mm{{$index}}" id="field_dialysis_length_hh_mm{{$index}}"> <span class="input-group-addon">{{info.hhmm ? \'Hours\' : \'Mins\'}}</span></div><div ng-show="vm.editForm.dialysis_length_hh_mm{{$index}}.$invalid"><p class="help-block" ng-show="vm.editForm.dialysis_length_hh_mm{{$index}}.$error.required">This field is required.</p></div></div><div class="col-xs-6 col-sm-4 col-md-2 col-lg-2" ng-if="!info.hhmm"><label class="control-label" for="field_dialysis_length{{$index}}" ng-show="$index == 0">Dialysis Length:</label><div class="input-group"><span class="input-group-addon" ng-click="info.hhmm=!info.hhmm" uib-tooltip="Change units to {{info.hhmm ? \'mm\' : \'HH:mm\'}}"><i class="fa fa-exchange" aria-hidden="true"></i> </span><input id="field_dialysis_length{{$index}}" type="number" class="form-control" uib-tooltip="Format: mm" ng-model="info.dialysisLength" placeholder="Select time length" name="dialysis_length{{$index}}" required min="1"> <span class="input-group-addon">{{info.hhmm ? \'HH:mm\' : \'mm\'}}</span></div><div ng-show="vm.editForm.dialysis_length{{$index}}.$invalid"><p class="help-block" ng-show="vm.editForm.dialysis_length{{$index}}.$error.required">This field is required.</p></div></div><div class="col-xs-5 col-sm-3 col-md-2 col-lg-2"><label class="control-label" for="field_preWeight{{$index}}" ng-show="$index == 0">Pre Weight</label><div class="input-group"><span class="input-group-addon" ng-click="info.kg=!info.kg" uib-tooltip="Change units to {{info.kg ? \'Lbs\' : \'Kg\'}}"><i class="fa fa-exchange" aria-hidden="true"></i> </span><input type="number" class="form-control" name="preWeight{{$index}}" min="0" id="field_preWeight{{$index}}" ng-model="info.preWeight" ng-required="true"> <span class="input-group-addon">{{info.kg ? \'Kg\' : \'Lbs\'}}</span></div><div ng-show="vm.editForm.preWeight{{$index}}.$invalid"><p class="help-block" ng-show="vm.editForm.preWeight{{$index}}.$error.required">This field is required.</p><p class="help-block" ng-show="vm.editForm.preWeight{{$index}}.$error.number">This field should be a number.</p></div></div><div class="col-xs-5 col-sm-3 col-md-2 col-lg-2"><label class="control-label" for="field_posWeight{{$index}}" ng-show="$index == 0">Post Weight</label><div class="input-group"><input type="number" class="form-control" name="posWeight{{$index}}" min="0" id="field_posWeight{{$index}}" ng-model="info.posWeight" ng-required="true"> <span class="input-group-addon">{{info.kg ? \'Kg\' : \'Lbs\'}}</span></div><div ng-show="vm.editForm.posWeight{{$index}}.$invalid"><p class="help-block" ng-show="vm.editForm.posWeight{{$index}}.$error.required">This field is required.</p><p class="help-block" ng-show="vm.editForm.posWeight{{$index}}.$error.number">This field should be a number.</p></div></div><div class="col-xs-2 col-sm-2 col-md-1 col-lg-1 text-center" ng-class="$index == 0?\'pt-20\':\'\'"><button type="button" class="btn btn-default btn-sm btn-remove-kinetic" uib-tooltip="Dismiss" ng-click="vm.remove($index)" ng-disabled="vm.missing.length == 1"><i class="fa fa-times" aria-hidden="true"></i></button></div></div></div></form></div><div class="box-footer"><div class="pull-right"><button type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="vm.editForm.$invalid || vm.isSaving">Send Information</button></div></div></div></section>');
$templateCache.put('app/entities/kinetic/kinetic-sent.html','<ng-include src="\'app/entities/kinetic/tpl/kinetic-filter-tpl.html\'"></ng-include><section class="content-header"><h1><i class="fa fa-calculator"></i> Kinetic Information Sent</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header"><div class="row"><div class="col-xs-3"><div class="input-group"><input id="field_start" type="text" class="form-control" name="start" placeholder="Start Sent Date" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.filterData.sentStart" is-open="vm.datePickerOpenStatus.start"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'start\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-xs-3"><div class="input-group"><input id="field_end" type="text" class="form-control" name="end" placeholder="End Sent Date" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.filterData.sentEnd" is-open="vm.datePickerOpenStatus.end"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'end\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div popover-class="pop" popover-placement="bottom" uib-popover-template="\'kinetic-filter-tpl.html\'" popover-is-open="vm.showFilter" popover-trigger="none"></div></div><div class="col-xs-3"><div class="input-group"><select class="form-control" ng-model="vm.filterData.clinic" ng-options="clinic as clinic.name for clinic in vm.clinics track by clinic.id"></select><span class="input-group-btn width-min"><button ng-click="vm.lessFilter()" class="btn btn-primary" type="button" class="btn btn-default"><span class="glyphicon glyphicon-refresh"></span></button></span></div></div><div class="col-xs-3"><form name="searchForm" class="form-inline"><div><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" popover-class="" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button ng-click="vm.popoverFilterEnable()" class="btn btn-primary" type="button" class="btn btn-default"><span class="glyphicon glyphicon-filter"></span></button> <button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></form></div></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/kinetic/kinetics.html','<section class="content-header"><h1 class="section-title">Pending Kinetics</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button type="button" class="btn btn-default btn-lg btn-header green" ng-click="vm.addKinetics()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Kinetics</button><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search query..." ng-model="vm.searchQuery" ng-change="vm.search()" id="searchQueryPatient"> <button type="button" class="btn btn-default btn-lg" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title"><strong>Clinic:</strong> {{vm.clinic.name}} | <strong>Patients:</strong> {{vm.patients.length}}</h3></div><div class="box-body"><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered custom-table"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/lab-bundle-billing-code/lab-bundle-billing-code-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.labBundleBillingCode.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Lab Bundle Billing Code?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/lab-bundle-billing-code/lab-bundle-billing-code-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLabBundleBillingCodeLabel">Create or edit a Lab Bundle Billing Code</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" for="field_testCode">Test Code</label><input type="text" class="form-control" name="testCode" id="field_testCode" ng-model="vm.labBundleBillingCode.testCode" required><div ng-show="editForm.testCode.$invalid"><p class="help-block" ng-show="editForm.testCode.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/lab-bundle-billing-code/lab-bundle-billing-codes.html','<section class="content-header"><h1>Lab Bundle Billing Codes</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><div class="btn-group" uib-dropdown><button type="button" class="btn btn-primary" ui-sref="lab-bundle-billing-code.new"><span class="glyphicon glyphicon-plus"></span> <span>New Lab Bundle Billing Codes</span></button> <button type="button" class="btn btn-primary dropdown-toggle" uib-dropdown-toggle data-toggle="dropdown" aria-expanded="false"><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a ng-click="vm.init()"><span class="glyphicon glyphicon-calendar"></span>Restore All Codes</a></li></ul></div></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryrace" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/lab-notification/lab-notification-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.labNotification.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Lab Notification?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/lab-notification/lab-notification-detail.html','<div><h2><span>Lab Notification</span> {{vm.labNotification.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.labNotification.name}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.labNotification.description}}</span></dd><dt><span>Start Date</span></dt><dd><span>{{vm.labNotification.startDate | date:\'mediumDate\'}}</span></dd><dt><span>End Date</span></dt><dd><span>{{vm.labNotification.endDate | date:\'mediumDate\'}}</span></dd><dt><span>Active</span></dt><dd><span>{{vm.labNotification.active}}</span></dd><dt><span>Type</span></dt><dd><span>{{vm.labNotification.type}}</span></dd><dt><span>Clinic</span></dt><dd><span ng-repeat="clinic in vm.labNotification.clinics"><a ui-sref="clinic-detail({id: clinic.id})">{{clinic.id}}</a>{{$last ? \'\' : \', \'}} </span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="lab-notification-detail.edit({id:vm.labNotification.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/lab-notification/lab-notification-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLabNotificationLabel">Create or edit a Lab Notification</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.labNotification.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.labNotification.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.labNotification.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><textarea type="text" class="form-control" name="description" id="field_description" rows="4" ng-model="vm.labNotification.description">\n            </textarea></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.labNotification.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_endDate">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.labNotification.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_active">Active</label><input type="checkbox" name="active" id="field_active" ng-model="vm.labNotification.active"></div></div></div><div class="form-group"><label class="control-label" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.labNotification.type" id="field_type"><option value="WARNING">WARNING</option><option value="URGENT">URGENT</option><option value="INFO">INFO</option><option value="CHECK">CHECK</option></select></div><div class="form-group"><label for="field_clinic">Clinics</label><select class="form-control" id="field_clinic" multiple="multiple" name="clinic" ng-model="vm.labNotification.clinics" ng-options="clinic as clinic.name for clinic in vm.clinics track by clinic.id"></select></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_top_priority">Top priority</label><input type="checkbox" name="active" id="field_top_priority" ng-model="vm.labNotification.topPriority"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_locked">Locked</label><input type="checkbox" name="active" id="field_locked" ng-model="vm.labNotification.locked"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/lab-notification/lab-notifications.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/language/language-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.language.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Language?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/language/language-detail.html','<div><h2><span>Language</span> {{vm.language.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.language.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.language.corporation.id})">{{vm.language.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="language-detail.edit({id:vm.language.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/language/language-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLanguageLabel">Create or edit a Language</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.language.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/language/languages.html','<section class="content-header"><h1>Languages</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="language.new"><span class="glyphicon glyphicon-flash"></span> <span>New Language</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerylanguage" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/machine/machine-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.machine.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Machine?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/machine/machine-detail.html','<section class="content-header"><h1 class="section-title"><i class="fa fa-gears"></i> Site: {{vm.machine.name}} <small>Type: {{vm.machine.mType}} | Status: {{vm.machine.mStatus ? \'Active\' : \'Inactive\'}}</small></h1><div ncy-breadcrumb class="breadcrumb"></div></section><div style="padding: 15px 15px 15px 15px; background: rgb(129,181,212); z-index: 999999; font-size: 16px; font-weight: 600" ui-view="select-filter"></div><div ui-view="content"></div>');
$templateCache.put('app/entities/machine/machine-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMachineLabel" ng-show="vm.machine.id">Edit Machine</h4><h4 class="modal-title" id="myMachineLabel" ng-show="!vm.machine.id">Create Machine</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.machine.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div><!--<div class="form-group">--><!--<label class="control-label" for="field_location">Location</label>--><!--<input type="text" class="form-control" name="location" id="field_location"--><!--ng-model="vm.machine.location"--><!--/>--><!--</div>--><div class="form-group"><label class="control-label">Active</label><br><toggle ng-model="vm.machine.mStatus" on="Yes" off="No" id="field_mStatus"></toggle></div><div class="form-group"><label class="control-label" for="field_mType">Type</label><select class="form-control" name="mType" ng-model="vm.machine.mType" id="field_mType" required><option value="WATER">WATER</option><option value="DIALYSATE">DIALYSATE</option><option value="BICARB">BICARB</option><option value="OTHER">OTHER</option></select><div ng-show="editForm.mType.$invalid"><p class="help-block" ng-show="editForm.mType.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_notes">Notes</label><input type="text" class="form-control" name="notes" id="field_notes" ng-model="vm.machine.notes"></div><div class="form-group"><label for="field_site-location">Location</label><select class="form-control" id="field_site-location" name="site-location" ng-model="vm.machine.siteLocation" ng-options="siteLocation as siteLocation.name for siteLocation in vm.siteLocations track by siteLocation.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/machine/machine-menu-dialog.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.machine()">&times;</button><h4 class="modal-title">Warning</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>No site selected!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.machine()"><span class="fa fa-thermometer"></span>&nbsp;<span>Sites</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.dashboard()"><span class="fa fa-dashboard"></span>&nbsp;<span>Dashboard</span></button></div></div>');
$templateCache.put('app/entities/machine/machine-select-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Select sites</h4></div><div class="modal-body"><div class="box-header"><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input type="text" class="form-control" ng-model="vm.searchQuery" size="80" id="searchQueryrpt-metadata" placeholder="Query" ng-change="vm.search()"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-default" data-dismiss="modal" ng-click="vm.accept()"><span class="fa fa-gears"></span>&nbsp;<span>Select</span></button></div>');
$templateCache.put('app/entities/machine/machine-select-filter.html','<div class="row"><div class="col-md-3"><div class="form-group"><div class="input-group"><ui-select ng-model="vm.machine" title="Choose a Site" ng-disabled="false" on-select="vm.selectMachine()"><ui-select-match placeholder="Select Site..."> {{$select.selected.name}} </ui-select-match><ui-select-choices repeat="machine in vm.machines | propsFilter: {name: $select.search}"><div ng-bind-html="machine.name | highlight: $select.search"></div><small>Location: {{machine.location | date:\'MM/dd/yy\'}} | Type: {{machine.mType}} </small></ui-select-choices></ui-select><span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.removeMachine()"><span class="fa fa-trash"></span></button></span></div></div></div></div>');
$templateCache.put('app/entities/machine/machines.html','<section class="content-header"><h1 class="section-title"><i class="fa fa-gears"></i> {{vm.title}}</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/med-dosage-unit/med-dosage-unit-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.medDosageUnit.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Med Dosage Unit?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/med-dosage-unit/med-dosage-unit-detail.html','<div><h2><span>Med Dosage Unit</span> {{vm.medDosageUnit.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.medDosageUnit.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.medDosageUnit.corporation.id})">{{vm.medDosageUnit.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="med-dosage-unit-detail.edit({id:vm.medDosageUnit.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/med-dosage-unit/med-dosage-unit-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMedDosageUnitLabel">Create or edit a Med Dosage Unit</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.medDosageUnit.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/med-dosage-unit/med-dosage-units.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/med-frequency-from/med-frequency-from-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.medFrequencyFrom.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Med Frequency From?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/med-frequency-from/med-frequency-from-detail.html','<div><h2><span>Med Frequency From</span> {{vm.medFrequencyFrom.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.medFrequencyFrom.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.medFrequencyFrom.corporation.id})">{{vm.medFrequencyFrom.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="med-frequency-from-detail.edit({id:vm.medFrequencyFrom.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/med-frequency-from/med-frequency-from-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMedFrequencyFromLabel">Create or edit a Med Frequency From</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.medFrequencyFrom.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/med-frequency-from/med-frequency-froms.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/med-frequency-to/med-frequency-to-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.medFrequencyTo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Med Frequency To?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/med-frequency-to/med-frequency-to-detail.html','<div><h2><span>Med Frequency To</span> {{vm.medFrequencyTo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.medFrequencyTo.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.medFrequencyTo.corporation.id})">{{vm.medFrequencyTo.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="med-frequency-to-detail.edit({id:vm.medFrequencyTo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/med-frequency-to/med-frequency-to-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMedFrequencyToLabel">Create or edit a Med Frequency To</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.medFrequencyTo.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/med-frequency-to/med-frequency-tos.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/med-location/med-location-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.medLocation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Med Location?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/med-location/med-location-detail.html','<div><h2><span>Med Location</span> {{vm.medLocation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.medLocation.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.medLocation.corporation.id})">{{vm.medLocation.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="med-location-detail.edit({id:vm.medLocation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/med-location/med-location-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMedLocationLabel">Create or edit a Med Location</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.medLocation.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/med-location/med-locations.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/med-route/med-route-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.medRoute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Med Route?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/med-route/med-route-detail.html','<div><h2><span>Med Route</span> {{vm.medRoute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.medRoute.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.medRoute.corporation.id})">{{vm.medRoute.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="med-route-detail.edit({id:vm.medRoute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/med-route/med-route-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMedRouteLabel">Create or edit a Med Route</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.medRoute.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/med-route/med-routes.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/medication/medication-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.medication.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Medication?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/medication/medication-detail.html','<div><h2><span>Medication</span> {{vm.medication.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>M Type</span></dt><dd><span>{{vm.medication.mType}}</span></dd><dt><span>Brand</span></dt><dd><span>{{vm.medication.brand}}</span></dd><dt><span>Dosage</span></dt><dd><span>{{vm.medication.dosage}}</span></dd><dt><span>Physician</span></dt><dd><span>{{vm.medication.physician}}</span></dd><dt><span>Other Freq</span></dt><dd><span>{{vm.medication.otherFreq}}</span></dd><dt><span>Days</span></dt><dd><span>{{vm.medication.days}}</span></dd><dt><span>Admin On Dialysis</span></dt><dd><span>{{vm.medication.adminOnDialysis}}</span></dd><dt><span>Instructions</span></dt><dd><span>{{vm.medication.instructions}}</span></dd><dt><span>Special Instructions</span></dt><dd><span>{{vm.medication.specialInstructions}}</span></dd><dt><span>Unit</span></dt><dd><a ui-sref="med-dosage-unit-detail({id:vm.medication.unit.id})">{{vm.medication.unit.id}}</a></dd><dt><span>Route</span></dt><dd><a ui-sref="med-route-detail({id:vm.medication.route.id})">{{vm.medication.route.id}}</a></dd><dt><span>Med Freq From</span></dt><dd><a ui-sref="med-frequency-from-detail({id:vm.medication.medFreqFrom.id})">{{vm.medication.medFreqFrom.id}}</a></dd><dt><span>Med Freq To</span></dt><dd><a ui-sref="med-frequency-to-detail({id:vm.medication.medFreqTo.id})">{{vm.medication.medFreqTo.id}}</a></dd><dt><span>Location</span></dt><dd><a ui-sref="med-location-detail({id:vm.medication.location.id})">{{vm.medication.location.id}}</a></dd><dt><span>Patient</span></dt><dd><a ui-sref="patient-detail({id:vm.medication.patient.id})">{{vm.medication.patient.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="medication-detail.edit({id:vm.medication.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/medication/medication-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMedicationLabel" ng-show="vm.medication.id">Edit patient medication</h4><h4 class="modal-title" id="myMedicationLabel" ng-show="!vm.medication.id">Create new patient medication</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_mType">Medication Type</label><input type="text" class="form-control" name="mType" id="field_mType" ng-model="vm.medication.mType" required><div ng-show="editForm.mType.$invalid"><p class="help-block" ng-show="editForm.mType.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_brand">Brand</label><input type="text" class="form-control" name="brand" id="field_brand" ng-model="vm.medication.brand" required><div ng-show="editForm.brand.$invalid"><p class="help-block" ng-show="editForm.brand.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_dosage">Dosage</label><div class="input-group"><input type="number" class="form-control" name="dosage" id="field_dosage" required ng-model="vm.medication.dosage"><div class="input-group-addon"> {{vm.medication.unit.name}} </div></div><div ng-show="editForm.dosage.$invalid"><p class="help-block" ng-show="editForm.dosage.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><div class="form-group"><label for="field_unit">Unit</label><select class="form-control" id="field_unit" name="unit" ng-model="vm.medication.unit" required ng-options="medDosageUnit as medDosageUnit.name for medDosageUnit in vm.meddosageunits track by medDosageUnit.id"><option value=""></option></select><div ng-show="editForm.unit.$invalid"><p class="help-block" ng-show="editForm.unit.$error.required">This field is required.</p></div></div></div></div><div class="col-lg-4"><div class="form-group"><label for="field_route">Route</label><select class="form-control" id="field_route" name="route" ng-model="vm.medication.route" required ng-options="medRoute as medRoute.name for medRoute in vm.medroutes track by medRoute.id"><option value=""></option></select><div ng-show="editForm.route.$invalid"><p class="help-block" ng-show="editForm.route.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label class="control-label" for="field_physician">Physician</label><input type="text" class="form-control" name="physician" id="field_physician" required ng-model="vm.medication.physician"><div ng-show="editForm.physician.$invalid"><p class="help-block" ng-show="editForm.physician.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label for="field_medFreqFrom">From</label><select class="form-control" id="field_medFreqFrom" name="medFreqFrom" ng-model="vm.medication.medFreqFrom" ng-options="medFrequencyFrom as medFrequencyFrom.name for medFrequencyFrom in vm.medfrequencyfroms track by medFrequencyFrom.id"><option value=""></option></select></div></div><div class="col-lg-4"><div class="form-group"><label for="field_medFreqTo">To</label><select class="form-control" id="field_medFreqTo" name="medFreqTo" ng-model="vm.medication.medFreqTo" ng-options="medFrequencyTo as medFrequencyTo.name for medFrequencyTo in vm.medfrequencytos track by medFrequencyTo.id"><option value=""></option></select></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_otherFreq">Other</label><input type="text" class="form-control" name="otherFreq" id="field_otherFreq" ng-model="vm.medication.otherFreq"></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label class="control-label">Days</label><ui-select id="field_days" name="drawDays" multiple="multiple" ng-model="vm.medication.days2" close-on-select="false" title="Days"><ui-select-match placeholder="Select Days...">{{$item}}</ui-select-match><ui-select-choices repeat="day in vm.days | filter:$select.search"> {{day}} </ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label for="field_location">Location</label><select class="form-control" id="field_location" name="location" ng-model="vm.medication.location" ng-options="medLocation as medLocation.name for medLocation in vm.medlocations track by medLocation.id"><option value=""></option></select></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">Administered On Dialysis?</label><br><toggle ng-model="vm.medication.adminOnDialysis" on="Yes" off="No" id="field_adminOnDialysis"></toggle></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label class="control-label" for="field_instructions">Instructions</label><input type="text" class="form-control" name="instructions" id="field_instructions" ng-model="vm.medication.instructions"></div><div class="form-group"><label class="control-label" for="field_specialInstructions">Special Instructions</label><textarea type="text" class="form-control" name="specialInstructions" id="field_specialInstructions" ng-model="vm.medication.specialInstructions"></textarea></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/medication/medications.html','<section class="content"><div class="row"><div class="col-xs-12"><button type="button" class="btn btn-primary" ui-sref="medication-new" ng-if="vm.patient.status"><span class="glyphicon glyphicon-add"></span> <span>New Medication</span></button><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></section>');
$templateCache.put('app/entities/modality/modalities.html','<section class="content-header"><h1>Modalities</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="modality.new"><span class="glyphicon glyphicon-flash"></span> <span>New Modality</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerymodality" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/modality/modality-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.modality.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Modality?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/modality/modality-detail.html','<div><h2><span>Modality</span> {{vm.modality.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.modality.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.modality.corporation.id})">{{vm.modality.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="modality-detail.edit({id:vm.modality.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/modality/modality-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myModalityLabel">Create or edit a Modality</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.modality.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/patient/patient-change.html','<ng-include src="\'app/entities/patient/tpl/patient-filter-tpl.html\'"></ng-include><!--<div--><!--style="padding: 15px 15px 15px 15px; background: rgb(129,181,212); z-index: 999999; font-size: 16px; font-weight: 600;"--><!--ui-view="select-filter"></div>--><section class="content-header"><h1><i class="fa fa-user"></i> Change patient from clinic</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Clinic : {{vm.clinic.name}} - Patients: {{vm.patients.length}}</h3></div><div class="box-header"><div class="col-xs-3 no-padding-left"><div class="input-group"><ui-select ng-model="vm.newClinic" name="clinic" id="field_clinic" reset-search-input="false" title="Clinic" search-enabled="false"><ui-select-match placeholder="Select new clinic...">{{$select.selected.name}} </ui-select-match><ui-select-choices repeat="clinic in vm.clinics"><div ng-bind-html="clinic.name"></div></ui-select-choices></ui-select><span class="input-group-btn width-min"><button class="btn btn-primary" name="search" id="search-btn" ng-disabled="vm.newClinic == null" ng-click="vm.changeClinic()"><span class="fa fa-refresh"></span></button></span></div></div><div class="col-xs-5 col-xs-offset-4 no-padding-right"><form name="searchForm"><div><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" popover-class="" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button ng-click="vm.popoverFilterEnable()" class="btn btn-primary" type="button" class="btn btn-default"><span class="glyphicon glyphicon-filter"></span></button> <button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div><div popover-class="pop" popover-placement="bottom" uib-popover-template="\'patient-filter-tpl.html\'" popover-is-open="vm.showFilter" popover-trigger="none"></div></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/patient/patient-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.patient.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Patient?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/patient/patient-detail.html','<jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Demographics</h3></div><div class="box-body"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" select="vm.keepActiveTab(0)" heading="Patient Information"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/patient/tpl/form/patient-info-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="1" select="vm.keepActiveTab(1)" heading="Address"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/patient/tpl/form/patient-address-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="2" select="vm.keepActiveTab(2)" heading="Insurance"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/patient/tpl/form/patient-insurance-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="3" select="vm.keepActiveTab(3)" heading="Clinical Information"><fieldset ng-disabled="!vm.editing"><ng-include src="\'app/entities/patient/tpl/form/patient-clinic-info-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="4" select="vm.keepActiveTab(4)" heading="Access" ng-if="vm.patient.id !== null"><div ui-view="patient-access"></div></uib-tab><uib-tab index="5" select="vm.keepActiveTab(5)" heading="Care Team" ng-if="vm.patient.id !== null"><div ui-view="care-team"></div></uib-tab><uib-tab index="6" select="vm.keepActiveTab(6)" heading="Problem List" ng-if="vm.patient.id !== null"><div ui-view="problem-list"></div></uib-tab><uib-tab index="7" select="vm.keepActiveTab(7)" heading="Medications" ng-if="vm.patient.id !== null"><div ui-view="patient-medications"></div></uib-tab><li class="dropdown pull-right" uib-dropdown><a class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false" uib-dropdown-toggle>Actions<span class="caret" uib-dropdown-toggle></span></a><ul class="dropdown-menu" uib-dropdown-menu><li><a ui-sref="hospitalization({id: vm.patient.id})">Hospitalizations</a></li><li><a ui-sref="infection({id: vm.patient.id})">Infections</a></li><li><a ui-sref="patient-order-current({id: vm.patient.id})">Orders - Current</a></li><li><a ui-sref="patient-order-history({id: vm.patient.id})">Orders - History</a></li><li><a ui-sref="patient-result({id: vm.patient.id})">Results</a></li><li><a ui-sref="trending({id: vm.patient.id})">Results Trending</a></li><li role="presentation" class="divider"></li><li><a ui-sref="patient-edit">Update Information</a></li></ul></li></uib-tabset><!--<div ng-if="vm.patient.status">--><div><div class="pull-right"><button type="button" class="btn btn-info" ui-sref="patient-edit">Update Information</button></div></div></div></div></div></div>');
$templateCache.put('app/entities/patient/patient-health-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Patients with <b>{{vm.patientResultHealth.testName}}</b> {{vm.patientResultHealthItem.range}}</h4></div><div class="modal-body"><div class="box-header"><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input type="text" class="form-control" ng-model="vm.searchQuery" size="80" id="searchQueryrpt-metadata" placeholder="Query" ng-change="vm.search()"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button></div>');
$templateCache.put('app/entities/patient/patient-menu-dialog.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.roster()">&times;</button><h4 class="modal-title">Warning</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>No patient selected!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.roster()"><span class="fa fa-users"></span>&nbsp;<span>Roster</span></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.dashboard()"><span class="fa fa-dashboard"></span>&nbsp;<span>Dashboard</span></button></div></div>');
$templateCache.put('app/entities/patient/patient-new.html','<ng-include src="\'app/entities/patient/tpl/patient-header-tpl.html\'"></ng-include><section class="content-header" ui-view="content"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Demographics</h3></div><jhi-alert-error></jhi-alert-error><div class="box-body"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" select="vm.keepActiveTab(0)" heading="Patient Information"><uib-tab-heading><span ng-class="{boom: vm.tab0}">Patient Information</span></uib-tab-heading><fieldset><ng-include src="\'app/entities/patient/tpl/form/patient-info-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="1" select="vm.keepActiveTab(1)" heading="Address"><uib-tab-heading><span ng-class="{boom: vm.tab1}">Address</span></uib-tab-heading><fieldset><ng-include src="\'app/entities/patient/tpl/form/patient-address-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="2" select="vm.keepActiveTab(2)" heading="Insurance"><uib-tab-heading><span ng-class="{boom: vm.tab2}">Insurance</span></uib-tab-heading><fieldset><ng-include src="\'app/entities/patient/tpl/form/patient-insurance-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="3" select="vm.keepActiveTab(3)" heading="Clinical Information"><uib-tab-heading><span ng-class="{boom: vm.tab3}">Clinical Information</span></uib-tab-heading><fieldset><ng-include src="\'app/entities/patient/tpl/form/patient-clinic-info-tpl.html\'"></ng-include></fieldset></uib-tab></uib-tabset><div class="pull-right"><button type="button" class="btn default" ng-click="vm.cancelEditing()"><i class="fa fa-times"></i> Cancel</button> <button type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="vm.form.patient_info_form.$invalid || vm.form.address_form.$invalid ||\n                        vm.form.insurance_form.$invalid || vm.form.clinic_info_form.$invalid || vm.form.access_form.$invalid">Save</button></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient/patient-select-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Select patient</h4></div><div class="modal-body"><div class="box-header"><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input type="text" class="form-control" ng-model="vm.searchQuery" size="80" id="searchQueryrpt-metadata" placeholder="Query" ng-change="vm.search()"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-success" data-dismiss="modal" ng-click="vm.accept()"><span class="fa fa-user"></span>&nbsp;<span>Select</span></button></div>');
$templateCache.put('app/entities/patient/patient-select-filter.html','<div class="row"><div class="col-lg-3 col-md-6"><div class="form-group"><div class="input-group"><ui-select ng-model="vm.patient" name="patient" id="field_patient" on-select="vm.onSelectCallback($item, $model)" reset-search-input="true" reset-search-input="false" ng-required="true" title="Patient List" append-to-body="true"><ui-select-match placeholder="Select patient...">{{$select.selected.firstName + \' \' +\n                        $select.selected.middleInitial + \' \' + $select.selected.lastName}} </ui-select-match><ui-select-choices repeat="patient in vm.patients" refresh="vm.filterPatients($select.search)" refresh-delay="0"><div ng-bind-html="patient.firstName + \' \' + patient.middleInitial + \' \' + patient.lastName | highlight: $select.search"></div><small>dob: {{patient.dob | amDateFormat:\'MM/DD/YYYY\'}} </small></ui-select-choices></ui-select><span class="input-group-btn width-min"><button class="btn btn-primary" name="search" id="search-btn" ng-click="vm.clearPatient()"><span class="fa fa-trash"></span></button></span></div></div></div><div class="col-lg-9 col-md-6"><div class="form-group" has-any-authority="{{vm.importAccess}}"><div class="btn-group pull-right" role="group" aria-label="..."><a class="btn btn-default" href="/content/patients-template.xlsx">Download tpl</a> <button type="button" class="btn btn-default" ngf-select="vm.importPatients($file)" accept=".xlsx">Import Patients...</button></div></div></div></div>');
$templateCache.put('app/entities/patient/patients-i.html','<ng-include src="\'app/entities/patient/tpl/patient-filter-tpl.html\'"></ng-include><!--<div style="padding: 15px 15px 15px 15px; background: rgb(129,181,212); z-index: 999999; font-size: 16px; font-weight: 600;" ui-view="select-filter"></div>--><section class="content-header"><h1 class="section-title"><i class="fa fa-user"></i> Patients</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Clinic : {{vm.clinic.name}} - Patients: {{vm.patients.length}}</h3></div><div class=""><div class="box-header"><div class="col-xs-4 no-padding-left"></div><div class="col-xs-8 no-padding-right"><form name="searchForm"><div><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" popover-class="" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button ng-click="vm.popoverFilterEnable()" class="btn btn-primary" type="button" class="btn btn-default"><span class="glyphicon glyphicon-filter"></span></button> <button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div><div popover-class="pop" popover-placement="bottom" uib-popover-template="\'patient-filter-tpl.html\'" popover-is-open="vm.showFilter" popover-trigger="none"></div></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient/patients.html','<ng-include src="\'app/entities/patient/tpl/patient-filter-tpl.html\'"></ng-include><!--<div style="padding: 15px 15px 15px 15px; background: rgb(129,181,212); z-index: 999999; font-size: 16px; font-weight: 600;" ui-view="select-filter"></div>--><section class="content-header"><h1 class="section-title"><i class="fa fa-user"></i> Patients</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Clinic : {{vm.clinic.name}} - Patients: {{vm.patients.length}}</h3></div><div class=""><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="patient-new"><span class="glyphicon glyphicon-flash"></span> <span>New Patient</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm"><div><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" popover-class="" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button ng-click="vm.popoverFilterEnable()" class="btn btn-primary" type="button" class="btn btn-default"><span class="glyphicon glyphicon-filter"></span></button> <button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div><div popover-class="pop" popover-placement="bottom" uib-popover-template="\'patient-filter-tpl.html\'" popover-is-open="vm.showFilter" popover-trigger="none"></div></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient-group/patient-group-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.patientGroup.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Patient Group?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/patient-group/patient-group-detail.html','<div><h2><span>Patient Group</span> {{vm.patientGroup.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.patientGroup.name}}</span></dd><dt><span>Clinic</span></dt><dd><a ui-sref="clinic-detail({id:vm.patientGroup.clinicId})">{{vm.patientGroup.clinicId}}</a></dd><dt><span>Patients</span></dt><dd><span ng-repeat="patient in vm.patientGroup.patients"><a ui-sref="patient-detail({id: patient.id})">{{patient.firstName}}</a>{{$last ? \'\' : \', \'}} </span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="patient-group-detail.edit({id:vm.patientGroup.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/patient-group/patient-group-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientGroupLabel">Create or edit a Patient Group</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.patientGroup.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.patientGroup.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.patientGroup.name"></div><div class="form-group"><label for="field_patient">Patient</label><select class="form-control" id="field_patient" multiple="multiple" name="patient" ng-model="vm.patientGroup.patients" ng-options="patient as patient.firstName + \' \' + patient.lastName for patient in vm.patients track by patient.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/patient-group/patient-groups.html','<div><h2>Patient Groups</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="patient-group.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down">Create new Patient Group</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Name</span></th><th><span>Patients</span></th><th></th></tr></thead><tbody><tr ng-repeat="patientGroup in vm.patientGroups track by patientGroup.id"><td><a ui-sref="patient-group-detail({id:patientGroup.id})">{{patientGroup.id}}</a></td><td>{{patientGroup.name}}</td><td><span ng-repeat="patient in patientGroup.patients"><a class="form-control-static" ui-sref="patient-detail({id: patient.id})">{{patient.firstName}}</a>{{$last ? \'\' : \', \'}} </span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="patient-group-detail({id:patientGroup.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="patient-group.edit({id:patientGroup.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="patient-group.delete({id:patientGroup.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/patient-img/patient-img-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientImgLabel">Create or edit a Patient Picture</h4></div><div class="modal-body"><div class="row"><div class="col-lg-5"><img data-ng-src="{{\'data:\' + vm.patient.patientPicture.pictureContentType + \';base64,\' + vm.patient.patientPicture.picture}}" class="img-responsive" ng-if="vm.patient.patientPicture.picture"><div ng-if="vm.patient.patientPicture.picture" class="help-block clearfix"><span class="pull-left">{{vm.patient.patientPicture.pictureContentType}}, {{vm.byteSize(vm.patient.patientPicture.picture)}}</span><button type="button" ng-click="vm.resetUserPicture()" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setPicture($file, vm.patient)" accept="image/*">Browse...</button></div><div class="col-lg-5"><div id="webcam"><webcam channel="vm.channel" on-streaming="vm.onSuccess()" on-error="vm.onError(err)" on-stream="vm.onStream(stream)"></webcam><div ng-if="vm.patient.patientPicture.picture" class="help-block clearfix"><span class="pull-left"><button class="btn btn-default btn-xs pull-right" type="button" ng-click="vm.makeSnapshot()"><span class="glyphicon glyphicon-camera"></span></button></span></div><canvas ng-hide="true" id="snapshot" width="383" height="383"></canvas></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Accept</span></button></div></form>');
$templateCache.put('app/entities/patient-order/patient-order-cancel-dialog.html','<form name="cancelForm" ng-submit="vm.confirmCancel(vm.patientOrder.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm cancel order</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to cancel this Patient Order?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Dismiss</span></button> <button type="submit" ng-disabled="cancelForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Cancel Order</span></button></div></form>');
$templateCache.put('app/entities/patient-order/patient-order-finish-dialog.html','<form name="cancelForm" ng-submit="vm.confirmFinish(vm.patientOrder.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm finish order</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to finish this Patient Order?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Dismiss</span></button> <button type="submit" ng-disabled="cancelForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Finish Order</span></button></div></form>');
$templateCache.put('app/entities/patient-order/patient-order-new.html','<div class="row"><div class="col-xs-12"><div class="input-group"><span class="input-group-addon" ng-click="vm.selectPatients()"><i class="fa fa-user-plus"></i> Patients</span><ui-select ng-model="vm.patients" name="patient" id="field_patient" multiple="multiple" ng-disabled="vm.patients.length == 1" on-remove="vm.f()" title="Patient List"><ui-select-match placeholder="Select patient..."> {{$item.firstName + \' \' + ($item.middleInitial ? $item.middleInitial : \'\') + \' \' + $item.lastName + \' - DOB: \' + ($item.dob | amDateFormat:\'MM/DD/YYYY\')}} </ui-select-match><ui-select-choices repeat="patient in vm.patientList | propsFilter: {lastName: $select.search, firstName: $select.search}"><div ng-bind-html="patient.firstName + \' \' + patient.middleInitial + \' \' + patient.lastName | highlight: $select.search"></div><small>dob: {{patient.dob | amDateFormat:\'MM/DD/YYYY\'}} </small></ui-select-choices></ui-select></div></div></div><br><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">New Order</h3></div><jhi-alert-error></jhi-alert-error><ng-include src="\'app/entities/patient-order/tpl/new/patient-order-form-tpl.html\'"></ng-include></div></div></div><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div></div></div></div>');
$templateCache.put('app/entities/patient-order/patient-order-update.html','<div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Order {{vm.patientOrder.id}} ({{vm.patientOrder.ordStatus}})</h3></div><jhi-alert-error></jhi-alert-error><div class="box-body"><ng-include src="\'app/entities/patient-order/tpl/update/patient-order-signed-tpl.html\'"></ng-include></div></div></div></div><div ui-view="order-tests"></div>');
$templateCache.put('app/entities/patient-order/patient-order-view.html','<div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Order {{vm.patientOrder.id}} ({{vm.patientOrder.ordStatus}})</h3></div><jhi-alert-error></jhi-alert-error><div class="box-body"><table class="table table-condensed table-striped table-bordered"><tbody><tr><th>Patient Name</th><th>Order Type</th><th>Obtained</th><th>Physician</th><th ng-if="vm.patientOrder.patientOrderTpl">Template</th></tr><tr><td>{{vm.patientOrder.patient.firstName + \' \' +\n                            (vm.patientOrder.patient.middleInitial ? vm.patientOrder.patient.middleInitial : \'\') + \' \' +\n                            vm.patientOrder.patient.lastName}}</td><td>{{vm.patientOrder.orderType}} </td><td>{{vm.patientOrder.via.name}}</td><td>{{vm.patientOrder.signedBy ? vm.patientOrder.signedBy.name + \' \' + vm.patientOrder.signedBy.lastName : ""}}</td><td ng-if="vm.patientOrder.patientOrderTpl">#{{vm.patientOrder.patientOrderTpl.id}} - {{vm.patientOrder.patientOrderTpl.description}}</td></tr></tbody></table></div></div></div></div><div ui-view="order-tests"></div>');
$templateCache.put('app/entities/patient-order-test/patient-order-test-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.patientOrderTest.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Patient Order Test?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/patient-order-test/patient-order-test-detail-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientAccessLabel">Test {{\'"\' + vm.patientOrderTest.compendium.code + \'"\'}}</h4></div><div class="modal-body"><table class="table table-condensed table-striped table-bordered"><tbody><tr><th>Test Code</th><th>Frequency</th><th>Staring Date</th><th>End Date</th><th>Renal</th></tr><tr><td>{{vm.patientOrderTest.compendium.code}}</td><td>{{vm.patientOrderTest.orderFrequency.name}}</td><td>{{vm.patientOrderTest.staringDate | amDateFormat:\'MM/DD/YYYY\'}}</td><td>{{vm.patientOrderTest.endDate | amDateFormat:\'MM/DD/YYYY\'}}</td><td>{{vm.patientOrderTest.renal ? "YES" : "NO"}}</td></tr></tbody></table><div class="row"><div class="col-md-12"><table class="table table-condensed table-striped table-bordered"><tbody><tr><th>ICD 10</th><th>Description</th></tr><tr ng-repeat="diagnosis in vm.patientOrderTest.diagnoses"><td>{{diagnosis.icd10Code}}</td><td>{{diagnosis.description}}</td></tr></tbody></table></div></div><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Test "{{vm.patientOrderTest.compendium.code}}" schedule</h3></div><div class="box-body"><table class="table table-condensed table-striped table-bordered"><tbody><tr><th style="width: 10px">#</th><th>Barcode</th><th>Scheduled Day</th><th>Collected</th><th>Collected Day</th><th>Sent</th><th>Sent Day</th><th>Canceled</th><th ng-show="vm.patientOrder.ordStatus == \'SCHEDULED\'">Cancel</th></tr><tr ng-repeat="item in vm.items"><td>{{$index}}.</td><td>{{item.groupNumberId}}</td><td>{{item.scheduleDate | amDateFormat:\'MM/DD/YYYY\'}}</td><td><span ng-class="item.collected ? \'label label-success\' : \'label label-danger\'">{{item.collected ? \'Yes\' : \'No\'}}</span></td><td>{{item.collectedDate | amDateFormat:\'MM/DD/YYYY\'}}</td><td><span ng-class="item.sent ? \'label label-success\' : \'label label-danger\'">{{item.sent ? \'Yes\' : \'No\'}}</span></td><td>{{item.sentDate | amDateFormat:\'MM/DD/YYYY\'}}</td><td><span ng-class="item.canceled ? \'label label-danger\' : \'label label-success\'">{{item.canceled ? \'Yes\' : \'No\'}}</span></td><td ng-show="vm.patientOrder.ordStatus == \'SCHEDULED\' && !item.canceled && (item.status == \'SCHEDULED\' || item.status == \'PRINTED\')"><nz-toggle ng-model="item.canceled" ng-disabled="item.canceled" ng-click="vm.cancelOrderTestItem(item)"></nz-toggle></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/patient-order-test/patient-order-test-new-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientAccessLabel">Create Order Test</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><form name="vm.form" role="form" show-validation><!--<div class="box-body">--><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label">Test Code</label><ui-select id="field_compendium" name="compendium" reset-search-input="false" ng-change="vm.change()" ng-model="vm.patientOrderTest.compendium" title="Compendium" ng-required="true"><ui-select-match placeholder="Select Test...">{{$select.selected.code}}</ui-select-match><ui-select-choices repeat="compendium in vm.compendiums" refresh="vm.getCompendium($select.search)" refresh-delay="0"><div ng-bind-html="compendium.code | highlight: $select.search"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select><div ng-show="vm.form.compendium.$invalid"><p class="help-block" ng-show="vm.form.compendium.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label for="field_orderFrequency">Frequency</label><select class="form-control" id="field_orderFrequency" name="orderFrequency" ng-required="vm.patientOrder.orderType != \'ONE_TIME\'" ng-change="vm.change()" ng-model="vm.patientOrderTest.orderFrequency" ng-disabled="vm.patientOrder.orderType == \'ONE_TIME\' || test.patientOrderItems.length > 0" ng-options="orderFrequency as orderFrequency.name for orderFrequency in vm.orderfrequencies track by orderFrequency.id"><option value=""></option></select><div ng-show="vm.form.orderFrequency.$invalid"><p class="help-block" ng-show="vm.form.orderFrequency.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label">Renal</label><br><toggle ng-model="vm.patientOrderTest.renal" on="Yes" off="No" name="renal" required ng-disabled="vm.patientOrder.id" ng-change="vm.change()"></toggle><div ng-show="vm.form.renal.$invalid"><p class="help-block" ng-show="vm.form.renal.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label">{{vm.patientOrder.orderType == \'ONE_TIME\' ? \'Collection Date\' : \'Staring Date\'}}</label><div class="input-group"><input id="field_staringDate" type="text" class="form-control" name="staringDate" required ng-change="vm.change()" datepicker-options="vm.startOptions" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.patientOrderTest.staringDate" ng-disabled="test.patientOrderItems.length > 0" is-open="vm.datePickerOpenStatus.staringDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'staringDate\')" ng-disabled="test.patientOrderItems.length > 0"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.staringDate.$invalid"><p class="help-block" ng-show="vm.form.staringDate.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group" ng-show="vm.patientOrder.orderType != \'ONE_TIME\'"><label class="control-label">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" datepicker-options="vm.endOptions" ng-required="vm.patientOrder.orderType != \'ONE_TIME\'" ng-change="vm.change()" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.patientOrderTest.endDate" ng-disabled="vm.patientOrder.orderType == \'ONE_TIME\' || test.patientOrderItems.length > 0" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')" ng-disabled="vm.patientOrder.orderType == \'ONE_TIME\'"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.endDate.$invalid"><p class="help-block" ng-show="vm.form.endDate.$error.required">This field is required.</p></div></div></div></div><div uib-alert ng-repeat="alert in vm.alerts" type="{{alert.type ? alert.type : warning}}" close="vm.closeAlert($index)" dismiss-on-timeout="10000">{{alert.msg}}</div><!--</div>--></form><div class="row"><div class="col-lg-12"><form name="vm.formProblem" role="form" show-validation><!--<div class="box-body">--><label class="control-label">ICD 10</label><ui-select id="field_diagnoses" name="diagnoses" multiple="multiple" ng-model="vm.patientOrderTest.diagnoses" close-on-select="false" title="Diagnoses" required><ui-select-match placeholder="Select ICD 10...">{{$item.icd10Code}}</ui-select-match><ui-select-choices repeat="diagnoses in vm.diagnoses" refresh="vm.getDiagnoses($select.search)" refresh-delay="0"><div ng-bind-html="diagnoses.icd10Code | highlight: $select.search"></div><small> {{diagnoses.description}} </small></ui-select-choices></ui-select><div ng-show="vm.formProblem.diagnoses.$invalid"><p class="help-block" ng-show="vm.formProblem.diagnoses.$error.required">This field is required.</p></div><!--</div>--></form></div></div><div class="row"><div class="col-lg-12"><ng-repeat ng-repeat="problemsChk in vm.problemsChk"><div class="col-lg-6"><div class="checkbox" ng-if="$even"><label><input type="checkbox" ng-change="vm.addProblemDiagnosis($index)" ng-model="problemsChk.in"><span class="badge bg-green">{{problemsChk.diagnosis.icd10Code}}</span> {{problemsChk.diagnosis.description}}</label></div></div><div class="col-lg-6"><div class="checkbox" ng-if="$odd"><label><input type="checkbox" ng-change="vm.addProblemDiagnosis($index)" ng-model="problemsChk.in"><span class="badge bg-green">{{problemsChk.diagnosis.icd10Code}}</span> {{problemsChk.diagnosis.description}}</label></div></div></ng-repeat></div></div><div class="modal-footer"><div class="pull-right"><button type="button" class="btn btn-danger" ng-click="vm.clear()">Cancel</button> <button type="button" class="btn btn-success" ng-disabled="vm.formProblem.$invalid || vm.patientOrderTest.patientOrderItems.length == 0 || !(vm.patientOrderTest.endDate && vm.patientOrderTest.staringDate &&\n                    vm.patientOrderTest.orderFrequency && vm.patientOrderTest.compendium)" ng-click="vm.accept()">Accept</button></div></div><div class="row"><div class="col-lg-12"><div class="box-body" ng-show="vm.patientOrderTest.patientOrderItems != null && vm.patientOrderTest.patientOrderItems.length > 0"><div class="box box-primary"><div class="box-header"><h3 class="box-title">Test "{{vm.patientOrderTest.compendium.code}}" schedule</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button></div></div><div class="box-body"><table class="table table-condensed table-striped table-bordered"><tbody><tr><th style="width: 10px">#</th><th>Scheduled Day</th><th>Collected</th><th>Collected Day</th><th>Canceled</th></tr><tr ng-repeat="item in vm.patientOrderTest.patientOrderItems"><td>{{$index}}.</td><td>{{item.scheduleDate | amDateFormat:\'MM/DD/YYYY\'}} </td><td><span ng-class="item.collected ? \'label label-success\' : \'label label-danger\'">{{item.collected ? \'Yes\' : \'No\'}}</span></td><td>{{item.collectedDate | amDateFormat:\'MM/DD/YYYY\'}}</td><td><span ng-class="item.canceled ? \'label label-danger\' : \'label label-success\'">{{item.canceled ? \'Yes\' : \'No\'}}</span></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/entities/patient-order-test/patient-order-tests.html','<div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div></div></div></div>');
$templateCache.put('app/entities/patient-order-tpl/patient-order-test-tpl-new-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientAccessLabel">Create Order Test</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><form name="vm.form" role="form" show-validation><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label">Test Code</label><ui-select id="field_compendium" name="compendium" reset-search-input="false" ng-model="vm.patientOrderTest.compendium" title="Compendium" ng-required="true"><ui-select-match placeholder="Select Test...">{{$select.selected.code}}</ui-select-match><ui-select-choices repeat="compendium in vm.compendiums" refresh="vm.getCompendium($select.search)" refresh-delay="0"><div ng-bind-html="compendium.code | highlight: $select.search"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select><div ng-show="vm.form.compendium.$invalid"><p class="help-block" ng-show="vm.form.compendium.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label for="field_orderFrequency">Frequency</label><select class="form-control" id="field_orderFrequency" name="orderFrequency" ng-required="vm.patientOrder.orderType != \'ONE_TIME\'" ng-model="vm.patientOrderTest.orderFrequency" ng-disabled="vm.patientOrder.orderType == \'ONE_TIME\'" ng-options="orderFrequency as orderFrequency.name for orderFrequency in vm.orderfrequencies track by orderFrequency.id"><option value=""></option></select><div ng-show="vm.form.orderFrequency.$invalid"><p class="help-block" ng-show="vm.form.orderFrequency.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label">Renal</label><br><toggle ng-model="vm.patientOrderTest.renal" on="Yes" off="No" name="renal" required ng-disabled="vm.patientOrder.id"></toggle><div ng-show="vm.form.renal.$invalid"><p class="help-block" ng-show="vm.form.renal.$error.required">This field is required.</p></div></div></div></div></form><div class="row"><div class="col-lg-12"><form name="vm.formProblem" role="form" show-validation><!--<div class="box-body">--><label class="control-label">ICD 10</label><ui-select id="field_diagnoses" name="diagnoses" multiple="multiple" ng-model="vm.patientOrderTest.diagnoses" close-on-select="false" title="Diagnoses" required><ui-select-match placeholder="Select ICD 10...">{{$item.icd10Code}}</ui-select-match><ui-select-choices repeat="diagnoses in vm.diagnoses" refresh="vm.getDiagnoses($select.search)" refresh-delay="0"><div ng-bind-html="diagnoses.icd10Code | highlight: $select.search"></div><small> {{diagnoses.description}} </small></ui-select-choices></ui-select><div ng-show="vm.formProblem.diagnoses.$invalid"><p class="help-block" ng-show="vm.formProblem.diagnoses.$error.required">This field is required.</p></div><!--</div>--></form></div></div><div class="row"><div class="col-lg-12"><ng-repeat ng-repeat="problemsChk in vm.problemsChk"><div class="col-lg-6"><div class="checkbox" ng-if="$even"><label><input type="checkbox" ng-change="vm.addProblemDiagnosis($index)" ng-model="problemsChk.in"> <span class="badge bg-green">{{problemsChk.diagnosis.icd10Code}}</span> {{problemsChk.diagnosis.description}}</label></div></div><div class="col-lg-6"><div class="checkbox" ng-if="$odd"><label><input type="checkbox" ng-change="vm.addProblemDiagnosis($index)" ng-model="problemsChk.in"> <span class="badge bg-green">{{problemsChk.diagnosis.icd10Code}}</span> {{problemsChk.diagnosis.description}} </label></div></div></ng-repeat></div></div><div class="modal-footer"><div class="pull-right"><button type="button" class="btn btn-danger" ng-click="vm.clear()">Cancel</button> <button type="button" class="btn btn-success" ng-disabled="vm.formProblem.$invalid || vm.form.$invalid" ng-click="vm.accept()">Accept</button></div></div></div>');
$templateCache.put('app/entities/patient-order-tpl/patient-order-tpl-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tpl.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Patient Order Template?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/patient-order-tpl/patient-order-tpl-new.html','<section class="content-header"><h1><i class="fa fa-calendar-check-o"></i> New Patient Order Template <small></small></h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header" ui-view="content"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">New Order</h3></div><jhi-alert-error></jhi-alert-error><ng-include src="\'app/entities/patient-order-tpl/tpl/patient-order-form-tpl.html\'"></ng-include></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><dl class="dl-horizontal"><dt><strong>Legend:</strong></dt><dd></dd><dt><span class="label label-danger">Red</span>:</dt><dd>This tests need to be deleted o replaced.</dd></dl></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-primary"><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/patient-order-tpl/patient-order-tpl.html','<section class="content-header"><h1 class="section-title">Patient Order Templates</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="patient-order-tpl.new"><span class="glyphicon glyphicon-plus"></span> <span>New Patient Order Tpl</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryvia" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/patient-order-wizard/patient-order-wizard-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Order Wizard</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><form action=""><wizard><wizard on-finish="vm.onFinishWizard()" on-cancel="vm.onCancelWizard()" indicators-position="top"><wz-step wz-title="Patient List"><ng-include src="\'app/entities/patient-order-wizard/steps/patient-list.html\'"></ng-include><button type="button" class="btn btn-default move-btn fixed next-btn" wz-next><svg id="i-chevron-right" viewBox="0 0 32 32" height="32" width="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Order Details"><ng-include src="\'app/entities/patient-order-wizard/steps/order-details.html\'"></ng-include><button type="button" class="btn btn-default move-btn fixed previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="button" class="btn btn-default move-btn fixed next-btn" wz-next><svg id="i-chevron-right" viewBox="0 0 32 32" height="32" width="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Components"><ng-include src="\'app/entities/patient-order-wizard/steps/components.html\'"></ng-include><button type="button" class="btn btn-default move-btn fixed previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="button" class="btn btn-default move-btn fixed next-btn" wz-next><svg id="i-chevron-right" viewBox="0 0 32 32" height="32" width="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Loremium"><ng-include src="\'app/entities/patient-order-wizard/steps/orders-list.html\'"></ng-include><button type="button" class="btn btn-default move-btn fixed previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="button" class="btn btn-default move-btn fixed next-btn" wz-next><svg id="i-chevron-right" viewBox="0 0 32 32" height="32" width="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Physician Signature"><ng-include src="\'app/entities/patient-order-wizard/steps/signature.html\'"></ng-include><button type="button" class="btn btn-default move-btn fixed previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button></wz-step></wizard></wizard></form></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal"><i class="fa fa-check-circle" aria-hidden="true"></i> Finish Order</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-order-wizard/patient-order-wizard.html','<section class="content-header"><h1 class="section-title">Orders Wizard</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button type="button" class="btn btn-default btn-lg btn-header green" ng-click="vm.openWizard()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Open Wizard</button></div><div class="box"><div class="box-body"><!--\n                    <wizard>\n                        <wz-step wz-title="Step1">\n                            <div class=""></div>\n                        </wz-step>\n                        <wz-step wz-title="Step2"></wz-step>\n                        <wz-step wz-title="Step3a"></wz-step>\n                        <wz-step wz-title="Step3b"></wz-step>\n                        <wz-step wz-title="Step4"></wz-step>\n                    </wizard>\n                    --></div></div></div></div></section>');
$templateCache.put('app/entities/patient-picture/patient-picture-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.patientPicture.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Patient Picture?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/patient-picture/patient-picture-detail.html','<div><h2><span>Patient Picture</span> {{vm.patientPicture.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Picture</span></dt><dd><span>{{vm.patientPicture.picture}}</span></dd><dt><span data-translate="dialysisApp.patientPicture.picture_content_type">Picture Content Type</span></dt><dd><span>{{vm.patientPicture.picture_content_type}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="patient-picture-detail.edit({id:vm.patientPicture.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/patient-picture/patient-picture-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientPictureLabel">Create or edit a Patient Picture</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.patientPicture.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.patientPicture.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_picture">Picture</label><input type="text" class="form-control" name="picture" id="field_picture" ng-model="vm.patientPicture.picture" required><div ng-show="editForm.picture.$invalid"><p class="help-block" ng-show="editForm.picture.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="dialysisApp.patientPicture.picture_content_type" for="field_picture_content_type">Picture Content Type</label><input type="text" class="form-control" name="picture_content_type" id="field_picture_content_type" ng-model="vm.patientPicture.picture_content_type" required><div ng-show="editForm.picture_content_type.$invalid"><p class="help-block" ng-show="editForm.picture_content_type.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/patient-picture/patient-pictures.html','<div><h2>Patient Pictures</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="patient-picture.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Patient Picture</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Picture</span></th><th><span data-translate="dialysisApp.patientPicture.picture_content_type">Picture Content Type</span></th><th></th></tr></thead><tbody><tr ng-repeat="patientPicture in vm.patientPictures track by patientPicture.id"><td><a ui-sref="patient-picture-detail({id:patientPicture.id})">{{patientPicture.id}}</a></td><td>{{patientPicture.picture}}</td><td>{{patientPicture.picture_content_type}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="patient-picture-detail({id:patientPicture.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="patient-picture.edit({id:patientPicture.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="patient-picture.delete({id:patientPicture.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/patient-result/maintenance-range.html','<section class="content-header"><h1><i class="ion ion-alert"></i> Maintenance Patient Result Range</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="box box-primary"><div class="box-body"><form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_end">Start Date</label><div class="input-group"><input id="field_start" type="text" class="form-control input-sm" name="start" uib-datepicker-popup="MM/dd/yyyy" placeholder="Start Date" required ng-model="vm.filterRes.startDate" is-open="vm.datePickerOpenStatus.start"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'start\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_end">End Date</label><div class="input-group"><input id="field_end" type="text" class="form-control input-sm" name="end" uib-datepicker-popup="MM/dd/yyyy" placeholder="End Date" required ng-model="vm.filterRes.endDate" is-open="vm.datePickerOpenStatus.end"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'end\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label>Clinics</label><ui-select id="clinics" name="clinics" multiple="multiple" required ng-model="vm.filterRes.clinics" title="Cinics"><ui-select-match placeholder="Select Cinics...">{{$item.name}}</ui-select-match><ui-select-choices repeat="clinic in vm.clinics | filter:$select.search"> {{clinic.name}} </ui-select-choices></ui-select></div></div></div></form></div><div class="box-footer"><div class="pull-right"><button type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="vm.editForm.$invalid || vm.isSaving">Execute Result Range Maintenance</button></div></div></div></section>');
$templateCache.put('app/entities/patient-result/maintenance-rgroup.html','<section class="content-header"><h1><i class="ion ion-alert"></i> Maintenance Patient Result Report Group</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="box box-primary"><div class="box-body"><form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_end">Start Date</label><div class="input-group"><input id="field_start" type="text" class="form-control input-sm" name="start" uib-datepicker-popup="MM/dd/yyyy" placeholder="Start Date" required ng-model="vm.filterRes.startDate" is-open="vm.datePickerOpenStatus.start"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'start\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_end">End Date</label><div class="input-group"><input id="field_end" type="text" class="form-control input-sm" name="end" uib-datepicker-popup="MM/dd/yyyy" placeholder="End Date" required ng-model="vm.filterRes.endDate" is-open="vm.datePickerOpenStatus.end"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'end\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label>Clinics</label><ui-select id="clinics" name="clinics" multiple="multiple" required ng-model="vm.filterRes.clinics" title="Cinics"><ui-select-match placeholder="Select Cinics...">{{$item.name}}</ui-select-match><ui-select-choices repeat="clinic in vm.clinics | filter:$select.search"> {{clinic.name}} </ui-select-choices></ui-select></div></div></div></form></div><div class="box-footer"><div class="pull-right"><button type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="vm.editForm.$invalid || vm.isSaving">Execute Report Group Maintenance</button></div></div></div></section>');
$templateCache.put('app/entities/patient-result/patient-result-by-patient.html','<ng-include src="\'app/entities/patient-result/tpl/patient-result-by-patient-filter-tpl.html\'"></ng-include><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Results</h3></div><div class=""><div class="box-header"><div class="col-xs-8 col-lg-offset-4 no-padding-right"><form name="searchForm"><div><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" popover-class="" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button ng-click="vm.popoverFilterEnable()" class="btn btn-primary" type="button" class="btn btn-default"><span class="glyphicon glyphicon-filter"></span></button> <button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div><div popover-class="pop" popover-placement="bottom" uib-popover-template="\'patient-filter-tpl.html\'" popover-is-open="vm.showFilter" popover-trigger="none"></div></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></div>');
$templateCache.put('app/entities/patient-result/patient-result-delete.html','<section class="content-header"><h1><i class="ion ion-alert"></i> Delete patient result for this barcode?</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="box box-primary"><div class="box-body"><form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="row"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="col-md-5"><div class="form-group"><label class="control-label" ng-show="$index == 0">Barcode</label><div class="input-group"><input id="barcode" type="text" class="form-control" name="barcode" ng-model="vm.barcode" ng-required="true"></div></div></div></div></div></form></div><div class="box-footer"><div class="pull-right"><button type="button" class="btn btn-danger" ng-click="vm.deleteResult()" ng-disabled="vm.editForm.$invalid || vm.isSaving">Delete</button></div></div></div></section>');
$templateCache.put('app/entities/patient-result/patient-result-final-partial-dashboard.html','<ng-include src="\'app/entities/patient-result/tpl/patient-result-filter-tpl.html\'"></ng-include><section class="content-header"><h1>{{vm.filterRes.title}} ({{vm.patientResults.length}})</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class=""><div class="box-header"><div class="col-xs-8 col-lg-offset-4 no-padding-right"><form name="searchForm"><div><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" popover-class="" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><!--<button ng-click="vm.popoverFilterEnable()" class="btn btn-primary"--><!--type="button" class="btn btn-default">--><!--<span class="glyphicon glyphicon-filter"></span>--><!--</button>--> <button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div><div popover-class="pop" popover-placement="bottom" uib-popover-template="\'patient-filter-tpl.html\'" popover-is-open="vm.showFilter" popover-trigger="none"></div></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient-result/patient-result-latest.html','<section class="content-header"><h1 class="section-title">{{vm.title}}</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button class="btn btn-default btn-lg btn-header green" ng-click="vm.printRangePDFs()" ng-if="!vm.enableEmrIntegration"><i class="fa fa-print" aria-hidden="true"></i> Get All PDF</button><div class="btn-group" uib-dropdown ng-if="vm.enableEmrIntegration"><button id="split-button" type="button" class="btn btn-default btn-lg btn-header green" ng-click="vm.printRangePDFs()"><i class="fa fa-print" aria-hidden="true"></i> Get All PDF</button> <button type="button" class="btn btn-default btn-lg btn-header green" uib-dropdown-toggle><span class="caret"></span> <span class="sr-only">Split button!</span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="split-button"><li role="menuitem"><a ng-click="vm.sendToEmr()">Send to EMR</a></li></ul></div><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search..." id="searchQuerypatient" ng-model-options="{ debounce: 500 }" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg" tabindex="0" id="btnSearch" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div><button class="btn btn-default btn-lg btn-header red toggle-filters" uib-tooltip="Show advanced filters" ng-click="vm.showFiltersPanel()" ng-class="active?\'open\':\'\'"><i class="fa fa-sliders" aria-hidden="true"></i> Filters</button><ng-include src="\'app/entities/patient-result/tpl/patient-result-latest-filter-tpl.html\'"></ng-include></div><div class="btn-group btn-group-lg main-filters"><button type="button" title="All Results" ng-click="vm.updateStatusButtonFilter(null);" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active green\': vm.filterRes.status == null}]"><i class="fa fa-flask" aria-hidden="true"></i> <span class="hidden-xs">All Results</span></button> <button type="button" class="btn btn-default btn-flat" title="Partial" ng-click="vm.updateStatusButtonFilter(\'PARTIAL\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active green\': vm.filterRes.status == \'PARTIAL\'}]"><i class="fa fa-spinner" aria-hidden="true"></i> <span class="hidden-xs">Partial</span></button> <button type="button" class="btn btn-default" title="Final" ng-click="vm.updateStatusButtonFilter(\'FINAL\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active green\': vm.filterRes.status == \'FINAL\'}]"><i class="fa fa-circle-o" aria-hidden="true"></i> <span class="hidden-xs">Final</span></button></div><button type="button" class="btn btn-default btn-lg btn-header grid-button" ng-class="{\'green\': vm.currentMonth}" uib-tooltip="Current Month" tooltip-placement="left" ng-click="vm.updateCurrentMonthFilter()" ng-model="vm.currentMonth" uib-btn-checkbox><i class="fa fa-calendar" aria-hidden="true"></i></button></div><div class="box box-primary"><div class="box-body"><div class="table-responsive"><table class="table table-hover table-condensed" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstanceCallback"></table></div><div class="text-center mb-15"><jhi-item-count page="vm.filterRes.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.filterRes.page" ng-change="vm.transition()"></ul></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient-result/patient-result-pending.html','<section class="content-header"><h1>Pending Results ({{vm.orders.length}})</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class=""><div class="box-header"><div class="col-xs-8 col-lg-offset-4 no-padding-right"><form name="searchForm"><div><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" popover-class="" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div><div popover-class="pop" popover-placement="bottom" uib-popover-template="\'patient-filter-tpl.html\'" popover-is-open="vm.showFilter" popover-trigger="none"></div></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient-result/patient-result-trending.html','<div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Trending Result</h3></div><div class="box-body"><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" for="field_staringDate">Collection Date Start</label><div class="input-group"><input id="field_staringDate" type="text" class="form-control" name="staringDate" required uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.trending.staringDate" ng-change="vm.getCompendium()" is-open="vm.datePickerOpenStatus.staringDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'staringDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" for="field_endDate">Collection Date End</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" required ng-change="vm.getCompendium()" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.trending.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-3"><div class="form-group"><label class="control-label">Test Code</label><div class="input-group"><ui-select id="field_compendium" name="compendium" reset-search-input="false" ng-model="vm.trending.compendium" title="Compendium" ng-required="true"><ui-select-match placeholder="Select Test...">{{$select.selected.code}}</ui-select-match><ui-select-choices repeat="compendium in vm.compendiums | propsFilter: {code: $select.search, description: $select.search}"><div ng-bind-html="compendium.code | highlight: $select.search"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.getResults()" ng-disabled="vm.form.$invalid"><i class="glyphicon glyphicon-search"></i></button></span></div><div ng-show="vm.form.compendium.$invalid"><p class="help-block" ng-show="vm.form.compendium.$error.required">This field is required.</p></div></div></div><div class="col-md-3"><div class="form-group"><label class="control-label">Selected Test Codes</label><ui-select id="field_trendings" name="trendings" reset-search-input="false" multiple="multiple" ng-change="vm.alert($selected)" ng-model="vm.trendings2" title="Selected Test Codes"><ui-select-match placeholder="Select person...">{{$item.testcode}} - {{$item.description}}</ui-select-match><ui-select-choices repeat="trending in vm.trendings" ng-disabled="true"><div ng-bind-html="trending.testcode"></div><small> {{trending.testcode}} </small></ui-select-choices></ui-select></div></div></div><div class="pull-right"><button type="button" class="btn btn-danger" ng-click="vm.getPDF()" ng-disabled="vm.trendings.length == 0">Get PDF</button></div></div><div class="row"><div class="col-md-12"><nvd3 options="vm.options" data="vm.data"></nvd3></div></div></div>');
$templateCache.put('app/entities/patient-result/patient-result-unassigned.html','<section class="content-header"><h1 class="section-title">{{vm.title}} ({{vm.patientResults.length}})</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class=""><div class="box-header"><div class="row"><div class="col-lg-3"><div class="input-group"><ui-select ng-model="vm.patient" name="patient" id="field_patient" reset-search-input="false" ng-required="true" title="Patient List" append-to-body="true"><ui-select-match placeholder="Select patient...">{{$select.selected.firstName + \' \' +\n                                            $select.selected.middleInitial + \' \' + $select.selected.lastName}} </ui-select-match><ui-select-choices repeat="patient in vm.patients" refresh="vm.filterPatients($select.search)" refresh-delay="0"><div ng-bind-html="patient.firstName + \' \' + patient.middleInitial + \' \' + patient.lastName | highlight: $select.search"></div><small>dob: {{patient.dob | amDateFormat:\'MM/DD/YYYY\'}} </small></ui-select-choices></ui-select><span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.assign()" ng-disabled="!vm.patient.id || vm.isSaving"><span class="glyphicon glyphicon-plus"></span></button></span></div></div><div class="col-lg-6 col-lg-offset-3"><div class="input-group"><input type="text" class="form-control" ng-model="vm.searchQuery" popover-class="" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button></span></div></div></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient-result/patient-result-update-dates.html','<section class="content-header"><h1><i class="ion ion-alert"></i> Update patient result for this barcode?</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="box box-primary"><div class="box-body"><jhi-alert-error></jhi-alert-error><form name="updateDatesForm" class="form" role="form" novalidate ng-submit="vm.saveDates()" show-validation><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 form-group"><label class="control-label" for="field_barcode">Barcode</label><input id="field_barcode" type="text" class="form-control input-sm" name="barcode" placeholder="Barcode..." ng-model="vm.barcode" ng-required="true"><div ng-show="updateDatesForm.barcode.$invalid"><p class="help-block" ng-show="updateDatesForm.barcode.$error.required">This field is required.</p></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-3 form-group"><label class="control-label" for="field_received_date">Result Date</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_received_date" placeholder="Day of Received..." name="received_date" ng-model="vm.receivedDate" uib-datepicker-popup="MM/dd/yyyy" ng-required="vm.receivedDate == null && vm.collectionDate == null" is-open="vm.datePickerOpenStatus.receivedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'receivedDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><div ng-show="updateDatesForm.received_date.$invalid"><p class="help-block" ng-show="updateDatesForm.received_date.$error.required">This field is required.</p></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-3 form-group"><label class="control-label" for="field_collection_date">Collection Date</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_collection_date" placeholder="Day of Collection..." name="collection_date" ng-model="vm.collectionDate" uib-datepicker-popup="MM/dd/yyyy" ng-required="vm.receivedDate == null && vm.collectionDate == null" is-open="vm.datePickerOpenStatus.collectionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'collectionDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><div ng-show="updateDatesForm.collection_date.$invalid"><p class="help-block" ng-show="updateDatesForm.collection_date.$error.required">This field is required.</p></div></div></div><div class="box-footer"><div class="pull-right"><button type="submit" class="btn btn-success" ng-disabled="updateDatesForm.$invalid || vm.isSaving"><i class="fa fa-check-square-o" aria-hidden="true"></i> Update</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div></form></div></div></section>');
$templateCache.put('app/entities/patient-result-det/patient-result-dets.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Result Details</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="padding: 0 20%"><table class="table table-condensed patient-info"><tbody><tr><td rowspan="5" class="pic-col"><div class="well well-sm text-center" ng-if="vm.patient"><img data-ng-src="{{\'data:\' + vm.patient.patientPicture.pictureContentType + \';base64,\' + vm.patient.patientPicture.picture}}" class="img-thumbnail patient-image"></div></td><td class="tlabel"><strong>Patient Name:</strong></td><td>{{vm.patientResult.patientName}}</td><td class="tlabel"><strong>Gender:</strong></td><td>{{vm.patient.gender != null ? vm.patient.gender : \'Not Specified\'}}</td></tr><tr><td class="tlabel"><strong>Order #:</strong></td><td>{{vm.patientResult.accessionNumber ? vm.patientResult.accessionNumber : \'-\'}}</td><td class="tlabel"><strong>D.O.B:</strong></td><td>{{vm.patientResult.dob | amDateFormat: displayDateformat}}</td></tr><tr><td class="tlabel"><strong>Collected Date:</strong></td><td>{{vm.patientResult.collectionDate | amDateFormat: displayDateformat}}</td><td class="tlabel"><strong>Result Date:</strong></td><td>{{vm.patientResult.createdDate | amDateFormat: displayDateformat}}</td></tr><tr><td class="tlabel"><strong>Doctor\'s Name:</strong></td><td colspan="2">{{vm.physician == null ? \'Not Specified\' : vm.physician.lastName + ", " +\n                        vm.physician.name}} </td><td></td></tr><tr><td></td><td></td><td></td><td></td><td></td></tr></tbody></table></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="filter-query"><div class="filter-input"><input type="text" class="form-control" id="searchQuerypatient" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <button class="btn btn-default" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button></div><button type="button" class="btn btn-danger show-filters" ng-click="vm.toggleFilters()"><i class="fa fa-sliders"></i> Filter</button><div class="filters-wrapper well"><div class="filter-group" ng-if="vm.groups.length > 0"><div class="name"><span><strong>Groups:</strong></span></div><div class="checkboxs"><!-- The filters ID must be the same as the label\'s FOR attribute --> <span class="filter-item"><input type="checkbox" name="filter-name" id="filter-groups-all" ng-model="vm.groupsAll.value" ng-click="vm.groupCheckAll()"><label for="filter-groups-all">{{vm.groupsAll.name}}</label></span><div class="divider"></div><span class="filter-item" ng-repeat="group in vm.groups | orderBy : \'name\'"><input type="checkbox" name="filter-name" id="filter-{{group.name}}" ng-model="group.value" ng-click="vm.groupsCheck()"><label for="filter-{{group.name}}">{{group.name}}</label></span></div></div><div class="filter-group"><div class="name"><span><strong>Status:</strong></span></div><div class="checkboxs"><!-- The filters ID must be the same as the label\'s FOR attribute --> <span class="filter-item"><input type="checkbox" name="" id="filter-all" ng-model="vm.levels.all" ng-click="vm.levelAll()"><label for="filter-all">All</label></span><span class="filter-item"><input type="checkbox" name="" id="filter-abnormals" ng-model="vm.levels.abnormals" ng-click="vm.abnormals()"><label for="filter-abnormals">Abnormals</label></span><span class="filter-item"><input type="checkbox" name="" id="filter-criticals" ng-model="vm.levels.criticals" ng-click="vm.criticals()"><label for="filter-criticals">Criticals</label></span><div class="divider"></div><span class="filter-item"><input type="checkbox" name="" id="filter-ll" ng-model="vm.levels.LL" ng-click="vm.notNormal()"><label for="filter-ll">Critical Low</label></span><span class="filter-item"><input type="checkbox" name="" id="filter-l" ng-model="vm.levels.L" ng-click="vm.notNormal()"><label for="filter-l">Low</label></span><span class="filter-item"><input type="checkbox" name="" id="filter-n" ng-model="vm.levels.N" ng-click="vm.normal()"><label for="filter-n">Normal</label></span><span class="filter-item"><input type="checkbox" name="" id="filter-h" ng-model="vm.levels.H" ng-click="vm.notNormal()"><label for="filter-h">High</label></span><span class="filter-item"><input type="checkbox" name="" id="filter-hh" ng-model="vm.levels.HH" ng-click="vm.notNormal()"><label for="filter-hh">Critical High</label></span></div></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><table datatable="vm.datatable" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" id="xxx" class="table table-striped table-bordered"></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button></div>');
$templateCache.put('app/entities/patient-result-missing-data/patient-result-missing-data-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.patientResultMissingData.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Patient Result Missing Data?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/patient-result-missing-data/patient-result-missing-data-detail.html','<div><h2><span>Patient Result Missing Data</span> {{vm.patientResultMissingData.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Result</span></dt><dd><span>{{vm.patientResultMissingData.result}}</span></dd><dt><span>Barcode</span></dt><dd><span>{{vm.patientResultMissingData.barcode}}</span></dd><dt><span>Compendium</span></dt><dd><a ui-sref="compendium-detail({id:vm.patientResultMissingData.compendium.id})">{{vm.patientResultMissingData.compendium.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="patient-result-missing-data-detail.edit({id:vm.patientResultMissingData.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/patient-result-missing-data/patient-result-missing-data-dialog.html','<form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientResultMissingDataLabel">Edit kinetic missing info</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label">Patient</label><input id="patient" type="text" class="form-control" name="begin" ng-disabled="true" value="{{vm.kinetic.patient.lastName + \', \' + vm.kinetic.patient.firstName}} - {{vm.kinetic.patientOrderItem.collectedDate | date:\'MM/dd/yy\'}} - {{vm.kinetic.patientOrderItem.groupNumberId}}"></div></div></div><div class="row"><div class="col-md-12" ng-if="vm.kinetic.hhmm"><div class="form-group"><label class="control-label" for="field_dialysis_length_hh_mm">Dialysis Length</label><div class="input-group" moment-picker="vm.kinetic.dialysisLengthHhmm" show-header="false" format="HH:mm"><span class="input-group-addon" ng-click="vm.kinetic.hhmm=!vm.kinetic.hhmm" title="Change units to {{vm.kinetic.hhmm ? \'mm\' : \'HH:mm\'}}"><i class="fa fa-rotate-right"></i> </span><input class="form-control" placeholder="Select a time in format HH:mm" show-header="false" format="HH:mm" ng-model="vm.kinetic.dialysisLengthHhmm" ng-model-options="{ updateOn: \'blur\'}" required name="dialysis_length_hh_mm" id="field_dialysis_length_hh_mm"> <span class="input-group-addon">{{vm.kinetic.hhmm ? \'HH:mm\' : \'mm\'}}</span></div><div ng-show="vm.editForm.dialysis_length_hh_mm.$invalid"><p class="help-block" ng-show="vm.editForm.dialysis_length_hh_mm.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-12" ng-if="!vm.kinetic.hhmm"><div class="form-group"><label class="control-label" for="field_dialysis_length">Dialysis Length</label><div class="input-group"><span class="input-group-addon" ng-click="vm.kinetic.hhmm=!vm.kinetic.hhmm" title="Change units to {{!vm.kinetic.hhmm ? \'mm\' : \'HH:mm\'}}"><i class="fa fa-rotate-right"></i> </span><input id="field_dialysis_length" type="number" class="form-control" ng-model="vm.kinetic.dialysisLength" placeholder="Enter a time in minutes" name="dialysis_length" required> <span class="input-group-addon">{{vm.kinetic.hhmm ? \'HH:mm\' : \'mm\'}}</span></div><div ng-show="vm.editForm.dialysis_length.$invalid"><p class="help-block" ng-show="vm.editForm.dialysis_length.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_preWeight">Pre Weight</label><div class="input-group"><span class="input-group-addon" ng-click="vm.kinetic.kg=!vm.kinetic.kg" title="Change units to {{vm.kinetic.kg ? \'Lbs\' : \'Kg\'}}"><i class="fa fa-rotate-right"></i> </span><input type="number" class="form-control" name="preWeight" id="field_preWeight" ng-model="vm.kinetic.preWeight" ng-required="true"> <span class="input-group-addon">{{vm.kinetic.kg ? \'Kg\' : \'Lbs\'}}</span></div><div ng-show="vm.editForm.preWeight.$invalid"><p class="help-block" ng-show="vm.editForm.preWeight.$error.required">This field is required.</p><p class="help-block" ng-show="vm.editForm.preWeight.$error.number">This field should be a number.</p></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_posWeight">Post Weight</label><div class="input-group"><input type="number" class="form-control" name="posWeight" id="field_posWeight" ng-model="vm.kinetic.posWeight" ng-required="true"> <span class="input-group-addon">{{vm.kinetic.kg ? \'Kg\' : \'Lbs\'}}</span></div><div ng-show="vm.editForm.posWeight.$invalid"><p class="help-block" ng-show="vm.editForm.posWeight.$error.required">This field is required.</p><p class="help-block" ng-show="vm.editForm.posWeight.$error.number">This field should be a number.</p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></div></form>');
$templateCache.put('app/entities/patient-result-missing-data/patient-result-missing-data.html','<div><h2>Patient Result Missing Data</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="patient-result-missing-data.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Patient Result Missing Data</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="result"><span>Result</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="barcode"><span>Barcode</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="compendium.id"><span>Compendium</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="patientResultMissingData in vm.patientResultMissingData track by patientResultMissingData.id"><td><a ui-sref="patient-result-missing-data-detail({id:patientResultMissingData.id})">{{patientResultMissingData.id}}</a></td><td>{{patientResultMissingData.result}}</td><td>{{patientResultMissingData.barcode}}</td><td><a ui-sref="compendium-detail({id:patientResultMissingData.compendium.id})">{{patientResultMissingData.compendium.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="patient-result-missing-data-detail({id:patientResultMissingData.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="patient-result-missing-data.edit({id:patientResultMissingData.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="patient-result-missing-data.delete({id:patientResultMissingData.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/patient-status/patient-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.patientStatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Patient Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/patient-status/patient-status-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientStatusLabel">Create or edit a Patient Status</h4></div><form name="editForm" role="form" novalidate ng-submit="vm.save()"><fieldset ng-disabled="!vm.editing"><div class="modal-body" ng-disabled="!vm.editing"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label">Clinic</label><input id="clinic_name" class="form-control" type="text" disabled="disabled" value="{{vm.patientStatus.clinic.name}}"></div><div class="form-group"><label class="control-label" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.patientStatus.startDate" is-open="vm.datePickerOpenStatus.startDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.startDate.$invalid"><p class="help-block" ng-show="editForm.startDate.$error.required">This field is required.</p></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_endDate">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.patientStatus.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><label class="control-label" for="field_endStatus">End Status</label><select class="form-control" name="endStatus" ng-model="vm.patientStatus.endStatus" id="field_endStatus" required><option value="EXPIRED">EXPIRED</option><option value="LEFT_FACILITY">LEFT_FACILITY</option><option value="TRANSPLANTED">TRANSPLANTED</option></select><div ng-show="editForm.endStatus.$invalid"><p class="help-block" ng-show="editForm.endStatus.$error.required">This field is required.</p></div></div></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" ng-show="vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-primary" ng-click="vm.editing = !vm.editing" ng-if="vm.patientStatus.patient.status" ng-show="!vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Edit Information</span></button></div></form>');
$templateCache.put('app/entities/patient-status/patient-statuses.html','<div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Patient Status</h3></div><div class=""><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="patient-status.new" ng-if="vm.patient.status"><span class="glyphicon glyphicon-flash"></span> <span>New Patient Status</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></div>');
$templateCache.put('app/entities/patient-template/patient-template-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.patientTemplate.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Patient Template?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/patient-template/patient-template-detail.html','<div><h2><span>Patient Template</span> {{vm.patientTemplate.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.patientTemplate.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.patientTemplate.corporation.id})">{{vm.patientTemplate.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="patient-template-detail.edit({id:vm.patientTemplate.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/patient-template/patient-template-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientTemplateLabel">Create or edit a Patient Template</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.patientTemplate.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/patient-template/patient-templates.html','<section class="content-header"><h1 class="section-title">Patient Templates</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="patient-template.new"><span class="glyphicon glyphicon-flash"></span> <span>New Patient Template</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerypatient-template" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/patient-type/patient-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.patientType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Patient Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/patient-type/patient-type-detail.html','<div><h2><span>Patient Type</span> {{vm.patientType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.patientType.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.patientType.corporation.id})">{{vm.patientType.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="patient-type-detail.edit({id:vm.patientType.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/patient-type/patient-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientTypeLabel">Create or edit a Patient Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.patientType.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/patient-type/patient-types.html','<section class="content-header"><h1>Patient Types</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="patient-type.new"><span class="glyphicon glyphicon-flash"></span> <span>New Patient Type</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerypatient-type" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/pd-adequacy/pd-adequacy-add.html','<section class="content-header"><h1><i class="ion ion-alert"></i> PD Adequacy Information</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content-header"><div class="box box-primary"><div class="box-body"><form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="row" ng-repeat="info in vm.missing"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="col-md-3"><div class="form-group"><label class="control-label" ng-show="$index == 0">Patient</label><div class="input-group"><input id="patient" type="text" class="form-control" name="begin" ng-disabled="true" value="{{info.patient.lastName + \', \' + info.patient.firstName}} - {{info.patientOrderItem.collectedDate | date:\'MM/dd/yy\'}} - {{info.patientOrderItem.groupNumberId}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.remove($index)" ng-disabled="vm.missing.length == 1"><i class="glyphicon glyphicon-trash"></i></button></span></div></div></div><div class="col-md-2"><div class="form-group" ng-if="info.intCode != 1072"><label class="control-label" for="field_urine_volume{{$index}}" ng-show="$index == 0">Urine Volume</label><input id="field_urine_volume{{$index}}" type="text" class="form-control" ng-model="info.urineVolume" name="urine_volume{{$index}}" ng-required="false"><div ng-show="vm.editForm.urine_volume{{$index}}.$invalid"><p class="help-block" ng-show="vm.editForm.urine_volume{{$index}}.$error.required">This field is required.</p></div></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" for="field_pd_fluid_out{{$index}}" ng-show="$index == 0">PD Fluid Out</label><input id="field_pd_fluid_out{{$index}}" type="text" class="form-control" ng-model="info.pdFluidOut" name="pd_fluid_out{{$index}}" ng-required="false"><div ng-show="vm.editForm.pd_fluid_out{{$index}}.$invalid"><p class="help-block" ng-show="vm.editForm.pd_fluid_out{{$index}}.$error.required">This field is required.</p></div></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" for="field_height{{$index}}" ng-show="$index == 0">Height</label><input id="field_height{{$index}}" type="text" class="form-control" ng-model="info.height" name="height{{$index}}" ng-required="false"><div ng-show="vm.editForm.height{{$index}}.$invalid"><p class="help-block" ng-show="vm.editForm.height{{$index}}.$error.required">This field is required.</p></div></div></div><div class="col-md-2"><div class="form-group"><label class="control-label" for="field_dry_weigh{{$index}}" ng-show="$index == 0">Dry Weigh</label><input id="field_dry_weigh{{$index}}" type="text" class="form-control" ng-model="info.dryWeigh" name="dry_weigh{{$index}}" ng-required="false"><div ng-show="vm.editForm.dry_weigh{{$index}}.$invalid"><p class="help-block" ng-show="vm.editForm.dry_weigh{{$index}}.$error.required">This field is required.</p></div></div></div><div class="col-md-1"><div class="form-group"><label class="control-label" for="field_patient_age{{$index}}" ng-show="$index == 0">Age</label><input id="field_patient_age{{$index}}" type="text" class="form-control" ng-model="info.patientAge" name="patient_age{{$index}}" ng-required="false" ng-disabled="true"></div></div></div></div></form></div><div class="box-footer"><div class="pull-right"><button type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="vm.editForm.$invalid || vm.isSaving">Send Information</button></div></div></div></section>');
$templateCache.put('app/entities/pd-adequacy/pd-adequacy-patients.html','<section class="content-header"><h1 class="section-title">Pending PD Adequacy</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button type="button" class="btn btn-default btn-lg btn-header green" ng-click="vm.addPDAdequacy()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add PD Adequacy</button><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search query..." ng-model="vm.searchQuery" popover-class="" ng-change="vm.search()" id="searchQueryPatient"> <button type="button" class="btn btn-default btn-lg" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title"><strong>Clinic:</strong> {{vm.clinic.name}} | <strong>Patients:</strong> {{vm.patients.length}}</h3></div><div class="box-body"><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered custom-table"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/pr-det-employee-comment/pr-det-employee-comment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="prDetEmployeeCommentLabel">Add Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="comment">Comment</label><textarea class="form-control" id="comment" name="comment" rows="4" ng-model="vm.prDetEmployeeComment.comment" required> </textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/pr-emr-integration-log/pr-emr-integration-log.html','<section class="content-header"><h1 class="section-title">{{vm.title}}</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search..." id="searchQuerypatient" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg" tabindex="0" id="btnSearch" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div><button class="btn btn-default btn-lg btn-header red toggle-filters" uib-tooltip="Show advanced filters" ng-click="vm.showFiltersPanel()" ng-class="active?\'open\':\'\'"><i class="fa fa-sliders" aria-hidden="true"></i> Filters</button><div class="filter-box" ng-include="\'app/entities/pr-emr-integration-log/tpl/pr-emr-integration-log-filter-tpl.html\'"></div></div></div><div class="box box-primary"><div class="box-body"><div class="table-responsive"><table class="table table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/problem-list/problem-list-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.problemList.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Problem List?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/problem-list/problem-list-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProblemListLabel">Problem List</h4></div><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><fieldset ng-disabled="!vm.editing"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-lg-12"><div class="form-group"><label class="control-label">Diagnosis</label><ui-select ng-model="vm.problem.diagnosis" name="problem_list_diagnosis" id="field_problem_list_diagnosis" reset-search-input="false" ng-required="true" title="Diagnosis"><ui-select-match placeholder="Enter diagnosis...">{{$select.selected.icd10Code}} </ui-select-match><ui-select-choices repeat="diagnosis in vm.diagnoses" refresh="vm.getDiagnosis($select.search)" refresh-delay="0"><div ng-bind-html="diagnosis.icd10Code | highlight: $select.search"></div><small> {{diagnosis.description}} </small></ui-select-choices></ui-select><div ng-show="editForm.problem_list_diagnosis.$invalid"><p class="help-block" ng-show="editForm.problem_list_diagnosis.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_problem_list_start_date">Start Date</label><div class="input-group"><input id="field_problem_list_start_date" type="text" class="form-control" name="problem_list_start_date" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.problem.startDate" is-open="vm.datePickerOpenStatus.problemStartDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'problemStartDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_problem_list_end_date">End Date</label><div class="input-group"><input id="field_problem_list_end_date" type="text" class="form-control" name="problem_list_end_date" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.problem.endDate" is-open="vm.datePickerOpenStatus.problemEndDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'problemEndDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Renal</label><br><toggle ng-model="vm.problem.renal" on="Yes" off="No" id="field_problem_list_renal"></toggle><div ng-show="editForm.problem_list_renal.$invalid"><p class="help-block" ng-show="editForm.problem_list_renal.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">Is Active?</label><br><toggle ng-model="vm.problem.active" on="Yes" off="No" id="field_problem_list_active"></toggle><div ng-show="editForm.problem_list_active.$invalid"><p class="help-block" ng-show="editForm.problem_list_active.$error.required">This field is required.</p></div></div></div></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" ng-show="vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-primary" ng-click="vm.editing = !vm.editing" ng-if="vm.problem.patient.status" ng-show="!vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Edit Information</span></button></div></form>');
$templateCache.put('app/entities/problem-list/problem-list.html','<section class="content"><div class="row"><div class="col-xs-12"><button type="button" class="btn btn-primary" ui-sref="problem-list-new" ng-if="vm.patient.status"><span class="glyphicon glyphicon-add"></span> <span>New Problem</span></button><table datatable="" dt-options="vm.problemListDtOptions" dt-columns="vm.problemListDtColumns" dt-instance="vm.problemListDtInstance" class="table table-striped table-bordered"></table></div></div></section>');
$templateCache.put('app/entities/race/race-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.race.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Race?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/race/race-detail.html','<div><h2><span>Race</span> {{vm.race.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.race.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.race.corporation.id})">{{vm.race.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="race-detail.edit({id:vm.race.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/race/race-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRaceLabel">Create or edit a Race</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.race.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/race/races.html','<section class="content-header"><h1>Races</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="race.new"><span class="glyphicon glyphicon-flash"></span> <span>New Race</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryrace" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/report-group/report-group-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.reportGroup.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Report Group?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/report-group/report-group-detail.html','<div><h2><span>Report Group</span> {{vm.reportGroup.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.reportGroup.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.reportGroup.corporation.id})">{{vm.reportGroup.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="report-group-detail.edit({id:vm.reportGroup.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/report-group/report-group-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReportGroupLabel">Create or edit a Report Group</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.reportGroup.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/report-group/report-groups.html','<section class="content-header"><h1>Report Groups</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="report-group.new"><span class="glyphicon glyphicon-flash"></span> <span>New Report Group</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryreport-group" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/result-range/result-range-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.resultRange.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Result Range?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/result-range/result-range-detail.html','<div><h2><span>Result Range</span> {{vm.resultRange.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Low</span></dt><dd><span>{{vm.resultRange.low}}</span></dd><dt><span>High</span></dt><dd><span>{{vm.resultRange.high}}</span></dd><dt><span>Critical Low</span></dt><dd><span>{{vm.resultRange.criticalLow}}</span></dd><dt><span>Critical High</span></dt><dd><span>{{vm.resultRange.criticalHigh}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.resultRange.description}}</span></dd><dt><span>Range</span></dt><dd><span>{{vm.resultRange.range}}</span></dd><dt><span data-translate="dialysisApp.resultRange.compendium_code">Compendium Code</span></dt><dd><span>{{vm.resultRange.compendium_code}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="result-range-detail.edit({id:vm.resultRange.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/result-range/result-range-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myResultRangeLabel">Create or edit a Result Range</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label">Compendium</label><ui-select ng-model="vm.resultRange.compendium" close-on-select="true" title="Internal Code"><ui-select-match allow-clear="true" placeholder="Select compendium...">{{$select.selected.code +\n                    \', \'+ $select.selected.description}} </ui-select-match><ui-select-choices repeat="compendium in vm.compendiums | filter: $select.search"><div ng-bind-html=" compendium.code + \', \' + compendium.description | highlight: $select.search"></div><small ng-bind-html="(compendium.wGroup ? compendium.wGroup : \'\') +\n                    (compendium.specimen ? (compendium.wGroup ? \', \' : \'\') + compendium.specimen : \'\') | highlight: $select.search"></small></ui-select-choices></ui-select></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_criticalLow">Critical Low</label><input type="number" class="form-control" name="criticalLow" id="field_criticalLow" ng-model="vm.resultRange.criticalLow"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_low">Low</label><input type="number" class="form-control" name="low" id="field_low" ng-model="vm.resultRange.low"></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_criticalHigh">Critical High</label><input type="number" class="form-control" name="criticalHigh" id="field_criticalHigh" ng-model="vm.resultRange.criticalHigh"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_high">High</label><input type="number" class="form-control" name="high" id="field_high" ng-model="vm.resultRange.high"></div></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.resultRange.description"></div><div class="form-group"><label class="control-label" for="field_range">Range</label><input type="text" class="form-control" name="range" id="field_range" ng-model="vm.resultRange.range"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/result-range/result-ranges.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4"><div class="btn-group" uib-dropdown><button type="button" class="btn btn-primary" ui-sref="{{vm.entityStateName}}.new"><span class="glyphicon glyphicon-plus"></span> <span>New {{vm.entityClassHumanized}}</span></button> <button type="button" class="btn btn-primary dropdown-toggle" uib-dropdown-toggle data-toggle="dropdown" aria-expanded="false"><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a ng-click="vm.init()"><span class="glyphicon glyphicon-calendar"></span>Restore All Ranges</a></li></ul></div></div><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input type="text" class="form-control" ng-model="vm.searchQuery" size="80" id="searchQueryrpt-metadata" placeholder="Query" ng-change="vm.search()"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/rpt-category/rpt-categories.html','<section class="content-header"><h1>Report Categories</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="rpt-category.new"><span class="glyphicon glyphicon-plus"></span> <span>New Report Category</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/rpt-category/rpt-category-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rptCategory.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Report Category?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/rpt-category/rpt-category-detail.html','<div><h2><span>Rpt Category</span> {{vm.rptCategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.rptCategory.name}}</span></dd><dt><span>Clinic</span></dt><dd><a ui-sref="clinic-detail({id:vm.rptCategory.clinic.id})">{{vm.rptCategory.clinic.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="rpt-category-detail.edit({id:vm.rptCategory.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/rpt-category/rpt-category-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRptCategoryLabel">Create or edit a Report Category</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rptCategory.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rptCategory.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.rptCategory.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div><div class="form-group" ng-if="vm.clinics.length > 0"><label for="field_clinic">Clinic</label><select class="form-control" ng-model="vm.rptCategory.clinic" name="clinic" id="field_clinic" ng-options="clinic as clinic.name for clinic in vm.clinics track by clinic.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/rpt-compendium-default-message/rpt-compendium-default-message-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rptCompendiumDefaultMessage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Rpt Compendium Default Message?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/rpt-compendium-default-message/rpt-compendium-default-message-detail.html','<div><h2><span>Rpt Compendium Default Message</span> {{vm.rptCompendiumDefaultMessage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Low Message</span></dt><dd><span>{{vm.rptCompendiumDefaultMessage.lowMessage}}</span></dd><dt><span>High Message</span></dt><dd><span>{{vm.rptCompendiumDefaultMessage.highMessage}}</span></dd><dt><span>Normal Message</span></dt><dd><span>{{vm.rptCompendiumDefaultMessage.normalMessage}}</span></dd><dt><span>Rpt Language</span></dt><dd><a ui-sref="rpt-language-detail({id:vm.rptCompendiumDefaultMessage.rptLanguage.id})">{{vm.rptCompendiumDefaultMessage.rptLanguage.id}}</a></dd><dt><span>Compendium</span></dt><dd><a ui-sref="compendium-detail({id:vm.rptCompendiumDefaultMessage.compendium.id})">{{vm.rptCompendiumDefaultMessage.compendium.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="rpt-compendium-default-message-detail.edit({id:vm.rptCompendiumDefaultMessage.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/rpt-compendium-default-message/rpt-compendium-default-message-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRptCompendiumDefaultMessageLabel">Create or edit a Rpt Compendium Default Message</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rptCompendiumDefaultMessage.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rptCompendiumDefaultMessage.id" readonly="readonly"></div><div class="row"><div class="col-lg-6"><div class="form-group"><label for="field_rptLanguage">Language</label><ui-select ng-model="vm.rptCompendiumDefaultMessage.rptLanguage" close-on-select="true" title="Language" id="field_rptLanguage" ng-required="true" name="rptLanguage"><ui-select-match allow-clear="true" placeholder="Select language..."> {{$select.selected.name}} </ui-select-match><ui-select-choices repeat="rptLanguage in vm.rptLanguages | filter: $select.search"><div ng-bind-html="rptLanguage.name"></div></ui-select-choices></ui-select><div ng-show="editForm.$invalid"><p class="help-block" ng-show="editForm.rptLanguage.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label for="field_compendium">Compendium</label><ui-select ng-model="vm.rptCompendiumDefaultMessage.compendium" close-on-select="true" title="Compendium" id="field_compendium" ng-required="true" name="compendium"><ui-select-match allow-clear="true" placeholder="Select compendium..."> {{$select.selected.code + \', \' + $select.selected.description}} </ui-select-match><ui-select-choices repeat="compendium in vm.compendiums | filter: $select.search"><div ng-bind-html=" compendium.code"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select><div ng-show="editForm.$invalid"><p class="help-block" ng-show="editForm.compendium.$error.required">This field is required.</p></div></div></div></div><div class="form-group"><label class="control-label" for="field_lowMessage">Low Message</label><textarea class="form-control" name="lowMessage" id="field_lowMessage" rows="4" ng-model="vm.rptCompendiumDefaultMessage.lowMessage"></textarea></div><div class="form-group"><label class="control-label" for="field_normalMessage">Normal Message</label><textarea class="form-control" name="normalMessage" id="field_normalMessage" rows="4" ng-model="vm.rptCompendiumDefaultMessage.normalMessage"></textarea></div><div class="form-group"><label class="control-label" for="field_highMessage">High Message</label><textarea class="form-control" name="highMessage" id="field_highMessage" rows="4" ng-model="vm.rptCompendiumDefaultMessage.highMessage"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/rpt-compendium-default-message/rpt-compendium-default-messages.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="header-options mb-30"><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search..." id="searchQuerypatient" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg" tabindex="0" id="btnSearch" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div><button class="btn btn-default btn-lg btn-header red toggle-filters" uib-tooltip="Show advanced filters" ng-click="vm.showFiltersPanel()" ng-class="active?\'open\':\'\'"><i class="fa fa-sliders" aria-hidden="true"></i> Filters</button><div class="filter-box" ng-include="\'app/entities/rpt-compendium-default-message/tpl/rpt-compendium-default-message-filter-tpl.html\'"></div></div></div><div class="box box-primary"><div class="box-header"><div class="btn-group" uib-dropdown><button type="button" class="btn btn-primary" ui-sref="{{vm.entityStateName}}.new"><span class="glyphicon glyphicon-plus"></span> <span>New {{vm.entityClassHumanized}}</span></button> <button type="button" class="btn btn-primary dropdown-toggle" uib-dropdown-toggle data-toggle="dropdown" aria-expanded="false"><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a ng-click="vm.init()"><span class="glyphicon glyphicon-calendar"></span>Restore All Messages For the Current Clinic</a></li></ul></div><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input type="text" class="form-control" ng-model="vm.searchQuery" size="80" id="searchQueryrpt-metadata" placeholder="Query" ng-change="vm.search()"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/rpt-compendium-message/rpt-compendium-message-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rptCompendiumMessage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Rpt Compendium Message?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/rpt-compendium-message/rpt-compendium-message-detail.html','<div><h2><span>Rpt Compendium Message</span> {{vm.rptCompendiumMessage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Low Message</span></dt><dd><span>{{vm.rptCompendiumMessage.lowMessage}}</span></dd><dt><span>Normal Message</span></dt><dd><span>{{vm.rptCompendiumMessage.normalMessage}}</span></dd><dt><span>High Message</span></dt><dd><span>{{vm.rptCompendiumMessage.highMessage}}</span></dd><dt><span>Rpt Language</span></dt><dd><a ui-sref="rpt-language-detail({id:vm.rptCompendiumMessage.rptLanguage.id})">{{vm.rptCompendiumMessage.rptLanguage.id}}</a></dd><dt><span>Compendium</span></dt><dd><a ui-sref="compendium-detail({id:vm.rptCompendiumMessage.compendium.id})">{{vm.rptCompendiumMessage.compendium.id}}</a></dd><dt><span>Clinic</span></dt><dd><a ui-sref="clinic-detail({id:vm.rptCompendiumMessage.clinic.id})">{{vm.rptCompendiumMessage.clinic.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="rpt-compendium-message-detail.edit({id:vm.rptCompendiumMessage.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/rpt-compendium-message/rpt-compendium-message-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRptCompendiumMessageLabel">Create or edit a Rpt Compendium Message</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rptCompendiumMessage.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rptCompendiumMessage.id" readonly="readonly"></div><div class="row"><div class="col-lg-6"><div class="form-group"><label for="field_rptLanguage">Language</label><ui-select ng-model="vm.rptCompendiumMessage.rptLanguage" close-on-select="true" title="Language" id="field_rptLanguage" ng-required="true" name="rptLanguage"><ui-select-match allow-clear="true" placeholder="Select language..."> {{$select.selected.name}} </ui-select-match><ui-select-choices repeat="rptLanguage in vm.rptLanguages | filter: $select.search"><div ng-bind-html="rptLanguage.name"></div></ui-select-choices></ui-select><div ng-show="editForm.$invalid"><p class="help-block" ng-show="editForm.rptLanguage.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label for="field_compendium">Compendium</label><ui-select ng-model="vm.rptCompendiumMessage.compendium" close-on-select="true" title="Compendium" id="field_compendium" ng-required="true" name="compendium"><ui-select-match allow-clear="true" placeholder="Select compendium..."> {{$select.selected.code + \', \' + $select.selected.description}} </ui-select-match><ui-select-choices repeat="compendium in vm.compendiums | filter: $select.search"><div ng-bind-html=" compendium.code"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select><div ng-show="editForm.$invalid"><p class="help-block" ng-show="editForm.compendium.$error.required">This field is required.</p></div></div></div></div><div class="form-group"><label class="control-label" for="field_lowMessage">Low Message</label><textarea class="form-control" name="lowMessage" id="field_lowMessage" rows="4" ng-model="vm.rptCompendiumMessage.lowMessage"></textarea></div><div class="form-group"><label class="control-label" for="field_normalMessage">Normal Message</label><textarea class="form-control" name="normalMessage" id="field_normalMessage" rows="4" ng-model="vm.rptCompendiumMessage.normalMessage"></textarea></div><div class="form-group"><label class="control-label" for="field_highMessage">High Message</label><textarea class="form-control" name="highMessage" id="field_highMessage" rows="4" ng-model="vm.rptCompendiumMessage.highMessage"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/rpt-compendium-message/rpt-compendium-messages.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="header-options mb-30"><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search..." id="searchQuerypatient" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg" tabindex="0" id="btnSearch" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div><button class="btn btn-default btn-lg btn-header red toggle-filters" uib-tooltip="Show advanced filters" ng-click="vm.showFiltersPanel()" ng-class="active?\'open\':\'\'"><i class="fa fa-sliders" aria-hidden="true"></i> Filters</button><div class="filter-box" ng-include="\'app/entities/rpt-compendium-message/tpl/rpt-compendium-message-filter-tpl.html\'"></div></div></div><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/rpt-metadata/rpt-metadata-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rptMetadata.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Rpt Metadata?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/rpt-metadata/rpt-metadata-detail.html','<div><h2><span>Rpt Metadata</span> {{vm.rptMetadata.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Int Code</span></dt><dd><span>{{vm.rptMetadata.intCode}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.rptMetadata.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="rpt-metadata-detail.edit({id:vm.rptMetadata.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/rpt-metadata/rpt-metadata-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRptMetadataLabel">Create or edit a Rpt Metadata</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rptMetadata.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rptMetadata.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_intCode">Int Code</label><input type="number" class="form-control" name="intCode" id="field_intCode" ng-model="vm.rptMetadata.intCode" required min="1000"><div ng-show="editForm.intCode.$invalid"><p class="help-block" ng-show="editForm.intCode.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.intCode.$error.min" translate-value-min="1000">This field should be more than 1000.</p><p class="help-block" ng-show="editForm.intCode.$error.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" for="field_code">Code</label><input type="text" class="form-control" name="description" id="field_code" ng-model="vm.rptMetadata.code" required><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.rptMetadata.description" required><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/rpt-metadata/rpt-metadata.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/rpt-language/rpt-language-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rptLanguage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Rpt Language?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/rpt-language/rpt-language-detail.html','<div><h2><span>Rpt Language</span> {{vm.rptLanguage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.rptLanguage.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="rpt-language-detail.edit({id:vm.rptLanguage.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/rpt-language/rpt-language-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRptLanguageLabel">Create or edit a Rpt Language</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rptLanguage.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rptLanguage.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.rptLanguage.name"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/rpt-language/rpt-languages.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/rpt-template/rpt-template-admin-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Report Template Wizard</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard on-finish="vm.onFinishWizard()" on-cancel="vm.onCancelWizard()" indicators-position="top" hide-indicators="true"><wz-step wz-title="Metadata"><ng-include src="\'app/entities/rpt-template/wizard/admin-dialog/rpt-template-admin-form-tpl.html\'"></ng-include><button type="button" class="btn btn-default move-btn fixed next-btn" wz-next ng-if="vm.rptTemplate.type && vm.rptTemplate.type != \'CUMULATIVE\'"><svg id="i-chevron-right" viewBox="0 0 32 32" height="32" width="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Test Ranges" ng-if="vm.rptTemplate.type == \'GRID\' || vm.rptTemplate.type == \'REPORT_CARD\' ||\n                         vm.rptTemplate.type == \'AVERAGE\' || vm.rptTemplate.type == \'ENV_GRID\' ||\n                         vm.rptTemplate.type == \'ENV_REFERENCE_RANGE\' || vm.rptTemplate.type == \'ENV_AVERAGE\'"><ng-include src="\'app/entities/rpt-template/wizard/admin-dialog/rpt-template-admin-range-tpl.html\'"></ng-include><button type="button" class="btn btn-default move-btn fixed previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button></wz-step><wz-step wz-title="Test List" ng-if="vm.rptTemplate.type == \'GRAPH\'"><ng-include src="\'app/entities/rpt-template/wizard/admin-dialog/rpt-template-admin-compendium-list-tpl.html\'"></ng-include><button type="button" class="btn btn-default move-btn fixed previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button></wz-step><wz-step wz-title="Vaccines" ng-if="vm.rptTemplate.type == \'VACCINATION\'"><ng-include src="\'app/entities/rpt-template/wizard/admin-dialog/rpt-template-admin-vaccine-form-tpl.html\'"></ng-include><button type="button" class="btn btn-default move-btn fixed previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button></wz-step></wizard></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal" ng-click="vm.save()" ng-disabled="vm.form.main.$invalid || vm.form.compendiumRanges.$invalid || vm.form.compendium.$invalid"><i class="fa fa-check-circle" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/rpt-template/rpt-template-admin.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/rpt-template/rpt-template-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rptTemplate.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Report Template?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/rpt-template/rpt-template-export-dialog.html','<form name="confirmForm" ng-submit="vm.confirmExport(vm.rptTemplate.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm export operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to export this Report Template?</p><div class="form-group"><label>Clinics</label><ui-select id="clinics" name="clinics" multiple="multiple" ng-model="vm.selectClinics" title="Clinics"><ui-select-match placeholder="Select Clinics...">{{$item.name}}</ui-select-match><ui-select-choices repeat="clinic in vm.clinics | filter:$select.search"> {{clinic.name}} </ui-select-choices></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="confirmForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Accept</span></button></div></form>');
$templateCache.put('app/entities/rpt-template/rpt-templates.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input type="text" class="form-control" ng-model="vm.searchQuery" size="80" id="searchQueryrpt-metadata" placeholder="Query" ng-change="vm.search()"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/sample/sample-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.title}}</h4></div><div class="modal-body"><p>Ridetis superbe ducunt ad magnum luba. Calcarias accelerare! Domesticus, fortis animaliss vix convertam de fatalis, neuter diatria. Cur epos ire? Barbatus, pius urias unus attrahendam de secundus, lotus demissio!</p></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/sample/sample.html','<section class="content-header"><h1 class="section-title"> {{vm.entityStateName}}</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button type="button" class="btn btn-default btn-lg btn-header blue"><i class="fa fa-check-circle" aria-hidden="true"></i> + New</button><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search query..." ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div><div class="box"><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped"></table></div></div></div></div></section>');
$templateCache.put('app/entities/site-location/site-location-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.siteLocation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Site Location?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/site-location/site-location-detail.html','<div><h2><span>Site Location</span> {{vm.siteLocation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.siteLocation.name}}</span></dd><dt><span>Clinic</span></dt><dd><a ui-sref="clinic-detail({id:vm.siteLocation.clinic.id})">{{vm.siteLocation.clinic.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="site-location-detail.edit({id:vm.siteLocation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/site-location/site-location-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySiteLocationLabel">Create or edit a Site Location</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.siteLocation.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/site-location/site-locations.html','<section class="content-header"><h1>Site Locations</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="site-location.new"><span class="glyphicon glyphicon-flash"></span> <span>New Site Location</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerySite-location" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/symptom/symptom-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.symptom.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Symptom?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/symptom/symptom-detail.html','<div><h2><span>Symptom</span> {{vm.symptom.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.symptom.name}}</span></dd><dt><span>Infection</span></dt><dd><span ng-repeat="infection in vm.symptom.infections"><a ui-sref="infection-detail({id: infection.id})">{{infection.id}}</a>{{$last ? \'\' : \', \'}} </span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.symptom.corporation.id})">{{vm.symptom.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="symptom-detail.edit({id:vm.symptom.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/symptom/symptom-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySymptomLabel">Create or edit a Symptom</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.symptom.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/symptom/symptoms.html','<section class="content-header"><h1>Symptoms</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="symptom.new"><span class="glyphicon glyphicon-flash"></span> <span>New Symptom</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerysymptom" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/tpl/list-box-header-tpl.html','<div class="box-header"><div class="navbar-form navbar-left" style="margin-left: -15px"><button class="btn btn-primary" ui-sref="{{vm.entityStateName}}.new"><span class="glyphicon glyphicon-plus"></span><span> New {{vm.entityClassHumanized}}</span></button></div><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input type="text" class="form-control" ng-model="vm.searchQuery" size="80" id="searchQueryrpt-metadata" placeholder="Query" ng-change="vm.search()"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div></div>');
$templateCache.put('app/entities/tpl/list-header-tpl.html','<section class="content-header"><h1>{{vm.title}}</h1><div ncy-breadcrumb class="breadcrumb"></div></section>');
$templateCache.put('app/entities/tube/tube-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tube.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Tube?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/tube/tube-detail.html','<div><h2><span>Tube</span> {{vm.tube.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.tube.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="tube-detail.edit({id:vm.tube.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/tube/tube-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTubeLabel">Create or edit a Tube</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tube.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tube.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.tube.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/tube/tubes.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-primary"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/vaccination/vaccination-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.vaccination.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Vaccination?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/vaccination/vaccination-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVaccinationLabel">Create or edit a Vaccination</h4></div><form name="editForm" role="form" novalidate ng-submit="vm.save()"><fieldset ng-disabled="!vm.editing"><div class="modal-body" ng-disabled="!vm.editing"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-6"><div class="form-group"><label for="field_vaccine">Vaccine</label><select class="form-control" id="field_vaccine" name="vaccine" required ng-model="vm.vaccination.vaccine" ng-options="vaccine as vaccine.name for vaccine in vm.vaccines track by vaccine.id"><option value=""></option></select><div ng-show="editForm.vaccine.$invalid"><p class="help-block" ng-show="editForm.vaccine.$error.required">This field is required.</p></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_completionDate">Completion Date</label><div class="input-group"><input id="field_completionDate" type="text" class="form-control" name="completionDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.vaccination.completionDate" is-open="vm.datePickerOpenStatus.completionDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'completionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.completionDate.$invalid"><p class="help-block" ng-show="editForm.completionDate.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label" for="field_responded">Responded</label><br><toggle ng-model="vm.vaccination.responded" on="Yes" off="No" id="field_responded"></toggle></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" for="field_result">Result</label><textarea type="text" class="form-control" name="result" id="field_result" rows="4" ng-model="vm.vaccination.result"></textarea></div></div></div></div></fieldset><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" ng-show="vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-primary" ng-click="vm.editing = !vm.editing" ng-if="vm.vaccination.patient.status" ng-show="!vm.editing"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Edit Information</span></button></div></form>');
$templateCache.put('app/entities/vaccination/vaccinations.html','<div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Vaccinations</h3></div><div class=""><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="vaccination.new" ng-if="vm.patient.status"><span class="glyphicon glyphicon-flash"></span> <span>New Vaccination</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerypatient" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-primary" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></div>');
$templateCache.put('app/entities/vaccine/vaccine-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.vaccine.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Vaccine?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/vaccine/vaccine-detail.html','<div><h2><span>Vaccine</span> {{vm.vaccine.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.vaccine.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="vaccine-detail.edit({id:vm.vaccine.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/vaccine/vaccine-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVaccineLabel">Create or edit a Vaccine</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.vaccine.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.vaccine.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.vaccine.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/vaccine/vaccines.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/via/via-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.via.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Via?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/via/via-detail.html','<div><h2><span>Via</span> {{vm.via.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.via.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="via-detail.edit({id:vm.via.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/via/via-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myViaLabel">Create or edit a Via</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.via.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.via.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.via.name"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/via/vias.html','<section class="content-header"><h1>Vias</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="via.new"><span class="glyphicon glyphicon-flash"></span> <span>New Via</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQueryvia" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/window-picker/date-picker-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.accept()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRaceLabel">Select new draw day</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_date">Select day</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Select Day</span></button></div></form>');
$templateCache.put('app/entities/window-picker/env-test-interval-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientAccessLabel">Select date interval</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><form name="vm.form" role="form" show-validation><div class="row"><div class="col-lg-12"><div class="form-group"><label class="control-label">Select Date</label><div class="input-group"><input id="field_staringDate" type="text" class="form-control" name="staringDate" required datepicker-options="vm.startOptions" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.staringDate" is-open="vm.datePickerOpenStatus.staringDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'staringDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.staringDate.$invalid"><p class="help-block" ng-show="vm.form.staringDate.$error.required">This field is required.</p></div></div></div></div></form><div class="modal-footer"><div class="pull-right"><button type="button" class="btn btn-danger" ng-click="vm.clear()">Cancel</button> <button type="button" class="btn btn-success" ng-disabled="vm.form.$invalid" ng-click="vm.accept()">Accept</button></div></div></div>');
$templateCache.put('app/entities/window-picker/patient-order-test-interval-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPatientAccessLabel">Select date interval</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><form name="vm.form" role="form" show-validation><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Staring Date</label><div class="input-group"><input id="field_staringDate" type="text" class="form-control" name="staringDate" required datepicker-options="vm.startOptions" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.staringDate" is-open="vm.datePickerOpenStatus.staringDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'staringDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.staringDate.$invalid"><p class="help-block" ng-show="vm.form.staringDate.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" datepicker-options="vm.endOptions" ng-required="vm.patientOrderTpl.orderType != \'ONE_TIME\'" ng-disabled="vm.patientOrderTpl.orderType == \'ONE_TIME\'" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')" ng-disabled="vm.patientOrderTpl.orderType == \'ONE_TIME\'"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.endDate.$invalid"><p class="help-block" ng-show="vm.form.endDate.$error.required">This field is required.</p></div></div></div></div></form><div class="modal-footer"><div class="pull-right"><button type="button" class="btn btn-danger" ng-click="vm.clear()">Cancel</button> <button type="button" class="btn btn-success" ng-disabled="vm.form.$invalid" ng-click="vm.accept()">Accept</button></div></div></div>');
$templateCache.put('app/entities/x-ml-config/x-ml-config-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.xMLConfig.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this XML Config?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/x-ml-config/x-ml-config-detail.html','<div><h2><span>XML Config</span> {{vm.xMLConfig.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.xMLConfig.name}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.xMLConfig.description}}</span></dd><dt><span>File</span></dt><dd><span>{{vm.xMLConfig.file}}</span></dd><dt><span>X Type</span></dt><dd><span>{{vm.xMLConfig.xType}}</span></dd><dt><span>By Default</span></dt><dd><span>{{vm.xMLConfig.byDefault}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.xMLConfig.corporation.id})">{{vm.xMLConfig.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="x-ml-config-detail.edit({id:vm.xMLConfig.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/x-ml-config/x-ml-config-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myXMLConfigLabel">Create or edit a XML Config</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.xMLConfig.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="col-md-6"><div class="form-group"><div class="form-group"><label class="control-label" for="field_xType">Label Type</label><select class="form-control" name="xType" ng-model="vm.xMLConfig.xType" id="field_xType" required><option value="PATIENT">PATIENT</option><option value="ENVIRONMENTAL">ENVIRONMENTAL</option></select><div ng-show="editForm.xType.$invalid"><p class="help-block" ng-show="editForm.xType.$error.required">This field is required.</p></div></div></div></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.xMLConfig.description" required><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required">This field is required.</p></div></div><div class="row"><div class="col-md-6"><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.xMLConfig)"><label class="control-label" for="field_file">File</label><div><div ng-if="vm.xMLConfig.file" class="help-block clearfix"><span class="pull-left">{{vm.xMLConfig.fileContentType}}, {{vm.byteSize(vm.xMLConfig.file)}}</span><button type="button" ng-click="vm.xMLConfig.file=null;vm.xMLConfig.fileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFile($file, vm.xMLConfig)">Select file...</button></div><input type="hidden" class="form-control" name="file" id="field_file" ng-model="vm.xMLConfig.file" required> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.xMLConfig.fileContentType"><div ng-show="editForm.file.$invalid"><p class="help-block" ng-show="editForm.file.$error.required">This field is required.</p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></div></form>');
$templateCache.put('app/entities/x-ml-config/x-ml-configs.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/layouts/controlbar/controlsidebar.tpl.html','<aside class="control-sidebar control-sidebar-dark" ng-class="{\'control-sidebar\': vm.isControlbarCollapsed , \'control-sidebar-open\': !vm.isControlbarCollapsed }"><!-- Create the tabs --><!--<ul class="nav nav-tabs nav-justified control-sidebar-tabs">--><!--<li class=""><a href="#control-sidebar-theme-demo-options-tab" data-toggle="tab" aria-expanded="false"><i--><!--class="fa fa-wrench"></i></a></li>--><!--<li class=""><a href="#control-sidebar-home-tab" data-toggle="tab" aria-expanded="false"><i--><!--class="fa fa-home"></i></a></li>--><!--<li class="active"><a href="#control-sidebar-settings-tab" data-toggle="tab" aria-expanded="true"><i--><!--class="fa fa-gears"></i></a></li>--><!--</ul>--><!-- Tab panes --><div class="tab-content"><!-- Home tab content --><!-- Settings tab content --><div class="tab-pane active" id="control-sidebar-settings-tab"><h3 class="control-sidebar-heading">Administration</h3><ul class="control-sidebar-menu"><li><a ui-sref="user-management"><i class="menu-icon glyphicon glyphicon-user bg-red"></i><div class="menu-info"><h4 class="control-sidebar-subheading">User management</h4><p>User management options</p></div></a></li><li><a ui-sref="jhi-metrics"><i class="menu-icon glyphicon glyphicon-dashboard bg-yellow"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Metrics</h4><p>Site metrics options</p></div></a></li><li><a ui-sref="jhi-health"><i class="menu-icon fa fa-heartbeat bg-light-blue" aria-hidden="true"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Health</h4><p>Site health options</p></div></a></li><li><a ui-sref="jhi-configuration"><i class="menu-icon fa fa-cog bg-green"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Configuration</h4><p>Site configuration options</p></div></a></li><li><a ui-sref="audits"><i class="menu-icon fa fa-history bg-aqua"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Audits</h4><p>Stite audits options</p></div></a></li><li><a ui-sref="logs"><i class="menu-icon glyphicon glyphicon-list-alt bg-danger"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Logs</h4><p>Site logs</p></div></a></li><li ng-show="vm.swaggerEnabled"><a ui-sref="docs"><i class="menu-icon fa fa-cogs bg-fuchsia"></i><div class="menu-info"><h4 class="control-sidebar-subheading">API</h4><p>Site apis</p></div></a></li><li><a ui-sref="entity-audit"><i class="menu-icon fa fa-search bg-gray"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Entity Audit</h4><p>Site entities audit</p></div></a></li><li><a ui-sref="elasticsearch-reindex"><i class="menu-icon fa fa-search bg-gray"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Reindex Elasticsearch</h4><p>Be careful!!!!!!!</p></div></a></li></ul></div><!-- /.tab-pane --></div></aside><div class="control-sidebar-bg" style="position: fixed; height: auto"></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><section class="content-header"><h1>403 Error Page!</h1><ol class="breadcrumb"><li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li></ol></section><section class="content"><div class="error-page"><h2 class="headline text-red">403</h2><div class="error-content"><h3><i class="fa fa-warning text-red"></i> Oops! Something went wrong.</h3><p>You are not authorized to access the page. Meanwhile, you may <a ui-sref="home">return to dashboard</a></p></div></div></section></div>');
$templateCache.put('app/layouts/error/construction.html','<section class="content"><!-- Default box --><div class="box"><div class="box-header with-border"><h3 class="box-title">We are working on this functionality!</h3></div><div class="box-body"><div class="abs-center"><div class="text-center mv-lg"><h1 class="mb-lg"><sup><em class="fa fa-cog fa-2x text-muted fa-spin text-info"></em></sup> <em class="fa fa-cog fa-5x text-muted fa-spin text-purple"></em> <em class="fa fa-cog fa-lg text-muted fa-spin text-success"></em></h1><div class="text-bold text-lg mb-lg">THIS PAGE IS UNDER MAINTENANCE</div><p class="lead m0">We\'ll back online shortly!</p></div></div></div><!-- /.box-body --><div class="box-footer"><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div><!-- /.box-footer--></div><!-- /.box --></section>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}} </div></div></div></div></div>');
$templateCache.put('app/layouts/footer/footer.tpl.html','<!-- Main Footer --><footer class="main-footer"><!-- To the right --><div class="pull-right hidden-xs">Version v{{VERSION}} </div><!-- Default to the left --> <strong>Copyright &copy; 2018 <a href="#">UDT Software, LLC</a>.</strong> All rights reserved.</footer>');
$templateCache.put('app/layouts/header/header.tpl.html','<ng-include src="\'app/layouts/header/tpl/idle-tpl.html\'"></ng-include><!-- Main Header --><header class="main-header"><!-- Header Navbar --><nav class="navbar navbar-static-top" role="navigation"><!-- Sidebar toggle button--> <a href="" class="sidebar-toggle" data-toggle="offcanvas" role="button" uib-tooltip="Toggle Sidebar" tooltip-placement="right"><span class="hamburger-icon"></span> <span class="sr-only">Toggle navigation</span> </a><!-- Navbar Right Menu --><div class="navbar-custom-menu"><ul class="nav navbar-nav"><!-- Messages: style can be found in dropdown.less--><li class="dropdown messages-menu" uib-dropdown></li><!-- User Account Menu --><li class="dropdown user user-menu" uib-dropdown><!-- Menu Toggle Button --> <a href="#" class="dropdown-toggle" data-toggle="dropdown" uib-dropdown-toggle id="user-dropdown-menu"><!-- The user image in the navbar--> <img src="{{vm.employee.avatar}}" class="user-image" id="user-avatar" alt="User Avatar"><!-- hidden-xs hides the username on small devices so only the image appears. --> <span class="hidden-xs user-name">{{vm.employee.name + " " + vm.employee.lastName}}</span></a><ul class="dropdown-menu" id="user-option-menu" uib-dropdown-menu><!-- The user image in the menu --><li class="user-header"><img src="{{vm.employee.avatar}}" class="img-bordered user-avatar" alt="User Image" uib-tooltip="User Photo"><p><span>{{vm.employee.title}} {{vm.employee.name}} {{vm.employee.lastName}}</span><!-- - Supervisor--> <small>Member since: <span am-time-ago="vm.employee.createdDate | amParse:\'YYYY-MM-DD HH:mm:ss\'"></span></small></p></li><!-- Menu Body --><li class="user-body"><div class="user-link"><a ui-sref="settings"><i class="fa fa-cog" aria-hidden="true"></i> Settings</a></div><div class="user-link"><a ui-sref="password"><i class="fa fa-asterisk" aria-hidden="true"></i> Password</a></div></li><!-- Menu Footer--><li class="user-footer"><button type="button" class="btn btn-danger btn-block" ng-click="vm.logout()"><i class="fa fa-sign-out" aria-hidden="true"></i> Log Out</button></li></ul></li><!-- Control Sidebar Toggle Button --><li has-authority="ROLE_ADMIN"><a href="" data-toggle="control-sidebar"><i class="fa fa-gears"></i></a></li></ul></div></nav></header>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-jhipster.png"> <span data-translate="global.title">Dialysis</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="race" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.race">Race</span></a></li><li ui-sref-active="active"><a ui-sref="ethnicity" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ethnicity">Ethnicity</span></a></li><li ui-sref-active="active"><a ui-sref="education-level" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.educationLevel">Education Level</span></a></li><li ui-sref-active="active"><a ui-sref="religion" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.religion">Religion</span></a></li><li ui-sref-active="active"><a ui-sref="language" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.language">Language</span></a></li><li ui-sref-active="active"><a ui-sref="employment-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.employmentStatus">Employment Status</span></a></li><li ui-sref-active="active"><a ui-sref="residential-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.residentialStatus">Residential Status</span></a></li><li ui-sref-active="active"><a ui-sref="legal-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.legalStatus">Legal Status</span></a></li><li ui-sref-active="active"><a ui-sref="provider" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.provider">Provider</span></a></li><li ui-sref-active="active"><a ui-sref="health-plan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.healthPlan">Health Plan</span></a></li><li ui-sref-active="active"><a ui-sref="psychiatrist" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.psychiatrist">Psychiatrist</span></a></li><li ui-sref-active="active"><a ui-sref="physician" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.physician">Physician</span></a></li><li ui-sref-active="active"><a ui-sref="patient" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.patient">Patient</span></a></li><li ui-sref-active="active"><a ui-sref="diagnosis" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.diagnosis">Diagnosis</span></a></li><li ui-sref-active="active"><a ui-sref="intake" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.intake">Intake</span></a></li><li ui-sref-active="active"><a ui-sref="company" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.company">Company</span></a></li><li ui-sref-active="active"><a ui-sref="country" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.country">Country</span></a></li><li ui-sref-active="active"><a ui-sref="state" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.state">State</span></a></li><li ui-sref-active="active"><a ui-sref="city" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.city">City</span></a></li><li ui-sref-active="active"><a ui-sref="department" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.department">Department</span></a></li><li ui-sref-active="active"><a ui-sref="gender" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.gender">Gender</span></a></li><li ui-sref-active="active"><a ui-sref="marital" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.marital">Marital</span></a></li><li ui-sref-active="active"><a ui-sref="employee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.employee">Employee</span></a></li><li ui-sref-active="active"><a ui-sref="contract-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.contractType">Contract Type</span></a></li><li ui-sref-active="active"><a ui-sref="working-hours" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.workingHours">Working Hours</span></a></li><li ui-sref-active="active"><a ui-sref="schedule-pay" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.schedulePay">Schedule Pay</span></a></li><li ui-sref-active="active"><a ui-sref="contract-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.contractStatus">Contract Status</span></a></li><li ui-sref-active="active"><a ui-sref="pay-roll-struct" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.payRollStruct">Pay Roll Struct</span></a></li><li ui-sref-active="active"><a ui-sref="contract" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.contract">Contract</span></a></li><li ui-sref-active="active"><a ui-sref="job-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.jobStatus">Job Status</span></a></li><li ui-sref-active="active"><a ui-sref="job" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.job">Job</span></a></li><li ui-sref-active="active"><a ui-sref="health-plan-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.healthPlanType">Health Plan Type</span></a></li><li ui-sref-active="active"><a ui-sref="patient-template" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Template</span></a></li><li ui-sref-active="active"><a ui-sref="patient-transfer-history" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Transfer History</span></a></li><li ui-sref-active="active"><a ui-sref="care-team-specialty" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Care Team Specialty</span></a></li><li ui-sref-active="active"><a ui-sref="care-team" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Care Team</span></a></li><li ui-sref-active="active"><a ui-sref="renal-failure" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Renal Failure</span></a></li><li ui-sref-active="active"><a ui-sref="patient-access" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Access</span></a></li><li ui-sref-active="active"><a ui-sref="patient-access-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Access Type</span></a></li><li ui-sref-active="active"><a ui-sref="vein-site" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Vein Site</span></a></li><li ui-sref-active="active"><a ui-sref="patient-access-function" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Access Function</span></a></li><li ui-sref-active="active"><a ui-sref="patient-access-physician" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Access Physician</span></a></li><li ui-sref-active="active"><a ui-sref="diangnosis" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Diangnosis</span></a></li><li ui-sref-active="active"><a ui-sref="problem-list" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Problem List</span></a></li><li ui-sref-active="active"><a ui-sref="patient" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient</span></a></li><li ui-sref-active="active"><a ui-sref="draw-week" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Draw Week</span></a></li><li ui-sref-active="active"><a ui-sref="report-group" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Report Group</span></a></li><li ui-sref-active="active"><a ui-sref="country-state" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Country State</span></a></li><li ui-sref-active="active"><a ui-sref="city" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>City</span></a></li><li ui-sref-active="active"><a ui-sref="address" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Address</span></a></li><li ui-sref-active="active"><a ui-sref="hospitalization-discharge-to" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Hospitalization Discharge To</span></a></li><li ui-sref-active="active"><a ui-sref="hospitalization" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Hospitalization</span></a></li><li ui-sref-active="active"><a ui-sref="source" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Source</span></a></li><li ui-sref-active="active"><a ui-sref="infection-primary-access" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Infection Primary Access</span></a></li><li ui-sref-active="active"><a ui-sref="dialyser-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Dialyser Type</span></a></li><li ui-sref-active="active"><a ui-sref="sympthom" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Sympthom</span></a></li><li ui-sref-active="active"><a ui-sref="infection" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Infection</span></a></li><li ui-sref-active="active"><a ui-sref="patient-address-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Address Type</span></a></li><li ui-sref-active="active"><a ui-sref="patient-address" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Address</span></a></li><li ui-sref-active="active"><a ui-sref="corporation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Corporation</span></a></li><li ui-sref-active="active"><a ui-sref="clinic" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Clinic</span></a></li><li ui-sref-active="active"><a ui-sref="insurance-carrier" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Insurance Carrier</span></a></li><li ui-sref-active="active"><a ui-sref="insurance-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Insurance Type</span></a></li><li ui-sref-active="active"><a ui-sref="insurance-level" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Insurance Level</span></a></li><li ui-sref-active="active"><a ui-sref="insurance-relation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Insurance Relation</span></a></li><li ui-sref-active="active"><a ui-sref="insurance" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Insurance</span></a></li><li ui-sref-active="active"><a ui-sref="modality" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Modality</span></a></li><li ui-sref-active="active"><a ui-sref="physician" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Physician</span></a></li><li ui-sref-active="active"><a ui-sref="language" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Language</span></a></li><li ui-sref-active="active"><a ui-sref="race" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Race</span></a></li><li ui-sref-active="active"><a ui-sref="patient-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Type</span></a></li><li ui-sref-active="active"><a ui-sref="diagnosis" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Diagnosis</span></a></li><li ui-sref-active="active"><a ui-sref="symptom" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Symptom</span></a></li><li ui-sref-active="active"><a ui-sref="employee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Employee</span></a></li><li ui-sref-active="active"><a ui-sref="patient-result" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Result</span></a></li><li ui-sref-active="active"><a ui-sref="employee-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Employee Type</span></a></li><li ui-sref-active="active"><a ui-sref="specialist" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Specialist</span></a></li><li ui-sref-active="active"><a ui-sref="test-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Test Type</span></a></li><li ui-sref-active="active"><a ui-sref="test" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Test</span></a></li><li ui-sref-active="active"><a ui-sref="patient-order-test" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Order Test</span></a></li><li ui-sref-active="active"><a ui-sref="patient-result-file" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Result File</span></a></li><li ui-sref-active="active"><a ui-sref="env-result-det" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Env Result Det</span></a></li><li ui-sref-active="active"><a ui-sref="rpt-metadata" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Rpt Metadata</span></a></li><li ui-sref-active="active"><a ui-sref="compendium" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Compendium</span></a></li><li ui-sref-active="active"><a ui-sref="result-level-message" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Result Level Message</span></a></li><li ui-sref-active="active"><a ui-sref="patient-group" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Group</span></a></li><li ui-sref-active="active"><a ui-sref="lab-notification" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Lab Notification</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="entity-audit" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.entity-audit">Entity Audit</span></a></li><li ui-sref-active="active"><a ui-sref="entity-audit" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span>Entity Audit</span></a></li><li ui-sref-active="active"><a ui-sref="elasticsearch-reindex" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span>Elasticsearch Reindex</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/layouts/sidebar/sidebar.tpl.html','<!-- Left side column. contains the logo and sidebar --><aside class="main-sidebar"><!-- sidebar: style can be found in sidebar.less --><section class="sidebar"><!-- Sidebar user panel (optional) --><div class="user-panel"><div class="image"><img src="{{vm.employee.avatar}}" class="img-bordered" alt="User Image"></div><div class="info"><p>{{vm.employee.name}} {{vm.employee.lastName}}</p><!-- Status --> <a href=""><i class="fa fa-circle text-success"></i> Online</a></div></div><form action="#" method="get" class="sidebar-form"><div class="input-group"><span class="input-group-addon"><i class="fa fa-hospital-o"></i></span><select class="form-control" ng-model="vm.currentClinic" ng-change="vm.changeClinic()" ng-options="clinic as clinic.name for clinic in vm.clinics track by clinic.id"></select></div></form><!-- Sidebar Menu --><ul class="sidebar-menu" id="sidebar-menu"><li class="header"><span>Main Menu</span></li><!-- Optionally, you can add icons to the links --><li class="treeview {{menu.state}}" data-ng-repeat="menu in vm.sideBarItems" has-any-authority="{{menu.access}}"><a ng-if="menu.url != null" ui-sref="{{menu.url}}" has-any-authority="{{menu.access}}"><i class="{{menu.icon}}"></i> <span>{{menu.displayName}}</span><span class="pull-right-container"><i class="fa fa-angle-left pull-right" ng-if="menu.items.length > 0"></i><!--<span class="pull-right-container" ng-if="menu.boxes && menu.boxes.length > 0">--><!--<small data-ng-repeat="box in menu.boxes" class="label pull-right bg-{{box.color}}" uib-tooltip="{{box.tip}}">--><!--{{box.value}}</small>--><!--</span>--> </span></a><a ng-if="menu.url == null" has-any-authority="{{menu.access}}"><i class="{{menu.icon}}"></i> <span>{{menu.displayName}}</span><span class="pull-right-container"><i class="fa fa-angle-left pull-right" ng-if="menu.items.length > 0"></i><!--<span class="pull-right-container" ng-if="menu.boxes && menu.boxes.length > 0">--><!--<small data-ng-repeat="box in menu.boxes" class="label pull-right bg-{{box.color}}" uib-tooltip="{{box.tip}}">--><!--{{box.value}}</small>--><!--</span>--></span></a><ul class="treeview-menu {{menu.open}}" style="{{menu.style}}"><li data-ng-repeat="item in menu.items" class="{{item.state}}"><a ng-if="item.items == null" ui-sref="{{item.url}}" has-any-authority="{{item.access}}"><i class="{{item.icon}}"></i>{{item.displayName}}</a><a href="" ng-if="item.items != null" has-any-authority="{{item.access}}"><i class="{{item.icon}}"></i>{{item.displayName}} <span class="pull-right-container"><i class="fa fa-angle-left pull-right"></i></span></a><ul class="treeview-menu {{item.open}}" style="{{item.style}}" ng-if="item.items != null"><li data-ng-repeat="item2 in item.items" has-any-authority="{{item2.access}}"><a ui-sref="{{item2.url}}"><i class="{{item2.icon}}"></i>{{item2.displayName}}</a></li></ul></li></ul></li></ul><!-- /.sidebar-menu --></section><!-- /.sidebar --></aside>');
$templateCache.put('app/sign/terms/01.html','<!--<h3 class="text-center">United Lab: Unity Online\u2122 Terms of Use Amendment</h3>--><p><strong>PLEASE READ THIS INFORMATION CAREFULLY</strong> : This United: Unity Online\u2122 Terms of Use Amendment ("Amendment") supplements the "United \u2122 Terms of Use" ("Agreement") previously accepted by User, and governs User\'s access and use of United\u2019s: Unity Online\u2122 ("UNITED LAB UNITY"). By clicking the "I ACCEPT" button, User agrees to be bound by the terms of this Amendment.</p><p><strong>Article I. License</strong></p><p>United hereby grants User a license to access and use United\'s propriety United LAB Unity system whereby mutual operating efficiencies can be derived from the features and functions described herein. User acknowledges and agrees to access United LAB Unity solely for the purposes and subject to the terms of use, set forth herein. The license granted hereunder shall terminate immediately upon, and simultaneously with, the expiration or termination of the Agreement or this Amendment, for whatever reason.</p><p><strong>Article II. Features and Functions</strong></p><p>Subject to the terms of the Agreement as amended, United LAB Unity shall provide User with certain features and functions, which may include but not be limited to, enabling User to enter certain patient demographic, clinical, lab information (collectivity "Information") into United LAB Unity so User may request United\'s Lab results and receive an electronic transmission of the results of such testing from the United laboratory system(s). United LAB Unity also allows User to view the results of such maternal and print the results reports for such tests to a User printer. In addition to receiving a copy of the test report through United LAB Unity, United will also furnish a copy of the official report to the ordering provider in accordance with United\'s customary practices.</p><p>User is being provided United LAB Unity solely for the purposes set forth in this Agreement. User agrees it shall make no other use of United LAB Unity during the term hereof. If User fails to comply fully with the requirements set forth in the Agreement United shall have the right to immediately disconnect United LAB Unity\u2122, and terminate this Amendment or the Agreement in its entirety.</p><p><strong>Article III. User Obligations</strong></p><ol><li><span class="agreement-li-under">User Inputs.</span><strong> At all times, User is solely responsible for all Information entered into United.</strong></li><li><span class="agreement-li-under">Right to Access United LAB Unity.</span> The right to use United LAB Unity is personal to User and is not transferable to any other person or entity. User will remain wholly responsible for how User or any of User\'s employees or other persons uses United LAB Unity, including for any Information entered into the system, or data accessed through United LAB Unity.</li><li><span class="agreement-li-under">Notice to United.</span> User shall notify United LAB Unity promptly in the event there is an error in results retrieved through United LAB Unity.</li><li><span class="agreement-li-under">Security of Exporting of Information.</span> Once United has delivered the Lab Results Report, United is not responsible for information exported from United LAB Unity or maintained outside of United LAB Unity. It is User\'s obligation and responsibility to protect all information in a manner that is consistent with the requirements of applicable laws and regulations including but not limited to HIPAA and HITECH.</li><li><span class="agreement-li-under">Confidentiality of United LAB Unity.</span> User shall keep confidential the United LAB Unity product and any associated documentation and materials and shall use its best efforts to prevent unauthorized disclosure of the United LAB Unity product and any associated documentation and materials to or by the agents, employees or customers of User or competitors of United. User covenants that it shall not make any copies of all or any part of United LAB Unity or United LAB Unity components.</li><li><span class="agreement-li-under">United Right to Audit.</span> United has the right, but not the obligation, to audit User\'s use of United LAB Unity at any time. Any such audits will be conducted in a manner so as to cause minimal disruption to User\'s business operations.</li></ol><p>liability for any indirect, special, consequential, punitive or exemplary damages of any kind, including but not limited to lost revenues or lost fits, loss of business or goodwill or loss of data, in any way arising out of, related to or in connection with this Agreement, even if advised or otherwise has reason to know or knows of the possibility of such damages. This section shall apply even if and to the extent any other remedy vided under this agreement fails of its essential purpose.</p><p><strong>Article IV. Warranty, Liability and Indemnification</strong></p><p><span class="agreement-li-under">Warranty/Liability.</span> United represents that United LAB Unity will perform in accordance with industry standards. Otherwise, United disclaims all other warranties whether express or implied, including without limitation, any implied warranties of merchantability or fitness for a particular purpose regarding United LAB Unity, or access to United LAB Unity through use of the Internet. United assumes no liability or responsibility for how User or any of User\'s employees or other persons uses United LAB Unity or the Data.</p><p>Notwithstanding any other vision of this Agreement, in no event shall United have any</p><p><strong>Article V. Intellectual property</strong></p><p>United is the creator and owner of United LAB Unity, and it and its vendors retain all right, title and interest in United LAB Unity. Nothing in this Agreement creates any ownership rights to User. User agrees not to change or delete any propriety notices from United LAB Unity or other materials related to United LAB Unity. Any other copying, redistribution, retransmission or publication of any such information or material vided without the prior express written consent of United, is strictly prohibited.</p><p><strong>Article VI. General Terms and Conditions</strong></p><p>All other terms of the "United Unity\u2122 Terms of Use Agreement" remain unchanged and in full effect.</p>');
$templateCache.put('app/entities/source/source-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.source.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Source?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/source/source-detail.html','<div><h2><span>Source</span> {{vm.source.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.source.name}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.source.corporation.id})">{{vm.source.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="source-detail.edit({id:vm.source.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/source/source-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySourceLabel">Create or edit a Source</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.source.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/source/sources.html','<section class="content-header"><h1>Sources</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="source.new"><span class="glyphicon glyphicon-flash"></span> <span>New Source</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuerysource" placeholder="Query" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-filter"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Reset your password</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p>Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset</button></form></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Reset password</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/components/ods-lib/reports/params.html','<form name="paramsForm" novalidate ng-submit="vm.openReport()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCityLabel">Report Params for:</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><h4>{{vm.report.title}}</h4><ng-include src="\'app/components/ods-lib/reports/tpl/one-col.tpl.html\'" ng-if="!vm.report.cols"></ng-include><ng-include src="\'app/components/ods-lib/reports/tpl/two-col.tpl.html\'" ng-if="vm.report.cols"></ng-include></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button ng-disabled="paramsForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Open</span></button></div></form>');
$templateCache.put('app/components/ods-lib/reports/reports.html','<div class="row" ng-show="infoMessage" ng-class="ng-hide"><div class="col-lg-12"><div uib-alert class="alert alert-info alert-dismissible" close="hideInfoMessage()"><h4><i class="icon fa fa-info"></i> Reports info!</h4>If don\'t have a PDF viewer plugin in the browser. No biggie... you can download it. Please select the report and download it from report preview.</div></div></div><div class="row"><div class="col-md-3"><div class="box box-solid"><div class="box-header with-border"><h3 class="box-title">{{reportsGroup.title}}</h3></div><!-- /.box-header --><div class="box-body"><uib-accordion close-others="true"><div uib-accordion-group class="panel-default" heading="{{group.title}}" is-open="group.open" is-disabled="group.disabled" ng-repeat="group in reportsGroup.groups" ng-init="groupIndex = $index"><ul class="list-group list-group-unbordered"><li class="list-group-item" ng-repeat="report in group.reports" ng-init="reportIndex = $index"><a ng-click="openReport(groupIndex, reportIndex)"><b>{{report.title}}</b></a></li></ul></div></uib-accordion></div><!-- /.box-body --></div><!-- /.box --></div><div class="col-md-9"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Report Preview</h3></div><!-- /.box-header --><div class="box-body" style="height: 100vh"><div ng-show="selectReport" class="ng-hide"><p>Download report: <a ng-click="downloadReport()">{{selectReport.title}}</a></p></div><pdfjs-viewer data="reportFile"></pdfjs-viewer><!--<object style="height: 90vh;" type="application/pdf" data="{{reportFile}}" width="100%"--><!--height="100%"/>--></div></div></div></div>');
$templateCache.put('app/entities/access/tpl/avf-tpl.html','<div class="box-body"><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label">Primary Access</label><br><toggle ng-model="vm.access.isPrimary" on="Yes" off="No" id="field_isPrimary"></toggle></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">Button Hole</label><br><toggle ng-model="vm.access.buttonHole" on="Yes" off="No" id="field_buttonHole"></toggle></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">Placement Site</label><br><select class="form-control" name="placementSite" ng-model="vm.access.placementSite" id="field_placementSite" ng-required="!vm.access.placementSiteOther" ng-disabled="vm.access.placementSiteOther"><option value=""></option><option value="UPPER_ARM_LEFT">UPPER ARM LEFT</option><option value="UPPER_ARM_RIGHT">UPPER ARM RIGHT</option><option value="FOREARM_LEFT">FOREARM LEFT</option><option value="FOREARM_RIGHT">FOREARM RIGHT</option><option value="FEMORAL_VEIN_LEFT">FEMORAL VEIN LEFT</option><option value="FEMORAL_VEIN_RIGHT">FEMORAL VEIN RIGHT</option></select><div ng-show="editForm.placementSite.$invalid"><p class="help-block" ng-show="editForm.placementSite.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Access Active</label><br><toggle ng-model="vm.access.isActive" on="Yes" off="No" id="field_isActive" ng-change="vm.access.avfgNoActiveSpecify=null;vm.access.noActiveOther=null;"></toggle></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_placementSiteOther">Other Placement Site</label><input type="text" class="form-control" name="placementSiteOther" id="field_placementSiteOther" ng-disabled="vm.access.placementSite" ng-model="vm.access.placementSiteOther"></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-disabled="!vm.access.isActive" ng-show="vm.access.avfgNoActiveSpecify != \'OTHER\'"><label class="control-label">Specify below</label><br><div class="btn-group"><label class="btn btn-primary" ng-model="vm.access.avfgNoActiveSpecify" uib-btn-radio="\'RESTING\'" uncheckable ng-disabled="vm.access.isActive">RESTING</label><label class="btn btn-primary" ng-model="vm.access.avfgNoActiveSpecify" uib-btn-radio="\'MATURING\'" uncheckable ng-disabled="vm.access.isActive">MATURING</label><label class="btn btn-primary" ng-model="vm.access.avfgNoActiveSpecify" uib-btn-radio="\'INFECTED\'" uncheckable ng-disabled="vm.access.isActive">INFECTED</label><label class="btn btn-primary" ng-model="vm.access.avfgNoActiveSpecify" uib-btn-radio="\'THROMBOSIS\'" uncheckable ng-disabled="vm.access.isActive">THROMBOSIS</label><label class="btn btn-primary" ng-model="vm.access.avfgNoActiveSpecify" uib-btn-radio="\'OTHER\'" uncheckable ng-disabled="vm.access.isActive">OTHER</label></div></div><div class="form-group" ng-show="!vm.access.isActive && vm.access.avfgNoActiveSpecify == \'OTHER\'"><label class="control-label" for="field_noActiveOther">Other</label><div class="input-group"><input type="text" class="form-control" name="noActiveOther" id="field_noActiveOther" ng-model="vm.access.noActiveOther"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.access.avfgNoActiveSpecify=null; vm.access.noActiveOther=null;"><i class="glyphicon glyphicon-remove"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_placedBy">Placed By</label><input type="text" class="form-control" name="placedBy" id="field_placedBy" ng-model="vm.access.placedBy"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_placementDate">Placement Date</label><div class="input-group"><input id="field_placementDate" type="text" class="form-control" name="placementDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.access.placementDate" is-open="vm.datePickerOpenStatus.placementDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'placementDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div>');
$templateCache.put('app/entities/access/tpl/avg-tpl.html','<div class="box-body"><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label">Primary Access</label><br><toggle ng-model="vm.access.isPrimary" on="Yes" off="No" id="field_isPrimary"></toggle></div></div><div class="col-lg-offset-3 col-lg-6"><div class="form-group"><label class="control-label">Placement Site</label><br><select class="form-control" name="placementSite" ng-model="vm.access.placementSite" id="field_placementSite" ng-required="!vm.access.placementSiteOther" ng-disabled="vm.access.placementSiteOther"><option value=""></option><option value="UPPER_ARM_LEFT">UPPER ARM LEFT</option><option value="UPPER_ARM_RIGHT">UPPER ARM RIGHT</option><option value="FOREARM_LEFT">FOREARM LEFT</option><option value="FOREARM_RIGHT">FOREARM RIGHT</option><option value="INTERNAL_JUGULAR_LEFT">INTERNAL JUGULAR LEFT</option><option value="INTERNAL_JUGULAR_RIGHT">INTERNAL JUGULAR RIGHT</option><option value="FEMORAL_VEIN_LEFT">FEMORAL VEIN LEFT</option><option value="FEMORAL_VEIN_RIGHT">FEMORAL VEIN RIGHT</option></select><div ng-show="editForm.placementSite.$invalid"><p class="help-block" ng-show="editForm.placementSite.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Access Active</label><br><toggle ng-model="vm.access.isActive" on="Yes" off="No" id="field_isActive" ng-change="vm.access.avfgNoActiveSpecify=null;vm.access.noActiveOther=null;"></toggle></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_placementSiteOther">Other Placement Site</label><input type="text" class="form-control" name="placementSiteOther" id="field_placementSiteOther" ng-disabled="vm.access.placementSite" ng-model="vm.access.placementSiteOther"></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group" ng-disabled="!vm.access.isActive" ng-show="vm.access.avfgNoActiveSpecify != \'OTHER\'"><label class="control-label">Specify below</label><br><div class="btn-group"><label class="btn btn-primary" ng-model="vm.access.avfgNoActiveSpecify" uib-btn-radio="\'RESTING\'" uncheckable ng-disabled="vm.access.isActive">RESTING</label><label class="btn btn-primary" ng-model="vm.access.avfgNoActiveSpecify" uib-btn-radio="\'MATURING\'" uncheckable ng-disabled="vm.access.isActive">MATURING</label><label class="btn btn-primary" ng-model="vm.access.avfgNoActiveSpecify" uib-btn-radio="\'INFECTED\'" uncheckable ng-disabled="vm.access.isActive">INFECTED</label><label class="btn btn-primary" ng-model="vm.access.avfgNoActiveSpecify" uib-btn-radio="\'THROMBOSIS\'" uncheckable ng-disabled="vm.access.isActive">THROMBOSIS</label><label class="btn btn-primary" ng-model="vm.access.avfgNoActiveSpecify" uib-btn-radio="\'OTHER\'" uncheckable ng-disabled="vm.access.isActive">OTHER</label></div></div><div class="form-group" ng-show="!vm.access.isActive && vm.access.avfgNoActiveSpecify == \'OTHER\'"><label class="control-label" for="field_noActiveOther">Other</label><div class="input-group"><input type="text" class="form-control" name="noActiveOther" id="field_noActiveOther" ng-model="vm.access.noActiveOther"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.access.avfgNoActiveSpecify=null; vm.access.noActiveOther=null;"><i class="glyphicon glyphicon-remove"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_placedBy">Placed By</label><input type="text" class="form-control" name="placedBy" id="field_placedBy" ng-model="vm.access.placedBy"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_placementDate">Placement Date</label><div class="input-group"><input id="field_placementDate" type="text" class="form-control" name="placementDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.access.placementDate" is-open="vm.datePickerOpenStatus.placementDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'placementDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div>');
$templateCache.put('app/entities/access/tpl/cvc-tpl.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="box-body"><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Primary Access</label><br><toggle ng-model="vm.access.isPrimary" on="Yes" off="No" id="field_isPrimary"></toggle></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">CVC > 90 Days</label><br><toggle ng-model="vm.access.cvcGt90" on="Yes" off="No" id="field_cvcGt90" name="cvcGt90"></toggle></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">Type of Cvc</label><br><toggle ng-model="vm.access.cvcType" on="Tunneled Central Line" off="Non-tunneled Central Line" id="field_cvcType" name="cvcType"></toggle></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Access Active</label><br><toggle ng-model="vm.access.isActive" on="Yes" off="No" id="field_isActive" ng-change="vm.access.cvcNoActiveSpecify=null;vm.access.noActiveOther=null;"></toggle></div></div><div class="col-lg-6"><div class="form-group"><div class="form-group"><label class="control-label">Placement Site</label><br><select class="form-control" name="placementSite" ng-model="vm.access.placementSite" id="field_placementSite" ng-required="!vm.access.placementSiteOther" ng-disabled="vm.access.placementSiteOther"><option value=""></option><option value="FOREARM_LEFT">FOREARM LEFT</option><option value="FOREARM_RIGHT">FOREARM RIGHT</option><option value="FEMORAL_VEIN_LEFT">FEMORAL VEIN LEFT</option><option value="FEMORAL_VEIN_RIGHT">FEMORAL VEIN RIGHT</option></select><div ng-show="editForm.placementSite.$invalid"><p class="help-block" ng-show="editForm.placementSite.$error.required">This field is required.</p></div></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group" ng-disabled="!vm.access.isActive" ng-show="vm.access.cvcNoActiveSpecify != \'OTHER\'"><label class="control-label">Specify below</label><br><div class="btn-group"><label class="btn btn-primary" ng-model="vm.access.cvcNoActiveSpecify" uib-btn-radio="\'RESTING\'" uncheckable ng-disabled="vm.access.isActive">RESTING</label><label class="btn btn-primary" ng-model="vm.access.cvcNoActiveSpecify" uib-btn-radio="\'INFECTED\'" uncheckable ng-disabled="vm.access.isActive">INFECTED</label><label class="btn btn-primary" ng-model="vm.access.cvcNoActiveSpecify" uib-btn-radio="\'CLOTHED\'" uncheckable ng-disabled="vm.access.isActive">CLOTHED</label><label class="btn btn-primary" ng-model="vm.access.cvcNoActiveSpecify" uib-btn-radio="\'OTHER\'" uncheckable ng-disabled="vm.access.isActive">OTHER</label></div></div><div class="form-group" ng-show="!vm.access.isActive && vm.access.cvcNoActiveSpecify == \'OTHER\'"><label class="control-label" for="field_noActiveOther">Other</label><div class="input-group"><input type="text" class="form-control" name="noActiveOther" id="field_noActiveOther" ng-model="vm.access.noActiveOther"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.access.cvcNoActiveSpecify=null; vm.access.noActiveOther=null"><i class="glyphicon glyphicon-remove"></i></button></span></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_placementSiteOther">Other Placement Site</label><input type="text" class="form-control" name="placementSiteOther" id="field_placementSiteOther" ng-disabled="vm.access.placementSite" ng-model="vm.access.placementSiteOther"></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_placedBy">Placed By</label><input type="text" class="form-control" name="placedBy" id="field_placedBy" ng-model="vm.access.placedBy"></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_placementDate">Placement Date</label><div class="input-group"><input id="field_placementDate" type="text" class="form-control" name="placementDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.access.placementDate" is-open="vm.datePickerOpenStatus.placementDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'placementDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div></form>');
$templateCache.put('app/entities/care-team/tpl/patient-care-team-tpl.html','<form name="vm.form.care_form" role="form" show-validation><div class="row" ng-show="vm.editingCareTeamMember"><div class="col-lg-2"><div class="form-group"><label for="field_care_form_careTeamSpecialty">Care Team Specialty</label><select class="form-control" id="field_care_form_careTeamSpecialty" name="care_form_careTeamSpecialty" ng-model="vm.careTeamMember.careTeamSpecialty" ng-options="careTeamSpecialty as careTeamSpecialty.name for careTeamSpecialty in vm.careteamspecialties track by careTeamSpecialty.id" required><option value=""></option></select><div ng-show="vm.form.care_form.care_form_careTeamSpecialty.$invalid"><p class="help-block" ng-show="vm.form.care_form.care_form_careTeamSpecialty.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_care_form_lastName">Last Name</label><input type="text" class="form-control" name="care_form_lastName" id="field_care_form_lastName" ng-model="vm.careTeamMember.lastName" required><div ng-show="vm.form.care_form.care_form_lastName.$invalid"><p class="help-block" ng-show="vm.form.care_form.care_form_lastName.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_care_form_firstName">First Name</label><input type="text" class="form-control" name="care_form_firstName" id="field_care_form_firstName" ng-model="vm.careTeamMember.firstName" required><div ng-show="vm.form.care_form.care_form_firstName.$invalid"><p class="help-block" ng-show="vm.form.care_form.care_form_firstName.$error.required">This field is required.</p></div></div></div><div class="col-lg-2"><div class="form-group"><label class="control-label" for="field_care_form_phone">Phone</label><input type="text" class="form-control" name="care_form_phone" id="field_care_form_phone" ng-model="vm.careTeamMember.phone" ui-mask="(999) 999-9999" required><div ng-show="vm.form.care_form.care_form_phone.$invalid"><p class="help-block" ng-show="vm.form.care_form.care_form_phone.$error.required">This field is required.</p></div></div></div><div class="col-lg-2"><div class="form-group"><label class="control-label" for="field_care_form_email">Email</label><input type="email" class="form-control" name="care_form_email" id="field_care_form_email" ng-model="vm.careTeamMember.email" required><div ng-show="vm.form.care_form.care_form_email.$invalid"><p class="help-block" ng-show="vm.form.care_form.care_form_email.$error.required">This field is required.</p></div><div><p class="help-block" ng-show="vm.form.care_form.care_form_email.$error.email">Not valid email.</p></div></div></div></div><div class="pull-right"><button type="button" class="btn btn-danger" ng-show="vm.editingCareTeamMember" ng-click="vm.changeEditingCareTeamState()">Cancel</button> <button type="submit" class="btn btn-success" ng-show="vm.editingCareTeamMember" ng-disabled="vm.form.care_form.$invalid" ng-click="vm.saveCareTeamMember()">Save</button></div></form>');
$templateCache.put('app/entities/clinic/dashboard2/clinic-admin-cancel-wizard-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.title}}</h4></div><div class="modal-body"><p class="">Are you sure you want to <strong>cancel</strong> the current wizard? All the entered information will be <strong>lost.</strong></p></div><div class="modal-footer"><button type="button" class="btn btn-danger"><i class="fa fa-check-circle-o" aria-hidden="true"></i> Confirm Cancel Wizard</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Dismiss</button></div>');
$templateCache.put('app/entities/clinic/dashboard2/clinic-admin-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Item?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></form>');
$templateCache.put('app/entities/clinic/dashboard2/clinic-admin-view.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><div class="box"><div class="box-header with-border"><h2 class="text-center mt-0 mb-0">Client Profile</h2><h4 class="text-center">This information will allow us to provide accurate service.</h4></div><div class="box-body"><wizard on-finish="" on-cancel="" indicators-position="top"><wz-step wz-title="Basic Information"><ng-include src="\'app/entities/clinic/dashboard2/wizard/basic-information.html\'"></ng-include><footer class="wz-footer"><button type="submit" wz-next class="btn btn-success">Next <i class="fa fa-chevron-right" aria-hidden="true"></i></button></footer><hr><div class="wz-cancel text-center"><button type="button" class="btn btn-danger" uib-tooltip="Cancel ongoing wizard" ng-click="vm.cancelWizard()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel Wizard</button></div></wz-step><wz-step wz-title="Billing Information"><ng-include src="\'app/entities/clinic/dashboard2/wizard/billing-information.html\'"></ng-include><footer class="wz-footer"><button type="submit" wz-previous class="btn btn-default"><i class="fa fa-chevron-left" aria-hidden="true"></i> Previous</button> <button type="submit" wz-next class="btn btn-success">Next <i class="fa fa-chevron-right" aria-hidden="true"></i></button></footer><hr><div class="wz-cancel text-center"><button type="button" class="btn btn-danger" uib-tooltip="Cancel ongoing wizard" ng-click="vm.cancelWizard()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel Wizard</button></div></wz-step><wz-step wz-title="Clinic Operations"><ng-include src="\'app/entities/clinic/dashboard2/wizard/clinic-operations.html\'"></ng-include><footer class="wz-footer"><button type="submit" wz-previous class="btn btn-default"><i class="fa fa-chevron-left" aria-hidden="true"></i> Previous</button> <button type="submit" wz-next class="btn btn-success">Next <i class="fa fa-chevron-right" aria-hidden="true"></i></button></footer><hr><div class="wz-cancel text-center"><button type="button" class="btn btn-danger" uib-tooltip="Cancel ongoing wizard" ng-click="vm.cancelWizard()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel Wizard</button></div></wz-step><wz-step wz-title="Bundle"><ng-include src="\'app/entities/clinic/dashboard2/wizard/bundle.html\'"></ng-include><footer class="wz-footer"><button type="submit" wz-previous class="btn btn-default"><i class="fa fa-chevron-left" aria-hidden="true"></i> Previous</button> <button type="submit" wz-next class="btn btn-success">Next <i class="fa fa-chevron-right" aria-hidden="true"></i></button></footer><hr><div class="wz-cancel text-center"><button type="button" class="btn btn-danger" uib-tooltip="Cancel ongoing wizard" ng-click="vm.cancelWizard()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel Wizard</button></div></wz-step><wz-step wz-title="Composite"><ng-include src="\'app/entities/clinic/dashboard2/wizard/composer.html\'"></ng-include><footer class="wz-footer"><button type="submit" wz-previous class="btn btn-default"><i class="fa fa-chevron-left" aria-hidden="true"></i> Previous</button> <button type="submit" wz-next class="btn btn-success">Next <i class="fa fa-chevron-right" aria-hidden="true"></i></button></footer><hr><div class="wz-cancel text-center" uib-tooltip="Cancel ongoing wizard" ng-click="vm.cancelWizard()"><button type="button" class="btn btn-danger"><i class="fa fa-ban" aria-hidden="true"></i> Cancel Wizard</button></div></wz-step><wz-step wz-title="Special Pricing"><ng-include src="\'app/entities/clinic/dashboard2/wizard/special-pricing.html\'"></ng-include><footer class="wz-footer"><button type="submit" wz-previous class="btn btn-default"><i class="fa fa-chevron-left" aria-hidden="true"></i> Previous</button> <button type="submit" wz-next class="btn btn-success"><i class="fa fa-check-circle-o" aria-hidden="true"></i> Finish</button></footer><hr><div class="wz-cancel text-center"><button type="button" class="btn btn-danger" uib-tooltip="Cancel ongoing wizard" ng-click="vm.cancelWizard()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel Wizard</button></div></wz-step></wizard></div></div></div></div></section>');
$templateCache.put('app/entities/clinic/dashboard2/clinic-admin.html','<ng-include src="\'app/entities/tpl/list-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button type="button" class="btn btn-default btn-lg btn-header green"><i class="fa fa-plus-circle" aria-hidden="true"></i> New Facility</button><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search..." id="searchQuerypatient" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg" tabindex="0" id="btnSearch" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="box-body"><table class="table table-striped table-condensed" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div></div></section>');
$templateCache.put('app/entities/clinic/tpl/billing-price-tpl.html','<form name="vm.form.billing_price_form" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_bundlePrice">Bundle Price</label><input type="text" class="form-control" name="bundlePrice" id="field_bundlePrice" ng-model="vm.clinic.bundlePrice" required><div ng-show="vm.form.billing_price_form.bundlePrice.$invalid"><p class="help-block" ng-show="vm.form.billing_price_form.bundlePrice.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_compositePrice">Composite Price</label><input type="text" class="form-control" name="compositePrice" id="field_compositePrice" ng-model="vm.clinic.compositePrice" required><div ng-show="vm.form.billing_price_form.compositePrice.$invalid"><p class="help-block" ng-show="vm.form.billing_price_form.compositePrice.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_billingAccount">Billing Account</label><input type="text" class="form-control" name="billingAccount" id="field_billingAccount" ng-model="vm.clinic.billingAccount"></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_billingCompanyCode">Billing Company Code</label><input type="text" class="form-control" name="billingCompanyCode" id="field_billingCompanyCode" ng-model="vm.clinic.billingCompanyCode"></div></div></div></div></form>');
$templateCache.put('app/entities/clinic/tpl/billing-tpl.html','<form name="vm.form.billing_form" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_billingContact">Billing Contact</label><input type="text" class="form-control" name="billingContact" id="field_billingContact" ng-model="vm.clinic.billingContact" required><div ng-show="vm.form.billing_form.billingContact.$invalid"><p class="help-block" ng-show="vm.form.billing_form.billingContact.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_billingPhone">Phone</label><div class="input-group"><input type="text" class="form-control" name="billingPhone" id="field_billingPhone" ng-model="vm.clinic.billingPhone" required ui-mask="(999) 999-9999"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.clinic.billingPhone = vm.clinic.phone"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.billing_form.billingPhone.$invalid"><p class="help-block" ng-show="vm.form.billing_form.billingPhone.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_billingEmail">Email</label><input type="email" class="form-control" name="billingEmail" id="field_billingEmail" ng-model="vm.clinic.billingEmail" required><div ng-show="vm.form.billing_form.billingEmail.$invalid"><p class="help-block" ng-show="vm.form.billing_form.billingEmail.$error.required">This field is required.</p></div><div><p class="help-block" ng-show="vm.form.billing_form.billingEmail.$error.email">Not valid email.</p></div></div></div></div><div class="row"><div class="col-lg-8"><div class="form-group"><label class="control-label" for="field_billingAddress1">Address</label><div class="input-group"><input type="text" class="form-control" name="billingAddress1" id="field_billingAddress1" ng-model="vm.clinic.billingAddress1" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.clinic.billingAddress1 = vm.clinic.address1"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.billing_form.billingAddress1.$invalid"><p class="help-block" ng-show="vm.form.billing_form.billingAddress1.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_billingAddress2">Address 2</label><div class="input-group"><input type="text" class="form-control" name="billingAddress2" id="field_billingAddress2" ng-model="vm.clinic.billingAddress2"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.clinic.billingAddress2 = vm.clinic.address2"><i class="glyphicon glyphicon-copy"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_billingCity">City</label><div class="input-group"><input type="text" class="form-control" name="billingCity" id="field_billingCity" ng-model="vm.clinic.billingCity" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.clinic.billingCity = vm.clinic.city"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.billing_form.billingCity.$invalid"><p class="help-block" ng-show="vm.form.billing_form.billingCity.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label for="field_billingCountryState">State</label><div class="input-group"><select class="form-control" id="field_billingCountryState" name="billingCountryState" ng-model="vm.clinic.billingCountryState" ng-options="countryState as countryState.state for countryState in vm.countrystates track by countryState.id" required><option value=""></option></select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.clinic.billingCountryState = vm.clinic.countryState"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.billing_form.billingCountryState.$invalid"><p class="help-block" ng-show="vm.form.billing_form.billingCountryState.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_billingZipCode">Zip Code</label><div class="input-group"><input type="text" class="form-control" name="billingZipCode" id="field_billingZipCode" ng-model="vm.clinic.billingZipCode" ui-mask="99999" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.clinic.billingZipCode = vm.clinic.zipCode"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.billing_form.billingZipCode.$invalid"><p class="help-block" ng-show="vm.form.billing_form.billingZipCode.$error.required">This field is required.</p></div></div></div></div></div></form>');
$templateCache.put('app/entities/clinic/tpl/corporation-tpl.html','<form name="vm.form.corp_form" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-4"><div class="form-group"><label for="field_corporation">Corporation</label><select class="form-control" id="field_corporation" name="corporation" ng-model="vm.clinic.corporation" ng-required="!vm.clinic.id" ng-options="corporation as corporation.name for corporation in vm.corporations track by corporation.id"></select><div ng-show="vm.form.corp_form.corporation.$invalid"><p class="help-block" ng-show="vm.form.corp_form.corporation.$error.required">This field is required.</p></div></div></div></div></div></form>');
$templateCache.put('app/entities/clinic/tpl/emr-integration-tpl.html','<form name="vm.form.emr_integration_form" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-4"><div class="form-group"><label for="field_emrIntegration">EMR Integration</label><!--<select class="form-control" id="field_emrIntegration" name="emrIntegration"--><!--ng-model="vm.clinic.emrIntegration">--><!--<option></option>--><!--<option value="GAIA">GAIA</option>--><!--<option value="RENESAN">RENESAN</option>--><!--</select>--><ui-select id="field_emrIntegration" name="emrIntegration" ng-model="vm.clinic.emrIntegration" title="EMR"><ui-select-match allow-clear="true" placeholder="Select EMR...">{{$select.selected}}</ui-select-match><ui-select-choices repeat="emr in [\'GAIA\', \'RENESAN\']"> {{emr}} </ui-select-choices></ui-select><!--<ui-select ng-model="vm.machine" title="Choose a Site" ng-disabled="false"--><!--on-select="vm.selectMachine()">--><!--<ui-select-match placeholder="Select Site...">--><!--{{$select.selected.name}}--><!--</ui-select-match>--><!--<ui-select-choices repeat="machine in vm.machines | propsFilter: {name: $select.search}">--><!--<div ng-bind-html="machine.name | highlight: $select.search"></div>--><!--<small>--><!--Location: {{machine.location | date:\'MM/dd/yy\'}} | Type: {{machine.mType}}--><!--</small>--><!--</ui-select-choices>--><!--</ui-select>--></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_emrIntegrationUser">EMR Integration User</label><input type="text" class="form-control" name="emrIntegrationUser" id="field_emrIntegrationUser" ng-model="vm.clinic.emrIntegrationUser"></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_emrIntegrationPass">EMR Integration Pass</label><input type="password" class="form-control" name="emrIntegrationPass" id="field_emrIntegrationPass" ng-model="vm.clinic.emrIntegrationPass"></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_emrIntegrationIp">EMR Integration Ip</label><input type="text" class="form-control" name="emrIntegrationIp" id="field_emrIntegrationIp" ng-model="vm.clinic.emrIntegrationIp"></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_emrIntegrationPath">EMR Integration Path</label><input type="text" class="form-control" name="emrIntegrationPath" id="field_emrIntegrationPath" ng-model="vm.clinic.emrIntegrationPath"></div></div></div></div></form>');
$templateCache.put('app/entities/clinic/tpl/info-tpl.html','<form name="vm.form.clinic_info_form" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_name">Facility Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.clinic.name" required><div ng-show="vm.form.clinic_info_form.name.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.name.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label for="abbr">Abbreviation</label><input type="text" class="form-control" id="abbr" name="abbr" required ng-model="vm.clinic.abbr"><div ng-show="vm.form.clinic_info_form.abbr.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.abbr.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label for="account">Account Number</label><input type="text" class="form-control" id="account" name="account" required ng-model="vm.clinic.account"><div ng-show="vm.form.clinic_info_form.account.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.account.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_medicareId">Medicare ID</label><input type="text" class="form-control" name="medicareId" id="field_medicareId" ng-model="vm.clinic.medicareId"></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.clinic.startDate" is-open="vm.datePickerOpenStatus.startDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.clinic_info_form.startDate.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.startDate.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">Status</label><br><toggle ng-model="vm.clinic.status" on="Active" off="Inactive" id="field_status" ng-disabled="!vm.editing"></toggle><div ng-show="vm.form.clinic_info_form.status.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.status.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_crownWebId">CROWNWeb ID</label><input type="text" class="form-control" name="crownWebId" id="field_crownWebId" ng-model="vm.clinic.crownWebId"></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_npi">NPI</label><input type="text" class="form-control" name="npi" id="field_npi" ng-model="vm.clinic.npi" required><div ng-show="vm.form.clinic_info_form.npi.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.npi.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.clinic.phone" required ui-mask="(999) 999-9999"><div ng-show="vm.form.clinic_info_form.phone.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.phone.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_fax">Fax</label><input type="text" class="form-control" name="fax" id="field_fax" ng-model="vm.clinic.fax" ui-mask="(999) 999-9999"></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_website">Website Address</label><input type="text" class="form-control" name="website" id="field_website" ng-model="vm.clinic.website"></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_standingEnd">Standing Orders End Date</label><div class="input-group"><input id="field_standingEnd" type="text" class="form-control" name="standingEnd" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.clinic.standingEnd" is-open="vm.datePickerOpenStatus.standingEnd" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'standingEnd\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.clinic_info_form.standingEnd.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.standingEnd.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_address1">Address</label><input type="text" class="form-control" name="address1" id="field_address1" ng-model="vm.clinic.address1" required><div ng-show="vm.form.clinic_info_form.address1.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.address1.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_address2">Address</label><input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.clinic.address2"></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.clinic.city" required><div ng-show="vm.form.clinic_info_form.city.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.city.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label for="field_countryState">State</label><select class="form-control" id="field_countryState" name="countryState" ng-model="vm.clinic.countryState" ng-options="countryState as countryState.state for countryState in vm.countrystates track by countryState.id" required><option value=""></option></select><div ng-show="vm.form.clinic_info_form.countryState.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.countryState.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_zipCode">Zip Code</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" ng-model="vm.clinic.zipCode" ui-mask="99999" required><div ng-show="vm.form.clinic_info_form.zipCode.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.zipCode.$error.required">This field is required.</p></div></div></div></div></div></form>');
$templateCache.put('app/entities/clinic/tpl/operation-tpl.html','<form name="vm.form.clinic_operation" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_contractExp">Contract Expire</label><div class="input-group"><input id="field_contractExp" type="text" class="form-control" name="contractExp" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.clinic.contractExp" is-open="vm.datePickerOpenStatus.contractExp" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'contractExp\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.clinic_operation.contractExp.$invalid"><p class="help-block" ng-show="vm.form.clinic_operation.contractExp.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_annualReview">Annual Review</label><div class="input-group"><input id="field_annualReview" type="text" class="form-control" name="annualReview" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.clinic.annualReview" is-open="vm.datePickerOpenStatus.annualReview" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'annualReview\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.clinic_operation.annualReview.$invalid"><p class="help-block" ng-show="vm.form.clinic_operation.annualReview.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">Patient Draw Days</label><ui-select id="field_drawDays" name="drawDays" multiple="multiple" ng-model="vm.clinic.drawDays2" close-on-select="false" title="Draw Days" required ng-disabled="!vm.editing"><ui-select-match placeholder="Select Draw Days...">{{$item}}</ui-select-match><ui-select-choices repeat="day in vm.days | filter:$select.search"> {{day}} </ui-select-choices></ui-select><div ng-show="vm.form.clinic_operation.drawDays.$invalid"><p class="help-block" ng-show="vm.form.clinic_operation.drawDays.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label for="field_pDrawWeek">Patient Draw Week</label><select class="form-control" name="pDrawWeek" ng-model="vm.clinic.pDrawWeek" id="field_pDrawWeek" required><option value=""></option><option value="FIRST_HALF_WEEK">FIRST HALF WEEK</option><option value="FIRST_FULL_WEEK">FIRST FULL WEEK</option><option value="SECOND_FULL_WEEK">SECOND FULL WEEK</option></select><div ng-show="vm.form.clinic_operation.pDrawWeek.$invalid"><p class="help-block" ng-show="vm.form.clinic_operation.pDrawWeek.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_annuals">Annuals</label><select class="form-control" name="annuals" ng-model="vm.clinic.annuals" id="field_annuals" required><option value="JANUARY">JANUARY</option><option value="FEBRUARY">FEBRUARY</option><option value="MARCH">MARCH</option><option value="APRIL">APRIL</option><option value="MAY">MAY</option><option value="JUNE">JUNE</option><option value="JULY">JULY</option><option value="AUGUST">AUGUST</option><option value="SEPTEMBER">SEPTEMBER</option><option value="OCTOBER">OCTOBER</option><option value="NOVEMBER">NOVEMBER</option><option value="DECEMBER">DECEMBER</option></select><div ng-show="vm.form.clinic_operation.annuals.$invalid"><p class="help-block" ng-show="vm.form.clinic_operation.annuals.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_semiAnnuals">Semi Annuals</label><select class="form-control" name="semiAnnuals" ng-model="vm.clinic.semiAnnuals" id="field_semiAnnuals" required><option value="JANUARY">JANUARY</option><option value="FEBRUARY">FEBRUARY</option><option value="MARCH">MARCH</option><option value="APRIL">APRIL</option><option value="MAY">MAY</option><option value="JUNE">JUNE</option><option value="JULY">JULY</option><option value="AUGUST">AUGUST</option><option value="SEPTEMBER">SEPTEMBER</option><option value="OCTOBER">OCTOBER</option><option value="NOVEMBER">NOVEMBER</option><option value="DECEMBER">DECEMBER</option></select><div ng-show="vm.form.clinic_operation.semiAnnuals.$invalid"><p class="help-block" ng-show="vm.form.clinic_operation.semiAnnuals.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">Environmental Draw Days</label><ui-select id="field_wDrawDays" name="wDrawDays" multiple="multiple" ng-model="vm.clinic.wDrawDays2" close-on-select="false" title="Environmental Draw Days" required><ui-select-match placeholder="Select Environmental Draw Days...">{{$item}}</ui-select-match><ui-select-choices repeat="day in vm.days | filter:$select.search"> {{day}} </ui-select-choices></ui-select><div ng-show="vm.form.clinic_operation.wDrawDays.$invalid"><p class="help-block" ng-show="vm.form.clinic_operation.wDrawDays.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label for="field_drawWeek">Environmental Draw Week</label><select class="form-control" name="wDrawWeek" ng-model="vm.clinic.wDrawWeek" id="field_wDrawWeek" required><option value=""></option><option value="FIRST_HALF_WEEK">FIRST HALF WEEK</option><option value="FIRST_FULL_WEEK">FIRST FULL WEEK</option><option value="SECOND_FULL_WEEK">SECOND FULL WEEK</option></select><div ng-show="vm.form.clinic_operation.wDrawWeek.$invalid"><p class="help-block" ng-show="vm.form.clinic_operation.wDrawWeek.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_ssn">EIN</label><input type="text" class="form-control" name="ssn" id="field_ssn" ng-model="vm.clinic.ssn"></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_fdod">FDoD</label><input type="text" class="form-control" name="fdod" id="field_fdod" ng-model="vm.clinic.fdod" required><div ng-show="vm.form.clinic_operation.fdod.$invalid"><p class="help-block" ng-show="vm.form.clinic_operation.fdod.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">Quarterlies</label><ui-select id="field_quarterlies" name="quarterlies" multiple="multiple" ng-model="vm.clinic.quarterlies2" close-on-select="false" title="Quarterlies" required ng-disabled="!vm.editing"><ui-select-match placeholder="Select Draw Month...">{{$item}}</ui-select-match><ui-select-choices repeat="month in vm.months | filter:$select.search"> {{month}} </ui-select-choices></ui-select><div ng-show="vm.form.clinic_operation.quarterlies.$invalid"><p class="help-block" ng-show="vm.form.clinic_operation.quarterlies.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label">Start Pickup</label><p class="input-group"><input type="text" class="form-control" datetime-picker="HH:mm" ng-model="vm.clinic.startPickup" is-open="vm.datePickerOpenStatus.startPickup" enable-date="false" name="startPickup" timepicker-options="vm.timepickerOptions" close-on-selection="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startPickup\')"><i class="fa fa-clock-o"></i></button></span></p></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">End Pickup</label><p class="input-group"><input type="text" class="form-control" datetime-picker="HH:mm" ng-model="vm.clinic.endPickup" is-open="vm.datePickerOpenStatus.endPickup" enable-date="false" name="endPickup" timepicker-options="vm.timepickerOptions" close-on-selection="true"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endPickup\')"><i class="fa fa-clock-o"></i></button></span></p></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_kineticTimeFormat">Kinetic Time Format</label><select class="form-control" name="kineticTimeFormat" ng-model="vm.clinic.kineticTimeFormat" id="field_kineticTimeFormat" required><option value="MM">Minutes (MM)</option><option value="HHMM">Hours and Minutes (HHMM)</option></select><div ng-show="vm.form.clinic_operation.kineticTimeFormat.$invalid"><p class="help-block" ng-show="vm.form.clinic_operation.kineticTimeFormat.$error.required">This field is required.</p></div></div></div></div></div></form>');
$templateCache.put('app/entities/clinic-schedule-detail/dashboard-v2/machine-barcode-detail.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h1 ng-if="vm.barcode != null"><i class="fa fa-barcode"></i> Barcode {{vm.barcode.id}} - Details</h1><h1 ng-if="vm.barcode == null">Details</h1></div><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"></div></div><hr><div class="row"><div class="col-md-3"><div class="box box-primary"><div class="box-body box-profile"><h3 ng-if="vm.barcode != null" class="profile-username text-center">{{vm.machine.name}}</h3><h3 ng-if="vm.barcode == null" class="profile-username text-center">{{vm.machine.machineName}}</h3><p ng-if="vm.barcode != null" class="text-muted text-center">ID: {{vm.machine.id}}</p><p ng-if="vm.barcode == null" class="text-muted text-center">ID: {{vm.machine.machineId}}</p><ul class="list-group list-group-unbordered"><li class="list-group-item" ng-if="vm.barcode != null"><b>Schedule Day</b> <span class="pull-right">{{vm.barcode.collectedDate | date:\'mediumDate\'}}</span></li><li class="list-group-item" ng-if="vm.barcode == null"><b>Schedule Day</b> <span class="pull-right">{{vm.machine.scheduleDate | date:\'mediumDate\'}}</span></li><li class="list-group-item" ng-if="vm.barcode != null"><b>Barcode</b> <span class="pull-right">{{vm.barcode.id}}</span></li><li class="list-group-item" ng-if="vm.barcode != null"><b>View Order</b> <span class="pull-right"><a ui-sref="env-order-detail({id: vm.machine.id, oid: vm.barcode.orderId})">{{vm.barcode.orderId}}</a></span></li><li class="list-group-item" ng-if="vm.barcode == null"><b>View Order</b> <span class="pull-right"><a ui-sref="env-order-detail({id: vm.machine.machineId, oid: vm.machine.id})">{{vm.machine.id}}</a></span></li></ul></div></div></div><div class="col-md-9"><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-body"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" heading="Test List"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></uib-tab></uib-tabset></div></div></div></div></div></div></section><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/clinic-schedule-detail/dashboard-v2/patient-barcode-detail.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h1 ng-if="vm.barcode != null"><i class="fa fa-barcode"></i> Barcode {{vm.barcode.id}} - Details</h1><h1 ng-if="vm.barcode == null">Details</h1></div><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="patient-details-popup"><div class="photo"><img class="img-responsive img-thumbnail" alt="Patient Photo" data-ng-src="{{\'data:\' + vm.patient.patientPicture.pictureContentType + \';base64,\' + vm.patient.patientPicture.picture}}"></div><div class="info-part"><h3 class="mt-0"><strong>{{vm.patient.lastName + \', \' + vm.patient.firstName + \' \' + vm.patient.middleInitial}}</strong></h3><h4 class="text-muted mt-0"><strong>MR#:</strong> {{vm.patient.mrn}}</h4><h4 class="mt-0 mb-0"><strong>D.O.B:</strong> {{vm.patient.dob | date:\'mediumDate\'}}</h4></div><div class="info-part"><h3 class="mt-0">Physician:</h3><p ng-if="vm.barcode != null">{{vm.barcode.physicianTitle + \' \' + vm.barcode.physicianLastName + \', \' + vm.barcode.physicianFirstName}}</p><p ng-if="vm.barcode == null">{{vm.patientOrder.title + \' \' + vm.patientOrder.physicianLastName + \', \' + vm.patientOrder.physicianFirstName}}</p></div><div class="info-part"><h3 class="mt-0">Schedule Day:</h3><p ng-if="vm.barcode != null">{{vm.barcode.collectedDate | date:\'mediumDate\'}}</p><p ng-if="vm.barcode == null">{{vm.patientOrder.scheduleDate | date:\'mediumDate\'}}</p></div></div><hr></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Test:</strong></th><th><strong>Description:</strong></th><th><strong>Frequency:</strong></th><th><strong>Order:</strong></th><th><strong>Template ID:</strong></th><th><strong>Diagnosis (ICD10)</strong></th><th><strong>Renal</strong></th><th></th></tr></thead><tbody><tr class="normal-row hideDescription" ng-repeat-start="patientOrderTest in vm.patientOrderTests track by patientOrderTest.orderTestId"><td>{{patientOrderTest.code}}</td><td>{{patientOrderTest.description}}</td><td>{{patientOrderTest.frequencyName}}</td><td><a ui-sref="patient-order-view({id:vm.patient.id,oid:patientOrderTest.patientOrderId})">{{patientOrderTest.patientOrderId}}</a></td><td></td><td><span>{{patientOrderTest.icd10Code}}</span><a ng-if="patientOrderTest.countOrderTest > 1" href="" class="icd-details" ng-click="vm.showDescription($event,patientOrderTest.orderTestId)" uib-tooltip="See more diagnosis"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></td><td><span class="label" ng-class="patientOrderTest.renal ? \'label-success\' : \'label-danger\'">{{patientOrderTest.renal ? \'Yes\' : \'No\'}}</span></td><td ng-show="vm.barcode == null || patientOrderTest.status == \'SCHEDULED\' || patientOrderTest.status == \'PRINTED\'"><a href="" ng-click="vm.showCancelTestDialog(patientOrderTest.patientOrderItemId)" class="dt-btn danger btn-remove" uib-tooltip="Cancel Test"><i class="fa fa-times"></i></a></td></tr><tr class="description-row" ng-repeat-end ng-if="patientOrderTest.countOrderTest > 1"><td colspan="8"><div class="table-wrapper"><dl class="dl-horizontal"><dt ng-repeat-start="diagnosis in vm.diagnosis[patientOrderTest.orderTestId] track by diagnosis.id">{{diagnosis.icd10Code}}</dt><dd ng-repeat-end>{{diagnosis.description}}</dd></dl></div></td></tr></tbody></table></div></div></div></section><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/dashboard/dashboard-admin/all-orders-schedule.html','<div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Scheduled Tests</h3></div><div><div data-ng-show="!vm.hasPrinter" style="padding: 20px 30px; background: rgb(243, 156, 18); z-index: 999999; font-size: 16px; font-weight: 600"><span style="color: rgba(255, 255, 255, 0.901961); display: inline-block; margin-right: 10px; text-decoration: none">No DYMO printers are installed. Install DYMO printers.</span></div><section class="content"><div class="row"><div class="col-md-9 col-sm-6"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" select="vm.keepActiveTab(0)" heading="Patients"><uib-tab-heading>Patients <span class="label label-danger">{{vm.patientOrders}}</span></uib-tab-heading><div ui-view="patients"></div></uib-tab><uib-tab index="1" select="vm.keepActiveTab(1)" heading="Machines"><uib-tab-heading>Environmentals <span class="label label-primary">{{vm.envOrders}}</span></uib-tab-heading><div ui-view="machines"></div></uib-tab></uib-tabset></div><div class="col-md-3 col-sm-6"><div rm2-datepicker ng-model="vm.oDate1" rm-config="vm.rmConfig1" ng-click="vm.select1(vm.oDate1)" ng-show="vm.activeTab == 0"></div><div rm2-datepicker ng-model="vm.oDate2" rm-config="vm.rmConfig2" ng-click="vm.select2(vm.oDate2)" ng-show="vm.activeTab == 1"></div></div></div></section></div></div>');
$templateCache.put('app/entities/dashboard/dashboard-admin/env-order-schedule.html','<section class="content"><div class="row no-padding"><div class="col-md-12 no-padding"><div class="pull-left"><button class="btn btn-primary" ng-click="vm.printLabels()" ng-disabled="vm.isSaving == true"><span class="glyphicon glyphicon-print"></span> <span>Print Label</span></button></div></div></div><div class="row no-padding"><div class="col-md-12 no-padding"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></section>');
$templateCache.put('app/entities/dashboard/dashboard-admin/patient-order-schedule.html','<section class="content"><div class="row no-padding"><div class="col-md-12 no-padding"><div class="btn-group hidden-lg" uib-dropdown ng-disabled="vm.isSaving == true"><button type="button" class="btn btn-primary" ng-click="vm.printLabels()" ng-disabled="vm.isSaving == true"><span class="glyphicon glyphicon-print"></span> <span>Send Order</span></button> <button type="button" class="btn btn-primary dropdown-toggle" uib-dropdown-toggle data-toggle="dropdown" aria-expanded="false"><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button></div><div class="pull-left hidden-md hidden-sm hidden-xs no-padding-left"><button class="btn btn-primary" ng-click="vm.printLabels()" ng-disabled="vm.isSaving == true"><span class="glyphicon glyphicon-print"></span> <span>Print Label</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"></div></form></div></div></div><div class="row no-padding"><div class="col-md-12 no-padding"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></section>');
$templateCache.put('app/entities/dashboard/dashboard-doc/all-orders-schedule.html','<div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Scheduled Tests</h3></div><div><div data-ng-show="!vm.hasPrinter" style="padding: 20px 30px; background: rgb(243, 156, 18); z-index: 999999; font-size: 16px; font-weight: 600"><span style="color: rgba(255, 255, 255, 0.901961); display: inline-block; margin-right: 10px; text-decoration: none">No DYMO printers are installed. Install DYMO printers.</span></div><section class="content"><div class="row"><div class="col-md-8 col-sm-6"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" select="vm.keepActiveTab(0)" heading="Patients"><uib-tab-heading>Patients</uib-tab-heading><div ui-view="patients"></div></uib-tab><uib-tab index="1" select="vm.keepActiveTab(1)" heading="Machines"><uib-tab-heading>Environmentals</uib-tab-heading><div ui-view="machines"></div></uib-tab></uib-tabset></div><div class="col-md-4 col-sm-6"><div rm2-datepicker ng-model="vm.oDate1" rm-config="vm.rmConfig1" ng-click="vm.select1(vm.oDate1)" ng-show="vm.activeTab == 0"></div><div rm2-datepicker ng-model="vm.oDate2" rm-config="vm.rmConfig2" ng-click="vm.select2(vm.oDate2)" ng-show="vm.activeTab == 1"></div></div></div></section></div></div>');
$templateCache.put('app/entities/dashboard/dashboard-doc/env-order-schedule.html','<section class="content"><div class="row no-padding"><div class="col-md-12 no-padding"><!--        <div class="pull-left">--><!--            <button class="btn btn-primary" ng-click="vm.printLabels()" ng-disabled="vm.isSaving == true">--><!--                <span class="glyphicon glyphicon-print"></span> <span>Send Order</span>--><!--            </button>--><!--        </div>--><div class="pull-right"><div class="btn-group" role="group"><div class="btn-group" role="group" uib-dropdown><button type="button" class="btn btn-primary" uib-dropdown-toggle>Send Order <i class="fa fa-chevron-down" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu role="menu"><li role="menuitem"><a ng-click="vm.printLabels()"><i class="fa fa-calendar"></i> Barcode DYMO</a></li><li role="separator" class="divider"></li><li role="menuitem"><a ng-click="vm.getBarcodeLabelsPdf()"><i class="fa fa-calendar"></i> Barcode PDF</a></li></ul></div><button class="btn btn-warning" ng-click="vm.drawDay()" ng-disabled="vm.isSaving == true"><span class="glyphicon glyphicon-calendar"></span> <span>Change Draw Day</span></button></div></div></div></div><div class="row no-padding"><div class="col-md-12 no-padding"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></section>');
$templateCache.put('app/entities/dashboard/dashboard-doc/patient-order-schedule.html','<section class="content"><div class="row no-padding"><div class="col-md-12 no-padding"><div class="btn-group hidden-lg" uib-dropdown ng-disabled="vm.isSaving == true"><button type="button" class="btn btn-primary" ng-click="vm.printLabels()" ng-disabled="vm.isSaving == true"><span class="glyphicon glyphicon-print"></span> <span>Print Barcodes</span></button> <button type="button" class="btn btn-primary" ng-click="vm.getManifest()" ng-disabled="vm.isSaving == true"><span class="glyphicon glyphicon-print"></span> <span>Manifest</span></button> <button type="button" class="btn btn-primary dropdown-toggle" uib-dropdown-toggle data-toggle="dropdown" aria-expanded="false"><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul class="dropdown-menu" role="menu" uib-dropdown-menu><li><a ng-click="vm.drawDay()" ng-disabled="vm.isSaving == true"><span class="glyphicon glyphicon-calendar"></span>Change Draw Day</a></li></ul></div><div class="pull-left hidden-md hidden-sm hidden-xs no-padding-left"><button class="btn btn-primary" ng-click="vm.printLabels()" ng-disabled="vm.isSaving == true"><span class="glyphicon glyphicon-print"></span> <span>Print Barcodes</span></button> <button class="btn btn-primary" ng-click="vm.getManifest()" ng-disabled="vm.isSaving == true"><span class="glyphicon glyphicon-print"></span> <span>Manifest</span></button></div><div class="pull-right hidden-md hidden-sm hidden-xs no-padding-right"><button class="btn btn-warning" ng-click="vm.drawDay()" ng-disabled="vm.isSaving == true"><span class="glyphicon glyphicon-calendar"></span> <span>Change Draw Day</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"></div></form></div></div></div><div class="row no-padding"><div class="col-md-12 no-padding"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></section>');
$templateCache.put('app/entities/dashboard/dashboard-env/all-orders-schedule.html','<div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Scheduled Tests</h3></div><div><div data-ng-show="!vm.hasPrinter" style="padding: 10px 10px; background: rgb(243, 156, 18); z-index: 999999; font-size: 16px; font-weight: 600"><span style="color: rgba(255, 255, 255, 0.901961); display: inline-block; margin-right: 10px; text-decoration: none">No DYMO printers are installed. Install DYMO printers.</span></div><section class="content"><div class="row"><div class="col-md-8 col-sm-6"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" select="vm.keepActiveTab(0)" heading="Machines"><uib-tab-heading>Environmentals <span class="label label-primary">{{vm.envOrders}}</span></uib-tab-heading><div ui-view="machines"></div></uib-tab></uib-tabset></div><div class="col-md-4 col-sm-6"><div rm2-datepicker ng-model="vm.oDate2" rm-config="vm.rmConfig2" ng-click="vm.select2(vm.oDate2)" ng-show="vm.activeTab == 0"></div></div></div></section></div></div>');
$templateCache.put('app/entities/dashboard/dashboard2/dashboard2-select-day.dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title text-center">Select Date</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-7 text-center"><div rm3-datepicker ng-model="vm.date" rm-config="vm.rmConfig1"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-5"><p class="selected-date"><strong>Selected:</strong> {{vm.date | amDateFormat: displayDateformat}}</p><hr><dl class=""><dt><strong>Legend:</strong></dt><dd class="mb-15"></dd><dt><span class="label label-danger">Red</span> :</dt><dd class="mb-15">Incomplete orders needs to be printed and/or manifested.</dd><dt><span class="label label-success">Green</span> :</dt><dd class="mb-15">Order has been printed and manifested.</dd><dt><span class="label label-warning">Orange</span> :</dt><dd>Date selected by user.</dd></dl></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.selectDate()"><i class="fa fa-check" aria-hidden="true"></i> Select</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/dashboard/dashboard2/env-order-schedule2.html','<div class="table-options"><div data-ng-show="!vm.hasPrinter" style="padding: 10px 10px; background: rgb(243, 156, 18); z-index: 999999; font-size: 16px; font-weight: 600"><span style="color: rgba(255, 255, 255, 0.901961); display: inline-block; margin-right: 10px; text-decoration: none">No DYMO printers are installed. Install DYMO printers.</span></div></div><div class="table-options"><p class="selected-date mb-0">Selected Date: {{vm.selectedDate | amDateFormat: displayDateformat}} <button type="button" class="btn btn-warning" style="margin-left: 10px" ng-click="vm.showCalendar()" uib-tooltip="Open Calendar"><i class="fa fa-calendar" aria-hidden="true"></i></button></p><div class="btn-group" role="group"><div class="btn-group" role="group" uib-dropdown><button type="button" class="btn btn-primary" uib-dropdown-toggle>Print <i class="fa fa-chevron-down" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu role="menu"><li role="menuitem"><a ng-click="vm.printLabels()"><i class="fa fa-calendar"></i> Barcode DYMO</a></li><li role="separator" class="divider"></li><li role="menuitem"><a ng-click="vm.getBarcodeLabelsPdf()"><i class="fa fa-calendar"></i> Barcode PDF</a></li></ul></div><!--        <button type="button" class="btn btn-default" ng-click="vm.getBarcodeLabelsPdf()"><i class="fa fa-barcode"--><!--                                                                                             aria-hidden="true"></i>--><!--            Barcode--><!--        </button>--> <button type="button" class="btn btn-default" ng-click="vm.getManifestPdf()"><i class="fa fa-print" aria-hidden="true"></i> Manifest</button><div class="btn-group" role="group" uib-dropdown><button type="button" class="btn btn-primary" uib-dropdown-toggle>More Actions <i class="fa fa-chevron-down" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu role="menu"><li role="menuitem"><a ng-click="vm.showChangeDrawDayCalendar()"><i class="fa fa-calendar"></i> Change Draw Date</a></li><li role="separator" class="divider"></li><li role="menuitem"><a ng-click="vm.cancelRequisition()"><i class="fa fa-ban"></i> Cancel Requisition</a></li></ul></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search..." id="searchQuerypatient" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg" tabindex="0" id="btnSearch" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed custom-table"></table></div></div></div>');
$templateCache.put('app/entities/dashboard/dashboard2/patient-order-schedule2.html','<div class="table-options"><div data-ng-show="!vm.hasPrinter" style="padding: 10px 10px; background: rgb(243, 156, 18); z-index: 999999; font-size: 16px; font-weight: 600"><span style="color: rgba(255, 255, 255, 0.901961); display: inline-block; margin-right: 10px; text-decoration: none">No DYMO printers are installed. Install DYMO printers.</span></div></div><div class="table-options"><p class="selected-date mb-0">Selected Date: {{vm.selectedDate | amDateFormat: displayDateformat}} <button type="button" class="btn btn-warning" style="margin-left: 10px" ng-click="vm.showCalendar()" uib-tooltip="Open Calendar"><i class="fa fa-calendar" aria-hidden="true"></i></button></p><div class="btn-group" role="group"><button type="button" class="btn btn-default" ng-click="vm.getBarcodeLabelsPdf()"><i class="fa fa-barcode" aria-hidden="true"></i> Barcode</button> <button type="button" class="btn btn-default" ng-click="vm.getManifestPdf()"><i class="fa fa-print" aria-hidden="true"></i> Manifest</button><div class="btn-group" role="group" uib-dropdown><button type="button" class="btn btn-primary" uib-dropdown-toggle>More Actions <i class="fa fa-chevron-down" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu role="menu"><li role="menuitem"><a ng-click="vm.showChangeDrawDayCalendar()"><i class="fa fa-calendar"></i> Change Draw Date</a></li><li role="separator" class="divider"></li><li role="menuitem"><a ng-click="vm.cancelRequisition()"><i class="fa fa-ban"></i> Cancel Requisition</a></li></ul></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search..." id="searchQuerypatient" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg" tabindex="0" id="btnSearch" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed custom-table"></table></div></div></div>');
$templateCache.put('app/entities/dashboard/layout/critical-results-top-box.html','<div class="icon red"><i class="fa fa-warning" aria-hidden="true"></i></div><div class="db-body"><div class="simple-data"><div class="text-data text-right"><h3 class="number mb-0 mt-0">{{vm.criticals.value}}</h3><div class="text">Critical Results</div></div></div></div><footer class="db-footer"><a href="" class="db-link" ui-sref="dashboard2-critical-result">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></footer>');
$templateCache.put('app/entities/dashboard/layout/env-result-abnormal.html','<div class="icon green"><i class="fa fa-bar-chart" aria-hidden="true"></i></div><div class="db-body"><div class="simple-data"><div class="text-data text-right"><h3 class="number mb-0 mt-0">{{vm.abnormalNotReviewed.value}}</h3><div class="text">Abnormal Env Results</div></div></div><div class="dash-graph"><canvas id="bar" class="chart chart-bar" chart-data="vm.data" chart-labels="vm.labels" chart-series="vm.series" chart-colors="vm.colors"></canvas></div></div><footer class="db-footer"><a ui-sref="latest-env-result({filter:{reviewedStatus: \'false\', abnormal: \'true\'}})" class="db-link">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></footer>');
$templateCache.put('app/entities/dashboard/layout/lab-notifications-area.html','<div ng-if="vm.showNotifications==undefined && vm.notifications.length > 0"><div class="well well-lg" ng-class="isCollapsed?\'shrinked\':\'\'"><div ng-repeat="notification in vm.notifications"><div class="alert alert-dismissible fade in" role="alert" ng-class="{\'alert-info\': notification.type === \'INFO\',\n                    \'alert-danger\': notification.type === \'URGENT\',\n                    \'alert-warning\': notification.type === \'WARNING\',\n                    \'alert-success\': notification.type === \'CHECK\'}"><button type="button" class="close" data-dismiss="alert" aria-label="Close" ng-if="!notification.locked" ng-click="vm.dismiss($index)"><span aria-hidden="true">\xD7</span></button><h4>{{notification.name}}</h4><p>{{notification.description}}</p></div></div></div><div class="toggle-expand" ng-show="vm.notifications.length > 2"><a href="" class="" role="button" ng-click="isCollapsed=!isCollapsed" ng-mouseenter="animationFlag = true" ng-mouseleave="animationFlag = false"><span class="label">View <span ng-if="isCollapsed">More</span> <span ng-if="!isCollapsed">Less</span> </span><i class="fa" aria-hidden="true" ng-class="isCollapsed?\'fa-chevron-down\':\'fa-chevron-up\'"></i></a></div></div>');
$templateCache.put('app/entities/dashboard/layout/missing-kinetics-top-box.html','<div class="icon yellow"><i class="fa fa-calendar-times-o" aria-hidden="true"></i></div><div class="db-body"><div class="simple-data"><div class="text-data text-right"><h3 class="number mb-0 mt-0">{{vm.countMissingKinetics}}</h3><div class="text">Missing Kinetics</div></div></div><div class="dash-graph"></div></div><footer class="db-footer"><a ui-sref="kinetic" class="db-link">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></footer>');
$templateCache.put('app/entities/dashboard/layout/missing-pd-adequacy-box.html','<div class="db-body centered well"><div class="simple-data"><div class="text-data text-center"><h3 class="number mb-0 mt-0">{{vm.countMissingPDAdequacy}}</h3><div class="text">Missing PD Adequacy</div></div></div><!--<div class="dash-graph"></div>--></div><footer class="db-footer"><a ui-sref="pd-adequacy-patients" class="db-link">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></footer>');
$templateCache.put('app/entities/dashboard/layout/patient-result-abnormal.html','<div class="icon yellow"><i class="fa fa-bar-chart" aria-hidden="true"></i></div><div class="db-body"><div class="simple-data"><div class="text-data text-right"><h3 class="number mb-0 mt-0">{{vm.abnormalNotReviewed.value}}</h3><div class="text">Abnormal Patient Results</div></div></div><div class="dash-graph"><canvas id="bar" class="chart chart-bar" chart-data="vm.data" chart-labels="vm.labels" chart-series="vm.series" chart-colors="vm.colors"></canvas></div></div><footer class="db-footer"><a ui-sref="latest-result({filter:{reviewedStatus: \'false\', abnormal: \'true\'}})" class="db-link">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></footer>');
$templateCache.put('app/entities/dashboard/layout/pending-results-top-box.html','<div class="icon green"><i class="fa fa-inbox" aria-hidden="true"></i></div><div class="db-body"><div class="simple-data"><div class="text-data text-right"><h3 class="number mb-0 mt-0">{{vm.pending.value}}</h3><div class="text">Pending Results</div></div></div></div><footer class="db-footer"><a href="" class="db-link" ui-sref="dashboard2-pending-result">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></footer>');
$templateCache.put('app/entities/dashboard/layout/unassigned-results-top-box.html','<div class="icon blue"><i class="fa fa-question-circle-o" aria-hidden="true"></i></div><div class="db-body"><div class="simple-data"><div class="text-data text-right"><h3 class="number mb-0 mt-0">{{vm.unassigned.value}}</h3><div class="text">Unassigned Results</div></div></div></div><footer class="db-footer"><a href="" class="db-link" ui-sref="dashboard2-unassigned-results">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></footer>');
$templateCache.put('app/entities/dashboard/layout/unsigned-orders-box.html','<div class="db-body centered well"><div class="simple-data"><div class="text-data text-center"><h3 class="number mb-0 mt-0">{{vm.unsigned.value}}</h3><div class="text">Unsigned Orders</div></div></div><!--<div class="dash-graph"></div>--></div><footer class="db-footer"><a href="" class="db-link" ui-sref="patient-order-unsigned">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></footer>');
$templateCache.put('app/entities/dashboard/tpl/lab-result-diagram-tpl.html','<div class="box box-primary"><div class="box-body box-profile"><h3 class="profile-username">Lab Results</h3><ul class="list-group list-group-unbordered"><li class="list-group-item"><b>Final Results</b> <a class="pull-right" ui-sref="dashboard-final-result">{{vm.dashboard.finalResult}}</a></li><li class="list-group-item"><b>Partial Results</b> <a class="pull-right" ui-sref="dashboard-partial-result">{{vm.dashboard.partialResult}}</a></li><li class="list-group-item"><b>Results Not Received</b> <span class="pull-right">{{vm.dashboard.resultNotReceived}}</span></li></ul><canvas id="polar-area" class="chart chart-pie" chart-colors="vm.colors" chart-data="vm.data" chart-labels="vm.labels" chart-options="options"></canvas></div></div>');
$templateCache.put('app/entities/diagnosis/dashboard-v2/diagnosis-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDiagnosisLabel">List of diagnosis (ICD10)</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button></div></div></form>');
$templateCache.put('app/entities/env-order-tpl/tpl/env-order-form-tpl.html','<form name="vm.form" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-8"><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" id="field_description" class="form-control" ng-model="vm.envOrderTpl.description" name="description" required><div ng-show="vm.form.description.$invalid"><p class="help-block" ng-show="vm.form.description.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><label for="field_corporation">Corporation</label><select class="form-control" id="field_corporation" name="corporation" ng-model="vm.envOrderTpl.corporation" ng-options="corporation as corporation.name for corporation in vm.corporations track by corporation.id"><option value=""></option></select><div ng-show="vm.form.corporation.$invalid"><p class="help-block" ng-show="vm.form.corporation.$error.required">This field is required.</p></div></div></div><div class="pull-left"><button type="button" class="btn btn-primary" ng-click="vm.addEnvOrderTest()">Add Test</button></div><div class="pull-right"><button type="button" class="btn btn-danger" ui-sref="env-order-tpl">Cancel</button> <button type="button" class="btn btn-success" ng-disabled="vm.compendiumErrors.length > 0 || vm.form.$invalid" ng-click="vm.save()">Save</button></div></div></form>');
$templateCache.put('app/entities/env-result/tpl/env-result-filter-tpl.html','<script type="text/ng-template" id="env-result-filter-tpl.html"><form name="editForm" role="form" novalidate="true" ng-submit="vm.filter()" show-validation="false">\n        <div class="modal-body">\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <input type="text" class="form-control input-sm" name="name" id="field_name"\n                               ng-model="vm.machine.name" disabled placeholder="Machine Name"/>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <select class="form-control input-sm" name="status" ng-model="vm.filterRes.status"\n                                id="field_gender">\n                            <option value="">--Status--</option>\n                            <option value="PARTIAL">PARTIAL</option>\n                            <option value="FINAL">FINAL</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="input-group">\n                        <input id="field_start" type="text" class="form-control input-sm" name="start"\n                               uib-datepicker-popup="MM/dd/yyyy" placeholder="Start Date"\n                               ng-model="vm.filterRes.start" is-open="vm.datePickerOpenStatus.start"/>\n                        <span class="input-group-btn">\n                            <button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'start\')"><i\n                                class="glyphicon glyphicon-calendar"></i></button>\n                        </span>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="input-group">\n                        <input id="field_end" type="text" class="form-control input-sm" name="end"\n                               uib-datepicker-popup="MM/dd/yyyy" placeholder="End Date"\n                               ng-model="vm.filterRes.end" is-open="vm.datePickerOpenStatus.end"/>\n                        <span class="input-group-btn">\n                            <button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'end\')"><i\n                                class="glyphicon glyphicon-calendar"></i></button>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="btn btn-default" ng-click="vm.clear()">\n                <span class="glyphicon glyphicon-trash"></span>&nbsp;<span>Clear</span>\n            </button>\n            <button type="submit" class="btn btn-primary" ng-click="vm.changeEditState()">\n                <span class="glyphicon glyphicon-search"></span>&nbsp;<span>Search</span>\n            </button>\n        </div>\n    </form></script>');
$templateCache.put('app/entities/env-result/tpl/env-result-latest-filter-tpl.html','<div class="filter-box"><form name="editForm" class="form filters-form" role="form" ng-submit="vm.search()"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><input type="text" class="form-control input-sm" name="name" id="field_name" ng-model="vm.filterRes.name" placeholder="Machine Name..."></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 form-group"><input type="text" class="form-control input-sm" placeholder="Barcode..." name="barCode" ng-model="vm.filterRes.barcode"></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 form-group"><select class="form-control input-sm" id="field_abnormal" name="abnormal" ng-model="vm.filterRes.abnormal"><option value="">--Alert--</option><option value="true">Abnormal</option><option value="false">Normal</option></select></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><select class="form-control input-sm" id="field_reviewedStatus" name="reviewedStatus" ng-model="vm.filterRes.reviewedStatus"><option value="">--Reviewed Status--</option><option value="true">Reviewed</option><option value="false">Not Reviewed</option></select></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_start" name="start" uib-datepicker-popup="MM/dd/yyyy" placeholder="Start Date..." ng-model="vm.filterRes.start" is-open="vm.datePickerOpenStatus.start"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'start\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 form-group"><div class="input-group input-group-sm"><input id="field_end" type="text" class="form-control" name="end" uib-datepicker-popup="MM/dd/yyyy" placeholder="End Date..." ng-model="vm.filterRes.end" is-open="vm.datePickerOpenStatus.end"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'end\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><hr style="margin-top: 0"><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-lg-offset-6"><button class="btn btn-warning btn-block"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><button class="btn btn-default btn-block" ng-click="vm.clear()" type="button"><i class="fa fa-trash" aria-hidden="true"></i> Clear</button></div></div></form></div>');
$templateCache.put('app/entities/kinetic/tpl/kinetic-filter-tpl.html','<script type="text/ng-template" id="kinetic-filter-tpl.html"><form name="editForm" role="form" novalidate="true" ng-submit="vm.search()" show-validation="false">\n        <div class="modal-body">\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <div class="input-group">\n                            <input id="field_send_start" type="text" class="form-control input-sm" name="sentStart"\n                                   placeholder="Sent Start Date"\n                                   uib-datepicker-popup="MM/dd/yyyy"\n                                   ng-model="vm.filterData.sentStart" is-open="vm.datePickerOpenStatus.sentStart"/>\n                            <span class="input-group-btn">\n                                <button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'sentStart\')"><i\n                                    class="glyphicon glyphicon-calendar"></i></button>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <div class="input-group">\n                            <input id="field_sent_end" type="text" class="form-control input-sm" name="sentEnd"\n                                   placeholder="Sent End Date"\n                                   uib-datepicker-popup="MM/dd/yyyy"\n                                   ng-model="vm.filterData.sentEnd" is-open="vm.datePickerOpenStatus.sentEnd"/>\n                            <span class="input-group-btn">\n                                <button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'sentEnd\')"><i\n                                    class="glyphicon glyphicon-calendar"></i></button>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <div class="input-group">\n                            <input id="field_schedule_start" type="text" class="form-control input-sm" name="scheduleStart"\n                                   placeholder="Schedule Start Date"\n                                   uib-datepicker-popup="MM/dd/yyyy"\n                                   ng-model="vm.filterData.scheduleStart" is-open="vm.datePickerOpenStatus.scheduleStart"/>\n                            <span class="input-group-btn">\n                                <button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'scheduleStart\')"><i\n                                    class="glyphicon glyphicon-calendar"></i></button>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <div class="input-group">\n                            <input id="field_schedule_end" type="text" class="form-control input-sm" name="scheduleEnd"\n                                   placeholder="Schedule End Date"\n                                   uib-datepicker-popup="MM/dd/yyyy"\n                                   ng-model="vm.filterData.scheduleEnd" is-open="vm.datePickerOpenStatus.scheduleEnd"/>\n                            <span class="input-group-btn">\n                                <button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'scheduleEnd\')"><i\n                                    class="glyphicon glyphicon-calendar"></i></button>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <input type="text" class="form-control input-sm" name="lastName" id="field_lastName"\n                               ng-model="vm.filterData.lastName" placeholder="Last Name"/>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <input type="text" class="form-control input-sm" name="firstName" id="field_firstName"\n                               ng-model="vm.filterData.firstName" placeholder="First Name"/>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <div class="input-group">\n                            <input id="field_dob" type="text" class="form-control input-sm" name="dob"\n                                   uib-datepicker-popup="MM/dd/yyyy" placeholder="D.O.B"\n                                   ng-model="vm.filterData.dob" is-open="vm.datePickerOpenStatus.dob"/>\n                            <span class="input-group-btn">\n                                <button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'dob\')"><i\n                                    class="glyphicon glyphicon-calendar"></i></button>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <input type="text" class="form-control input-sm" name="barcode" id="field_barcode"\n                               ng-model="vm.filterData.barcode" placeholder="Barcode"/>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <select class="form-control input-sm" ng-model="vm.filterData.clinic" id="field_clinic" name="clinic"\n                                ng-options="clinic as clinic.name for clinic in vm.clinics track by clinic.id">\n                            <option value="">--Clinic?--</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <select class="form-control input-sm" name="sent" ng-model="vm.filterData.sent"\n                                id="field_sent">\n                            <option value="">--Sent?--</option>\n                            <option value="true">Yes</option>\n                            <option value="false">No</option>\n                        </select>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <select class="form-control input-sm" name="skipped" ng-model="vm.filterData.skipped"\n                                id="field_skipped">\n                            <option value="">--Skipped?--</option>\n                            <option value="true">Yes</option>\n                            <option value="false">No</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="btn btn-default" ng-click="vm.clear()">\n                <span class="glyphicon glyphicon-trash"></span>&nbsp;<span>Clear</span>\n            </button>\n            <button type="submit" class="btn btn-primary">\n                <span class="glyphicon glyphicon-search"></span>&nbsp;<span>Search</span>\n            </button>\n        </div>\n    </form></script>');
$templateCache.put('app/entities/machine/tpl/list-box-header-tpl.html','<div class="box-header"><div class="navbar-form navbar-left" style="margin-left: -15px"><button class="btn btn-primary" ui-sref="{{vm.entityStateName}}.new"><span class="glyphicon glyphicon-plus"></span><span>New {{vm.entityClassHumanized}}</span></button></div><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input type="text" class="form-control" ng-model="vm.searchQuery" size="80" id="searchQueryrpt-metadata" placeholder="Query" ng-change="vm.search()"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div></div>');
$templateCache.put('app/entities/patient/tpl/patient-filter-tpl.html','<script type="text/ng-template" id="patient-filter-tpl.html"><form name="editForm" role="form" novalidate="true" ng-submit="vm.filter()" show-validation="false">\n        <div class="modal-body">\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <input type="text" class="form-control input-sm" name="lastName" id="field_lastName"\n                               ng-model="vm.patient.lastName" placeholder="Last Name"/>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <input type="text" class="form-control input-sm" name="firstName" id="field_firstName"\n                               ng-model="vm.patient.firstName" placeholder="First Name"/>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="input-group">\n                        <input id="field_dob" type="text" class="form-control input-sm" name="dob"\n                               uib-datepicker-popup="MM/dd/yyyy" placeholder="D.O.B"\n                               ng-model="vm.patient.dob" is-open="vm.datePickerOpenStatus.dob"/>\n                        <span class="input-group-btn">\n                            <button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'dob\')"><i\n                                class="glyphicon glyphicon-calendar"></i></button>\n                        </span>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <select class="form-control input-sm" name="gender" ng-model="vm.patient.gender"\n                                id="field_gender">\n                            <option value="">--Gender--</option>\n                            <option value="MALE">MALE</option>\n                            <option value="FEMALE">FEMALE</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <select class="form-control input-sm" id="field_modality" name="modality"\n                                ng-model="vm.patient.modality"\n                                ng-options="modality as modality.name for modality in vm.modalities track by modality.id">\n                            <option value="">--Modality--</option>\n                        </select>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <input type="text" class="form-control input-sm" name="shift" id="field_shift"\n                               placeholder="Shift"\n                               ng-model="vm.patient.shift"/>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-12">\n                    <div class="form-group">\n                        <ui-select id="field_treatmentDays" name="treatmentDays" multiple\n                                   ng-model="vm.patient.treatmentDays" close-on-select="false" title="Treatment Days">\n                            <ui-select-match placeholder="Treatment Days...">{{$item}}</ui-select-match>\n                            <ui-select-choices repeat="day in vm.days | filter:$select.search"> {{day}} </ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-12">\n                    <div class="form-group">\n                        <select class="form-control input-sm" id="field_physician" name="physician"\n                                ng-model="vm.patient.physician"\n                                ng-options="physician as (physician.name) for physician in vm.physicians track by physician.id">\n                            <option value="">--Physician.--</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <select class="form-control input-sm" name="gender" ng-model="vm.patient.diabetic"\n                                id="field_diabetic">\n                            <option value="">--Is Diabetic?--</option>\n                            <option value="true">Yes</option>\n                            <option value="false">No</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="btn btn-default" ng-click="vm.clear()">\n                <span class="glyphicon glyphicon-trash"></span>&nbsp;<span>Clear</span>\n            </button>\n            <button type="submit" class="btn btn-primary" ng-click="vm.changeEditState()">\n                <span class="glyphicon glyphicon-search"></span>&nbsp;<span>Search</span>\n            </button>\n        </div>\n    </form></script>');
$templateCache.put('app/entities/patient/tpl/patient-header-tpl.html','<section class="content-header"><h1 class="section-title"><i class="fa fa-user"></i> {{vm.patient.firstName}} {{vm.patient.middleInitial}} {{vm.patient.lastName}} <small>ID: {{vm.patient.id}} | DOB: {{vm.patient.dob | date:\'mediumDate\'}}</small></h1><div ncy-breadcrumb class="breadcrumb"></div></section>');
$templateCache.put('app/entities/patient/tpl/patient-tpl.html','<!--<div style="padding: 15px 15px 15px 15px; background: rgb(129,181,212); z-index: 999999; font-size: 16px; font-weight: 600;" ui-view="select-filter"></div>--><ng-include src="\'app/entities/patient/tpl/patient-header-tpl.html\'"></ng-include><section class="content" ui-view="content"></section>');
$templateCache.put('app/entities/patient-order/current-order/patient-order-current.html','<div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Current Orders</h3></div><jhi-alert-error></jhi-alert-error><div class="box-body"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" select="vm.keepActiveTab(0)" heading="One Time Requisitions"><div ui-view="onetime"></div></uib-tab><uib-tab index="1" select="vm.keepActiveTab(1)" heading="Recurring Order"><div ui-view="recurring"></div></uib-tab><uib-tab index="2" select="vm.keepActiveTab(2)" heading="Standing Order"><div ui-view="standing"></div></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/entities/patient-order/current-order/patient-order-onetime.html','<div class="box-header with-border"><div class="col-xs-4 no-padding-left"><button type="button" class="btn btn-primary" ui-sref="patient-order-current.new({id: {{vm.patient.id}}, orderType: \'ONE_TIME\'})"><span class="glyphicon glyphicon-add"></span> <span>New One Time Order</span></button></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div>');
$templateCache.put('app/entities/patient-order/current-order/patient-order-recurring.html','<div class="box-header with-border"><div class="col-xs-4 no-padding-left"><button type="button" class="btn btn-primary" ui-sref="patient-order-current.new({id: {{vm.patient.id}}, orderType: \'RECURRING\'})"><span class="glyphicon glyphicon-add"></span> <span>New Recurring Order</span></button></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div>');
$templateCache.put('app/entities/patient-order/current-order/patient-order-standing-confirm.html','<form name="cancelForm" ng-submit="vm.confirmFinish(vm.patientOrder)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm finish order</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to finish this Patient Order?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Dismiss</span></button> <button type="submit" ng-disabled="cancelForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Finish Order</span></button></div></form>');
$templateCache.put('app/entities/patient-order/current-order/patient-order-standing.html','<div class="box-header with-border"><div class="col-xs-4 no-padding-left"><button type="button" class="btn btn-primary" ui-sref="patient-order-current.new({orderType: \'STANDING\'})" ng-show="vm.orders.length == 0"><span class="glyphicon glyphicon-add"></span> <span>New Standing Order</span></button> <button type="button" class="btn btn-primary" ng-click="vm.finishActiveConfirm(vm.orders[0].id)" ng-show="vm.orders.length != 0"><span class="glyphicon glyphicon-add"></span> <span>New Standing Order</span></button></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div>');
$templateCache.put('app/entities/patient-order/dashboard/patient-orders-sign-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">{{vm.wizardTitle}}</h3></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><jhi-alert-error></jhi-alert-error><form name="signForm" ng-submit="vm.signOrders()" show-validation><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h4 class="text-center">Please, enter your personal PIN:</h4><input type="password" class="form-control" placeholder="Pin..." maxlength="4" minlength="4" pattern="\\d{4}" ng-model="vm.signaturePin" ng-required="vm.signature == null" ng-change="vm.signature = \'\'"><div ng-if="vm.showSignature()"><br><h2 class="text-center mt-0 mb-0">OR</h2><br><h4 class="text-center">Sign Here:</h4><ods-signature ng-model="vm.signature" ng-required="vm.signaturePin == null || vm.signaturePin == \'\'" options="vm.signatureOpts"></ods-signature></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="signForm.$invalid"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form></div></div></div>');
$templateCache.put('app/entities/patient-order/dashboard/patient-orders-unsigned.html','<section class="content-header"><h1 class="section-title">{{vm.title}} ({{vm.orders.length}})</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button type="button" class="btn btn-default btn-lg btn-header green" ng-click="vm.modalSignDialog()" ng-show="vm.signOrdersAllowed()"><i class="fa fa-check-circle" aria-hidden="true"></i> Sign Selected Orders</button><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search query..." ng-model="vm.searchQuery" popover-class="" ng-change="vm.search()" id="searchQueryPatient"> <button type="button" class="btn btn-default btn-lg" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div><div class="box"><div class="box-body"><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered custom-table"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient-order/detail/patient-order-detail-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Order Details</h3></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h1 class="section-title"><i class="fa fa-user"></i> {{vm.patientOrder.patient.firstName}} {{vm.patientOrder.patient.middleInitial}} {{vm.patientOrder.patient.lastName}} <small>ID: {{vm.patientOrder.patient.id}} | DOB: {{vm.patientOrder.patient.dob | date:\'mediumDate\'}}</small></h1><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Order {{vm.patientOrder.id}} ({{vm.patientOrder.ordStatus}})</h3></div><jhi-alert-error></jhi-alert-error><div class="box-body"><table class="table table-condensed table-striped table-bordered"><tbody><tr><th>Patient Name</th><th>Order Type</th><th>Obtained</th><th>Physician</th><th>Employee</th></tr><tr><td>{{vm.patientOrder.patient.firstName + \' \' +\n                                    (vm.patientOrder.patient.middleInitial ? vm.patientOrder.patient.middleInitial : \'\') + \' \' +\n                                    vm.patientOrder.patient.lastName}} </td><td>{{vm.patientOrder.orderType}} </td><td>{{vm.patientOrder.via.name}}</td><td>{{vm.patientOrder.signedBy ? vm.patientOrder.signedBy.name + \' \' +\n                                        vm.patientOrder.signedBy.lastName : ""}} </td><td>{{vm.patientOrder.employee ? vm.patientOrder.employee.name + \' \' +\n                                        vm.patientOrder.employee.lastName : ""}} </td></tr></tbody></table></div></div></div></div><div class="row"><div class="col-xs-12"><div class="box box-primary"><div class="box-body"><table datatable="patientOrderTests" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/patient-order/history-order/patient-order-history.html','<div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">History Orders</h3></div><jhi-alert-error></jhi-alert-error><div class="box-body"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" select="vm.keepActiveTab(0)" heading="One Time Requisitions"><div ui-view="onetime"></div></uib-tab><uib-tab index="1" select="vm.keepActiveTab(1)" heading="Recurring Order"><div ui-view="recurring"></div></uib-tab><uib-tab index="2" select="vm.keepActiveTab(2)" heading="Standing Order"><div ui-view="standing"></div></uib-tab></uib-tabset></div></div></div></div>');
$templateCache.put('app/entities/patient-order/history-order/patient-order-onetime.html','<table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table>');
$templateCache.put('app/entities/patient-order/history-order/patient-order-recurring.html','<table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table>');
$templateCache.put('app/entities/patient-order/history-order/patient-order-standing.html','<table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped table-bordered"></table>');
$templateCache.put('app/entities/patient-order-tpl/tpl/patient-order-form-tpl.html','<form name="vm.form" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-12"><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" id="field_description" class="form-control" ng-model="vm.patientOrderTpl.description" name="description" required><div ng-show="vm.form.description.$invalid"><p class="help-block" ng-show="vm.form.description.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_orderType">Order Type</label><select class="form-control" name="orderType" ng-model="vm.patientOrder.orderType" id="field_orderType" ng-change="vm.changeOrderType()"><option value="ONE_TIME">ONE_TIME</option><option value="STANDING">STANDING</option><option value="RECURRING">RECURRING</option></select></div></div><div class="col-lg-3"><div class="form-group"><label for="field_via">Obtained</label><select class="form-control" id="field_via" name="via" ng-model="vm.patientOrder.via" ng-options="via as via.name for via in vm.vias track by via.id"><option value=""></option></select></div></div><div class="col-lg-3"><div class="form-group"><label for="field_employee">Physician</label><select class="form-control" id="field_employee" name="employee" ng-model="vm.patientOrder.signedBy" ng-options="employee as employee.name + \' \' + employee.lastName for employee in vm.employees track by employee.id"><option value=""></option></select></div></div><div class="col-lg-3"><div class="form-group"><label for="field_corporation">Corporation</label><select class="form-control" id="field_corporation" name="corporation" ng-model="vm.patientOrder.corporation" ng-options="corporation as corporation.name for corporation in vm.corporations track by corporation.id"><option value=""></option></select><div ng-show="vm.form.corporation.$invalid"><p class="help-block" ng-show="vm.form.corporation.$error.required">This field is required.</p></div></div></div></div><div class="pull-left"><button type="button" class="btn btn-primary" ng-click="vm.addPatientOrderTest()">Add Test</button></div><div class="pull-right"><button type="button" class="btn btn-danger" ui-sref="patient-order-tpl">Cancel</button> <button type="button" class="btn btn-success" ng-disabled="vm.compendiumErrors.length > 0 || vm.form.$invalid" ng-click="vm.save()">Save</button></div></div></form>');
$templateCache.put('app/entities/patient-order-wizard/steps/components.html','<h3 class="text-center wz-top-margin mb-30"><strong>Components</strong></h3><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 form-group"><label for="testCode">Test Codes:</label><select name="test-code" id="testCode" class="form-control"><option value="01">Order Type 1</option><option value="02">Capsium Dotus 2</option><option value="03">Often Lafitum 3</option></select></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 form-group"><label for="icd10Code">ICD10:</label><select name="icd10Code" id="icd10Code" class="form-control"><option value="01">F11.24</option><option value="02">X23.45</option><option value="03">FCC.11</option><option value="04">Q50.2</option><option value="05">W20.77</option></select></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 form-group"><label for="rationales">Rationales:</label><select name="doctor-list" id="rationales" class="form-control"><option value="01">Mengano Periquito</option><option value="02">Fulano Prostocio</option><option value="03">Siclano Lorem</option></select></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 form-group"><label for="feqName">Frequency:</label><select name="doctor-list" id="feqName" class="form-control"><option value="01">Mengano Periquito</option><option value="02">Fulano Prostocio</option><option value="03">Siclano Lorem</option></select></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 form-group"><label for="startDate">Star Date:</label><div class="input-group"><input type="text" id="startDate" class="form-control" placeholder="mm/dd/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 form-group"><label for="endDate">End Date:</label><div class="input-group"><input type="text" id="endDate" class="form-control" placeholder="mm/dd/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><button type="button" class="btn btn-warning"><i class="fa fa-plus-circle" aria-hidden="true"></i> Generate</button></div></div><hr><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive"><table class="table table-striped table-condensed"><thead><tr><th><strong>Test Code:</strong></th><th><strong>Frequency:</strong></th><th><strong>Start Date:</strong></th><th><strong>End Date:</strong></th><th><strong>ICD10:</strong></th><th><strong>Rationales:</strong></th></tr></thead><tbody><tr><td>2345 For testing use only</td><td><div class="table-control"><select name="" id="" class="form-control"><option value="01">Mengano Periquito</option><option value="02">Fulano Prostocio</option><option value="03">Siclano Lorem</option></select></div></td><td><div class="table-control"><div class="input-group"><input type="text" class="form-control" placeholder="mm/dd/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></td><td><div class="table-control"><div class="input-group"><input type="text" class="form-control" placeholder="mm/dd/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></td><td><div class="table-control"><select name="icd10Code" id="" class="form-control"><option value="01">F11.24</option><option value="02">X23.45</option><option value="03">FCC.11</option><option value="04">Q50.2</option><option value="05">W20.77</option></select></div></td><td><div class="table-control"><select name="doctor-list" id="" class="form-control"><option value="01">Mengano Periquito</option><option value="02">Fulano Prostocio</option><option value="03">Siclano Lorem</option></select></div></td></tr><tr><td>2345 For testing use only</td><td><div class="table-control"><select name="" id="" class="form-control"><option value="01">Mengano Periquito</option><option value="02">Fulano Prostocio</option><option value="03">Siclano Lorem</option></select></div></td><td><div class="table-control"><div class="input-group"><input type="text" class="form-control" placeholder="mm/dd/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></td><td><div class="table-control"><div class="input-group"><input type="text" class="form-control" placeholder="mm/dd/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></td><td><div class="table-control"><select name="icd10Code" id="" class="form-control"><option value="01">F11.24</option><option value="02">X23.45</option><option value="03">FCC.11</option><option value="04">Q50.2</option><option value="05">W20.77</option></select></div></td><td><div class="table-control"><select name="doctor-list" id="" class="form-control"><option value="01">Mengano Periquito</option><option value="02">Fulano Prostocio</option><option value="03">Siclano Lorem</option></select></div></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/patient-order-wizard/steps/order-details.html','<h3 class="text-center wz-top-margin"><strong>Order Details</strong></h3><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 form-group"><label for="orderType">Order Type:</label><select name="" id="orderType" class="form-control"><option value="1">Sensorems messis in camerarius hafnia!</option><option value="2">The zen of respecting bodies is holy.</option><option value="3">Controlled to a post-apocalyptic parasite.</option><option value="4">Lasses sing with strength at the wet norman island!</option></select></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 form-group"><label for="obtainedField">Obtained:</label><select name="" id="obtainedField" class="form-control"><option value="1">Sensorems messis in camerarius hafnia!</option><option value="2">The zen of respecting bodies is holy.</option><option value="3">Controlled to a post-apocalyptic parasite.</option><option value="4">Lasses sing with strength at the wet norman island!</option></select></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 form-group"><label for="physicianGuy">Physician:</label><select name="" id="physicianGuy" class="form-control"><option value="1">Sensorems messis in camerarius hafnia!</option><option value="2">The zen of respecting bodies is holy.</option><option value="3">Controlled to a post-apocalyptic parasite.</option><option value="4">Lasses sing with strength at the wet norman island!</option></select></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="instructionField">Instructions:</label><textarea id="instructionField" rows="4" placeholder="Write instructions" class="form-control" data-resize="disabled"></textarea></div></div>');
$templateCache.put('app/entities/patient-order-wizard/steps/orders-list.html','<h3 class="text-center wz-top-margin"><strong>Order Details</strong></h3><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Test Code:</strong></th><th><strong>Frequency:</strong></th><th><strong>Start Date:</strong></th><th><strong>End Date:</strong></th><th><strong>ICD10:</strong></th><th><strong>Rationales</strong></th><th><strong>Details</strong></th></tr></thead><tbody><tr class="normal-row hideDetails hideDescription"><td>2345 for testing use only</td><td>Daily</td><td>03/12/2016</td><td>04/08/2018</td><td class="icd10-list"><span class="name">F11.24</span> <a href="" uib-tooltip="Details" class="icd-details" ng-click="showDescription($event)"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></td><td>Lorem Ipsum DollorAmet</td><td><a href="" class="dt-btn warning" uib-tooltip="Show Details" ng-click="enableDetails($event)"><i class="fa" aria-hidden="true"></i></a></td></tr><tr class="details-row"><td colspan="7"><div class="table-wrapper"><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>#</strong></th><th><strong>Barcode:</strong></th><th><strong>Scheduled Date:</strong></th><th><strong>Collected:</strong></th><th><strong>Collected Day:</strong></th><th><strong>Sent:</strong></th><th><strong>Sent Day:</strong></th><th><strong>Canceled:</strong></th></tr></thead><tbody><tr><td>0</td><td>P0789428</td><td>09/09/2018</td><td><span class="label label-danger">No</span></td><td>05/08/2018</td><td><span class="label label-success">Yes</span></td><td>08/09/2018</td><td><span class="label label-danger">No</span></td></tr></tbody></table></div></div></td></tr><tr class="description-row"><td colspan="7"><div class="table-wrapper"><dl class="dl-horizontal"><dt>F11.24</dt><dd>Superbus, pius compaters diligenter acquirere de rusticus, alter luna. Lorem Ipsum Dollor Sit Amet copeciut</dd></dl></div></td></tr><tr class="normal-row hideDetails hideDescription"><td>2345 for testing use only</td><td>Daily</td><td>03/12/2016</td><td>04/08/2018</td><td>F11.24</td><td>Lorem Ipsum DollorAmet</td><td><a href="" class="dt-btn warning" uib-tooltip="Show Details" ng-click="enableDetails($event)"><i class="fa fa-file-text-o" aria-hidden="true"></i></a></td></tr><tr class="details-row"><td colspan="7"><div class="table-wrapper"><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>#</strong></th><th><strong>Barcode:</strong></th><th><strong>Scheduled Date:</strong></th><th><strong>Collected:</strong></th><th><strong>Collected Day:</strong></th><th><strong>Sent:</strong></th><th><strong>Sent Day:</strong></th><th><strong>Canceled:</strong></th></tr></thead><tbody><tr><td>0</td><td>P0789428</td><td>09/09/2018</td><td><span class="label label-danger">No</span></td><td>05/08/2018</td><td><span class="label label-success">Yes</span></td><td>08/09/2018</td><td><span class="label label-danger">No</span></td></tr></tbody></table></div></div></td></tr><tr class="description-row"><td colspan="7"><div class="table-wrapper"><dl class="dl-horizontal"><dt>F11.24</dt><dd>Superbus, pius compaters diligenter acquirere de rusticus, alter luna. Lorem Ipsum Dollor Sit Amet copeciut</dd></dl></div></td></tr><tr class="normal-row hideDetails hideDescription"><td>2345 for testing use only</td><td>Daily</td><td>03/12/2016</td><td>04/08/2018</td><td>F11.24</td><td>Lorem Ipsum DollorAmet</td><td><a href="" class="dt-btn warning" uib-tooltip="See Details" ng-click="enableDetails($event)"><i class="fa fa-file-text-o" aria-hidden="true"></i></a></td></tr><tr class="details-row"><td colspan="7"><div class="table-wrapper"><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>#</strong></th><th><strong>Barcode:</strong></th><th><strong>Scheduled Date:</strong></th><th><strong>Collected:</strong></th><th><strong>Collected Day:</strong></th><th><strong>Sent:</strong></th><th><strong>Sent Day:</strong></th><th><strong>Canceled:</strong></th></tr></thead><tbody><tr><td>0</td><td>P0789428</td><td>09/09/2018</td><td><span class="label label-danger">No</span></td><td>05/08/2018</td><td><span class="label label-success">Yes</span></td><td>08/09/2018</td><td><span class="label label-danger">No</span></td></tr></tbody></table></div></div></td></tr><tr class="description-row"><td colspan="7"><div class="table-wrapper"><dl class="dl-horizontal"><dt>F11.24</dt><dd>Superbus, pius compaters diligenter acquirere de rusticus, alter luna. Lorem Ipsum Dollor Sit Amet copeciut</dd></dl></div></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/patient-order-wizard/steps/patient-list.html','<h3 class="text-center wz-top-margin"><strong>Patient List</strong></h3><div class="table-responsive"><table class="table table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div>');
$templateCache.put('app/entities/patient-order-wizard/steps/signature.html','<h3 class="text-center wz-top-margin"><strong>Signature</strong></h3><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="sign-drawer"><div class="pin-code mb-15"><label for="pinCode">Enter Pin Code:</label><input type="text" class="form-control" id="pinCode" ui-mask="9999" ng-model="vm.pinCode"></div><hr class="mb-0"><div class="text-center"><strong>OR</strong></div><hr class="mt-0"><div class="sign well mb-15"><div class="whiteboard"></div></div><div class="terms mb-15"><label for="field_chartSignatureAgree"><input type="checkbox" name="chartSignatureAgree" id="field_chartSignatureAgree" required ng-model="vm.patientSignatureAgree"> I, Pancracio PrintLorem, have reviewed, agree and understand the information contained here in the.</label></div><div><button type="button" class="btn btn-warning btn-block">Sign</button></div></div></div></div>');
$templateCache.put('app/entities/patient-result/dashboard/patient-result-critical-alert-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Critical Results</h3></div><div class="modal-body"><div class="well well-lg jumbotron"><h1 class="text-center"><strong>{{vm.criticals.value}}</strong></h1><p class="text-center small">Critical Results</p></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.clear()" ui-sref="dashboard2-critical-result"><i class="fa fa-external-link" aria-hidden="true"></i> View Details</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/patient-result/dashboard/patient-result-critical-chart-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Patient Results Chart - 6 Month - {{vm.criticalResult.testName}}</h3></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="top-info"><div class="basic-details"><h4 class="mb-0 mt-0">{{vm.criticalResult.patientName}}</h4><p class="small mb-0">Specimen ID: <strong>{{vm.criticalResult.barcode}}</strong></p><p class="small mb-0">Collection Date: <strong>{{vm.criticalResult.collectionDate | amDateFormat: displayDateformat}}</strong></p><p class="small mb-0">Test Performed: <strong>{{vm.criticalResult.testName}}</strong></p><p ng-if="vm.criticalResult.date" class="small mb-0">Acknowledge By: <strong>{{vm.acknowledgeBy}}</strong></p><p ng-if="vm.criticalResult.date" class="small mb-0">Acknowledge Date: <strong>{{vm.criticalResult.date  | amDateFormat: displayDateformat}}</strong></p></div><div class="result-label"><span class="highlighted-label red big">{{vm.testResult}}</span></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h1 class="text-center"><div class="row"><div class="col-md-12"><canvas id="line" class="chart chart-line" chart-data="vm.data" chart-labels="vm.labels" chart-series="vm.series" chart-options="vm.options" chart-dataset-override="vm.datasetOverride" chart-colors="vm.colors"></canvas></div></div></h1><h4><ul><li style="color:red"><span style="color:black">LL/HH</span></li><li style="color:blue"><span style="color:black">L/H</span></li><li style="color:green"><span style="color:black">Normal</span></li></ul></h4></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.acknowledge()" ng-if="!vm.criticalResult.isAcknowledge"><i class="fa fa-check" aria-hidden="true"></i> Acknowledge</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-result/dashboard/patient-result-critical-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Critical Results</h3></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="top-info"><div class="basic-details"><h4 class="mb-0 mt-0">{{vm.criticalResult.patientName}}</h4><p class="small mb-0">Specimen ID: <strong>{{vm.criticalResult.barcode}}</strong></p><p class="small mb-0">Collection Date: <strong>{{vm.criticalResult.collectionDate | amDateFormat:\n                        displayDateformat}}</strong></p><p class="small mb-0">Test Performed: <strong>{{vm.criticalResult.testName}}</strong></p><p ng-if="vm.criticalResult.date" class="small mb-0">Acknowledge By: <strong>{{vm.acknowledgeBy}}</strong></p><p ng-if="vm.criticalResult.date" class="small mb-0">Acknowledge Date: <strong>{{vm.criticalResult.date\n                        | amDateFormat: displayDateformat}}</strong></p></div><div class="result-label"><span class="highlighted-label red big">{{vm.testResult}}</span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><label>Lab Comments</label><div class="well well-lg"><div class="text"><p ng-repeat="comment in vm.comments">{{comment.resultComment}}</p><p ng-if="vm.comments.length == 0">No Lab Comments</p></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><label>Employee Comments</label><table class="table table-bordered"><tbody><tr><th>Employee</th><th>Date/Time</th><th>Comment</th></tr><tr ng-repeat="ecomment in vm.prDetEmployeeComments"><td>{{ecomment.employeeFirstName}} {{ecomment.employeeLastName}}</td><td>{{ecomment.createdDate | amDateFormat: displayAmDateTimeFormat}}</td><td>{{ecomment.comment}}</td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.acknowledge()" ng-if="!vm.criticalResult.isAcknowledge"><i class="fa fa-check" aria-hidden="true"></i> Acknowledge</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-result/dashboard/patient-result-critical.html','<section class="content-header"><h1 class="section-title">{{vm.title}} ({{vm.patientResults.length}})</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button type="button" class="btn btn-default btn-lg btn-header green" ng-click="vm.acknowledge()"><i class="fa fa-check-circle" aria-hidden="true"></i> Acknowledge Selected</button><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search query..." ng-model="vm.searchQuery" popover-class="" ng-change="vm.search()" id="searchQueryPatient"> <button type="button" class="btn btn-default btn-lg" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div></div><div class="btn-group btn-group-lg main-filters"><button type="button" title="All Results" ng-click="vm.updateAcknowledgeButtonFilter(\'All\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active green\': vm.acknowledgeFilter == \'All\'}]"><i class="fa fa-flask" aria-hidden="true"></i> <span class="hidden-xs">All Results</span></button> <button type="button" class="btn btn-default btn-flat" title="Acknowledge" ng-click="vm.updateAcknowledgeButtonFilter(\'Acknowledge\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active green\': vm.acknowledgeFilter == \'Acknowledge\'}]"><i class="fa fa-spinner" aria-hidden="true"></i> <span class="hidden-xs">Acknowledge</span></button> <button type="button" class="btn btn-default" title="Unacknowledged" ng-click="vm.updateAcknowledgeButtonFilter(\'Unacknowledged\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active green\': vm.acknowledgeFilter == \'Unacknowledged\'}]"><i class="fa fa-circle-o" aria-hidden="true"></i> <span class="hidden-xs">Unacknowledged</span></button></div></div><div class="box"><div class="box-body"><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped custom-table"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient-result/dashboard/patient-result-pending-delete-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Please Confirm</h3></div><div class="modal-body"><p class="">Are you sure you want to delete?</p></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="vm.deletePendingResult()" ng-disabled="vm.isSaving"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-result/dashboard/patient-result-pending.html','<section class="content-header"><h1 class="section-title">{{vm.title}} <strong>({{vm.patientResults.length}})</strong></h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button type="button" class="btn btn-default btn-lg btn-header green" ng-click="vm.modalDeletePendingResult()" ng-disabled="vm.deletePendingResult().length == 0"><i class="fa fa-trash" aria-hidden="true"></i> Delete Selected</button><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search query..." ng-model="vm.searchQuery" popover-class="" ng-change="vm.search()" id="searchQueryPatient"> <button type="button" class="btn btn-default btn-lg" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div><div class="box"><div class="box-body"><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped custom-table"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient-result/dashboard/patient-result-sign-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Sign Dialog</h3></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h4 class="text-center">Please, enter your personal PIN:</h4><input type="text" class="form-control" placeholder="Pin..."><br><h2 class="text-center mt-0 mb-0">OR</h2><h4 class="text-center">Sign Here:</h4><div class="well"><div class="sign-canvas"></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click=""><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-result/dashboard/patient-result-unassigned-delete-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Please Confirm</h3></div><div class="modal-body"><p class="">Are you sure you want to delete?</p></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="vm.deleteUnassignedResult()"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-result/dashboard/patient-result-unassigned.html','<section class="content-header"><h1 class="section-title">{{vm.title}} ({{vm.patientResults.length}})</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><jhi-alert></jhi-alert><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button type="button" class="btn btn-default btn-lg btn-header green" ng-click="vm.assign()" ng-disabled="!vm.patient.id || vm.isSaving"><i class="fa fa-check-circle" aria-hidden="true"></i> Assign Results</button><div class="header-select"><ui-select name="patient-names" id="field_patient" uib-tooltip="Patient List" theme="bootstrap" ng-model="vm.patient" reset-search-input="false" ng-required="true" append-to-body="true"><ui-select-match placeholder="Select patient...">{{$select.selected.fullName}} </ui-select-match><ui-select-choices repeat="patient in vm.patients | filter: $select.search"><div ng-bind-html="patient.fullName | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="search-material"><div class="search-input"><input type="text" id="searchQueryPatient" class="form-control input-lg" placeholder="Search query..." ng-model="vm.searchQuery" popover-class="" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div></div><div class="btn-group btn-group-lg main-filters"><button type="button" title="All Results" ng-click="vm.updateStatusButtonFilter(\'all\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active green\': vm.filterRes.status == \'all\'}]"><i class="fa fa-flask" aria-hidden="true"></i> <span class="hidden-xs">All Results</span></button> <button type="button" class="btn btn-default btn-flat" title="Unassigned" ng-click="vm.updateStatusButtonFilter(\'unassigned\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active green\': vm.filterRes.status == \'unassigned\'}]"><i class="fa fa-circle-o" aria-hidden="true"></i> <span class="hidden-xs">Unassigned</span></button> <button type="button" class="btn btn-default" title="Assigned" ng-click="vm.updateStatusButtonFilter(\'assigned\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active green\': vm.filterRes.status == \'assigned\'}]"><i class="fa fa-spinner" aria-hidden="true"></i> <span class="hidden-xs">History</span></button></div></div><div class="box"><div class="box-body"><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped custom-table"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient-result/tpl/patient-result-by-patient-filter-tpl.html','<script type="text/ng-template" id="patient-filter-tpl.html"><form name="editForm" role="form" novalidate="true" ng-submit="vm.filter()" show-validation="false">\n        <div class="modal-body">\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <select class="form-control input-sm" name="status" ng-model="vm.filterRes.status"\n                                id="field_status">\n                            <option value="">--Status--</option>\n                            <option value="PARTIAL">PARTIAL</option>\n                            <option value="FINAL">FINAL</option>\n                        </select>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <select class="form-control input-sm" name="abnormal" ng-model="vm.filterRes.abnormal"\n                                id="field_abnormal">\n                            <option value="">--Abnormal?--</option>\n                            <option value="true">YES</option>\n                            <option value="false">NO</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="input-group">\n                        <input id="field_start" type="text" class="form-control input-sm" name="start"\n                               uib-datepicker-popup="MM/dd/yyyy" placeholder="Start Date"\n                               ng-model="vm.filterRes.start" is-open="vm.datePickerOpenStatus.start"/>\n                        <span class="input-group-btn">\n                            <button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'start\')"><i\n                                class="glyphicon glyphicon-calendar"></i></button>\n                        </span>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="input-group">\n                        <input id="field_end" type="text" class="form-control input-sm" name="end"\n                               uib-datepicker-popup="MM/dd/yyyy" placeholder="End Date"\n                               ng-model="vm.filterRes.end" is-open="vm.datePickerOpenStatus.end"/>\n                        <span class="input-group-btn">\n                            <button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'end\')"><i\n                                class="glyphicon glyphicon-calendar"></i></button>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="btn btn-default" ng-click="vm.clear()">\n                <span class="glyphicon glyphicon-trash"></span>&nbsp;<span>Clear</span>\n            </button>\n            <button type="submit" class="btn btn-primary" ng-click="vm.changeEditState()">\n                <span class="glyphicon glyphicon-search"></span>&nbsp;<span>Search</span>\n            </button>\n        </div>\n    </form></script>');
$templateCache.put('app/entities/patient-result/tpl/patient-result-filter-tpl.html','<script type="text/ng-template" id="patient-filter-tpl.html"><form name="editForm" role="form" novalidate="true" ng-submit="vm.filter()" show-validation="false">\n        <div class="modal-body">\n            <div class="row">\n                <div class="col-lg-12">\n                    <div class="form-group">\n                        <input type="text" class="form-control input-sm" name="patientName" id="field_patientName"\n                               ng-model="vm.filterRes.patientName" placeholder="Patient Name"/>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <select class="form-control input-sm" name="status" ng-model="vm.filterRes.status"\n                                id="field_gender">\n                            <option value="">--Status--</option>\n                            <option value="PARTIAL">PARTIAL</option>\n                            <option value="FINAL">FINAL</option>\n                        </select>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="form-group">\n                        <select class="form-control input-sm" name="abnormal" ng-model="vm.filterRes.abnormal"\n                                id="field_abnormal">\n                            <option value="">--Abnormal?--</option>\n                            <option value="true">YES</option>\n                            <option value="false">NO</option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-lg-6">\n                    <div class="input-group">\n                        <input id="field_start" type="text" class="form-control input-sm" name="start"\n                               uib-datepicker-popup="MM/dd/yyyy" placeholder="Start Date"\n                               ng-model="vm.filterRes.start" is-open="vm.datePickerOpenStatus.start"/>\n                        <span class="input-group-btn">\n                            <button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'start\')"><i\n                                class="glyphicon glyphicon-calendar"></i></button>\n                        </span>\n                    </div>\n                </div>\n                <div class="col-lg-6">\n                    <div class="input-group">\n                        <input id="field_end" type="text" class="form-control input-sm" name="end"\n                               uib-datepicker-popup="MM/dd/yyyy" placeholder="End Date"\n                               ng-model="vm.filterRes.end" is-open="vm.datePickerOpenStatus.end"/>\n                        <span class="input-group-btn">\n                            <button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'end\')"><i\n                                class="glyphicon glyphicon-calendar"></i></button>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="btn btn-default" ng-click="vm.clear()">\n                <span class="glyphicon glyphicon-trash"></span>&nbsp;<span>Clear</span>\n            </button>\n            <button type="submit" class="btn btn-primary">\n                <span class="glyphicon glyphicon-search"></span>&nbsp;<span>Search</span>\n            </button>\n        </div>\n    </form></script>');
$templateCache.put('app/entities/patient-result/tpl/patient-result-latest-filter-tpl.html','<div class="filter-box"><form name="editForm" class="form filters-form" role="form" ng-submit="vm.search()"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><input type="text" class="form-control input-sm" id="field_patientName" placeholder="Patient Name..." name="patientName" ng-model="vm.filterRes.patientName"></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_dob" placeholder="Day of Birth..." name="dob" ng-model="vm.filterRes.dob" uib-datepicker-popup="MM/dd/yyyy" is-open="vm.datePickerOpenStatus.dob"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dob\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 form-group"><input type="text" class="form-control input-sm" placeholder="Barcode..." name="barCode" ng-model="vm.filterRes.barcode"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><select class="form-control input-sm" id="field_abnormal" name="abnormal" ng-model="vm.filterRes.abnormal"><option value="">--Alert--</option><option value="true">Abnormal</option><option value="false">Normal</option></select></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_start" placeholder="Start Date..." name="start" ng-model="vm.filterRes.start" uib-datepicker-popup="MM/dd/yyyy" is-open="vm.datePickerOpenStatus.start"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'start\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_end" placeholder="End Date..." name="end" ng-model="vm.filterRes.end" is-open="vm.datePickerOpenStatus.end" uib-datepicker-popup="MM/dd/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'end\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><select class="form-control input-sm" id="field_reviewedStatus" name="reviewedStatus" ng-model="vm.filterRes.reviewedStatus"><option value="">--Reviewed Status--</option><option value="true">Reviewed</option><option value="false">Not Reviewed</option></select></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><ui-select name="shift" id="field_shift" title="Shift" ng-model="vm.filterRes.shift" ng-change="vm.selectShift()" reset-search-input="false" search-enabled="false"><ui-select-match placeholder="Select Shift...">{{\'Shift: \' + $select.selected.shift}} </ui-select-match><ui-select-choices repeat="shift in vm.shifts"><div ng-bind-html="\'Shift: \' + shift.shift"></div></ui-select-choices></ui-select></div></div><hr style="margin-top: 0"><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-lg-offset-6"><button class="btn btn-warning btn-block"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><button class="btn btn-default btn-block" ng-click="vm.clear()" type="button"><i class="fa fa-trash" aria-hidden="true"></i> Clear</button></div></div></form></div><!-- filters box -->');
$templateCache.put('app/entities/pr-emr-integration-log/tpl/pr-emr-integration-log-filter-tpl.html','<form name="editForm" class="form filters-form" role="form" ng-submit="vm.search()"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><select class="form-control input-sm" id="field_status" name="status" ng-model="vm.filterRes.status"><option value="">--Status--</option><option value="SUCCESS">SUCCESS</option><option value="FAILED">FAILED</option><option value="SKIPPED">SKIPPED</option><option value="MISS_CONFIGURATION">MISS CONFIGURATION</option></select></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><input type="text" class="form-control input-sm" placeholder="Barcode..." name="barCode" ng-model="vm.filterRes.barcode"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_start" placeholder="Start Date..." name="start" ng-model="vm.filterRes.start" uib-datepicker-popup="MM/dd/yyyy" is-open="vm.datePickerOpenStatus.start"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'start\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_end" placeholder="End Date..." name="end" ng-model="vm.filterRes.end" is-open="vm.datePickerOpenStatus.end" uib-datepicker-popup="MM/dd/yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'end\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><hr style="margin-top: 0"><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-lg-offset-6"><button class="btn btn-warning btn-block"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><button class="btn btn-default btn-block" ng-click="vm.clear()" type="button"><i class="fa fa-trash" aria-hidden="true"></i> Clear</button></div></div></form>');
$templateCache.put('app/entities/problem-list/tpl/problem-list-form-tpl.html','<form name="vm.form.problem_form" role="form" show-validation><div class="row" ng-show="vm.editingProblem"><div class="col-lg-4"><div class="form-group"><label class="control-label">Diagnosis</label><ui-select ng-model="vm.problem.diagnosis" name="problem_list_diagnosis" id="field_problem_list_diagnosis" reset-search-input="false" ng-required="true" title="Diagnosis"><ui-select-match placeholder="Enter diagnosis...">{{$select.selected.icd10Code}}</ui-select-match><ui-select-choices repeat="diagnosis in vm.diagnoses" refresh="vm.getDiagnosis($select.search)" refresh-delay="0"><div ng-bind-html="diagnosis.icd10Code | highlight: $select.search"></div><small> {{diagnosis.description}} </small></ui-select-choices></ui-select><div ng-show="vm.form.problem_form.problem_list_diagnosis.$invalid"><p class="help-block" ng-show="vm.form.problem_form.problem_list_diagnosis.$error.required">This field is required.</p></div></div></div><div class="col-lg-1"><div class="form-group"><label class="control-label">Renal</label><br><toggle ng-model="vm.problem.renal" on="Yes" off="No" id="field_problem_list_renal"></toggle><div ng-show="vm.form.problem_form.problem_list_renal.$invalid"><p class="help-block" ng-show="vm.form.problem_form.problem_list_renal.$error.required">This field is required.</p></div></div></div><div class="col-lg-1"><div class="form-group"><label class="control-label">Is Active?</label><br><toggle ng-model="vm.problem.active" on="Yes" off="No" id="field_problem_list_active"></toggle><div ng-show="vm.form.problem_form.problem_list_active.$invalid"><p class="help-block" ng-show="vm.form.problem_form.problem_list_active.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_problem_list_start_date">Start Date</label><div class="input-group"><input id="field_problem_list_start_date" type="text" class="form-control" name="problem_list_start_date" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.problem.startDate" is-open="vm.datePickerOpenStatus.problemStartDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'problemStartDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_problem_list_end_date">End Date</label><div class="input-group"><input id="field_problem_list_end_date" type="text" class="form-control" name="problem_list_end_date" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.problem.endDate" is-open="vm.datePickerOpenStatus.problemEndDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'problemEndDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="pull-right"><button type="button" class="btn btn-danger" ng-show="vm.editingProblem" ng-click="vm.changeEditingProblemState()">Cancel</button> <button type="submit" class="btn btn-success" ng-show="vm.editingProblem" ng-disabled="vm.form.problem_form.$invalid" ng-click="vm.saveProblem()">Save</button></div></form>');
$templateCache.put('app/entities/rpt-compendium-default-message/tpl/rpt-compendium-default-message-filter-tpl.html','<form name="editForm" class="form filters-form" role="form" ng-submit="vm.search()"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><input type="text" class="form-control input-sm" id="field_language" placeholder="Language ..." name="name" ng-model="vm.filterRes.name"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><input type="text" class="form-control input-sm" id="field_compendium" placeholder="Compendium Description..." name="description" ng-model="vm.filterRes.description"></div></div><hr style="margin-top: 0"><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-lg-offset-6"><button class="btn btn-warning btn-block"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><button class="btn btn-default btn-block" ng-click="vm.clear()" type="button"><i class="fa fa-trash" aria-hidden="true"></i> Clear</button></div></div></form>');
$templateCache.put('app/entities/rpt-compendium-message/tpl/rpt-compendium-message-filter-tpl.html','<form name="editForm" class="form filters-form" role="form" ng-submit="vm.search()"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><input type="text" class="form-control input-sm" id="field_language" placeholder="Language ..." name="name" ng-model="vm.filterRes.name"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><input type="text" class="form-control input-sm" id="field_compendium" placeholder="Compendium Description..." name="description" ng-model="vm.filterRes.description"></div></div><hr style="margin-top: 0"><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-lg-offset-6"><button class="btn btn-warning btn-block"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><button class="btn btn-default btn-block" ng-click="vm.clear()" type="button"><i class="fa fa-trash" aria-hidden="true"></i> Clear</button></div></div></form>');
$templateCache.put('app/layouts/header/tpl/idle-tpl.html','<script type="text/ng-template" id="warning-dialog.html"><div class="modal-header">\n        <h3>You\'re Idle. Do Something!</h3>\n    </div>\n    <div idle-countdown="vm.countdown" class="modal-body">\n        <p>You\'ll be logged out in <span class="label label-warning">{{vm.countdown}}</span>\n            <span ng-pluralize="" count="vm.countdown" when="{\'one\': \'second\', \'other\': \'seconds\' }"></span>.</p>\n        <uib-progressbar max="30" value="vm.countdown" animate="true" class="progress-striped active"></uib-progressbar>\n    </div></script>');
$templateCache.put('app/components/ods-lib/reports/tpl/one-col.tpl.html','<div class="form-group" ng-repeat="param in vm.report.params" ng-switch="param.type" ng-class="{\'has-error\': paramsForm.{{param.name}}.$invalid}"><label class="control-label" for="{{param.name}}" ng-hide="vm.hideTitle(param)">{{param.title}}</label><input class="form-control" name="{{param.name}}" id="{{param.name}}" ng-hide="vm.hideParam(param)" ng-model="param.value" ng-required="vm.getRequired(param)" ng-switch-when="NUMBER" type="number"> <input class="form-control" name="{{param.name}}" id="{{param.name}}" ng-hide="vm.hideParam(param)" ng-model="param.value" ng-required="vm.getRequired(param)" ng-switch-when="TEXT"><div class="input-group" ng-switch-when="DATE" ng-hide="vm.hideParam(param)"><input id="{{param.name}}" class="form-control" name="{{param.name}}" uib-datepicker-popup="MM/dd/yyyy" ng-required="vm.getRequired(param)" ng-model="param.value" is-open="param.datePickerOpenStatus"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($index)"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-switch-when="SINGLE_SELECT" ng-hide="vm.hideParam(param)"><ui-select name="{{param.name}}" id="{{param.name}}" ng-model="param.value" ui-select-required="vm.getRequired(param)" close-on-select="true" title="{{param.title}}"><ui-select-match placeholder="{{param.placeholder}}">{{vm.getSelectTitleField(param,\n                $select.selected)}} </ui-select-match><ui-select-choices repeat="element in param.list | filter:$select.search | limitTo: 500"><div ng-bind-html="vm.getSelectTitleField(param, element) | highlight: $select.search"></div><!--<small ng-bind-html="vm.getSelectTitleField(param, element) | highlight: $select.search"></small>--><!--{{vm.getSelectTitleField(param, element)}}--></ui-select-choices></ui-select></div><select class="form-control" name="{{param.name}}" id="{{param.name}}" ng-hide="vm.hideParam(param)" ng-switch-when="LIST" ng-model="param.value" ng-options="item.id as item.name for item in param.list" ng-required="vm.getRequired(param)"></select><div ng-switch-when="MULTI_SELECT" ng-hide="vm.hideParam(param)"><ui-select name="{{param.name}}" id="{{param.name}}" multiple="multiple" ng-model="param.value" close-on-select="false" title="{{param.title}}" ui-select-required="vm.getRequired(param)"><ui-select-match placeholder="{{param.placeholder}}"> {{vm.getSelectTitleField(param, $item)}} </ui-select-match><ui-select-choices repeat="element in param.list | filter:$select.search"> {{vm.getSelectTitleField(param, element)}} </ui-select-choices></ui-select></div><div ng-switch-when="TABLE_SELECT" ng-hide="vm.hideParam(param)"><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input class="form-control" ng-model="param.searchQuery" id="searchQueryrpt-metadata" placeholder="{{param.placeholder}}" ng-change="vm.search($index)"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div><br><br><table datatable="" dt-options="vm.getDtOptions(param, $index)" dt-columns="vm.getDtColumns(param, $index)" dt-instance="param.dtInstance" class="table table-striped table-bordered table-condensed"></table></div><input class="form-control" name="{{param.name}}" id="{{param.name}}" ng-hide="vm.hideParam(param)" ng-model="param.value" ng-required="vm.getRequired(param)" ng-switch-default><div ng-show="paramsForm.{{param.name}}.$invalid"><p class="help-block" ng-show="paramsForm.{{param.name}}.$error.required">This field is required.</p></div></div>');
$templateCache.put('app/components/ods-lib/reports/tpl/two-col.tpl.html','<div class="row" ng-repeat="(indexp, param) in vm.report.params" ng-if="$index % 2 == 0"><div class="col-lg-6"><div class="form-group" ng-switch="param.type" ng-class="{\'has-error\': paramsForm.{{param.name}}.$invalid}"><label class="control-label" for="{{param.name}}" ng-hide="vm.hideTitle(param)">{{param.title}}</label><input class="form-control" name="{{param.name}}" id="{{param.name}}" ng-hide="vm.hideParam(param)" ng-model="param.value" ng-required="vm.getRequired(param)" ng-switch-when="NUMBER" type="number"> <input class="form-control" name="{{param.name}}" id="{{param.name}}" ng-hide="vm.hideParam(param)" ng-model="param.value" ng-required="vm.getRequired(param)" ng-switch-when="TEXT"><div class="input-group" ng-switch-when="DATE" ng-hide="vm.hideParam(param)"><input id="{{param.name}}" class="form-control" name="{{param.name}}" uib-datepicker-popup="MM/dd/yyyy" ng-required="vm.getRequired(param)" ng-model="param.value" is-open="param.datePickerOpenStatus"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($index)"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-switch-when="SINGLE_SELECT" ng-hide="vm.hideParam(param)"><ui-select name="{{param.name}}" id="{{param.name}}" ng-model="param.value" ui-select-required="vm.getRequired(param)" close-on-select="true" title="{{param.title}}"><ui-select-match placeholder="{{param.placeholder}}">{{vm.getSelectTitleField(param,\n                        $select.selected)}} </ui-select-match><ui-select-choices repeat="element in param.list | filter:$select.search | limitTo: 500"><div ng-bind-html="vm.getSelectTitleField(param, element) | highlight: $select.search"></div><!--<small ng-bind-html="vm.getSelectTitleField(param, element) | highlight: $select.search"></small>--><!--{{vm.getSelectTitleField(param, element)}}--></ui-select-choices></ui-select></div><select class="form-control" name="{{param.name}}" id="{{param.name}}" ng-hide="vm.hideParam(param)" ng-switch-when="LIST" ng-model="param.value" ng-options="item.id as item.name for item in param.list" ng-required="vm.getRequired(param)"></select><div ng-switch-when="MULTI_SELECT" ng-hide="vm.hideParam(param)"><ui-select name="{{param.name}}" id="{{param.name}}" multiple="multiple" ng-model="param.value" close-on-select="false" title="{{param.title}}" ui-select-required="vm.getRequired(param)"><ui-select-match placeholder="{{param.placeholder}}">{{vm.getSelectTitleField(param,\n                        $item)}} </ui-select-match><ui-select-choices repeat="element in param.list | filter:$select.search"> {{vm.getSelectTitleField(param, element)}} </ui-select-choices></ui-select></div><div ng-switch-when="TABLE_SELECT" ng-hide="vm.hideParam(param)"><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input class="form-control" ng-model="param.searchQuery" id="searchQueryrpt-metadata" placeholder="{{param.placeholder}}" ng-change="vm.search($index)"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div><br><br><table datatable="" dt-options="vm.getDtOptions(param, $index)" dt-columns="vm.getDtColumns(param, $index)" dt-instance="param.dtInstance" class="table table-striped table-bordered table-condensed"></table></div><input class="form-control" name="{{param.name}}" id="{{param.name}}" ng-hide="vm.hideParam(param)" ng-model="param.value" ng-required="vm.getRequired(param)" ng-switch-default><div ng-show="paramsForm.{{param.name}}.$invalid"><p class="help-block" ng-show="paramsForm.{{param.name}}.$error.required">This field is required.</p></div></div></div><div class="col-lg-6" ng-if="$index + 1 < vm.report.params.length"><div class="form-group" ng-switch="vm.report.params[$index + 1].type" ng-class="{\'has-error\': paramsForm.{{vm.report.params[$index + 1].name}}.$invalid}"><label class="control-label" for="{{vm.report.params[$index + 1].name}}" ng-hide="vm.hideTitle(vm.report.params[$index + 1])">{{vm.report.params[$index +\n                1].title}} </label><input class="form-control" name="{{vm.report.params[$index + 1].name}}" id="{{vm.report.params[$index + 1].name}}" ng-hide="vm.hideParam(vm.report.params[$index + 1])" ng-model="vm.report.params[$index + 1].value" ng-required="vm.getRequired(vm.report.params[$index + 1])" ng-switch-when="NUMBER" type="number"> <input class="form-control" name="{{vm.report.params[$index + 1].name}}" id="{{vm.report.params[$index + 1].name}}" ng-hide="vm.hideParam(vm.report.params[$index + 1])" ng-model="vm.report.params[$index + 1].value" ng-required="vm.getRequired(vm.report.params[$index + 1])" ng-switch-when="TEXT"><div class="input-group" ng-switch-when="DATE" ng-hide="vm.hideParam(vm.report.params[$index + 1])"><input id="{{vm.report.params[$index + 1].name}}" class="form-control" name="{{vm.report.params[$index + 1].name}}" uib-datepicker-popup="MM/dd/yyyy" ng-required="vm.getRequired(vm.report.params[$index + 1])" ng-model="vm.report.params[$index + 1].value" is-open="vm.report.params[$index + 1].datePickerOpenStatus"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($index + 1)"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-switch-when="SINGLE_SELECT" ng-hide="vm.hideParam(vm.report.params[$index + 1])"><ui-select name="{{vm.report.params[$index + 1].name}}" id="{{vm.report.params[$index + 1].name}}" ng-model="vm.report.params[$index + 1].value" ui-select-required="vm.getRequired(vm.report.params[$index + 1])" close-on-select="true" title="{{vm.report.params[$index + 1].title}}"><ui-select-match placeholder="{{vm.report.params[$index + 1].placeholder}}"> {{vm.getSelectTitleField(vm.report.params[$index + 1],\n                        $select.selected)}} </ui-select-match><ui-select-choices repeat="element in vm.report.params[$index + 1].list | filter:$select.search | limitTo: 500"><div ng-bind-html="vm.getSelectTitleField(vm.report.params[$index + 1], element) | highlight: $select.search"></div><!--<small ng-bind-html="vm.getSelectTitleField(param, element) | highlight: $select.search"></small>--><!--{{vm.getSelectTitleField(param, element)}}--></ui-select-choices></ui-select></div><select class="form-control" name="{{vm.report.params[$index + 1].name}}" id="{{vm.report.params[$index + 1].name}}" ng-hide="vm.hideParam(vm.report.params[$index + 1])" ng-switch-when="LIST" ng-model="vm.report.params[$index + 1].value" ng-options="item.id as item.name for item in vm.report.params[$index + 1].list" ng-required="vm.getRequired(vm.report.params[$index + 1])"></select><div ng-switch-when="MULTI_SELECT" ng-hide="vm.hideParam(vm.report.params[indexp + 1])"><ui-select name="{{vm.report.params[indexp + 1].name}}" id="{{vm.report.params[indexp + 1].name}}" multiple="multiple" ng-model="vm.report.params[indexp + 1].value" close-on-select="false" title="{{vm.report.params[indexp + 1].title}}" ui-select-required="vm.getRequired(vm.report.params[indexp + 1])"><ui-select-match placeholder="{{vm.report.params[indexp + 1].placeholder}}"> {{vm.getSelectTitleField(vm.report.params[indexp + 1], $item)}} </ui-select-match><ui-select-choices repeat="element in vm.report.params[indexp + 1].list | filter:$select.search"> {{vm.getSelectTitleField(vm.report.params[indexp + 1], element)}} </ui-select-choices></ui-select></div><div ng-switch-when="TABLE_SELECT" ng-hide="vm.hideParam(vm.report.params[$index + 1])"><div class="navbar-form navbar-right"><div class="text-right"><div class="has-feedback input-group-sm"><input class="form-control" ng-model="vm.report.params[$index + 1].searchQuery" id="searchQueryrpt-metadata" placeholder="{{vm.report.params[$index + 1].placeholder}}" ng-change="vm.search($index)"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></div><br><br><table datatable="" dt-options="vm.getDtOptions(vm.report.params[$index + 1], $index)" dt-columns="vm.getDtColumns(vm.report.params[$index + 1], $index)" dt-instance="vm.report.params[$index + 1].dtInstance" class="table table-striped table-bordered table-condensed"></table></div><input class="form-control" name="{{vm.report.params[$index + 1].name}}" id="{{vm.report.params[$index + 1].name}}" ng-hide="vm.hideParam(vm.report.params[$index + 1])" ng-model="vm.report.params[$index + 1].value" ng-required="vm.getRequired(vm.report.params[$index + 1])" ng-switch-default><div ng-show="paramsForm.{{vm.report.params[$index + 1].name}}.$invalid"><p class="help-block" ng-show="paramsForm.{{vm.report.params[$index + 1].name}}.$error.required">This field is required.</p></div></div></div></div>');
$templateCache.put('app/entities/clinic/dashboard2/wizard/basic-information.html','<form action="" method="post" class="wz-form form mt-30"><h3 class="text-center"><strong>Basic Information:</strong></h3><hr><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="clientName">Client Name:</label><input type="text" id="clientName" class="form-control" placeholder="John Doe..."></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="accountNumber">Account Number:</label><input type="text" id="accountNumber" class="form-control" placeholder="123456.."></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="npiNumber">NPI Number:</label><input type="text" id="npiNumber" class="form-control" placeholder="123456.."></div><div class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-8"><label for="addressOne">Address:</label><input type="text" id="addressOne" class="form-control" placeholder="Address..."></div><div class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-4"><label for="addressTwo">Address Two:</label><input type="text" id="addressTwo" class="form-control" placeholder="Address Two..."></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="clientCity">City:</label><input type="text" id="clientCity" class="form-control" placeholder="City..."></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="clientState">State:</label><input type="text" id="clientState" class="form-control" placeholder="Sate..."></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="zipCode">Zip Code:</label><input type="text" id="zipCode" class="form-control" ng-model="vm.basicInfZipCode" ui-mask="99999"></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="clientPhone">Phone:</label><input type="text" id="clientPhone" class="form-control" ng-model="vm.basicInfClientPhone" ui-mask="(999)-999-9999"></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="clientFax">Fax:</label><input type="text" id="clientFax" class="form-control" ng-model="vm.basicInfZipCode" ui-mask="(999)-999-9999"></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="crownWebId">CrownWeb ID:</label><input type="text" id="crownWebId" class="form-control" placeholder="CrownWeb ID.."></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="status">Status:</label><br><toggle id="status" ng-model="toggle2.model" onstyle="btn-success" offstyle="btn-danger" on="Enable" off="Disable"></toggle></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-4"><label for="corporations">Corporations:</label><select name="" id="corporations" class="form-control"><option value="1">Corporation 1</option><option value="1">ACME</option></select></div></form>');
$templateCache.put('app/entities/clinic/dashboard2/wizard/billing-information.html','<form action="" method="post" class="wz-form form"><div class="form-billing mt-30 mb-30"><h3 class="text-center"><strong>Primary:</strong></h3><hr><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="billingContact">Billing Contact:</label><input type="text" id="billingContact" class="form-control" placeholder="John Doe..."></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="billingPhone">Phone:</label><input type="text" id="billingPhone" class="form-control" ng-model="vm.billingInfoPhone" ui-mask="(999)-999-9999"></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="billingEmail">Email:</label><input type="email" id="billingEmail" class="form-control" placeholder="example@domain.com"></div><div class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-8"><label for="billingAddressOne">Billing Address:</label><input type="text" id="billingAddressOne" class="form-control" placeholder="Address..."></div><div class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-4"><label for="billingAddressTwo">Billing Address Two:</label><input type="text" id="billingAddressTwo" class="form-control" placeholder="Address Two..."></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="clientCity">City:</label><input type="text" id="clientCity" class="form-control" placeholder="City..."></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="clientState">State:</label><input type="text" id="clientState" class="form-control" placeholder="Sate..."></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="zipCode">Zip Code:</label><input type="text" id="zipCode" class="form-control" ng-model="vm.billingInfoZip" ui-mask="99999"></div></div><div class="form-billing" ng-if="vm.secondBilling"><hr><h4 class="flex-heading"><strong>Secondary:</strong> <button type="button" class="btn btn-danger" ng-if="vm.secondBilling" ng-click="vm.toggleSecondBilling()"><i class="fa fa-trash" aria-hidden="true"></i> Remove Secondary Billing</button></h4><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="billingContact2">Billing Contact:</label><input type="text" id="billingContact2" class="form-control" placeholder="John Doe..."></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="billingPhone2">Phone:</label><input type="text" id="billingPhone2" class="form-control" ng-model="vm.billingInfoPhone2" ui-mask="(999)-999-9999"></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="billingEmail2">Email:</label><input type="email" id="billingEmail2" class="form-control" placeholder="example@domain.com"></div><div class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-8"><label for="billingAddressOne2">Billing Address:</label><input type="text" id="billingAddressOne2" class="form-control" placeholder="Address..."></div><div class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-4"><label for="billingAddressTwo2">Billing Address Two:</label><input type="text" id="billingAddressTwo2" class="form-control" placeholder="Address Two..."></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="clientCity2">City:</label><input type="text" id="clientCity2" class="form-control" placeholder="City..."></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="clientState2">State:</label><input type="text" id="clientState2" class="form-control" placeholder="Sate..."></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="zipCode2">Zip Code:</label><input type="text" id="zipCode2" class="form-control" ng-model="vm.billingInfoZip2" ui-mask="99999"></div></div><div class="billing-groups" ng-if="!vm.secondBilling && vm.companyBilling"><button type="button" class="btn btn-warning" ng-click="vm.toggleSecondBilling()"><i class="fa fa-plus-circle"></i> Add Secondary Billing</button></div><div class="form-billing" ng-if="vm.companyBilling"><hr><h4 class="flex-heading"><strong>Company Billing:</strong> <button class="btn btn-danger" ng-if="vm.companyBilling" ng-click="vm.toggleCompanyBilling()"><i class="fa fa-trash" aria-hidden="true"></i> Remove Company Billing</button></h4><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="billingContact3">Billing Contact:</label><input type="text" id="billingContact3" class="form-control" placeholder="John Doe..."></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="billingPhone3">Phone:</label><input type="text" id="billingPhone3" class="form-control" ng-model="vm.billingInfoPhone3" ui-mask="(999)-999-9999"></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="billingEmail3">Email:</label><input type="email" id="billingEmail3" class="form-control" placeholder="example@domain.com"></div><div class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-8"><label for="billingAddressOne3">Billing Address:</label><input type="text" id="billingAddressOne3" class="form-control" placeholder="Address..."></div><div class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-4"><label for="billingAddressTwo3">Billing Address Two:</label><input type="text" id="billingAddressTwo3" class="form-control" placeholder="Address Two..."></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="clientCity3">City:</label><input type="text" id="clientCity3" class="form-control" placeholder="City..."></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="clientState3">State:</label><input type="text" id="clientState3" class="form-control" placeholder="Sate..."></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="zipCode3">Zip Code:</label><input type="text" id="zipCode3" class="form-control" ng-model="vm.billingInfoZip3" ui-mask="99999"></div></div><div class="billing-groups mt-15 mb-30" ng-if="!vm.companyBilling && vm.secondBilling"><button type="button" class="btn btn-info" ng-click="vm.toggleCompanyBilling()"><i class="fa fa-bank" aria-hidden="true"></i> Add Company Billing</button></div><div class="billing-groups" ng-if="!vm.secondBilling && !vm.companyBilling"><button type="button" class="btn btn-warning" ng-click="vm.toggleSecondBilling()"><i class="fa fa-plus-circle"></i> Add Secondary Billing</button> <button type="button" class="btn btn-info" ng-click="vm.toggleCompanyBilling()"><i class="fa fa-bank" aria-hidden="true"></i> Add Company Billing</button></div></form>');
$templateCache.put('app/entities/clinic/dashboard2/wizard/bundle.html','<h3 class="text-center mt-30 pt-30"><strong>Bundle</strong></h3><hr><div class="header-options"><button type="button" class="btn btn-default btn-header green"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Bundle</button><div class="search-material"><div class="search-input"><input type="text" class="form-control" placeholder="Search..."> <button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div><table class="table table-striped table-condensed wz-table mt-30 mb-15"><thead><tr><th><strong>Code</strong></th><th><strong>Description</strong></th><th><strong>Frequency</strong></th><th><strong>Modality</strong></th><th><strong></strong></th></tr></thead><tbody><tr><td>1020</td><td>Lipid Panel</td><td>Weekly</td><td>Peritoneal Dialysis</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr><tr><td>4321</td><td>Renal Replated Test</td><td>Bi Monthly</td><td>Hemo Dialysis</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr><tr class="red-row"><td>LC-2234 <i class="fa fa-exclamation-triangle" aria-hidden="true"></i><p class="small">This test is a sendout</p></td><td>Some example of a LabCorp test in bundle</td><td>Per Treatment</td><td>Hemo Dialysis</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr><tr><td>1020</td><td>Lipid Panel</td><td>Weekly</td><td>Peritoneal Dialysis</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr><tr><td>1020</td><td>Lipid Panel</td><td>Weekly</td><td>Peritoneal Dialysis</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr></tbody></table>');
$templateCache.put('app/entities/clinic/dashboard2/wizard/clinic-operations.html','<form action="" method="post" class="wz-form form mt-30"><h4 class="text-center"><strong>Clinic Operations:</strong></h4><hr><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="clinicOpAnnuals">Annuals:</label><select name="selectAnnuals" id="clinicOpAnnuals" class="form-control"><option value="01">January</option><option value="02">February</option><option value="03">March</option><option value="04">April</option><option value="05">May</option><option value="06">June</option><option value="07">July</option><option value="08">August</option><option value="09">September</option><option value="10">October:</option><option value="11">November</option><option value="12">December</option></select></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="clinicOpSemiAnnuals">Semi Annuals:</label><select name="selectSemiAnnuals" id="clinicOpSemiAnnuals" class="form-control"><option value="01">January</option><option value="02">February</option><option value="03">March</option><option value="04">April</option><option value="05">May</option><option value="06">June</option><option value="07">July</option><option value="08">August</option><option value="09">September</option><option value="10">October:</option><option value="11">November</option><option value="12">December</option></select></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="clinicOpQuarterlies">Quarterlies:</label><!-- Multiple Select --><select name="selectQuarterlies" id="clinicOpQuarterlies" class="form-control"><option value="01">January</option><option value="02">February</option><option value="03">March</option><option value="04">April</option><option value="05">May</option><option value="06">June</option><option value="07">July</option><option value="08">August</option><option value="09">September</option><option value="10">October:</option><option value="11">November</option><option value="12">December</option></select></div><div class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-8"><label for="patientDrawDays">Patient Draw Dates:</label><!-- Multiple Select --><select name="selectSemiAnnuals" id="patientDrawDays" class="form-control"><option value="01">Monday</option><option value="02">Tuesday</option><option value="03">Wednesday</option><option value="04">Thursday</option><option value="05">Friday</option><option value="06">Saturday</option><option value="06">Sunday</option></select></div><div class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-4"><label for="patientDrawWeeks">Patient Draw Week:</label><!-- Multiple Select --><select name="selectSemiAnnuals" id="patientDrawWeeks" class="form-control"><option value="01">First Full Week</option><option value="02">Second Week</option><option value="03">Four Week</option></select></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="contractExpirationDate">Contract Expires:</label><input type="date" id="contractExpirationDate" class="form-control" placeholder="mm/dd/yyyy"></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="annualReview">Annual Review:</label><input type="date" id="annualReview" class="form-control" placeholder="mm/dd/yyyy"></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="startDate">Start Date:</label><input type="date" id="startDate" class="form-control" placeholder="mm/dd/yyyy"></div><div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="ein">EIN:</label><input type="text" id="ein" class="form-control" placeholder="123456789..."></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="standingOrderDate">Standing Order End Date:</label><input type="date" id="standingOrderDate" class="form-control" placeholder="mm/dd/yyyy"></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="externalAbbreviation">External Abbreviation:</label><input type="text" id="externalAbbreviation" class="form-control" placeholder="123456789..."></div><div class="form-group col-xs-12 col-sm-6 col-md-6 col-lg-4"><label for="templates">Template:</label><select name="selectTemplates" id="templates" class="form-control"><option value="01">Facility Only</option><option value="02">Template Fancy</option><option value="03">Almighty Template</option></select></div><div class="form-group col-xs-12 col-sm-6 col-md-4 col-lg-4"><label for="bundlePrice">Contracted Bundle Price:</label><div class="input-group"><div class="input-group-addon">$</div><input type="text" class="form-control" id="bundlePrice" placeholder="Amount"><div class="input-group-addon">.00</div></div></div><div class="form-group col-xs-12 col-sm-6 col-md-4 col-lg-4"><label for="composeRate">Contracted Composite Price:</label><div class="input-group"><div class="input-group-addon">$</div><input type="text" class="form-control" id="composeRate" placeholder="Amount"><div class="input-group-addon">.00</div></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><label for="operationInterface">Interface:</label><select id="operationInterface" class="form-control"><option value="1">GAIA Interface</option><option value="1">Renesan Interface</option></select></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="kineticTimeFormat">Kinetics Time Format:</label><select name="selectTemplates" id="kineticTimeFormat" class="form-control"><option value="01">Format 01</option><option value="02">LBS</option><option value="03">ZXYTR-RT</option></select></div><div class="form-group col-xs-6 col-sm-6 col-md-4 col-lg-4"><label for="kineticWeightFormat">Kinetics Weight Format:</label><select name="selectTemplates" id="kineticWeightFormat" class="form-control"><option value="01">Format 01</option><option value="02">LBS</option><option value="03">ZXYTR-RT</option></select></div></form>');
$templateCache.put('app/entities/clinic/dashboard2/wizard/composer.html','<h3 class="text-center mt-30 pt-30"><strong>Composite</strong></h3><hr><div class="header-options"><button type="button" class="btn btn-default btn-header green"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add New Composite</button><div class="search-material"><div class="search-input"><input type="text" class="form-control" placeholder="Search..."> <button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div><table class="table table-striped table-condensed wz-table mt-30 mb-15"><thead><tr><th><strong>Code</strong></th><th><strong>Description</strong></th><th><strong>Frequency</strong></th><th><strong>Modality</strong></th><th><strong></strong></th></tr></thead><tbody><tr><td>1020</td><td>Lipid Panel</td><td>Weekly</td><td>Peritoneal Dialysis</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr><tr><td>4321</td><td>Renal Replated Test</td><td>Bi Monthly</td><td>Hemo Dialysis</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr><tr class="red-row"><td>LC-2234 <i class="fa fa-exclamation-triangle" aria-hidden="true"></i><p class="small">This test is a sendout</p></td><td>Some example of a LabCorp test in bundle</td><td>Per Treatment</td><td>Hemo Dialysis</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr><tr><td>1020</td><td>Lipid Panel</td><td>Weekly</td><td>Peritoneal Dialysis</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr><tr><td>1020</td><td>Lipid Panel</td><td>Weekly</td><td>Peritoneal Dialysis</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr></tbody></table>');
$templateCache.put('app/entities/clinic/dashboard2/wizard/special-pricing.html','<h3 class="text-center mt-30 pt-30"><strong>Special Pricing</strong></h3><hr><div class="header-options"><button type="button" class="btn btn-default btn-header green"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Special Pricing</button><div class="search-material"><div class="search-input"><input type="text" class="form-control" placeholder="Search..."> <button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div><table class="table table-striped table-condensed wz-table mt-30 mb-15"><thead><tr><th><strong>Code</strong></th><th><strong>Description</strong></th><th><strong>CPT</strong></th><th><strong>Special Price</strong></th><th><strong></strong></th></tr></thead><tbody><tr><td>1020</td><td>Lipid Panel</td><td>G6060</td><td>$12.50</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" ng-click="vm.del()" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr><tr><td>4321</td><td>Renal Replated Test</td><td>G1234</td><td>$100.43</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" ng-click="vm.del()" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr><tr class="red-row"><td>LC-2234 <i class="fa fa-exclamation-triangle" aria-hidden="true"></i><p class="small">This test is a sendout</p></td><td>Some example of a LabCorp test in bundle</td><td>G5023</td><td>$2345.67</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" ng-click="vm.del()" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr><tr><td>1020</td><td>Lipid Panel</td><td>G4343</td><td>$5.20</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" ng-click="vm.del()" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr><tr><td>1020</td><td>Lipid Panel</td><td>G6666</td><td>$1000.13</td><td class="col"><a class="dt-btn warning" href="#" uib-tooltip="Edit"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a class="dt-btn danger" href="" ng-click="vm.del()" uib-tooltip="Delete"><i class="fa fa-trash" aria-hidden="true"></i></a></td></tr></tbody></table>');
$templateCache.put('app/entities/patient/tpl/form/patient-address-tpl.html','<button ng-show="vm.patient.addresses[0] == null" type="button" class="btn btn-info" ng-click="vm.addAddress(0)" ng-show="vm.patient.addresses.length == 0">Add Primary Address</button><form name="vm.form.address_form" role="form" show-validation bind-validity="vm.tab1"><div ng-repeat="address in vm.patient.addresses"><div class="box-header with-border"><h3 ng-if="$even" class="box-title">Primary Address</h3><h3 ng-if="$odd" class="box-title">Secondary Address</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" ng-show="$even && vm.patient.addresses.length > 1" ng-click="vm.swapAddresses()"><i class="fa fa-refresh fa-spin fa-fw"></i></button> <button type="button" class="btn btn-box-tool" ng-show="$even" ng-click="vm.deleteAddress(0)"><i class="fa fa-times"></i></button> <button type="button" class="btn btn-box-tool" ng-show="$odd" ng-click="vm.deleteAddress(1)"><i class="fa fa-times"></i></button></div></div><div class="box-body"><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_address{{$index}}_address1">Address</label><input type="text" class="form-control" name="address{{$index}}_address1" id="field_address{{$index}}_address1" ng-model="address.address1" required><div ng-show="vm.form.address_form.address{{$index}}_address1.$invalid"><p class="help-block" ng-show="vm.form.address_form.address{{$index}}_address1.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><label class="control-label" for="field_address{{$index}}_address2">Address 2</label><input type="text" class="form-control" name="address{{$index}}_address2" id="field_address{{$index}}_address2" ng-model="address.address2"></div><div class="col-lg-3"><label class="control-label" for="field_address{{$index}}_phone">Phone</label><input type="text" class="form-control" name="address{{$index}}_phone" id="field_address{{$index}}_phone" ng-model="address.phone" ui-mask="(999) 999-9999" required><div ng-show="vm.form.address_form.address{{$index}}_phone.$invalid"><p class="help-block" ng-show="vm.form.address_form.address{{$index}}_phone.$error.required">This field is required.</p></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label for="field_address{{$index}}_city">City</label><input type="text" class="form-control" id="field_address{{$index}}_city" name="address{{$index}}_city" ng-model="address.city" required><div ng-show="vm.form.address_form.address{{$index}}_city.$invalid"><p class="help-block" ng-show="vm.form.address_form.address{{$index}}_city.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">State</label><select class="form-control" id="address{{$index}}_country_state" name="address{{$index}}_country_state" ng-model="address.countryState" ng-options="state as state.state for state in vm.countrystates track by state.id" required><option value=""></option></select><div ng-show="vm.form.address_form.address{{$index}}_country_state.$invalid"><p class="help-block" ng-show="vm.form.address_form.address{{$index}}_country_state.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_address{{$index}}_zipCode">Zip Code</label><input type="text" class="form-control" name="address{{$index}}_zipCode" id="field_address{{$index}}_zipCode" ng-model="address.zipCode" ui-mask="99999" required><div ng-show="vm.form.address_form.address{{$index}}_zipCode.$invalid"><p class="help-block" ng-show="vm.form.address_form.address{{$index}}_zipCode.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_address{{$index}}_notes">Notes</label><input type="text" class="form-control" name="address{{$index}}_notes" id="field_address{{$index}}_notes" ng-model="address.notes"></div></div></div></div><div class="box-footer" ng-show="vm.patient.addresses[1] == null"><button type="button" class="btn btn-info" ng-click="vm.addAddress(1)" ng-show="vm.patient.addresses.length == 1">Add Secondary Address</button></div></div></form>');
$templateCache.put('app/entities/patient/tpl/form/patient-care-team-tpl.html','<form name="vm.form.care_form" role="form" show-validation><div class="row" ng-show="vm.editingCareTeamMember"><div class="col-lg-2"><div class="form-group"><label for="field_care_form_careTeamSpecialty">Care Team Specialty</label><select class="form-control" id="field_care_form_careTeamSpecialty" name="care_form_careTeamSpecialty" ng-model="vm.careTeamMember.careTeamSpecialty" ng-options="careTeamSpecialty as careTeamSpecialty.name for careTeamSpecialty in vm.careteamspecialties track by careTeamSpecialty.id" required><option value=""></option></select><div ng-show="vm.form.care_form.care_form_careTeamSpecialty.$invalid"><p class="help-block" ng-show="vm.form.care_form.care_form_careTeamSpecialty.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_care_form_lastName">Last Name</label><input type="text" class="form-control" name="care_form_lastName" id="field_care_form_lastName" ng-model="vm.careTeamMember.lastName" required><div ng-show="vm.form.care_form.care_form_lastName.$invalid"><p class="help-block" ng-show="vm.form.care_form.care_form_lastName.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_care_form_firstName">First Name</label><input type="text" class="form-control" name="care_form_firstName" id="field_care_form_firstName" ng-model="vm.careTeamMember.firstName" required><div ng-show="vm.form.care_form.care_form_firstName.$invalid"><p class="help-block" ng-show="vm.form.care_form.care_form_firstName.$error.required">This field is required.</p></div></div></div><div class="col-lg-2"><div class="form-group"><label class="control-label" for="field_care_form_phone">Phone</label><input type="text" class="form-control" name="care_form_phone" id="field_care_form_phone" ng-model="vm.careTeamMember.phone" ui-mask="(999) 999-9999" required><div ng-show="vm.form.care_form.care_form_phone.$invalid"><p class="help-block" ng-show="vm.form.care_form.care_form_phone.$error.required">This field is required.</p></div></div></div><div class="col-lg-2"><div class="form-group"><label class="control-label" for="field_care_form_email">Email</label><input type="email" class="form-control" name="care_form_email" id="field_care_form_email" ng-model="vm.careTeamMember.email" required><div ng-show="vm.form.care_form.care_form_email.$invalid"><p class="help-block" ng-show="vm.form.care_form.care_form_email.$error.required">This field is required.</p></div><div><p class="help-block" ng-show="vm.form.care_form.care_form_email.$error.email">Not valid email.</p></div></div></div></div><div class="pull-right"><button type="button" class="btn btn-danger" ng-show="vm.editingCareTeamMember" ng-click="vm.changeEditingCareTeamState()">Cancel</button> <button type="submit" class="btn btn-success" ng-show="vm.editingCareTeamMember" ng-disabled="vm.form.care_form.$invalid" ng-click="vm.saveCareTeamMember()">Save</button></div></form>');
$templateCache.put('app/entities/patient/tpl/form/patient-clinic-info-tpl.html','<form name="vm.form.clinic_info_form" role="form" show-validation bind-validity="vm.tab3"><div class="box-body"><div class="row"><div class="col-lg-3"><div class="form-group"><label for="field_physician">Physician</label><div class="input-group"><span class="input-group-addon">Dr.</span><select class="form-control" id="field_physician" name="physician" ng-model="vm.patient.employee" ng-options="physician as (physician.name + \' \' + physician.lastName) for physician in vm.physicians track by physician.id"><option value=""></option></select></div></div><div class="form-group"><label for="field_patientType">Patient Type</label><select class="form-control" id="field_patientType" name="patientType" ng-model="vm.patient.patientType" ng-options="patientType as patientType.name for patientType in vm.patienttypes track by patientType.id"><option value=""></option></select></div><div class="form-group"><label class="control-label">Ever had a kidney transplant?</label><br><toggle ng-model="vm.patient.kidneyTransplant" on="Yes" off="No" id="field_kidneyTransplant" ng-disabled="!vm.editing"></toggle></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_fDayDialysis">First Day of Dialysis</label><div class="input-group"><input id="field_fDayDialysis" type="text" class="form-control" name="fDayDialysis" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.patient.fDayDialysis" is-open="vm.datePickerOpenStatus.fDayDialysis"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fDayDialysis\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><div class="form-group"><label for="field_modality">Modality</label><select class="form-control" id="field_modality" name="modality" ng-model="vm.patient.modality" ng-options="modality as modality.name for modality in vm.modalities track by modality.id"><option value=""></option></select></div></div><div class="form-group"><label class="control-label">Primary Renal Failure</label><ui-select ng-model="vm.patient.primaryRenalFailure" name="primaryRenalFailure" id="field_primaryRenalFailure" ng-disabled="!vm.editing" reset-search-input="false" ng-required="true" title="Primary Renal Failure"><ui-select-match placeholder="Select ICD 10...">{{$select.selected.icd10Code + \' - \' +\n                            $select.selected.description}} </ui-select-match><ui-select-choices repeat="diagnoses in vm.diagnoses" refresh="vm.getDiagnoses($select.search)" refresh-delay="0"><div ng-bind-html="(diagnoses.icd10Code +  \' - \' + diagnoses.description) | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="vm.form.clinic_info_form.primaryRenalFailure.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.primaryRenalFailure.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_clinicAdmission">Clinic Admission</label><div class="input-group"><input id="field_clinicAdmission" type="text" class="form-control" name="clinicAdmission" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.patient.clinicAdmission" is-open="vm.datePickerOpenStatus.clinicAdmission"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'clinicAdmission\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="field_patientTemplate">Patient Template</label><select class="form-control" id="field_patientTemplate" name="patientTemplate" ng-model="vm.patient.patientTemplate" ng-options="patientTemplate as patientTemplate.name for patientTemplate in vm.patienttemplates track by patientTemplate.id"><option value=""></option></select></div><div class="form-group"><label class="control-label">Secondary Renal Failure</label><ui-select ng-model="vm.patient.secondaryRenalFailure" name="secondaryRenalFailure" id="field_secondaryRenalFailure" ng-disabled="!vm.editing" reset-search-input="false" append-to-body="true" title="Secondary Renal Failure"><ui-select-match placeholder="Select ICD 10...">{{$select.selected.icd10Code + \' - \' +\n                            $select.selected.description}} </ui-select-match><ui-select-choices repeat="diagnoses in vm.diagnoses" refresh="vm.getDiagnoses($select.search)" refresh-delay="0"><div ng-bind-html="(diagnoses.icd10Code +  \' - \' + diagnoses.description) | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">Active</label><br><toggle ng-model="vm.patient.status" on="Yes" off="No" id="field_status" ng-disabled="!vm.editing" ng-change="vm.deactivate()"></toggle></div><div class="form-group"><label for="field_modality">Dialysis Modality</label><select class="form-control" id="field_dialysis_modality" name="dialysis_modality" required ng-model="vm.patient.dialysisModality"><option value="HEMO_DIALYSIS">HEMO DIALYSIS</option><option value="PERITONEAL_DIALYSIS">PERITONEAL DIALYSIS</option></select><div ng-show="vm.form.clinic_info_form.dialysis_modality.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.dialysis_modality.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label">Treatment Days</label><ui-select id="field_treatmentDays" name="treatmentDays" multiple="multiple" ng-model="vm.patient.treatmentDays2" close-on-select="false" title="Treatment Days" required ng-disabled="!vm.editing"><ui-select-match placeholder="Select Treatment Days...">{{$item}}</ui-select-match><ui-select-choices repeat="day in vm.days2 | filter:$select.search"> {{day}} </ui-select-choices></ui-select><div ng-show="vm.form.clinic_info_form.treatmentDays.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.treatmentDays.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_shift">Shift</label><input type="text" class="form-control" name="shift" id="field_shift" ng-model="vm.patient.shift" ui-mask="9"></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">Draw Days</label><ui-select id="field_draw_days" name="drawDays" multiple="multiple" ng-model="vm.patient.drawDays2" close-on-select="false" title="Treatment Days" required ng-disabled="!vm.editing"><ui-select-match placeholder="Select Draw Days...">{{$item}}</ui-select-match><ui-select-choices repeat="day in vm.days | filter:$select.search"> {{day}} </ui-select-choices></ui-select><div ng-show="vm.form.clinic_info_form.drawDays.$invalid"><p class="help-block" ng-show="vm.form.clinic_info_form.drawDays.$error.required">This field is required.</p></div></div></div></div></div></form>');
$templateCache.put('app/entities/patient/tpl/form/patient-detail-action-buttons-tpl.html','<div class="btn-group" uib-dropdown><button type="button" class="btn btn-default" ui-sref="hospitalization({id: vm.patient.id})" ng-show="!vm.editing">Hospitalizations</button> <button type="button" class="btn btn-default dropdown-toggle" uib-dropdown-toggle ng-disabled="disabled" data-toggle="dropdown" aria-expanded="false"><span class="caret"></span> <span class="sr-only">Actions</span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu"><li><a ui-sref="infection({id: vm.patient.id})">Infections</a></li><li><a ui-sref="patient-order-current({id: vm.patient.id})">Orders - Current</a></li><li><a ui-sref="patient-order-history({id: vm.patient.id})">Orders - History</a></li><li><a ui-sref="patient-result({id: vm.patient.id})">Results</a></li></ul></div>');
$templateCache.put('app/entities/patient/tpl/form/patient-info-tpl.html','<form name="vm.form.patient_info_form" role="form" show-validation bind-validity="vm.tab0"><div class="box-body"><div class="col-lg-3"><a ng-if="!vm.patient.id" ui-sref="patient-picture-new({patient: vm.patient})"><img data-ng-src="{{\'data:\' + vm.patient.patientPicture.pictureContentType + \';base64,\' + vm.patient.patientPicture.picture}}" class="img-responsive"> </a><a ng-if="vm.patient.id && vm.editing" ui-sref="patient-picture-edit({id: vm.patient.id})"><img data-ng-src="{{\'data:\' + vm.patient.patientPicture.pictureContentType + \';base64,\' + vm.patient.patientPicture.picture}}" class="img-responsive"> </a><a ng-if="vm.patient.id && !vm.editing"><img data-ng-src="{{\'data:\' + vm.patient.patientPicture.pictureContentType + \';base64,\' + vm.patient.patientPicture.picture}}" class="img-responsive"></a></div><div class="col-lg-9"><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.patient.lastName" required><div ng-show="vm.form.patient_info_form.lastName.$invalid"><p class="help-block" ng-show="vm.form.patient_info_form.lastName.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.patient.firstName" required><div ng-show="vm.form.patient_info_form.firstName.$invalid"><p class="help-block" ng-show="vm.form.patient_info_form.firstName.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_middleInitial">Middle Initial</label><input type="text" class="form-control" name="middleInitial" id="field_middleInitial" ng-model="vm.patient.middleInitial" ng-maxlength="1" ui-mask="A"><div ng-show="vm.form.patient_info_form.middleInitial.$invalid"><p class="help-block" ng-show="vm.form.patient_info_form.middleInitial.$error.maxlength">This field cannot be longer than 1 characters.</p></div></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_mrn">MRN</label><input type="text" class="form-control" name="mrn" id="field_mrn" readonly="readonly" ng-model="vm.patient.mrn"><div ng-show="vm.form.patient_info_form.mrn.$invalid"><p class="help-block" ng-show="vm.form.patient_info_form.mrn.$error.required">This field is required.</p></div></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_ssn">SSN</label><input type="text" class="form-control" name="ssn" id="field_ssn" ng-model="vm.patient.ssn" ui-mask="999-99-9999"></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_dob">Dob</label><div class="input-group"><input id="field_dob" type="text" class="form-control" name="dob" uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.patient.dob" is-open="vm.datePickerOpenStatus.dob" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dob\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.patient_info_form.dob.$invalid"><p class="help-block" ng-show="vm.form.patient_info_form.dob.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label for="field_language">Language</label><select class="form-control" id="field_language" name="language" ng-model="vm.patient.language" ng-options="language as language.name for language in vm.languages track by language.id"><option value=""></option></select></div></div><div class="col-lg-4"><div class="form-group"><label for="field_race">Race</label><select class="form-control" id="field_race" name="race" ng-model="vm.patient.race" ng-options="race as race.name for race in vm.races track by race.id"><option value=""></option></select></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_gender">Gender</label><select class="form-control" name="gender" ng-model="vm.patient.gender" id="field_gender" required><option value="MALE">MALE</option><option value="FEMALE">FEMALE</option></select><div ng-show="vm.form.patient_info_form.gender.$invalid"><p class="help-block" ng-show="vm.form.patient_info_form.gender.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_maritalStatus">Marital Status</label><select class="form-control" name="maritalStatus" ng-model="vm.patient.maritalStatus" id="field_maritalStatus"><option value="MARRIED">MARRIED</option><option value="SINGLE">SINGLE</option><option value="DIVORCED">DIVORCED</option><option value="WIDOWED">WIDOWED</option></select></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label">Height</label><input type="number" ng-model="vm.patient.height" id="field_height" class="form-control" name="height"></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label">Diabetic</label><br><toggle ng-model="vm.patient.diabetic" on="Yes" off="No" id="field_diabetic" ng-disabled="!vm.editing"></toggle></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_external_mrn">External MRN</label><input type="text" class="form-control" name="mrn" id="field_external_mrn" ng-model="vm.patient.externalMrn"></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_external_billing_id">External Billing ID</label><input type="text" class="form-control" name="mrn" id="field_external_billing_id" ng-model="vm.patient.externalBillingId"></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.patient.phone"><div ng-show="vm.form.patient_info_form.phone.$invalid"><p class="help-block" ng-show="vm.form.patient_info_form.phone.$error.required">This field is required.</p></div></div></div></div></div><!--</div>--><!--<div class="row">--><!--<div class="col-lg-3">--><!--<div class="form-group" ng-show="vm.patient.id">--><!--<label for="id">ID</label>--><!--<input type="text" class="form-control" id="id" name="id"--><!--ng-model="vm.patient.id" readonly />--><!--</div>--><!--</div>--><!--</div>--></div></form>');
$templateCache.put('app/entities/patient/tpl/form/patient-insurance-tpl.html','<button type="button" class="btn btn-info" ng-click="vm.addInsurance()" ng-show="vm.patient.insurances.length == 0">Add Primary Insurance</button><form name="vm.form.insurance_form" role="form" show-validation bind-validity="vm.tab2"><div ng-repeat="insurance in vm.patient.insurances"><div class="box-header with-border"><h3 ng-if="$even" class="box-title">Primary Insurance</h3><h3 ng-if="$odd" class="box-title">Secondary Insurance</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" ng-show="$even && vm.patient.insurances.length > 1" ng-click="vm.swapInsurances()"><i class="fa fa-refresh fa-spin fa-fw"></i></button> <button type="button" class="btn btn-box-tool" ng-show="$even" ng-click="vm.deleteInsurance(0)"><i class="fa fa-times"></i></button> <button type="button" class="btn btn-box-tool" ng-show="$odd" ng-click="vm.deleteInsurance(1)"><i class="fa fa-times"></i></button></div></div><div class="box-body"><div class="row"><div class="col-lg-3"><label class="control-label" for="field_insurance{{$index}}_lastName">Last Name</label><div class="input-group"><input type="text" class="form-control" name="insurance{{$index}}_lastName" id="field_insurance{{$index}}_lastName" ng-model="insurance.lastName" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="insurance.lastName = vm.patient.lastName"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.insurance_form.insurance{{$index}}_lastName.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_lastName.$error.required">This field is required.</p></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_insurance{{$index}}_firstName">First Name</label><div class="input-group"><input type="text" class="form-control" name="insurance{{$index}}_firstName" id="field_insurance{{$index}}_firstName" ng-model="insurance.firstName" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="insurance.firstName = vm.patient.firstName"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.insurance_form.insurance{{$index}}_firstName.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_firstName.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">Middle Initial</label><div class="input-group"><input type="text" class="form-control" name="insurance{{$index}}_middleInitial" id="field_insurance{{$index}}_middleInitial" ng-model="insurance.middleInitial" ng-maxlength="1" ui-mask="A"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="insurance.middleInitial = vm.patient.middleInitial"><i class="glyphicon glyphicon-copy"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_insurance{{$index}}_gender">Gender</label><div class="input-group"><select class="form-control" name="insurance{{$index}}_gender" ng-model="insurance.gender" id="field_insurance{{$index}}_gender" required><option value="MALE">MALE</option><option value="FEMALE">FEMALE</option></select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="insurance.gender = vm.patient.gender"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.insurance_form.insurance{{$index}}_gender.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_gender.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_insurance{{$index}}_dob">Dob</label><div class="input-group"><input id="field_insurance{{$index}}_dob" type="text" class="form-control" name="insurance{{$index}}_dob" uib-datepicker-popup="MM/dd/yyyy" ng-model="insurance.dob" is-open="vm.datePickerOpenStatus.insuranceDob[$index]" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openInsuranceCalendar($index)"><i class="glyphicon glyphicon-calendar"></i></button> <button type="button" class="btn btn-default" ng-click="insurance.dob = vm.patient.dob"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.insurance_form.insurance{{$index}}_dob.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_dob.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_insurance{{$index}}_phone">Phone</label><div class="input-group"><input type="text" class="form-control" name="insurance{{$index}}_phone" id="field_insurance{{$index}}_phone" ng-model="insurance.phone" required ui-mask="(999) 999-9999" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="insurance.phone = vm.patient.addresses[0].phone"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.insurance_form.insurance{{$index}}_phone.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_phone.$error.required">This field is required.</p></div></div></div></div><div class="box-footer"><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_insurance{{$index}}_address">Address</label><div class="input-group"><input type="text" class="form-control" name="insurance{{$index}}_address" id="field_insurance{{$index}}_address" ng-model="insurance.address" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="insurance.address = vm.patient.addresses[0].address1"><i class="glyphicon glyphicon-copy" title="asda"></i></button></span></div><div ng-show="vm.form.insurance_form.insurance{{$index}}_address.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_address.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">Address 2</label><div class="input-group"><input type="text" class="form-control" name="insurance{{$index}}_address2" id="field_insurance{{$index}}_address2" ng-model="insurance.address2"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="insurance.address2 = vm.patient.addresses[0].address2"><i class="glyphicon glyphicon-copy"></i></button></span></div></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label for="field_insurance{{$index}}_city">City</label><div class="input-group"><input type="text" class="form-control" id="field_insurance{{$index}}_city" name="insurance{{$index}}_city" ng-model="insurance.city" required><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="insurance.city = vm.patient.addresses[0].city"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.insurance_form.insurance{{$index}}_city.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_city.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label">State</label><div class="input-group"><select class="form-control" id="field_insurance{{$index}}_state" name="insurance{{$index}}_state" ng-model="insurance.state" ng-options="state as state.state for state in vm.countrystates track by state.id" required><option value=""></option></select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="insurance.state = vm.patient.addresses[0].countryState"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.insurance_form.insurance{{$index}}_state.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_state.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_insurance{{$index}}_zipCode">Zip Code</label><div class="input-group"><input type="text" class="form-control" name="insurance{{$index}}_zipCode" id="field_insurance{{$index}}_zipCode" ng-model="insurance.zipCode" ui-mask="99999" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="insurance.zipCode = vm.patient.addresses[0].zipCode"><i class="glyphicon glyphicon-copy"></i></button></span></div><div ng-show="vm.form.insurance_form.insurance{{$index}}_zipCode.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_zipCode.$error.required">This field is required.</p></div></div></div></div></div><div class="box-footer"><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label">Insurance Carrier</label><ui-select ng-model="insurance.insuranceCarrier" name="insurance{{$index}}_carrier" id="field_insurance{{$index}}_carrier" reset-search-input="false" ng-required="true" title="Insurance Carrier"><ui-select-match placeholder="Enter an insurance carrier...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="carrier in vm.carriers" refresh="vm.getInsuranceCarrier($select.search)" refresh-delay="0"><div ng-bind-html="carrier.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="vm.form.insurance_form.insurance{{$index}}_carrier.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_carrier.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_insurance{{$index}}_policyNumber">Policy Number</label><input type="text" class="form-control" name="insurance{{$index}}_policyNumber" id="field_insurance{{$index}}_policyNumber" ng-model="insurance.policyNumber"></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_insurance{{$index}}_planNumber">Plan Number</label><input type="text" class="form-control" name="planNumber" id="field_insurance{{$index}}_planNumber" ng-model="insurance.planNumber"></div></div></div><div class="row"><div class="col-md-3"><div class="form-group"><label for="field_insurance{{$index}}_insuranceLevel">Insurance Level</label><select class="form-control" id="field_insurance{{$index}}_insuranceLevel" name="insurance{{$index}}_insuranceLevel" ng-model="insurance.insuranceLevel" ng-options="insuranceLevel as insuranceLevel.name for insuranceLevel in vm.insurancelevels track by insuranceLevel.id"><option value=""></option></select></div></div><div class="col-md-3"><div class="form-group"><label for="field_insurance{{$index}}_insuranceRelation">Insurance Relation</label><select class="form-control" id="field_insurance{{$index}}_insuranceRelation" name="insurance{{$index}}_insuranceRelation" required ng-model="insurance.insuranceRelation" ng-options="insuranceRelation as insuranceRelation.name for insuranceRelation in vm.insurancerelations track by insuranceRelation.id"><option value=""></option></select><div ng-show="vm.form.insurance_form.insurance{{$index}}_insuranceRelation.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_insuranceRelation.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label for="field_insurance{{$index}}_insuranceType">Insurance Type</label><select class="form-control" id="field_insurance{{$index}}_insuranceType" name="insurance{{$index}}_insuranceType" ng-model="insurance.insuranceType" ng-options="insuranceType as insuranceType.name for insuranceType in vm.insurancestypes track by insuranceType.id"><option value=""></option></select></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_insurance{{$index}}_groupNumber">Group Number</label><input type="text" class="form-control" name="insurance{{$index}}_groupNumber" id="field_insurance{{$index}}_groupNumber" required ng-model="insurance.groupNumber"><div ng-show="vm.form.insurance_form.insurance{{$index}}_groupNumber.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_groupNumber.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_insurance{{$index}}_groupName">Group Name</label><input type="text" class="form-control" name="insurance{{$index}}_groupName" id="field_insurance{{$index}}_groupName" required ng-model="insurance.groupName"><div ng-show="vm.form.insurance_form.insurance{{$index}}_groupName.$invalid"><p class="help-block" ng-show="vm.form.insurance_form.insurance{{$index}}_groupName.$error.required">This field is required.</p></div></div></div><div class="col-md-3"><div class="form-group"><label class="control-label" for="field_insurance{{$index}}_employer">Employer</label><input type="text" class="form-control" name="employer" id="field_insurance{{$index}}_employer" ng-model="insurance.employer"></div></div></div></div></div><div class="box-footer" ng-show="vm.patient.insurances.length == 1"><button type="button" class="btn btn-info" ng-click="vm.addInsurance()">Add Secondary Insurance</button></div></div></form>');
$templateCache.put('app/entities/patient-order/tpl/new/patient-order-form-tpl.html','<form name="vm.form.order" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-3"><div class="form-group"><label>Patient Name</label><input type="text" class="form-control" readonly="readonly" value="{{vm.patientOrder.patient.firstName + \' \' +\n                           (vm.patientOrder.patient.middleInitial ? vm.patientOrder.patient.middleInitial : \'\') + \' \' +\n                           vm.patientOrder.patient.lastName}}"></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_orderType">Order Type</label><select class="form-control" name="orderType" ng-model="vm.patientOrder.orderType" ng-disabled="vm.patientOrder.patientOrderTests.length > 0" id="field_orderType" ng-change="vm.changeOrderType()"><option value="ONE_TIME">ONE_TIME</option><option value="STANDING" ng-show="!vm.hasStanding">STANDING</option><option value="RECURRING">RECURRING</option></select></div></div><div class="col-lg-3"><div class="form-group"><label for="field_via">Obtained</label><select class="form-control" id="field_via" name="via" ng-model="vm.patientOrder.via" required ng-options="via as via.name for via in vm.vias track by via.id"><option value=""></option></select><div ng-show="vm.form.order.via.$invalid"><p class="help-block" ng-show="vm.form.order.via.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label for="field_employee">Physician</label><select class="form-control" id="field_employee" name="employee" ng-model="vm.patientOrder.signedBy" required ng-disabled="vm.patientOrder.signed" ng-options="employee as employee.name + \' \' + employee.lastName for employee in vm.employees track by employee.id"><option value=""></option></select><div ng-show="vm.form.order.employee.$invalid"><p class="help-block" ng-show="vm.form.order.employee.$error.required">This field is required.</p></div></div></div></div><div class="pull-left"><button type="button" class="btn btn-primary" ng-click="vm.addPatientOrderTest()">Add Test</button></div><div class="pull-right"><button type="button" class="btn btn-danger" ui-sref="patient-order-current({id: vm.patient.id})">Cancel</button> <button type="button" class="btn btn-success" ng-disabled="vm.form.order.$invalid || vm.patientOrder.patientOrderTests.length == 0 || vm.isSaving == true" ng-click="vm.save()">Save</button></div></div></form>');
$templateCache.put('app/entities/patient-order/tpl/update/patient-order-form-tpl.html','<form name="vm.form.order" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-3"><div class="form-group"><label>Patient Name</label><input type="text" class="form-control" readonly="readonly" value="{{vm.patientOrder.patient.firstName + \' \' +\n                           (vm.patientOrder.patient.middleInitial ? vm.patientOrder.patient.middleInitial : \'\') + \' \' +\n                           vm.patientOrder.patient.lastName}}"></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_orderType">Order Type</label><select class="form-control" name="orderType" ng-model="vm.patientOrder.orderType" id="field_orderType" ng-change="vm.changeOrderType()" ng-disabled="true"><option value="ONE_TIME">ONE_TIME</option><option value="STANDING">STANDING</option><option value="RECURRING">RECURRING</option></select></div></div><div class="col-lg-3"><div class="form-group"><label for="field_via">Obtained</label><select class="form-control" id="field_via" name="via" ng-model="vm.patientOrder.via" required ng-disabled="true" ng-options="via as via.name for via in vm.vias track by via.id"><option value=""></option></select><div ng-show="vm.form.order.via.$invalid"><p class="help-block" ng-show="vm.form.order.via.$error.required">This field is required.</p></div></div></div><div class="col-lg-3"><div class="form-group"><label for="field_employee">Physician</label><select class="form-control" id="field_employee" name="employee" ng-model="vm.patientOrder.signedBy" required ng-disabled="true" ng-options="employee as employee.name + \' \' + employee.lastName for employee in vm.employees track by employee.id"><option value=""></option></select><div ng-show="vm.form.order.employee.$invalid"><p class="help-block" ng-show="vm.form.order.employee.$error.required">This field is required.</p></div></div></div></div><div class="pull-left" ng-show="vm.canCancel"><button type="button" class="btn btn-warning" ui-sref="patient-order-update.cancel({oid: vm.patientOrder.id})">Cancel Order</button></div><div class="pull-right"><button type="button" ng-show="vm.canSign" class="btn btn-warning" ng-click="vm.signIn()"><span class="glyphicon glyphicon-pencil"></span> <span>Sign Order</span></button> <button type="button" ng-show="vm.canFinish" class="btn btn-danger" ui-sref="patient-order-update.finish({oid: vm.patientOrder.id})">Finish Order</button></div></div></form>');
$templateCache.put('app/entities/patient-order/tpl/update/patient-order-signed-tpl.html','<form name="vm.form.order" role="form" show-validation><table class="table table-condensed table-striped table-bordered"><tbody><tr><th>Patient Name</th><th>Order Type</th><th>Obtained</th><th>Physician</th><th ng-if="vm.patientOrder.patientOrderTpl">Template</th></tr><tr><td>{{vm.patientOrder.patient.firstName + \' \' +\n                (vm.patientOrder.patient.middleInitial ? vm.patientOrder.patient.middleInitial : \'\') + \' \' +\n                vm.patientOrder.patient.lastName}}</td><td>{{vm.patientOrder.orderType}} </td><td>{{vm.patientOrder.via.name}}</td><td>{{vm.patientOrder.signedBy ? vm.patientOrder.signedBy.name + \' \' + vm.patientOrder.signedBy.lastName : ""}}</td><td ng-if="vm.patientOrder.patientOrderTpl">#{{vm.patientOrder.patientOrderTpl.id}} - {{vm.patientOrder.patientOrderTpl.description}}</td></tr></tbody></table><div class="pull-left" ng-show="vm.canCancel"><button type="button" class="btn btn-danger" ui-sref="patient-order-update.cancel({oid: vm.patientOrder.id})">Cancel Order</button></div><div class="pull-right"><button type="button" ng-show="vm.canSign" class="btn btn-warning" ng-click="vm.signIn()"><span class="glyphicon glyphicon-pencil"></span> <span>Sign Order</span></button> <button type="button" ng-show="vm.canFinish" class="btn btn-danger" ui-sref="patient-order-update.finish({oid: vm.patientOrder.id})">Finish Order</button></div></form>');
$templateCache.put('app/entities/rpt-template/wizard/admin-dialog/rpt-template-admin-compendium-list-tpl.html','<h3 class="text-center wz-top-margin mb-30"><strong>Test List</strong></h3><form name="vm.form.compendium" role="form" novalidate><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="field_compendiums">Test Codes:</label><ui-select id="field_compendiums" name="compendiums" multiple="multiple" ng-model="vm.rptTemplate.compendiums" title="Compendium" required><ui-select-match placeholder="Select Test...">{{$item.code + \' - \' + $item.description}}</ui-select-match><ui-select-choices repeat="compendium in vm.compendiums  | propsFilter: {code: $select.search, description: $select.search}"><div ng-bind-html="compendium.code"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select><div ng-show="vm.form.compendium.compendiums.$invalid"><p class="help-block" ng-show="vm.form.compendium.compendiums.$error.required">This field is required.</p></div></div></div></form>');
$templateCache.put('app/entities/rpt-template/wizard/admin-dialog/rpt-template-admin-form-tpl.html','<form name="vm.form.main" role="form" novalidate><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rptTemplate.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rptTemplate.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.rptTemplate.name" required><div ng-show="vm.form.main.name.$invalid"><p class="help-block" ng-show="vm.form.main.name.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.rptTemplate.description"></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_type">Type</label><select class="form-control" name="type" ng-model="vm.rptTemplate.type" id="field_type" required><option value="GRID">GRID</option><option value="REPORT_CARD">REPORT CARD</option><!--<option value="ADVANCED">ADVANCED</option>--><option value="AVERAGE">AVERAGE</option><option value="GRAPH">GRAPH</option><option value="CUMULATIVE">CUMULATIVE</option><option value="VACCINATION">VACCINATION</option><option value="ENV_GRID">ENVIRONMENTAL GRID</option><option value="ENV_REFERENCE_RANGE">ENVIRONMENTAL REFERENCE RANGE</option><option value="ENV_AVERAGE">ENVIRONMENTAL AVERAGE</option></select><div ng-show="vm.form.main.type.$invalid"><p class="help-block" ng-show="vm.form.main.type.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_orientation">Orientation</label><select class="form-control" name="orientation" ng-model="vm.rptTemplate.orientation" id="field_orientation" required><option value="PORTRAIT">PORTRAIT</option><option value="LANDSCAPE">LANDSCAPE</option></select><div ng-show="vm.form.main.orientation.$invalid"><p class="help-block" ng-show="vm.form.main.orientation.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label">Active</label><br><toggle ng-model="vm.rptTemplate.active" on="Yes" off="No" id="field_active"></toggle></div></div><div class="col-lg-3"><div class="form-group"><label class="control-label" for="field_patientStatus">Patient/Machine Status</label><select class="form-control" ng-model="vm.rptTemplate.patientStatus" id="field_patientStatus" name="patientStatus" ng-options="(item == null ? \'\' : item  ? \'Active\' : \'Inactive\') for item in [null, true, false]"></select></div></div><div class="col-lg-6"><div class="form-group" ng-if="vm.rptTemplate.type == \'REPORT_CARD\'"><label for="field_rptLanguage">Language</label><ui-select ng-model="vm.rptTemplate.rptLanguage" close-on-select="true" title="Language" id="field_rptLanguage" ng-required="true" name="rptLanguage"><ui-select-match allow-clear="true" placeholder="Select language..."> {{$select.selected.name}} </ui-select-match><ui-select-choices repeat="rptLanguage in vm.rptLanguages | filter: $select.search"><div ng-bind-html="rptLanguage.name"></div></ui-select-choices></ui-select><div ng-show="vm.form.main.$invalid"><p class="help-block" ng-show="vm.form.main.rptLanguage.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_modality">Modality</label><ui-select id="field_modality" name="modality" ng-model="vm.rptTemplate.modality" title="Modality"><ui-select-match allow-clear="true" placeholder="Select Modality...">{{$select.selected.replace(\'_\', \' \')}}</ui-select-match><ui-select-choices repeat="modality in vm.modalities"><div ng-bind-html="modality.replace(\'_\', \' \')"></div></ui-select-choices></ui-select></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_shift">Shift</label><input type="number" class="form-control" name="shift" id="field_shift" min="1" max="3" ng-model="vm.rptTemplate.shift"> <span class="help-block" ng-show="vm.form.main.shift.$dirty && vm.form.main.shift.$invalid"><span ng-show="vm.form.main.shift.$error.min">Shift should be above 1</span> <span ng-show="vm.form.main.shift.$error.max">Shift should be below 3</span></span></div></div></div><div class="row"><div class="col-lg-6" ng-if="vm.rptTemplate.type != \'ENV_GRID\' && vm.rptTemplate.type != \'ENV_REFERENCE_RANGE\' && vm.rptTemplate.type != \'ENV_AVERAGE\'"><div class="form-group"><label class="control-label" for="field_diabetic">Diabetic</label><select class="form-control" ng-model="vm.rptTemplate.diabetic" id="field_diabetic" name="diabetic" ng-options="(item == null ? \'\' : item  ? \'Active\' : \'Inactive\') for item in [null, true, false]"></select></div></div><div class="col-lg-6"><div class="form-group"><label for="field_category">Category</label><select class="form-control" id="field_category" name="category" required ng-model="vm.rptTemplate.rptCategory" ng-options="rptCategory as ((rptCategory.clinic ? rptCategory.clinic.name + \' - \' : \'\') + rptCategory.name) for rptCategory in vm.rptCategories track by rptCategory.id"><option value=""></option></select><div ng-show="vm.form.main.category.$invalid"><p class="help-block" ng-show="vm.form.main.category.$error.required">This field is required.</p></div></div></div></div></form>');
$templateCache.put('app/entities/rpt-template/wizard/admin-dialog/rpt-template-admin-range-tpl.html','<h3 class="text-center wz-top-margin mb-30"><strong>Test Ranges</strong></h3><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="field_compendiums">Test Codes:</label><ui-select id="field_compendiums" name="compendiums" multiple="multiple" ng-model="vm.rptCompendiumRange.compendiums" title="Compendium" ng-required="true"><ui-select-match placeholder="Select Test...">{{$item.code + \' - \' + $item.description}}</ui-select-match><ui-select-choices repeat="compendium in vm.compendiums  | propsFilter: {code: $select.search, description: $select.search}"><div ng-bind-html="compendium.code"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><label for="aboveEq">Above:</label><input type="number" name="aboveEq" id="aboveEq" class="form-control" ng-model="vm.rptCompendiumRange.aboveEq"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><label for="belowEq">Below:</label><input type="number" name="belowEq" id="belowEq" class="form-control" ng-model="vm.rptCompendiumRange.belowEq"></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><button type="button" class="btn btn-warning" ng-click="vm.addRange()" ng-disabled="vm.rptCompendiumRange.compendiums.length == 0"><i class="fa fa-plus-circle" aria-hidden="true"></i> Generate</button></div></div><hr><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive"><form name="vm.form.compendiumRanges" role="form" novalidate><table class="table table-striped table-condensed"><thead><tr><th><strong>Test Code:</strong></th><th><strong>Above:</strong></th><th><strong>Below:</strong></th><th><strong></strong></th></tr></thead><tbody><tr ng-repeat="compendiumRange in vm.rptTemplate.rptCompendiumRanges"><td><div class="table-control"><ui-select ng-model="compendiumRange.compendium" close-on-select="true" title="Compendium" id="field_compendium{{$index}}" ng-required="true" name="compendium{{$index}}"><ui-select-match allow-clear="true" placeholder="Select compendium..."> {{$select.selected.code + \', \' + $select.selected.description}} </ui-select-match><ui-select-choices repeat="compendium in vm.compendiums | filter: $select.search"><div ng-bind-html=" compendium.code"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select><div ng-show="vm.form.compendiumRanges[\'compendium\' + $index].$invalid"><p class="help-block" ng-show="vm.form.compendiumRanges[\'compendium\' + $index].$error.required">This field is required.</p></div></div></td><td><div class="table-control"><input type="number" name="aboveEq{{$index}}" id="field_aboveEq{{$index}}" class="form-control" ng-model="compendiumRange.aboveEq"></div></td><td><div class="table-control"><input type="number" name="belowEq{{$index}}" id="field_belowEq{{$index}}" class="form-control" ng-model="compendiumRange.belowEq"></div></td><td><div class="table-control"><button type="button" class="btn btn-primary" ng-click="vm.cloneRange($index)"><i class="fa fa-copy" aria-hidden="true"></i></button> <button type="button" class="btn btn-danger" ng-click="vm.deleteRange($index)"><i class="fa fa-trash" aria-hidden="true"></i></button></div></td></tr></tbody></table></form></div></div></div>');
$templateCache.put('app/entities/rpt-template/wizard/admin-dialog/rpt-template-admin-vaccine-form-tpl.html','<form name="vm.form.vaccine" role="form" novalidate><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label">Vaccinated</label><br><toggle ng-model="vm.rptTemplate.vaccinated" on="Yes" off="No" id="field_active"></toggle></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label for="field_vaccines">Vaccines</label><ui-select id="field_vaccines" name="vaccines" multiple="multiple" ng-model="vm.rptTemplate.vaccines" title="Vaccines"><ui-select-match placeholder="Select Vaccine...">{{$item.name}}</ui-select-match><ui-select-choices repeat="vaccine in vm.vaccines  | propsFilter: {name: $select.search}"><div ng-bind-html="vaccine.name"></div></ui-select-choices></ui-select><div ng-show="vm.form.vaccine.vaccines.$invalid"><p class="help-block" ng-show="vm.form.vaccine.vaccines.$error.required">This field is required.</p></div></div></div></div></form>');
$templateCache.put('app/entities/rpt-template/wizard/report/rpt-template-advanced-report-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.rptTemplate.name}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard on-finish="vm.onFinishWizard()" on-cancel="vm.onCancelWizard()" indicators-position="top" hide-indicators="true"><wz-step wz-title="Dates and Patient"><ng-include src="\'app/entities/rpt-template/wizard/report/step/date-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Metadata">UNDER CONSTRUCTION<ng-include src="\'app/entities/rpt-template/wizard/report/step/metadata-form-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Test Ranges"><ng-include src="\'app/entities/rpt-template/wizard/report/step/compendium-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal" ng-click="vm.report()" ng-disabled="vm.form.main.$invalid || vm.form.compendiumRanges.$invalid || vm.form.patients.$invalid ||\n            vm.rptTemplate.rptCompendiumRanges.length == 0"><i class="fa fa-check-circle" aria-hidden="true"></i> Get Report</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/rpt-template/wizard/report/rpt-template-average-report-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.rptTemplate.name}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard on-finish="vm.onFinishWizard()" on-cancel="vm.onCancelWizard()" indicators-position="top" hide-indicators="true"><wz-step wz-title="Dates and Patient"><ng-include src="\'app/entities/rpt-template/wizard/report/step/date-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Metadata"><ng-include src="\'app/entities/rpt-template/wizard/report/step/metadata-form-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Test Ranges"><ng-include src="\'app/entities/rpt-template/wizard/report/step/compendium-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal" ng-click="vm.report()" ng-disabled="vm.form.main.$invalid || vm.form.compendiumRanges.$invalid || vm.form.dateRange.$invalid ||\n            vm.rptTemplate.rptCompendiumRanges.length == 0"><i class="fa fa-check-circle" aria-hidden="true"></i> Get Report</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/rpt-template/wizard/report/rpt-template-cumulative-report-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.rptTemplate.name}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard on-finish="vm.onFinishWizard()" on-cancel="vm.onCancelWizard()" indicators-position="top" hide-indicators="true"><wz-step wz-title="Dates and Patient"><ng-include src="\'app/entities/rpt-template/wizard/report/step/date-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Metadata"><ng-include src="\'app/entities/rpt-template/wizard/report/step/metadata-form-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal" ng-click="vm.report()" ng-disabled="vm.form.main.$invalid || vm.form.compendiumRanges.$invalid || vm.form.dateRange.$invalid ||\n            vm.rptTemplate.compendiumRanges.length == 0"><i class="fa fa-check-circle" aria-hidden="true"></i> Get Report</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/rpt-template/wizard/report/rpt-template-env-average-report-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.rptTemplate.name}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard on-finish="vm.onFinishWizard()" on-cancel="vm.onCancelWizard()" indicators-position="top" hide-indicators="true"><wz-step wz-title="Dates and Patient"><ng-include src="\'app/entities/rpt-template/wizard/report/step/date-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Metadata"><ng-include src="\'app/entities/rpt-template/wizard/report/step/metadata-env-form-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Test Ranges"><ng-include src="\'app/entities/rpt-template/wizard/report/step/compendium-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal" ng-click="vm.report()" ng-disabled="vm.form.main.$invalid || vm.form.compendiumRanges.$invalid || vm.form.dateRange.$invalid ||\n            vm.rptTemplate.rptCompendiumRanges.length == 0"><i class="fa fa-check-circle" aria-hidden="true"></i> Get Report</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/rpt-template/wizard/report/rpt-template-env-grid-report-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.rptTemplate.name}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard on-finish="vm.onFinishWizard()" on-cancel="vm.onCancelWizard()" indicators-position="top" hide-indicators="true"><wz-step wz-title="Dates and Patient"><ng-include src="\'app/entities/rpt-template/wizard/report/step/date-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Metadata"><ng-include src="\'app/entities/rpt-template/wizard/report/step/metadata-env-form-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Test Ranges"><ng-include src="\'app/entities/rpt-template/wizard/report/step/compendium-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal" ng-click="vm.report()" ng-disabled="vm.form.main.$invalid || vm.form.compendiumRanges.$invalid || vm.form.dateRange.$invalid ||\n            vm.rptTemplate.rptCompendiumRanges.length == 0"><i class="fa fa-check-circle" aria-hidden="true"></i> Get Report</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/rpt-template/wizard/report/rpt-template-env-reference-range-report-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.rptTemplate.name}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard on-finish="vm.onFinishWizard()" on-cancel="vm.onCancelWizard()" indicators-position="top" hide-indicators="true"><wz-step wz-title="Dates and Patient"><ng-include src="\'app/entities/rpt-template/wizard/report/step/date-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Metadata"><ng-include src="\'app/entities/rpt-template/wizard/report/step/metadata-env-form-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Test Ranges"><ng-include src="\'app/entities/rpt-template/wizard/report/step/compendium-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal" ng-click="vm.report()" ng-disabled="vm.form.main.$invalid || vm.form.compendiumRanges.$invalid || vm.form.dateRange.$invalid ||\n            vm.rptTemplate.rptCompendiumRanges.length == 0"><i class="fa fa-check-circle" aria-hidden="true"></i> Get Report</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/rpt-template/wizard/report/rpt-template-graph-report-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.rptTemplate.name}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard on-finish="vm.onFinishWizard()" on-cancel="vm.onCancelWizard()" indicators-position="top" hide-indicators="true"><wz-step wz-title="Dates and Patient"><ng-include src="\'app/entities/rpt-template/wizard/report/step/date-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Metadata"><ng-include src="\'app/entities/rpt-template/wizard/report/step/metadata-form-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Test List"><ng-include src="\'app/entities/rpt-template/wizard/report/step/compendium-list-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal" ng-click="vm.report()" ng-disabled="vm.form.main.$invalid || vm.form.compendium.$invalid || vm.form.dateRange.$invalid"><i class="fa fa-check-circle" aria-hidden="true"></i> Get Report</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/rpt-template/wizard/report/rpt-template-grid-report-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.rptTemplate.name}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard on-finish="vm.onFinishWizard()" on-cancel="vm.onCancelWizard()" indicators-position="top" hide-indicators="true"><wz-step wz-title="Dates and Patient"><ng-include src="\'app/entities/rpt-template/wizard/report/step/date-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Metadata"><ng-include src="\'app/entities/rpt-template/wizard/report/step/metadata-form-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Test Ranges"><ng-include src="\'app/entities/rpt-template/wizard/report/step/compendium-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal" ng-click="vm.report()" ng-disabled="vm.form.main.$invalid || vm.form.compendiumRanges.$invalid || vm.form.dateRange.$invalid ||\n            vm.rptTemplate.rptCompendiumRanges.length == 0"><i class="fa fa-check-circle" aria-hidden="true"></i> Get Report</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/rpt-template/wizard/report/rpt-template-report-card-report-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.rptTemplate.name}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard on-finish="vm.onFinishWizard()" on-cancel="vm.onCancelWizard()" indicators-position="top" hide-indicators="true"><wz-step wz-title="Dates and Patient"><ng-include src="\'app/entities/rpt-template/wizard/report/step/date-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Metadata"><ng-include src="\'app/entities/rpt-template/wizard/report/step/metadata-form-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Test Ranges"><ng-include src="\'app/entities/rpt-template/wizard/report/step/compendium-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal" ng-click="vm.report()" ng-disabled="vm.form.main.$invalid || vm.form.compendiumRanges.$invalid || vm.form.dateRange.$invalid ||\n            vm.rptTemplate.rptCompendiumRanges.length == 0"><i class="fa fa-check-circle" aria-hidden="true"></i> Get Report</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/rpt-template/wizard/report/rpt-template-vaccination-report-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.rptTemplate.name}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard on-finish="vm.onFinishWizard()" on-cancel="vm.onCancelWizard()" indicators-position="top" hide-indicators="true"><wz-step wz-title="Params"><ng-include src="\'app/entities/rpt-template/wizard/report/step/date-range-step-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Params"><ng-include src="\'app/entities/rpt-template/wizard/report/step/metadata-form-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/next-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Vaccines"><ng-include src="\'app/entities/rpt-template/wizard/report/step/vaccine-tpl.html\'"></ng-include><ng-include src="\'app/entities/rpt-template/wizard/report/step/previous-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal" ng-click="vm.report()" ng-disabled="vm.form.main.$invalid || vm.form.dateRange.$invalid ||\n            vm.rptTemplate.vaccines.length == 0"><i class="fa fa-check-circle" aria-hidden="true"></i> Get Report</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/rpt-template/wizard/report/step/compendium-list-tpl.html','<h3 class="text-center wz-top-margin mb-30"><strong>Test List</strong></h3><form name="vm.form.compendium" role="form" novalidate><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="field_compendiums">Test Codes:</label><ui-select id="field_compendiums" name="compendiums" multiple="multiple" ng-model="vm.rptTemplate.compendiums" title="Compendium" ng-required="true"><ui-select-match placeholder="Select Test...">{{$item.code + \' - \' + $item.description}}</ui-select-match><ui-select-choices repeat="compendium in vm.compendiums  | propsFilter: {code: $select.search, description: $select.search}"><div ng-bind-html="compendium.code"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select><div ng-show="vm.form.compendium.compendiums.$invalid"><p class="help-block" ng-show="vm.form.compendium.compendiums.$error.required">This field is required.</p></div></div></div></form>');
$templateCache.put('app/entities/rpt-template/wizard/report/step/compendium-range-step-tpl.html','<h3 class="text-center wz-top-margin mb-30"><strong>Test Ranges</strong></h3><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="compendiums">Test Codes:</label><ui-select id="field_compendiums" name="compendiums" multiple="multiple" ng-model="vm.rptCompendiumRange.compendiums" title="Compendium" ng-required="true"><ui-select-match placeholder="Select Test...">{{$item.code + \' - \' + $item.description}}</ui-select-match><ui-select-choices repeat="compendium in vm.compendiums  | propsFilter: {code: $select.search, description: $select.search}"><div ng-bind-html="compendium.code"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><label for="aboveEq">Above:</label><input type="number" name="aboveEq" id="aboveEq" class="form-control" ng-model="vm.rptCompendiumRange.aboveEq"></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 form-group"><label for="belowEq">Below:</label><input type="number" name="belowEq" id="belowEq" class="form-control" ng-model="vm.rptCompendiumRange.belowEq"></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><button type="button" class="btn btn-warning" ng-click="vm.addRange()" ng-disabled="vm.rptCompendiumRange.compendiums.length == 0"><i class="fa fa-plus-circle" aria-hidden="true"></i> Generate</button></div></div><hr><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive"><form name="vm.form.compendiumRanges" role="form" novalidate><table class="table table-striped table-condensed"><thead><tr><th><strong>Test Code:</strong></th><th><strong>Above:</strong></th><th><strong>Below:</strong></th><th><strong></strong></th></tr></thead><tbody><tr ng-repeat="compendiumRange in vm.rptTemplate.rptCompendiumRanges"><td><div class="table-control"><ui-select ng-model="compendiumRange.compendium" close-on-select="true" title="Compendium" id="field_compendium{{$index}}" ng-required="true" name="compendium{{$index}}"><ui-select-match allow-clear="true" placeholder="Select compendium..."> {{$select.selected.code + \', \' + $select.selected.description}} </ui-select-match><ui-select-choices repeat="compendium in vm.compendiums | filter: $select.search"><div ng-bind-html=" compendium.code"></div><small> {{compendium.description}} </small></ui-select-choices></ui-select><div ng-show="vm.form.compendiumRanges[\'compendium\' + $index].$invalid"><p class="help-block" ng-show="vm.form.compendiumRanges[\'compendium\' + $index].$error.required">This field is required.</p></div></div></td><td><div class="table-control"><input type="number" name="aboveEq{{$index}}" id="field_aboveEq{{$index}}" class="form-control" ng-model="compendiumRange.aboveEq"></div></td><td><div class="table-control"><input type="number" name="belowEq{{$index}}" id="field_belowEq{{$index}}" class="form-control" ng-model="compendiumRange.belowEq"></div></td><td><div class="table-control"><button type="button" class="btn btn-primary" ng-click="vm.cloneRange($index)"><i class="fa fa-copy" aria-hidden="true"></i></button> <button type="button" class="btn btn-danger" ng-click="vm.deleteRange($index)"><i class="fa fa-trash" aria-hidden="true"></i></button></div></td></tr></tbody></table></form></div></div></div>');
$templateCache.put('app/entities/rpt-template/wizard/report/step/date-range-step-tpl.html','<form name="vm.form.dateRange" role="form" novalidate><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" required uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.rptTemplate.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.dateRange.startDate.$invalid"><p class="help-block" ng-show="vm.form.dateRange.startDate.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_endDate">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" required uib-datepicker-popup="MM/dd/yyyy" ng-model="vm.rptTemplate.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="vm.form.dateRange.endDate.$invalid"><p class="help-block" ng-show="vm.form.dateRange.endDate.$error.required">This field is required.</p></div></div></div><div class="row"><div class="col-lg-12"><div class="table-responsive"><table class="table table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div></div></form>');
$templateCache.put('app/entities/rpt-template/wizard/report/step/metadata-env-form-tpl.html','<form name="vm.form.main" role="form" novalidate><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.rptTemplate.name" required><div ng-show="vm.form.main.name.$invalid"><p class="help-block" ng-show="vm.form.main.name.$error.required">This field is required.</p></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_orientation">Orientation</label><select class="form-control" name="orientation" ng-model="vm.rptTemplate.orientation" id="field_orientation" required><option value="PORTRAIT">PORTRAIT</option><option value="LANDSCAPE">LANDSCAPE</option></select><div ng-show="vm.form.main.orientation.$invalid"><p class="help-block" ng-show="vm.form.main.orientation.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_patientStatus">Machine Status</label><select class="form-control" ng-model="vm.rptTemplate.patientStatus" id="field_patientStatus" name="patientStatus" ng-options="(item == null ? \'\' : item  ? \'Active\' : \'Inactive\') for item in [null, true, false]"></select></div></div></div></form>');
$templateCache.put('app/entities/rpt-template/wizard/report/step/metadata-form-tpl.html','<form name="vm.form.main" role="form" novalidate><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.rptTemplate.name" required><div ng-show="vm.form.main.name.$invalid"><p class="help-block" ng-show="vm.form.main.name.$error.required">This field is required.</p></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_orientation">Orientation</label><select class="form-control" name="orientation" ng-model="vm.rptTemplate.orientation" id="field_orientation" required><option value="PORTRAIT">PORTRAIT</option><option value="LANDSCAPE">LANDSCAPE</option></select><div ng-show="vm.form.main.orientation.$invalid"><p class="help-block" ng-show="vm.form.main.orientation.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_patientStatus">Patient Status</label><select class="form-control" ng-model="vm.rptTemplate.patientStatus" id="field_patientStatus" name="patientStatus" ng-options="(item == null ? \'\' : item  ? \'Active\' : \'Inactive\') for item in [null, true, false]"></select></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_modality">Modality</label><ui-select id="field_modality" name="modality" ng-model="vm.rptTemplate.modality" title="Modality"><ui-select-match allow-clear="true" placeholder="Select Modality..."> {{$select.selected.replace(\'_\', \' \')}} </ui-select-match><ui-select-choices repeat="modality in vm.modalities"><div ng-bind-html="modality.replace(\'_\', \' \')"></div></ui-select-choices></ui-select></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_shift">Shift</label><input type="number" class="form-control" name="shift" id="field_shift" min="1" max="3" ng-model="vm.rptTemplate.shift"> <span class="help-block" ng-show="vm.form.main.shift.$dirty && vm.form.main.shift.$invalid"><span ng-show="vm.form.main.shift.$error.min">Shift should be above 1</span> <span ng-show="vm.form.main.shift.$error.max">Shift should be below 3</span></span></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_diabetic">Diabetic</label><select class="form-control" ng-model="vm.rptTemplate.diabetic" id="field_diabetic" name="diabetic" ng-options="(item == null ? \'\' : item  ? \'Active\' : \'Inactive\') for item in [null, true, false]"></select></div></div><div class="col-lg-6"><div class="form-group"><label for="field_physician">Physician</label><select class="form-control" id="field_physician" name="physician" ng-model="vm.rptTemplate.employee" ng-options="physician as (physician.name + \' \' + physician.lastName) for physician in vm.physicians track by physician.id"><option value=""></option></select></div></div><div class="col-lg-6" ng-if="vm.rptTemplate.type == \'REPORT_CARD\'"><div class="form-group"><label for="field_rptLanguage">Language</label><ui-select ng-model="vm.rptTemplate.rptLanguage" close-on-select="true" title="Language" id="field_rptLanguage" ng-required="true" name="rptLanguage"><ui-select-match allow-clear="true" placeholder="Select language..."> {{$select.selected.name}} </ui-select-match><ui-select-choices repeat="rptLanguage in vm.rptLanguages | filter: $select.search"><div ng-bind-html="rptLanguage.name"></div></ui-select-choices></ui-select><div ng-show="vm.form.main.$invalid"><p class="help-block" ng-show="vm.form.main.rptLanguage.$error.required">This field is required.</p></div></div></div></div></form>');
$templateCache.put('app/entities/rpt-template/wizard/report/step/next-tpl.html','<button type="button" class="btn btn-default move-btn fixed next-btn" wz-next><svg id="i-chevron-right" viewBox="0 0 32 32" height="32" width="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button>');
$templateCache.put('app/entities/rpt-template/wizard/report/step/previous-tpl.html','<button type="button" class="btn btn-default move-btn fixed previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button>');
$templateCache.put('app/entities/rpt-template/wizard/report/step/vaccine-tpl.html','<form name="vm.form.vaccine" role="form" novalidate><div class="row"><div class="col-lg-3"><div class="form-group"><label class="control-label">Vaccinated</label><br><toggle ng-model="vm.rptTemplate.vaccinated" on="Yes" off="No" id="field_active"></toggle></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label for="field_vaccines">Vaccines</label><ui-select id="field_vaccines" name="vaccines" multiple="multiple" ng-model="vm.rptTemplate.vaccines" title="Vaccines" ng-required="true"><ui-select-match placeholder="Select Vaccine...">{{$item.name}}</ui-select-match><ui-select-choices repeat="vaccine in vm.vaccines  | propsFilter: {name: $select.search}"><div ng-bind-html="vaccine.name"></div></ui-select-choices></ui-select><div ng-show="vm.form.vaccine.vaccines.$invalid"><p class="help-block" ng-show="vm.form.vaccine.vaccines.$error.required">This field is required.</p></div></div></div></div></form>');}]);})();